var Ar = Object.defineProperty;
var Dr = (t, r, n) => r in t ? Ar(t, r, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[r] = n;
var Mr = (t, r, n) => Dr(t, typeof r != "symbol" ? r + "" : r, n);
import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import c, { clsx } from "clsx";
import * as React from "react";
import React__default, { forwardRef, version, isValidElement, useState as useState$1, useMemo as useMemo$1, useCallback, useRef, useLayoutEffect as useLayoutEffect$3, useEffect, cloneElement, createContext, useContext, useId as useId$3, useReducer, Children } from "react";
import * as ReactDOM from "react-dom";
import ReactDOM__default, { unstable_batchedUpdates, createPortal, flushSync } from "react-dom";
import { ru as ru$1, enUS } from "date-fns/locale";
import { CloseMiniLine, DoneRoundLight, SearchLight, ArrowDropDown, ArrowLeftLight, ArrowRightLight, ArrowDropUp, ExpandDown, CloseRoundLight, DoneLight, CalendarDuotoneLine, CloseRoundDuotone, InfoLight, InfoRoundFill, QuestionFill, CheckRoundFill, AttantionMiniCustom, CloseRingDuotoneLine, ExpandRightLight } from "@repo/go-icons";
import { getMonth, isSameDay, setHours, setMinutes, getMinutes, getHours, startOfMonth, startOfWeek, sub as sub$1, add as add$1, eachDayOfInterval, differenceInWeeks, format, isWeekend, toDate, endOfWeek, getYear, setMonth, isBefore, startOfMinute, isAfter, endOfMinute, startOfHour, endOfHour, startOfDay, endOfDay, parse, millisecondsToSeconds, secondsToMilliseconds, getUnixTime } from "date-fns";
function ActionsBar({ children: t, className: r, style: n }) {
  return /* @__PURE__ */ jsx("div", { className: clsx("go-actions-bar", r), style: n, children: t });
}
function TopBar({ children: t, className: r, style: n }) {
  return /* @__PURE__ */ jsx("div", { className: clsx("go-actions-bar__top", r), style: n, children: t });
}
function BottomBar({ children: t, className: r, style: n }) {
  return /* @__PURE__ */ jsx("div", { className: clsx("go-actions-bar__bottom", r), style: n, children: t });
}
const Item$3 = forwardRef(function({ children: r, className: n, style: a, active: s, disabled: o, onClick: l }, x) {
  return /* @__PURE__ */ jsx(
    "button",
    {
      ref: x,
      type: "button",
      disabled: o,
      className: clsx("go-actions-bar__item", s && "active", n),
      style: a,
      onClick: l,
      children: r
    }
  );
});
function Space({ children: t, className: r, style: n }) {
  return /* @__PURE__ */ jsx("div", { className: clsx("go-actions-bar__space", r), style: n, children: t });
}
function Divider({ children: t, className: r, style: n }) {
  return /* @__PURE__ */ jsx("div", { className: clsx("go-actions-bar__divider", r), style: n, children: t });
}
const actionsBar = Object.assign(ActionsBar, { TopBar, BottomBar, Item: Item$3, Space, Divider });
function getDefaultExportFromCjs(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var toArray$4 = {}, interopRequireDefault = { exports: {} }, hasRequiredInteropRequireDefault;
function requireInteropRequireDefault() {
  return hasRequiredInteropRequireDefault || (hasRequiredInteropRequireDefault = 1, (function(t) {
    function r(n) {
      return n && n.__esModule ? n : {
        default: n
      };
    }
    t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
  })(interopRequireDefault)), interopRequireDefault.exports;
}
var isFragment$1 = {}, _typeof$2 = { exports: {} }, hasRequired_typeof;
function require_typeof() {
  return hasRequired_typeof || (hasRequired_typeof = 1, (function(t) {
    function r(n) {
      "@babel/helpers - typeof";
      return t.exports = r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(a) {
        return typeof a;
      } : function(a) {
        return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
      }, t.exports.__esModule = !0, t.exports.default = t.exports, r(n);
    }
    t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
  })(_typeof$2)), _typeof$2.exports;
}
var hasRequiredIsFragment;
function requireIsFragment() {
  if (hasRequiredIsFragment) return isFragment$1;
  hasRequiredIsFragment = 1;
  var t = requireInteropRequireDefault().default;
  Object.defineProperty(isFragment$1, "__esModule", {
    value: !0
  }), isFragment$1.default = o;
  var r = t(require_typeof()), n = /* @__PURE__ */ Symbol.for("react.element"), a = /* @__PURE__ */ Symbol.for("react.transitional.element"), s = /* @__PURE__ */ Symbol.for("react.fragment");
  function o(l) {
    return (
      // Base object type
      l && (0, r.default)(l) === "object" && // React Element type
      (l.$$typeof === n || l.$$typeof === a) && // React Fragment type
      l.type === s
    );
  }
  return isFragment$1;
}
var hasRequiredToArray;
function requireToArray() {
  if (hasRequiredToArray) return toArray$4;
  hasRequiredToArray = 1;
  var t = requireInteropRequireDefault().default;
  Object.defineProperty(toArray$4, "__esModule", {
    value: !0
  }), toArray$4.default = a;
  var r = t(requireIsFragment()), n = t(React__default);
  function a(s) {
    var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, l = [];
    return n.default.Children.forEach(s, function(x) {
      x == null && !o.keepEmpty || (Array.isArray(x) ? l = l.concat(a(x)) : (0, r.default)(x) && x.props ? l = l.concat(a(x.props.children, o)) : l.push(x));
    }), l;
  }
  return toArray$4;
}
var toArrayExports = requireToArray();
const toArray$3 = /* @__PURE__ */ getDefaultExportFromCjs(toArrayExports);
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(t) {
    for (var r = 1; r < arguments.length; r++) {
      var n = arguments[r];
      for (var a in n) ({}).hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, _extends.apply(null, arguments);
}
function _arrayLikeToArray(t, r) {
  (r == null || r > t.length) && (r = t.length);
  for (var n = 0, a = Array(r); n < r; n++) a[n] = t[n];
  return a;
}
function _arrayWithoutHoles(t) {
  if (Array.isArray(t)) return _arrayLikeToArray(t);
}
function _iterableToArray(t) {
  if (typeof Symbol != "undefined" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function _unsupportedIterableToArray(t, r) {
  if (t) {
    if (typeof t == "string") return _arrayLikeToArray(t, r);
    var n = {}.toString.call(t).slice(8, -1);
    return n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set" ? Array.from(t) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? _arrayLikeToArray(t, r) : void 0;
  }
}
function _nonIterableSpread() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _toConsumableArray(t) {
  return _arrayWithoutHoles(t) || _iterableToArray(t) || _unsupportedIterableToArray(t) || _nonIterableSpread();
}
function _typeof$1(t) {
  "@babel/helpers - typeof";
  return _typeof$1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, _typeof$1(t);
}
function toPrimitive(t, r) {
  if (_typeof$1(t) != "object" || !t) return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var a = n.call(t, r);
    if (_typeof$1(a) != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(t);
}
function toPropertyKey(t) {
  var r = toPrimitive(t, "string");
  return _typeof$1(r) == "symbol" ? r : r + "";
}
function _defineProperty(t, r, n) {
  return (r = toPropertyKey(r)) in t ? Object.defineProperty(t, r, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[r] = n, t;
}
function ownKeys(t, r) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    r && (a = a.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function _objectSpread2(t) {
  for (var r = 1; r < arguments.length; r++) {
    var n = arguments[r] != null ? arguments[r] : {};
    r % 2 ? ownKeys(Object(n), !0).forEach(function(a) {
      _defineProperty(t, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ownKeys(Object(n)).forEach(function(a) {
      Object.defineProperty(t, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return t;
}
function _arrayWithHoles(t) {
  if (Array.isArray(t)) return t;
}
function _iterableToArrayLimit(t, r) {
  var n = t == null ? null : typeof Symbol != "undefined" && t[Symbol.iterator] || t["@@iterator"];
  if (n != null) {
    var a, s, o, l, x = [], j = !0, Z = !1;
    try {
      if (o = (n = n.call(t)).next, r === 0) {
        if (Object(n) !== n) return;
        j = !1;
      } else for (; !(j = (a = o.call(n)).done) && (x.push(a.value), x.length !== r); j = !0) ;
    } catch (V) {
      Z = !0, s = V;
    } finally {
      try {
        if (!j && n.return != null && (l = n.return(), Object(l) !== l)) return;
      } finally {
        if (Z) throw s;
      }
    }
    return x;
  }
}
function _nonIterableRest() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _slicedToArray(t, r) {
  return _arrayWithHoles(t) || _iterableToArrayLimit(t, r) || _unsupportedIterableToArray(t, r) || _nonIterableRest();
}
function _objectWithoutPropertiesLoose(t, r) {
  if (t == null) return {};
  var n = {};
  for (var a in t) if ({}.hasOwnProperty.call(t, a)) {
    if (r.indexOf(a) !== -1) continue;
    n[a] = t[a];
  }
  return n;
}
function _objectWithoutProperties(t, r) {
  if (t == null) return {};
  var n, a, s = _objectWithoutPropertiesLoose(t, r);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (a = 0; a < o.length; a++) n = o[a], r.indexOf(n) === -1 && {}.propertyIsEnumerable.call(t, n) && (s[n] = t[n]);
  }
  return s;
}
function useEvent$1(t) {
  var r = React.useRef();
  r.current = t;
  var n = React.useCallback(function() {
    for (var a, s = arguments.length, o = new Array(s), l = 0; l < s; l++)
      o[l] = arguments[l];
    return (a = r.current) === null || a === void 0 ? void 0 : a.call.apply(a, [r].concat(o));
  }, []);
  return n;
}
function canUseDom$1() {
  return !!(typeof window != "undefined" && window.document && window.document.createElement);
}
var useInternalLayoutEffect = process.env.NODE_ENV !== "test" && canUseDom$1() ? React.useLayoutEffect : React.useEffect, useLayoutEffect$2 = function(r, n) {
  var a = React.useRef(!0);
  useInternalLayoutEffect(function() {
    return r(a.current);
  }, n), useInternalLayoutEffect(function() {
    return a.current = !1, function() {
      a.current = !0;
    };
  }, []);
}, useLayoutUpdateEffect = function(r, n) {
  useLayoutEffect$2(function(a) {
    if (!a)
      return r();
  }, n);
};
function useSafeState(t) {
  var r = React.useRef(!1), n = React.useState(t), a = _slicedToArray(n, 2), s = a[0], o = a[1];
  React.useEffect(function() {
    return r.current = !1, function() {
      r.current = !0;
    };
  }, []);
  function l(x, j) {
    j && r.current || o(x);
  }
  return [s, l];
}
function hasValue$3(t) {
  return t !== void 0;
}
function useMergedState$2(t, r) {
  var n = r || {}, a = n.defaultValue, s = n.value, o = n.onChange, l = n.postState, x = useSafeState(function() {
    return hasValue$3(s) ? s : hasValue$3(a) ? typeof a == "function" ? a() : a : typeof t == "function" ? t() : t;
  }), j = _slicedToArray(x, 2), Z = j[0], V = j[1], $ = s !== void 0 ? s : Z, X = l ? l($) : $, W = useEvent$1(o), Y = useSafeState([$]), U = _slicedToArray(Y, 2), G = U[0], K = U[1];
  useLayoutUpdateEffect(function() {
    var ee = G[0];
    Z !== ee && W(Z, ee);
  }, [G]), useLayoutUpdateEffect(function() {
    hasValue$3(s) || V(s);
  }, [s]);
  var J = useEvent$1(function(ee, te) {
    V(ee, te), K([$], te);
  });
  return [X, J];
}
var warned = {}, preWarningFns = [], preMessage = function(r) {
  preWarningFns.push(r);
};
function warning(t, r) {
  if (process.env.NODE_ENV !== "production" && !t && console !== void 0) {
    var n = preWarningFns.reduce(function(a, s) {
      return s(a != null ? a : "", "warning");
    }, r);
    n && console.error("Warning: ".concat(n));
  }
}
function note(t, r) {
  if (process.env.NODE_ENV !== "production" && !t && console !== void 0) {
    var n = preWarningFns.reduce(function(a, s) {
      return s(a != null ? a : "", "note");
    }, r);
    n && console.warn("Note: ".concat(n));
  }
}
function resetWarned() {
  warned = {};
}
function call(t, r, n) {
  !r && !warned[n] && (t(!1, n), warned[n] = !0);
}
function warningOnce(t, r) {
  call(warning, t, r);
}
function noteOnce(t, r) {
  call(note, t, r);
}
warningOnce.preMessage = preMessage;
warningOnce.resetWarned = resetWarned;
warningOnce.noteOnce = noteOnce;
var classnames = { exports: {} };
var hasRequiredClassnames;
function requireClassnames() {
  return hasRequiredClassnames || (hasRequiredClassnames = 1, (function(t) {
    (function() {
      var r = {}.hasOwnProperty;
      function n() {
        for (var o = "", l = 0; l < arguments.length; l++) {
          var x = arguments[l];
          x && (o = s(o, a(x)));
        }
        return o;
      }
      function a(o) {
        if (typeof o == "string" || typeof o == "number")
          return o;
        if (typeof o != "object")
          return "";
        if (Array.isArray(o))
          return n.apply(null, o);
        if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]"))
          return o.toString();
        var l = "";
        for (var x in o)
          r.call(o, x) && o[x] && (l = s(l, x));
        return l;
      }
      function s(o, l) {
        return l ? o ? o + " " + l : o + l : o;
      }
      t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
    })();
  })(classnames)), classnames.exports;
}
var classnamesExports = requireClassnames();
const cls = /* @__PURE__ */ getDefaultExportFromCjs(classnamesExports), isMobile = (function() {
  if (typeof navigator == "undefined" || typeof window == "undefined")
    return !1;
  var t = navigator.userAgent || navigator.vendor || window.opera;
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(t) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(t == null ? void 0 : t.substr(0, 4));
});
var KeyCode = {
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33,
  // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,
  // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35,
  // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36,
  // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37,
  // also NUM_WEST
  /**
   * UP
   */
  UP: 38,
  // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39,
  // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40,
  /**
   * N
   */
  N: 78,
  /**
   * P
   */
  P: 80,
  /**
   * META
   */
  META: 91,
  // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186,
  // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187,
  // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224
}, reactIs$1 = { exports: {} }, reactIs_production_min$1 = {};
var hasRequiredReactIs_production_min$1;
function requireReactIs_production_min$1() {
  if (hasRequiredReactIs_production_min$1) return reactIs_production_min$1;
  hasRequiredReactIs_production_min$1 = 1;
  var t = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), n = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), s = /* @__PURE__ */ Symbol.for("react.profiler"), o = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), x = /* @__PURE__ */ Symbol.for("react.server_context"), j = /* @__PURE__ */ Symbol.for("react.forward_ref"), Z = /* @__PURE__ */ Symbol.for("react.suspense"), V = /* @__PURE__ */ Symbol.for("react.suspense_list"), $ = /* @__PURE__ */ Symbol.for("react.memo"), X = /* @__PURE__ */ Symbol.for("react.lazy"), W = /* @__PURE__ */ Symbol.for("react.offscreen"), Y;
  Y = /* @__PURE__ */ Symbol.for("react.module.reference");
  function U(G) {
    if (typeof G == "object" && G !== null) {
      var K = G.$$typeof;
      switch (K) {
        case t:
          switch (G = G.type, G) {
            case n:
            case s:
            case a:
            case Z:
            case V:
              return G;
            default:
              switch (G = G && G.$$typeof, G) {
                case x:
                case l:
                case j:
                case X:
                case $:
                case o:
                  return G;
                default:
                  return K;
              }
          }
        case r:
          return K;
      }
    }
  }
  return reactIs_production_min$1.ContextConsumer = l, reactIs_production_min$1.ContextProvider = o, reactIs_production_min$1.Element = t, reactIs_production_min$1.ForwardRef = j, reactIs_production_min$1.Fragment = n, reactIs_production_min$1.Lazy = X, reactIs_production_min$1.Memo = $, reactIs_production_min$1.Portal = r, reactIs_production_min$1.Profiler = s, reactIs_production_min$1.StrictMode = a, reactIs_production_min$1.Suspense = Z, reactIs_production_min$1.SuspenseList = V, reactIs_production_min$1.isAsyncMode = function() {
    return !1;
  }, reactIs_production_min$1.isConcurrentMode = function() {
    return !1;
  }, reactIs_production_min$1.isContextConsumer = function(G) {
    return U(G) === l;
  }, reactIs_production_min$1.isContextProvider = function(G) {
    return U(G) === o;
  }, reactIs_production_min$1.isElement = function(G) {
    return typeof G == "object" && G !== null && G.$$typeof === t;
  }, reactIs_production_min$1.isForwardRef = function(G) {
    return U(G) === j;
  }, reactIs_production_min$1.isFragment = function(G) {
    return U(G) === n;
  }, reactIs_production_min$1.isLazy = function(G) {
    return U(G) === X;
  }, reactIs_production_min$1.isMemo = function(G) {
    return U(G) === $;
  }, reactIs_production_min$1.isPortal = function(G) {
    return U(G) === r;
  }, reactIs_production_min$1.isProfiler = function(G) {
    return U(G) === s;
  }, reactIs_production_min$1.isStrictMode = function(G) {
    return U(G) === a;
  }, reactIs_production_min$1.isSuspense = function(G) {
    return U(G) === Z;
  }, reactIs_production_min$1.isSuspenseList = function(G) {
    return U(G) === V;
  }, reactIs_production_min$1.isValidElementType = function(G) {
    return typeof G == "string" || typeof G == "function" || G === n || G === s || G === a || G === Z || G === V || G === W || typeof G == "object" && G !== null && (G.$$typeof === X || G.$$typeof === $ || G.$$typeof === o || G.$$typeof === l || G.$$typeof === j || G.$$typeof === Y || G.getModuleId !== void 0);
  }, reactIs_production_min$1.typeOf = U, reactIs_production_min$1;
}
var reactIs_development$1 = {};
var hasRequiredReactIs_development$1;
function requireReactIs_development$1() {
  return hasRequiredReactIs_development$1 || (hasRequiredReactIs_development$1 = 1, process.env.NODE_ENV !== "production" && (function() {
    var t = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), n = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), s = /* @__PURE__ */ Symbol.for("react.profiler"), o = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), x = /* @__PURE__ */ Symbol.for("react.server_context"), j = /* @__PURE__ */ Symbol.for("react.forward_ref"), Z = /* @__PURE__ */ Symbol.for("react.suspense"), V = /* @__PURE__ */ Symbol.for("react.suspense_list"), $ = /* @__PURE__ */ Symbol.for("react.memo"), X = /* @__PURE__ */ Symbol.for("react.lazy"), W = /* @__PURE__ */ Symbol.for("react.offscreen"), Y = !1, U = !1, G = !1, K = !1, J = !1, ee;
    ee = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(be) {
      return !!(typeof be == "string" || typeof be == "function" || be === n || be === s || J || be === a || be === Z || be === V || K || be === W || Y || U || G || typeof be == "object" && be !== null && (be.$$typeof === X || be.$$typeof === $ || be.$$typeof === o || be.$$typeof === l || be.$$typeof === j || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      be.$$typeof === ee || be.getModuleId !== void 0));
    }
    function re(be) {
      if (typeof be == "object" && be !== null) {
        var De = be.$$typeof;
        switch (De) {
          case t:
            var Fe = be.type;
            switch (Fe) {
              case n:
              case s:
              case a:
              case Z:
              case V:
                return Fe;
              default:
                var Le = Fe && Fe.$$typeof;
                switch (Le) {
                  case x:
                  case l:
                  case j:
                  case X:
                  case $:
                  case o:
                    return Le;
                  default:
                    return De;
                }
            }
          case r:
            return De;
        }
      }
    }
    var ae = l, ie = o, ce = t, he = j, oe = n, le = X, pe = $, de = r, se = s, ue = a, fe = Z, ge = V, ne = !1, ve = !1;
    function me(be) {
      return ne || (ne = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function xe(be) {
      return ve || (ve = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function Ee(be) {
      return re(be) === l;
    }
    function Se(be) {
      return re(be) === o;
    }
    function _e(be) {
      return typeof be == "object" && be !== null && be.$$typeof === t;
    }
    function Ce(be) {
      return re(be) === j;
    }
    function Te(be) {
      return re(be) === n;
    }
    function we(be) {
      return re(be) === X;
    }
    function Re(be) {
      return re(be) === $;
    }
    function Ae(be) {
      return re(be) === r;
    }
    function Pe(be) {
      return re(be) === s;
    }
    function ke(be) {
      return re(be) === a;
    }
    function ye(be) {
      return re(be) === Z;
    }
    function Me(be) {
      return re(be) === V;
    }
    reactIs_development$1.ContextConsumer = ae, reactIs_development$1.ContextProvider = ie, reactIs_development$1.Element = ce, reactIs_development$1.ForwardRef = he, reactIs_development$1.Fragment = oe, reactIs_development$1.Lazy = le, reactIs_development$1.Memo = pe, reactIs_development$1.Portal = de, reactIs_development$1.Profiler = se, reactIs_development$1.StrictMode = ue, reactIs_development$1.Suspense = fe, reactIs_development$1.SuspenseList = ge, reactIs_development$1.isAsyncMode = me, reactIs_development$1.isConcurrentMode = xe, reactIs_development$1.isContextConsumer = Ee, reactIs_development$1.isContextProvider = Se, reactIs_development$1.isElement = _e, reactIs_development$1.isForwardRef = Ce, reactIs_development$1.isFragment = Te, reactIs_development$1.isLazy = we, reactIs_development$1.isMemo = Re, reactIs_development$1.isPortal = Ae, reactIs_development$1.isProfiler = Pe, reactIs_development$1.isStrictMode = ke, reactIs_development$1.isSuspense = ye, reactIs_development$1.isSuspenseList = Me, reactIs_development$1.isValidElementType = te, reactIs_development$1.typeOf = re;
  })()), reactIs_development$1;
}
var hasRequiredReactIs$1;
function requireReactIs$1() {
  return hasRequiredReactIs$1 || (hasRequiredReactIs$1 = 1, process.env.NODE_ENV === "production" ? reactIs$1.exports = requireReactIs_production_min$1() : reactIs$1.exports = requireReactIs_development$1()), reactIs$1.exports;
}
var reactIsExports = requireReactIs$1();
function useMemo(t, r, n) {
  var a = React.useRef({});
  return (!("value" in a.current) || n(a.current.condition, r)) && (a.current.value = t(), a.current.condition = r), a.current.value;
}
var REACT_ELEMENT_TYPE_18 = /* @__PURE__ */ Symbol.for("react.element"), REACT_ELEMENT_TYPE_19 = /* @__PURE__ */ Symbol.for("react.transitional.element"), REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
function isFragment(t) {
  return (
    // Base object type
    t && _typeof$1(t) === "object" && // React Element type
    (t.$$typeof === REACT_ELEMENT_TYPE_18 || t.$$typeof === REACT_ELEMENT_TYPE_19) && // React Fragment type
    t.type === REACT_FRAGMENT_TYPE
  );
}
var ReactMajorVersion = Number(version.split(".")[0]), fillRef = function(r, n) {
  typeof r == "function" ? r(n) : _typeof$1(r) === "object" && r && "current" in r && (r.current = n);
}, composeRef = function() {
  for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
    n[a] = arguments[a];
  var s = n.filter(Boolean);
  return s.length <= 1 ? s[0] : function(o) {
    n.forEach(function(l) {
      fillRef(l, o);
    });
  };
}, useComposeRef = function() {
  for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
    n[a] = arguments[a];
  return useMemo(function() {
    return composeRef.apply(void 0, n);
  }, n, function(s, o) {
    return s.length !== o.length || s.every(function(l, x) {
      return l !== o[x];
    });
  });
}, supportRef = function(r) {
  var n, a;
  if (!r)
    return !1;
  if (isReactElement(r) && ReactMajorVersion >= 19)
    return !0;
  var s = reactIsExports.isMemo(r) ? r.type.type : r.type;
  return !(typeof s == "function" && !((n = s.prototype) !== null && n !== void 0 && n.render) && s.$$typeof !== reactIsExports.ForwardRef || typeof r == "function" && !((a = r.prototype) !== null && a !== void 0 && a.render) && r.$$typeof !== reactIsExports.ForwardRef);
};
function isReactElement(t) {
  return /* @__PURE__ */ isValidElement(t) && !isFragment(t);
}
var getNodeRef = function(r) {
  if (r && isReactElement(r)) {
    var n = r;
    return n.props.propertyIsEnumerable("ref") ? n.props.ref : n.ref;
  }
  return null;
}, TransBtn = function(r) {
  var n = r.className, a = r.customizeIcon, s = r.customizeIconProps, o = r.children, l = r.onMouseDown, x = r.onClick, j = typeof a == "function" ? a(s) : a;
  return /* @__PURE__ */ React.createElement("span", {
    className: n,
    onMouseDown: function(V) {
      V.preventDefault(), l == null || l(V);
    },
    style: {
      userSelect: "none",
      WebkitUserSelect: "none"
    },
    unselectable: "on",
    onClick: x,
    "aria-hidden": !0
  }, j !== void 0 ? j : /* @__PURE__ */ React.createElement("span", {
    className: cls(n.split(/\s+/).map(function(Z) {
      return "".concat(Z, "-icon");
    }))
  }, o));
}, useAllowClear = function(r, n, a, s, o) {
  var l = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : !1, x = arguments.length > 6 ? arguments[6] : void 0, j = arguments.length > 7 ? arguments[7] : void 0, Z = React__default.useMemo(function() {
    if (_typeof$1(s) === "object")
      return s.clearIcon;
    if (o)
      return o;
  }, [s, o]), V = React__default.useMemo(function() {
    return !!(!l && s && (a.length || x) && !(j === "combobox" && x === ""));
  }, [s, l, a.length, x, j]);
  return {
    allowClear: V,
    clearIcon: /* @__PURE__ */ React__default.createElement(TransBtn, {
      className: "".concat(r, "-clear"),
      onMouseDown: n,
      customizeIcon: Z
    }, "×")
  };
}, BaseSelectContext = /* @__PURE__ */ React.createContext(null);
function useBaseProps() {
  return React.useContext(BaseSelectContext);
}
function useDelayReset() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10, r = React.useState(!1), n = _slicedToArray(r, 2), a = n[0], s = n[1], o = React.useRef(null), l = function() {
    window.clearTimeout(o.current);
  };
  React.useEffect(function() {
    return l;
  }, []);
  var x = function(Z, V) {
    l(), o.current = window.setTimeout(function() {
      s(Z), V && V();
    }, t);
  };
  return [a, x, l];
}
function useLock() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 250, r = React.useRef(null), n = React.useRef(null);
  React.useEffect(function() {
    return function() {
      window.clearTimeout(n.current);
    };
  }, []);
  function a(s) {
    (s || r.current === null) && (r.current = s), window.clearTimeout(n.current), n.current = window.setTimeout(function() {
      r.current = null;
    }, t);
  }
  return [function() {
    return r.current;
  }, a];
}
function useSelectTriggerControl(t, r, n, a) {
  var s = React.useRef(null);
  s.current = {
    open: r,
    triggerOpen: n,
    customizedTrigger: a
  }, React.useEffect(function() {
    function o(l) {
      var x;
      if (!((x = s.current) !== null && x !== void 0 && x.customizedTrigger)) {
        var j = l.target;
        j.shadowRoot && l.composed && (j = l.composedPath()[0] || j), s.current.open && t().filter(function(Z) {
          return Z;
        }).every(function(Z) {
          return !Z.contains(j) && Z !== j;
        }) && s.current.triggerOpen(!1);
      }
    }
    return window.addEventListener("mousedown", o), function() {
      return window.removeEventListener("mousedown", o);
    };
  }, []);
}
function isValidateOpenKey(t) {
  return ![
    // System function button
    KeyCode.ESC,
    KeyCode.SHIFT,
    KeyCode.BACKSPACE,
    KeyCode.TAB,
    KeyCode.WIN_KEY,
    KeyCode.ALT,
    KeyCode.META,
    KeyCode.WIN_KEY_RIGHT,
    KeyCode.CTRL,
    KeyCode.SEMICOLON,
    KeyCode.EQUALS,
    KeyCode.CAPS_LOCK,
    KeyCode.CONTEXT_MENU,
    // F1-F12
    KeyCode.F1,
    KeyCode.F2,
    KeyCode.F3,
    KeyCode.F4,
    KeyCode.F5,
    KeyCode.F6,
    KeyCode.F7,
    KeyCode.F8,
    KeyCode.F9,
    KeyCode.F10,
    KeyCode.F11,
    KeyCode.F12
  ].includes(t);
}
var attributes = `accept acceptCharset accessKey action allowFullScreen allowTransparency
    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge
    charSet checked classID className colSpan cols content contentEditable contextMenu
    controls coords crossOrigin data dateTime default defer dir disabled download draggable
    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder
    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity
    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media
    mediaGroup method min minLength multiple muted name noValidate nonce open
    optimum pattern placeholder poster preload radioGroup readOnly rel required
    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected
    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style
    summary tabIndex target title type useMap value width wmode wrap`, eventsName = `onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown
    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick
    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown
    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel
    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough
    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata
    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError`, propList = "".concat(attributes, " ").concat(eventsName).split(/[\s\n]+/), ariaPrefix = "aria-", dataPrefix = "data-";
function match(t, r) {
  return t.indexOf(r) === 0;
}
function pickAttrs(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n;
  r === !1 ? n = {
    aria: !0,
    data: !0,
    attr: !0
  } : r === !0 ? n = {
    aria: !0
  } : n = _objectSpread2({}, r);
  var a = {};
  return Object.keys(t).forEach(function(s) {
    // Aria
    (n.aria && (s === "role" || match(s, ariaPrefix)) || // Data
    n.data && match(s, dataPrefix) || // Attr
    n.attr && propList.includes(s)) && (a[s] = t[s]);
  }), a;
}
function toArray$2(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = [];
  return React__default.Children.forEach(t, function(a) {
    a == null && !r.keepEmpty || (Array.isArray(a) ? n = n.concat(toArray$2(a)) : isFragment(a) && a.props ? n = n.concat(toArray$2(a.props.children, r)) : n.push(a));
  }), n;
}
function isDOM(t) {
  return t instanceof HTMLElement || t instanceof SVGElement;
}
function getDOM(t) {
  return t && _typeof$1(t) === "object" && isDOM(t.nativeElement) ? t.nativeElement : isDOM(t) ? t : null;
}
function findDOMNode$1(t) {
  var r = getDOM(t);
  if (r)
    return r;
  if (t instanceof React__default.Component) {
    var n;
    return (n = ReactDOM__default.findDOMNode) === null || n === void 0 ? void 0 : n.call(ReactDOM__default, t);
  }
  return null;
}
var CollectionContext = /* @__PURE__ */ React.createContext(null);
function Collection(t) {
  var r = t.children, n = t.onBatchResize, a = React.useRef(0), s = React.useRef([]), o = React.useContext(CollectionContext), l = React.useCallback(function(x, j, Z) {
    a.current += 1;
    var V = a.current;
    s.current.push({
      size: x,
      element: j,
      data: Z
    }), Promise.resolve().then(function() {
      V === a.current && (n == null || n(s.current), s.current = []);
    }), o == null || o(x, j, Z);
  }, [n, o]);
  return /* @__PURE__ */ React.createElement(CollectionContext.Provider, {
    value: l
  }, r);
}
var MapShim = (function() {
  if (typeof Map != "undefined")
    return Map;
  function t(r, n) {
    var a = -1;
    return r.some(function(s, o) {
      return s[0] === n ? (a = o, !0) : !1;
    }), a;
  }
  return (
    /** @class */
    (function() {
      function r() {
        this.__entries__ = [];
      }
      return Object.defineProperty(r.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), r.prototype.get = function(n) {
        var a = t(this.__entries__, n), s = this.__entries__[a];
        return s && s[1];
      }, r.prototype.set = function(n, a) {
        var s = t(this.__entries__, n);
        ~s ? this.__entries__[s][1] = a : this.__entries__.push([n, a]);
      }, r.prototype.delete = function(n) {
        var a = this.__entries__, s = t(a, n);
        ~s && a.splice(s, 1);
      }, r.prototype.has = function(n) {
        return !!~t(this.__entries__, n);
      }, r.prototype.clear = function() {
        this.__entries__.splice(0);
      }, r.prototype.forEach = function(n, a) {
        a === void 0 && (a = null);
        for (var s = 0, o = this.__entries__; s < o.length; s++) {
          var l = o[s];
          n.call(a, l[1], l[0]);
        }
      }, r;
    })()
  );
})(), isBrowser$1 = typeof window != "undefined" && typeof document != "undefined" && window.document === document, global$1 = (function() {
  return typeof global != "undefined" && global.Math === Math ? global : typeof self != "undefined" && self.Math === Math ? self : typeof window != "undefined" && window.Math === Math ? window : Function("return this")();
})(), requestAnimationFrame$1 = (function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(global$1) : function(t) {
    return setTimeout(function() {
      return t(Date.now());
    }, 1e3 / 60);
  };
})(), trailingTimeout = 2;
function throttle(t, r) {
  var n = !1, a = !1, s = 0;
  function o() {
    n && (n = !1, t()), a && x();
  }
  function l() {
    requestAnimationFrame$1(o);
  }
  function x() {
    var j = Date.now();
    if (n) {
      if (j - s < trailingTimeout)
        return;
      a = !0;
    } else
      n = !0, a = !1, setTimeout(l, r);
    s = j;
  }
  return x;
}
var REFRESH_DELAY = 20, transitionKeys = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], mutationObserverSupported = typeof MutationObserver != "undefined", ResizeObserverController = (
  /** @class */
  (function() {
    function t() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    return t.prototype.addObserver = function(r) {
      ~this.observers_.indexOf(r) || this.observers_.push(r), this.connected_ || this.connect_();
    }, t.prototype.removeObserver = function(r) {
      var n = this.observers_, a = n.indexOf(r);
      ~a && n.splice(a, 1), !n.length && this.connected_ && this.disconnect_();
    }, t.prototype.refresh = function() {
      var r = this.updateObservers_();
      r && this.refresh();
    }, t.prototype.updateObservers_ = function() {
      var r = this.observers_.filter(function(n) {
        return n.gatherActive(), n.hasActive();
      });
      return r.forEach(function(n) {
        return n.broadcastActive();
      }), r.length > 0;
    }, t.prototype.connect_ = function() {
      !isBrowser$1 || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), mutationObserverSupported ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, t.prototype.disconnect_ = function() {
      !isBrowser$1 || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, t.prototype.onTransitionEnd_ = function(r) {
      var n = r.propertyName, a = n === void 0 ? "" : n, s = transitionKeys.some(function(o) {
        return !!~a.indexOf(o);
      });
      s && this.refresh();
    }, t.getInstance = function() {
      return this.instance_ || (this.instance_ = new t()), this.instance_;
    }, t.instance_ = null, t;
  })()
), defineConfigurable = (function(t, r) {
  for (var n = 0, a = Object.keys(r); n < a.length; n++) {
    var s = a[n];
    Object.defineProperty(t, s, {
      value: r[s],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return t;
}), getWindowOf = (function(t) {
  var r = t && t.ownerDocument && t.ownerDocument.defaultView;
  return r || global$1;
}), emptyRect = createRectInit(0, 0, 0, 0);
function toFloat(t) {
  return parseFloat(t) || 0;
}
function getBordersSize(t) {
  for (var r = [], n = 1; n < arguments.length; n++)
    r[n - 1] = arguments[n];
  return r.reduce(function(a, s) {
    var o = t["border-" + s + "-width"];
    return a + toFloat(o);
  }, 0);
}
function getPaddings(t) {
  for (var r = ["top", "right", "bottom", "left"], n = {}, a = 0, s = r; a < s.length; a++) {
    var o = s[a], l = t["padding-" + o];
    n[o] = toFloat(l);
  }
  return n;
}
function getSVGContentRect(t) {
  var r = t.getBBox();
  return createRectInit(0, 0, r.width, r.height);
}
function getHTMLElementContentRect(t) {
  var r = t.clientWidth, n = t.clientHeight;
  if (!r && !n)
    return emptyRect;
  var a = getWindowOf(t).getComputedStyle(t), s = getPaddings(a), o = s.left + s.right, l = s.top + s.bottom, x = toFloat(a.width), j = toFloat(a.height);
  if (a.boxSizing === "border-box" && (Math.round(x + o) !== r && (x -= getBordersSize(a, "left", "right") + o), Math.round(j + l) !== n && (j -= getBordersSize(a, "top", "bottom") + l)), !isDocumentElement(t)) {
    var Z = Math.round(x + o) - r, V = Math.round(j + l) - n;
    Math.abs(Z) !== 1 && (x -= Z), Math.abs(V) !== 1 && (j -= V);
  }
  return createRectInit(s.left, s.top, x, j);
}
var isSVGGraphicsElement = /* @__PURE__ */ (function() {
  return typeof SVGGraphicsElement != "undefined" ? function(t) {
    return t instanceof getWindowOf(t).SVGGraphicsElement;
  } : function(t) {
    return t instanceof getWindowOf(t).SVGElement && typeof t.getBBox == "function";
  };
})();
function isDocumentElement(t) {
  return t === getWindowOf(t).document.documentElement;
}
function getContentRect(t) {
  return isBrowser$1 ? isSVGGraphicsElement(t) ? getSVGContentRect(t) : getHTMLElementContentRect(t) : emptyRect;
}
function createReadOnlyRect(t) {
  var r = t.x, n = t.y, a = t.width, s = t.height, o = typeof DOMRectReadOnly != "undefined" ? DOMRectReadOnly : Object, l = Object.create(o.prototype);
  return defineConfigurable(l, {
    x: r,
    y: n,
    width: a,
    height: s,
    top: n,
    right: r + a,
    bottom: s + n,
    left: r
  }), l;
}
function createRectInit(t, r, n, a) {
  return { x: t, y: r, width: n, height: a };
}
var ResizeObservation = (
  /** @class */
  (function() {
    function t(r) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = createRectInit(0, 0, 0, 0), this.target = r;
    }
    return t.prototype.isActive = function() {
      var r = getContentRect(this.target);
      return this.contentRect_ = r, r.width !== this.broadcastWidth || r.height !== this.broadcastHeight;
    }, t.prototype.broadcastRect = function() {
      var r = this.contentRect_;
      return this.broadcastWidth = r.width, this.broadcastHeight = r.height, r;
    }, t;
  })()
), ResizeObserverEntry = (
  /** @class */
  /* @__PURE__ */ (function() {
    function t(r, n) {
      var a = createReadOnlyRect(n);
      defineConfigurable(this, { target: r, contentRect: a });
    }
    return t;
  })()
), ResizeObserverSPI = (
  /** @class */
  (function() {
    function t(r, n, a) {
      if (this.activeObservations_ = [], this.observations_ = new MapShim(), typeof r != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = r, this.controller_ = n, this.callbackCtx_ = a;
    }
    return t.prototype.observe = function(r) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element == "undefined" || !(Element instanceof Object))) {
        if (!(r instanceof getWindowOf(r).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var n = this.observations_;
        n.has(r) || (n.set(r, new ResizeObservation(r)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, t.prototype.unobserve = function(r) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element == "undefined" || !(Element instanceof Object))) {
        if (!(r instanceof getWindowOf(r).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var n = this.observations_;
        n.has(r) && (n.delete(r), n.size || this.controller_.removeObserver(this));
      }
    }, t.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, t.prototype.gatherActive = function() {
      var r = this;
      this.clearActive(), this.observations_.forEach(function(n) {
        n.isActive() && r.activeObservations_.push(n);
      });
    }, t.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var r = this.callbackCtx_, n = this.activeObservations_.map(function(a) {
          return new ResizeObserverEntry(a.target, a.broadcastRect());
        });
        this.callback_.call(r, n, r), this.clearActive();
      }
    }, t.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, t.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, t;
  })()
), observers = typeof WeakMap != "undefined" ? /* @__PURE__ */ new WeakMap() : new MapShim(), ResizeObserver$2 = (
  /** @class */
  /* @__PURE__ */ (function() {
    function t(r) {
      if (!(this instanceof t))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var n = ResizeObserverController.getInstance(), a = new ResizeObserverSPI(r, n, this);
      observers.set(this, a);
    }
    return t;
  })()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(t) {
  ResizeObserver$2.prototype[t] = function() {
    var r;
    return (r = observers.get(this))[t].apply(r, arguments);
  };
});
var index$2 = (function() {
  return typeof global$1.ResizeObserver != "undefined" ? global$1.ResizeObserver : ResizeObserver$2;
})(), elementListeners = /* @__PURE__ */ new Map();
function onResize(t) {
  t.forEach(function(r) {
    var n, a = r.target;
    (n = elementListeners.get(a)) === null || n === void 0 || n.forEach(function(s) {
      return s(a);
    });
  });
}
var resizeObserver = new index$2(onResize);
process.env.NODE_ENV;
process.env.NODE_ENV;
function observe(t, r) {
  elementListeners.has(t) || (elementListeners.set(t, /* @__PURE__ */ new Set()), resizeObserver.observe(t)), elementListeners.get(t).add(r);
}
function unobserve(t, r) {
  elementListeners.has(t) && (elementListeners.get(t).delete(r), elementListeners.get(t).size || (resizeObserver.unobserve(t), elementListeners.delete(t)));
}
function _classCallCheck(t, r) {
  if (!(t instanceof r)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(t, r) {
  for (var n = 0; n < r.length; n++) {
    var a = r[n];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, toPropertyKey(a.key), a);
  }
}
function _createClass(t, r, n) {
  return r && _defineProperties(t.prototype, r), n && _defineProperties(t, n), Object.defineProperty(t, "prototype", {
    writable: !1
  }), t;
}
function _setPrototypeOf(t, r) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, _setPrototypeOf(t, r);
}
function _inherits(t, r) {
  if (typeof r != "function" && r !== null) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(r && r.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), r && _setPrototypeOf(t, r);
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, _getPrototypeOf(t);
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (_isNativeReflectConstruct = function() {
    return !!t;
  })();
}
function _assertThisInitialized(t) {
  if (t === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function _possibleConstructorReturn(t, r) {
  if (r && (_typeof$1(r) == "object" || typeof r == "function")) return r;
  if (r !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _createSuper(t) {
  var r = _isNativeReflectConstruct();
  return function() {
    var n, a = _getPrototypeOf(t);
    if (r) {
      var s = _getPrototypeOf(this).constructor;
      n = Reflect.construct(a, arguments, s);
    } else n = a.apply(this, arguments);
    return _possibleConstructorReturn(this, n);
  };
}
var DomWrapper$1 = /* @__PURE__ */ (function(t) {
  _inherits(n, t);
  var r = _createSuper(n);
  function n() {
    return _classCallCheck(this, n), r.apply(this, arguments);
  }
  return _createClass(n, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), n;
})(React.Component);
function SingleObserver(t, r) {
  var n = t.children, a = t.disabled, s = React.useRef(null), o = React.useRef(null), l = React.useContext(CollectionContext), x = typeof n == "function", j = x ? n(s) : n, Z = React.useRef({
    width: -1,
    height: -1,
    offsetWidth: -1,
    offsetHeight: -1
  }), V = !x && /* @__PURE__ */ React.isValidElement(j) && supportRef(j), $ = V ? getNodeRef(j) : null, X = useComposeRef($, s), W = function() {
    var K;
    return findDOMNode$1(s.current) || // Support `nativeElement` format
    (s.current && _typeof$1(s.current) === "object" ? findDOMNode$1((K = s.current) === null || K === void 0 ? void 0 : K.nativeElement) : null) || findDOMNode$1(o.current);
  };
  React.useImperativeHandle(r, function() {
    return W();
  });
  var Y = React.useRef(t);
  Y.current = t;
  var U = React.useCallback(function(G) {
    var K = Y.current, J = K.onResize, ee = K.data, te = G.getBoundingClientRect(), re = te.width, ae = te.height, ie = G.offsetWidth, ce = G.offsetHeight, he = Math.floor(re), oe = Math.floor(ae);
    if (Z.current.width !== he || Z.current.height !== oe || Z.current.offsetWidth !== ie || Z.current.offsetHeight !== ce) {
      var le = {
        width: he,
        height: oe,
        offsetWidth: ie,
        offsetHeight: ce
      };
      Z.current = le;
      var pe = ie === Math.round(re) ? re : ie, de = ce === Math.round(ae) ? ae : ce, se = _objectSpread2(_objectSpread2({}, le), {}, {
        offsetWidth: pe,
        offsetHeight: de
      });
      l == null || l(se, G, ee), J && Promise.resolve().then(function() {
        J(se, G);
      });
    }
  }, []);
  return React.useEffect(function() {
    var G = W();
    return G && !a && observe(G, U), function() {
      return unobserve(G, U);
    };
  }, [s.current, a]), /* @__PURE__ */ React.createElement(DomWrapper$1, {
    ref: o
  }, V ? /* @__PURE__ */ React.cloneElement(j, {
    ref: X
  }) : j);
}
var RefSingleObserver = /* @__PURE__ */ React.forwardRef(SingleObserver);
process.env.NODE_ENV !== "production" && (RefSingleObserver.displayName = "SingleObserver");
var INTERNAL_PREFIX_KEY = "rc-observer-key";
function ResizeObserver$1(t, r) {
  var n = t.children, a = typeof n == "function" ? [n] : toArray$2(n);
  return process.env.NODE_ENV !== "production" && (a.length > 1 ? warning(!1, "Find more than one child node with `children` in ResizeObserver. Please use ResizeObserver.Collection instead.") : a.length === 0 && warning(!1, "`children` of ResizeObserver is empty. Nothing is in observe.")), a.map(function(s, o) {
    var l = (s == null ? void 0 : s.key) || "".concat(INTERNAL_PREFIX_KEY, "-").concat(o);
    return /* @__PURE__ */ React.createElement(RefSingleObserver, _extends({}, t, {
      key: l,
      ref: o === 0 ? r : void 0
    }), s);
  });
}
var RefResizeObserver = /* @__PURE__ */ React.forwardRef(ResizeObserver$1);
process.env.NODE_ENV !== "production" && (RefResizeObserver.displayName = "ResizeObserver");
RefResizeObserver.Collection = Collection;
var _excluded$j = ["prefixCls", "invalidate", "item", "renderItem", "responsive", "responsiveDisabled", "registerSize", "itemKey", "className", "style", "children", "display", "order", "component"], UNDEFINED = void 0;
function InternalItem(t, r) {
  var n = t.prefixCls, a = t.invalidate, s = t.item, o = t.renderItem, l = t.responsive, x = t.responsiveDisabled, j = t.registerSize, Z = t.itemKey, V = t.className, $ = t.style, X = t.children, W = t.display, Y = t.order, U = t.component, G = U === void 0 ? "div" : U, K = _objectWithoutProperties(t, _excluded$j), J = l && !W;
  function ee(ce) {
    j(Z, ce);
  }
  React.useEffect(function() {
    return function() {
      ee(null);
    };
  }, []);
  var te = o && s !== UNDEFINED ? o(s, {
    index: Y
  }) : X, re;
  a || (re = {
    opacity: J ? 0 : 1,
    height: J ? 0 : UNDEFINED,
    overflowY: J ? "hidden" : UNDEFINED,
    order: l ? Y : UNDEFINED,
    pointerEvents: J ? "none" : UNDEFINED,
    position: J ? "absolute" : UNDEFINED
  });
  var ae = {};
  J && (ae["aria-hidden"] = !0);
  var ie = /* @__PURE__ */ React.createElement(G, _extends({
    className: cls(!a && n, V),
    style: _objectSpread2(_objectSpread2({}, re), $)
  }, ae, K, {
    ref: r
  }), te);
  return l && (ie = /* @__PURE__ */ React.createElement(RefResizeObserver, {
    onResize: function(he) {
      var oe = he.offsetWidth;
      ee(oe);
    },
    disabled: x
  }, ie)), ie;
}
var Item$2 = /* @__PURE__ */ React.forwardRef(InternalItem);
Item$2.displayName = "Item";
var raf = function(r) {
  return +setTimeout(r, 16);
}, caf = function(r) {
  return clearTimeout(r);
};
typeof window != "undefined" && "requestAnimationFrame" in window && (raf = function(r) {
  return window.requestAnimationFrame(r);
}, caf = function(r) {
  return window.cancelAnimationFrame(r);
});
var rafUUID = 0, rafIds = /* @__PURE__ */ new Map();
function cleanup(t) {
  rafIds.delete(t);
}
var wrapperRaf = function(r) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  rafUUID += 1;
  var a = rafUUID;
  function s(o) {
    if (o === 0)
      cleanup(a), r();
    else {
      var l = raf(function() {
        s(o - 1);
      });
      rafIds.set(a, l);
    }
  }
  return s(n), a;
};
wrapperRaf.cancel = function(t) {
  var r = rafIds.get(t);
  return cleanup(t), caf(r);
};
process.env.NODE_ENV !== "production" && (wrapperRaf.ids = function() {
  return rafIds;
});
function channelUpdate(t) {
  if (typeof MessageChannel == "undefined")
    wrapperRaf(t);
  else {
    var r = new MessageChannel();
    r.port1.onmessage = function() {
      return t();
    }, r.port2.postMessage(void 0);
  }
}
function useBatcher() {
  var t = React.useRef(null), r = function(a) {
    t.current || (t.current = [], channelUpdate(function() {
      unstable_batchedUpdates(function() {
        t.current.forEach(function(s) {
          s();
        }), t.current = null;
      });
    })), t.current.push(a);
  };
  return r;
}
function useEffectState(t, r) {
  var n = React.useState(r), a = _slicedToArray(n, 2), s = a[0], o = a[1], l = useEvent$1(function(x) {
    t(function() {
      o(x);
    });
  });
  return [s, l];
}
var OverflowContext = /* @__PURE__ */ React__default.createContext(null), _excluded$i = ["component"], _excluded2$2 = ["className"], _excluded3 = ["className"], InternalRawItem = function(r, n) {
  var a = React.useContext(OverflowContext);
  if (!a) {
    var s = r.component, o = s === void 0 ? "div" : s, l = _objectWithoutProperties(r, _excluded$i);
    return /* @__PURE__ */ React.createElement(o, _extends({}, l, {
      ref: n
    }));
  }
  var x = a.className, j = _objectWithoutProperties(a, _excluded2$2), Z = r.className, V = _objectWithoutProperties(r, _excluded3);
  return /* @__PURE__ */ React.createElement(OverflowContext.Provider, {
    value: null
  }, /* @__PURE__ */ React.createElement(Item$2, _extends({
    ref: n,
    className: cls(x, Z)
  }, j, V)));
}, RawItem = /* @__PURE__ */ React.forwardRef(InternalRawItem);
RawItem.displayName = "RawItem";
var _excluded$h = ["prefixCls", "data", "renderItem", "renderRawItem", "itemKey", "itemWidth", "ssr", "style", "className", "maxCount", "renderRest", "renderRawRest", "prefix", "suffix", "component", "itemComponent", "onVisibleChange"], RESPONSIVE = "responsive", INVALIDATE = "invalidate";
function defaultRenderRest(t) {
  return "+ ".concat(t.length, " ...");
}
function Overflow(t, r) {
  var n = t.prefixCls, a = n === void 0 ? "rc-overflow" : n, s = t.data, o = s === void 0 ? [] : s, l = t.renderItem, x = t.renderRawItem, j = t.itemKey, Z = t.itemWidth, V = Z === void 0 ? 10 : Z, $ = t.ssr, X = t.style, W = t.className, Y = t.maxCount, U = t.renderRest, G = t.renderRawRest, K = t.prefix, J = t.suffix, ee = t.component, te = ee === void 0 ? "div" : ee, re = t.itemComponent, ae = t.onVisibleChange, ie = _objectWithoutProperties(t, _excluded$h), ce = $ === "full", he = useBatcher(), oe = useEffectState(he, null), le = _slicedToArray(oe, 2), pe = le[0], de = le[1], se = pe || 0, ue = useEffectState(he, /* @__PURE__ */ new Map()), fe = _slicedToArray(ue, 2), ge = fe[0], ne = fe[1], ve = useEffectState(he, 0), me = _slicedToArray(ve, 2), xe = me[0], Ee = me[1], Se = useEffectState(he, 0), _e = _slicedToArray(Se, 2), Ce = _e[0], Te = _e[1], we = useEffectState(he, 0), Re = _slicedToArray(we, 2), Ae = Re[0], Pe = Re[1], ke = useEffectState(he, 0), ye = _slicedToArray(ke, 2), Me = ye[0], be = ye[1], De = useState$1(null), Fe = _slicedToArray(De, 2), Le = Fe[0], Ne = Fe[1], Ie = useState$1(null), je = _slicedToArray(Ie, 2), Ze = je[0], $e = je[1], We = React.useMemo(function() {
    return Ze === null && ce ? Number.MAX_SAFE_INTEGER : Ze || 0;
  }, [Ze, pe]), Be = useState$1(!1), Ue = _slicedToArray(Be, 2), Qe = Ue[0], et = Ue[1], rt = "".concat(a, "-item"), ut = Math.max(xe, Ce), tt = Y === RESPONSIVE, nt = o.length && tt, Dt = Y === INVALIDATE, xt = nt || typeof Y == "number" && o.length > Y, yt = useMemo$1(function() {
    var Oe = o;
    return nt ? pe === null && ce ? Oe = o : Oe = o.slice(0, Math.min(o.length, se / V)) : typeof Y == "number" && (Oe = o.slice(0, Y)), Oe;
  }, [o, V, pe, Y, nt]), St = useMemo$1(function() {
    return nt ? o.slice(We + 1) : o.slice(yt.length);
  }, [o, yt, nt, We]), dt = useCallback(function(Oe, Ve) {
    var qe;
    return typeof j == "function" ? j(Oe) : (qe = j && (Oe == null ? void 0 : Oe[j])) !== null && qe !== void 0 ? qe : Ve;
  }, [j]), Zt = useCallback(l || function(Oe) {
    return Oe;
  }, [l]);
  function wt(Oe, Ve, qe) {
    Ze === Oe && (Ve === void 0 || Ve === Le) || ($e(Oe), qe || (et(Oe < o.length - 1), ae == null || ae(Oe)), Ve !== void 0 && Ne(Ve));
  }
  function It(Oe, Ve) {
    de(Ve.clientWidth);
  }
  function Tt(Oe, Ve) {
    ne(function(qe) {
      var st = new Map(qe);
      return Ve === null ? st.delete(Oe) : st.set(Oe, Ve), st;
    });
  }
  function Gt(Oe, Ve) {
    Te(Ve), Ee(Ce);
  }
  function Vt(Oe, Ve) {
    Pe(Ve);
  }
  function Lt(Oe, Ve) {
    be(Ve);
  }
  function mt(Oe) {
    return ge.get(dt(yt[Oe], Oe));
  }
  useLayoutEffect$2(function() {
    if (se && typeof ut == "number" && yt) {
      var Oe = Ae + Me, Ve = yt.length, qe = Ve - 1;
      if (!Ve) {
        wt(0, null);
        return;
      }
      for (var st = 0; st < Ve; st += 1) {
        var Mt = mt(st);
        if (ce && (Mt = Mt || 0), Mt === void 0) {
          wt(st - 1, void 0, !0);
          break;
        }
        if (Oe += Mt, // Only one means `totalWidth` is the final width
        qe === 0 && Oe <= se || // Last two width will be the final width
        st === qe - 1 && Oe + mt(qe) <= se) {
          wt(qe, null);
          break;
        } else if (Oe + ut > se) {
          wt(st - 1, Oe - Mt - Me + Ce);
          break;
        }
      }
      J && mt(0) + Me > se && Ne(null);
    }
  }, [se, ge, Ce, Ae, Me, dt, yt]);
  var at = Qe && !!St.length, Pt = {};
  Le !== null && nt && (Pt = {
    position: "absolute",
    left: Le,
    top: 0
  });
  var _t = {
    prefixCls: rt,
    responsive: nt,
    component: re,
    invalidate: Dt
  }, pt = x ? function(Oe, Ve) {
    var qe = dt(Oe, Ve);
    return /* @__PURE__ */ React.createElement(OverflowContext.Provider, {
      key: qe,
      value: _objectSpread2(_objectSpread2({}, _t), {}, {
        order: Ve,
        item: Oe,
        itemKey: qe,
        registerSize: Tt,
        display: Ve <= We
      })
    }, x(Oe, Ve));
  } : function(Oe, Ve) {
    var qe = dt(Oe, Ve);
    return /* @__PURE__ */ React.createElement(Item$2, _extends({}, _t, {
      order: Ve,
      key: qe,
      item: Oe,
      renderItem: Zt,
      itemKey: qe,
      registerSize: Tt,
      display: Ve <= We
    }));
  }, Wt = {
    order: at ? We : Number.MAX_SAFE_INTEGER,
    className: "".concat(rt, "-rest"),
    registerSize: Gt,
    display: at
  }, Nt = U || defaultRenderRest, Ye = G ? /* @__PURE__ */ React.createElement(OverflowContext.Provider, {
    value: _objectSpread2(_objectSpread2({}, _t), Wt)
  }, G(St)) : /* @__PURE__ */ React.createElement(Item$2, _extends({}, _t, Wt), typeof Nt == "function" ? Nt(St) : Nt), ze = /* @__PURE__ */ React.createElement(te, _extends({
    className: cls(!Dt && a, W),
    style: X,
    ref: r
  }, ie), K && /* @__PURE__ */ React.createElement(Item$2, _extends({}, _t, {
    responsive: tt,
    responsiveDisabled: !nt,
    order: -1,
    className: "".concat(rt, "-prefix"),
    registerSize: Vt,
    display: !0
  }), K), yt.map(pt), xt ? Ye : null, J && /* @__PURE__ */ React.createElement(Item$2, _extends({}, _t, {
    responsive: tt,
    responsiveDisabled: !nt,
    order: We,
    className: "".concat(rt, "-suffix"),
    registerSize: Lt,
    display: !0,
    style: Pt
  }), J));
  return tt ? /* @__PURE__ */ React.createElement(RefResizeObserver, {
    onResize: It,
    disabled: !nt
  }, ze) : ze;
}
var ForwardOverflow = /* @__PURE__ */ React.forwardRef(Overflow);
ForwardOverflow.displayName = "Overflow";
ForwardOverflow.Item = RawItem;
ForwardOverflow.RESPONSIVE = RESPONSIVE;
ForwardOverflow.INVALIDATE = INVALIDATE;
var Input$1 = function(r, n) {
  var a, s = r.prefixCls, o = r.id, l = r.inputElement, x = r.disabled, j = r.tabIndex, Z = r.autoFocus, V = r.autoComplete, $ = r.editable, X = r.activeDescendantId, W = r.value, Y = r.maxLength, U = r.onKeyDown, G = r.onMouseDown, K = r.onChange, J = r.onPaste, ee = r.onCompositionStart, te = r.onCompositionEnd, re = r.open, ae = r.attrs, ie = l || /* @__PURE__ */ React.createElement("input", null), ce = ie, he = ce.ref, oe = ce.props, le = oe.onKeyDown, pe = oe.onChange, de = oe.onMouseDown, se = oe.onCompositionStart, ue = oe.onCompositionEnd, fe = oe.style;
  return warning(!("maxLength" in ie.props), "Passing 'maxLength' to input element directly may not work because input in BaseSelect is controlled."), ie = /* @__PURE__ */ React.cloneElement(ie, _objectSpread2(_objectSpread2(_objectSpread2({
    type: "search"
  }, oe), {}, {
    // Override over origin props
    id: o,
    ref: composeRef(n, he),
    disabled: x,
    tabIndex: j,
    autoComplete: V || "off",
    autoFocus: Z,
    className: cls("".concat(s, "-selection-search-input"), (a = ie) === null || a === void 0 || (a = a.props) === null || a === void 0 ? void 0 : a.className),
    role: "combobox",
    "aria-expanded": re || !1,
    "aria-haspopup": "listbox",
    "aria-owns": "".concat(o, "_list"),
    "aria-autocomplete": "list",
    "aria-controls": "".concat(o, "_list"),
    "aria-activedescendant": re ? X : void 0
  }, ae), {}, {
    value: $ ? W : "",
    maxLength: Y,
    readOnly: !$,
    unselectable: $ ? null : "on",
    style: _objectSpread2(_objectSpread2({}, fe), {}, {
      opacity: $ ? null : 0
    }),
    onKeyDown: function(ne) {
      U(ne), le && le(ne);
    },
    onMouseDown: function(ne) {
      G(ne), de && de(ne);
    },
    onChange: function(ne) {
      K(ne), pe && pe(ne);
    },
    onCompositionStart: function(ne) {
      ee(ne), se && se(ne);
    },
    onCompositionEnd: function(ne) {
      te(ne), ue && ue(ne);
    },
    onPaste: J
  })), ie;
}, RefInput = /* @__PURE__ */ React.forwardRef(Input$1);
process.env.NODE_ENV !== "production" && (RefInput.displayName = "Input");
function toArray$1(t) {
  return Array.isArray(t) ? t : t !== void 0 ? [t] : [];
}
var isClient$2 = typeof window != "undefined" && window.document && window.document.documentElement, isBrowserClient$1 = process.env.NODE_ENV !== "test" && isClient$2;
function hasValue$2(t) {
  return t != null;
}
function isComboNoValue(t) {
  return !t && t !== 0;
}
function isTitleType$1(t) {
  return ["string", "number"].includes(_typeof$1(t));
}
function getTitle(t) {
  var r = void 0;
  return t && (isTitleType$1(t.title) ? r = t.title.toString() : isTitleType$1(t.label) && (r = t.label.toString())), r;
}
function useLayoutEffect$1(t, r) {
  isBrowserClient$1 ? React.useLayoutEffect(t, r) : React.useEffect(t, r);
}
function itemKey(t) {
  var r;
  return (r = t.key) !== null && r !== void 0 ? r : t.value;
}
var onPreventMouseDown = function(r) {
  r.preventDefault(), r.stopPropagation();
}, SelectSelector = function(r) {
  var n = r.id, a = r.prefixCls, s = r.values, o = r.open, l = r.searchValue, x = r.autoClearSearchValue, j = r.inputRef, Z = r.placeholder, V = r.disabled, $ = r.mode, X = r.showSearch, W = r.autoFocus, Y = r.autoComplete, U = r.activeDescendantId, G = r.tabIndex, K = r.removeIcon, J = r.maxTagCount, ee = r.maxTagTextLength, te = r.maxTagPlaceholder, re = te === void 0 ? function(Me) {
    return "+ ".concat(Me.length, " ...");
  } : te, ae = r.tagRender, ie = r.onToggleOpen, ce = r.onRemove, he = r.onInputChange, oe = r.onInputPaste, le = r.onInputKeyDown, pe = r.onInputMouseDown, de = r.onInputCompositionStart, se = r.onInputCompositionEnd, ue = React.useRef(null), fe = useState$1(0), ge = _slicedToArray(fe, 2), ne = ge[0], ve = ge[1], me = useState$1(!1), xe = _slicedToArray(me, 2), Ee = xe[0], Se = xe[1], _e = "".concat(a, "-selection"), Ce = o || $ === "multiple" && x === !1 || $ === "tags" ? l : "", Te = $ === "tags" || $ === "multiple" && x === !1 || X && (o || Ee);
  useLayoutEffect$1(function() {
    ve(ue.current.scrollWidth);
  }, [Ce]);
  var we = function(be, De, Fe, Le, Ne) {
    return /* @__PURE__ */ React.createElement("span", {
      title: getTitle(be),
      className: cls("".concat(_e, "-item"), _defineProperty({}, "".concat(_e, "-item-disabled"), Fe))
    }, /* @__PURE__ */ React.createElement("span", {
      className: "".concat(_e, "-item-content")
    }, De), Le && /* @__PURE__ */ React.createElement(TransBtn, {
      className: "".concat(_e, "-item-remove"),
      onMouseDown: onPreventMouseDown,
      onClick: Ne,
      customizeIcon: K
    }, "×"));
  }, Re = function(be, De, Fe, Le, Ne) {
    var Ie = function(Ze) {
      onPreventMouseDown(Ze), ie(!o);
    };
    return /* @__PURE__ */ React.createElement("span", {
      onMouseDown: Ie
    }, ae({
      label: De,
      value: be,
      disabled: Fe,
      closable: Le,
      onClose: Ne
    }));
  }, Ae = function(be) {
    var De = be.disabled, Fe = be.label, Le = be.value, Ne = !V && !De, Ie = Fe;
    if (typeof ee == "number" && (typeof Fe == "string" || typeof Fe == "number")) {
      var je = String(Ie);
      je.length > ee && (Ie = "".concat(je.slice(0, ee), "..."));
    }
    var Ze = function(We) {
      We && We.stopPropagation(), ce(be);
    };
    return typeof ae == "function" ? Re(Le, Ie, De, Ne, Ze) : we(be, Ie, De, Ne, Ze);
  }, Pe = function(be) {
    var De = typeof re == "function" ? re(be) : re;
    return we({
      title: De
    }, De, !1);
  }, ke = /* @__PURE__ */ React.createElement("div", {
    className: "".concat(_e, "-search"),
    style: {
      width: ne
    },
    onFocus: function() {
      Se(!0);
    },
    onBlur: function() {
      Se(!1);
    }
  }, /* @__PURE__ */ React.createElement(RefInput, {
    ref: j,
    open: o,
    prefixCls: a,
    id: n,
    inputElement: null,
    disabled: V,
    autoFocus: W,
    autoComplete: Y,
    editable: Te,
    activeDescendantId: U,
    value: Ce,
    onKeyDown: le,
    onMouseDown: pe,
    onChange: he,
    onPaste: oe,
    onCompositionStart: de,
    onCompositionEnd: se,
    tabIndex: G,
    attrs: pickAttrs(r, !0)
  }), /* @__PURE__ */ React.createElement("span", {
    ref: ue,
    className: "".concat(_e, "-search-mirror"),
    "aria-hidden": !0
  }, Ce, " ")), ye = /* @__PURE__ */ React.createElement(ForwardOverflow, {
    prefixCls: "".concat(_e, "-overflow"),
    data: s,
    renderItem: Ae,
    renderRest: Pe,
    suffix: ke,
    itemKey,
    maxCount: J
  });
  return /* @__PURE__ */ React.createElement(React.Fragment, null, ye, !s.length && !Ce && /* @__PURE__ */ React.createElement("span", {
    className: "".concat(_e, "-placeholder")
  }, Z));
}, SingleSelector = function(r) {
  var n = r.inputElement, a = r.prefixCls, s = r.id, o = r.inputRef, l = r.disabled, x = r.autoFocus, j = r.autoComplete, Z = r.activeDescendantId, V = r.mode, $ = r.open, X = r.values, W = r.placeholder, Y = r.tabIndex, U = r.showSearch, G = r.searchValue, K = r.activeValue, J = r.maxLength, ee = r.onInputKeyDown, te = r.onInputMouseDown, re = r.onInputChange, ae = r.onInputPaste, ie = r.onInputCompositionStart, ce = r.onInputCompositionEnd, he = r.title, oe = React.useState(!1), le = _slicedToArray(oe, 2), pe = le[0], de = le[1], se = V === "combobox", ue = se || U, fe = X[0], ge = G || "";
  se && K && !pe && (ge = K), React.useEffect(function() {
    se && de(!1);
  }, [se, K]);
  var ne = V !== "combobox" && !$ && !U ? !1 : !!ge, ve = he === void 0 ? getTitle(fe) : he, me = React.useMemo(function() {
    return fe ? null : /* @__PURE__ */ React.createElement("span", {
      className: "".concat(a, "-selection-placeholder"),
      style: ne ? {
        visibility: "hidden"
      } : void 0
    }, W);
  }, [fe, ne, W, a]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", {
    className: "".concat(a, "-selection-search")
  }, /* @__PURE__ */ React.createElement(RefInput, {
    ref: o,
    prefixCls: a,
    id: s,
    open: $,
    inputElement: n,
    disabled: l,
    autoFocus: x,
    autoComplete: j,
    editable: ue,
    activeDescendantId: Z,
    value: ge,
    onKeyDown: ee,
    onMouseDown: te,
    onChange: function(Ee) {
      de(!0), re(Ee);
    },
    onPaste: ae,
    onCompositionStart: ie,
    onCompositionEnd: ce,
    tabIndex: Y,
    attrs: pickAttrs(r, !0),
    maxLength: se ? J : void 0
  })), !se && fe ? /* @__PURE__ */ React.createElement("span", {
    className: "".concat(a, "-selection-item"),
    title: ve,
    style: ne ? {
      visibility: "hidden"
    } : void 0
  }, fe.label) : null, me);
}, Selector = function(r, n) {
  var a = useRef(null), s = useRef(!1), o = r.prefixCls, l = r.open, x = r.mode, j = r.showSearch, Z = r.tokenWithEnter, V = r.autoClearSearchValue, $ = r.onSearch, X = r.onSearchSubmit, W = r.onToggleOpen, Y = r.onInputKeyDown, U = r.domRef;
  React.useImperativeHandle(n, function() {
    return {
      focus: function(ge) {
        a.current.focus(ge);
      },
      blur: function() {
        a.current.blur();
      }
    };
  });
  var G = useLock(0), K = _slicedToArray(G, 2), J = K[0], ee = K[1], te = function(ge) {
    var ne = ge.which;
    (ne === KeyCode.UP || ne === KeyCode.DOWN) && ge.preventDefault(), Y && Y(ge), ne === KeyCode.ENTER && x === "tags" && !s.current && !l && (X == null || X(ge.target.value)), isValidateOpenKey(ne) && W(!0);
  }, re = function() {
    ee(!0);
  }, ae = useRef(null), ie = function(ge) {
    $(ge, !0, s.current) !== !1 && W(!0);
  }, ce = function() {
    s.current = !0;
  }, he = function(ge) {
    s.current = !1, x !== "combobox" && ie(ge.target.value);
  }, oe = function(ge) {
    var ne = ge.target.value;
    if (Z && ae.current && /[\r\n]/.test(ae.current)) {
      var ve = ae.current.replace(/[\r\n]+$/, "").replace(/\r\n/g, " ").replace(/[\r\n]/g, " ");
      ne = ne.replace(ve, ae.current);
    }
    ae.current = null, ie(ne);
  }, le = function(ge) {
    var ne = ge.clipboardData, ve = ne == null ? void 0 : ne.getData("text");
    ae.current = ve || "";
  }, pe = function(ge) {
    var ne = ge.target;
    if (ne !== a.current) {
      var ve = document.body.style.msTouchAction !== void 0;
      ve ? setTimeout(function() {
        a.current.focus();
      }) : a.current.focus();
    }
  }, de = function(ge) {
    var ne = J();
    ge.target !== a.current && !ne && x !== "combobox" && ge.preventDefault(), (x !== "combobox" && (!j || !ne) || !l) && (l && V !== !1 && $("", !0, !1), W());
  }, se = {
    inputRef: a,
    onInputKeyDown: te,
    onInputMouseDown: re,
    onInputChange: oe,
    onInputPaste: le,
    onInputCompositionStart: ce,
    onInputCompositionEnd: he
  }, ue = x === "multiple" || x === "tags" ? /* @__PURE__ */ React.createElement(SelectSelector, _extends({}, r, se)) : /* @__PURE__ */ React.createElement(SingleSelector, _extends({}, r, se));
  return /* @__PURE__ */ React.createElement("div", {
    ref: U,
    className: "".concat(o, "-selector"),
    onClick: pe,
    onMouseDown: de
  }, ue);
}, ForwardSelector = /* @__PURE__ */ React.forwardRef(Selector);
process.env.NODE_ENV !== "production" && (ForwardSelector.displayName = "Selector");
var OrderContext = /* @__PURE__ */ React.createContext(null), EMPTY_LIST = [];
function useDom(t, r) {
  var n = React.useState(function() {
    if (!canUseDom$1())
      return null;
    var Y = document.createElement("div");
    return process.env.NODE_ENV !== "production" && r && Y.setAttribute("data-debug", r), Y;
  }), a = _slicedToArray(n, 1), s = a[0], o = React.useRef(!1), l = React.useContext(OrderContext), x = React.useState(EMPTY_LIST), j = _slicedToArray(x, 2), Z = j[0], V = j[1], $ = l || (o.current ? void 0 : function(Y) {
    V(function(U) {
      var G = [Y].concat(_toConsumableArray(U));
      return G;
    });
  });
  function X() {
    s.parentElement || document.body.appendChild(s), o.current = !0;
  }
  function W() {
    var Y;
    (Y = s.parentElement) === null || Y === void 0 || Y.removeChild(s), o.current = !1;
  }
  return useLayoutEffect$2(function() {
    return t ? l ? l(X) : X() : W(), W;
  }, [t]), useLayoutEffect$2(function() {
    Z.length && (Z.forEach(function(Y) {
      return Y();
    }), V(EMPTY_LIST));
  }, [Z]), [s, $];
}
function contains$2(t, r) {
  if (!t)
    return !1;
  if (t.contains)
    return t.contains(r);
  for (var n = r; n; ) {
    if (n === t)
      return !0;
    n = n.parentNode;
  }
  return !1;
}
var APPEND_ORDER = "data-rc-order", APPEND_PRIORITY = "data-rc-priority", MARK_KEY = "rc-util-key", containerCache = /* @__PURE__ */ new Map();
function getMark() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = t.mark;
  return r ? r.startsWith("data-") ? r : "data-".concat(r) : MARK_KEY;
}
function getContainer(t) {
  if (t.attachTo)
    return t.attachTo;
  var r = document.querySelector("head");
  return r || document.body;
}
function getOrder(t) {
  return t === "queue" ? "prependQueue" : t ? "prepend" : "append";
}
function findStyles(t) {
  return Array.from((containerCache.get(t) || t).children).filter(function(r) {
    return r.tagName === "STYLE";
  });
}
function injectCSS(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!canUseDom$1())
    return null;
  var n = r.csp, a = r.prepend, s = r.priority, o = s === void 0 ? 0 : s, l = getOrder(a), x = l === "prependQueue", j = document.createElement("style");
  j.setAttribute(APPEND_ORDER, l), x && o && j.setAttribute(APPEND_PRIORITY, "".concat(o)), n != null && n.nonce && (j.nonce = n == null ? void 0 : n.nonce), j.innerHTML = t;
  var Z = getContainer(r), V = Z.firstChild;
  if (a) {
    if (x) {
      var $ = (r.styles || findStyles(Z)).filter(function(X) {
        if (!["prepend", "prependQueue"].includes(X.getAttribute(APPEND_ORDER)))
          return !1;
        var W = Number(X.getAttribute(APPEND_PRIORITY) || 0);
        return o >= W;
      });
      if ($.length)
        return Z.insertBefore(j, $[$.length - 1].nextSibling), j;
    }
    Z.insertBefore(j, V);
  } else
    Z.appendChild(j);
  return j;
}
function findExistNode(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = getContainer(r);
  return (r.styles || findStyles(n)).find(function(a) {
    return a.getAttribute(getMark(r)) === t;
  });
}
function removeCSS(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = findExistNode(t, r);
  if (n) {
    var a = getContainer(r);
    a.removeChild(n);
  }
}
function syncRealContainer(t, r) {
  var n = containerCache.get(t);
  if (!n || !contains$2(document, n)) {
    var a = injectCSS("", r), s = a.parentNode;
    containerCache.set(t, s), t.removeChild(a);
  }
}
function updateCSS(t, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = getContainer(n), s = findStyles(a), o = _objectSpread2(_objectSpread2({}, n), {}, {
    styles: s
  });
  syncRealContainer(a, o);
  var l = findExistNode(r, o);
  if (l) {
    var x, j;
    if ((x = o.csp) !== null && x !== void 0 && x.nonce && l.nonce !== ((j = o.csp) === null || j === void 0 ? void 0 : j.nonce)) {
      var Z;
      l.nonce = (Z = o.csp) === null || Z === void 0 ? void 0 : Z.nonce;
    }
    return l.innerHTML !== t && (l.innerHTML = t), l;
  }
  var V = injectCSS(t, o);
  return V.setAttribute(getMark(o), r), V;
}
function measureScrollbarSize(t) {
  var r = "rc-scrollbar-measure-".concat(Math.random().toString(36).substring(7)), n = document.createElement("div");
  n.id = r;
  var a = n.style;
  a.position = "absolute", a.left = "0", a.top = "0", a.width = "100px", a.height = "100px", a.overflow = "scroll";
  var s, o;
  if (t) {
    var l = getComputedStyle(t);
    a.scrollbarColor = l.scrollbarColor, a.scrollbarWidth = l.scrollbarWidth;
    var x = getComputedStyle(t, "::-webkit-scrollbar"), j = parseInt(x.width, 10), Z = parseInt(x.height, 10);
    try {
      var V = j ? "width: ".concat(x.width, ";") : "", $ = Z ? "height: ".concat(x.height, ";") : "";
      updateCSS(`
#`.concat(r, `::-webkit-scrollbar {
`).concat(V, `
`).concat($, `
}`), r);
    } catch (Y) {
      console.error(Y), s = j, o = Z;
    }
  }
  document.body.appendChild(n);
  var X = t && s && !isNaN(s) ? s : n.offsetWidth - n.clientWidth, W = t && o && !isNaN(o) ? o : n.offsetHeight - n.clientHeight;
  return document.body.removeChild(n), removeCSS(r), {
    width: X,
    height: W
  };
}
function getTargetScrollBarSize(t) {
  return typeof document == "undefined" || !t || !(t instanceof Element) ? {
    width: 0,
    height: 0
  } : measureScrollbarSize(t);
}
function isBodyOverflowing() {
  return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}
var UNIQUE_ID = "rc-util-locker-".concat(Date.now()), uuid$3 = 0;
function useScrollLocker(t) {
  var r = !!t, n = React.useState(function() {
    return uuid$3 += 1, "".concat(UNIQUE_ID, "_").concat(uuid$3);
  }), a = _slicedToArray(n, 1), s = a[0];
  useLayoutEffect$2(function() {
    if (r) {
      var o = getTargetScrollBarSize(document.body).width, l = isBodyOverflowing();
      updateCSS(`
html body {
  overflow-y: hidden;
  `.concat(l ? "width: calc(100% - ".concat(o, "px);") : "", `
}`), s);
    } else
      removeCSS(s);
    return function() {
      removeCSS(s);
    };
  }, [r, s]);
}
var inline = !1;
function inlineMock(t) {
  return inline;
}
var getPortalContainer = function(r) {
  return r === !1 ? !1 : !canUseDom$1() || !r ? null : typeof r == "string" ? document.querySelector(r) : typeof r == "function" ? r() : r;
}, Portal$1 = /* @__PURE__ */ React.forwardRef(function(t, r) {
  var n = t.open, a = t.autoLock, s = t.getContainer, o = t.debug, l = t.autoDestroy, x = l === void 0 ? !0 : l, j = t.children, Z = React.useState(n), V = _slicedToArray(Z, 2), $ = V[0], X = V[1], W = $ || n;
  process.env.NODE_ENV !== "production" && warningOnce(canUseDom$1() || !n, "Portal only work in client side. Please call 'useEffect' to show Portal instead default render in SSR."), React.useEffect(function() {
    (x || n) && X(n);
  }, [n, x]);
  var Y = React.useState(function() {
    return getPortalContainer(s);
  }), U = _slicedToArray(Y, 2), G = U[0], K = U[1];
  React.useEffect(function() {
    var pe = getPortalContainer(s);
    K(pe != null ? pe : null);
  });
  var J = useDom(W && !G, o), ee = _slicedToArray(J, 2), te = ee[0], re = ee[1], ae = G != null ? G : te;
  useScrollLocker(a && n && canUseDom$1() && (ae === te || ae === document.body));
  var ie = null;
  if (j && supportRef(j) && r) {
    var ce = j;
    ie = ce.ref;
  }
  var he = useComposeRef(ie, r);
  if (!W || !canUseDom$1() || G === void 0)
    return null;
  var oe = ae === !1 || inlineMock(), le = j;
  return r && (le = /* @__PURE__ */ React.cloneElement(j, {
    ref: he
  })), /* @__PURE__ */ React.createElement(OrderContext.Provider, {
    value: re
  }, oe ? le : /* @__PURE__ */ createPortal(le, ae));
});
process.env.NODE_ENV !== "production" && (Portal$1.displayName = "Portal");
function getRoot(t) {
  var r;
  return t == null || (r = t.getRootNode) === null || r === void 0 ? void 0 : r.call(t);
}
function inShadow(t) {
  return getRoot(t) instanceof ShadowRoot;
}
function getShadowRoot(t) {
  return inShadow(t) ? getRoot(t) : null;
}
function getUseId() {
  var t = _objectSpread2({}, React);
  return t.useId;
}
var uuid$2 = 0, useOriginId = getUseId();
const useId$2 = useOriginId ? (
  // Use React `useId`
  function(r) {
    var n = useOriginId();
    return r || (process.env.NODE_ENV === "test" ? "test-id" : n);
  }
) : (
  // Use compatible of `useId`
  function(r) {
    var n = React.useState("ssr-id"), a = _slicedToArray(n, 2), s = a[0], o = a[1];
    return React.useEffect(function() {
      var l = uuid$2;
      uuid$2 += 1, o("rc_unique_".concat(l));
    }, []), r || (process.env.NODE_ENV === "test" ? "test-id" : s);
  }
);
var Context = /* @__PURE__ */ React.createContext({}), DomWrapper = /* @__PURE__ */ (function(t) {
  _inherits(n, t);
  var r = _createSuper(n);
  function n() {
    return _classCallCheck(this, n), r.apply(this, arguments);
  }
  return _createClass(n, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), n;
})(React.Component);
function _toArray(t) {
  return _arrayWithHoles(t) || _iterableToArray(t) || _unsupportedIterableToArray(t) || _nonIterableRest();
}
function useSyncState(t) {
  var r = React.useReducer(function(x) {
    return x + 1;
  }, 0), n = _slicedToArray(r, 2), a = n[1], s = React.useRef(t), o = useEvent$1(function() {
    return s.current;
  }), l = useEvent$1(function(x) {
    s.current = typeof x == "function" ? x(s.current) : x, a();
  });
  return [o, l];
}
var STATUS_NONE = "none", STATUS_APPEAR = "appear", STATUS_ENTER = "enter", STATUS_LEAVE = "leave", STEP_NONE = "none", STEP_PREPARE = "prepare", STEP_START = "start", STEP_ACTIVE = "active", STEP_ACTIVATED = "end", STEP_PREPARED = "prepared";
function makePrefixMap(t, r) {
  var n = {};
  return n[t.toLowerCase()] = r.toLowerCase(), n["Webkit".concat(t)] = "webkit".concat(r), n["Moz".concat(t)] = "moz".concat(r), n["ms".concat(t)] = "MS".concat(r), n["O".concat(t)] = "o".concat(r.toLowerCase()), n;
}
function getVendorPrefixes(t, r) {
  var n = {
    animationend: makePrefixMap("Animation", "AnimationEnd"),
    transitionend: makePrefixMap("Transition", "TransitionEnd")
  };
  return t && ("AnimationEvent" in r || delete n.animationend.animation, "TransitionEvent" in r || delete n.transitionend.transition), n;
}
var vendorPrefixes = getVendorPrefixes(canUseDom$1(), typeof window != "undefined" ? window : {}), style$1 = {};
if (canUseDom$1()) {
  var _document$createEleme = document.createElement("div");
  style$1 = _document$createEleme.style;
}
var prefixedEventNames = {};
function getVendorPrefixedEventName(t) {
  if (prefixedEventNames[t])
    return prefixedEventNames[t];
  var r = vendorPrefixes[t];
  if (r)
    for (var n = Object.keys(r), a = n.length, s = 0; s < a; s += 1) {
      var o = n[s];
      if (Object.prototype.hasOwnProperty.call(r, o) && o in style$1)
        return prefixedEventNames[t] = r[o], prefixedEventNames[t];
    }
  return "";
}
var internalAnimationEndName = getVendorPrefixedEventName("animationend"), internalTransitionEndName = getVendorPrefixedEventName("transitionend"), supportTransition = !!(internalAnimationEndName && internalTransitionEndName), animationEndName = internalAnimationEndName || "animationend", transitionEndName = internalTransitionEndName || "transitionend";
function getTransitionName(t, r) {
  if (!t) return null;
  if (_typeof$1(t) === "object") {
    var n = r.replace(/-\w/g, function(a) {
      return a[1].toUpperCase();
    });
    return t[n];
  }
  return "".concat(t, "-").concat(r);
}
const useDomMotionEvents = (function(t) {
  var r = useRef();
  function n(s) {
    s && (s.removeEventListener(transitionEndName, t), s.removeEventListener(animationEndName, t));
  }
  function a(s) {
    r.current && r.current !== s && n(r.current), s && s !== r.current && (s.addEventListener(transitionEndName, t), s.addEventListener(animationEndName, t), r.current = s);
  }
  return React.useEffect(function() {
    return function() {
      n(r.current);
    };
  }, []), [a, n];
});
var useIsomorphicLayoutEffect = canUseDom$1() ? useLayoutEffect$3 : useEffect;
const useNextFrame = (function() {
  var t = React.useRef(null);
  function r() {
    wrapperRaf.cancel(t.current);
  }
  function n(a) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    r();
    var o = wrapperRaf(function() {
      s <= 1 ? a({
        isCanceled: function() {
          return o !== t.current;
        }
      }) : n(a, s - 1);
    });
    t.current = o;
  }
  return React.useEffect(function() {
    return function() {
      r();
    };
  }, []), [n, r];
});
var FULL_STEP_QUEUE = [STEP_PREPARE, STEP_START, STEP_ACTIVE, STEP_ACTIVATED], SIMPLE_STEP_QUEUE = [STEP_PREPARE, STEP_PREPARED], SkipStep = !1, DoStep = !0;
function isActive(t) {
  return t === STEP_ACTIVE || t === STEP_ACTIVATED;
}
const useStepQueue = (function(t, r, n) {
  var a = useSafeState(STEP_NONE), s = _slicedToArray(a, 2), o = s[0], l = s[1], x = useNextFrame(), j = _slicedToArray(x, 2), Z = j[0], V = j[1];
  function $() {
    l(STEP_PREPARE, !0);
  }
  var X = r ? SIMPLE_STEP_QUEUE : FULL_STEP_QUEUE;
  return useIsomorphicLayoutEffect(function() {
    if (o !== STEP_NONE && o !== STEP_ACTIVATED) {
      var W = X.indexOf(o), Y = X[W + 1], U = n(o);
      U === SkipStep ? l(Y, !0) : Y && Z(function(G) {
        function K() {
          G.isCanceled() || l(Y, !0);
        }
        U === !0 ? K() : Promise.resolve(U).then(K);
      });
    }
  }, [t, o]), React.useEffect(function() {
    return function() {
      V();
    };
  }, []), [$, o];
});
function useStatus(t, r, n, a) {
  var s = a.motionEnter, o = s === void 0 ? !0 : s, l = a.motionAppear, x = l === void 0 ? !0 : l, j = a.motionLeave, Z = j === void 0 ? !0 : j, V = a.motionDeadline, $ = a.motionLeaveImmediately, X = a.onAppearPrepare, W = a.onEnterPrepare, Y = a.onLeavePrepare, U = a.onAppearStart, G = a.onEnterStart, K = a.onLeaveStart, J = a.onAppearActive, ee = a.onEnterActive, te = a.onLeaveActive, re = a.onAppearEnd, ae = a.onEnterEnd, ie = a.onLeaveEnd, ce = a.onVisibleChanged, he = useSafeState(), oe = _slicedToArray(he, 2), le = oe[0], pe = oe[1], de = useSyncState(STATUS_NONE), se = _slicedToArray(de, 2), ue = se[0], fe = se[1], ge = useSafeState(null), ne = _slicedToArray(ge, 2), ve = ne[0], me = ne[1], xe = ue(), Ee = useRef(!1), Se = useRef(null);
  function _e() {
    return n();
  }
  var Ce = useRef(!1);
  function Te() {
    fe(STATUS_NONE), me(null, !0);
  }
  var we = useEvent$1(function(Ze) {
    var $e = ue();
    if ($e !== STATUS_NONE) {
      var We = _e();
      if (!(Ze && !Ze.deadline && Ze.target !== We)) {
        var Be = Ce.current, Ue;
        $e === STATUS_APPEAR && Be ? Ue = re == null ? void 0 : re(We, Ze) : $e === STATUS_ENTER && Be ? Ue = ae == null ? void 0 : ae(We, Ze) : $e === STATUS_LEAVE && Be && (Ue = ie == null ? void 0 : ie(We, Ze)), Be && Ue !== !1 && Te();
      }
    }
  }), Re = useDomMotionEvents(we), Ae = _slicedToArray(Re, 1), Pe = Ae[0], ke = function($e) {
    switch ($e) {
      case STATUS_APPEAR:
        return _defineProperty(_defineProperty(_defineProperty({}, STEP_PREPARE, X), STEP_START, U), STEP_ACTIVE, J);
      case STATUS_ENTER:
        return _defineProperty(_defineProperty(_defineProperty({}, STEP_PREPARE, W), STEP_START, G), STEP_ACTIVE, ee);
      case STATUS_LEAVE:
        return _defineProperty(_defineProperty(_defineProperty({}, STEP_PREPARE, Y), STEP_START, K), STEP_ACTIVE, te);
      default:
        return {};
    }
  }, ye = React.useMemo(function() {
    return ke(xe);
  }, [xe]), Me = useStepQueue(xe, !t, function(Ze) {
    if (Ze === STEP_PREPARE) {
      var $e = ye[STEP_PREPARE];
      return $e ? $e(_e()) : SkipStep;
    }
    if (Fe in ye) {
      var We;
      me(((We = ye[Fe]) === null || We === void 0 ? void 0 : We.call(ye, _e(), null)) || null);
    }
    return Fe === STEP_ACTIVE && xe !== STATUS_NONE && (Pe(_e()), V > 0 && (clearTimeout(Se.current), Se.current = setTimeout(function() {
      we({
        deadline: !0
      });
    }, V))), Fe === STEP_PREPARED && Te(), DoStep;
  }), be = _slicedToArray(Me, 2), De = be[0], Fe = be[1], Le = isActive(Fe);
  Ce.current = Le;
  var Ne = useRef(null);
  useIsomorphicLayoutEffect(function() {
    if (!(Ee.current && Ne.current === r)) {
      pe(r);
      var Ze = Ee.current;
      Ee.current = !0;
      var $e;
      !Ze && r && x && ($e = STATUS_APPEAR), Ze && r && o && ($e = STATUS_ENTER), (Ze && !r && Z || !Ze && $ && !r && Z) && ($e = STATUS_LEAVE);
      var We = ke($e);
      $e && (t || We[STEP_PREPARE]) ? (fe($e), De()) : fe(STATUS_NONE), Ne.current = r;
    }
  }, [r]), useEffect(function() {
    // Cancel appear
    (xe === STATUS_APPEAR && !x || // Cancel enter
    xe === STATUS_ENTER && !o || // Cancel leave
    xe === STATUS_LEAVE && !Z) && fe(STATUS_NONE);
  }, [x, o, Z]), useEffect(function() {
    return function() {
      Ee.current = !1, clearTimeout(Se.current);
    };
  }, []);
  var Ie = React.useRef(!1);
  useEffect(function() {
    le && (Ie.current = !0), le !== void 0 && xe === STATUS_NONE && ((Ie.current || le) && (ce == null || ce(le)), Ie.current = !0);
  }, [le, xe]);
  var je = ve;
  return ye[STEP_PREPARE] && Fe === STEP_START && (je = _objectSpread2({
    transition: "none"
  }, je)), [xe, Fe, je, le != null ? le : r];
}
function genCSSMotion(t) {
  var r = t;
  _typeof$1(t) === "object" && (r = t.transitionSupport);
  function n(s, o) {
    return !!(s.motionName && r && o !== !1);
  }
  var a = /* @__PURE__ */ React.forwardRef(function(s, o) {
    var l = s.visible, x = l === void 0 ? !0 : l, j = s.removeOnLeave, Z = j === void 0 ? !0 : j, V = s.forceRender, $ = s.children, X = s.motionName, W = s.leavedClassName, Y = s.eventProps, U = React.useContext(Context), G = U.motion, K = n(s, G), J = useRef(), ee = useRef();
    function te() {
      try {
        return J.current instanceof HTMLElement ? J.current : findDOMNode$1(ee.current);
      } catch {
        return null;
      }
    }
    var re = useStatus(K, x, te, s), ae = _slicedToArray(re, 4), ie = ae[0], ce = ae[1], he = ae[2], oe = ae[3], le = React.useRef(oe);
    oe && (le.current = !0);
    var pe = React.useCallback(function(ne) {
      J.current = ne, fillRef(o, ne);
    }, [o]), de, se = _objectSpread2(_objectSpread2({}, Y), {}, {
      visible: x
    });
    if (!$)
      de = null;
    else if (ie === STATUS_NONE)
      oe ? de = $(_objectSpread2({}, se), pe) : !Z && le.current && W ? de = $(_objectSpread2(_objectSpread2({}, se), {}, {
        className: W
      }), pe) : V || !Z && !W ? de = $(_objectSpread2(_objectSpread2({}, se), {}, {
        style: {
          display: "none"
        }
      }), pe) : de = null;
    else {
      var ue;
      ce === STEP_PREPARE ? ue = "prepare" : isActive(ce) ? ue = "active" : ce === STEP_START && (ue = "start");
      var fe = getTransitionName(X, "".concat(ie, "-").concat(ue));
      de = $(_objectSpread2(_objectSpread2({}, se), {}, {
        className: cls(getTransitionName(X, ie), _defineProperty(_defineProperty({}, fe, fe && ue), X, typeof X == "string")),
        style: he
      }), pe);
    }
    if (/* @__PURE__ */ React.isValidElement(de) && supportRef(de)) {
      var ge = getNodeRef(de);
      ge || (de = /* @__PURE__ */ React.cloneElement(de, {
        ref: pe
      }));
    }
    return /* @__PURE__ */ React.createElement(DomWrapper, {
      ref: ee
    }, de);
  });
  return a.displayName = "CSSMotion", a;
}
const CSSMotion = genCSSMotion(supportTransition);
var STATUS_ADD = "add", STATUS_KEEP = "keep", STATUS_REMOVE = "remove", STATUS_REMOVED = "removed";
function wrapKeyToObject(t) {
  var r;
  return t && _typeof$1(t) === "object" && "key" in t ? r = t : r = {
    key: t
  }, _objectSpread2(_objectSpread2({}, r), {}, {
    key: String(r.key)
  });
}
function parseKeys() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  return t.map(wrapKeyToObject);
}
function diffKeys() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], n = [], a = 0, s = r.length, o = parseKeys(t), l = parseKeys(r);
  o.forEach(function(Z) {
    for (var V = !1, $ = a; $ < s; $ += 1) {
      var X = l[$];
      if (X.key === Z.key) {
        a < $ && (n = n.concat(l.slice(a, $).map(function(W) {
          return _objectSpread2(_objectSpread2({}, W), {}, {
            status: STATUS_ADD
          });
        })), a = $), n.push(_objectSpread2(_objectSpread2({}, X), {}, {
          status: STATUS_KEEP
        })), a += 1, V = !0;
        break;
      }
    }
    V || n.push(_objectSpread2(_objectSpread2({}, Z), {}, {
      status: STATUS_REMOVE
    }));
  }), a < s && (n = n.concat(l.slice(a).map(function(Z) {
    return _objectSpread2(_objectSpread2({}, Z), {}, {
      status: STATUS_ADD
    });
  })));
  var x = {};
  n.forEach(function(Z) {
    var V = Z.key;
    x[V] = (x[V] || 0) + 1;
  });
  var j = Object.keys(x).filter(function(Z) {
    return x[Z] > 1;
  });
  return j.forEach(function(Z) {
    n = n.filter(function(V) {
      var $ = V.key, X = V.status;
      return $ !== Z || X !== STATUS_REMOVE;
    }), n.forEach(function(V) {
      V.key === Z && (V.status = STATUS_KEEP);
    });
  }), n;
}
var _excluded$g = ["component", "children", "onVisibleChanged", "onAllRemoved"], _excluded2$1 = ["status"], MOTION_PROP_NAMES = ["eventProps", "visible", "children", "motionName", "motionAppear", "motionEnter", "motionLeave", "motionLeaveImmediately", "motionDeadline", "removeOnLeave", "leavedClassName", "onAppearPrepare", "onAppearStart", "onAppearActive", "onAppearEnd", "onEnterStart", "onEnterActive", "onEnterEnd", "onLeaveStart", "onLeaveActive", "onLeaveEnd"];
function genCSSMotionList(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : CSSMotion, n = /* @__PURE__ */ (function(a) {
    _inherits(o, a);
    var s = _createSuper(o);
    function o() {
      var l;
      _classCallCheck(this, o);
      for (var x = arguments.length, j = new Array(x), Z = 0; Z < x; Z++)
        j[Z] = arguments[Z];
      return l = s.call.apply(s, [this].concat(j)), _defineProperty(_assertThisInitialized(l), "state", {
        keyEntities: []
      }), _defineProperty(_assertThisInitialized(l), "removeKey", function(V) {
        l.setState(function($) {
          var X = $.keyEntities.map(function(W) {
            return W.key !== V ? W : _objectSpread2(_objectSpread2({}, W), {}, {
              status: STATUS_REMOVED
            });
          });
          return {
            keyEntities: X
          };
        }, function() {
          var $ = l.state.keyEntities, X = $.filter(function(W) {
            var Y = W.status;
            return Y !== STATUS_REMOVED;
          }).length;
          X === 0 && l.props.onAllRemoved && l.props.onAllRemoved();
        });
      }), l;
    }
    return _createClass(o, [{
      key: "render",
      value: function() {
        var x = this, j = this.state.keyEntities, Z = this.props, V = Z.component, $ = Z.children, X = Z.onVisibleChanged;
        Z.onAllRemoved;
        var W = _objectWithoutProperties(Z, _excluded$g), Y = V || React.Fragment, U = {};
        return MOTION_PROP_NAMES.forEach(function(G) {
          U[G] = W[G], delete W[G];
        }), delete W.keys, /* @__PURE__ */ React.createElement(Y, W, j.map(function(G, K) {
          var J = G.status, ee = _objectWithoutProperties(G, _excluded2$1), te = J === STATUS_ADD || J === STATUS_KEEP;
          return /* @__PURE__ */ React.createElement(r, _extends({}, U, {
            key: ee.key,
            visible: te,
            eventProps: ee,
            onVisibleChanged: function(ae) {
              X == null || X(ae, {
                key: ee.key
              }), ae || x.removeKey(ee.key);
            }
          }), function(re, ae) {
            return $(_objectSpread2(_objectSpread2({}, re), {}, {
              index: K
            }), ae);
          });
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(x, j) {
        var Z = x.keys, V = j.keyEntities, $ = parseKeys(Z), X = diffKeys(V, $);
        return {
          keyEntities: X.filter(function(W) {
            var Y = V.find(function(U) {
              var G = U.key;
              return W.key === G;
            });
            return !(Y && Y.status === STATUS_REMOVED && W.status === STATUS_REMOVE);
          })
        };
      }
    }]), o;
  })(React.Component);
  return _defineProperty(n, "defaultProps", {
    component: "div"
  }), n;
}
genCSSMotionList(supportTransition);
function Arrow(t) {
  var r = t.prefixCls, n = t.align, a = t.arrow, s = t.arrowPos, o = a || {}, l = o.className, x = o.content, j = s.x, Z = j === void 0 ? 0 : j, V = s.y, $ = V === void 0 ? 0 : V, X = React.useRef();
  if (!n || !n.points)
    return null;
  var W = {
    position: "absolute"
  };
  if (n.autoArrow !== !1) {
    var Y = n.points[0], U = n.points[1], G = Y[0], K = Y[1], J = U[0], ee = U[1];
    G === J || !["t", "b"].includes(G) ? W.top = $ : G === "t" ? W.top = 0 : W.bottom = 0, K === ee || !["l", "r"].includes(K) ? W.left = Z : K === "l" ? W.left = 0 : W.right = 0;
  }
  return /* @__PURE__ */ React.createElement("div", {
    ref: X,
    className: cls("".concat(r, "-arrow"), l),
    style: W
  }, x);
}
function Mask(t) {
  var r = t.prefixCls, n = t.open, a = t.zIndex, s = t.mask, o = t.motion;
  return s ? /* @__PURE__ */ React.createElement(CSSMotion, _extends({}, o, {
    motionAppear: !0,
    visible: n,
    removeOnLeave: !0
  }), function(l) {
    var x = l.className;
    return /* @__PURE__ */ React.createElement("div", {
      style: {
        zIndex: a
      },
      className: cls("".concat(r, "-mask"), x)
    });
  }) : null;
}
var PopupContent = /* @__PURE__ */ React.memo(function(t) {
  var r = t.children;
  return r;
}, function(t, r) {
  return r.cache;
});
process.env.NODE_ENV !== "production" && (PopupContent.displayName = "PopupContent");
var Popup = /* @__PURE__ */ React.forwardRef(function(t, r) {
  var n = t.popup, a = t.className, s = t.prefixCls, o = t.style, l = t.target, x = t.onVisibleChanged, j = t.open, Z = t.keepDom, V = t.fresh, $ = t.onClick, X = t.mask, W = t.arrow, Y = t.arrowPos, U = t.align, G = t.motion, K = t.maskMotion, J = t.forceRender, ee = t.getPopupContainer, te = t.autoDestroy, re = t.portal, ae = t.zIndex, ie = t.onMouseEnter, ce = t.onMouseLeave, he = t.onPointerEnter, oe = t.ready, le = t.offsetX, pe = t.offsetY, de = t.offsetR, se = t.offsetB, ue = t.onAlign, fe = t.onPrepare, ge = t.stretch, ne = t.targetWidth, ve = t.targetHeight, me = typeof n == "function" ? n() : n, xe = j || Z, Ee = (ee == null ? void 0 : ee.length) > 0, Se = React.useState(!ee || !Ee), _e = _slicedToArray(Se, 2), Ce = _e[0], Te = _e[1];
  if (useLayoutEffect$2(function() {
    !Ce && Ee && l && Te(!0);
  }, [Ce, Ee, l]), !Ce)
    return null;
  var we = "auto", Re = {
    left: "-1000vw",
    top: "-1000vh",
    right: we,
    bottom: we
  };
  if (oe || !j) {
    var Ae, Pe = U.points, ke = U.dynamicInset || ((Ae = U._experimental) === null || Ae === void 0 ? void 0 : Ae.dynamicInset), ye = ke && Pe[0][1] === "r", Me = ke && Pe[0][0] === "b";
    ye ? (Re.right = de, Re.left = we) : (Re.left = le, Re.right = we), Me ? (Re.bottom = se, Re.top = we) : (Re.top = pe, Re.bottom = we);
  }
  var be = {};
  return ge && (ge.includes("height") && ve ? be.height = ve : ge.includes("minHeight") && ve && (be.minHeight = ve), ge.includes("width") && ne ? be.width = ne : ge.includes("minWidth") && ne && (be.minWidth = ne)), j || (be.pointerEvents = "none"), /* @__PURE__ */ React.createElement(re, {
    open: J || xe,
    getContainer: ee && function() {
      return ee(l);
    },
    autoDestroy: te
  }, /* @__PURE__ */ React.createElement(Mask, {
    prefixCls: s,
    open: j,
    zIndex: ae,
    mask: X,
    motion: K
  }), /* @__PURE__ */ React.createElement(RefResizeObserver, {
    onResize: ue,
    disabled: !j
  }, function(De) {
    return /* @__PURE__ */ React.createElement(CSSMotion, _extends({
      motionAppear: !0,
      motionEnter: !0,
      motionLeave: !0,
      removeOnLeave: !1,
      forceRender: J,
      leavedClassName: "".concat(s, "-hidden")
    }, G, {
      onAppearPrepare: fe,
      onEnterPrepare: fe,
      visible: j,
      onVisibleChanged: function(Le) {
        var Ne;
        G == null || (Ne = G.onVisibleChanged) === null || Ne === void 0 || Ne.call(G, Le), x(Le);
      }
    }), function(Fe, Le) {
      var Ne = Fe.className, Ie = Fe.style, je = cls(s, Ne, a);
      return /* @__PURE__ */ React.createElement("div", {
        ref: composeRef(De, r, Le),
        className: je,
        style: _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
          "--arrow-x": "".concat(Y.x || 0, "px"),
          "--arrow-y": "".concat(Y.y || 0, "px")
        }, Re), be), Ie), {}, {
          boxSizing: "border-box",
          zIndex: ae
        }, o),
        onMouseEnter: ie,
        onMouseLeave: ce,
        onPointerEnter: he,
        onClick: $
      }, W && /* @__PURE__ */ React.createElement(Arrow, {
        prefixCls: s,
        arrow: W,
        arrowPos: Y,
        align: U
      }), /* @__PURE__ */ React.createElement(PopupContent, {
        cache: !j && !V
      }, me));
    });
  }));
});
process.env.NODE_ENV !== "production" && (Popup.displayName = "Popup");
var TriggerWrapper = /* @__PURE__ */ React.forwardRef(function(t, r) {
  var n = t.children, a = t.getTriggerDOMNode, s = supportRef(n), o = React.useCallback(function(x) {
    fillRef(r, a ? a(x) : x);
  }, [a]), l = useComposeRef(o, n.ref);
  return s ? /* @__PURE__ */ React.cloneElement(n, {
    ref: l
  }) : n;
});
process.env.NODE_ENV !== "production" && (TriggerWrapper.displayName = "TriggerWrapper");
var TriggerContext = /* @__PURE__ */ React.createContext(null);
function toArray(t) {
  return t ? Array.isArray(t) ? t : [t] : [];
}
function useAction(t, r, n, a) {
  return React.useMemo(function() {
    var s = toArray(n != null ? n : r), o = toArray(a != null ? a : r), l = new Set(s), x = new Set(o);
    return t && (l.has("hover") && (l.delete("hover"), l.add("click")), x.has("hover") && (x.delete("hover"), x.add("click"))), [l, x];
  }, [t, r, n, a]);
}
const isVisible = (function(t) {
  if (!t)
    return !1;
  if (t instanceof Element) {
    if (t.offsetParent)
      return !0;
    if (t.getBBox) {
      var r = t.getBBox(), n = r.width, a = r.height;
      if (n || a)
        return !0;
    }
    if (t.getBoundingClientRect) {
      var s = t.getBoundingClientRect(), o = s.width, l = s.height;
      if (o || l)
        return !0;
    }
  }
  return !1;
});
function isPointsEq() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], n = arguments.length > 2 ? arguments[2] : void 0;
  return n ? t[0] === r[0] : t[0] === r[0] && t[1] === r[1];
}
function getAlignPopupClassName(t, r, n, a) {
  for (var s = n.points, o = Object.keys(t), l = 0; l < o.length; l += 1) {
    var x, j = o[l];
    if (isPointsEq((x = t[j]) === null || x === void 0 ? void 0 : x.points, s, a))
      return "".concat(r, "-placement-").concat(j);
  }
  return "";
}
function getMotion(t, r, n, a) {
  return r || (n ? {
    motionName: "".concat(t, "-").concat(n)
  } : a ? {
    motionName: a
  } : null);
}
function getWin(t) {
  return t.ownerDocument.defaultView;
}
function collectScroller(t) {
  for (var r = [], n = t == null ? void 0 : t.parentElement, a = ["hidden", "scroll", "clip", "auto"]; n; ) {
    var s = getWin(n).getComputedStyle(n), o = s.overflowX, l = s.overflowY, x = s.overflow;
    [o, l, x].some(function(j) {
      return a.includes(j);
    }) && r.push(n), n = n.parentElement;
  }
  return r;
}
function toNum(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  return Number.isNaN(t) ? r : t;
}
function getPxValue(t) {
  return toNum(parseFloat(t), 0);
}
function getVisibleArea(t, r) {
  var n = _objectSpread2({}, t);
  return (r || []).forEach(function(a) {
    if (!(a instanceof HTMLBodyElement || a instanceof HTMLHtmlElement)) {
      var s = getWin(a).getComputedStyle(a), o = s.overflow, l = s.overflowClipMargin, x = s.borderTopWidth, j = s.borderBottomWidth, Z = s.borderLeftWidth, V = s.borderRightWidth, $ = a.getBoundingClientRect(), X = a.offsetHeight, W = a.clientHeight, Y = a.offsetWidth, U = a.clientWidth, G = getPxValue(x), K = getPxValue(j), J = getPxValue(Z), ee = getPxValue(V), te = toNum(Math.round($.width / Y * 1e3) / 1e3), re = toNum(Math.round($.height / X * 1e3) / 1e3), ae = (Y - U - J - ee) * te, ie = (X - W - G - K) * re, ce = G * re, he = K * re, oe = J * te, le = ee * te, pe = 0, de = 0;
      if (o === "clip") {
        var se = getPxValue(l);
        pe = se * te, de = se * re;
      }
      var ue = $.x + oe - pe, fe = $.y + ce - de, ge = ue + $.width + 2 * pe - oe - le - ae, ne = fe + $.height + 2 * de - ce - he - ie;
      n.left = Math.max(n.left, ue), n.top = Math.max(n.top, fe), n.right = Math.min(n.right, ge), n.bottom = Math.min(n.bottom, ne);
    }
  }), n;
}
function getUnitOffset(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = "".concat(r), a = n.match(/^(.*)\%$/);
  return a ? t * (parseFloat(a[1]) / 100) : parseFloat(n);
}
function getNumberOffset(t, r) {
  var n = r || [], a = _slicedToArray(n, 2), s = a[0], o = a[1];
  return [getUnitOffset(t.width, s), getUnitOffset(t.height, o)];
}
function splitPoints() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  return [t[0], t[1]];
}
function getAlignPoint(t, r) {
  var n = r[0], a = r[1], s, o;
  return n === "t" ? o = t.y : n === "b" ? o = t.y + t.height : o = t.y + t.height / 2, a === "l" ? s = t.x : a === "r" ? s = t.x + t.width : s = t.x + t.width / 2, {
    x: s,
    y: o
  };
}
function reversePoints(t, r) {
  var n = {
    t: "b",
    b: "t",
    l: "r",
    r: "l"
  };
  return t.map(function(a, s) {
    return s === r ? n[a] || "c" : a;
  }).join("");
}
function useAlign(t, r, n, a, s, o, l) {
  var x = React.useState({
    ready: !1,
    offsetX: 0,
    offsetY: 0,
    offsetR: 0,
    offsetB: 0,
    arrowX: 0,
    arrowY: 0,
    scaleX: 1,
    scaleY: 1,
    align: s[a] || {}
  }), j = _slicedToArray(x, 2), Z = j[0], V = j[1], $ = React.useRef(0), X = React.useMemo(function() {
    return r ? collectScroller(r) : [];
  }, [r]), W = React.useRef({}), Y = function() {
    W.current = {};
  };
  t || Y();
  var U = useEvent$1(function() {
    if (r && n && t) {
      let rr = function(cr, pr) {
        var vr = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : je, gr = me.x + cr, yr = me.y + pr, br = gr + Ae, Sr = yr + Re, Cr = Math.max(gr, vr.left), Rr = Math.max(yr, vr.top), wr = Math.min(br, vr.right), Tr = Math.min(Sr, vr.bottom);
        return Math.max(0, (wr - Cr) * (Tr - Rr));
      }, xr = function() {
        kt = me.y + at, Ft = kt + Re, Je = me.x + mt, Xe = Je + Ae;
      };
      var J, ee, te = r, re = te.ownerDocument, ae = getWin(te), ie = ae.getComputedStyle(te), ce = ie.width, he = ie.height, oe = ie.position, le = te.style.left, pe = te.style.top, de = te.style.right, se = te.style.bottom, ue = te.style.overflow, fe = _objectSpread2(_objectSpread2({}, s[a]), o), ge = re.createElement("div");
      (J = te.parentElement) === null || J === void 0 || J.appendChild(ge), ge.style.left = "".concat(te.offsetLeft, "px"), ge.style.top = "".concat(te.offsetTop, "px"), ge.style.position = oe, ge.style.height = "".concat(te.offsetHeight, "px"), ge.style.width = "".concat(te.offsetWidth, "px"), te.style.left = "0", te.style.top = "0", te.style.right = "auto", te.style.bottom = "auto", te.style.overflow = "hidden";
      var ne;
      if (Array.isArray(n))
        ne = {
          x: n[0],
          y: n[1],
          width: 0,
          height: 0
        };
      else {
        var ve = n.getBoundingClientRect();
        ne = {
          x: ve.x,
          y: ve.y,
          width: ve.width,
          height: ve.height
        };
      }
      var me = te.getBoundingClientRect(), xe = re.documentElement, Ee = xe.clientWidth, Se = xe.clientHeight, _e = xe.scrollWidth, Ce = xe.scrollHeight, Te = xe.scrollTop, we = xe.scrollLeft, Re = me.height, Ae = me.width, Pe = ne.height, ke = ne.width, ye = {
        left: 0,
        top: 0,
        right: Ee,
        bottom: Se
      }, Me = {
        left: -we,
        top: -Te,
        right: _e - we,
        bottom: Ce - Te
      }, be = fe.htmlRegion, De = "visible", Fe = "visibleFirst";
      be !== "scroll" && be !== Fe && (be = De);
      var Le = be === Fe, Ne = getVisibleArea(Me, X), Ie = getVisibleArea(ye, X), je = be === De ? Ie : Ne, Ze = Le ? Ie : je;
      te.style.left = "auto", te.style.top = "auto", te.style.right = "0", te.style.bottom = "0";
      var $e = te.getBoundingClientRect();
      te.style.left = le, te.style.top = pe, te.style.right = de, te.style.bottom = se, te.style.overflow = ue, (ee = te.parentElement) === null || ee === void 0 || ee.removeChild(ge);
      var We = toNum(Math.round(Ae / parseFloat(ce) * 1e3) / 1e3), Be = toNum(Math.round(Re / parseFloat(he) * 1e3) / 1e3);
      if (We === 0 || Be === 0 || isDOM(n) && !isVisible(n))
        return;
      var Ue = fe.offset, Qe = fe.targetOffset, et = getNumberOffset(me, Ue), rt = _slicedToArray(et, 2), ut = rt[0], tt = rt[1], nt = getNumberOffset(ne, Qe), Dt = _slicedToArray(nt, 2), xt = Dt[0], yt = Dt[1];
      ne.x -= xt, ne.y -= yt;
      var St = fe.points || [], dt = _slicedToArray(St, 2), Zt = dt[0], wt = dt[1], It = splitPoints(wt), Tt = splitPoints(Zt), Gt = getAlignPoint(ne, It), Vt = getAlignPoint(me, Tt), Lt = _objectSpread2({}, fe), mt = Gt.x - Vt.x + ut, at = Gt.y - Vt.y + tt, Pt = rr(mt, at), _t = rr(mt, at, Ie), pt = getAlignPoint(ne, ["t", "l"]), Wt = getAlignPoint(me, ["t", "l"]), Nt = getAlignPoint(ne, ["b", "r"]), Ye = getAlignPoint(me, ["b", "r"]), ze = fe.overflow || {}, Oe = ze.adjustX, Ve = ze.adjustY, qe = ze.shiftX, st = ze.shiftY, Mt = function(pr) {
        return typeof pr == "boolean" ? pr : pr >= 0;
      }, kt, Ft, Je, Xe;
      xr();
      var ct = Mt(Ve), bt = Tt[0] === It[0];
      if (ct && Tt[0] === "t" && (Ft > Ze.bottom || W.current.bt)) {
        var vt = at;
        bt ? vt -= Re - Pe : vt = pt.y - Ye.y - tt;
        var Rt = rr(mt, vt), Et = rr(mt, vt, Ie);
        // Of course use larger one
        Rt > Pt || Rt === Pt && (!Le || // Choose recommend one
        Et >= _t) ? (W.current.bt = !0, at = vt, tt = -tt, Lt.points = [reversePoints(Tt, 0), reversePoints(It, 0)]) : W.current.bt = !1;
      }
      if (ct && Tt[0] === "b" && (kt < Ze.top || W.current.tb)) {
        var gt = at;
        bt ? gt += Re - Pe : gt = Nt.y - Wt.y - tt;
        var He = rr(mt, gt), Ge = rr(mt, gt, Ie);
        // Of course use larger one
        He > Pt || He === Pt && (!Le || // Choose recommend one
        Ge >= _t) ? (W.current.tb = !0, at = gt, tt = -tt, Lt.points = [reversePoints(Tt, 0), reversePoints(It, 0)]) : W.current.tb = !1;
      }
      var it = Mt(Oe), ht = Tt[1] === It[1];
      if (it && Tt[1] === "l" && (Xe > Ze.right || W.current.rl)) {
        var Ct = mt;
        ht ? Ct -= Ae - ke : Ct = pt.x - Ye.x - ut;
        var nr = rr(Ct, at), Ut = rr(Ct, at, Ie);
        // Of course use larger one
        nr > Pt || nr === Pt && (!Le || // Choose recommend one
        Ut >= _t) ? (W.current.rl = !0, mt = Ct, ut = -ut, Lt.points = [reversePoints(Tt, 1), reversePoints(It, 1)]) : W.current.rl = !1;
      }
      if (it && Tt[1] === "r" && (Je < Ze.left || W.current.lr)) {
        var Xt = mt;
        ht ? Xt += Ae - ke : Xt = Nt.x - Wt.x - ut;
        var lr = rr(Xt, at), Jt = rr(Xt, at, Ie);
        // Of course use larger one
        lr > Pt || lr === Pt && (!Le || // Choose recommend one
        Jt >= _t) ? (W.current.lr = !0, mt = Xt, ut = -ut, Lt.points = [reversePoints(Tt, 1), reversePoints(It, 1)]) : W.current.lr = !1;
      }
      xr();
      var Yt = qe === !0 ? 0 : qe;
      typeof Yt == "number" && (Je < Ie.left && (mt -= Je - Ie.left - ut, ne.x + ke < Ie.left + Yt && (mt += ne.x - Ie.left + ke - Yt)), Xe > Ie.right && (mt -= Xe - Ie.right - ut, ne.x > Ie.right - Yt && (mt += ne.x - Ie.right + Yt)));
      var ir = st === !0 ? 0 : st;
      typeof ir == "number" && (kt < Ie.top && (at -= kt - Ie.top - tt, ne.y + Pe < Ie.top + ir && (at += ne.y - Ie.top + Pe - ir)), Ft > Ie.bottom && (at -= Ft - Ie.bottom - tt, ne.y > Ie.bottom - ir && (at += ne.y - Ie.bottom + ir)));
      var ur = me.x + mt, hr = ur + Ae, ar = me.y + at, mr = ar + Re, sr = ne.x, er = sr + ke, ft = ne.y, lt = ft + Pe, Bt = Math.max(ur, sr), $t = Math.min(hr, er), At = (Bt + $t) / 2, Ht = At - ur, qt = Math.max(ar, ft), Kt = Math.min(mr, lt), tr = (qt + Kt) / 2, or = tr - ar;
      l == null || l(r, Lt);
      var Qt = $e.right - me.x - (mt + me.width), dr = $e.bottom - me.y - (at + me.height);
      V({
        ready: !0,
        offsetX: mt / We,
        offsetY: at / Be,
        offsetR: Qt / We,
        offsetB: dr / Be,
        arrowX: Ht / We,
        arrowY: or / Be,
        scaleX: We,
        scaleY: Be,
        align: Lt
      });
    }
  }), G = function() {
    $.current += 1;
    var ee = $.current;
    Promise.resolve().then(function() {
      $.current === ee && U();
    });
  }, K = function() {
    V(function(ee) {
      return _objectSpread2(_objectSpread2({}, ee), {}, {
        ready: !1
      });
    });
  };
  return useLayoutEffect$2(K, [a]), useLayoutEffect$2(function() {
    t || K();
  }, [t]), [Z.ready, Z.offsetX, Z.offsetY, Z.offsetR, Z.offsetB, Z.arrowX, Z.arrowY, Z.scaleX, Z.scaleY, Z.align, G];
}
function useWatch(t, r, n, a, s) {
  useLayoutEffect$2(function() {
    if (t && r && n) {
      let $ = function() {
        a(), s();
      };
      var o = r, l = n, x = collectScroller(o), j = collectScroller(l), Z = getWin(l), V = new Set([Z].concat(_toConsumableArray(x), _toConsumableArray(j)));
      return V.forEach(function(X) {
        X.addEventListener("scroll", $, {
          passive: !0
        });
      }), Z.addEventListener("resize", $, {
        passive: !0
      }), a(), function() {
        V.forEach(function(X) {
          X.removeEventListener("scroll", $), Z.removeEventListener("resize", $);
        });
      };
    }
  }, [t, r, n]);
}
function useWinClick(t, r, n, a, s, o, l, x) {
  var j = React.useRef(t), Z = React.useRef(!1);
  j.current !== t && (Z.current = !0, j.current = t), React.useEffect(function() {
    var V = wrapperRaf(function() {
      Z.current = !1;
    });
    return function() {
      wrapperRaf.cancel(V);
    };
  }, [t]), React.useEffect(function() {
    if (r && a && (!s || o)) {
      var V = function() {
        var oe = !1, le = function(se) {
          var ue = se.target;
          oe = l(ue);
        }, pe = function(se) {
          var ue = se.target;
          !Z.current && j.current && !oe && !l(ue) && x(!1);
        };
        return [le, pe];
      }, $ = V(), X = _slicedToArray($, 2), W = X[0], Y = X[1], U = V(), G = _slicedToArray(U, 2), K = G[0], J = G[1], ee = getWin(a);
      ee.addEventListener("mousedown", W, !0), ee.addEventListener("click", Y, !0), ee.addEventListener("contextmenu", Y, !0);
      var te = getShadowRoot(n);
      if (te && (te.addEventListener("mousedown", K, !0), te.addEventListener("click", J, !0), te.addEventListener("contextmenu", J, !0)), process.env.NODE_ENV !== "production") {
        var re, ae, ie = n == null || (re = n.getRootNode) === null || re === void 0 ? void 0 : re.call(n), ce = (ae = a.getRootNode) === null || ae === void 0 ? void 0 : ae.call(a);
        warning(ie === ce, "trigger element and popup element should in same shadow root.");
      }
      return function() {
        ee.removeEventListener("mousedown", W, !0), ee.removeEventListener("click", Y, !0), ee.removeEventListener("contextmenu", Y, !0), te && (te.removeEventListener("mousedown", K, !0), te.removeEventListener("click", J, !0), te.removeEventListener("contextmenu", J, !0));
      };
    }
  }, [r, n, a, s, o]);
}
var _excluded$f = ["prefixCls", "children", "action", "showAction", "hideAction", "popupVisible", "defaultPopupVisible", "onPopupVisibleChange", "afterPopupVisibleChange", "mouseEnterDelay", "mouseLeaveDelay", "focusDelay", "blurDelay", "mask", "maskClosable", "getPopupContainer", "forceRender", "autoDestroy", "destroyPopupOnHide", "popup", "popupClassName", "popupStyle", "popupPlacement", "builtinPlacements", "popupAlign", "zIndex", "stretch", "getPopupClassNameFromAlign", "fresh", "alignPoint", "onPopupClick", "onPopupAlign", "arrow", "popupMotion", "maskMotion", "popupTransitionName", "popupAnimation", "maskTransitionName", "maskAnimation", "className", "getTriggerDOMNode"];
function generateTrigger() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Portal$1, r = /* @__PURE__ */ React.forwardRef(function(n, a) {
    var s = n.prefixCls, o = s === void 0 ? "rc-trigger-popup" : s, l = n.children, x = n.action, j = x === void 0 ? "hover" : x, Z = n.showAction, V = n.hideAction, $ = n.popupVisible, X = n.defaultPopupVisible, W = n.onPopupVisibleChange, Y = n.afterPopupVisibleChange, U = n.mouseEnterDelay, G = n.mouseLeaveDelay, K = G === void 0 ? 0.1 : G, J = n.focusDelay, ee = n.blurDelay, te = n.mask, re = n.maskClosable, ae = re === void 0 ? !0 : re, ie = n.getPopupContainer, ce = n.forceRender, he = n.autoDestroy, oe = n.destroyPopupOnHide, le = n.popup, pe = n.popupClassName, de = n.popupStyle, se = n.popupPlacement, ue = n.builtinPlacements, fe = ue === void 0 ? {} : ue, ge = n.popupAlign, ne = n.zIndex, ve = n.stretch, me = n.getPopupClassNameFromAlign, xe = n.fresh, Ee = n.alignPoint, Se = n.onPopupClick, _e = n.onPopupAlign, Ce = n.arrow, Te = n.popupMotion, we = n.maskMotion, Re = n.popupTransitionName, Ae = n.popupAnimation, Pe = n.maskTransitionName, ke = n.maskAnimation, ye = n.className, Me = n.getTriggerDOMNode, be = _objectWithoutProperties(n, _excluded$f), De = he || oe || !1, Fe = React.useState(!1), Le = _slicedToArray(Fe, 2), Ne = Le[0], Ie = Le[1];
    useLayoutEffect$2(function() {
      Ie(isMobile());
    }, []);
    var je = React.useRef({}), Ze = React.useContext(TriggerContext), $e = React.useMemo(function() {
      return {
        registerSubPopup: function(ot, Ot) {
          je.current[ot] = Ot, Ze == null || Ze.registerSubPopup(ot, Ot);
        }
      };
    }, [Ze]), We = useId$2(), Be = React.useState(null), Ue = _slicedToArray(Be, 2), Qe = Ue[0], et = Ue[1], rt = useEvent$1(function(Ke) {
      isDOM(Ke) && Qe !== Ke && et(Ke), Ze == null || Ze.registerSubPopup(We, Ke);
    }), ut = React.useState(null), tt = _slicedToArray(ut, 2), nt = tt[0], Dt = tt[1], xt = React.useRef(null), yt = useEvent$1(function(Ke) {
      isDOM(Ke) && nt !== Ke && (Dt(Ke), xt.current = Ke);
    }), St = React.Children.only(l), dt = (St == null ? void 0 : St.props) || {}, Zt = {}, wt = useEvent$1(function(Ke) {
      var ot, Ot, zt = nt;
      return (zt == null ? void 0 : zt.contains(Ke)) || ((ot = getShadowRoot(zt)) === null || ot === void 0 ? void 0 : ot.host) === Ke || Ke === zt || (Qe == null ? void 0 : Qe.contains(Ke)) || ((Ot = getShadowRoot(Qe)) === null || Ot === void 0 ? void 0 : Ot.host) === Ke || Ke === Qe || Object.values(je.current).some(function(jt) {
        return (jt == null ? void 0 : jt.contains(Ke)) || Ke === jt;
      });
    }), It = getMotion(o, Te, Ae, Re), Tt = getMotion(o, we, ke, Pe), Gt = React.useState(X || !1), Vt = _slicedToArray(Gt, 2), Lt = Vt[0], mt = Vt[1], at = $ != null ? $ : Lt, Pt = useEvent$1(function(Ke) {
      $ === void 0 && mt(Ke);
    });
    useLayoutEffect$2(function() {
      mt($ || !1);
    }, [$]);
    var _t = React.useRef(at);
    _t.current = at;
    var pt = React.useRef([]);
    pt.current = [];
    var Wt = useEvent$1(function(Ke) {
      var ot;
      Pt(Ke), ((ot = pt.current[pt.current.length - 1]) !== null && ot !== void 0 ? ot : at) !== Ke && (pt.current.push(Ke), W == null || W(Ke));
    }), Nt = React.useRef(), Ye = function() {
      clearTimeout(Nt.current);
    }, ze = function(ot) {
      var Ot = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      Ye(), Ot === 0 ? Wt(ot) : Nt.current = setTimeout(function() {
        Wt(ot);
      }, Ot * 1e3);
    };
    React.useEffect(function() {
      return Ye;
    }, []);
    var Oe = React.useState(!1), Ve = _slicedToArray(Oe, 2), qe = Ve[0], st = Ve[1];
    useLayoutEffect$2(function(Ke) {
      (!Ke || at) && st(!0);
    }, [at]);
    var Mt = React.useState(null), kt = _slicedToArray(Mt, 2), Ft = kt[0], Je = kt[1], Xe = React.useState([0, 0]), ct = _slicedToArray(Xe, 2), bt = ct[0], vt = ct[1], Rt = function(ot) {
      vt([ot.clientX, ot.clientY]);
    }, Et = useAlign(at, Qe, Ee ? bt : nt, se, fe, ge, _e), gt = _slicedToArray(Et, 11), He = gt[0], Ge = gt[1], it = gt[2], ht = gt[3], Ct = gt[4], nr = gt[5], Ut = gt[6], Xt = gt[7], lr = gt[8], Jt = gt[9], Yt = gt[10], ir = useAction(Ne, j, Z, V), ur = _slicedToArray(ir, 2), hr = ur[0], ar = ur[1], mr = hr.has("click"), sr = ar.has("click") || ar.has("contextMenu"), er = useEvent$1(function() {
      qe || Yt();
    }), ft = function() {
      _t.current && Ee && sr && ze(!1);
    };
    useWatch(at, nt, Qe, er, ft), useLayoutEffect$2(function() {
      er();
    }, [bt, se]), useLayoutEffect$2(function() {
      at && !(fe != null && fe[se]) && er();
    }, [JSON.stringify(ge)]);
    var lt = React.useMemo(function() {
      var Ke = getAlignPopupClassName(fe, o, Jt, Ee);
      return cls(Ke, me == null ? void 0 : me(Jt));
    }, [Jt, me, fe, o, Ee]);
    React.useImperativeHandle(a, function() {
      return {
        nativeElement: xt.current,
        forceAlign: er
      };
    });
    var Bt = React.useState(0), $t = _slicedToArray(Bt, 2), At = $t[0], Ht = $t[1], qt = React.useState(0), Kt = _slicedToArray(qt, 2), tr = Kt[0], or = Kt[1], Qt = function() {
      if (ve && nt) {
        var ot = nt.getBoundingClientRect();
        Ht(ot.width), or(ot.height);
      }
    }, dr = function() {
      Qt(), er();
    }, rr = function(ot) {
      st(!1), Yt(), Y == null || Y(ot);
    }, xr = function() {
      return new Promise(function(ot) {
        Qt(), Je(function() {
          return ot;
        });
      });
    };
    useLayoutEffect$2(function() {
      Ft && (Yt(), Ft(), Je(null));
    }, [Ft]);
    function cr(Ke, ot, Ot, zt) {
      Zt[Ke] = function(jt) {
        var Er;
        zt == null || zt(jt), ze(ot, Ot);
        for (var Pr = arguments.length, kr = new Array(Pr > 1 ? Pr - 1 : 0), _r = 1; _r < Pr; _r++)
          kr[_r - 1] = arguments[_r];
        (Er = dt[Ke]) === null || Er === void 0 || Er.call.apply(Er, [dt, jt].concat(kr));
      };
    }
    (mr || sr) && (Zt.onClick = function(Ke) {
      var ot;
      _t.current && sr ? ze(!1) : !_t.current && mr && (Rt(Ke), ze(!0));
      for (var Ot = arguments.length, zt = new Array(Ot > 1 ? Ot - 1 : 0), jt = 1; jt < Ot; jt++)
        zt[jt - 1] = arguments[jt];
      (ot = dt.onClick) === null || ot === void 0 || ot.call.apply(ot, [dt, Ke].concat(zt));
    }), useWinClick(at, sr, nt, Qe, te, ae, wt, ze);
    var pr = hr.has("hover"), vr = ar.has("hover"), gr, yr;
    pr && (cr("onMouseEnter", !0, U, function(Ke) {
      Rt(Ke);
    }), cr("onPointerEnter", !0, U, function(Ke) {
      Rt(Ke);
    }), gr = function(ot) {
      (at || qe) && Qe !== null && Qe !== void 0 && Qe.contains(ot.target) && ze(!0, U);
    }, Ee && (Zt.onMouseMove = function(Ke) {
      var ot;
      (ot = dt.onMouseMove) === null || ot === void 0 || ot.call(dt, Ke);
    })), vr && (cr("onMouseLeave", !1, K), cr("onPointerLeave", !1, K), yr = function() {
      ze(!1, K);
    }), hr.has("focus") && cr("onFocus", !0, J), ar.has("focus") && cr("onBlur", !1, ee), hr.has("contextMenu") && (Zt.onContextMenu = function(Ke) {
      var ot;
      _t.current && ar.has("contextMenu") ? ze(!1) : (Rt(Ke), ze(!0)), Ke.preventDefault();
      for (var Ot = arguments.length, zt = new Array(Ot > 1 ? Ot - 1 : 0), jt = 1; jt < Ot; jt++)
        zt[jt - 1] = arguments[jt];
      (ot = dt.onContextMenu) === null || ot === void 0 || ot.call.apply(ot, [dt, Ke].concat(zt));
    }), ye && (Zt.className = cls(dt.className, ye));
    var br = _objectSpread2(_objectSpread2({}, dt), Zt), Sr = {}, Cr = ["onContextMenu", "onClick", "onMouseDown", "onTouchStart", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur"];
    Cr.forEach(function(Ke) {
      be[Ke] && (Sr[Ke] = function() {
        for (var ot, Ot = arguments.length, zt = new Array(Ot), jt = 0; jt < Ot; jt++)
          zt[jt] = arguments[jt];
        (ot = br[Ke]) === null || ot === void 0 || ot.call.apply(ot, [br].concat(zt)), be[Ke].apply(be, zt);
      });
    });
    var Rr = /* @__PURE__ */ React.cloneElement(St, _objectSpread2(_objectSpread2({}, br), Sr)), wr = {
      x: nr,
      y: Ut
    }, Tr = Ce ? _objectSpread2({}, Ce !== !0 ? Ce : {}) : null;
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(RefResizeObserver, {
      disabled: !at,
      ref: yt,
      onResize: dr
    }, /* @__PURE__ */ React.createElement(TriggerWrapper, {
      getTriggerDOMNode: Me
    }, Rr)), /* @__PURE__ */ React.createElement(TriggerContext.Provider, {
      value: $e
    }, /* @__PURE__ */ React.createElement(Popup, {
      portal: t,
      ref: rt,
      prefixCls: o,
      popup: le,
      className: cls(pe, lt),
      style: de,
      target: nt,
      onMouseEnter: gr,
      onMouseLeave: yr,
      onPointerEnter: gr,
      zIndex: ne,
      open: at,
      keepDom: qe,
      fresh: xe,
      onClick: Se,
      mask: te,
      motion: It,
      maskMotion: Tt,
      onVisibleChanged: rr,
      onPrepare: xr,
      forceRender: ce,
      autoDestroy: De,
      getPopupContainer: ie,
      align: Jt,
      arrow: Tr,
      arrowPos: wr,
      ready: He,
      offsetX: Ge,
      offsetY: it,
      offsetR: ht,
      offsetB: Ct,
      onAlign: er,
      stretch: ve,
      targetWidth: At / Xt,
      targetHeight: tr / lr
    })));
  });
  return process.env.NODE_ENV !== "production" && (r.displayName = "Trigger"), r;
}
const Trigger = generateTrigger(Portal$1);
var _excluded$e = ["prefixCls", "disabled", "visible", "children", "popupElement", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "direction", "placement", "builtinPlacements", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "getPopupContainer", "empty", "getTriggerDOMNode", "onPopupVisibleChange", "onPopupMouseEnter"], getBuiltInPlacements = function(r) {
  var n = r === !0 ? 0 : 1;
  return {
    bottomLeft: {
      points: ["tl", "bl"],
      offset: [0, 4],
      overflow: {
        adjustX: n,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    bottomRight: {
      points: ["tr", "br"],
      offset: [0, 4],
      overflow: {
        adjustX: n,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    topLeft: {
      points: ["bl", "tl"],
      offset: [0, -4],
      overflow: {
        adjustX: n,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    topRight: {
      points: ["br", "tr"],
      offset: [0, -4],
      overflow: {
        adjustX: n,
        adjustY: 1
      },
      htmlRegion: "scroll"
    }
  };
}, SelectTrigger = function(r, n) {
  var a = r.prefixCls;
  r.disabled;
  var s = r.visible, o = r.children, l = r.popupElement, x = r.animation, j = r.transitionName, Z = r.dropdownStyle, V = r.dropdownClassName, $ = r.direction, X = $ === void 0 ? "ltr" : $, W = r.placement, Y = r.builtinPlacements, U = r.dropdownMatchSelectWidth, G = r.dropdownRender, K = r.dropdownAlign, J = r.getPopupContainer, ee = r.empty, te = r.getTriggerDOMNode, re = r.onPopupVisibleChange, ae = r.onPopupMouseEnter, ie = _objectWithoutProperties(r, _excluded$e), ce = "".concat(a, "-dropdown"), he = l;
  G && (he = G(l));
  var oe = React.useMemo(function() {
    return Y || getBuiltInPlacements(U);
  }, [Y, U]), le = x ? "".concat(ce, "-").concat(x) : j, pe = typeof U == "number", de = React.useMemo(function() {
    return pe ? null : U === !1 ? "minWidth" : "width";
  }, [U, pe]), se = Z;
  pe && (se = _objectSpread2(_objectSpread2({}, se), {}, {
    width: U
  }));
  var ue = React.useRef(null);
  return React.useImperativeHandle(n, function() {
    return {
      getPopupElement: function() {
        return ue.current;
      }
    };
  }), /* @__PURE__ */ React.createElement(Trigger, _extends({}, ie, {
    showAction: re ? ["click"] : [],
    hideAction: re ? ["click"] : [],
    popupPlacement: W || (X === "rtl" ? "bottomRight" : "bottomLeft"),
    builtinPlacements: oe,
    prefixCls: ce,
    popupTransitionName: le,
    popup: /* @__PURE__ */ React.createElement("div", {
      ref: ue,
      onMouseEnter: ae
    }, he),
    stretch: de,
    popupAlign: K,
    popupVisible: s,
    getPopupContainer: J,
    popupClassName: cls(V, _defineProperty({}, "".concat(ce, "-empty"), ee)),
    popupStyle: se,
    getTriggerDOMNode: te,
    onPopupVisibleChange: re
  }), o);
}, RefSelectTrigger = /* @__PURE__ */ React.forwardRef(SelectTrigger);
process.env.NODE_ENV !== "production" && (RefSelectTrigger.displayName = "SelectTrigger");
function getKey(t, r) {
  var n = t.key, a;
  return "value" in t && (a = t.value), n != null ? n : a !== void 0 ? a : "rc-index-key-".concat(r);
}
function isValidCount(t) {
  return typeof t != "undefined" && !Number.isNaN(t);
}
function fillFieldNames(t, r) {
  var n = t || {}, a = n.label, s = n.value, o = n.options, l = n.groupLabel, x = a || (r ? "children" : "label");
  return {
    label: x,
    value: s || "value",
    options: o || "options",
    groupLabel: l || x
  };
}
function flattenOptions(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.fieldNames, a = r.childrenAsData, s = [], o = fillFieldNames(n, !1), l = o.label, x = o.value, j = o.options, Z = o.groupLabel;
  function V($, X) {
    Array.isArray($) && $.forEach(function(W) {
      if (X || !(j in W)) {
        var Y = W[x];
        s.push({
          key: getKey(W, s.length),
          groupOption: X,
          data: W,
          label: W[l],
          value: Y
        });
      } else {
        var U = W[Z];
        U === void 0 && a && (U = W.label), s.push({
          key: getKey(W, s.length),
          group: !0,
          data: W,
          label: U
        }), V(W[j], !0);
      }
    });
  }
  return V(t, !1), s;
}
function injectPropsWithOption(t) {
  var r = _objectSpread2({}, t);
  return "props" in r || Object.defineProperty(r, "props", {
    get: function() {
      return warningOnce(!1, "Return type is option instead of Option instance. Please read value directly instead of reading from `props`."), r;
    }
  }), r;
}
var getSeparatedContent = function(r, n, a) {
  if (!n || !n.length)
    return null;
  var s = !1, o = function x(j, Z) {
    var V = _toArray(Z), $ = V[0], X = V.slice(1);
    if (!$)
      return [j];
    var W = j.split($);
    return s = s || W.length > 1, W.reduce(function(Y, U) {
      return [].concat(_toConsumableArray(Y), _toConsumableArray(x(U, X)));
    }, []).filter(Boolean);
  }, l = o(r, n);
  return s ? typeof a != "undefined" ? l.slice(0, a) : l : null;
}, SelectContext = /* @__PURE__ */ React.createContext(null), _excluded$d = ["id", "prefixCls", "className", "showSearch", "tagRender", "direction", "omitDomProps", "displayValues", "onDisplayValuesChange", "emptyOptions", "notFoundContent", "onClear", "mode", "disabled", "loading", "getInputElement", "getRawInputElement", "open", "defaultOpen", "onDropdownVisibleChange", "activeValue", "onActiveValueChange", "activeDescendantId", "searchValue", "autoClearSearchValue", "onSearch", "onSearchSplit", "tokenSeparators", "allowClear", "suffixIcon", "clearIcon", "OptionList", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "placement", "builtinPlacements", "getPopupContainer", "showAction", "onFocus", "onBlur", "onKeyUp", "onKeyDown", "onMouseDown"], DEFAULT_OMIT_PROPS = ["value", "onChange", "removeIcon", "placeholder", "autoFocus", "maxTagCount", "maxTagTextLength", "maxTagPlaceholder", "choiceTransitionName", "onInputKeyDown", "onPopupScroll", "tabIndex"], isMultiple = function(r) {
  return r === "tags" || r === "multiple";
}, BaseSelect = /* @__PURE__ */ React.forwardRef(function(t, r) {
  var n, a = t.id, s = t.prefixCls, o = t.className, l = t.showSearch, x = t.tagRender, j = t.direction, Z = t.omitDomProps, V = t.displayValues, $ = t.onDisplayValuesChange, X = t.emptyOptions, W = t.notFoundContent, Y = W === void 0 ? "Not Found" : W, U = t.onClear, G = t.mode, K = t.disabled, J = t.loading, ee = t.getInputElement, te = t.getRawInputElement, re = t.open, ae = t.defaultOpen, ie = t.onDropdownVisibleChange, ce = t.activeValue, he = t.onActiveValueChange, oe = t.activeDescendantId, le = t.searchValue, pe = t.autoClearSearchValue, de = t.onSearch, se = t.onSearchSplit, ue = t.tokenSeparators, fe = t.allowClear, ge = t.suffixIcon, ne = t.clearIcon, ve = t.OptionList, me = t.animation, xe = t.transitionName, Ee = t.dropdownStyle, Se = t.dropdownClassName, _e = t.dropdownMatchSelectWidth, Ce = t.dropdownRender, Te = t.dropdownAlign, we = t.placement, Re = t.builtinPlacements, Ae = t.getPopupContainer, Pe = t.showAction, ke = Pe === void 0 ? [] : Pe, ye = t.onFocus, Me = t.onBlur, be = t.onKeyUp, De = t.onKeyDown, Fe = t.onMouseDown, Le = _objectWithoutProperties(t, _excluded$d), Ne = isMultiple(G), Ie = (l !== void 0 ? l : Ne) || G === "combobox", je = _objectSpread2({}, Le);
  DEFAULT_OMIT_PROPS.forEach(function(ft) {
    delete je[ft];
  }), Z == null || Z.forEach(function(ft) {
    delete je[ft];
  });
  var Ze = React.useState(!1), $e = _slicedToArray(Ze, 2), We = $e[0], Be = $e[1];
  React.useEffect(function() {
    Be(isMobile());
  }, []);
  var Ue = React.useRef(null), Qe = React.useRef(null), et = React.useRef(null), rt = React.useRef(null), ut = React.useRef(null), tt = React.useRef(!1), nt = useDelayReset(), Dt = _slicedToArray(nt, 3), xt = Dt[0], yt = Dt[1], St = Dt[2];
  React.useImperativeHandle(r, function() {
    var ft, lt;
    return {
      focus: (ft = rt.current) === null || ft === void 0 ? void 0 : ft.focus,
      blur: (lt = rt.current) === null || lt === void 0 ? void 0 : lt.blur,
      scrollTo: function($t) {
        var At;
        return (At = ut.current) === null || At === void 0 ? void 0 : At.scrollTo($t);
      }
    };
  });
  var dt = React.useMemo(function() {
    var ft;
    if (G !== "combobox")
      return le;
    var lt = (ft = V[0]) === null || ft === void 0 ? void 0 : ft.value;
    return typeof lt == "string" || typeof lt == "number" ? String(lt) : "";
  }, [le, G, V]), Zt = G === "combobox" && typeof ee == "function" && ee() || null, wt = typeof te == "function" && te(), It = useComposeRef(Qe, wt == null || (n = wt.props) === null || n === void 0 ? void 0 : n.ref), Tt = React.useState(!1), Gt = _slicedToArray(Tt, 2), Vt = Gt[0], Lt = Gt[1];
  useLayoutEffect$2(function() {
    Lt(!0);
  }, []);
  var mt = useMergedState$2(!1, {
    defaultValue: ae,
    value: re
  }), at = _slicedToArray(mt, 2), Pt = at[0], _t = at[1], pt = Vt ? Pt : !1, Wt = !Y && X;
  (K || Wt && pt && G === "combobox") && (pt = !1);
  var Nt = Wt ? !1 : pt, Ye = React.useCallback(function(ft) {
    var lt = ft !== void 0 ? ft : !pt;
    K || (_t(lt), pt !== lt && (ie == null || ie(lt)));
  }, [K, pt, _t, ie]), ze = React.useMemo(function() {
    return (ue || []).some(function(ft) {
      return [`
`, `\r
`].includes(ft);
    });
  }, [ue]), Oe = React.useContext(SelectContext) || {}, Ve = Oe.maxCount, qe = Oe.rawValues, st = function(lt, Bt, $t) {
    if (!(isValidCount(Ve) && (qe == null ? void 0 : qe.size) >= Ve)) {
      var At = !0, Ht = lt;
      he == null || he(null);
      var qt = getSeparatedContent(lt, ue, isValidCount(Ve) ? Ve - qe.size : void 0), Kt = $t ? null : qt;
      return G !== "combobox" && Kt && (Ht = "", se == null || se(Kt), Ye(!1), At = !1), de && dt !== Ht && de(Ht, {
        source: Bt ? "typing" : "effect"
      }), At;
    }
  }, Mt = function(lt) {
    !lt || !lt.trim() || de(lt, {
      source: "submit"
    });
  };
  React.useEffect(function() {
    !pt && !Ne && G !== "combobox" && st("", !1, !1);
  }, [pt]), React.useEffect(function() {
    Pt && K && _t(!1), K && !tt.current && yt(!1);
  }, [K]);
  var kt = useLock(), Ft = _slicedToArray(kt, 2), Je = Ft[0], Xe = Ft[1], ct = function(lt) {
    var Bt = Je(), $t = lt.which;
    if ($t === KeyCode.ENTER && (G !== "combobox" && lt.preventDefault(), pt || Ye(!0)), Xe(!!dt), $t === KeyCode.BACKSPACE && !Bt && Ne && !dt && V.length) {
      for (var At = _toConsumableArray(V), Ht = null, qt = At.length - 1; qt >= 0; qt -= 1) {
        var Kt = At[qt];
        if (!Kt.disabled) {
          At.splice(qt, 1), Ht = Kt;
          break;
        }
      }
      Ht && $(At, {
        type: "remove",
        values: [Ht]
      });
    }
    for (var tr = arguments.length, or = new Array(tr > 1 ? tr - 1 : 0), Qt = 1; Qt < tr; Qt++)
      or[Qt - 1] = arguments[Qt];
    if (pt) {
      var dr;
      (dr = ut.current) === null || dr === void 0 || dr.onKeyDown.apply(dr, [lt].concat(or));
    }
    De == null || De.apply(void 0, [lt].concat(or));
  }, bt = function(lt) {
    for (var Bt = arguments.length, $t = new Array(Bt > 1 ? Bt - 1 : 0), At = 1; At < Bt; At++)
      $t[At - 1] = arguments[At];
    if (pt) {
      var Ht;
      (Ht = ut.current) === null || Ht === void 0 || Ht.onKeyUp.apply(Ht, [lt].concat($t));
    }
    be == null || be.apply(void 0, [lt].concat($t));
  }, vt = function(lt) {
    var Bt = V.filter(function($t) {
      return $t !== lt;
    });
    $(Bt, {
      type: "remove",
      values: [lt]
    });
  }, Rt = React.useRef(!1), Et = function() {
    yt(!0), K || (ye && !Rt.current && ye.apply(void 0, arguments), ke.includes("focus") && Ye(!0)), Rt.current = !0;
  }, gt = function() {
    tt.current = !0, yt(!1, function() {
      Rt.current = !1, tt.current = !1, Ye(!1);
    }), !K && (dt && (G === "tags" ? de(dt, {
      source: "submit"
    }) : G === "multiple" && de("", {
      source: "blur"
    })), Me && Me.apply(void 0, arguments));
  }, He = [];
  React.useEffect(function() {
    return function() {
      He.forEach(function(ft) {
        return clearTimeout(ft);
      }), He.splice(0, He.length);
    };
  }, []);
  var Ge = function(lt) {
    var Bt, $t = lt.target, At = (Bt = et.current) === null || Bt === void 0 ? void 0 : Bt.getPopupElement();
    if (At && At.contains($t)) {
      var Ht = setTimeout(function() {
        var or = He.indexOf(Ht);
        if (or !== -1 && He.splice(or, 1), St(), !We && !At.contains(document.activeElement)) {
          var Qt;
          (Qt = rt.current) === null || Qt === void 0 || Qt.focus();
        }
      });
      He.push(Ht);
    }
    for (var qt = arguments.length, Kt = new Array(qt > 1 ? qt - 1 : 0), tr = 1; tr < qt; tr++)
      Kt[tr - 1] = arguments[tr];
    Fe == null || Fe.apply(void 0, [lt].concat(Kt));
  }, it = React.useState({}), ht = _slicedToArray(it, 2), Ct = ht[1];
  function nr() {
    Ct({});
  }
  var Ut;
  wt && (Ut = function(lt) {
    Ye(lt);
  }), useSelectTriggerControl(function() {
    var ft;
    return [Ue.current, (ft = et.current) === null || ft === void 0 ? void 0 : ft.getPopupElement()];
  }, Nt, Ye, !!wt);
  var Xt = React.useMemo(function() {
    return _objectSpread2(_objectSpread2({}, t), {}, {
      notFoundContent: Y,
      open: pt,
      triggerOpen: Nt,
      id: a,
      showSearch: Ie,
      multiple: Ne,
      toggleOpen: Ye
    });
  }, [t, Y, Nt, pt, a, Ie, Ne, Ye]), lr = !!ge || J, Jt;
  lr && (Jt = /* @__PURE__ */ React.createElement(TransBtn, {
    className: cls("".concat(s, "-arrow"), _defineProperty({}, "".concat(s, "-arrow-loading"), J)),
    customizeIcon: ge,
    customizeIconProps: {
      loading: J,
      searchValue: dt,
      open: pt,
      focused: xt,
      showSearch: Ie
    }
  }));
  var Yt = function() {
    var lt;
    U == null || U(), (lt = rt.current) === null || lt === void 0 || lt.focus(), $([], {
      type: "clear",
      values: V
    }), st("", !1, !1);
  }, ir = useAllowClear(s, Yt, V, fe, ne, K, dt, G), ur = ir.allowClear, hr = ir.clearIcon, ar = /* @__PURE__ */ React.createElement(ve, {
    ref: ut
  }), mr = cls(s, o, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(s, "-focused"), xt), "".concat(s, "-multiple"), Ne), "".concat(s, "-single"), !Ne), "".concat(s, "-allow-clear"), fe), "".concat(s, "-show-arrow"), lr), "".concat(s, "-disabled"), K), "".concat(s, "-loading"), J), "".concat(s, "-open"), pt), "".concat(s, "-customize-input"), Zt), "".concat(s, "-show-search"), Ie)), sr = /* @__PURE__ */ React.createElement(RefSelectTrigger, {
    ref: et,
    disabled: K,
    prefixCls: s,
    visible: Nt,
    popupElement: ar,
    animation: me,
    transitionName: xe,
    dropdownStyle: Ee,
    dropdownClassName: Se,
    direction: j,
    dropdownMatchSelectWidth: _e,
    dropdownRender: Ce,
    dropdownAlign: Te,
    placement: we,
    builtinPlacements: Re,
    getPopupContainer: Ae,
    empty: X,
    getTriggerDOMNode: function() {
      return Qe.current;
    },
    onPopupVisibleChange: Ut,
    onPopupMouseEnter: nr
  }, wt ? /* @__PURE__ */ React.cloneElement(wt, {
    ref: It
  }) : /* @__PURE__ */ React.createElement(ForwardSelector, _extends({}, t, {
    domRef: Qe,
    prefixCls: s,
    inputElement: Zt,
    ref: rt,
    id: a,
    showSearch: Ie,
    autoClearSearchValue: pe,
    mode: G,
    activeDescendantId: oe,
    tagRender: x,
    values: V,
    open: pt,
    onToggleOpen: Ye,
    activeValue: ce,
    searchValue: dt,
    onSearch: st,
    onSearchSubmit: Mt,
    onRemove: vt,
    tokenWithEnter: ze
  }))), er;
  return wt ? er = sr : er = /* @__PURE__ */ React.createElement("div", _extends({
    className: mr
  }, je, {
    ref: Ue,
    onMouseDown: Ge,
    onKeyDown: ct,
    onKeyUp: bt,
    onFocus: Et,
    onBlur: gt
  }), xt && !pt && /* @__PURE__ */ React.createElement("span", {
    "aria-live": "polite",
    style: {
      width: 0,
      height: 0,
      position: "absolute",
      overflow: "hidden",
      opacity: 0
    }
  }, "".concat(V.map(function(ft) {
    var lt = ft.label, Bt = ft.value;
    return ["number", "string"].includes(_typeof$1(lt)) ? lt : Bt;
  }).join(", "))), sr, Jt, ur && hr), /* @__PURE__ */ React.createElement(BaseSelectContext.Provider, {
    value: Xt
  }, er);
});
process.env.NODE_ENV !== "production" && (BaseSelect.displayName = "BaseSelect");
var OptGroup = function() {
  return null;
};
OptGroup.isSelectOptGroup = !0;
var Option = function() {
  return null;
};
Option.isSelectOption = !0;
function omit$2(t, r) {
  var n = Object.assign({}, t);
  return Array.isArray(r) && r.forEach(function(a) {
    delete n[a];
  }), n;
}
var Filler = /* @__PURE__ */ React.forwardRef(function(t, r) {
  var n = t.height, a = t.offsetY, s = t.offsetX, o = t.children, l = t.prefixCls, x = t.onInnerResize, j = t.innerProps, Z = t.rtl, V = t.extra, $ = {}, X = {
    display: "flex",
    flexDirection: "column"
  };
  return a !== void 0 && ($ = {
    height: n,
    position: "relative",
    overflow: "hidden"
  }, X = _objectSpread2(_objectSpread2({}, X), {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    transform: "translateY(".concat(a, "px)")
  }, Z ? "marginRight" : "marginLeft", -s), "position", "absolute"), "left", 0), "right", 0), "top", 0))), /* @__PURE__ */ React.createElement("div", {
    style: $
  }, /* @__PURE__ */ React.createElement(RefResizeObserver, {
    onResize: function(Y) {
      var U = Y.offsetHeight;
      U && x && x();
    }
  }, /* @__PURE__ */ React.createElement("div", _extends({
    style: X,
    className: cls(_defineProperty({}, "".concat(l, "-holder-inner"), l)),
    ref: r
  }, j), o, V)));
});
Filler.displayName = "Filler";
function Item$1(t) {
  var r = t.children, n = t.setRef, a = React.useCallback(function(s) {
    n(s);
  }, []);
  return /* @__PURE__ */ React.cloneElement(r, {
    ref: a
  });
}
function useChildren(t, r, n, a, s, o, l, x) {
  var j = x.getKey;
  return t.slice(r, n + 1).map(function(Z, V) {
    var $ = r + V, X = l(Z, $, {
      style: {
        width: a
      },
      offsetX: s
    }), W = j(Z);
    return /* @__PURE__ */ React.createElement(Item$1, {
      key: W,
      setRef: function(U) {
        return o(Z, U);
      }
    }, X);
  });
}
function findListDiffIndex(t, r, n) {
  var a = t.length, s = r.length, o, l;
  if (a === 0 && s === 0)
    return null;
  a < s ? (o = t, l = r) : (o = r, l = t);
  var x = {
    __EMPTY_ITEM__: !0
  };
  function j(Y) {
    return Y !== void 0 ? n(Y) : x;
  }
  for (var Z = null, V = Math.abs(a - s) !== 1, $ = 0; $ < l.length; $ += 1) {
    var X = j(o[$]), W = j(l[$]);
    if (X !== W) {
      Z = $, V = V || X !== j(l[$ + 1]);
      break;
    }
  }
  return Z === null ? null : {
    index: Z,
    multiple: V
  };
}
function useDiffItem(t, r, n) {
  var a = React.useState(t), s = _slicedToArray(a, 2), o = s[0], l = s[1], x = React.useState(null), j = _slicedToArray(x, 2), Z = j[0], V = j[1];
  return React.useEffect(function() {
    var $ = findListDiffIndex(o || [], t || [], r);
    ($ == null ? void 0 : $.index) !== void 0 && V(t[$.index]), l(t);
  }, [t]), [Z];
}
var isFF = (typeof navigator == "undefined" ? "undefined" : _typeof$1(navigator)) === "object" && /Firefox/i.test(navigator.userAgent);
const useOriginScroll = (function(t, r, n, a) {
  var s = useRef(!1), o = useRef(null);
  function l() {
    clearTimeout(o.current), s.current = !0, o.current = setTimeout(function() {
      s.current = !1;
    }, 50);
  }
  var x = useRef({
    top: t,
    bottom: r,
    left: n,
    right: a
  });
  return x.current.top = t, x.current.bottom = r, x.current.left = n, x.current.right = a, function(j, Z) {
    var V = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, $ = j ? (
      // Pass origin wheel when on the left
      Z < 0 && x.current.left || // Pass origin wheel when on the right
      Z > 0 && x.current.right
    ) : Z < 0 && x.current.top || // Pass origin wheel when on the bottom
    Z > 0 && x.current.bottom;
    return V && $ ? (clearTimeout(o.current), s.current = !1) : (!$ || s.current) && l(), !s.current && $;
  };
});
function useFrameWheel(t, r, n, a, s, o, l) {
  var x = useRef(0), j = useRef(null), Z = useRef(null), V = useRef(!1), $ = useOriginScroll(r, n, a, s);
  function X(J, ee) {
    if (wrapperRaf.cancel(j.current), !$(!1, ee)) {
      var te = J;
      if (!te._virtualHandled)
        te._virtualHandled = !0;
      else
        return;
      x.current += ee, Z.current = ee, isFF || te.preventDefault(), j.current = wrapperRaf(function() {
        var re = V.current ? 10 : 1;
        l(x.current * re, !1), x.current = 0;
      });
    }
  }
  function W(J, ee) {
    l(ee, !0), isFF || J.preventDefault();
  }
  var Y = useRef(null), U = useRef(null);
  function G(J) {
    if (t) {
      wrapperRaf.cancel(U.current), U.current = wrapperRaf(function() {
        Y.current = null;
      }, 2);
      var ee = J.deltaX, te = J.deltaY, re = J.shiftKey, ae = ee, ie = te;
      (Y.current === "sx" || !Y.current && re && te && !ee) && (ae = te, ie = 0, Y.current = "sx");
      var ce = Math.abs(ae), he = Math.abs(ie);
      Y.current === null && (Y.current = o && ce > he ? "x" : "y"), Y.current === "y" ? X(J, ie) : W(J, ae);
    }
  }
  function K(J) {
    t && (V.current = J.detail === Z.current);
  }
  return [G, K];
}
function useGetSize(t, r, n, a) {
  var s = React.useMemo(function() {
    return [/* @__PURE__ */ new Map(), []];
  }, [t, n.id, a]), o = _slicedToArray(s, 2), l = o[0], x = o[1], j = function(V) {
    var $ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : V, X = l.get(V), W = l.get($);
    if (X === void 0 || W === void 0)
      for (var Y = t.length, U = x.length; U < Y; U += 1) {
        var G, K = t[U], J = r(K);
        l.set(J, U);
        var ee = (G = n.get(J)) !== null && G !== void 0 ? G : a;
        if (x[U] = (x[U - 1] || 0) + ee, J === V && (X = U), J === $ && (W = U), X !== void 0 && W !== void 0)
          break;
      }
    return {
      top: x[X - 1] || 0,
      bottom: x[W]
    };
  };
  return j;
}
var CacheMap = /* @__PURE__ */ (function() {
  function t() {
    _classCallCheck(this, t), _defineProperty(this, "maps", void 0), _defineProperty(this, "id", 0), _defineProperty(this, "diffRecords", /* @__PURE__ */ new Map()), this.maps = /* @__PURE__ */ Object.create(null);
  }
  return _createClass(t, [{
    key: "set",
    value: function(n, a) {
      this.diffRecords.set(n, this.maps[n]), this.maps[n] = a, this.id += 1;
    }
  }, {
    key: "get",
    value: function(n) {
      return this.maps[n];
    }
    /**
     * CacheMap will record the key changed.
     * To help to know what's update in the next render.
     */
  }, {
    key: "resetRecord",
    value: function() {
      this.diffRecords.clear();
    }
  }, {
    key: "getRecord",
    value: function() {
      return this.diffRecords;
    }
  }]), t;
})();
function parseNumber(t) {
  var r = parseFloat(t);
  return isNaN(r) ? 0 : r;
}
function useHeights(t, r, n) {
  var a = React.useState(0), s = _slicedToArray(a, 2), o = s[0], l = s[1], x = useRef(/* @__PURE__ */ new Map()), j = useRef(new CacheMap()), Z = useRef(0);
  function V() {
    Z.current += 1;
  }
  function $() {
    var W = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    V();
    var Y = function() {
      var K = !1;
      x.current.forEach(function(J, ee) {
        if (J && J.offsetParent) {
          var te = J.offsetHeight, re = getComputedStyle(J), ae = re.marginTop, ie = re.marginBottom, ce = parseNumber(ae), he = parseNumber(ie), oe = te + ce + he;
          j.current.get(ee) !== oe && (j.current.set(ee, oe), K = !0);
        }
      }), K && l(function(J) {
        return J + 1;
      });
    };
    if (W)
      Y();
    else {
      Z.current += 1;
      var U = Z.current;
      Promise.resolve().then(function() {
        U === Z.current && Y();
      });
    }
  }
  function X(W, Y) {
    var U = t(W);
    x.current.get(U), Y ? (x.current.set(U, Y), $()) : x.current.delete(U);
  }
  return useEffect(function() {
    return V;
  }, []), [X, $, j.current, o];
}
var SMOOTH_PTG = 14 / 15;
function useMobileTouchMove(t, r, n) {
  var a = useRef(!1), s = useRef(0), o = useRef(0), l = useRef(null), x = useRef(null), j, Z = function(W) {
    if (a.current) {
      var Y = Math.ceil(W.touches[0].pageX), U = Math.ceil(W.touches[0].pageY), G = s.current - Y, K = o.current - U, J = Math.abs(G) > Math.abs(K);
      J ? s.current = Y : o.current = U;
      var ee = n(J, J ? G : K, !1, W);
      ee && W.preventDefault(), clearInterval(x.current), ee && (x.current = setInterval(function() {
        J ? G *= SMOOTH_PTG : K *= SMOOTH_PTG;
        var te = Math.floor(J ? G : K);
        (!n(J, te, !0) || Math.abs(te) <= 0.1) && clearInterval(x.current);
      }, 16));
    }
  }, V = function() {
    a.current = !1, j();
  }, $ = function(W) {
    j(), W.touches.length === 1 && !a.current && (a.current = !0, s.current = Math.ceil(W.touches[0].pageX), o.current = Math.ceil(W.touches[0].pageY), l.current = W.target, l.current.addEventListener("touchmove", Z, {
      passive: !1
    }), l.current.addEventListener("touchend", V, {
      passive: !0
    }));
  };
  j = function() {
    l.current && (l.current.removeEventListener("touchmove", Z), l.current.removeEventListener("touchend", V));
  }, useLayoutEffect$2(function() {
    return t && r.current.addEventListener("touchstart", $, {
      passive: !0
    }), function() {
      var X;
      (X = r.current) === null || X === void 0 || X.removeEventListener("touchstart", $), j(), clearInterval(x.current);
    };
  }, [t]);
}
function smoothScrollOffset(t) {
  return Math.floor(Math.pow(t, 0.5));
}
function getPageXY(t, r) {
  var n = "touches" in t ? t.touches[0] : t;
  return n[r ? "pageX" : "pageY"] - window[r ? "scrollX" : "scrollY"];
}
function useScrollDrag(t, r, n) {
  React.useEffect(function() {
    var a = r.current;
    if (t && a) {
      var s = !1, o, l, x = function() {
        wrapperRaf.cancel(o);
      }, j = function X() {
        x(), o = wrapperRaf(function() {
          n(l), X();
        });
      }, Z = function() {
        s = !1, x();
      }, V = function(W) {
        if (!(W.target.draggable || W.button !== 0)) {
          var Y = W;
          Y._virtualHandled || (Y._virtualHandled = !0, s = !0);
        }
      }, $ = function(W) {
        if (s) {
          var Y = getPageXY(W, !1), U = a.getBoundingClientRect(), G = U.top, K = U.bottom;
          if (Y <= G) {
            var J = G - Y;
            l = -smoothScrollOffset(J), j();
          } else if (Y >= K) {
            var ee = Y - K;
            l = smoothScrollOffset(ee), j();
          } else
            x();
        }
      };
      return a.addEventListener("mousedown", V), a.ownerDocument.addEventListener("mouseup", Z), a.ownerDocument.addEventListener("mousemove", $), a.ownerDocument.addEventListener("dragend", Z), function() {
        a.removeEventListener("mousedown", V), a.ownerDocument.removeEventListener("mouseup", Z), a.ownerDocument.removeEventListener("mousemove", $), a.ownerDocument.removeEventListener("dragend", Z), x();
      };
    }
  }, [t]);
}
var MAX_TIMES = 10;
function useScrollTo(t, r, n, a, s, o, l, x) {
  var j = React.useRef(), Z = React.useState(null), V = _slicedToArray(Z, 2), $ = V[0], X = V[1];
  return useLayoutEffect$2(function() {
    if ($ && $.times < MAX_TIMES) {
      if (!t.current) {
        X(function(ve) {
          return _objectSpread2({}, ve);
        });
        return;
      }
      o();
      var W = $.targetAlign, Y = $.originAlign, U = $.index, G = $.offset, K = t.current.clientHeight, J = !1, ee = W, te = null;
      if (K) {
        for (var re = W || Y, ae = 0, ie = 0, ce = 0, he = Math.min(r.length - 1, U), oe = 0; oe <= he; oe += 1) {
          var le = s(r[oe]);
          ie = ae;
          var pe = n.get(le);
          ce = ie + (pe === void 0 ? a : pe), ae = ce;
        }
        for (var de = re === "top" ? G : K - G, se = he; se >= 0; se -= 1) {
          var ue = s(r[se]), fe = n.get(ue);
          if (fe === void 0) {
            J = !0;
            break;
          }
          if (de -= fe, de <= 0)
            break;
        }
        switch (re) {
          case "top":
            te = ie - G;
            break;
          case "bottom":
            te = ce - K + G;
            break;
          default: {
            var ge = t.current.scrollTop, ne = ge + K;
            ie < ge ? ee = "top" : ce > ne && (ee = "bottom");
          }
        }
        te !== null && l(te), te !== $.lastTop && (J = !0);
      }
      J && X(_objectSpread2(_objectSpread2({}, $), {}, {
        times: $.times + 1,
        targetAlign: ee,
        lastTop: te
      }));
    } else process.env.NODE_ENV !== "production" && ($ == null ? void 0 : $.times) === MAX_TIMES && warningOnce(!1, "Seems `scrollTo` with `rc-virtual-list` reach the max limitation. Please fire issue for us. Thanks.");
  }, [$, t.current]), function(W) {
    if (W == null) {
      x();
      return;
    }
    if (wrapperRaf.cancel(j.current), typeof W == "number")
      l(W);
    else if (W && _typeof$1(W) === "object") {
      var Y, U = W.align;
      "index" in W ? Y = W.index : Y = r.findIndex(function(J) {
        return s(J) === W.key;
      });
      var G = W.offset, K = G === void 0 ? 0 : G;
      X({
        times: 0,
        index: Y,
        offset: K,
        originAlign: U
      });
    }
  };
}
var ScrollBar = /* @__PURE__ */ React.forwardRef(function(t, r) {
  var n = t.prefixCls, a = t.rtl, s = t.scrollOffset, o = t.scrollRange, l = t.onStartMove, x = t.onStopMove, j = t.onScroll, Z = t.horizontal, V = t.spinSize, $ = t.containerSize, X = t.style, W = t.thumbStyle, Y = t.showScrollBar, U = React.useState(!1), G = _slicedToArray(U, 2), K = G[0], J = G[1], ee = React.useState(null), te = _slicedToArray(ee, 2), re = te[0], ae = te[1], ie = React.useState(null), ce = _slicedToArray(ie, 2), he = ce[0], oe = ce[1], le = !a, pe = React.useRef(), de = React.useRef(), se = React.useState(Y), ue = _slicedToArray(se, 2), fe = ue[0], ge = ue[1], ne = React.useRef(), ve = function() {
    Y === !0 || Y === !1 || (clearTimeout(ne.current), ge(!0), ne.current = setTimeout(function() {
      ge(!1);
    }, 3e3));
  }, me = o - $ || 0, xe = $ - V || 0, Ee = React.useMemo(function() {
    if (s === 0 || me === 0)
      return 0;
    var ke = s / me;
    return ke * xe;
  }, [s, me, xe]), Se = function(ye) {
    ye.stopPropagation(), ye.preventDefault();
  }, _e = React.useRef({
    top: Ee,
    dragging: K,
    pageY: re,
    startTop: he
  });
  _e.current = {
    top: Ee,
    dragging: K,
    pageY: re,
    startTop: he
  };
  var Ce = function(ye) {
    J(!0), ae(getPageXY(ye, Z)), oe(_e.current.top), l(), ye.stopPropagation(), ye.preventDefault();
  };
  React.useEffect(function() {
    var ke = function(De) {
      De.preventDefault();
    }, ye = pe.current, Me = de.current;
    return ye.addEventListener("touchstart", ke, {
      passive: !1
    }), Me.addEventListener("touchstart", Ce, {
      passive: !1
    }), function() {
      ye.removeEventListener("touchstart", ke), Me.removeEventListener("touchstart", Ce);
    };
  }, []);
  var Te = React.useRef();
  Te.current = me;
  var we = React.useRef();
  we.current = xe, React.useEffect(function() {
    if (K) {
      var ke, ye = function(De) {
        var Fe = _e.current, Le = Fe.dragging, Ne = Fe.pageY, Ie = Fe.startTop;
        wrapperRaf.cancel(ke);
        var je = pe.current.getBoundingClientRect(), Ze = $ / (Z ? je.width : je.height);
        if (Le) {
          var $e = (getPageXY(De, Z) - Ne) * Ze, We = Ie;
          !le && Z ? We -= $e : We += $e;
          var Be = Te.current, Ue = we.current, Qe = Ue ? We / Ue : 0, et = Math.ceil(Qe * Be);
          et = Math.max(et, 0), et = Math.min(et, Be), ke = wrapperRaf(function() {
            j(et, Z);
          });
        }
      }, Me = function() {
        J(!1), x();
      };
      return window.addEventListener("mousemove", ye, {
        passive: !0
      }), window.addEventListener("touchmove", ye, {
        passive: !0
      }), window.addEventListener("mouseup", Me, {
        passive: !0
      }), window.addEventListener("touchend", Me, {
        passive: !0
      }), function() {
        window.removeEventListener("mousemove", ye), window.removeEventListener("touchmove", ye), window.removeEventListener("mouseup", Me), window.removeEventListener("touchend", Me), wrapperRaf.cancel(ke);
      };
    }
  }, [K]), React.useEffect(function() {
    return ve(), function() {
      clearTimeout(ne.current);
    };
  }, [s]), React.useImperativeHandle(r, function() {
    return {
      delayHidden: ve
    };
  });
  var Re = "".concat(n, "-scrollbar"), Ae = {
    position: "absolute",
    visibility: fe ? null : "hidden"
  }, Pe = {
    position: "absolute",
    borderRadius: 99,
    background: "var(--rc-virtual-list-scrollbar-bg, rgba(0, 0, 0, 0.5))",
    cursor: "pointer",
    userSelect: "none"
  };
  return Z ? (Object.assign(Ae, {
    height: 8,
    left: 0,
    right: 0,
    bottom: 0
  }), Object.assign(Pe, _defineProperty({
    height: "100%",
    width: V
  }, le ? "left" : "right", Ee))) : (Object.assign(Ae, _defineProperty({
    width: 8,
    top: 0,
    bottom: 0
  }, le ? "right" : "left", 0)), Object.assign(Pe, {
    width: "100%",
    height: V,
    top: Ee
  })), /* @__PURE__ */ React.createElement("div", {
    ref: pe,
    className: cls(Re, _defineProperty(_defineProperty(_defineProperty({}, "".concat(Re, "-horizontal"), Z), "".concat(Re, "-vertical"), !Z), "".concat(Re, "-visible"), fe)),
    style: _objectSpread2(_objectSpread2({}, Ae), X),
    onMouseDown: Se,
    onMouseMove: ve
  }, /* @__PURE__ */ React.createElement("div", {
    ref: de,
    className: cls("".concat(Re, "-thumb"), _defineProperty({}, "".concat(Re, "-thumb-moving"), K)),
    style: _objectSpread2(_objectSpread2({}, Pe), W),
    onMouseDown: Ce
  }));
});
process.env.NODE_ENV !== "production" && (ScrollBar.displayName = "ScrollBar");
var MIN_SIZE = 20;
function getSpinSize() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = t / r * t;
  return isNaN(n) && (n = 0), n = Math.max(n, MIN_SIZE), Math.floor(n);
}
var _excluded$c = ["prefixCls", "className", "height", "itemHeight", "fullHeight", "style", "data", "children", "itemKey", "virtual", "direction", "scrollWidth", "component", "onScroll", "onVirtualScroll", "onVisibleChange", "innerProps", "extraRender", "styles", "showScrollBar"], EMPTY_DATA = [], ScrollStyle = {
  overflowY: "auto",
  overflowAnchor: "none"
};
function RawList(t, r) {
  var n = t.prefixCls, a = n === void 0 ? "rc-virtual-list" : n, s = t.className, o = t.height, l = t.itemHeight, x = t.fullHeight, j = x === void 0 ? !0 : x, Z = t.style, V = t.data, $ = t.children, X = t.itemKey, W = t.virtual, Y = t.direction, U = t.scrollWidth, G = t.component, K = G === void 0 ? "div" : G, J = t.onScroll, ee = t.onVirtualScroll, te = t.onVisibleChange, re = t.innerProps, ae = t.extraRender, ie = t.styles, ce = t.showScrollBar, he = ce === void 0 ? "optional" : ce, oe = _objectWithoutProperties(t, _excluded$c), le = React.useCallback(function(He) {
    return typeof X == "function" ? X(He) : He == null ? void 0 : He[X];
  }, [X]), pe = useHeights(le), de = _slicedToArray(pe, 4), se = de[0], ue = de[1], fe = de[2], ge = de[3], ne = !!(W !== !1 && o && l), ve = React.useMemo(function() {
    return Object.values(fe.maps).reduce(function(He, Ge) {
      return He + Ge;
    }, 0);
  }, [fe.id, fe.maps]), me = ne && V && (Math.max(l * V.length, ve) > o || !!U), xe = Y === "rtl", Ee = cls(a, _defineProperty({}, "".concat(a, "-rtl"), xe), s), Se = V || EMPTY_DATA, _e = useRef(), Ce = useRef(), Te = useRef(), we = useState$1(0), Re = _slicedToArray(we, 2), Ae = Re[0], Pe = Re[1], ke = useState$1(0), ye = _slicedToArray(ke, 2), Me = ye[0], be = ye[1], De = useState$1(!1), Fe = _slicedToArray(De, 2), Le = Fe[0], Ne = Fe[1], Ie = function() {
    Ne(!0);
  }, je = function() {
    Ne(!1);
  }, Ze = {
    getKey: le
  };
  function $e(He) {
    Pe(function(Ge) {
      var it;
      typeof He == "function" ? it = He(Ge) : it = He;
      var ht = mt(it);
      return _e.current.scrollTop = ht, ht;
    });
  }
  var We = useRef({
    start: 0,
    end: Se.length
  }), Be = useRef(), Ue = useDiffItem(Se, le), Qe = _slicedToArray(Ue, 1), et = Qe[0];
  Be.current = et;
  var rt = React.useMemo(function() {
    if (!ne)
      return {
        scrollHeight: void 0,
        start: 0,
        end: Se.length - 1,
        offset: void 0
      };
    if (!me) {
      var He;
      return {
        scrollHeight: ((He = Ce.current) === null || He === void 0 ? void 0 : He.offsetHeight) || 0,
        start: 0,
        end: Se.length - 1,
        offset: void 0
      };
    }
    for (var Ge = 0, it, ht, Ct, nr = Se.length, Ut = 0; Ut < nr; Ut += 1) {
      var Xt = Se[Ut], lr = le(Xt), Jt = fe.get(lr), Yt = Ge + (Jt === void 0 ? l : Jt);
      Yt >= Ae && it === void 0 && (it = Ut, ht = Ge), Yt > Ae + o && Ct === void 0 && (Ct = Ut), Ge = Yt;
    }
    return it === void 0 && (it = 0, ht = 0, Ct = Math.ceil(o / l)), Ct === void 0 && (Ct = Se.length - 1), Ct = Math.min(Ct + 1, Se.length - 1), {
      scrollHeight: Ge,
      start: it,
      end: Ct,
      offset: ht
    };
  }, [me, ne, Ae, Se, ge, o]), ut = rt.scrollHeight, tt = rt.start, nt = rt.end, Dt = rt.offset;
  We.current.start = tt, We.current.end = nt, React.useLayoutEffect(function() {
    var He = fe.getRecord();
    if (He.size === 1) {
      var Ge = Array.from(He.keys())[0], it = He.get(Ge), ht = Se[tt];
      if (ht && it === void 0) {
        var Ct = le(ht);
        if (Ct === Ge) {
          var nr = fe.get(Ge), Ut = nr - l;
          $e(function(Xt) {
            return Xt + Ut;
          });
        }
      }
    }
    fe.resetRecord();
  }, [ut]);
  var xt = React.useState({
    width: 0,
    height: o
  }), yt = _slicedToArray(xt, 2), St = yt[0], dt = yt[1], Zt = function(Ge) {
    dt({
      width: Ge.offsetWidth,
      height: Ge.offsetHeight
    });
  }, wt = useRef(), It = useRef(), Tt = React.useMemo(function() {
    return getSpinSize(St.width, U);
  }, [St.width, U]), Gt = React.useMemo(function() {
    return getSpinSize(St.height, ut);
  }, [St.height, ut]), Vt = ut - o, Lt = useRef(Vt);
  Lt.current = Vt;
  function mt(He) {
    var Ge = He;
    return Number.isNaN(Lt.current) || (Ge = Math.min(Ge, Lt.current)), Ge = Math.max(Ge, 0), Ge;
  }
  var at = Ae <= 0, Pt = Ae >= Vt, _t = Me <= 0, pt = Me >= U, Wt = useOriginScroll(at, Pt, _t, pt), Nt = function() {
    return {
      x: xe ? -Me : Me,
      y: Ae
    };
  }, Ye = useRef(Nt()), ze = useEvent$1(function(He) {
    if (ee) {
      var Ge = _objectSpread2(_objectSpread2({}, Nt()), He);
      (Ye.current.x !== Ge.x || Ye.current.y !== Ge.y) && (ee(Ge), Ye.current = Ge);
    }
  });
  function Oe(He, Ge) {
    var it = He;
    Ge ? (flushSync(function() {
      be(it);
    }), ze()) : $e(it);
  }
  function Ve(He) {
    var Ge = He.currentTarget.scrollTop;
    Ge !== Ae && $e(Ge), J == null || J(He), ze();
  }
  var qe = function(Ge) {
    var it = Ge, ht = U ? U - St.width : 0;
    return it = Math.max(it, 0), it = Math.min(it, ht), it;
  }, st = useEvent$1(function(He, Ge) {
    Ge ? (flushSync(function() {
      be(function(it) {
        var ht = it + (xe ? -He : He);
        return qe(ht);
      });
    }), ze()) : $e(function(it) {
      var ht = it + He;
      return ht;
    });
  }), Mt = useFrameWheel(ne, at, Pt, _t, pt, !!U, st), kt = _slicedToArray(Mt, 2), Ft = kt[0], Je = kt[1];
  useMobileTouchMove(ne, _e, function(He, Ge, it, ht) {
    var Ct = ht;
    return Wt(He, Ge, it) ? !1 : !Ct || !Ct._virtualHandled ? (Ct && (Ct._virtualHandled = !0), Ft({
      preventDefault: function() {
      },
      deltaX: He ? Ge : 0,
      deltaY: He ? 0 : Ge
    }), !0) : !1;
  }), useScrollDrag(me, _e, function(He) {
    $e(function(Ge) {
      return Ge + He;
    });
  }), useLayoutEffect$2(function() {
    function He(it) {
      var ht = at && it.detail < 0, Ct = Pt && it.detail > 0;
      ne && !ht && !Ct && it.preventDefault();
    }
    var Ge = _e.current;
    return Ge.addEventListener("wheel", Ft, {
      passive: !1
    }), Ge.addEventListener("DOMMouseScroll", Je, {
      passive: !0
    }), Ge.addEventListener("MozMousePixelScroll", He, {
      passive: !1
    }), function() {
      Ge.removeEventListener("wheel", Ft), Ge.removeEventListener("DOMMouseScroll", Je), Ge.removeEventListener("MozMousePixelScroll", He);
    };
  }, [ne, at, Pt]), useLayoutEffect$2(function() {
    if (U) {
      var He = qe(Me);
      be(He), ze({
        x: He
      });
    }
  }, [St.width, U]);
  var Xe = function() {
    var Ge, it;
    (Ge = wt.current) === null || Ge === void 0 || Ge.delayHidden(), (it = It.current) === null || it === void 0 || it.delayHidden();
  }, ct = useScrollTo(_e, Se, fe, l, le, function() {
    return ue(!0);
  }, $e, Xe);
  React.useImperativeHandle(r, function() {
    return {
      nativeElement: Te.current,
      getScrollInfo: Nt,
      scrollTo: function(Ge) {
        function it(ht) {
          return ht && _typeof$1(ht) === "object" && ("left" in ht || "top" in ht);
        }
        it(Ge) ? (Ge.left !== void 0 && be(qe(Ge.left)), ct(Ge.top)) : ct(Ge);
      }
    };
  }), useLayoutEffect$2(function() {
    if (te) {
      var He = Se.slice(tt, nt + 1);
      te(He, Se);
    }
  }, [tt, nt, Se]);
  var bt = useGetSize(Se, le, fe, l), vt = ae == null ? void 0 : ae({
    start: tt,
    end: nt,
    virtual: me,
    offsetX: Me,
    offsetY: Dt,
    rtl: xe,
    getSize: bt
  }), Rt = useChildren(Se, tt, nt, U, Me, se, $, Ze), Et = null;
  o && (Et = _objectSpread2(_defineProperty({}, j ? "height" : "maxHeight", o), ScrollStyle), ne && (Et.overflowY = "hidden", U && (Et.overflowX = "hidden"), Le && (Et.pointerEvents = "none")));
  var gt = {};
  return xe && (gt.dir = "rtl"), /* @__PURE__ */ React.createElement("div", _extends({
    ref: Te,
    style: _objectSpread2(_objectSpread2({}, Z), {}, {
      position: "relative"
    }),
    className: Ee
  }, gt, oe), /* @__PURE__ */ React.createElement(RefResizeObserver, {
    onResize: Zt
  }, /* @__PURE__ */ React.createElement(K, {
    className: "".concat(a, "-holder"),
    style: Et,
    ref: _e,
    onScroll: Ve,
    onMouseEnter: Xe
  }, /* @__PURE__ */ React.createElement(Filler, {
    prefixCls: a,
    height: ut,
    offsetX: Me,
    offsetY: Dt,
    scrollWidth: U,
    onInnerResize: ue,
    ref: Ce,
    innerProps: re,
    rtl: xe,
    extra: vt
  }, Rt))), me && ut > o && /* @__PURE__ */ React.createElement(ScrollBar, {
    ref: wt,
    prefixCls: a,
    scrollOffset: Ae,
    scrollRange: ut,
    rtl: xe,
    onScroll: Oe,
    onStartMove: Ie,
    onStopMove: je,
    spinSize: Gt,
    containerSize: St.height,
    style: ie == null ? void 0 : ie.verticalScrollBar,
    thumbStyle: ie == null ? void 0 : ie.verticalScrollBarThumb,
    showScrollBar: he
  }), me && U > St.width && /* @__PURE__ */ React.createElement(ScrollBar, {
    ref: It,
    prefixCls: a,
    scrollOffset: Me,
    scrollRange: U,
    rtl: xe,
    onScroll: Oe,
    onStartMove: Ie,
    onStopMove: je,
    spinSize: Tt,
    containerSize: St.width,
    horizontal: !0,
    style: ie == null ? void 0 : ie.horizontalScrollBar,
    thumbStyle: ie == null ? void 0 : ie.horizontalScrollBarThumb,
    showScrollBar: he
  }));
}
var List = /* @__PURE__ */ React.forwardRef(RawList);
List.displayName = "List";
function isPlatformMac() {
  return /(mac\sos|macintosh)/i.test(navigator.appVersion);
}
var _excluded$b = ["disabled", "title", "children", "style", "className"];
function isTitleType(t) {
  return typeof t == "string" || typeof t == "number";
}
var OptionList = function(r, n) {
  var a = useBaseProps(), s = a.prefixCls, o = a.id, l = a.open, x = a.multiple, j = a.mode, Z = a.searchValue, V = a.toggleOpen, $ = a.notFoundContent, X = a.onPopupScroll, W = React.useContext(SelectContext), Y = W.maxCount, U = W.flattenOptions, G = W.onActiveValue, K = W.defaultActiveFirstOption, J = W.onSelect, ee = W.menuItemSelectedIcon, te = W.rawValues, re = W.fieldNames, ae = W.virtual, ie = W.direction, ce = W.listHeight, he = W.listItemHeight, oe = W.optionRender, le = "".concat(s, "-item"), pe = useMemo(function() {
    return U;
  }, [l, U], function(Pe, ke) {
    return ke[0] && Pe[1] !== ke[1];
  }), de = React.useRef(null), se = React.useMemo(function() {
    return x && isValidCount(Y) && (te == null ? void 0 : te.size) >= Y;
  }, [x, Y, te == null ? void 0 : te.size]), ue = function(ke) {
    ke.preventDefault();
  }, fe = function(ke) {
    var ye;
    (ye = de.current) === null || ye === void 0 || ye.scrollTo(typeof ke == "number" ? {
      index: ke
    } : ke);
  }, ge = function(ke) {
    for (var ye = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, Me = pe.length, be = 0; be < Me; be += 1) {
      var De = (ke + be * ye + Me) % Me, Fe = pe[De] || {}, Le = Fe.group, Ne = Fe.data;
      if (!Le && !(Ne != null && Ne.disabled) && !se)
        return De;
    }
    return -1;
  }, ne = React.useState(function() {
    return ge(0);
  }), ve = _slicedToArray(ne, 2), me = ve[0], xe = ve[1], Ee = function(ke) {
    var ye = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    xe(ke);
    var Me = {
      source: ye ? "keyboard" : "mouse"
    }, be = pe[ke];
    if (!be) {
      G(null, -1, Me);
      return;
    }
    G(be.value, ke, Me);
  };
  useEffect(function() {
    Ee(K !== !1 ? ge(0) : -1);
  }, [pe.length, Z]);
  var Se = React.useCallback(function(Pe) {
    return te.has(Pe) && j !== "combobox";
  }, [j, _toConsumableArray(te).toString(), te.size]);
  useEffect(function() {
    var Pe = setTimeout(function() {
      if (!x && l && te.size === 1) {
        var ye = Array.from(te)[0], Me = pe.findIndex(function(be) {
          var De = be.data;
          return De.value === ye;
        });
        Me !== -1 && (Ee(Me), fe(Me));
      }
    });
    if (l) {
      var ke;
      (ke = de.current) === null || ke === void 0 || ke.scrollTo(void 0);
    }
    return function() {
      return clearTimeout(Pe);
    };
  }, [l, Z]);
  var _e = function(ke) {
    ke !== void 0 && J(ke, {
      selected: !te.has(ke)
    }), x || V(!1);
  };
  if (React.useImperativeHandle(n, function() {
    return {
      onKeyDown: function(ke) {
        var ye = ke.which, Me = ke.ctrlKey;
        switch (ye) {
          // >>> Arrow keys & ctrl + n/p on Mac
          case KeyCode.N:
          case KeyCode.P:
          case KeyCode.UP:
          case KeyCode.DOWN: {
            var be = 0;
            if (ye === KeyCode.UP ? be = -1 : ye === KeyCode.DOWN ? be = 1 : isPlatformMac() && Me && (ye === KeyCode.N ? be = 1 : ye === KeyCode.P && (be = -1)), be !== 0) {
              var De = ge(me + be, be);
              fe(De), Ee(De, !0);
            }
            break;
          }
          // >>> Select
          case KeyCode.ENTER: {
            var Fe, Le = pe[me];
            Le && !(Le != null && (Fe = Le.data) !== null && Fe !== void 0 && Fe.disabled) && !se ? _e(Le.value) : _e(void 0), l && ke.preventDefault();
            break;
          }
          // >>> Close
          case KeyCode.ESC:
            V(!1), l && ke.stopPropagation();
        }
      },
      onKeyUp: function() {
      },
      scrollTo: function(ke) {
        fe(ke);
      }
    };
  }), pe.length === 0)
    return /* @__PURE__ */ React.createElement("div", {
      role: "listbox",
      id: "".concat(o, "_list"),
      className: "".concat(le, "-empty"),
      onMouseDown: ue
    }, $);
  var Ce = Object.keys(re).map(function(Pe) {
    return re[Pe];
  }), Te = function(ke) {
    return ke.label;
  };
  function we(Pe, ke) {
    var ye = Pe.group;
    return {
      role: ye ? "presentation" : "option",
      id: "".concat(o, "_list_").concat(ke)
    };
  }
  var Re = function(ke) {
    var ye = pe[ke];
    if (!ye)
      return null;
    var Me = ye.data || {}, be = Me.value, De = ye.group, Fe = pickAttrs(Me, !0), Le = Te(ye);
    return ye ? /* @__PURE__ */ React.createElement("div", _extends({
      "aria-label": typeof Le == "string" && !De ? Le : null
    }, Fe, {
      key: ke
    }, we(ye, ke), {
      "aria-selected": Se(be)
    }), be) : null;
  }, Ae = {
    role: "listbox",
    id: "".concat(o, "_list")
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, ae && /* @__PURE__ */ React.createElement("div", _extends({}, Ae, {
    style: {
      height: 0,
      width: 0,
      overflow: "hidden"
    }
  }), Re(me - 1), Re(me), Re(me + 1)), /* @__PURE__ */ React.createElement(List, {
    itemKey: "key",
    ref: de,
    data: pe,
    height: ce,
    itemHeight: he,
    fullHeight: !1,
    onMouseDown: ue,
    onScroll: X,
    virtual: ae,
    direction: ie,
    innerProps: ae ? null : Ae
  }, function(Pe, ke) {
    var ye = Pe.group, Me = Pe.groupOption, be = Pe.data, De = Pe.label, Fe = Pe.value, Le = be.key;
    if (ye) {
      var Ne, Ie = (Ne = be.title) !== null && Ne !== void 0 ? Ne : isTitleType(De) ? De.toString() : void 0;
      return /* @__PURE__ */ React.createElement("div", {
        className: cls(le, "".concat(le, "-group"), be.className),
        title: Ie
      }, De !== void 0 ? De : Le);
    }
    var je = be.disabled, Ze = be.title;
    be.children;
    var $e = be.style, We = be.className, Be = _objectWithoutProperties(be, _excluded$b), Ue = omit$2(Be, Ce), Qe = Se(Fe), et = je || !Qe && se, rt = "".concat(le, "-option"), ut = cls(le, rt, We, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(rt, "-grouped"), Me), "".concat(rt, "-active"), me === ke && !et), "".concat(rt, "-disabled"), et), "".concat(rt, "-selected"), Qe)), tt = Te(Pe), nt = !ee || typeof ee == "function" || Qe, Dt = typeof tt == "number" ? tt : tt || Fe, xt = isTitleType(Dt) ? Dt.toString() : void 0;
    return Ze !== void 0 && (xt = Ze), /* @__PURE__ */ React.createElement("div", _extends({}, pickAttrs(Ue), ae ? {} : we(Pe, ke), {
      "aria-selected": Qe,
      className: ut,
      title: xt,
      onMouseMove: function() {
        me === ke || et || Ee(ke);
      },
      onClick: function() {
        et || _e(Fe);
      },
      style: $e
    }), /* @__PURE__ */ React.createElement("div", {
      className: "".concat(rt, "-content")
    }, typeof oe == "function" ? oe(Pe, {
      index: ke
    }) : Dt), /* @__PURE__ */ React.isValidElement(ee) || Qe, nt && /* @__PURE__ */ React.createElement(TransBtn, {
      className: "".concat(le, "-option-state"),
      customizeIcon: ee,
      customizeIconProps: {
        value: Fe,
        disabled: et,
        isSelected: Qe
      }
    }, Qe ? "✓" : null));
  }));
}, RefOptionList = /* @__PURE__ */ React.forwardRef(OptionList);
process.env.NODE_ENV !== "production" && (RefOptionList.displayName = "OptionList");
const useCache = (function(t, r) {
  var n = React.useRef({
    values: /* @__PURE__ */ new Map(),
    options: /* @__PURE__ */ new Map()
  }), a = React.useMemo(function() {
    var o = n.current, l = o.values, x = o.options, j = t.map(function($) {
      if ($.label === void 0) {
        var X;
        return _objectSpread2(_objectSpread2({}, $), {}, {
          label: (X = l.get($.value)) === null || X === void 0 ? void 0 : X.label
        });
      }
      return $;
    }), Z = /* @__PURE__ */ new Map(), V = /* @__PURE__ */ new Map();
    return j.forEach(function($) {
      Z.set($.value, $), V.set($.value, r.get($.value) || x.get($.value));
    }), n.current.values = Z, n.current.options = V, j;
  }, [t, r]), s = React.useCallback(function(o) {
    return r.get(o) || n.current.options.get(o);
  }, [r]);
  return [a, s];
});
function includes(t, r) {
  return toArray$1(t).join("").toUpperCase().includes(r);
}
const useFilterOptions = (function(t, r, n, a, s) {
  return React.useMemo(function() {
    if (!n || a === !1)
      return t;
    var o = r.options, l = r.label, x = r.value, j = [], Z = typeof a == "function", V = n.toUpperCase(), $ = Z ? a : function(W, Y) {
      return s ? includes(Y[s], V) : Y[o] ? includes(Y[l !== "children" ? l : "label"], V) : includes(Y[x], V);
    }, X = Z ? function(W) {
      return injectPropsWithOption(W);
    } : function(W) {
      return W;
    };
    return t.forEach(function(W) {
      if (W[o]) {
        var Y = $(n, X(W));
        if (Y)
          j.push(W);
        else {
          var U = W[o].filter(function(G) {
            return $(n, X(G));
          });
          U.length && j.push(_objectSpread2(_objectSpread2({}, W), {}, _defineProperty({}, o, U)));
        }
        return;
      }
      $(n, X(W)) && j.push(W);
    }), j;
  }, [t, a, s, n, r]);
});
var uuid$1 = 0, isBrowserClient = process.env.NODE_ENV !== "test" && canUseDom$1();
function getUUID() {
  var t;
  return isBrowserClient ? (t = uuid$1, uuid$1 += 1) : t = "TEST_OR_SSR", t;
}
function useId$1(t) {
  var r = React.useState(), n = _slicedToArray(r, 2), a = n[0], s = n[1];
  return React.useEffect(function() {
    s("rc_select_".concat(getUUID()));
  }, []), t || a;
}
var _excluded$a = ["children", "value"], _excluded2 = ["children"];
function convertNodeToOption(t) {
  var r = t, n = r.key, a = r.props, s = a.children, o = a.value, l = _objectWithoutProperties(a, _excluded$a);
  return _objectSpread2({
    key: n,
    value: o !== void 0 ? o : n,
    children: s
  }, l);
}
function convertChildrenToData(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  return toArray$2(t).map(function(n, a) {
    if (!/* @__PURE__ */ React.isValidElement(n) || !n.type)
      return null;
    var s = n, o = s.type.isSelectOptGroup, l = s.key, x = s.props, j = x.children, Z = _objectWithoutProperties(x, _excluded2);
    return r || !o ? convertNodeToOption(n) : _objectSpread2(_objectSpread2({
      key: "__RC_SELECT_GRP__".concat(l === null ? a : l, "__"),
      label: l
    }, Z), {}, {
      options: convertChildrenToData(j)
    });
  }).filter(function(n) {
    return n;
  });
}
var useOptions = function(r, n, a, s, o) {
  return React.useMemo(function() {
    var l = r, x = !r;
    x && (l = convertChildrenToData(n));
    var j = /* @__PURE__ */ new Map(), Z = /* @__PURE__ */ new Map(), V = function(W, Y, U) {
      U && typeof U == "string" && W.set(Y[U], Y);
    }, $ = function X(W) {
      for (var Y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, U = 0; U < W.length; U += 1) {
        var G = W[U];
        !G[a.options] || Y ? (j.set(G[a.value], G), V(Z, G, a.label), V(Z, G, s), V(Z, G, o)) : X(G[a.options], !0);
      }
    };
    return $(l), {
      options: l,
      valueOptions: j,
      labelOptions: Z
    };
  }, [r, n, a, s, o]);
};
function useRefFunc(t) {
  var r = React.useRef();
  r.current = t;
  var n = React.useCallback(function() {
    return r.current.apply(r, arguments);
  }, []);
  return n;
}
function warningProps(t) {
  var r = t.mode, n = t.options, a = t.children, s = t.backfill, o = t.allowClear, l = t.placeholder, x = t.getInputElement, j = t.showSearch, Z = t.onSearch, V = t.defaultOpen, $ = t.autoFocus, X = t.labelInValue, W = t.value, Y = t.inputValue, U = t.optionLabelProp, G = isMultiple(r), K = j !== void 0 ? j : G || r === "combobox", J = n || convertChildrenToData(a);
  if (warningOnce(r !== "tags" || J.every(function(ae) {
    return !ae.disabled;
  }), "Please avoid setting option to disabled in tags mode since user can always type text as tag."), r === "tags" || r === "combobox") {
    var ee = J.some(function(ae) {
      return ae.options ? ae.options.some(function(ie) {
        return typeof ("value" in ie ? ie.value : ie.key) == "number";
      }) : typeof ("value" in ae ? ae.value : ae.key) == "number";
    });
    warningOnce(!ee, "`value` of Option should not use number type when `mode` is `tags` or `combobox`.");
  }
  if (warningOnce(r !== "combobox" || !U, "`combobox` mode not support `optionLabelProp`. Please set `value` on Option directly."), warningOnce(r === "combobox" || !s, "`backfill` only works with `combobox` mode."), warningOnce(r === "combobox" || !x, "`getInputElement` only work with `combobox` mode."), noteOnce(r !== "combobox" || !x || !o || !l, "Customize `getInputElement` should customize clear and placeholder logic instead of configuring `allowClear` and `placeholder`."), Z && !K && r !== "combobox" && r !== "tags" && warningOnce(!1, "`onSearch` should work with `showSearch` instead of use alone."), noteOnce(!V || $, "`defaultOpen` makes Select open without focus which means it will not close by click outside. You can set `autoFocus` if needed."), W != null) {
    var te = toArray$1(W);
    warningOnce(!X || te.every(function(ae) {
      return _typeof$1(ae) === "object" && ("key" in ae || "value" in ae);
    }), "`value` should in shape of `{ value: string | number, label?: ReactNode }` when you set `labelInValue` to `true`"), warningOnce(!G || Array.isArray(W), "`value` should be array when `mode` is `multiple` or `tags`");
  }
  if (a) {
    var re = null;
    toArray$2(a).some(function(ae) {
      if (!/* @__PURE__ */ React.isValidElement(ae) || !ae.type)
        return !1;
      var ie = ae, ce = ie.type;
      if (ce.isSelectOption)
        return !1;
      if (ce.isSelectOptGroup) {
        var he = toArray$2(ae.props.children).every(function(oe) {
          return !/* @__PURE__ */ React.isValidElement(oe) || !ae.type || oe.type.isSelectOption ? !0 : (re = oe.type, !1);
        });
        return !he;
      }
      return re = ce, !0;
    }), re && warningOnce(!1, "`children` should be `Select.Option` or `Select.OptGroup` instead of `".concat(re.displayName || re.name || re, "`.")), warningOnce(Y === void 0, "`inputValue` is deprecated, please use `searchValue` instead.");
  }
}
function warningNullOptions(t, r) {
  if (t) {
    var n = function a(s) {
      for (var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, l = 0; l < s.length; l++) {
        var x = s[l];
        if (x[r == null ? void 0 : r.value] === null)
          return warningOnce(!1, "`value` in Select options should not be `null`."), !0;
        if (!o && Array.isArray(x[r == null ? void 0 : r.options]) && a(x[r == null ? void 0 : r.options], !0))
          break;
      }
    };
    n(t);
  }
}
var _excluded$9 = ["id", "mode", "prefixCls", "backfill", "fieldNames", "inputValue", "searchValue", "onSearch", "autoClearSearchValue", "onSelect", "onDeselect", "dropdownMatchSelectWidth", "filterOption", "filterSort", "optionFilterProp", "optionLabelProp", "options", "optionRender", "children", "defaultActiveFirstOption", "menuItemSelectedIcon", "virtual", "direction", "listHeight", "listItemHeight", "labelRender", "value", "defaultValue", "labelInValue", "onChange", "maxCount"], OMIT_DOM_PROPS = ["inputValue"];
function isRawValue(t) {
  return !t || _typeof$1(t) !== "object";
}
var Select$1 = /* @__PURE__ */ React.forwardRef(function(t, r) {
  var n = t.id, a = t.mode, s = t.prefixCls, o = s === void 0 ? "rc-select" : s, l = t.backfill, x = t.fieldNames, j = t.inputValue, Z = t.searchValue, V = t.onSearch, $ = t.autoClearSearchValue, X = $ === void 0 ? !0 : $, W = t.onSelect, Y = t.onDeselect, U = t.dropdownMatchSelectWidth, G = U === void 0 ? !0 : U, K = t.filterOption, J = t.filterSort, ee = t.optionFilterProp, te = t.optionLabelProp, re = t.options, ae = t.optionRender, ie = t.children, ce = t.defaultActiveFirstOption, he = t.menuItemSelectedIcon, oe = t.virtual, le = t.direction, pe = t.listHeight, de = pe === void 0 ? 200 : pe, se = t.listItemHeight, ue = se === void 0 ? 20 : se, fe = t.labelRender, ge = t.value, ne = t.defaultValue, ve = t.labelInValue, me = t.onChange, xe = t.maxCount, Ee = _objectWithoutProperties(t, _excluded$9), Se = useId$1(n), _e = isMultiple(a), Ce = !!(!re && ie), Te = React.useMemo(function() {
    return K === void 0 && a === "combobox" ? !1 : K;
  }, [K, a]), we = React.useMemo(
    function() {
      return fillFieldNames(x, Ce);
    },
    /* eslint-disable react-hooks/exhaustive-deps */
    [
      // We stringify fieldNames to avoid unnecessary re-renders.
      JSON.stringify(x),
      Ce
    ]
    /* eslint-enable react-hooks/exhaustive-deps */
  ), Re = useMergedState$2("", {
    value: Z !== void 0 ? Z : j,
    postState: function(ze) {
      return ze || "";
    }
  }), Ae = _slicedToArray(Re, 2), Pe = Ae[0], ke = Ae[1], ye = useOptions(re, ie, we, ee, te), Me = ye.valueOptions, be = ye.labelOptions, De = ye.options, Fe = React.useCallback(function(Ye) {
    var ze = toArray$1(Ye);
    return ze.map(function(Oe) {
      var Ve, qe, st, Mt, kt;
      if (isRawValue(Oe))
        Ve = Oe;
      else {
        var Ft;
        st = Oe.key, qe = Oe.label, Ve = (Ft = Oe.value) !== null && Ft !== void 0 ? Ft : st;
      }
      var Je = Me.get(Ve);
      if (Je) {
        var Xe;
        if (qe === void 0 && (qe = Je == null ? void 0 : Je[te || we.label]), st === void 0 && (st = (Xe = Je == null ? void 0 : Je.key) !== null && Xe !== void 0 ? Xe : Ve), Mt = Je == null ? void 0 : Je.disabled, kt = Je == null ? void 0 : Je.title, process.env.NODE_ENV !== "production" && !te) {
          var ct = Je == null ? void 0 : Je[we.label];
          ct !== void 0 && !/* @__PURE__ */ React.isValidElement(ct) && !/* @__PURE__ */ React.isValidElement(qe) && ct !== qe && warningOnce(!1, "`label` of `value` is not same as `label` in Select options.");
        }
      }
      return {
        label: qe,
        value: Ve,
        key: st,
        disabled: Mt,
        title: kt
      };
    });
  }, [we, te, Me]), Le = useMergedState$2(ne, {
    value: ge
  }), Ne = _slicedToArray(Le, 2), Ie = Ne[0], je = Ne[1], Ze = React.useMemo(function() {
    var Ye, ze = _e && Ie === null ? [] : Ie, Oe = Fe(ze);
    return a === "combobox" && isComboNoValue((Ye = Oe[0]) === null || Ye === void 0 ? void 0 : Ye.value) ? [] : Oe;
  }, [Ie, Fe, a, _e]), $e = useCache(Ze, Me), We = _slicedToArray($e, 2), Be = We[0], Ue = We[1], Qe = React.useMemo(function() {
    if (!a && Be.length === 1) {
      var Ye = Be[0];
      if (Ye.value === null && (Ye.label === null || Ye.label === void 0))
        return [];
    }
    return Be.map(function(ze) {
      var Oe;
      return _objectSpread2(_objectSpread2({}, ze), {}, {
        label: (Oe = typeof fe == "function" ? fe(ze) : ze.label) !== null && Oe !== void 0 ? Oe : ze.value
      });
    });
  }, [a, Be, fe]), et = React.useMemo(function() {
    return new Set(Be.map(function(Ye) {
      return Ye.value;
    }));
  }, [Be]);
  React.useEffect(function() {
    if (a === "combobox") {
      var Ye, ze = (Ye = Be[0]) === null || Ye === void 0 ? void 0 : Ye.value;
      ke(hasValue$2(ze) ? String(ze) : "");
    }
  }, [Be]);
  var rt = useRefFunc(function(Ye, ze) {
    var Oe = ze != null ? ze : Ye;
    return _defineProperty(_defineProperty({}, we.value, Ye), we.label, Oe);
  }), ut = React.useMemo(function() {
    if (a !== "tags")
      return De;
    var Ye = _toConsumableArray(De), ze = function(Ve) {
      return Me.has(Ve);
    };
    return _toConsumableArray(Be).sort(function(Oe, Ve) {
      return Oe.value < Ve.value ? -1 : 1;
    }).forEach(function(Oe) {
      var Ve = Oe.value;
      ze(Ve) || Ye.push(rt(Ve, Oe.label));
    }), Ye;
  }, [rt, De, Me, Be, a]), tt = useFilterOptions(ut, we, Pe, Te, ee), nt = React.useMemo(function() {
    return a !== "tags" || !Pe || tt.some(function(Ye) {
      return Ye[ee || "value"] === Pe;
    }) || tt.some(function(Ye) {
      return Ye[we.value] === Pe;
    }) ? tt : [rt(Pe)].concat(_toConsumableArray(tt));
  }, [rt, ee, a, tt, Pe, we]), Dt = React.useMemo(function() {
    return J ? _toConsumableArray(nt).sort(function(Ye, ze) {
      return J(Ye, ze);
    }) : nt;
  }, [nt, J]), xt = React.useMemo(function() {
    return flattenOptions(Dt, {
      fieldNames: we,
      childrenAsData: Ce
    });
  }, [Dt, we, Ce]), yt = function(ze) {
    var Oe = Fe(ze);
    if (je(Oe), me && // Trigger event only when value changed
    (Oe.length !== Be.length || Oe.some(function(st, Mt) {
      var kt;
      return ((kt = Be[Mt]) === null || kt === void 0 ? void 0 : kt.value) !== (st == null ? void 0 : st.value);
    }))) {
      var Ve = ve ? Oe : Oe.map(function(st) {
        return st.value;
      }), qe = Oe.map(function(st) {
        return injectPropsWithOption(Ue(st.value));
      });
      me(
        // Value
        _e ? Ve : Ve[0],
        // Option
        _e ? qe : qe[0]
      );
    }
  }, St = React.useState(null), dt = _slicedToArray(St, 2), Zt = dt[0], wt = dt[1], It = React.useState(0), Tt = _slicedToArray(It, 2), Gt = Tt[0], Vt = Tt[1], Lt = ce !== void 0 ? ce : a !== "combobox", mt = React.useCallback(function(Ye, ze) {
    var Oe = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, Ve = Oe.source, qe = Ve === void 0 ? "keyboard" : Ve;
    Vt(ze), l && a === "combobox" && Ye !== null && qe === "keyboard" && wt(String(Ye));
  }, [l, a]), at = function(ze, Oe, Ve) {
    var qe = function() {
      var Rt, Et = Ue(ze);
      return [ve ? {
        label: Et == null ? void 0 : Et[we.label],
        value: ze,
        key: (Rt = Et == null ? void 0 : Et.key) !== null && Rt !== void 0 ? Rt : ze
      } : ze, injectPropsWithOption(Et)];
    };
    if (Oe && W) {
      var st = qe(), Mt = _slicedToArray(st, 2), kt = Mt[0], Ft = Mt[1];
      W(kt, Ft);
    } else if (!Oe && Y && Ve !== "clear") {
      var Je = qe(), Xe = _slicedToArray(Je, 2), ct = Xe[0], bt = Xe[1];
      Y(ct, bt);
    }
  }, Pt = useRefFunc(function(Ye, ze) {
    var Oe, Ve = _e ? ze.selected : !0;
    Ve ? Oe = _e ? [].concat(_toConsumableArray(Be), [Ye]) : [Ye] : Oe = Be.filter(function(qe) {
      return qe.value !== Ye;
    }), yt(Oe), at(Ye, Ve), a === "combobox" ? wt("") : (!isMultiple || X) && (ke(""), wt(""));
  }), _t = function(ze, Oe) {
    yt(ze);
    var Ve = Oe.type, qe = Oe.values;
    (Ve === "remove" || Ve === "clear") && qe.forEach(function(st) {
      at(st.value, !1, Ve);
    });
  }, pt = function(ze, Oe) {
    if (ke(ze), wt(null), Oe.source === "submit") {
      var Ve = (ze || "").trim();
      if (Ve) {
        var qe = Array.from(new Set([].concat(_toConsumableArray(et), [Ve])));
        yt(qe), at(Ve, !0), ke("");
      }
      return;
    }
    Oe.source !== "blur" && (a === "combobox" && yt(ze), V == null || V(ze));
  }, Wt = function(ze) {
    var Oe = ze;
    a !== "tags" && (Oe = ze.map(function(qe) {
      var st = be.get(qe);
      return st == null ? void 0 : st.value;
    }).filter(function(qe) {
      return qe !== void 0;
    }));
    var Ve = Array.from(new Set([].concat(_toConsumableArray(et), _toConsumableArray(Oe))));
    yt(Ve), Ve.forEach(function(qe) {
      at(qe, !0);
    });
  }, Nt = React.useMemo(function() {
    var Ye = oe !== !1 && G !== !1;
    return _objectSpread2(_objectSpread2({}, ye), {}, {
      flattenOptions: xt,
      onActiveValue: mt,
      defaultActiveFirstOption: Lt,
      onSelect: Pt,
      menuItemSelectedIcon: he,
      rawValues: et,
      fieldNames: we,
      virtual: Ye,
      direction: le,
      listHeight: de,
      listItemHeight: ue,
      childrenAsData: Ce,
      maxCount: xe,
      optionRender: ae
    });
  }, [xe, ye, xt, mt, Lt, Pt, he, et, we, oe, G, le, de, ue, Ce, ae]);
  return process.env.NODE_ENV !== "production" && (warningProps(t), warningNullOptions(De, we)), /* @__PURE__ */ React.createElement(SelectContext.Provider, {
    value: Nt
  }, /* @__PURE__ */ React.createElement(BaseSelect, _extends({}, Ee, {
    // >>> MISC
    id: Se,
    prefixCls: o,
    ref: r,
    omitDomProps: OMIT_DOM_PROPS,
    mode: a,
    displayValues: Qe,
    onDisplayValuesChange: _t,
    direction: le,
    searchValue: Pe,
    onSearch: pt,
    autoClearSearchValue: X,
    onSearchSplit: Wt,
    dropdownMatchSelectWidth: G,
    OptionList: RefOptionList,
    emptyOptions: !xt.length,
    activeValue: Zt,
    activeDescendantId: "".concat(Se, "_list_").concat(Gt)
  })));
});
process.env.NODE_ENV !== "production" && (Select$1.displayName = "Select");
var TypedSelect = Select$1;
TypedSelect.Option = Option;
TypedSelect.OptGroup = OptGroup;
var omit$1 = {}, hasRequiredOmit;
function requireOmit() {
  if (hasRequiredOmit) return omit$1;
  hasRequiredOmit = 1, Object.defineProperty(omit$1, "__esModule", {
    value: !0
  }), omit$1.default = t;
  function t(r, n) {
    var a = Object.assign({}, r);
    return Array.isArray(n) && n.forEach(function(s) {
      delete a[s];
    }), a;
  }
  return omit$1;
}
var omitExports = requireOmit();
const omit = /* @__PURE__ */ getDefaultExportFromCjs(omitExports);
function easeInOutQuad(t, r, n, a) {
  return (t /= a / 2) < 1 ? n / 2 * t * t * t * t + r : -n / 2 * ((t -= 2) * t * t * t - 2) + r;
}
function animate(t, r, n, a, s, o = {}) {
  const { duration: l = 300 } = o;
  let x, j;
  const Z = (V) => {
    if (x === void 0 && (x = V), V - x < l) {
      j = requestAnimationFrame(Z);
      const $ = easeInOutQuad(V - x, t, r - t, l);
      n($);
    } else
      n(r), a == null || a(r);
  };
  return j = requestAnimationFrame(Z), () => {
    cancelAnimationFrame(j);
  };
}
function getLineHeightPx(t) {
  const r = window.getComputedStyle(t), n = r.lineHeight;
  if (n === "normal" || !n) {
    const s = Number.parseFloat(r.fontSize);
    return Number.isFinite(s) ? s * 1.2 : 20;
  }
  const a = Number.parseFloat(n);
  return Number.isFinite(a) ? a : 20;
}
function getVerticalPaddingPx(t) {
  const r = window.getComputedStyle(t), n = Number.parseFloat(r.paddingTop) || 0, a = Number.parseFloat(r.paddingBottom) || 0;
  return n + a;
}
function autoHeight(t, r) {
  const { minRows: n, maxRows: a } = r != null ? r : {};
  t.style.height = "auto", t.style.overflowY = "hidden";
  const s = getLineHeightPx(t), o = getVerticalPaddingPx(t), l = t.scrollHeight;
  let x = l;
  if (hasValue$1(n) && n > 0) {
    const j = s * n + o;
    x = Math.max(x, j), t.style.minHeight = `${j}px`;
  } else
    t.style.minHeight = "";
  if (hasValue$1(a) && a > 0) {
    const j = s * a + o;
    t.style.maxHeight = `${j}px`, l > j ? (x = j, t.style.overflowY = "auto") : t.style.overflowY = "hidden";
  } else
    t.style.maxHeight = "";
  t.style.height = `${x}px`;
}
function hasValue$1(t) {
  return typeof t == "number" && Number.isFinite(t);
}
function hasValue(t) {
  return Array.isArray(t) ? t.length !== 0 : t != null && t !== "null";
}
function mergeRefs(...t) {
  return (r) => {
    for (const n of t)
      n && setRefValue(n, r);
  };
}
function setRefValue(t, r) {
  t && (typeof t == "function" ? t(r) : t.current = r);
}
function renderNode(t, r = "p", n) {
  const a = r;
  return ["string", "number", "boolean"].includes(typeof t) ? /* @__PURE__ */ jsx(a, { className: n, title: t == null ? void 0 : t.toString(), children: t }) : isValidElement(t) ? cloneElement(t, {
    className: clsx(t.props.className, n)
  }) : null;
}
const ru = {
  common: {
    yes: "Да",
    no: "Нет"
  },
  calendar: {
    locale: ru$1,
    values: {
      hour: "час",
      minuteShort: "мин."
    }
  },
  input: {
    values: {
      clear: "Очистить"
    }
  },
  datePicker: {
    values: {
      apply: "Применить",
      cancel: "Сбросить"
    }
  },
  tableMenu: {
    values: {
      sortAsc: "Сортировать по возрастанию",
      sortDesc: "Сортировать по убыванию",
      clearSorting: "Сбросить сортировку",
      hideColumn: "Скрыть столбец",
      tableSettings: "Настройка таблицы",
      pinLeft: "Закрепить слева",
      pinRight: "Закрепить справа",
      unpin: "Открепить",
      filter: "Добавить фильтр",
      inputPlaceholder: "Текст"
    },
    filter: {
      operators: {
        isAnyOf: "любой",
        isNotEmpty: "задано",
        isEmpty: "не задано",
        endsWith: "заканчивается на",
        startsWith: "начинается с",
        equals: "равно",
        contains: "содержит",
        is: "равно",
        not: "не",
        after: "после",
        onOrAfter: "с выбранной и позже",
        before: "до",
        onOrBefore: "до выбранной включительно"
      },
      clearAll: "Удалить все фильтры",
      clearAllForColumn: "Удалить фильтры для колонки"
    }
  },
  stringList: {
    values: {
      add: "Добавить",
      addAll: "Добавить все",
      addSomething: "Введите значение"
    }
  },
  noResultOverlay: {
    values: {
      overlayText: "Данные для выбранных фильтров отсутствуют. Попробуйте установить другие фильтры"
    }
  },
  noRowsOverlay: {
    values: {
      overlayText: "Данные отсутствуют"
    }
  }
}, en = {
  common: {
    yes: "Yes",
    no: "No"
  },
  calendar: {
    locale: enUS,
    values: {
      hour: "hour",
      minuteShort: "min."
    }
  },
  input: {
    values: {
      clear: "Clear"
    }
  },
  datePicker: {
    values: {
      apply: "Apply",
      cancel: "Cancel"
    }
  },
  tableMenu: {
    values: {
      sortAsc: "Sort ascending",
      sortDesc: "Sort descending",
      clearSorting: "Clear sorting",
      hideColumn: "Hide column",
      tableSettings: "Manage table",
      pinLeft: "Pin to the left",
      pinRight: "Pin to the right",
      unpin: "Unpin",
      filter: " Add Filter",
      inputPlaceholder: "Text"
    },
    filter: {
      operators: {
        isAnyOf: "is any of",
        isNotEmpty: "is not empty",
        isEmpty: "is empty",
        endsWith: "ends with",
        startsWith: "starts with",
        equals: "equals",
        contains: "contains",
        is: "is",
        not: "not",
        after: "after",
        onOrAfter: "on or after",
        before: "before",
        onOrBefore: "on or before"
      },
      clearAll: "Clear all filters",
      clearAllForColumn: "Clear all filters for current column"
    }
  },
  stringList: {
    values: {
      add: "Add",
      addAll: "Add all",
      addSomething: "Enter value"
    }
  },
  noResultOverlay: {
    values: {
      overlayText: "There is no data available for the selected filters. Try setting other filters."
    }
  },
  noRowsOverlay: {
    values: {
      overlayText: "No data"
    }
  }
}, DEFAULT_GLOBAL_CONFIG = {
  theme: "dark",
  style: void 0,
  size: "m",
  localization: ru
}, ConfigContext = createContext(DEFAULT_GLOBAL_CONFIG), ConfigProvider = ({ children: t, config: r, externalElement: n }) => {
  const a = { ...DEFAULT_GLOBAL_CONFIG, ...r, rootElement: n };
  return useLayoutEffect$3(() => (n && (a.theme === "dark" && n.classList.add("go-theme_dark"), a.theme === "light" && n.classList.add("go-theme_light"), a.style === "bordered" && n.classList.add("go-style_bordered")), () => {
    n && (n.classList.remove("go-theme_dark"), n.classList.remove("go-theme_light"), n.classList.remove("go-style_bordered"));
  }), [a.theme, a.style, n]), n ? /* @__PURE__ */ jsx(ConfigContext.Consumer, { children: (s) => /* @__PURE__ */ jsx(ConfigContext.Provider, { value: { ...s, ...a }, children: t }) }) : /* @__PURE__ */ jsx(ConfigContext.Consumer, { children: (s) => /* @__PURE__ */ jsx(ConfigContext.Provider, { value: { ...s, ...a }, children: /* @__PURE__ */ jsx(
    "div",
    {
      className: clsx(
        a.theme === "dark" && "go-theme_dark",
        a.theme === "light" && "go-theme_light",
        a.style === "bordered" && "go-style_bordered"
      ),
      children: t
    }
  ) }) });
};
function isValidSize(t) {
  return typeof t == "string" && ["s", "m"].includes(t);
}
function useGlobalComponentConfig(t) {
  const r = useContext(ConfigContext), n = t && isValidSize(t.size) ? t.size : null;
  return {
    ...r,
    size: n || r.size || DEFAULT_GLOBAL_CONFIG.size || "m"
  };
}
var extendStatics$1 = function(t, r) {
  return (extendStatics$1 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, a) {
    n.__proto__ = a;
  } || function(n, a) {
    for (var s in a) Object.prototype.hasOwnProperty.call(a, s) && (n[s] = a[s]);
  })(t, r);
};
function __extends$1(t, r) {
  if (typeof r != "function" && r !== null) throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
  function n() {
    this.constructor = t;
  }
  extendStatics$1(t, r), t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
}
var __assign$1 = function() {
  return (__assign$1 = Object.assign || function(t) {
    for (var r, n = 1, a = arguments.length; n < a; n++) for (var s in r = arguments[n]) Object.prototype.hasOwnProperty.call(r, s) && (t[s] = r[s]);
    return t;
  }).apply(this, arguments);
};
function __awaiter(t, r, n, a) {
  return new (n || (n = Promise))((function(s, o) {
    function l(Z) {
      try {
        j(a.next(Z));
      } catch (V) {
        o(V);
      }
    }
    function x(Z) {
      try {
        j(a.throw(Z));
      } catch (V) {
        o(V);
      }
    }
    function j(Z) {
      var V;
      Z.done ? s(Z.value) : (V = Z.value, V instanceof n ? V : new n((function($) {
        $(V);
      }))).then(l, x);
    }
    j((a = a.apply(t, [])).next());
  }));
}
function __generator(t, r) {
  var n, a, s, o, l = { label: 0, sent: function() {
    if (1 & s[0]) throw s[1];
    return s[1];
  }, trys: [], ops: [] };
  return o = { next: x(0), throw: x(1), return: x(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function x(j) {
    return function(Z) {
      return (function(V) {
        if (n) throw new TypeError("Generator is already executing.");
        for (; l; ) try {
          if (n = 1, a && (s = 2 & V[0] ? a.return : V[0] ? a.throw || ((s = a.return) && s.call(a), 0) : a.next) && !(s = s.call(a, V[1])).done) return s;
          switch (a = 0, s && (V = [2 & V[0], s.value]), V[0]) {
            case 0:
            case 1:
              s = V;
              break;
            case 4:
              return l.label++, { value: V[1], done: !1 };
            case 5:
              l.label++, a = V[1], V = [0];
              continue;
            case 7:
              V = l.ops.pop(), l.trys.pop();
              continue;
            default:
              if (s = l.trys, !((s = s.length > 0 && s[s.length - 1]) || V[0] !== 6 && V[0] !== 2)) {
                l = 0;
                continue;
              }
              if (V[0] === 3 && (!s || V[1] > s[0] && V[1] < s[3])) {
                l.label = V[1];
                break;
              }
              if (V[0] === 6 && l.label < s[1]) {
                l.label = s[1], s = V;
                break;
              }
              if (s && l.label < s[2]) {
                l.label = s[2], l.ops.push(V);
                break;
              }
              s[2] && l.ops.pop(), l.trys.pop();
              continue;
          }
          V = r.call(t, l);
        } catch ($) {
          V = [6, $], a = 0;
        } finally {
          n = s = 0;
        }
        if (5 & V[0]) throw V[1];
        return { value: V[0] ? V[1] : void 0, done: !0 };
      })([j, Z]);
    };
  }
}
function createCommonjsModule(t, r) {
  return t(r = { exports: {} }, r.exports), r.exports;
}
var lottie = createCommonjsModule((function(module, exports) {
  typeof navigator != "undefined" && (function(t, r) {
    module.exports = r();
  })(0, (function() {
    var svgNS = "http://www.w3.org/2000/svg", locationHref = "", _useWebWorker = !1, initialDefaultFrame = -999999, setWebWorker = function(t) {
      _useWebWorker = !!t;
    }, getWebWorker = function() {
      return _useWebWorker;
    }, setLocationHref = function(t) {
      locationHref = t;
    }, getLocationHref = function() {
      return locationHref;
    };
    function createTag(t) {
      return document.createElement(t);
    }
    function extendPrototype(t, r) {
      var n, a, s = t.length;
      for (n = 0; n < s; n += 1) for (var o in a = t[n].prototype) Object.prototype.hasOwnProperty.call(a, o) && (r.prototype[o] = a[o]);
    }
    function getDescriptor(t, r) {
      return Object.getOwnPropertyDescriptor(t, r);
    }
    function createProxyFunction(t) {
      function r() {
      }
      return r.prototype = t, r;
    }
    var audioControllerFactory = (function() {
      function t(r) {
        this.audios = [], this.audioFactory = r, this._volume = 1, this._isMuted = !1;
      }
      return t.prototype = { addAudio: function(r) {
        this.audios.push(r);
      }, pause: function() {
        var r, n = this.audios.length;
        for (r = 0; r < n; r += 1) this.audios[r].pause();
      }, resume: function() {
        var r, n = this.audios.length;
        for (r = 0; r < n; r += 1) this.audios[r].resume();
      }, setRate: function(r) {
        var n, a = this.audios.length;
        for (n = 0; n < a; n += 1) this.audios[n].setRate(r);
      }, createAudio: function(r) {
        return this.audioFactory ? this.audioFactory(r) : window.Howl ? new window.Howl({ src: [r] }) : { isPlaying: !1, play: function() {
          this.isPlaying = !0;
        }, seek: function() {
          this.isPlaying = !1;
        }, playing: function() {
        }, rate: function() {
        }, setVolume: function() {
        } };
      }, setAudioFactory: function(r) {
        this.audioFactory = r;
      }, setVolume: function(r) {
        this._volume = r, this._updateVolume();
      }, mute: function() {
        this._isMuted = !0, this._updateVolume();
      }, unmute: function() {
        this._isMuted = !1, this._updateVolume();
      }, getVolume: function() {
        return this._volume;
      }, _updateVolume: function() {
        var r, n = this.audios.length;
        for (r = 0; r < n; r += 1) this.audios[r].volume(this._volume * (this._isMuted ? 0 : 1));
      } }, function() {
        return new t();
      };
    })(), createTypedArray = /* @__PURE__ */ (function() {
      function t(r, n) {
        var a, s = 0, o = [];
        switch (r) {
          case "int16":
          case "uint8c":
            a = 1;
            break;
          default:
            a = 1.1;
        }
        for (s = 0; s < n; s += 1) o.push(a);
        return o;
      }
      return typeof Uint8ClampedArray == "function" && typeof Float32Array == "function" ? function(r, n) {
        return r === "float32" ? new Float32Array(n) : r === "int16" ? new Int16Array(n) : r === "uint8c" ? new Uint8ClampedArray(n) : t(r, n);
      } : t;
    })();
    function createSizedArray(t) {
      return Array.apply(null, { length: t });
    }
    function _typeof$6(t) {
      return (_typeof$6 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
        return typeof r;
      } : function(r) {
        return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
      })(t);
    }
    var subframeEnabled = !0, expressionsPlugin = null, expressionsInterfaces = null, idPrefix$1 = "", isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent), bmPow = Math.pow, bmSqrt = Math.sqrt, bmFloor = Math.floor, bmMax = Math.max, bmMin = Math.min, BMMath = {};
    (function() {
      var t, r = ["abs", "acos", "acosh", "asin", "asinh", "atan", "atanh", "atan2", "ceil", "cbrt", "expm1", "clz32", "cos", "cosh", "exp", "floor", "fround", "hypot", "imul", "log", "log1p", "log2", "log10", "max", "min", "pow", "random", "round", "sign", "sin", "sinh", "sqrt", "tan", "tanh", "trunc", "E", "LN10", "LN2", "LOG10E", "LOG2E", "PI", "SQRT1_2", "SQRT2"], n = r.length;
      for (t = 0; t < n; t += 1) BMMath[r[t]] = Math[r[t]];
    })(), BMMath.random = Math.random, BMMath.abs = function(t) {
      if (_typeof$6(t) === "object" && t.length) {
        var r, n = createSizedArray(t.length), a = t.length;
        for (r = 0; r < a; r += 1) n[r] = Math.abs(t[r]);
        return n;
      }
      return Math.abs(t);
    };
    var defaultCurveSegments = 150, degToRads = Math.PI / 180, roundCorner = 0.5519;
    function styleDiv(t) {
      t.style.position = "absolute", t.style.top = 0, t.style.left = 0, t.style.display = "block", t.style.transformOrigin = "0 0", t.style.webkitTransformOrigin = "0 0", t.style.backfaceVisibility = "visible", t.style.webkitBackfaceVisibility = "visible", t.style.transformStyle = "preserve-3d", t.style.webkitTransformStyle = "preserve-3d", t.style.mozTransformStyle = "preserve-3d";
    }
    function BMEnterFrameEvent(t, r, n, a) {
      this.type = t, this.currentTime = r, this.totalTime = n, this.direction = a < 0 ? -1 : 1;
    }
    function BMCompleteEvent(t, r) {
      this.type = t, this.direction = r < 0 ? -1 : 1;
    }
    function BMCompleteLoopEvent(t, r, n, a) {
      this.type = t, this.currentLoop = n, this.totalLoops = r, this.direction = a < 0 ? -1 : 1;
    }
    function BMSegmentStartEvent(t, r, n) {
      this.type = t, this.firstFrame = r, this.totalFrames = n;
    }
    function BMDestroyEvent(t, r) {
      this.type = t, this.target = r;
    }
    function BMRenderFrameErrorEvent(t, r) {
      this.type = "renderFrameError", this.nativeError = t, this.currentTime = r;
    }
    function BMConfigErrorEvent(t) {
      this.type = "configError", this.nativeError = t;
    }
    var createElementID = (_count = 0, function() {
      return idPrefix$1 + "__lottie_element_" + (_count += 1);
    }), _count;
    function HSVtoRGB(t, r, n) {
      var a, s, o, l, x, j, Z, V;
      switch (j = n * (1 - r), Z = n * (1 - (x = 6 * t - (l = Math.floor(6 * t))) * r), V = n * (1 - (1 - x) * r), l % 6) {
        case 0:
          a = n, s = V, o = j;
          break;
        case 1:
          a = Z, s = n, o = j;
          break;
        case 2:
          a = j, s = n, o = V;
          break;
        case 3:
          a = j, s = Z, o = n;
          break;
        case 4:
          a = V, s = j, o = n;
          break;
        case 5:
          a = n, s = j, o = Z;
      }
      return [a, s, o];
    }
    function RGBtoHSV(t, r, n) {
      var a, s = Math.max(t, r, n), o = Math.min(t, r, n), l = s - o, x = s === 0 ? 0 : l / s, j = s / 255;
      switch (s) {
        case o:
          a = 0;
          break;
        case t:
          a = r - n + l * (r < n ? 6 : 0), a /= 6 * l;
          break;
        case r:
          a = n - t + 2 * l, a /= 6 * l;
          break;
        case n:
          a = t - r + 4 * l, a /= 6 * l;
      }
      return [a, x, j];
    }
    function addSaturationToRGB(t, r) {
      var n = RGBtoHSV(255 * t[0], 255 * t[1], 255 * t[2]);
      return n[1] += r, n[1] > 1 ? n[1] = 1 : n[1] <= 0 && (n[1] = 0), HSVtoRGB(n[0], n[1], n[2]);
    }
    function addBrightnessToRGB(t, r) {
      var n = RGBtoHSV(255 * t[0], 255 * t[1], 255 * t[2]);
      return n[2] += r, n[2] > 1 ? n[2] = 1 : n[2] < 0 && (n[2] = 0), HSVtoRGB(n[0], n[1], n[2]);
    }
    function addHueToRGB(t, r) {
      var n = RGBtoHSV(255 * t[0], 255 * t[1], 255 * t[2]);
      return n[0] += r / 360, n[0] > 1 ? n[0] -= 1 : n[0] < 0 && (n[0] += 1), HSVtoRGB(n[0], n[1], n[2]);
    }
    var rgbToHex = (function() {
      var t, r, n = [];
      for (t = 0; t < 256; t += 1) r = t.toString(16), n[t] = r.length === 1 ? "0" + r : r;
      return function(a, s, o) {
        return a < 0 && (a = 0), s < 0 && (s = 0), o < 0 && (o = 0), "#" + n[a] + n[s] + n[o];
      };
    })(), setSubframeEnabled = function(t) {
      subframeEnabled = !!t;
    }, getSubframeEnabled = function() {
      return subframeEnabled;
    }, setExpressionsPlugin = function(t) {
      expressionsPlugin = t;
    }, getExpressionsPlugin = function() {
      return expressionsPlugin;
    }, setExpressionInterfaces = function(t) {
      expressionsInterfaces = t;
    }, getExpressionInterfaces = function() {
      return expressionsInterfaces;
    }, setDefaultCurveSegments = function(t) {
      defaultCurveSegments = t;
    }, getDefaultCurveSegments = function() {
      return defaultCurveSegments;
    }, setIdPrefix = function(t) {
      idPrefix$1 = t;
    };
    function createNS(t) {
      return document.createElementNS(svgNS, t);
    }
    function _typeof$5(t) {
      return (_typeof$5 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
        return typeof r;
      } : function(r) {
        return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
      })(t);
    }
    var dataManager = /* @__PURE__ */ (function() {
      var t, r, n = 1, a = [], s = { onmessage: function() {
      }, postMessage: function(j) {
        t({ data: j });
      } }, o = { postMessage: function(j) {
        s.onmessage({ data: j });
      } };
      function l() {
        r || ((r = (function(j) {
          if (window.Worker && window.Blob && getWebWorker()) {
            var Z = new Blob(["var _workerSelf = self; self.onmessage = ", j.toString()], { type: "text/javascript" }), V = URL.createObjectURL(Z);
            return new Worker(V);
          }
          return t = j, s;
        })((function(j) {
          if (o.dataManager || (o.dataManager = (function() {
            function V(ie, ce) {
              var he, oe, le, pe, de, se, ue = ie.length;
              for (oe = 0; oe < ue; oe += 1) if ("ks" in (he = ie[oe]) && !he.completed) {
                if (he.completed = !0, he.hasMask) {
                  var fe = he.masksProperties;
                  for (pe = fe.length, le = 0; le < pe; le += 1) if (fe[le].pt.k.i) W(fe[le].pt.k);
                  else for (se = fe[le].pt.k.length, de = 0; de < se; de += 1) fe[le].pt.k[de].s && W(fe[le].pt.k[de].s[0]), fe[le].pt.k[de].e && W(fe[le].pt.k[de].e[0]);
                }
                he.ty === 0 ? (he.layers = $(he.refId, ce), V(he.layers, ce)) : he.ty === 4 ? X(he.shapes) : he.ty === 5 && re(he);
              }
            }
            function $(ie, ce) {
              var he = (function(oe, le) {
                for (var pe = 0, de = le.length; pe < de; ) {
                  if (le[pe].id === oe) return le[pe];
                  pe += 1;
                }
                return null;
              })(ie, ce);
              return he ? he.layers.__used ? JSON.parse(JSON.stringify(he.layers)) : (he.layers.__used = !0, he.layers) : null;
            }
            function X(ie) {
              var ce, he, oe;
              for (ce = ie.length - 1; ce >= 0; ce -= 1) if (ie[ce].ty === "sh") if (ie[ce].ks.k.i) W(ie[ce].ks.k);
              else for (oe = ie[ce].ks.k.length, he = 0; he < oe; he += 1) ie[ce].ks.k[he].s && W(ie[ce].ks.k[he].s[0]), ie[ce].ks.k[he].e && W(ie[ce].ks.k[he].e[0]);
              else ie[ce].ty === "gr" && X(ie[ce].it);
            }
            function W(ie) {
              var ce, he = ie.i.length;
              for (ce = 0; ce < he; ce += 1) ie.i[ce][0] += ie.v[ce][0], ie.i[ce][1] += ie.v[ce][1], ie.o[ce][0] += ie.v[ce][0], ie.o[ce][1] += ie.v[ce][1];
            }
            function Y(ie, ce) {
              var he = ce ? ce.split(".") : [100, 100, 100];
              return ie[0] > he[0] || !(he[0] > ie[0]) && (ie[1] > he[1] || !(he[1] > ie[1]) && (ie[2] > he[2] || !(he[2] > ie[2]) && null));
            }
            var U, G = /* @__PURE__ */ (function() {
              var ie = [4, 4, 14];
              function ce(he) {
                var oe, le, pe, de = he.length;
                for (oe = 0; oe < de; oe += 1) he[oe].ty === 5 && (le = he[oe], pe = void 0, pe = le.t.d, le.t.d = { k: [{ s: pe, t: 0 }] });
              }
              return function(he) {
                if (Y(ie, he.v) && (ce(he.layers), he.assets)) {
                  var oe, le = he.assets.length;
                  for (oe = 0; oe < le; oe += 1) he.assets[oe].layers && ce(he.assets[oe].layers);
                }
              };
            })(), K = (U = [4, 7, 99], function(ie) {
              if (ie.chars && !Y(U, ie.v)) {
                var ce, he = ie.chars.length;
                for (ce = 0; ce < he; ce += 1) {
                  var oe = ie.chars[ce];
                  oe.data && oe.data.shapes && (X(oe.data.shapes), oe.data.ip = 0, oe.data.op = 99999, oe.data.st = 0, oe.data.sr = 1, oe.data.ks = { p: { k: [0, 0], a: 0 }, s: { k: [100, 100], a: 0 }, a: { k: [0, 0], a: 0 }, r: { k: 0, a: 0 }, o: { k: 100, a: 0 } }, ie.chars[ce].t || (oe.data.shapes.push({ ty: "no" }), oe.data.shapes[0].it.push({ p: { k: [0, 0], a: 0 }, s: { k: [100, 100], a: 0 }, a: { k: [0, 0], a: 0 }, r: { k: 0, a: 0 }, o: { k: 100, a: 0 }, sk: { k: 0, a: 0 }, sa: { k: 0, a: 0 }, ty: "tr" })));
                }
              }
            }), J = /* @__PURE__ */ (function() {
              var ie = [5, 7, 15];
              function ce(he) {
                var oe, le, pe, de = he.length;
                for (oe = 0; oe < de; oe += 1) he[oe].ty === 5 && (le = he[oe], pe = void 0, typeof (pe = le.t.p).a == "number" && (pe.a = { a: 0, k: pe.a }), typeof pe.p == "number" && (pe.p = { a: 0, k: pe.p }), typeof pe.r == "number" && (pe.r = { a: 0, k: pe.r }));
              }
              return function(he) {
                if (Y(ie, he.v) && (ce(he.layers), he.assets)) {
                  var oe, le = he.assets.length;
                  for (oe = 0; oe < le; oe += 1) he.assets[oe].layers && ce(he.assets[oe].layers);
                }
              };
            })(), ee = /* @__PURE__ */ (function() {
              var ie = [4, 1, 9];
              function ce(oe) {
                var le, pe, de, se = oe.length;
                for (le = 0; le < se; le += 1) if (oe[le].ty === "gr") ce(oe[le].it);
                else if (oe[le].ty === "fl" || oe[le].ty === "st") if (oe[le].c.k && oe[le].c.k[0].i) for (de = oe[le].c.k.length, pe = 0; pe < de; pe += 1) oe[le].c.k[pe].s && (oe[le].c.k[pe].s[0] /= 255, oe[le].c.k[pe].s[1] /= 255, oe[le].c.k[pe].s[2] /= 255, oe[le].c.k[pe].s[3] /= 255), oe[le].c.k[pe].e && (oe[le].c.k[pe].e[0] /= 255, oe[le].c.k[pe].e[1] /= 255, oe[le].c.k[pe].e[2] /= 255, oe[le].c.k[pe].e[3] /= 255);
                else oe[le].c.k[0] /= 255, oe[le].c.k[1] /= 255, oe[le].c.k[2] /= 255, oe[le].c.k[3] /= 255;
              }
              function he(oe) {
                var le, pe = oe.length;
                for (le = 0; le < pe; le += 1) oe[le].ty === 4 && ce(oe[le].shapes);
              }
              return function(oe) {
                if (Y(ie, oe.v) && (he(oe.layers), oe.assets)) {
                  var le, pe = oe.assets.length;
                  for (le = 0; le < pe; le += 1) oe.assets[le].layers && he(oe.assets[le].layers);
                }
              };
            })(), te = /* @__PURE__ */ (function() {
              var ie = [4, 4, 18];
              function ce(oe) {
                var le, pe, de;
                for (le = oe.length - 1; le >= 0; le -= 1) if (oe[le].ty === "sh") if (oe[le].ks.k.i) oe[le].ks.k.c = oe[le].closed;
                else for (de = oe[le].ks.k.length, pe = 0; pe < de; pe += 1) oe[le].ks.k[pe].s && (oe[le].ks.k[pe].s[0].c = oe[le].closed), oe[le].ks.k[pe].e && (oe[le].ks.k[pe].e[0].c = oe[le].closed);
                else oe[le].ty === "gr" && ce(oe[le].it);
              }
              function he(oe) {
                var le, pe, de, se, ue, fe, ge = oe.length;
                for (pe = 0; pe < ge; pe += 1) {
                  if ((le = oe[pe]).hasMask) {
                    var ne = le.masksProperties;
                    for (se = ne.length, de = 0; de < se; de += 1) if (ne[de].pt.k.i) ne[de].pt.k.c = ne[de].cl;
                    else for (fe = ne[de].pt.k.length, ue = 0; ue < fe; ue += 1) ne[de].pt.k[ue].s && (ne[de].pt.k[ue].s[0].c = ne[de].cl), ne[de].pt.k[ue].e && (ne[de].pt.k[ue].e[0].c = ne[de].cl);
                  }
                  le.ty === 4 && ce(le.shapes);
                }
              }
              return function(oe) {
                if (Y(ie, oe.v) && (he(oe.layers), oe.assets)) {
                  var le, pe = oe.assets.length;
                  for (le = 0; le < pe; le += 1) oe.assets[le].layers && he(oe.assets[le].layers);
                }
              };
            })();
            function re(ie) {
              ie.t.a.length === 0 && ie.t.p;
            }
            var ae = { completeData: function(ie) {
              ie.__complete || (ee(ie), G(ie), K(ie), J(ie), te(ie), V(ie.layers, ie.assets), (function(ce, he) {
                if (ce) {
                  var oe = 0, le = ce.length;
                  for (oe = 0; oe < le; oe += 1) ce[oe].t === 1 && (ce[oe].data.layers = $(ce[oe].data.refId, he), V(ce[oe].data.layers, he));
                }
              })(ie.chars, ie.assets), ie.__complete = !0);
            } };
            return ae.checkColors = ee, ae.checkChars = K, ae.checkPathProperties = J, ae.checkShapes = te, ae.completeLayers = V, ae;
          })()), o.assetLoader || (o.assetLoader = /* @__PURE__ */ (function() {
            function V($) {
              var X = $.getResponseHeader("content-type");
              return X && $.responseType === "json" && X.indexOf("json") !== -1 || $.response && _typeof$5($.response) === "object" ? $.response : $.response && typeof $.response == "string" ? JSON.parse($.response) : $.responseText ? JSON.parse($.responseText) : null;
            }
            return { load: function($, X, W, Y) {
              var U, G = new XMLHttpRequest();
              try {
                G.responseType = "json";
              } catch {
              }
              G.onreadystatechange = function() {
                if (G.readyState === 4) if (G.status === 200) U = V(G), W(U);
                else try {
                  U = V(G), W(U);
                } catch (K) {
                  Y && Y(K);
                }
              };
              try {
                G.open(["G", "E", "T"].join(""), $, !0);
              } catch {
                G.open(["G", "E", "T"].join(""), X + "/" + $, !0);
              }
              G.send();
            } };
          })()), j.data.type === "loadAnimation") o.assetLoader.load(j.data.path, j.data.fullPath, (function(V) {
            o.dataManager.completeData(V), o.postMessage({ id: j.data.id, payload: V, status: "success" });
          }), (function() {
            o.postMessage({ id: j.data.id, status: "error" });
          }));
          else if (j.data.type === "complete") {
            var Z = j.data.animation;
            o.dataManager.completeData(Z), o.postMessage({ id: j.data.id, payload: Z, status: "success" });
          } else j.data.type === "loadData" && o.assetLoader.load(j.data.path, j.data.fullPath, (function(V) {
            o.postMessage({ id: j.data.id, payload: V, status: "success" });
          }), (function() {
            o.postMessage({ id: j.data.id, status: "error" });
          }));
        }))).onmessage = function(j) {
          var Z = j.data, V = Z.id, $ = a[V];
          a[V] = null, Z.status === "success" ? $.onComplete(Z.payload) : $.onError && $.onError();
        });
      }
      function x(j, Z) {
        var V = "processId_" + (n += 1);
        return a[V] = { onComplete: j, onError: Z }, V;
      }
      return { loadAnimation: function(j, Z, V) {
        l();
        var $ = x(Z, V);
        r.postMessage({ type: "loadAnimation", path: j, fullPath: window.location.origin + window.location.pathname, id: $ });
      }, loadData: function(j, Z, V) {
        l();
        var $ = x(Z, V);
        r.postMessage({ type: "loadData", path: j, fullPath: window.location.origin + window.location.pathname, id: $ });
      }, completeAnimation: function(j, Z, V) {
        l();
        var $ = x(Z, V);
        r.postMessage({ type: "complete", animation: j, id: $ });
      } };
    })(), ImagePreloader = (function() {
      var t = (function() {
        var x = createTag("canvas");
        x.width = 1, x.height = 1;
        var j = x.getContext("2d");
        return j.fillStyle = "rgba(0,0,0,0)", j.fillRect(0, 0, 1, 1), x;
      })();
      function r() {
        this.loadedAssets += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
      }
      function n() {
        this.loadedFootagesCount += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
      }
      function a(x, j, Z) {
        var V = "";
        if (x.e) V = x.p;
        else if (j) {
          var $ = x.p;
          $.indexOf("images/") !== -1 && ($ = $.split("/")[1]), V = j + $;
        } else V = Z, V += x.u ? x.u : "", V += x.p;
        return V;
      }
      function s(x) {
        var j = 0, Z = setInterval(function() {
          (x.getBBox().width || j > 500) && (this._imageLoaded(), clearInterval(Z)), j += 1;
        }.bind(this), 50);
      }
      function o(x) {
        var j = { assetData: x }, Z = a(x, this.assetsPath, this.path);
        return dataManager.loadData(Z, function(V) {
          j.img = V, this._footageLoaded();
        }.bind(this), function() {
          j.img = {}, this._footageLoaded();
        }.bind(this)), j;
      }
      function l() {
        this._imageLoaded = r.bind(this), this._footageLoaded = n.bind(this), this.testImageLoaded = s.bind(this), this.createFootageData = o.bind(this), this.assetsPath = "", this.path = "", this.totalImages = 0, this.totalFootages = 0, this.loadedAssets = 0, this.loadedFootagesCount = 0, this.imagesLoadedCb = null, this.images = [];
      }
      return l.prototype = { loadAssets: function(x, j) {
        var Z;
        this.imagesLoadedCb = j;
        var V = x.length;
        for (Z = 0; Z < V; Z += 1) x[Z].layers || (x[Z].t && x[Z].t !== "seq" ? x[Z].t === 3 && (this.totalFootages += 1, this.images.push(this.createFootageData(x[Z]))) : (this.totalImages += 1, this.images.push(this._createImageData(x[Z]))));
      }, setAssetsPath: function(x) {
        this.assetsPath = x || "";
      }, setPath: function(x) {
        this.path = x || "";
      }, loadedImages: function() {
        return this.totalImages === this.loadedAssets;
      }, loadedFootages: function() {
        return this.totalFootages === this.loadedFootagesCount;
      }, destroy: function() {
        this.imagesLoadedCb = null, this.images.length = 0;
      }, getAsset: function(x) {
        for (var j = 0, Z = this.images.length; j < Z; ) {
          if (this.images[j].assetData === x) return this.images[j].img;
          j += 1;
        }
        return null;
      }, createImgData: function(x) {
        var j = a(x, this.assetsPath, this.path), Z = createTag("img");
        Z.crossOrigin = "anonymous", Z.addEventListener("load", this._imageLoaded, !1), Z.addEventListener("error", function() {
          V.img = t, this._imageLoaded();
        }.bind(this), !1), Z.src = j;
        var V = { img: Z, assetData: x };
        return V;
      }, createImageData: function(x) {
        var j = a(x, this.assetsPath, this.path), Z = createNS("image");
        isSafari ? this.testImageLoaded(Z) : Z.addEventListener("load", this._imageLoaded, !1), Z.addEventListener("error", function() {
          V.img = t, this._imageLoaded();
        }.bind(this), !1), Z.setAttributeNS("http://www.w3.org/1999/xlink", "href", j), this._elementHelper.append ? this._elementHelper.append(Z) : this._elementHelper.appendChild(Z);
        var V = { img: Z, assetData: x };
        return V;
      }, imageLoaded: r, footageLoaded: n, setCacheType: function(x, j) {
        x === "svg" ? (this._elementHelper = j, this._createImageData = this.createImageData.bind(this)) : this._createImageData = this.createImgData.bind(this);
      } }, l;
    })();
    function BaseEvent() {
    }
    BaseEvent.prototype = { triggerEvent: function(t, r) {
      if (this._cbs[t]) for (var n = this._cbs[t], a = 0; a < n.length; a += 1) n[a](r);
    }, addEventListener: function(t, r) {
      return this._cbs[t] || (this._cbs[t] = []), this._cbs[t].push(r), function() {
        this.removeEventListener(t, r);
      }.bind(this);
    }, removeEventListener: function(t, r) {
      if (r) {
        if (this._cbs[t]) {
          for (var n = 0, a = this._cbs[t].length; n < a; ) this._cbs[t][n] === r && (this._cbs[t].splice(n, 1), n -= 1, a -= 1), n += 1;
          this._cbs[t].length || (this._cbs[t] = null);
        }
      } else this._cbs[t] = null;
    } };
    var markerParser = /* @__PURE__ */ (function() {
      function t(r) {
        for (var n, a = r.split(`\r
`), s = {}, o = 0, l = 0; l < a.length; l += 1) (n = a[l].split(":")).length === 2 && (s[n[0]] = n[1].trim(), o += 1);
        if (o === 0) throw new Error();
        return s;
      }
      return function(r) {
        for (var n = [], a = 0; a < r.length; a += 1) {
          var s = r[a], o = { time: s.tm, duration: s.dr };
          try {
            o.payload = JSON.parse(r[a].cm);
          } catch {
            try {
              o.payload = t(r[a].cm);
            } catch {
              o.payload = { name: r[a].cm };
            }
          }
          n.push(o);
        }
        return n;
      };
    })(), ProjectInterface = /* @__PURE__ */ (function() {
      function t(r) {
        this.compositions.push(r);
      }
      return function() {
        function r(n) {
          for (var a = 0, s = this.compositions.length; a < s; ) {
            if (this.compositions[a].data && this.compositions[a].data.nm === n) return this.compositions[a].prepareFrame && this.compositions[a].data.xt && this.compositions[a].prepareFrame(this.currentFrame), this.compositions[a].compInterface;
            a += 1;
          }
          return null;
        }
        return r.compositions = [], r.currentFrame = 0, r.registerComposition = t, r;
      };
    })(), renderers = {}, registerRenderer = function(t, r) {
      renderers[t] = r;
    };
    function getRenderer(t) {
      return renderers[t];
    }
    function getRegisteredRenderer() {
      if (renderers.canvas) return "canvas";
      for (var t in renderers) if (renderers[t]) return t;
      return "";
    }
    function _typeof$4(t) {
      return (_typeof$4 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
        return typeof r;
      } : function(r) {
        return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
      })(t);
    }
    var AnimationItem = function() {
      this._cbs = [], this.name = "", this.path = "", this.isLoaded = !1, this.currentFrame = 0, this.currentRawFrame = 0, this.firstFrame = 0, this.totalFrames = 0, this.frameRate = 0, this.frameMult = 0, this.playSpeed = 1, this.playDirection = 1, this.playCount = 0, this.animationData = {}, this.assets = [], this.isPaused = !0, this.autoplay = !1, this.loop = !0, this.renderer = null, this.animationID = createElementID(), this.assetsPath = "", this.timeCompleted = 0, this.segmentPos = 0, this.isSubframeEnabled = getSubframeEnabled(), this.segments = [], this._idle = !0, this._completedLoop = !1, this.projectInterface = ProjectInterface(), this.imagePreloader = new ImagePreloader(), this.audioController = audioControllerFactory(), this.markers = [], this.configAnimation = this.configAnimation.bind(this), this.onSetupError = this.onSetupError.bind(this), this.onSegmentComplete = this.onSegmentComplete.bind(this), this.drawnFrameEvent = new BMEnterFrameEvent("drawnFrame", 0, 0, 0), this.expressionsPlugin = getExpressionsPlugin();
    };
    extendPrototype([BaseEvent], AnimationItem), AnimationItem.prototype.setParams = function(t) {
      (t.wrapper || t.container) && (this.wrapper = t.wrapper || t.container);
      var r = "svg";
      t.animType ? r = t.animType : t.renderer && (r = t.renderer);
      var n = getRenderer(r);
      this.renderer = new n(this, t.rendererSettings), this.imagePreloader.setCacheType(r, this.renderer.globalData.defs), this.renderer.setProjectInterface(this.projectInterface), this.animType = r, t.loop === "" || t.loop === null || t.loop === void 0 || t.loop === !0 ? this.loop = !0 : t.loop === !1 ? this.loop = !1 : this.loop = parseInt(t.loop, 10), this.autoplay = !("autoplay" in t) || t.autoplay, this.name = t.name ? t.name : "", this.autoloadSegments = !Object.prototype.hasOwnProperty.call(t, "autoloadSegments") || t.autoloadSegments, this.assetsPath = t.assetsPath, this.initialSegment = t.initialSegment, t.audioFactory && this.audioController.setAudioFactory(t.audioFactory), t.animationData ? this.setupAnimation(t.animationData) : t.path && (t.path.lastIndexOf("\\") !== -1 ? this.path = t.path.substr(0, t.path.lastIndexOf("\\") + 1) : this.path = t.path.substr(0, t.path.lastIndexOf("/") + 1), this.fileName = t.path.substr(t.path.lastIndexOf("/") + 1), this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf(".json")), dataManager.loadAnimation(t.path, this.configAnimation, this.onSetupError));
    }, AnimationItem.prototype.onSetupError = function() {
      this.trigger("data_failed");
    }, AnimationItem.prototype.setupAnimation = function(t) {
      dataManager.completeAnimation(t, this.configAnimation);
    }, AnimationItem.prototype.setData = function(t, r) {
      r && _typeof$4(r) !== "object" && (r = JSON.parse(r));
      var n = { wrapper: t, animationData: r }, a = t.attributes;
      n.path = a.getNamedItem("data-animation-path") ? a.getNamedItem("data-animation-path").value : a.getNamedItem("data-bm-path") ? a.getNamedItem("data-bm-path").value : a.getNamedItem("bm-path") ? a.getNamedItem("bm-path").value : "", n.animType = a.getNamedItem("data-anim-type") ? a.getNamedItem("data-anim-type").value : a.getNamedItem("data-bm-type") ? a.getNamedItem("data-bm-type").value : a.getNamedItem("bm-type") ? a.getNamedItem("bm-type").value : a.getNamedItem("data-bm-renderer") ? a.getNamedItem("data-bm-renderer").value : a.getNamedItem("bm-renderer") ? a.getNamedItem("bm-renderer").value : getRegisteredRenderer() || "canvas";
      var s = a.getNamedItem("data-anim-loop") ? a.getNamedItem("data-anim-loop").value : a.getNamedItem("data-bm-loop") ? a.getNamedItem("data-bm-loop").value : a.getNamedItem("bm-loop") ? a.getNamedItem("bm-loop").value : "";
      s === "false" ? n.loop = !1 : s === "true" ? n.loop = !0 : s !== "" && (n.loop = parseInt(s, 10));
      var o = a.getNamedItem("data-anim-autoplay") ? a.getNamedItem("data-anim-autoplay").value : a.getNamedItem("data-bm-autoplay") ? a.getNamedItem("data-bm-autoplay").value : !a.getNamedItem("bm-autoplay") || a.getNamedItem("bm-autoplay").value;
      n.autoplay = o !== "false", n.name = a.getNamedItem("data-name") ? a.getNamedItem("data-name").value : a.getNamedItem("data-bm-name") ? a.getNamedItem("data-bm-name").value : a.getNamedItem("bm-name") ? a.getNamedItem("bm-name").value : "", (a.getNamedItem("data-anim-prerender") ? a.getNamedItem("data-anim-prerender").value : a.getNamedItem("data-bm-prerender") ? a.getNamedItem("data-bm-prerender").value : a.getNamedItem("bm-prerender") ? a.getNamedItem("bm-prerender").value : "") === "false" && (n.prerender = !1), n.path ? this.setParams(n) : this.trigger("destroy");
    }, AnimationItem.prototype.includeLayers = function(t) {
      t.op > this.animationData.op && (this.animationData.op = t.op, this.totalFrames = Math.floor(t.op - this.animationData.ip));
      var r, n, a = this.animationData.layers, s = a.length, o = t.layers, l = o.length;
      for (n = 0; n < l; n += 1) for (r = 0; r < s; ) {
        if (a[r].id === o[n].id) {
          a[r] = o[n];
          break;
        }
        r += 1;
      }
      if ((t.chars || t.fonts) && (this.renderer.globalData.fontManager.addChars(t.chars), this.renderer.globalData.fontManager.addFonts(t.fonts, this.renderer.globalData.defs)), t.assets) for (s = t.assets.length, r = 0; r < s; r += 1) this.animationData.assets.push(t.assets[r]);
      this.animationData.__complete = !1, dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
    }, AnimationItem.prototype.onSegmentComplete = function(t) {
      this.animationData = t;
      var r = getExpressionsPlugin();
      r && r.initExpressions(this), this.loadNextSegment();
    }, AnimationItem.prototype.loadNextSegment = function() {
      var t = this.animationData.segments;
      if (!t || t.length === 0 || !this.autoloadSegments) return this.trigger("data_ready"), void (this.timeCompleted = this.totalFrames);
      var r = t.shift();
      this.timeCompleted = r.time * this.frameRate;
      var n = this.path + this.fileName + "_" + this.segmentPos + ".json";
      this.segmentPos += 1, dataManager.loadData(n, this.includeLayers.bind(this), function() {
        this.trigger("data_failed");
      }.bind(this));
    }, AnimationItem.prototype.loadSegments = function() {
      this.animationData.segments || (this.timeCompleted = this.totalFrames), this.loadNextSegment();
    }, AnimationItem.prototype.imagesLoaded = function() {
      this.trigger("loaded_images"), this.checkLoaded();
    }, AnimationItem.prototype.preloadImages = function() {
      this.imagePreloader.setAssetsPath(this.assetsPath), this.imagePreloader.setPath(this.path), this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
    }, AnimationItem.prototype.configAnimation = function(t) {
      if (this.renderer) try {
        this.animationData = t, this.initialSegment ? (this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]), this.firstFrame = Math.round(this.initialSegment[0])) : (this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip), this.firstFrame = Math.round(this.animationData.ip)), this.renderer.configAnimation(t), t.assets || (t.assets = []), this.assets = this.animationData.assets, this.frameRate = this.animationData.fr, this.frameMult = this.animationData.fr / 1e3, this.renderer.searchExtraCompositions(t.assets), this.markers = markerParser(t.markers || []), this.trigger("config_ready"), this.preloadImages(), this.loadSegments(), this.updaFrameModifier(), this.waitForFontsLoaded(), this.isPaused && this.audioController.pause();
      } catch (r) {
        this.triggerConfigError(r);
      }
    }, AnimationItem.prototype.waitForFontsLoaded = function() {
      this.renderer && (this.renderer.globalData.fontManager.isLoaded ? this.checkLoaded() : setTimeout(this.waitForFontsLoaded.bind(this), 20));
    }, AnimationItem.prototype.checkLoaded = function() {
      if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || this.renderer.rendererType !== "canvas") && this.imagePreloader.loadedFootages()) {
        this.isLoaded = !0;
        var t = getExpressionsPlugin();
        t && t.initExpressions(this), this.renderer.initItems(), setTimeout(function() {
          this.trigger("DOMLoaded");
        }.bind(this), 0), this.gotoFrame(), this.autoplay && this.play();
      }
    }, AnimationItem.prototype.resize = function(t, r) {
      var n = typeof t == "number" ? t : void 0, a = typeof r == "number" ? r : void 0;
      this.renderer.updateContainerSize(n, a);
    }, AnimationItem.prototype.setSubframe = function(t) {
      this.isSubframeEnabled = !!t;
    }, AnimationItem.prototype.gotoFrame = function() {
      this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame, this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted && (this.currentFrame = this.timeCompleted), this.trigger("enterFrame"), this.renderFrame(), this.trigger("drawnFrame");
    }, AnimationItem.prototype.renderFrame = function() {
      if (this.isLoaded !== !1 && this.renderer) try {
        this.expressionsPlugin && this.expressionsPlugin.resetFrame(), this.renderer.renderFrame(this.currentFrame + this.firstFrame);
      } catch (t) {
        this.triggerRenderFrameError(t);
      }
    }, AnimationItem.prototype.play = function(t) {
      t && this.name !== t || this.isPaused === !0 && (this.isPaused = !1, this.trigger("_play"), this.audioController.resume(), this._idle && (this._idle = !1, this.trigger("_active")));
    }, AnimationItem.prototype.pause = function(t) {
      t && this.name !== t || this.isPaused === !1 && (this.isPaused = !0, this.trigger("_pause"), this._idle = !0, this.trigger("_idle"), this.audioController.pause());
    }, AnimationItem.prototype.togglePause = function(t) {
      t && this.name !== t || (this.isPaused === !0 ? this.play() : this.pause());
    }, AnimationItem.prototype.stop = function(t) {
      t && this.name !== t || (this.pause(), this.playCount = 0, this._completedLoop = !1, this.setCurrentRawFrameValue(0));
    }, AnimationItem.prototype.getMarkerData = function(t) {
      for (var r, n = 0; n < this.markers.length; n += 1) if ((r = this.markers[n]).payload && r.payload.name === t) return r;
      return null;
    }, AnimationItem.prototype.goToAndStop = function(t, r, n) {
      if (!n || this.name === n) {
        var a = Number(t);
        if (isNaN(a)) {
          var s = this.getMarkerData(t);
          s && this.goToAndStop(s.time, !0);
        } else r ? this.setCurrentRawFrameValue(t) : this.setCurrentRawFrameValue(t * this.frameModifier);
        this.pause();
      }
    }, AnimationItem.prototype.goToAndPlay = function(t, r, n) {
      if (!n || this.name === n) {
        var a = Number(t);
        if (isNaN(a)) {
          var s = this.getMarkerData(t);
          s && (s.duration ? this.playSegments([s.time, s.time + s.duration], !0) : this.goToAndStop(s.time, !0));
        } else this.goToAndStop(a, r, n);
        this.play();
      }
    }, AnimationItem.prototype.advanceTime = function(t) {
      if (this.isPaused !== !0 && this.isLoaded !== !1) {
        var r = this.currentRawFrame + t * this.frameModifier, n = !1;
        r >= this.totalFrames - 1 && this.frameModifier > 0 ? this.loop && this.playCount !== this.loop ? r >= this.totalFrames ? (this.playCount += 1, this.checkSegments(r % this.totalFrames) || (this.setCurrentRawFrameValue(r % this.totalFrames), this._completedLoop = !0, this.trigger("loopComplete"))) : this.setCurrentRawFrameValue(r) : this.checkSegments(r > this.totalFrames ? r % this.totalFrames : 0) || (n = !0, r = this.totalFrames - 1) : r < 0 ? this.checkSegments(r % this.totalFrames) || (!this.loop || this.playCount-- <= 0 && this.loop !== !0 ? (n = !0, r = 0) : (this.setCurrentRawFrameValue(this.totalFrames + r % this.totalFrames), this._completedLoop ? this.trigger("loopComplete") : this._completedLoop = !0)) : this.setCurrentRawFrameValue(r), n && (this.setCurrentRawFrameValue(r), this.pause(), this.trigger("complete"));
      }
    }, AnimationItem.prototype.adjustSegment = function(t, r) {
      this.playCount = 0, t[1] < t[0] ? (this.frameModifier > 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(-1)), this.totalFrames = t[0] - t[1], this.timeCompleted = this.totalFrames, this.firstFrame = t[1], this.setCurrentRawFrameValue(this.totalFrames - 1e-3 - r)) : t[1] > t[0] && (this.frameModifier < 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(1)), this.totalFrames = t[1] - t[0], this.timeCompleted = this.totalFrames, this.firstFrame = t[0], this.setCurrentRawFrameValue(1e-3 + r)), this.trigger("segmentStart");
    }, AnimationItem.prototype.setSegment = function(t, r) {
      var n = -1;
      this.isPaused && (this.currentRawFrame + this.firstFrame < t ? n = t : this.currentRawFrame + this.firstFrame > r && (n = r - t)), this.firstFrame = t, this.totalFrames = r - t, this.timeCompleted = this.totalFrames, n !== -1 && this.goToAndStop(n, !0);
    }, AnimationItem.prototype.playSegments = function(t, r) {
      if (r && (this.segments.length = 0), _typeof$4(t[0]) === "object") {
        var n, a = t.length;
        for (n = 0; n < a; n += 1) this.segments.push(t[n]);
      } else this.segments.push(t);
      this.segments.length && r && this.adjustSegment(this.segments.shift(), 0), this.isPaused && this.play();
    }, AnimationItem.prototype.resetSegments = function(t) {
      this.segments.length = 0, this.segments.push([this.animationData.ip, this.animationData.op]), t && this.checkSegments(0);
    }, AnimationItem.prototype.checkSegments = function(t) {
      return !!this.segments.length && (this.adjustSegment(this.segments.shift(), t), !0);
    }, AnimationItem.prototype.destroy = function(t) {
      t && this.name !== t || !this.renderer || (this.renderer.destroy(), this.imagePreloader.destroy(), this.trigger("destroy"), this._cbs = null, this.onEnterFrame = null, this.onLoopComplete = null, this.onComplete = null, this.onSegmentStart = null, this.onDestroy = null, this.renderer = null, this.expressionsPlugin = null, this.imagePreloader = null, this.projectInterface = null);
    }, AnimationItem.prototype.setCurrentRawFrameValue = function(t) {
      this.currentRawFrame = t, this.gotoFrame();
    }, AnimationItem.prototype.setSpeed = function(t) {
      this.playSpeed = t, this.updaFrameModifier();
    }, AnimationItem.prototype.setDirection = function(t) {
      this.playDirection = t < 0 ? -1 : 1, this.updaFrameModifier();
    }, AnimationItem.prototype.setLoop = function(t) {
      this.loop = t;
    }, AnimationItem.prototype.setVolume = function(t, r) {
      r && this.name !== r || this.audioController.setVolume(t);
    }, AnimationItem.prototype.getVolume = function() {
      return this.audioController.getVolume();
    }, AnimationItem.prototype.mute = function(t) {
      t && this.name !== t || this.audioController.mute();
    }, AnimationItem.prototype.unmute = function(t) {
      t && this.name !== t || this.audioController.unmute();
    }, AnimationItem.prototype.updaFrameModifier = function() {
      this.frameModifier = this.frameMult * this.playSpeed * this.playDirection, this.audioController.setRate(this.playSpeed * this.playDirection);
    }, AnimationItem.prototype.getPath = function() {
      return this.path;
    }, AnimationItem.prototype.getAssetsPath = function(t) {
      var r = "";
      if (t.e) r = t.p;
      else if (this.assetsPath) {
        var n = t.p;
        n.indexOf("images/") !== -1 && (n = n.split("/")[1]), r = this.assetsPath + n;
      } else r = this.path, r += t.u ? t.u : "", r += t.p;
      return r;
    }, AnimationItem.prototype.getAssetData = function(t) {
      for (var r = 0, n = this.assets.length; r < n; ) {
        if (t === this.assets[r].id) return this.assets[r];
        r += 1;
      }
      return null;
    }, AnimationItem.prototype.hide = function() {
      this.renderer.hide();
    }, AnimationItem.prototype.show = function() {
      this.renderer.show();
    }, AnimationItem.prototype.getDuration = function(t) {
      return t ? this.totalFrames : this.totalFrames / this.frameRate;
    }, AnimationItem.prototype.updateDocumentData = function(t, r, n) {
      try {
        this.renderer.getElementByPath(t).updateDocumentData(r, n);
      } catch {
      }
    }, AnimationItem.prototype.trigger = function(t) {
      if (this._cbs && this._cbs[t]) switch (t) {
        case "enterFrame":
          this.triggerEvent(t, new BMEnterFrameEvent(t, this.currentFrame, this.totalFrames, this.frameModifier));
          break;
        case "drawnFrame":
          this.drawnFrameEvent.currentTime = this.currentFrame, this.drawnFrameEvent.totalTime = this.totalFrames, this.drawnFrameEvent.direction = this.frameModifier, this.triggerEvent(t, this.drawnFrameEvent);
          break;
        case "loopComplete":
          this.triggerEvent(t, new BMCompleteLoopEvent(t, this.loop, this.playCount, this.frameMult));
          break;
        case "complete":
          this.triggerEvent(t, new BMCompleteEvent(t, this.frameMult));
          break;
        case "segmentStart":
          this.triggerEvent(t, new BMSegmentStartEvent(t, this.firstFrame, this.totalFrames));
          break;
        case "destroy":
          this.triggerEvent(t, new BMDestroyEvent(t, this));
          break;
        default:
          this.triggerEvent(t);
      }
      t === "enterFrame" && this.onEnterFrame && this.onEnterFrame.call(this, new BMEnterFrameEvent(t, this.currentFrame, this.totalFrames, this.frameMult)), t === "loopComplete" && this.onLoopComplete && this.onLoopComplete.call(this, new BMCompleteLoopEvent(t, this.loop, this.playCount, this.frameMult)), t === "complete" && this.onComplete && this.onComplete.call(this, new BMCompleteEvent(t, this.frameMult)), t === "segmentStart" && this.onSegmentStart && this.onSegmentStart.call(this, new BMSegmentStartEvent(t, this.firstFrame, this.totalFrames)), t === "destroy" && this.onDestroy && this.onDestroy.call(this, new BMDestroyEvent(t, this));
    }, AnimationItem.prototype.triggerRenderFrameError = function(t) {
      var r = new BMRenderFrameErrorEvent(t, this.currentFrame);
      this.triggerEvent("error", r), this.onError && this.onError.call(this, r);
    }, AnimationItem.prototype.triggerConfigError = function(t) {
      var r = new BMConfigErrorEvent(t, this.currentFrame);
      this.triggerEvent("error", r), this.onError && this.onError.call(this, r);
    };
    var animationManager = (function() {
      var t = {}, r = [], n = 0, a = 0, s = 0, o = !0, l = !1;
      function x(U) {
        for (var G = 0, K = U.target; G < a; ) r[G].animation === K && (r.splice(G, 1), G -= 1, a -= 1, K.isPaused || V()), G += 1;
      }
      function j(U, G) {
        if (!U) return null;
        for (var K = 0; K < a; ) {
          if (r[K].elem === U && r[K].elem !== null) return r[K].animation;
          K += 1;
        }
        var J = new AnimationItem();
        return $(J, U), J.setData(U, G), J;
      }
      function Z() {
        s += 1, Y();
      }
      function V() {
        s -= 1;
      }
      function $(U, G) {
        U.addEventListener("destroy", x), U.addEventListener("_active", Z), U.addEventListener("_idle", V), r.push({ elem: G, animation: U }), a += 1;
      }
      function X(U) {
        var G, K = U - n;
        for (G = 0; G < a; G += 1) r[G].animation.advanceTime(K);
        n = U, s && !l ? window.requestAnimationFrame(X) : o = !0;
      }
      function W(U) {
        n = U, window.requestAnimationFrame(X);
      }
      function Y() {
        !l && s && o && (window.requestAnimationFrame(W), o = !1);
      }
      return t.registerAnimation = j, t.loadAnimation = function(U) {
        var G = new AnimationItem();
        return $(G, null), G.setParams(U), G;
      }, t.setSpeed = function(U, G) {
        var K;
        for (K = 0; K < a; K += 1) r[K].animation.setSpeed(U, G);
      }, t.setDirection = function(U, G) {
        var K;
        for (K = 0; K < a; K += 1) r[K].animation.setDirection(U, G);
      }, t.play = function(U) {
        var G;
        for (G = 0; G < a; G += 1) r[G].animation.play(U);
      }, t.pause = function(U) {
        var G;
        for (G = 0; G < a; G += 1) r[G].animation.pause(U);
      }, t.stop = function(U) {
        var G;
        for (G = 0; G < a; G += 1) r[G].animation.stop(U);
      }, t.togglePause = function(U) {
        var G;
        for (G = 0; G < a; G += 1) r[G].animation.togglePause(U);
      }, t.searchAnimations = function(U, G, K) {
        var J, ee = [].concat([].slice.call(document.getElementsByClassName("lottie")), [].slice.call(document.getElementsByClassName("bodymovin"))), te = ee.length;
        for (J = 0; J < te; J += 1) K && ee[J].setAttribute("data-bm-type", K), j(ee[J], U);
        if (G && te === 0) {
          K || (K = "svg");
          var re = document.getElementsByTagName("body")[0];
          re.innerText = "";
          var ae = createTag("div");
          ae.style.width = "100%", ae.style.height = "100%", ae.setAttribute("data-bm-type", K), re.appendChild(ae), j(ae, U);
        }
      }, t.resize = function() {
        var U;
        for (U = 0; U < a; U += 1) r[U].animation.resize();
      }, t.goToAndStop = function(U, G, K) {
        var J;
        for (J = 0; J < a; J += 1) r[J].animation.goToAndStop(U, G, K);
      }, t.destroy = function(U) {
        var G;
        for (G = a - 1; G >= 0; G -= 1) r[G].animation.destroy(U);
      }, t.freeze = function() {
        l = !0;
      }, t.unfreeze = function() {
        l = !1, Y();
      }, t.setVolume = function(U, G) {
        var K;
        for (K = 0; K < a; K += 1) r[K].animation.setVolume(U, G);
      }, t.mute = function(U) {
        var G;
        for (G = 0; G < a; G += 1) r[G].animation.mute(U);
      }, t.unmute = function(U) {
        var G;
        for (G = 0; G < a; G += 1) r[G].animation.unmute(U);
      }, t.getRegisteredAnimations = function() {
        var U, G = r.length, K = [];
        for (U = 0; U < G; U += 1) K.push(r[U].animation);
        return K;
      }, t;
    })(), BezierFactory = (function() {
      var t = { getBezierEasing: function(Z, V, $, X, W) {
        var Y = W || ("bez_" + Z + "_" + V + "_" + $ + "_" + X).replace(/\./g, "p");
        if (r[Y]) return r[Y];
        var U = new j([Z, V, $, X]);
        return r[Y] = U, U;
      } }, r = {}, n = typeof Float32Array == "function";
      function a(Z, V) {
        return 1 - 3 * V + 3 * Z;
      }
      function s(Z, V) {
        return 3 * V - 6 * Z;
      }
      function o(Z) {
        return 3 * Z;
      }
      function l(Z, V, $) {
        return ((a(V, $) * Z + s(V, $)) * Z + o(V)) * Z;
      }
      function x(Z, V, $) {
        return 3 * a(V, $) * Z * Z + 2 * s(V, $) * Z + o(V);
      }
      function j(Z) {
        this._p = Z, this._mSampleValues = n ? new Float32Array(11) : new Array(11), this._precomputed = !1, this.get = this.get.bind(this);
      }
      return j.prototype = { get: function(Z) {
        var V = this._p[0], $ = this._p[1], X = this._p[2], W = this._p[3];
        return this._precomputed || this._precompute(), V === $ && X === W ? Z : Z === 0 ? 0 : Z === 1 ? 1 : l(this._getTForX(Z), $, W);
      }, _precompute: function() {
        var Z = this._p[0], V = this._p[1], $ = this._p[2], X = this._p[3];
        this._precomputed = !0, Z === V && $ === X || this._calcSampleValues();
      }, _calcSampleValues: function() {
        for (var Z = this._p[0], V = this._p[2], $ = 0; $ < 11; ++$) this._mSampleValues[$] = l(0.1 * $, Z, V);
      }, _getTForX: function(Z) {
        for (var V = this._p[0], $ = this._p[2], X = this._mSampleValues, W = 0, Y = 1; Y !== 10 && X[Y] <= Z; ++Y) W += 0.1;
        var U = W + 0.1 * ((Z - X[--Y]) / (X[Y + 1] - X[Y])), G = x(U, V, $);
        return G >= 1e-3 ? (function(K, J, ee, te) {
          for (var re = 0; re < 4; ++re) {
            var ae = x(J, ee, te);
            if (ae === 0) return J;
            J -= (l(J, ee, te) - K) / ae;
          }
          return J;
        })(Z, U, V, $) : G === 0 ? U : (function(K, J, ee, te, re) {
          var ae, ie, ce = 0;
          do
            (ae = l(ie = J + (ee - J) / 2, te, re) - K) > 0 ? ee = ie : J = ie;
          while (Math.abs(ae) > 1e-7 && ++ce < 10);
          return ie;
        })(Z, W, W + 0.1, V, $);
      } }, t;
    })(), pooling = { double: function(t) {
      return t.concat(createSizedArray(t.length));
    } }, poolFactory = function(t, r, n) {
      var a = 0, s = t, o = createSizedArray(s);
      return { newElement: function() {
        return a ? o[a -= 1] : r();
      }, release: function(l) {
        a === s && (o = pooling.double(o), s *= 2), n && n(l), o[a] = l, a += 1;
      } };
    }, bezierLengthPool = poolFactory(8, (function() {
      return { addedLength: 0, percents: createTypedArray("float32", getDefaultCurveSegments()), lengths: createTypedArray("float32", getDefaultCurveSegments()) };
    })), segmentsLengthPool = poolFactory(8, (function() {
      return { lengths: [], totalLength: 0 };
    }), (function(t) {
      var r, n = t.lengths.length;
      for (r = 0; r < n; r += 1) bezierLengthPool.release(t.lengths[r]);
      t.lengths.length = 0;
    }));
    function bezFunction() {
      var t = Math;
      function r(Z, V, $, X, W, Y) {
        var U = Z * X + V * W + $ * Y - W * X - Y * Z - $ * V;
        return U > -1e-3 && U < 1e-3;
      }
      var n = function(Z, V, $, X) {
        var W, Y, U, G, K, J, ee = getDefaultCurveSegments(), te = 0, re = [], ae = [], ie = bezierLengthPool.newElement();
        for (U = $.length, W = 0; W < ee; W += 1) {
          for (K = W / (ee - 1), J = 0, Y = 0; Y < U; Y += 1) G = bmPow(1 - K, 3) * Z[Y] + 3 * bmPow(1 - K, 2) * K * $[Y] + 3 * (1 - K) * bmPow(K, 2) * X[Y] + bmPow(K, 3) * V[Y], re[Y] = G, ae[Y] !== null && (J += bmPow(re[Y] - ae[Y], 2)), ae[Y] = re[Y];
          J && (te += J = bmSqrt(J)), ie.percents[W] = K, ie.lengths[W] = te;
        }
        return ie.addedLength = te, ie;
      };
      function a(Z) {
        this.segmentLength = 0, this.points = new Array(Z);
      }
      function s(Z, V) {
        this.partialLength = Z, this.point = V;
      }
      var o, l = (o = {}, function(Z, V, $, X) {
        var W = (Z[0] + "_" + Z[1] + "_" + V[0] + "_" + V[1] + "_" + $[0] + "_" + $[1] + "_" + X[0] + "_" + X[1]).replace(/\./g, "p");
        if (!o[W]) {
          var Y, U, G, K, J, ee, te, re = getDefaultCurveSegments(), ae = 0, ie = null;
          Z.length === 2 && (Z[0] !== V[0] || Z[1] !== V[1]) && r(Z[0], Z[1], V[0], V[1], Z[0] + $[0], Z[1] + $[1]) && r(Z[0], Z[1], V[0], V[1], V[0] + X[0], V[1] + X[1]) && (re = 2);
          var ce = new a(re);
          for (G = $.length, Y = 0; Y < re; Y += 1) {
            for (te = createSizedArray(G), J = Y / (re - 1), ee = 0, U = 0; U < G; U += 1) K = bmPow(1 - J, 3) * Z[U] + 3 * bmPow(1 - J, 2) * J * (Z[U] + $[U]) + 3 * (1 - J) * bmPow(J, 2) * (V[U] + X[U]) + bmPow(J, 3) * V[U], te[U] = K, ie !== null && (ee += bmPow(te[U] - ie[U], 2));
            ae += ee = bmSqrt(ee), ce.points[Y] = new s(ee, te), ie = te;
          }
          ce.segmentLength = ae, o[W] = ce;
        }
        return o[W];
      });
      function x(Z, V) {
        var $ = V.percents, X = V.lengths, W = $.length, Y = bmFloor((W - 1) * Z), U = Z * V.addedLength, G = 0;
        if (Y === W - 1 || Y === 0 || U === X[Y]) return $[Y];
        for (var K = X[Y] > U ? -1 : 1, J = !0; J; ) if (X[Y] <= U && X[Y + 1] > U ? (G = (U - X[Y]) / (X[Y + 1] - X[Y]), J = !1) : Y += K, Y < 0 || Y >= W - 1) {
          if (Y === W - 1) return $[Y];
          J = !1;
        }
        return $[Y] + ($[Y + 1] - $[Y]) * G;
      }
      var j = createTypedArray("float32", 8);
      return { getSegmentsLength: function(Z) {
        var V, $ = segmentsLengthPool.newElement(), X = Z.c, W = Z.v, Y = Z.o, U = Z.i, G = Z._length, K = $.lengths, J = 0;
        for (V = 0; V < G - 1; V += 1) K[V] = n(W[V], W[V + 1], Y[V], U[V + 1]), J += K[V].addedLength;
        return X && G && (K[V] = n(W[V], W[0], Y[V], U[0]), J += K[V].addedLength), $.totalLength = J, $;
      }, getNewSegment: function(Z, V, $, X, W, Y, U) {
        W < 0 ? W = 0 : W > 1 && (W = 1);
        var G, K = x(W, U), J = x(Y = Y > 1 ? 1 : Y, U), ee = Z.length, te = 1 - K, re = 1 - J, ae = te * te * te, ie = K * te * te * 3, ce = K * K * te * 3, he = K * K * K, oe = te * te * re, le = K * te * re + te * K * re + te * te * J, pe = K * K * re + te * K * J + K * te * J, de = K * K * J, se = te * re * re, ue = K * re * re + te * J * re + te * re * J, fe = K * J * re + te * J * J + K * re * J, ge = K * J * J, ne = re * re * re, ve = J * re * re + re * J * re + re * re * J, me = J * J * re + re * J * J + J * re * J, xe = J * J * J;
        for (G = 0; G < ee; G += 1) j[4 * G] = t.round(1e3 * (ae * Z[G] + ie * $[G] + ce * X[G] + he * V[G])) / 1e3, j[4 * G + 1] = t.round(1e3 * (oe * Z[G] + le * $[G] + pe * X[G] + de * V[G])) / 1e3, j[4 * G + 2] = t.round(1e3 * (se * Z[G] + ue * $[G] + fe * X[G] + ge * V[G])) / 1e3, j[4 * G + 3] = t.round(1e3 * (ne * Z[G] + ve * $[G] + me * X[G] + xe * V[G])) / 1e3;
        return j;
      }, getPointInSegment: function(Z, V, $, X, W, Y) {
        var U = x(W, Y), G = 1 - U;
        return [t.round(1e3 * (G * G * G * Z[0] + (U * G * G + G * U * G + G * G * U) * $[0] + (U * U * G + G * U * U + U * G * U) * X[0] + U * U * U * V[0])) / 1e3, t.round(1e3 * (G * G * G * Z[1] + (U * G * G + G * U * G + G * G * U) * $[1] + (U * U * G + G * U * U + U * G * U) * X[1] + U * U * U * V[1])) / 1e3];
      }, buildBezierData: l, pointOnLine2D: r, pointOnLine3D: function(Z, V, $, X, W, Y, U, G, K) {
        if ($ === 0 && Y === 0 && K === 0) return r(Z, V, X, W, U, G);
        var J, ee = t.sqrt(t.pow(X - Z, 2) + t.pow(W - V, 2) + t.pow(Y - $, 2)), te = t.sqrt(t.pow(U - Z, 2) + t.pow(G - V, 2) + t.pow(K - $, 2)), re = t.sqrt(t.pow(U - X, 2) + t.pow(G - W, 2) + t.pow(K - Y, 2));
        return (J = ee > te ? ee > re ? ee - te - re : re - te - ee : re > te ? re - te - ee : te - ee - re) > -1e-4 && J < 1e-4;
      } };
    }
    var bez = bezFunction(), initFrame = initialDefaultFrame, mathAbs = Math.abs;
    function interpolateValue(t, r) {
      var n, a = this.offsetTime;
      this.propType === "multidimensional" && (n = createTypedArray("float32", this.pv.length));
      for (var s, o, l, x, j, Z, V, $, X, W = r.lastIndex, Y = W, U = this.keyframes.length - 1, G = !0; G; ) {
        if (s = this.keyframes[Y], o = this.keyframes[Y + 1], Y === U - 1 && t >= o.t - a) {
          s.h && (s = o), W = 0;
          break;
        }
        if (o.t - a > t) {
          W = Y;
          break;
        }
        Y < U - 1 ? Y += 1 : (W = 0, G = !1);
      }
      l = this.keyframesMetadata[Y] || {};
      var K, J = o.t - a, ee = s.t - a;
      if (s.to) {
        l.bezierData || (l.bezierData = bez.buildBezierData(s.s, o.s || s.e, s.to, s.ti));
        var te = l.bezierData;
        if (t >= J || t < ee) {
          var re = t >= J ? te.points.length - 1 : 0;
          for (j = te.points[re].point.length, x = 0; x < j; x += 1) n[x] = te.points[re].point[x];
        } else {
          l.__fnct ? X = l.__fnct : (X = BezierFactory.getBezierEasing(s.o.x, s.o.y, s.i.x, s.i.y, s.n).get, l.__fnct = X), Z = X((t - ee) / (J - ee));
          var ae, ie = te.segmentLength * Z, ce = r.lastFrame < t && r._lastKeyframeIndex === Y ? r._lastAddedLength : 0;
          for ($ = r.lastFrame < t && r._lastKeyframeIndex === Y ? r._lastPoint : 0, G = !0, V = te.points.length; G; ) {
            if (ce += te.points[$].partialLength, ie === 0 || Z === 0 || $ === te.points.length - 1) {
              for (j = te.points[$].point.length, x = 0; x < j; x += 1) n[x] = te.points[$].point[x];
              break;
            }
            if (ie >= ce && ie < ce + te.points[$ + 1].partialLength) {
              for (ae = (ie - ce) / te.points[$ + 1].partialLength, j = te.points[$].point.length, x = 0; x < j; x += 1) n[x] = te.points[$].point[x] + (te.points[$ + 1].point[x] - te.points[$].point[x]) * ae;
              break;
            }
            $ < V - 1 ? $ += 1 : G = !1;
          }
          r._lastPoint = $, r._lastAddedLength = ce - te.points[$].partialLength, r._lastKeyframeIndex = Y;
        }
      } else {
        var he, oe, le, pe, de;
        if (U = s.s.length, K = o.s || s.e, this.sh && s.h !== 1) t >= J ? (n[0] = K[0], n[1] = K[1], n[2] = K[2]) : t <= ee ? (n[0] = s.s[0], n[1] = s.s[1], n[2] = s.s[2]) : quaternionToEuler(n, slerp(createQuaternion(s.s), createQuaternion(K), (t - ee) / (J - ee)));
        else for (Y = 0; Y < U; Y += 1) s.h !== 1 && (t >= J ? Z = 1 : t < ee ? Z = 0 : (s.o.x.constructor === Array ? (l.__fnct || (l.__fnct = []), l.__fnct[Y] ? X = l.__fnct[Y] : (he = s.o.x[Y] === void 0 ? s.o.x[0] : s.o.x[Y], oe = s.o.y[Y] === void 0 ? s.o.y[0] : s.o.y[Y], le = s.i.x[Y] === void 0 ? s.i.x[0] : s.i.x[Y], pe = s.i.y[Y] === void 0 ? s.i.y[0] : s.i.y[Y], X = BezierFactory.getBezierEasing(he, oe, le, pe).get, l.__fnct[Y] = X)) : l.__fnct ? X = l.__fnct : (he = s.o.x, oe = s.o.y, le = s.i.x, pe = s.i.y, X = BezierFactory.getBezierEasing(he, oe, le, pe).get, s.keyframeMetadata = X), Z = X((t - ee) / (J - ee)))), K = o.s || s.e, de = s.h === 1 ? s.s[Y] : s.s[Y] + (K[Y] - s.s[Y]) * Z, this.propType === "multidimensional" ? n[Y] = de : n = de;
      }
      return r.lastIndex = W, n;
    }
    function slerp(t, r, n) {
      var a, s, o, l, x, j = [], Z = t[0], V = t[1], $ = t[2], X = t[3], W = r[0], Y = r[1], U = r[2], G = r[3];
      return (s = Z * W + V * Y + $ * U + X * G) < 0 && (s = -s, W = -W, Y = -Y, U = -U, G = -G), 1 - s > 1e-6 ? (a = Math.acos(s), o = Math.sin(a), l = Math.sin((1 - n) * a) / o, x = Math.sin(n * a) / o) : (l = 1 - n, x = n), j[0] = l * Z + x * W, j[1] = l * V + x * Y, j[2] = l * $ + x * U, j[3] = l * X + x * G, j;
    }
    function quaternionToEuler(t, r) {
      var n = r[0], a = r[1], s = r[2], o = r[3], l = Math.atan2(2 * a * o - 2 * n * s, 1 - 2 * a * a - 2 * s * s), x = Math.asin(2 * n * a + 2 * s * o), j = Math.atan2(2 * n * o - 2 * a * s, 1 - 2 * n * n - 2 * s * s);
      t[0] = l / degToRads, t[1] = x / degToRads, t[2] = j / degToRads;
    }
    function createQuaternion(t) {
      var r = t[0] * degToRads, n = t[1] * degToRads, a = t[2] * degToRads, s = Math.cos(r / 2), o = Math.cos(n / 2), l = Math.cos(a / 2), x = Math.sin(r / 2), j = Math.sin(n / 2), Z = Math.sin(a / 2);
      return [x * j * l + s * o * Z, x * o * l + s * j * Z, s * j * l - x * o * Z, s * o * l - x * j * Z];
    }
    function getValueAtCurrentTime() {
      var t = this.comp.renderedFrame - this.offsetTime, r = this.keyframes[0].t - this.offsetTime, n = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
      if (!(t === this._caching.lastFrame || this._caching.lastFrame !== initFrame && (this._caching.lastFrame >= n && t >= n || this._caching.lastFrame < r && t < r))) {
        this._caching.lastFrame >= t && (this._caching._lastKeyframeIndex = -1, this._caching.lastIndex = 0);
        var a = this.interpolateValue(t, this._caching);
        this.pv = a;
      }
      return this._caching.lastFrame = t, this.pv;
    }
    function setVValue(t) {
      var r;
      if (this.propType === "unidimensional") r = t * this.mult, mathAbs(this.v - r) > 1e-5 && (this.v = r, this._mdf = !0);
      else for (var n = 0, a = this.v.length; n < a; ) r = t[n] * this.mult, mathAbs(this.v[n] - r) > 1e-5 && (this.v[n] = r, this._mdf = !0), n += 1;
    }
    function processEffectsSequence() {
      if (this.elem.globalData.frameId !== this.frameId && this.effectsSequence.length) if (this.lock) this.setVValue(this.pv);
      else {
        var t;
        this.lock = !0, this._mdf = this._isFirstFrame;
        var r = this.effectsSequence.length, n = this.kf ? this.pv : this.data.k;
        for (t = 0; t < r; t += 1) n = this.effectsSequence[t](n);
        this.setVValue(n), this._isFirstFrame = !1, this.lock = !1, this.frameId = this.elem.globalData.frameId;
      }
    }
    function addEffect(t) {
      this.effectsSequence.push(t), this.container.addDynamicProperty(this);
    }
    function ValueProperty(t, r, n, a) {
      this.propType = "unidimensional", this.mult = n || 1, this.data = r, this.v = n ? r.k * n : r.k, this.pv = r.k, this._mdf = !1, this.elem = t, this.container = a, this.comp = t.comp, this.k = !1, this.kf = !1, this.vel = 0, this.effectsSequence = [], this._isFirstFrame = !0, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.addEffect = addEffect;
    }
    function MultiDimensionalProperty(t, r, n, a) {
      var s;
      this.propType = "multidimensional", this.mult = n || 1, this.data = r, this._mdf = !1, this.elem = t, this.container = a, this.comp = t.comp, this.k = !1, this.kf = !1, this.frameId = -1;
      var o = r.k.length;
      for (this.v = createTypedArray("float32", o), this.pv = createTypedArray("float32", o), this.vel = createTypedArray("float32", o), s = 0; s < o; s += 1) this.v[s] = r.k[s] * this.mult, this.pv[s] = r.k[s];
      this._isFirstFrame = !0, this.effectsSequence = [], this.getValue = processEffectsSequence, this.setVValue = setVValue, this.addEffect = addEffect;
    }
    function KeyframedValueProperty(t, r, n, a) {
      this.propType = "unidimensional", this.keyframes = r.k, this.keyframesMetadata = [], this.offsetTime = t.data.st, this.frameId = -1, this._caching = { lastFrame: initFrame, lastIndex: 0, value: 0, _lastKeyframeIndex: -1 }, this.k = !0, this.kf = !0, this.data = r, this.mult = n || 1, this.elem = t, this.container = a, this.comp = t.comp, this.v = initFrame, this.pv = initFrame, this._isFirstFrame = !0, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.interpolateValue = interpolateValue, this.effectsSequence = [getValueAtCurrentTime.bind(this)], this.addEffect = addEffect;
    }
    function KeyframedMultidimensionalProperty(t, r, n, a) {
      var s;
      this.propType = "multidimensional";
      var o, l, x, j, Z = r.k.length;
      for (s = 0; s < Z - 1; s += 1) r.k[s].to && r.k[s].s && r.k[s + 1] && r.k[s + 1].s && (o = r.k[s].s, l = r.k[s + 1].s, x = r.k[s].to, j = r.k[s].ti, (o.length === 2 && (o[0] !== l[0] || o[1] !== l[1]) && bez.pointOnLine2D(o[0], o[1], l[0], l[1], o[0] + x[0], o[1] + x[1]) && bez.pointOnLine2D(o[0], o[1], l[0], l[1], l[0] + j[0], l[1] + j[1]) || o.length === 3 && (o[0] !== l[0] || o[1] !== l[1] || o[2] !== l[2]) && bez.pointOnLine3D(o[0], o[1], o[2], l[0], l[1], l[2], o[0] + x[0], o[1] + x[1], o[2] + x[2]) && bez.pointOnLine3D(o[0], o[1], o[2], l[0], l[1], l[2], l[0] + j[0], l[1] + j[1], l[2] + j[2])) && (r.k[s].to = null, r.k[s].ti = null), o[0] === l[0] && o[1] === l[1] && x[0] === 0 && x[1] === 0 && j[0] === 0 && j[1] === 0 && (o.length === 2 || o[2] === l[2] && x[2] === 0 && j[2] === 0) && (r.k[s].to = null, r.k[s].ti = null));
      this.effectsSequence = [getValueAtCurrentTime.bind(this)], this.data = r, this.keyframes = r.k, this.keyframesMetadata = [], this.offsetTime = t.data.st, this.k = !0, this.kf = !0, this._isFirstFrame = !0, this.mult = n || 1, this.elem = t, this.container = a, this.comp = t.comp, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.interpolateValue = interpolateValue, this.frameId = -1;
      var V = r.k[0].s.length;
      for (this.v = createTypedArray("float32", V), this.pv = createTypedArray("float32", V), s = 0; s < V; s += 1) this.v[s] = initFrame, this.pv[s] = initFrame;
      this._caching = { lastFrame: initFrame, lastIndex: 0, value: createTypedArray("float32", V) }, this.addEffect = addEffect;
    }
    var PropertyFactory = { getProp: function(t, r, n, a, s) {
      var o;
      if (r.sid && (r = t.globalData.slotManager.getProp(r)), r.k.length) if (typeof r.k[0] == "number") o = new MultiDimensionalProperty(t, r, a, s);
      else switch (n) {
        case 0:
          o = new KeyframedValueProperty(t, r, a, s);
          break;
        case 1:
          o = new KeyframedMultidimensionalProperty(t, r, a, s);
      }
      else o = new ValueProperty(t, r, a, s);
      return o.effectsSequence.length && s.addDynamicProperty(o), o;
    } };
    function DynamicPropertyContainer() {
    }
    DynamicPropertyContainer.prototype = { addDynamicProperty: function(t) {
      this.dynamicProperties.indexOf(t) === -1 && (this.dynamicProperties.push(t), this.container.addDynamicProperty(this), this._isAnimated = !0);
    }, iterateDynamicProperties: function() {
      var t;
      this._mdf = !1;
      var r = this.dynamicProperties.length;
      for (t = 0; t < r; t += 1) this.dynamicProperties[t].getValue(), this.dynamicProperties[t]._mdf && (this._mdf = !0);
    }, initDynamicPropertyContainer: function(t) {
      this.container = t, this.dynamicProperties = [], this._mdf = !1, this._isAnimated = !1;
    } };
    var pointPool = poolFactory(8, (function() {
      return createTypedArray("float32", 2);
    }));
    function ShapePath() {
      this.c = !1, this._length = 0, this._maxLength = 8, this.v = createSizedArray(this._maxLength), this.o = createSizedArray(this._maxLength), this.i = createSizedArray(this._maxLength);
    }
    ShapePath.prototype.setPathData = function(t, r) {
      this.c = t, this.setLength(r);
      for (var n = 0; n < r; ) this.v[n] = pointPool.newElement(), this.o[n] = pointPool.newElement(), this.i[n] = pointPool.newElement(), n += 1;
    }, ShapePath.prototype.setLength = function(t) {
      for (; this._maxLength < t; ) this.doubleArrayLength();
      this._length = t;
    }, ShapePath.prototype.doubleArrayLength = function() {
      this.v = this.v.concat(createSizedArray(this._maxLength)), this.i = this.i.concat(createSizedArray(this._maxLength)), this.o = this.o.concat(createSizedArray(this._maxLength)), this._maxLength *= 2;
    }, ShapePath.prototype.setXYAt = function(t, r, n, a, s) {
      var o;
      switch (this._length = Math.max(this._length, a + 1), this._length >= this._maxLength && this.doubleArrayLength(), n) {
        case "v":
          o = this.v;
          break;
        case "i":
          o = this.i;
          break;
        case "o":
          o = this.o;
          break;
        default:
          o = [];
      }
      (!o[a] || o[a] && !s) && (o[a] = pointPool.newElement()), o[a][0] = t, o[a][1] = r;
    }, ShapePath.prototype.setTripleAt = function(t, r, n, a, s, o, l, x) {
      this.setXYAt(t, r, "v", l, x), this.setXYAt(n, a, "o", l, x), this.setXYAt(s, o, "i", l, x);
    }, ShapePath.prototype.reverse = function() {
      var t = new ShapePath();
      t.setPathData(this.c, this._length);
      var r = this.v, n = this.o, a = this.i, s = 0;
      this.c && (t.setTripleAt(r[0][0], r[0][1], a[0][0], a[0][1], n[0][0], n[0][1], 0, !1), s = 1);
      var o, l = this._length - 1, x = this._length;
      for (o = s; o < x; o += 1) t.setTripleAt(r[l][0], r[l][1], a[l][0], a[l][1], n[l][0], n[l][1], o, !1), l -= 1;
      return t;
    }, ShapePath.prototype.length = function() {
      return this._length;
    };
    var shapePool = (factory = poolFactory(4, (function() {
      return new ShapePath();
    }), (function(t) {
      var r, n = t._length;
      for (r = 0; r < n; r += 1) pointPool.release(t.v[r]), pointPool.release(t.i[r]), pointPool.release(t.o[r]), t.v[r] = null, t.i[r] = null, t.o[r] = null;
      t._length = 0, t.c = !1;
    })), factory.clone = function(t) {
      var r, n = factory.newElement(), a = t._length === void 0 ? t.v.length : t._length;
      for (n.setLength(a), n.c = t.c, r = 0; r < a; r += 1) n.setTripleAt(t.v[r][0], t.v[r][1], t.o[r][0], t.o[r][1], t.i[r][0], t.i[r][1], r);
      return n;
    }, factory), factory;
    function ShapeCollection() {
      this._length = 0, this._maxLength = 4, this.shapes = createSizedArray(this._maxLength);
    }
    ShapeCollection.prototype.addShape = function(t) {
      this._length === this._maxLength && (this.shapes = this.shapes.concat(createSizedArray(this._maxLength)), this._maxLength *= 2), this.shapes[this._length] = t, this._length += 1;
    }, ShapeCollection.prototype.releaseShapes = function() {
      var t;
      for (t = 0; t < this._length; t += 1) shapePool.release(this.shapes[t]);
      this._length = 0;
    };
    var shapeCollectionPool = (ob = { newShapeCollection: function() {
      return _length ? pool[_length -= 1] : new ShapeCollection();
    }, release: function(t) {
      var r, n = t._length;
      for (r = 0; r < n; r += 1) shapePool.release(t.shapes[r]);
      t._length = 0, _length === _maxLength && (pool = pooling.double(pool), _maxLength *= 2), pool[_length] = t, _length += 1;
    } }, _length = 0, _maxLength = 4, pool = createSizedArray(_maxLength), ob), ob, _length, _maxLength, pool, ShapePropertyFactory = (function() {
      function t(X, W, Y) {
        var U, G, K, J, ee, te, re, ae, ie, ce = Y.lastIndex, he = this.keyframes;
        if (X < he[0].t - this.offsetTime) U = he[0].s[0], K = !0, ce = 0;
        else if (X >= he[he.length - 1].t - this.offsetTime) U = he[he.length - 1].s ? he[he.length - 1].s[0] : he[he.length - 2].e[0], K = !0;
        else {
          for (var oe, le, pe, de = ce, se = he.length - 1, ue = !0; ue && (oe = he[de], !((le = he[de + 1]).t - this.offsetTime > X)); ) de < se - 1 ? de += 1 : ue = !1;
          if (pe = this.keyframesMetadata[de] || {}, ce = de, !(K = oe.h === 1)) {
            if (X >= le.t - this.offsetTime) ae = 1;
            else if (X < oe.t - this.offsetTime) ae = 0;
            else {
              var fe;
              pe.__fnct ? fe = pe.__fnct : (fe = BezierFactory.getBezierEasing(oe.o.x, oe.o.y, oe.i.x, oe.i.y).get, pe.__fnct = fe), ae = fe((X - (oe.t - this.offsetTime)) / (le.t - this.offsetTime - (oe.t - this.offsetTime)));
            }
            G = le.s ? le.s[0] : oe.e[0];
          }
          U = oe.s[0];
        }
        for (te = W._length, re = U.i[0].length, Y.lastIndex = ce, J = 0; J < te; J += 1) for (ee = 0; ee < re; ee += 1) ie = K ? U.i[J][ee] : U.i[J][ee] + (G.i[J][ee] - U.i[J][ee]) * ae, W.i[J][ee] = ie, ie = K ? U.o[J][ee] : U.o[J][ee] + (G.o[J][ee] - U.o[J][ee]) * ae, W.o[J][ee] = ie, ie = K ? U.v[J][ee] : U.v[J][ee] + (G.v[J][ee] - U.v[J][ee]) * ae, W.v[J][ee] = ie;
      }
      function r() {
        var X = this.comp.renderedFrame - this.offsetTime, W = this.keyframes[0].t - this.offsetTime, Y = this.keyframes[this.keyframes.length - 1].t - this.offsetTime, U = this._caching.lastFrame;
        return U !== -999999 && (U < W && X < W || U > Y && X > Y) || (this._caching.lastIndex = U < X ? this._caching.lastIndex : 0, this.interpolateShape(X, this.pv, this._caching)), this._caching.lastFrame = X, this.pv;
      }
      function n() {
        this.paths = this.localShapeCollection;
      }
      function a(X) {
        (function(W, Y) {
          if (W._length !== Y._length || W.c !== Y.c) return !1;
          var U, G = W._length;
          for (U = 0; U < G; U += 1) if (W.v[U][0] !== Y.v[U][0] || W.v[U][1] !== Y.v[U][1] || W.o[U][0] !== Y.o[U][0] || W.o[U][1] !== Y.o[U][1] || W.i[U][0] !== Y.i[U][0] || W.i[U][1] !== Y.i[U][1]) return !1;
          return !0;
        })(this.v, X) || (this.v = shapePool.clone(X), this.localShapeCollection.releaseShapes(), this.localShapeCollection.addShape(this.v), this._mdf = !0, this.paths = this.localShapeCollection);
      }
      function s() {
        if (this.elem.globalData.frameId !== this.frameId) if (this.effectsSequence.length) if (this.lock) this.setVValue(this.pv);
        else {
          var X, W;
          this.lock = !0, this._mdf = !1, X = this.kf ? this.pv : this.data.ks ? this.data.ks.k : this.data.pt.k;
          var Y = this.effectsSequence.length;
          for (W = 0; W < Y; W += 1) X = this.effectsSequence[W](X);
          this.setVValue(X), this.lock = !1, this.frameId = this.elem.globalData.frameId;
        }
        else this._mdf = !1;
      }
      function o(X, W, Y) {
        this.propType = "shape", this.comp = X.comp, this.container = X, this.elem = X, this.data = W, this.k = !1, this.kf = !1, this._mdf = !1;
        var U = Y === 3 ? W.pt.k : W.ks.k;
        this.v = shapePool.clone(U), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.reset = n, this.effectsSequence = [];
      }
      function l(X) {
        this.effectsSequence.push(X), this.container.addDynamicProperty(this);
      }
      function x(X, W, Y) {
        this.propType = "shape", this.comp = X.comp, this.elem = X, this.container = X, this.offsetTime = X.data.st, this.keyframes = Y === 3 ? W.pt.k : W.ks.k, this.keyframesMetadata = [], this.k = !0, this.kf = !0;
        var U = this.keyframes[0].s[0].i.length;
        this.v = shapePool.newElement(), this.v.setPathData(this.keyframes[0].s[0].c, U), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.lastFrame = -999999, this.reset = n, this._caching = { lastFrame: -999999, lastIndex: 0 }, this.effectsSequence = [r.bind(this)];
      }
      o.prototype.interpolateShape = t, o.prototype.getValue = s, o.prototype.setVValue = a, o.prototype.addEffect = l, x.prototype.getValue = s, x.prototype.interpolateShape = t, x.prototype.setVValue = a, x.prototype.addEffect = l;
      var j = (function() {
        var X = roundCorner;
        function W(Y, U) {
          this.v = shapePool.newElement(), this.v.setPathData(!0, 4), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.localShapeCollection.addShape(this.v), this.d = U.d, this.elem = Y, this.comp = Y.comp, this.frameId = -1, this.initDynamicPropertyContainer(Y), this.p = PropertyFactory.getProp(Y, U.p, 1, 0, this), this.s = PropertyFactory.getProp(Y, U.s, 1, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertEllToPath());
        }
        return W.prototype = { reset: n, getValue: function() {
          this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertEllToPath());
        }, convertEllToPath: function() {
          var Y = this.p.v[0], U = this.p.v[1], G = this.s.v[0] / 2, K = this.s.v[1] / 2, J = this.d !== 3, ee = this.v;
          ee.v[0][0] = Y, ee.v[0][1] = U - K, ee.v[1][0] = J ? Y + G : Y - G, ee.v[1][1] = U, ee.v[2][0] = Y, ee.v[2][1] = U + K, ee.v[3][0] = J ? Y - G : Y + G, ee.v[3][1] = U, ee.i[0][0] = J ? Y - G * X : Y + G * X, ee.i[0][1] = U - K, ee.i[1][0] = J ? Y + G : Y - G, ee.i[1][1] = U - K * X, ee.i[2][0] = J ? Y + G * X : Y - G * X, ee.i[2][1] = U + K, ee.i[3][0] = J ? Y - G : Y + G, ee.i[3][1] = U + K * X, ee.o[0][0] = J ? Y + G * X : Y - G * X, ee.o[0][1] = U - K, ee.o[1][0] = J ? Y + G : Y - G, ee.o[1][1] = U + K * X, ee.o[2][0] = J ? Y - G * X : Y + G * X, ee.o[2][1] = U + K, ee.o[3][0] = J ? Y - G : Y + G, ee.o[3][1] = U - K * X;
        } }, extendPrototype([DynamicPropertyContainer], W), W;
      })(), Z = (function() {
        function X(W, Y) {
          this.v = shapePool.newElement(), this.v.setPathData(!0, 0), this.elem = W, this.comp = W.comp, this.data = Y, this.frameId = -1, this.d = Y.d, this.initDynamicPropertyContainer(W), Y.sy === 1 ? (this.ir = PropertyFactory.getProp(W, Y.ir, 0, 0, this), this.is = PropertyFactory.getProp(W, Y.is, 0, 0.01, this), this.convertToPath = this.convertStarToPath) : this.convertToPath = this.convertPolygonToPath, this.pt = PropertyFactory.getProp(W, Y.pt, 0, 0, this), this.p = PropertyFactory.getProp(W, Y.p, 1, 0, this), this.r = PropertyFactory.getProp(W, Y.r, 0, degToRads, this), this.or = PropertyFactory.getProp(W, Y.or, 0, 0, this), this.os = PropertyFactory.getProp(W, Y.os, 0, 0.01, this), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertToPath());
        }
        return X.prototype = { reset: n, getValue: function() {
          this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertToPath());
        }, convertStarToPath: function() {
          var W, Y, U, G, K = 2 * Math.floor(this.pt.v), J = 2 * Math.PI / K, ee = !0, te = this.or.v, re = this.ir.v, ae = this.os.v, ie = this.is.v, ce = 2 * Math.PI * te / (2 * K), he = 2 * Math.PI * re / (2 * K), oe = -Math.PI / 2;
          oe += this.r.v;
          var le = this.data.d === 3 ? -1 : 1;
          for (this.v._length = 0, W = 0; W < K; W += 1) {
            U = ee ? ae : ie, G = ee ? ce : he;
            var pe = (Y = ee ? te : re) * Math.cos(oe), de = Y * Math.sin(oe), se = pe === 0 && de === 0 ? 0 : de / Math.sqrt(pe * pe + de * de), ue = pe === 0 && de === 0 ? 0 : -pe / Math.sqrt(pe * pe + de * de);
            pe += +this.p.v[0], de += +this.p.v[1], this.v.setTripleAt(pe, de, pe - se * G * U * le, de - ue * G * U * le, pe + se * G * U * le, de + ue * G * U * le, W, !0), ee = !ee, oe += J * le;
          }
        }, convertPolygonToPath: function() {
          var W, Y = Math.floor(this.pt.v), U = 2 * Math.PI / Y, G = this.or.v, K = this.os.v, J = 2 * Math.PI * G / (4 * Y), ee = 0.5 * -Math.PI, te = this.data.d === 3 ? -1 : 1;
          for (ee += this.r.v, this.v._length = 0, W = 0; W < Y; W += 1) {
            var re = G * Math.cos(ee), ae = G * Math.sin(ee), ie = re === 0 && ae === 0 ? 0 : ae / Math.sqrt(re * re + ae * ae), ce = re === 0 && ae === 0 ? 0 : -re / Math.sqrt(re * re + ae * ae);
            re += +this.p.v[0], ae += +this.p.v[1], this.v.setTripleAt(re, ae, re - ie * J * K * te, ae - ce * J * K * te, re + ie * J * K * te, ae + ce * J * K * te, W, !0), ee += U * te;
          }
          this.paths.length = 0, this.paths[0] = this.v;
        } }, extendPrototype([DynamicPropertyContainer], X), X;
      })(), V = (function() {
        function X(W, Y) {
          this.v = shapePool.newElement(), this.v.c = !0, this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.elem = W, this.comp = W.comp, this.frameId = -1, this.d = Y.d, this.initDynamicPropertyContainer(W), this.p = PropertyFactory.getProp(W, Y.p, 1, 0, this), this.s = PropertyFactory.getProp(W, Y.s, 1, 0, this), this.r = PropertyFactory.getProp(W, Y.r, 0, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertRectToPath());
        }
        return X.prototype = { convertRectToPath: function() {
          var W = this.p.v[0], Y = this.p.v[1], U = this.s.v[0] / 2, G = this.s.v[1] / 2, K = bmMin(U, G, this.r.v), J = K * (1 - roundCorner);
          this.v._length = 0, this.d === 2 || this.d === 1 ? (this.v.setTripleAt(W + U, Y - G + K, W + U, Y - G + K, W + U, Y - G + J, 0, !0), this.v.setTripleAt(W + U, Y + G - K, W + U, Y + G - J, W + U, Y + G - K, 1, !0), K !== 0 ? (this.v.setTripleAt(W + U - K, Y + G, W + U - K, Y + G, W + U - J, Y + G, 2, !0), this.v.setTripleAt(W - U + K, Y + G, W - U + J, Y + G, W - U + K, Y + G, 3, !0), this.v.setTripleAt(W - U, Y + G - K, W - U, Y + G - K, W - U, Y + G - J, 4, !0), this.v.setTripleAt(W - U, Y - G + K, W - U, Y - G + J, W - U, Y - G + K, 5, !0), this.v.setTripleAt(W - U + K, Y - G, W - U + K, Y - G, W - U + J, Y - G, 6, !0), this.v.setTripleAt(W + U - K, Y - G, W + U - J, Y - G, W + U - K, Y - G, 7, !0)) : (this.v.setTripleAt(W - U, Y + G, W - U + J, Y + G, W - U, Y + G, 2), this.v.setTripleAt(W - U, Y - G, W - U, Y - G + J, W - U, Y - G, 3))) : (this.v.setTripleAt(W + U, Y - G + K, W + U, Y - G + J, W + U, Y - G + K, 0, !0), K !== 0 ? (this.v.setTripleAt(W + U - K, Y - G, W + U - K, Y - G, W + U - J, Y - G, 1, !0), this.v.setTripleAt(W - U + K, Y - G, W - U + J, Y - G, W - U + K, Y - G, 2, !0), this.v.setTripleAt(W - U, Y - G + K, W - U, Y - G + K, W - U, Y - G + J, 3, !0), this.v.setTripleAt(W - U, Y + G - K, W - U, Y + G - J, W - U, Y + G - K, 4, !0), this.v.setTripleAt(W - U + K, Y + G, W - U + K, Y + G, W - U + J, Y + G, 5, !0), this.v.setTripleAt(W + U - K, Y + G, W + U - J, Y + G, W + U - K, Y + G, 6, !0), this.v.setTripleAt(W + U, Y + G - K, W + U, Y + G - K, W + U, Y + G - J, 7, !0)) : (this.v.setTripleAt(W - U, Y - G, W - U + J, Y - G, W - U, Y - G, 1, !0), this.v.setTripleAt(W - U, Y + G, W - U, Y + G - J, W - U, Y + G, 2, !0), this.v.setTripleAt(W + U, Y + G, W + U - J, Y + G, W + U, Y + G, 3, !0)));
        }, getValue: function() {
          this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertRectToPath());
        }, reset: n }, extendPrototype([DynamicPropertyContainer], X), X;
      })(), $ = { getShapeProp: function(X, W, Y) {
        var U;
        return Y === 3 || Y === 4 ? U = (Y === 3 ? W.pt : W.ks).k.length ? new x(X, W, Y) : new o(X, W, Y) : Y === 5 ? U = new V(X, W) : Y === 6 ? U = new j(X, W) : Y === 7 && (U = new Z(X, W)), U.k && X.addDynamicProperty(U), U;
      }, getConstructorFunction: function() {
        return o;
      }, getKeyframedConstructorFunction: function() {
        return x;
      } };
      return $;
    })(), Matrix = /* @__PURE__ */ (function() {
      var t = Math.cos, r = Math.sin, n = Math.tan, a = Math.round;
      function s() {
        return this.props[0] = 1, this.props[1] = 0, this.props[2] = 0, this.props[3] = 0, this.props[4] = 0, this.props[5] = 1, this.props[6] = 0, this.props[7] = 0, this.props[8] = 0, this.props[9] = 0, this.props[10] = 1, this.props[11] = 0, this.props[12] = 0, this.props[13] = 0, this.props[14] = 0, this.props[15] = 1, this;
      }
      function o(ne) {
        if (ne === 0) return this;
        var ve = t(ne), me = r(ne);
        return this._t(ve, -me, 0, 0, me, ve, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function l(ne) {
        if (ne === 0) return this;
        var ve = t(ne), me = r(ne);
        return this._t(1, 0, 0, 0, 0, ve, -me, 0, 0, me, ve, 0, 0, 0, 0, 1);
      }
      function x(ne) {
        if (ne === 0) return this;
        var ve = t(ne), me = r(ne);
        return this._t(ve, 0, me, 0, 0, 1, 0, 0, -me, 0, ve, 0, 0, 0, 0, 1);
      }
      function j(ne) {
        if (ne === 0) return this;
        var ve = t(ne), me = r(ne);
        return this._t(ve, -me, 0, 0, me, ve, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function Z(ne, ve) {
        return this._t(1, ve, ne, 1, 0, 0);
      }
      function V(ne, ve) {
        return this.shear(n(ne), n(ve));
      }
      function $(ne, ve) {
        var me = t(ve), xe = r(ve);
        return this._t(me, xe, 0, 0, -xe, me, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, n(ne), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(me, -xe, 0, 0, xe, me, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function X(ne, ve, me) {
        return me || me === 0 || (me = 1), ne === 1 && ve === 1 && me === 1 ? this : this._t(ne, 0, 0, 0, 0, ve, 0, 0, 0, 0, me, 0, 0, 0, 0, 1);
      }
      function W(ne, ve, me, xe, Ee, Se, _e, Ce, Te, we, Re, Ae, Pe, ke, ye, Me) {
        return this.props[0] = ne, this.props[1] = ve, this.props[2] = me, this.props[3] = xe, this.props[4] = Ee, this.props[5] = Se, this.props[6] = _e, this.props[7] = Ce, this.props[8] = Te, this.props[9] = we, this.props[10] = Re, this.props[11] = Ae, this.props[12] = Pe, this.props[13] = ke, this.props[14] = ye, this.props[15] = Me, this;
      }
      function Y(ne, ve, me) {
        return me = me || 0, ne !== 0 || ve !== 0 || me !== 0 ? this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, ne, ve, me, 1) : this;
      }
      function U(ne, ve, me, xe, Ee, Se, _e, Ce, Te, we, Re, Ae, Pe, ke, ye, Me) {
        var be = this.props;
        if (ne === 1 && ve === 0 && me === 0 && xe === 0 && Ee === 0 && Se === 1 && _e === 0 && Ce === 0 && Te === 0 && we === 0 && Re === 1 && Ae === 0) return be[12] = be[12] * ne + be[15] * Pe, be[13] = be[13] * Se + be[15] * ke, be[14] = be[14] * Re + be[15] * ye, be[15] *= Me, this._identityCalculated = !1, this;
        var De = be[0], Fe = be[1], Le = be[2], Ne = be[3], Ie = be[4], je = be[5], Ze = be[6], $e = be[7], We = be[8], Be = be[9], Ue = be[10], Qe = be[11], et = be[12], rt = be[13], ut = be[14], tt = be[15];
        return be[0] = De * ne + Fe * Ee + Le * Te + Ne * Pe, be[1] = De * ve + Fe * Se + Le * we + Ne * ke, be[2] = De * me + Fe * _e + Le * Re + Ne * ye, be[3] = De * xe + Fe * Ce + Le * Ae + Ne * Me, be[4] = Ie * ne + je * Ee + Ze * Te + $e * Pe, be[5] = Ie * ve + je * Se + Ze * we + $e * ke, be[6] = Ie * me + je * _e + Ze * Re + $e * ye, be[7] = Ie * xe + je * Ce + Ze * Ae + $e * Me, be[8] = We * ne + Be * Ee + Ue * Te + Qe * Pe, be[9] = We * ve + Be * Se + Ue * we + Qe * ke, be[10] = We * me + Be * _e + Ue * Re + Qe * ye, be[11] = We * xe + Be * Ce + Ue * Ae + Qe * Me, be[12] = et * ne + rt * Ee + ut * Te + tt * Pe, be[13] = et * ve + rt * Se + ut * we + tt * ke, be[14] = et * me + rt * _e + ut * Re + tt * ye, be[15] = et * xe + rt * Ce + ut * Ae + tt * Me, this._identityCalculated = !1, this;
      }
      function G(ne) {
        var ve = ne.props;
        return this.transform(ve[0], ve[1], ve[2], ve[3], ve[4], ve[5], ve[6], ve[7], ve[8], ve[9], ve[10], ve[11], ve[12], ve[13], ve[14], ve[15]);
      }
      function K() {
        return this._identityCalculated || (this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1), this._identityCalculated = !0), this._identity;
      }
      function J(ne) {
        for (var ve = 0; ve < 16; ) {
          if (ne.props[ve] !== this.props[ve]) return !1;
          ve += 1;
        }
        return !0;
      }
      function ee(ne) {
        var ve;
        for (ve = 0; ve < 16; ve += 1) ne.props[ve] = this.props[ve];
        return ne;
      }
      function te(ne) {
        var ve;
        for (ve = 0; ve < 16; ve += 1) this.props[ve] = ne[ve];
      }
      function re(ne, ve, me) {
        return { x: ne * this.props[0] + ve * this.props[4] + me * this.props[8] + this.props[12], y: ne * this.props[1] + ve * this.props[5] + me * this.props[9] + this.props[13], z: ne * this.props[2] + ve * this.props[6] + me * this.props[10] + this.props[14] };
      }
      function ae(ne, ve, me) {
        return ne * this.props[0] + ve * this.props[4] + me * this.props[8] + this.props[12];
      }
      function ie(ne, ve, me) {
        return ne * this.props[1] + ve * this.props[5] + me * this.props[9] + this.props[13];
      }
      function ce(ne, ve, me) {
        return ne * this.props[2] + ve * this.props[6] + me * this.props[10] + this.props[14];
      }
      function he() {
        var ne = this.props[0] * this.props[5] - this.props[1] * this.props[4], ve = this.props[5] / ne, me = -this.props[1] / ne, xe = -this.props[4] / ne, Ee = this.props[0] / ne, Se = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / ne, _e = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / ne, Ce = new Matrix();
        return Ce.props[0] = ve, Ce.props[1] = me, Ce.props[4] = xe, Ce.props[5] = Ee, Ce.props[12] = Se, Ce.props[13] = _e, Ce;
      }
      function oe(ne) {
        return this.getInverseMatrix().applyToPointArray(ne[0], ne[1], ne[2] || 0);
      }
      function le(ne) {
        var ve, me = ne.length, xe = [];
        for (ve = 0; ve < me; ve += 1) xe[ve] = oe(ne[ve]);
        return xe;
      }
      function pe(ne, ve, me) {
        var xe = createTypedArray("float32", 6);
        if (this.isIdentity()) xe[0] = ne[0], xe[1] = ne[1], xe[2] = ve[0], xe[3] = ve[1], xe[4] = me[0], xe[5] = me[1];
        else {
          var Ee = this.props[0], Se = this.props[1], _e = this.props[4], Ce = this.props[5], Te = this.props[12], we = this.props[13];
          xe[0] = ne[0] * Ee + ne[1] * _e + Te, xe[1] = ne[0] * Se + ne[1] * Ce + we, xe[2] = ve[0] * Ee + ve[1] * _e + Te, xe[3] = ve[0] * Se + ve[1] * Ce + we, xe[4] = me[0] * Ee + me[1] * _e + Te, xe[5] = me[0] * Se + me[1] * Ce + we;
        }
        return xe;
      }
      function de(ne, ve, me) {
        return this.isIdentity() ? [ne, ve, me] : [ne * this.props[0] + ve * this.props[4] + me * this.props[8] + this.props[12], ne * this.props[1] + ve * this.props[5] + me * this.props[9] + this.props[13], ne * this.props[2] + ve * this.props[6] + me * this.props[10] + this.props[14]];
      }
      function se(ne, ve) {
        if (this.isIdentity()) return ne + "," + ve;
        var me = this.props;
        return Math.round(100 * (ne * me[0] + ve * me[4] + me[12])) / 100 + "," + Math.round(100 * (ne * me[1] + ve * me[5] + me[13])) / 100;
      }
      function ue() {
        for (var ne = 0, ve = this.props, me = "matrix3d("; ne < 16; ) me += a(1e4 * ve[ne]) / 1e4, me += ne === 15 ? ")" : ",", ne += 1;
        return me;
      }
      function fe(ne) {
        return ne < 1e-6 && ne > 0 || ne > -1e-6 && ne < 0 ? a(1e4 * ne) / 1e4 : ne;
      }
      function ge() {
        var ne = this.props;
        return "matrix(" + fe(ne[0]) + "," + fe(ne[1]) + "," + fe(ne[4]) + "," + fe(ne[5]) + "," + fe(ne[12]) + "," + fe(ne[13]) + ")";
      }
      return function() {
        this.reset = s, this.rotate = o, this.rotateX = l, this.rotateY = x, this.rotateZ = j, this.skew = V, this.skewFromAxis = $, this.shear = Z, this.scale = X, this.setTransform = W, this.translate = Y, this.transform = U, this.multiply = G, this.applyToPoint = re, this.applyToX = ae, this.applyToY = ie, this.applyToZ = ce, this.applyToPointArray = de, this.applyToTriplePoints = pe, this.applyToPointStringified = se, this.toCSS = ue, this.to2dCSS = ge, this.clone = ee, this.cloneFromProps = te, this.equals = J, this.inversePoints = le, this.inversePoint = oe, this.getInverseMatrix = he, this._t = this.transform, this.isIdentity = K, this._identity = !0, this._identityCalculated = !1, this.props = createTypedArray("float32", 16), this.reset();
      };
    })();
    function _typeof$3(t) {
      return (_typeof$3 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
        return typeof r;
      } : function(r) {
        return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
      })(t);
    }
    var lottie = {};
    function setLocation(t) {
      setLocationHref(t);
    }
    function searchAnimations() {
      animationManager.searchAnimations();
    }
    function setSubframeRendering(t) {
      setSubframeEnabled(t);
    }
    function setPrefix(t) {
      setIdPrefix(t);
    }
    function loadAnimation(t) {
      return animationManager.loadAnimation(t);
    }
    function setQuality(t) {
      if (typeof t == "string") switch (t) {
        case "high":
          setDefaultCurveSegments(200);
          break;
        default:
        case "medium":
          setDefaultCurveSegments(50);
          break;
        case "low":
          setDefaultCurveSegments(10);
      }
      else !isNaN(t) && t > 1 && setDefaultCurveSegments(t);
    }
    function inBrowser() {
      return typeof navigator != "undefined";
    }
    function installPlugin(t, r) {
      t === "expressions" && setExpressionsPlugin(r);
    }
    function getFactory(t) {
      switch (t) {
        case "propertyFactory":
          return PropertyFactory;
        case "shapePropertyFactory":
          return ShapePropertyFactory;
        case "matrix":
          return Matrix;
        default:
          return null;
      }
    }
    function checkReady() {
      document.readyState === "complete" && (clearInterval(readyStateCheckInterval), searchAnimations());
    }
    function getQueryVariable(t) {
      for (var r = queryString.split("&"), n = 0; n < r.length; n += 1) {
        var a = r[n].split("=");
        if (decodeURIComponent(a[0]) == t) return decodeURIComponent(a[1]);
      }
      return null;
    }
    lottie.play = animationManager.play, lottie.pause = animationManager.pause, lottie.setLocationHref = setLocation, lottie.togglePause = animationManager.togglePause, lottie.setSpeed = animationManager.setSpeed, lottie.setDirection = animationManager.setDirection, lottie.stop = animationManager.stop, lottie.searchAnimations = searchAnimations, lottie.registerAnimation = animationManager.registerAnimation, lottie.loadAnimation = loadAnimation, lottie.setSubframeRendering = setSubframeRendering, lottie.resize = animationManager.resize, lottie.goToAndStop = animationManager.goToAndStop, lottie.destroy = animationManager.destroy, lottie.setQuality = setQuality, lottie.inBrowser = inBrowser, lottie.installPlugin = installPlugin, lottie.freeze = animationManager.freeze, lottie.unfreeze = animationManager.unfreeze, lottie.setVolume = animationManager.setVolume, lottie.mute = animationManager.mute, lottie.unmute = animationManager.unmute, lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations, lottie.useWebWorker = setWebWorker, lottie.setIDPrefix = setPrefix, lottie.__getFactory = getFactory, lottie.version = "5.12.2";
    var queryString = "";
    {
      var scripts = document.getElementsByTagName("script"), index = scripts.length - 1, myScript = scripts[index] || { src: "" };
      queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, "") : "", getQueryVariable("renderer");
    }
    var readyStateCheckInterval = setInterval(checkReady, 100);
    try {
      _typeof$3(exports) !== "object" && (window.bodymovin = lottie);
    } catch (t) {
    }
    var ShapeModifiers = (function() {
      var t = {}, r = {};
      return t.registerModifier = function(n, a) {
        r[n] || (r[n] = a);
      }, t.getModifier = function(n, a, s) {
        return new r[n](a, s);
      }, t;
    })();
    function ShapeModifier() {
    }
    function TrimModifier() {
    }
    function PuckerAndBloatModifier() {
    }
    ShapeModifier.prototype.initModifierProperties = function() {
    }, ShapeModifier.prototype.addShapeToModifier = function() {
    }, ShapeModifier.prototype.addShape = function(t) {
      if (!this.closed) {
        t.sh.container.addDynamicProperty(t.sh);
        var r = { shape: t.sh, data: t, localShapeCollection: shapeCollectionPool.newShapeCollection() };
        this.shapes.push(r), this.addShapeToModifier(r), this._isAnimated && t.setAsAnimated();
      }
    }, ShapeModifier.prototype.init = function(t, r) {
      this.shapes = [], this.elem = t, this.initDynamicPropertyContainer(t), this.initModifierProperties(t, r), this.frameId = initialDefaultFrame, this.closed = !1, this.k = !1, this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
    }, ShapeModifier.prototype.processKeys = function() {
      this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties());
    }, extendPrototype([DynamicPropertyContainer], ShapeModifier), extendPrototype([ShapeModifier], TrimModifier), TrimModifier.prototype.initModifierProperties = function(t, r) {
      this.s = PropertyFactory.getProp(t, r.s, 0, 0.01, this), this.e = PropertyFactory.getProp(t, r.e, 0, 0.01, this), this.o = PropertyFactory.getProp(t, r.o, 0, 0, this), this.sValue = 0, this.eValue = 0, this.getValue = this.processKeys, this.m = r.m, this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
    }, TrimModifier.prototype.addShapeToModifier = function(t) {
      t.pathsData = [];
    }, TrimModifier.prototype.calculateShapeEdges = function(t, r, n, a, s) {
      var o = [];
      r <= 1 ? o.push({ s: t, e: r }) : t >= 1 ? o.push({ s: t - 1, e: r - 1 }) : (o.push({ s: t, e: 1 }), o.push({ s: 0, e: r - 1 }));
      var l, x, j = [], Z = o.length;
      for (l = 0; l < Z; l += 1) {
        var V, $;
        (x = o[l]).e * s < a || x.s * s > a + n || (V = x.s * s <= a ? 0 : (x.s * s - a) / n, $ = x.e * s >= a + n ? 1 : (x.e * s - a) / n, j.push([V, $]));
      }
      return j.length || j.push([0, 0]), j;
    }, TrimModifier.prototype.releasePathsData = function(t) {
      var r, n = t.length;
      for (r = 0; r < n; r += 1) segmentsLengthPool.release(t[r]);
      return t.length = 0, t;
    }, TrimModifier.prototype.processShapes = function(t) {
      var r, n, a, s;
      if (this._mdf || t) {
        var o = this.o.v % 360 / 360;
        if (o < 0 && (o += 1), (r = this.s.v > 1 ? 1 + o : this.s.v < 0 ? 0 + o : this.s.v + o) > (n = this.e.v > 1 ? 1 + o : this.e.v < 0 ? 0 + o : this.e.v + o)) {
          var l = r;
          r = n, n = l;
        }
        r = 1e-4 * Math.round(1e4 * r), n = 1e-4 * Math.round(1e4 * n), this.sValue = r, this.eValue = n;
      } else r = this.sValue, n = this.eValue;
      var x, j, Z, V, $, X = this.shapes.length, W = 0;
      if (n === r) for (s = 0; s < X; s += 1) this.shapes[s].localShapeCollection.releaseShapes(), this.shapes[s].shape._mdf = !0, this.shapes[s].shape.paths = this.shapes[s].localShapeCollection, this._mdf && (this.shapes[s].pathsData.length = 0);
      else if (n === 1 && r === 0 || n === 0 && r === 1) {
        if (this._mdf) for (s = 0; s < X; s += 1) this.shapes[s].pathsData.length = 0, this.shapes[s].shape._mdf = !0;
      } else {
        var Y, U, G = [];
        for (s = 0; s < X; s += 1) if ((Y = this.shapes[s]).shape._mdf || this._mdf || t || this.m === 2) {
          if (j = (a = Y.shape.paths)._length, $ = 0, !Y.shape._mdf && Y.pathsData.length) $ = Y.totalShapeLength;
          else {
            for (Z = this.releasePathsData(Y.pathsData), x = 0; x < j; x += 1) V = bez.getSegmentsLength(a.shapes[x]), Z.push(V), $ += V.totalLength;
            Y.totalShapeLength = $, Y.pathsData = Z;
          }
          W += $, Y.shape._mdf = !0;
        } else Y.shape.paths = Y.localShapeCollection;
        var K, J = r, ee = n, te = 0;
        for (s = X - 1; s >= 0; s -= 1) if ((Y = this.shapes[s]).shape._mdf) {
          for ((U = Y.localShapeCollection).releaseShapes(), this.m === 2 && X > 1 ? (K = this.calculateShapeEdges(r, n, Y.totalShapeLength, te, W), te += Y.totalShapeLength) : K = [[J, ee]], j = K.length, x = 0; x < j; x += 1) {
            J = K[x][0], ee = K[x][1], G.length = 0, ee <= 1 ? G.push({ s: Y.totalShapeLength * J, e: Y.totalShapeLength * ee }) : J >= 1 ? G.push({ s: Y.totalShapeLength * (J - 1), e: Y.totalShapeLength * (ee - 1) }) : (G.push({ s: Y.totalShapeLength * J, e: Y.totalShapeLength }), G.push({ s: 0, e: Y.totalShapeLength * (ee - 1) }));
            var re = this.addShapes(Y, G[0]);
            if (G[0].s !== G[0].e) {
              if (G.length > 1) if (Y.shape.paths.shapes[Y.shape.paths._length - 1].c) {
                var ae = re.pop();
                this.addPaths(re, U), re = this.addShapes(Y, G[1], ae);
              } else this.addPaths(re, U), re = this.addShapes(Y, G[1]);
              this.addPaths(re, U);
            }
          }
          Y.shape.paths = U;
        }
      }
    }, TrimModifier.prototype.addPaths = function(t, r) {
      var n, a = t.length;
      for (n = 0; n < a; n += 1) r.addShape(t[n]);
    }, TrimModifier.prototype.addSegment = function(t, r, n, a, s, o, l) {
      s.setXYAt(r[0], r[1], "o", o), s.setXYAt(n[0], n[1], "i", o + 1), l && s.setXYAt(t[0], t[1], "v", o), s.setXYAt(a[0], a[1], "v", o + 1);
    }, TrimModifier.prototype.addSegmentFromArray = function(t, r, n, a) {
      r.setXYAt(t[1], t[5], "o", n), r.setXYAt(t[2], t[6], "i", n + 1), a && r.setXYAt(t[0], t[4], "v", n), r.setXYAt(t[3], t[7], "v", n + 1);
    }, TrimModifier.prototype.addShapes = function(t, r, n) {
      var a, s, o, l, x, j, Z, V, $ = t.pathsData, X = t.shape.paths.shapes, W = t.shape.paths._length, Y = 0, U = [], G = !0;
      for (n ? (x = n._length, V = n._length) : (n = shapePool.newElement(), x = 0, V = 0), U.push(n), a = 0; a < W; a += 1) {
        for (j = $[a].lengths, n.c = X[a].c, o = X[a].c ? j.length : j.length + 1, s = 1; s < o; s += 1) if (Y + (l = j[s - 1]).addedLength < r.s) Y += l.addedLength, n.c = !1;
        else {
          if (Y > r.e) {
            n.c = !1;
            break;
          }
          r.s <= Y && r.e >= Y + l.addedLength ? (this.addSegment(X[a].v[s - 1], X[a].o[s - 1], X[a].i[s], X[a].v[s], n, x, G), G = !1) : (Z = bez.getNewSegment(X[a].v[s - 1], X[a].v[s], X[a].o[s - 1], X[a].i[s], (r.s - Y) / l.addedLength, (r.e - Y) / l.addedLength, j[s - 1]), this.addSegmentFromArray(Z, n, x, G), G = !1, n.c = !1), Y += l.addedLength, x += 1;
        }
        if (X[a].c && j.length) {
          if (l = j[s - 1], Y <= r.e) {
            var K = j[s - 1].addedLength;
            r.s <= Y && r.e >= Y + K ? (this.addSegment(X[a].v[s - 1], X[a].o[s - 1], X[a].i[0], X[a].v[0], n, x, G), G = !1) : (Z = bez.getNewSegment(X[a].v[s - 1], X[a].v[0], X[a].o[s - 1], X[a].i[0], (r.s - Y) / K, (r.e - Y) / K, j[s - 1]), this.addSegmentFromArray(Z, n, x, G), G = !1, n.c = !1);
          } else n.c = !1;
          Y += l.addedLength, x += 1;
        }
        if (n._length && (n.setXYAt(n.v[V][0], n.v[V][1], "i", V), n.setXYAt(n.v[n._length - 1][0], n.v[n._length - 1][1], "o", n._length - 1)), Y > r.e) break;
        a < W - 1 && (n = shapePool.newElement(), G = !0, U.push(n), x = 0);
      }
      return U;
    }, extendPrototype([ShapeModifier], PuckerAndBloatModifier), PuckerAndBloatModifier.prototype.initModifierProperties = function(t, r) {
      this.getValue = this.processKeys, this.amount = PropertyFactory.getProp(t, r.a, 0, null, this), this._isAnimated = !!this.amount.effectsSequence.length;
    }, PuckerAndBloatModifier.prototype.processPath = function(t, r) {
      var n = r / 100, a = [0, 0], s = t._length, o = 0;
      for (o = 0; o < s; o += 1) a[0] += t.v[o][0], a[1] += t.v[o][1];
      a[0] /= s, a[1] /= s;
      var l, x, j, Z, V, $, X = shapePool.newElement();
      for (X.c = t.c, o = 0; o < s; o += 1) l = t.v[o][0] + (a[0] - t.v[o][0]) * n, x = t.v[o][1] + (a[1] - t.v[o][1]) * n, j = t.o[o][0] + (a[0] - t.o[o][0]) * -n, Z = t.o[o][1] + (a[1] - t.o[o][1]) * -n, V = t.i[o][0] + (a[0] - t.i[o][0]) * -n, $ = t.i[o][1] + (a[1] - t.i[o][1]) * -n, X.setTripleAt(l, x, j, Z, V, $, o);
      return X;
    }, PuckerAndBloatModifier.prototype.processShapes = function(t) {
      var r, n, a, s, o, l, x = this.shapes.length, j = this.amount.v;
      if (j !== 0) for (n = 0; n < x; n += 1) {
        if (l = (o = this.shapes[n]).localShapeCollection, o.shape._mdf || this._mdf || t) for (l.releaseShapes(), o.shape._mdf = !0, r = o.shape.paths.shapes, s = o.shape.paths._length, a = 0; a < s; a += 1) l.addShape(this.processPath(r[a], j));
        o.shape.paths = o.localShapeCollection;
      }
      this.dynamicProperties.length || (this._mdf = !1);
    };
    var TransformPropertyFactory = (function() {
      var t = [0, 0];
      function r(n, a, s) {
        if (this.elem = n, this.frameId = -1, this.propType = "transform", this.data = a, this.v = new Matrix(), this.pre = new Matrix(), this.appliedTransformations = 0, this.initDynamicPropertyContainer(s || n), a.p && a.p.s ? (this.px = PropertyFactory.getProp(n, a.p.x, 0, 0, this), this.py = PropertyFactory.getProp(n, a.p.y, 0, 0, this), a.p.z && (this.pz = PropertyFactory.getProp(n, a.p.z, 0, 0, this))) : this.p = PropertyFactory.getProp(n, a.p || { k: [0, 0, 0] }, 1, 0, this), a.rx) {
          if (this.rx = PropertyFactory.getProp(n, a.rx, 0, degToRads, this), this.ry = PropertyFactory.getProp(n, a.ry, 0, degToRads, this), this.rz = PropertyFactory.getProp(n, a.rz, 0, degToRads, this), a.or.k[0].ti) {
            var o, l = a.or.k.length;
            for (o = 0; o < l; o += 1) a.or.k[o].to = null, a.or.k[o].ti = null;
          }
          this.or = PropertyFactory.getProp(n, a.or, 1, degToRads, this), this.or.sh = !0;
        } else this.r = PropertyFactory.getProp(n, a.r || { k: 0 }, 0, degToRads, this);
        a.sk && (this.sk = PropertyFactory.getProp(n, a.sk, 0, degToRads, this), this.sa = PropertyFactory.getProp(n, a.sa, 0, degToRads, this)), this.a = PropertyFactory.getProp(n, a.a || { k: [0, 0, 0] }, 1, 0, this), this.s = PropertyFactory.getProp(n, a.s || { k: [100, 100, 100] }, 1, 0.01, this), a.o ? this.o = PropertyFactory.getProp(n, a.o, 0, 0.01, n) : this.o = { _mdf: !1, v: 1 }, this._isDirty = !0, this.dynamicProperties.length || this.getValue(!0);
      }
      return r.prototype = { applyToMatrix: function(n) {
        var a = this._mdf;
        this.iterateDynamicProperties(), this._mdf = this._mdf || a, this.a && n.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.s && n.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && n.skewFromAxis(-this.sk.v, this.sa.v), this.r ? n.rotate(-this.r.v) : n.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.data.p.s ? this.data.p.z ? n.translate(this.px.v, this.py.v, -this.pz.v) : n.translate(this.px.v, this.py.v, 0) : n.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
      }, getValue: function(n) {
        if (this.elem.globalData.frameId !== this.frameId) {
          if (this._isDirty && (this.precalculateMatrix(), this._isDirty = !1), this.iterateDynamicProperties(), this._mdf || n) {
            var a;
            if (this.v.cloneFromProps(this.pre.props), this.appliedTransformations < 1 && this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations < 2 && this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && this.appliedTransformations < 3 && this.v.skewFromAxis(-this.sk.v, this.sa.v), this.r && this.appliedTransformations < 4 ? this.v.rotate(-this.r.v) : !this.r && this.appliedTransformations < 4 && this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.autoOriented) {
              var s, o;
              if (a = this.elem.globalData.frameRate, this.p && this.p.keyframes && this.p.getValueAtTime) this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t ? (s = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / a, 0), o = this.p.getValueAtTime(this.p.keyframes[0].t / a, 0)) : this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t ? (s = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / a, 0), o = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / a, 0)) : (s = this.p.pv, o = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - 0.01) / a, this.p.offsetTime));
              else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
                s = [], o = [];
                var l = this.px, x = this.py;
                l._caching.lastFrame + l.offsetTime <= l.keyframes[0].t ? (s[0] = l.getValueAtTime((l.keyframes[0].t + 0.01) / a, 0), s[1] = x.getValueAtTime((x.keyframes[0].t + 0.01) / a, 0), o[0] = l.getValueAtTime(l.keyframes[0].t / a, 0), o[1] = x.getValueAtTime(x.keyframes[0].t / a, 0)) : l._caching.lastFrame + l.offsetTime >= l.keyframes[l.keyframes.length - 1].t ? (s[0] = l.getValueAtTime(l.keyframes[l.keyframes.length - 1].t / a, 0), s[1] = x.getValueAtTime(x.keyframes[x.keyframes.length - 1].t / a, 0), o[0] = l.getValueAtTime((l.keyframes[l.keyframes.length - 1].t - 0.01) / a, 0), o[1] = x.getValueAtTime((x.keyframes[x.keyframes.length - 1].t - 0.01) / a, 0)) : (s = [l.pv, x.pv], o[0] = l.getValueAtTime((l._caching.lastFrame + l.offsetTime - 0.01) / a, l.offsetTime), o[1] = x.getValueAtTime((x._caching.lastFrame + x.offsetTime - 0.01) / a, x.offsetTime));
              } else s = o = t;
              this.v.rotate(-Math.atan2(s[1] - o[1], s[0] - o[0]));
            }
            this.data.p && this.data.p.s ? this.data.p.z ? this.v.translate(this.px.v, this.py.v, -this.pz.v) : this.v.translate(this.px.v, this.py.v, 0) : this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
          }
          this.frameId = this.elem.globalData.frameId;
        }
      }, precalculateMatrix: function() {
        if (this.appliedTransformations = 0, this.pre.reset(), !this.a.effectsSequence.length && (this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations = 1, !this.s.effectsSequence.length)) {
          if (this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.appliedTransformations = 2, this.sk) {
            if (this.sk.effectsSequence.length || this.sa.effectsSequence.length) return;
            this.pre.skewFromAxis(-this.sk.v, this.sa.v), this.appliedTransformations = 3;
          }
          this.r ? this.r.effectsSequence.length || (this.pre.rotate(-this.r.v), this.appliedTransformations = 4) : this.rz.effectsSequence.length || this.ry.effectsSequence.length || this.rx.effectsSequence.length || this.or.effectsSequence.length || (this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.appliedTransformations = 4);
        }
      }, autoOrient: function() {
      } }, extendPrototype([DynamicPropertyContainer], r), r.prototype.addDynamicProperty = function(n) {
        this._addDynamicProperty(n), this.elem.addDynamicProperty(n), this._isDirty = !0;
      }, r.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty, { getTransformProperty: function(n, a, s) {
        return new r(n, a, s);
      } };
    })();
    function RepeaterModifier() {
    }
    function RoundCornersModifier() {
    }
    function floatEqual(t, r) {
      return 1e5 * Math.abs(t - r) <= Math.min(Math.abs(t), Math.abs(r));
    }
    function floatZero(t) {
      return Math.abs(t) <= 1e-5;
    }
    function lerp(t, r, n) {
      return t * (1 - n) + r * n;
    }
    function lerpPoint(t, r, n) {
      return [lerp(t[0], r[0], n), lerp(t[1], r[1], n)];
    }
    function quadRoots(t, r, n) {
      if (t === 0) return [];
      var a = r * r - 4 * t * n;
      if (a < 0) return [];
      var s = -r / (2 * t);
      if (a === 0) return [s];
      var o = Math.sqrt(a) / (2 * t);
      return [s - o, s + o];
    }
    function polynomialCoefficients(t, r, n, a) {
      return [3 * r - t - 3 * n + a, 3 * t - 6 * r + 3 * n, -3 * t + 3 * r, t];
    }
    function singlePoint(t) {
      return new PolynomialBezier(t, t, t, t, !1);
    }
    function PolynomialBezier(t, r, n, a, s) {
      s && pointEqual(t, r) && (r = lerpPoint(t, a, 1 / 3)), s && pointEqual(n, a) && (n = lerpPoint(t, a, 2 / 3));
      var o = polynomialCoefficients(t[0], r[0], n[0], a[0]), l = polynomialCoefficients(t[1], r[1], n[1], a[1]);
      this.a = [o[0], l[0]], this.b = [o[1], l[1]], this.c = [o[2], l[2]], this.d = [o[3], l[3]], this.points = [t, r, n, a];
    }
    function extrema(t, r) {
      var n = t.points[0][r], a = t.points[t.points.length - 1][r];
      if (n > a) {
        var s = a;
        a = n, n = s;
      }
      for (var o = quadRoots(3 * t.a[r], 2 * t.b[r], t.c[r]), l = 0; l < o.length; l += 1) if (o[l] > 0 && o[l] < 1) {
        var x = t.point(o[l])[r];
        x < n ? n = x : x > a && (a = x);
      }
      return { min: n, max: a };
    }
    function intersectData(t, r, n) {
      var a = t.boundingBox();
      return { cx: a.cx, cy: a.cy, width: a.width, height: a.height, bez: t, t: (r + n) / 2, t1: r, t2: n };
    }
    function splitData(t) {
      var r = t.bez.split(0.5);
      return [intersectData(r[0], t.t1, t.t), intersectData(r[1], t.t, t.t2)];
    }
    function boxIntersect(t, r) {
      return 2 * Math.abs(t.cx - r.cx) < t.width + r.width && 2 * Math.abs(t.cy - r.cy) < t.height + r.height;
    }
    function intersectsImpl(t, r, n, a, s, o) {
      if (boxIntersect(t, r)) if (n >= o || t.width <= a && t.height <= a && r.width <= a && r.height <= a) s.push([t.t, r.t]);
      else {
        var l = splitData(t), x = splitData(r);
        intersectsImpl(l[0], x[0], n + 1, a, s, o), intersectsImpl(l[0], x[1], n + 1, a, s, o), intersectsImpl(l[1], x[0], n + 1, a, s, o), intersectsImpl(l[1], x[1], n + 1, a, s, o);
      }
    }
    function crossProduct(t, r) {
      return [t[1] * r[2] - t[2] * r[1], t[2] * r[0] - t[0] * r[2], t[0] * r[1] - t[1] * r[0]];
    }
    function lineIntersection(t, r, n, a) {
      var s = [t[0], t[1], 1], o = [r[0], r[1], 1], l = [n[0], n[1], 1], x = [a[0], a[1], 1], j = crossProduct(crossProduct(s, o), crossProduct(l, x));
      return floatZero(j[2]) ? null : [j[0] / j[2], j[1] / j[2]];
    }
    function polarOffset(t, r, n) {
      return [t[0] + Math.cos(r) * n, t[1] - Math.sin(r) * n];
    }
    function pointDistance(t, r) {
      return Math.hypot(t[0] - r[0], t[1] - r[1]);
    }
    function pointEqual(t, r) {
      return floatEqual(t[0], r[0]) && floatEqual(t[1], r[1]);
    }
    function ZigZagModifier() {
    }
    function setPoint(t, r, n, a, s, o, l) {
      var x = n - Math.PI / 2, j = n + Math.PI / 2, Z = r[0] + Math.cos(n) * a * s, V = r[1] - Math.sin(n) * a * s;
      t.setTripleAt(Z, V, Z + Math.cos(x) * o, V - Math.sin(x) * o, Z + Math.cos(j) * l, V - Math.sin(j) * l, t.length());
    }
    function getPerpendicularVector(t, r) {
      var n = [r[0] - t[0], r[1] - t[1]], a = 0.5 * -Math.PI;
      return [Math.cos(a) * n[0] - Math.sin(a) * n[1], Math.sin(a) * n[0] + Math.cos(a) * n[1]];
    }
    function getProjectingAngle(t, r) {
      var n = r === 0 ? t.length() - 1 : r - 1, a = (r + 1) % t.length(), s = getPerpendicularVector(t.v[n], t.v[a]);
      return Math.atan2(0, 1) - Math.atan2(s[1], s[0]);
    }
    function zigZagCorner(t, r, n, a, s, o, l) {
      var x = getProjectingAngle(r, n), j = r.v[n % r._length], Z = r.v[n === 0 ? r._length - 1 : n - 1], V = r.v[(n + 1) % r._length], $ = o === 2 ? Math.sqrt(Math.pow(j[0] - Z[0], 2) + Math.pow(j[1] - Z[1], 2)) : 0, X = o === 2 ? Math.sqrt(Math.pow(j[0] - V[0], 2) + Math.pow(j[1] - V[1], 2)) : 0;
      setPoint(t, r.v[n % r._length], x, l, a, X / (2 * (s + 1)), $ / (2 * (s + 1)));
    }
    function zigZagSegment(t, r, n, a, s, o) {
      for (var l = 0; l < a; l += 1) {
        var x = (l + 1) / (a + 1), j = s === 2 ? Math.sqrt(Math.pow(r.points[3][0] - r.points[0][0], 2) + Math.pow(r.points[3][1] - r.points[0][1], 2)) : 0, Z = r.normalAngle(x);
        setPoint(t, r.point(x), Z, o, n, j / (2 * (a + 1)), j / (2 * (a + 1))), o = -o;
      }
      return o;
    }
    function linearOffset(t, r, n) {
      var a = Math.atan2(r[0] - t[0], r[1] - t[1]);
      return [polarOffset(t, a, n), polarOffset(r, a, n)];
    }
    function offsetSegment(t, r) {
      var n, a, s, o, l, x, j;
      n = (j = linearOffset(t.points[0], t.points[1], r))[0], a = j[1], s = (j = linearOffset(t.points[1], t.points[2], r))[0], o = j[1], l = (j = linearOffset(t.points[2], t.points[3], r))[0], x = j[1];
      var Z = lineIntersection(n, a, s, o);
      Z === null && (Z = a);
      var V = lineIntersection(l, x, s, o);
      return V === null && (V = l), new PolynomialBezier(n, Z, V, x);
    }
    function joinLines(t, r, n, a, s) {
      var o = r.points[3], l = n.points[0];
      if (a === 3 || pointEqual(o, l)) return o;
      if (a === 2) {
        var x = -r.tangentAngle(1), j = -n.tangentAngle(0) + Math.PI, Z = lineIntersection(o, polarOffset(o, x + Math.PI / 2, 100), l, polarOffset(l, x + Math.PI / 2, 100)), V = Z ? pointDistance(Z, o) : pointDistance(o, l) / 2, $ = polarOffset(o, x, 2 * V * roundCorner);
        return t.setXYAt($[0], $[1], "o", t.length() - 1), $ = polarOffset(l, j, 2 * V * roundCorner), t.setTripleAt(l[0], l[1], l[0], l[1], $[0], $[1], t.length()), l;
      }
      var X = lineIntersection(pointEqual(o, r.points[2]) ? r.points[0] : r.points[2], o, l, pointEqual(l, n.points[1]) ? n.points[3] : n.points[1]);
      return X && pointDistance(X, o) < s ? (t.setTripleAt(X[0], X[1], X[0], X[1], X[0], X[1], t.length()), X) : o;
    }
    function getIntersection(t, r) {
      var n = t.intersections(r);
      return n.length && floatEqual(n[0][0], 1) && n.shift(), n.length ? n[0] : null;
    }
    function pruneSegmentIntersection(t, r) {
      var n = t.slice(), a = r.slice(), s = getIntersection(t[t.length - 1], r[0]);
      return s && (n[t.length - 1] = t[t.length - 1].split(s[0])[0], a[0] = r[0].split(s[1])[1]), t.length > 1 && r.length > 1 && (s = getIntersection(t[0], r[r.length - 1])) ? [[t[0].split(s[0])[0]], [r[r.length - 1].split(s[1])[1]]] : [n, a];
    }
    function pruneIntersections(t) {
      for (var r, n = 1; n < t.length; n += 1) r = pruneSegmentIntersection(t[n - 1], t[n]), t[n - 1] = r[0], t[n] = r[1];
      return t.length > 1 && (r = pruneSegmentIntersection(t[t.length - 1], t[0]), t[t.length - 1] = r[0], t[0] = r[1]), t;
    }
    function offsetSegmentSplit(t, r) {
      var n, a, s, o, l = t.inflectionPoints();
      if (l.length === 0) return [offsetSegment(t, r)];
      if (l.length === 1 || floatEqual(l[1], 1)) return n = (s = t.split(l[0]))[0], a = s[1], [offsetSegment(n, r), offsetSegment(a, r)];
      n = (s = t.split(l[0]))[0];
      var x = (l[1] - l[0]) / (1 - l[0]);
      return o = (s = s[1].split(x))[0], a = s[1], [offsetSegment(n, r), offsetSegment(o, r), offsetSegment(a, r)];
    }
    function OffsetPathModifier() {
    }
    function getFontProperties(t) {
      for (var r = t.fStyle ? t.fStyle.split(" ") : [], n = "normal", a = "normal", s = r.length, o = 0; o < s; o += 1) switch (r[o].toLowerCase()) {
        case "italic":
          a = "italic";
          break;
        case "bold":
          n = "700";
          break;
        case "black":
          n = "900";
          break;
        case "medium":
          n = "500";
          break;
        case "regular":
        case "normal":
          n = "400";
          break;
        case "light":
        case "thin":
          n = "200";
      }
      return { style: a, weight: t.fWeight || n };
    }
    extendPrototype([ShapeModifier], RepeaterModifier), RepeaterModifier.prototype.initModifierProperties = function(t, r) {
      this.getValue = this.processKeys, this.c = PropertyFactory.getProp(t, r.c, 0, null, this), this.o = PropertyFactory.getProp(t, r.o, 0, null, this), this.tr = TransformPropertyFactory.getTransformProperty(t, r.tr, this), this.so = PropertyFactory.getProp(t, r.tr.so, 0, 0.01, this), this.eo = PropertyFactory.getProp(t, r.tr.eo, 0, 0.01, this), this.data = r, this.dynamicProperties.length || this.getValue(!0), this._isAnimated = !!this.dynamicProperties.length, this.pMatrix = new Matrix(), this.rMatrix = new Matrix(), this.sMatrix = new Matrix(), this.tMatrix = new Matrix(), this.matrix = new Matrix();
    }, RepeaterModifier.prototype.applyTransforms = function(t, r, n, a, s, o) {
      var l = o ? -1 : 1, x = a.s.v[0] + (1 - a.s.v[0]) * (1 - s), j = a.s.v[1] + (1 - a.s.v[1]) * (1 - s);
      t.translate(a.p.v[0] * l * s, a.p.v[1] * l * s, a.p.v[2]), r.translate(-a.a.v[0], -a.a.v[1], a.a.v[2]), r.rotate(-a.r.v * l * s), r.translate(a.a.v[0], a.a.v[1], a.a.v[2]), n.translate(-a.a.v[0], -a.a.v[1], a.a.v[2]), n.scale(o ? 1 / x : x, o ? 1 / j : j), n.translate(a.a.v[0], a.a.v[1], a.a.v[2]);
    }, RepeaterModifier.prototype.init = function(t, r, n, a) {
      for (this.elem = t, this.arr = r, this.pos = n, this.elemsData = a, this._currentCopies = 0, this._elements = [], this._groups = [], this.frameId = -1, this.initDynamicPropertyContainer(t), this.initModifierProperties(t, r[n]); n > 0; ) n -= 1, this._elements.unshift(r[n]);
      this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
    }, RepeaterModifier.prototype.resetElements = function(t) {
      var r, n = t.length;
      for (r = 0; r < n; r += 1) t[r]._processed = !1, t[r].ty === "gr" && this.resetElements(t[r].it);
    }, RepeaterModifier.prototype.cloneElements = function(t) {
      var r = JSON.parse(JSON.stringify(t));
      return this.resetElements(r), r;
    }, RepeaterModifier.prototype.changeGroupRender = function(t, r) {
      var n, a = t.length;
      for (n = 0; n < a; n += 1) t[n]._render = r, t[n].ty === "gr" && this.changeGroupRender(t[n].it, r);
    }, RepeaterModifier.prototype.processShapes = function(t) {
      var r, n, a, s, o, l = !1;
      if (this._mdf || t) {
        var x, j = Math.ceil(this.c.v);
        if (this._groups.length < j) {
          for (; this._groups.length < j; ) {
            var Z = { it: this.cloneElements(this._elements), ty: "gr" };
            Z.it.push({ a: { a: 0, ix: 1, k: [0, 0] }, nm: "Transform", o: { a: 0, ix: 7, k: 100 }, p: { a: 0, ix: 2, k: [0, 0] }, r: { a: 1, ix: 6, k: [{ s: 0, e: 0, t: 0 }, { s: 0, e: 0, t: 1 }] }, s: { a: 0, ix: 3, k: [100, 100] }, sa: { a: 0, ix: 5, k: 0 }, sk: { a: 0, ix: 4, k: 0 }, ty: "tr" }), this.arr.splice(0, 0, Z), this._groups.splice(0, 0, Z), this._currentCopies += 1;
          }
          this.elem.reloadShapes(), l = !0;
        }
        for (o = 0, a = 0; a <= this._groups.length - 1; a += 1) {
          if (x = o < j, this._groups[a]._render = x, this.changeGroupRender(this._groups[a].it, x), !x) {
            var V = this.elemsData[a].it, $ = V[V.length - 1];
            $.transform.op.v !== 0 ? ($.transform.op._mdf = !0, $.transform.op.v = 0) : $.transform.op._mdf = !1;
          }
          o += 1;
        }
        this._currentCopies = j;
        var X = this.o.v, W = X % 1, Y = X > 0 ? Math.floor(X) : Math.ceil(X), U = this.pMatrix.props, G = this.rMatrix.props, K = this.sMatrix.props;
        this.pMatrix.reset(), this.rMatrix.reset(), this.sMatrix.reset(), this.tMatrix.reset(), this.matrix.reset();
        var J, ee, te = 0;
        if (X > 0) {
          for (; te < Y; ) this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), te += 1;
          W && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, W, !1), te += W);
        } else if (X < 0) {
          for (; te > Y; ) this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !0), te -= 1;
          W && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -W, !0), te -= W);
        }
        for (a = this.data.m === 1 ? 0 : this._currentCopies - 1, s = this.data.m === 1 ? 1 : -1, o = this._currentCopies; o; ) {
          if (ee = (n = (r = this.elemsData[a].it)[r.length - 1].transform.mProps.v.props).length, r[r.length - 1].transform.mProps._mdf = !0, r[r.length - 1].transform.op._mdf = !0, r[r.length - 1].transform.op.v = this._currentCopies === 1 ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (a / (this._currentCopies - 1)), te !== 0) {
            for ((a !== 0 && s === 1 || a !== this._currentCopies - 1 && s === -1) && this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), this.matrix.transform(G[0], G[1], G[2], G[3], G[4], G[5], G[6], G[7], G[8], G[9], G[10], G[11], G[12], G[13], G[14], G[15]), this.matrix.transform(K[0], K[1], K[2], K[3], K[4], K[5], K[6], K[7], K[8], K[9], K[10], K[11], K[12], K[13], K[14], K[15]), this.matrix.transform(U[0], U[1], U[2], U[3], U[4], U[5], U[6], U[7], U[8], U[9], U[10], U[11], U[12], U[13], U[14], U[15]), J = 0; J < ee; J += 1) n[J] = this.matrix.props[J];
            this.matrix.reset();
          } else for (this.matrix.reset(), J = 0; J < ee; J += 1) n[J] = this.matrix.props[J];
          te += 1, o -= 1, a += s;
        }
      } else for (o = this._currentCopies, a = 0, s = 1; o; ) n = (r = this.elemsData[a].it)[r.length - 1].transform.mProps.v.props, r[r.length - 1].transform.mProps._mdf = !1, r[r.length - 1].transform.op._mdf = !1, o -= 1, a += s;
      return l;
    }, RepeaterModifier.prototype.addShape = function() {
    }, extendPrototype([ShapeModifier], RoundCornersModifier), RoundCornersModifier.prototype.initModifierProperties = function(t, r) {
      this.getValue = this.processKeys, this.rd = PropertyFactory.getProp(t, r.r, 0, null, this), this._isAnimated = !!this.rd.effectsSequence.length;
    }, RoundCornersModifier.prototype.processPath = function(t, r) {
      var n, a = shapePool.newElement();
      a.c = t.c;
      var s, o, l, x, j, Z, V, $, X, W, Y, U, G = t._length, K = 0;
      for (n = 0; n < G; n += 1) s = t.v[n], l = t.o[n], o = t.i[n], s[0] === l[0] && s[1] === l[1] && s[0] === o[0] && s[1] === o[1] ? n !== 0 && n !== G - 1 || t.c ? (x = n === 0 ? t.v[G - 1] : t.v[n - 1], Z = (j = Math.sqrt(Math.pow(s[0] - x[0], 2) + Math.pow(s[1] - x[1], 2))) ? Math.min(j / 2, r) / j : 0, V = Y = s[0] + (x[0] - s[0]) * Z, $ = U = s[1] - (s[1] - x[1]) * Z, X = V - (V - s[0]) * roundCorner, W = $ - ($ - s[1]) * roundCorner, a.setTripleAt(V, $, X, W, Y, U, K), K += 1, x = n === G - 1 ? t.v[0] : t.v[n + 1], Z = (j = Math.sqrt(Math.pow(s[0] - x[0], 2) + Math.pow(s[1] - x[1], 2))) ? Math.min(j / 2, r) / j : 0, V = X = s[0] + (x[0] - s[0]) * Z, $ = W = s[1] + (x[1] - s[1]) * Z, Y = V - (V - s[0]) * roundCorner, U = $ - ($ - s[1]) * roundCorner, a.setTripleAt(V, $, X, W, Y, U, K), K += 1) : (a.setTripleAt(s[0], s[1], l[0], l[1], o[0], o[1], K), K += 1) : (a.setTripleAt(t.v[n][0], t.v[n][1], t.o[n][0], t.o[n][1], t.i[n][0], t.i[n][1], K), K += 1);
      return a;
    }, RoundCornersModifier.prototype.processShapes = function(t) {
      var r, n, a, s, o, l, x = this.shapes.length, j = this.rd.v;
      if (j !== 0) for (n = 0; n < x; n += 1) {
        if (l = (o = this.shapes[n]).localShapeCollection, o.shape._mdf || this._mdf || t) for (l.releaseShapes(), o.shape._mdf = !0, r = o.shape.paths.shapes, s = o.shape.paths._length, a = 0; a < s; a += 1) l.addShape(this.processPath(r[a], j));
        o.shape.paths = o.localShapeCollection;
      }
      this.dynamicProperties.length || (this._mdf = !1);
    }, PolynomialBezier.prototype.point = function(t) {
      return [((this.a[0] * t + this.b[0]) * t + this.c[0]) * t + this.d[0], ((this.a[1] * t + this.b[1]) * t + this.c[1]) * t + this.d[1]];
    }, PolynomialBezier.prototype.derivative = function(t) {
      return [(3 * t * this.a[0] + 2 * this.b[0]) * t + this.c[0], (3 * t * this.a[1] + 2 * this.b[1]) * t + this.c[1]];
    }, PolynomialBezier.prototype.tangentAngle = function(t) {
      var r = this.derivative(t);
      return Math.atan2(r[1], r[0]);
    }, PolynomialBezier.prototype.normalAngle = function(t) {
      var r = this.derivative(t);
      return Math.atan2(r[0], r[1]);
    }, PolynomialBezier.prototype.inflectionPoints = function() {
      var t = this.a[1] * this.b[0] - this.a[0] * this.b[1];
      if (floatZero(t)) return [];
      var r = -0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1]) / t, n = r * r - 1 / 3 * (this.b[1] * this.c[0] - this.b[0] * this.c[1]) / t;
      if (n < 0) return [];
      var a = Math.sqrt(n);
      return floatZero(a) ? a > 0 && a < 1 ? [r] : [] : [r - a, r + a].filter((function(s) {
        return s > 0 && s < 1;
      }));
    }, PolynomialBezier.prototype.split = function(t) {
      if (t <= 0) return [singlePoint(this.points[0]), this];
      if (t >= 1) return [this, singlePoint(this.points[this.points.length - 1])];
      var r = lerpPoint(this.points[0], this.points[1], t), n = lerpPoint(this.points[1], this.points[2], t), a = lerpPoint(this.points[2], this.points[3], t), s = lerpPoint(r, n, t), o = lerpPoint(n, a, t), l = lerpPoint(s, o, t);
      return [new PolynomialBezier(this.points[0], r, s, l, !0), new PolynomialBezier(l, o, a, this.points[3], !0)];
    }, PolynomialBezier.prototype.bounds = function() {
      return { x: extrema(this, 0), y: extrema(this, 1) };
    }, PolynomialBezier.prototype.boundingBox = function() {
      var t = this.bounds();
      return { left: t.x.min, right: t.x.max, top: t.y.min, bottom: t.y.max, width: t.x.max - t.x.min, height: t.y.max - t.y.min, cx: (t.x.max + t.x.min) / 2, cy: (t.y.max + t.y.min) / 2 };
    }, PolynomialBezier.prototype.intersections = function(t, r, n) {
      r === void 0 && (r = 2), n === void 0 && (n = 7);
      var a = [];
      return intersectsImpl(intersectData(this, 0, 1), intersectData(t, 0, 1), 0, r, a, n), a;
    }, PolynomialBezier.shapeSegment = function(t, r) {
      var n = (r + 1) % t.length();
      return new PolynomialBezier(t.v[r], t.o[r], t.i[n], t.v[n], !0);
    }, PolynomialBezier.shapeSegmentInverted = function(t, r) {
      var n = (r + 1) % t.length();
      return new PolynomialBezier(t.v[n], t.i[n], t.o[r], t.v[r], !0);
    }, extendPrototype([ShapeModifier], ZigZagModifier), ZigZagModifier.prototype.initModifierProperties = function(t, r) {
      this.getValue = this.processKeys, this.amplitude = PropertyFactory.getProp(t, r.s, 0, null, this), this.frequency = PropertyFactory.getProp(t, r.r, 0, null, this), this.pointsType = PropertyFactory.getProp(t, r.pt, 0, null, this), this._isAnimated = this.amplitude.effectsSequence.length !== 0 || this.frequency.effectsSequence.length !== 0 || this.pointsType.effectsSequence.length !== 0;
    }, ZigZagModifier.prototype.processPath = function(t, r, n, a) {
      var s = t._length, o = shapePool.newElement();
      if (o.c = t.c, t.c || (s -= 1), s === 0) return o;
      var l = -1, x = PolynomialBezier.shapeSegment(t, 0);
      zigZagCorner(o, t, 0, r, n, a, l);
      for (var j = 0; j < s; j += 1) l = zigZagSegment(o, x, r, n, a, -l), x = j !== s - 1 || t.c ? PolynomialBezier.shapeSegment(t, (j + 1) % s) : null, zigZagCorner(o, t, j + 1, r, n, a, l);
      return o;
    }, ZigZagModifier.prototype.processShapes = function(t) {
      var r, n, a, s, o, l, x = this.shapes.length, j = this.amplitude.v, Z = Math.max(0, Math.round(this.frequency.v)), V = this.pointsType.v;
      if (j !== 0) for (n = 0; n < x; n += 1) {
        if (l = (o = this.shapes[n]).localShapeCollection, o.shape._mdf || this._mdf || t) for (l.releaseShapes(), o.shape._mdf = !0, r = o.shape.paths.shapes, s = o.shape.paths._length, a = 0; a < s; a += 1) l.addShape(this.processPath(r[a], j, Z, V));
        o.shape.paths = o.localShapeCollection;
      }
      this.dynamicProperties.length || (this._mdf = !1);
    }, extendPrototype([ShapeModifier], OffsetPathModifier), OffsetPathModifier.prototype.initModifierProperties = function(t, r) {
      this.getValue = this.processKeys, this.amount = PropertyFactory.getProp(t, r.a, 0, null, this), this.miterLimit = PropertyFactory.getProp(t, r.ml, 0, null, this), this.lineJoin = r.lj, this._isAnimated = this.amount.effectsSequence.length !== 0;
    }, OffsetPathModifier.prototype.processPath = function(t, r, n, a) {
      var s = shapePool.newElement();
      s.c = t.c;
      var o, l, x, j = t.length();
      t.c || (j -= 1);
      var Z = [];
      for (o = 0; o < j; o += 1) x = PolynomialBezier.shapeSegment(t, o), Z.push(offsetSegmentSplit(x, r));
      if (!t.c) for (o = j - 1; o >= 0; o -= 1) x = PolynomialBezier.shapeSegmentInverted(t, o), Z.push(offsetSegmentSplit(x, r));
      Z = pruneIntersections(Z);
      var V = null, $ = null;
      for (o = 0; o < Z.length; o += 1) {
        var X = Z[o];
        for ($ && (V = joinLines(s, $, X[0], n, a)), $ = X[X.length - 1], l = 0; l < X.length; l += 1) x = X[l], V && pointEqual(x.points[0], V) ? s.setXYAt(x.points[1][0], x.points[1][1], "o", s.length() - 1) : s.setTripleAt(x.points[0][0], x.points[0][1], x.points[1][0], x.points[1][1], x.points[0][0], x.points[0][1], s.length()), s.setTripleAt(x.points[3][0], x.points[3][1], x.points[3][0], x.points[3][1], x.points[2][0], x.points[2][1], s.length()), V = x.points[3];
      }
      return Z.length && joinLines(s, $, Z[0][0], n, a), s;
    }, OffsetPathModifier.prototype.processShapes = function(t) {
      var r, n, a, s, o, l, x = this.shapes.length, j = this.amount.v, Z = this.miterLimit.v, V = this.lineJoin;
      if (j !== 0) for (n = 0; n < x; n += 1) {
        if (l = (o = this.shapes[n]).localShapeCollection, o.shape._mdf || this._mdf || t) for (l.releaseShapes(), o.shape._mdf = !0, r = o.shape.paths.shapes, s = o.shape.paths._length, a = 0; a < s; a += 1) l.addShape(this.processPath(r[a], j, V, Z));
        o.shape.paths = o.localShapeCollection;
      }
      this.dynamicProperties.length || (this._mdf = !1);
    };
    var FontManager = (function() {
      var t = { w: 0, size: 0, shapes: [], data: { shapes: [] } }, r = [];
      r = r.concat([2304, 2305, 2306, 2307, 2362, 2363, 2364, 2364, 2366, 2367, 2368, 2369, 2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379, 2380, 2381, 2382, 2383, 2387, 2388, 2389, 2390, 2391, 2402, 2403]);
      var n = ["d83cdffb", "d83cdffc", "d83cdffd", "d83cdffe", "d83cdfff"];
      function a(j, Z) {
        var V = createTag("span");
        V.setAttribute("aria-hidden", !0), V.style.fontFamily = Z;
        var $ = createTag("span");
        $.innerText = "giItT1WQy@!-/#", V.style.position = "absolute", V.style.left = "-10000px", V.style.top = "-10000px", V.style.fontSize = "300px", V.style.fontVariant = "normal", V.style.fontStyle = "normal", V.style.fontWeight = "normal", V.style.letterSpacing = "0", V.appendChild($), document.body.appendChild(V);
        var X = $.offsetWidth;
        return $.style.fontFamily = (function(W) {
          var Y, U = W.split(","), G = U.length, K = [];
          for (Y = 0; Y < G; Y += 1) U[Y] !== "sans-serif" && U[Y] !== "monospace" && K.push(U[Y]);
          return K.join(",");
        })(j) + ", " + Z, { node: $, w: X, parent: V };
      }
      function s(j, Z) {
        var V, $ = document.body && Z ? "svg" : "canvas", X = getFontProperties(j);
        if ($ === "svg") {
          var W = createNS("text");
          W.style.fontSize = "100px", W.setAttribute("font-family", j.fFamily), W.setAttribute("font-style", X.style), W.setAttribute("font-weight", X.weight), W.textContent = "1", j.fClass ? (W.style.fontFamily = "inherit", W.setAttribute("class", j.fClass)) : W.style.fontFamily = j.fFamily, Z.appendChild(W), V = W;
        } else {
          var Y = new OffscreenCanvas(500, 500).getContext("2d");
          Y.font = X.style + " " + X.weight + " 100px " + j.fFamily, V = Y;
        }
        return { measureText: function(U) {
          return $ === "svg" ? (V.textContent = U, V.getComputedTextLength()) : V.measureText(U).width;
        } };
      }
      function o(j) {
        var Z = 0, V = j.charCodeAt(0);
        if (V >= 55296 && V <= 56319) {
          var $ = j.charCodeAt(1);
          $ >= 56320 && $ <= 57343 && (Z = 1024 * (V - 55296) + $ - 56320 + 65536);
        }
        return Z;
      }
      function l(j) {
        var Z = o(j);
        return Z >= 127462 && Z <= 127487;
      }
      var x = function() {
        this.fonts = [], this.chars = null, this.typekitLoaded = 0, this.isLoaded = !1, this._warned = !1, this.initTime = Date.now(), this.setIsLoadedBinded = this.setIsLoaded.bind(this), this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
      };
      return x.isModifier = function(j, Z) {
        var V = j.toString(16) + Z.toString(16);
        return n.indexOf(V) !== -1;
      }, x.isZeroWidthJoiner = function(j) {
        return j === 8205;
      }, x.isFlagEmoji = function(j) {
        return l(j.substr(0, 2)) && l(j.substr(2, 2));
      }, x.isRegionalCode = l, x.isCombinedCharacter = function(j) {
        return r.indexOf(j) !== -1;
      }, x.isRegionalFlag = function(j, Z) {
        var V = o(j.substr(Z, 2));
        if (V !== 127988) return !1;
        var $ = 0;
        for (Z += 2; $ < 5; ) {
          if ((V = o(j.substr(Z, 2))) < 917601 || V > 917626) return !1;
          $ += 1, Z += 2;
        }
        return o(j.substr(Z, 2)) === 917631;
      }, x.isVariationSelector = function(j) {
        return j === 65039;
      }, x.BLACK_FLAG_CODE_POINT = 127988, x.prototype = { addChars: function(j) {
        if (j) {
          var Z;
          this.chars || (this.chars = []);
          var V, $, X = j.length, W = this.chars.length;
          for (Z = 0; Z < X; Z += 1) {
            for (V = 0, $ = !1; V < W; ) this.chars[V].style === j[Z].style && this.chars[V].fFamily === j[Z].fFamily && this.chars[V].ch === j[Z].ch && ($ = !0), V += 1;
            $ || (this.chars.push(j[Z]), W += 1);
          }
        }
      }, addFonts: function(j, Z) {
        if (j) {
          if (this.chars) return this.isLoaded = !0, void (this.fonts = j.list);
          if (!document.body) return this.isLoaded = !0, j.list.forEach((function(te) {
            te.helper = s(te), te.cache = {};
          })), void (this.fonts = j.list);
          var V, $ = j.list, X = $.length, W = X;
          for (V = 0; V < X; V += 1) {
            var Y, U, G = !0;
            if ($[V].loaded = !1, $[V].monoCase = a($[V].fFamily, "monospace"), $[V].sansCase = a($[V].fFamily, "sans-serif"), $[V].fPath) {
              if ($[V].fOrigin === "p" || $[V].origin === 3) {
                if ((Y = document.querySelectorAll('style[f-forigin="p"][f-family="' + $[V].fFamily + '"], style[f-origin="3"][f-family="' + $[V].fFamily + '"]')).length > 0 && (G = !1), G) {
                  var K = createTag("style");
                  K.setAttribute("f-forigin", $[V].fOrigin), K.setAttribute("f-origin", $[V].origin), K.setAttribute("f-family", $[V].fFamily), K.type = "text/css", K.innerText = "@font-face {font-family: " + $[V].fFamily + "; font-style: normal; src: url('" + $[V].fPath + "');}", Z.appendChild(K);
                }
              } else if ($[V].fOrigin === "g" || $[V].origin === 1) {
                for (Y = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]'), U = 0; U < Y.length; U += 1) Y[U].href.indexOf($[V].fPath) !== -1 && (G = !1);
                if (G) {
                  var J = createTag("link");
                  J.setAttribute("f-forigin", $[V].fOrigin), J.setAttribute("f-origin", $[V].origin), J.type = "text/css", J.rel = "stylesheet", J.href = $[V].fPath, document.body.appendChild(J);
                }
              } else if ($[V].fOrigin === "t" || $[V].origin === 2) {
                for (Y = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]'), U = 0; U < Y.length; U += 1) $[V].fPath === Y[U].src && (G = !1);
                if (G) {
                  var ee = createTag("link");
                  ee.setAttribute("f-forigin", $[V].fOrigin), ee.setAttribute("f-origin", $[V].origin), ee.setAttribute("rel", "stylesheet"), ee.setAttribute("href", $[V].fPath), Z.appendChild(ee);
                }
              }
            } else $[V].loaded = !0, W -= 1;
            $[V].helper = s($[V], Z), $[V].cache = {}, this.fonts.push($[V]);
          }
          W === 0 ? this.isLoaded = !0 : setTimeout(this.checkLoadedFonts.bind(this), 100);
        } else this.isLoaded = !0;
      }, getCharData: function(j, Z, V) {
        for (var $ = 0, X = this.chars.length; $ < X; ) {
          if (this.chars[$].ch === j && this.chars[$].style === Z && this.chars[$].fFamily === V) return this.chars[$];
          $ += 1;
        }
        return (typeof j == "string" && j.charCodeAt(0) !== 13 || !j) && console && console.warn && !this._warned && (this._warned = !0), t;
      }, getFontByName: function(j) {
        for (var Z = 0, V = this.fonts.length; Z < V; ) {
          if (this.fonts[Z].fName === j) return this.fonts[Z];
          Z += 1;
        }
        return this.fonts[0];
      }, measureText: function(j, Z, V) {
        var $ = this.getFontByName(Z), X = j;
        if (!$.cache[X]) {
          var W = $.helper;
          if (j === " ") {
            var Y = W.measureText("|" + j + "|"), U = W.measureText("||");
            $.cache[X] = (Y - U) / 100;
          } else $.cache[X] = W.measureText(j) / 100;
        }
        return $.cache[X] * V;
      }, checkLoadedFonts: function() {
        var j, Z, V, $ = this.fonts.length, X = $;
        for (j = 0; j < $; j += 1) this.fonts[j].loaded ? X -= 1 : this.fonts[j].fOrigin === "n" || this.fonts[j].origin === 0 ? this.fonts[j].loaded = !0 : (Z = this.fonts[j].monoCase.node, V = this.fonts[j].monoCase.w, Z.offsetWidth !== V ? (X -= 1, this.fonts[j].loaded = !0) : (Z = this.fonts[j].sansCase.node, V = this.fonts[j].sansCase.w, Z.offsetWidth !== V && (X -= 1, this.fonts[j].loaded = !0)), this.fonts[j].loaded && (this.fonts[j].sansCase.parent.parentNode.removeChild(this.fonts[j].sansCase.parent), this.fonts[j].monoCase.parent.parentNode.removeChild(this.fonts[j].monoCase.parent)));
        X !== 0 && Date.now() - this.initTime < 5e3 ? setTimeout(this.checkLoadedFontsBinded, 20) : setTimeout(this.setIsLoadedBinded, 10);
      }, setIsLoaded: function() {
        this.isLoaded = !0;
      } }, x;
    })();
    function SlotManager(t) {
      this.animationData = t;
    }
    function slotFactory(t) {
      return new SlotManager(t);
    }
    function RenderableElement() {
    }
    SlotManager.prototype.getProp = function(t) {
      return this.animationData.slots && this.animationData.slots[t.sid] ? Object.assign(t, this.animationData.slots[t.sid].p) : t;
    }, RenderableElement.prototype = { initRenderable: function() {
      this.isInRange = !1, this.hidden = !1, this.isTransparent = !1, this.renderableComponents = [];
    }, addRenderableComponent: function(t) {
      this.renderableComponents.indexOf(t) === -1 && this.renderableComponents.push(t);
    }, removeRenderableComponent: function(t) {
      this.renderableComponents.indexOf(t) !== -1 && this.renderableComponents.splice(this.renderableComponents.indexOf(t), 1);
    }, prepareRenderableFrame: function(t) {
      this.checkLayerLimits(t);
    }, checkTransparency: function() {
      this.finalTransform.mProp.o.v <= 0 ? !this.isTransparent && this.globalData.renderConfig.hideOnTransparent && (this.isTransparent = !0, this.hide()) : this.isTransparent && (this.isTransparent = !1, this.show());
    }, checkLayerLimits: function(t) {
      this.data.ip - this.data.st <= t && this.data.op - this.data.st > t ? this.isInRange !== !0 && (this.globalData._mdf = !0, this._mdf = !0, this.isInRange = !0, this.show()) : this.isInRange !== !1 && (this.globalData._mdf = !0, this.isInRange = !1, this.hide());
    }, renderRenderable: function() {
      var t, r = this.renderableComponents.length;
      for (t = 0; t < r; t += 1) this.renderableComponents[t].renderFrame(this._isFirstFrame);
    }, sourceRectAtTime: function() {
      return { top: 0, left: 0, width: 100, height: 100 };
    }, getLayerSize: function() {
      return this.data.ty === 5 ? { w: this.data.textData.width, h: this.data.textData.height } : { w: this.data.width, h: this.data.height };
    } };
    var getBlendMode = (blendModeEnums = { 0: "source-over", 1: "multiply", 2: "screen", 3: "overlay", 4: "darken", 5: "lighten", 6: "color-dodge", 7: "color-burn", 8: "hard-light", 9: "soft-light", 10: "difference", 11: "exclusion", 12: "hue", 13: "saturation", 14: "color", 15: "luminosity" }, function(t) {
      return blendModeEnums[t] || "";
    }), blendModeEnums;
    function SliderEffect(t, r, n) {
      this.p = PropertyFactory.getProp(r, t.v, 0, 0, n);
    }
    function AngleEffect(t, r, n) {
      this.p = PropertyFactory.getProp(r, t.v, 0, 0, n);
    }
    function ColorEffect(t, r, n) {
      this.p = PropertyFactory.getProp(r, t.v, 1, 0, n);
    }
    function PointEffect(t, r, n) {
      this.p = PropertyFactory.getProp(r, t.v, 1, 0, n);
    }
    function LayerIndexEffect(t, r, n) {
      this.p = PropertyFactory.getProp(r, t.v, 0, 0, n);
    }
    function MaskIndexEffect(t, r, n) {
      this.p = PropertyFactory.getProp(r, t.v, 0, 0, n);
    }
    function CheckboxEffect(t, r, n) {
      this.p = PropertyFactory.getProp(r, t.v, 0, 0, n);
    }
    function NoValueEffect() {
      this.p = {};
    }
    function EffectsManager(t, r) {
      var n, a = t.ef || [];
      this.effectElements = [];
      var s, o = a.length;
      for (n = 0; n < o; n += 1) s = new GroupEffect(a[n], r), this.effectElements.push(s);
    }
    function GroupEffect(t, r) {
      this.init(t, r);
    }
    function BaseElement() {
    }
    function FrameElement() {
    }
    function FootageElement(t, r, n) {
      this.initFrame(), this.initRenderable(), this.assetData = r.getAssetData(t.refId), this.footageData = r.imageLoader.getAsset(this.assetData), this.initBaseData(t, r, n);
    }
    function AudioElement(t, r, n) {
      this.initFrame(), this.initRenderable(), this.assetData = r.getAssetData(t.refId), this.initBaseData(t, r, n), this._isPlaying = !1, this._canPlay = !1;
      var a = this.globalData.getAssetsPath(this.assetData);
      this.audio = this.globalData.audioController.createAudio(a), this._currentTime = 0, this.globalData.audioController.addAudio(this), this._volumeMultiplier = 1, this._volume = 1, this._previousVolume = null, this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, r.frameRate, this) : { _placeholder: !0 }, this.lv = PropertyFactory.getProp(this, t.au && t.au.lv ? t.au.lv : { k: [100] }, 1, 0.01, this);
    }
    function BaseRenderer() {
    }
    extendPrototype([DynamicPropertyContainer], GroupEffect), GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties, GroupEffect.prototype.init = function(t, r) {
      var n;
      this.data = t, this.effectElements = [], this.initDynamicPropertyContainer(r);
      var a, s = this.data.ef.length, o = this.data.ef;
      for (n = 0; n < s; n += 1) {
        switch (a = null, o[n].ty) {
          case 0:
            a = new SliderEffect(o[n], r, this);
            break;
          case 1:
            a = new AngleEffect(o[n], r, this);
            break;
          case 2:
            a = new ColorEffect(o[n], r, this);
            break;
          case 3:
            a = new PointEffect(o[n], r, this);
            break;
          case 4:
          case 7:
            a = new CheckboxEffect(o[n], r, this);
            break;
          case 10:
            a = new LayerIndexEffect(o[n], r, this);
            break;
          case 11:
            a = new MaskIndexEffect(o[n], r, this);
            break;
          case 5:
            a = new EffectsManager(o[n], r);
            break;
          default:
            a = new NoValueEffect(o[n]);
        }
        a && this.effectElements.push(a);
      }
    }, BaseElement.prototype = { checkMasks: function() {
      if (!this.data.hasMask) return !1;
      for (var t = 0, r = this.data.masksProperties.length; t < r; ) {
        if (this.data.masksProperties[t].mode !== "n" && this.data.masksProperties[t].cl !== !1) return !0;
        t += 1;
      }
      return !1;
    }, initExpressions: function() {
      var t = getExpressionInterfaces();
      if (t) {
        var r = t("layer"), n = t("effects"), a = t("shape"), s = t("text"), o = t("comp");
        this.layerInterface = r(this), this.data.hasMask && this.maskManager && this.layerInterface.registerMaskInterface(this.maskManager);
        var l = n.createEffectsInterface(this, this.layerInterface);
        this.layerInterface.registerEffectsInterface(l), this.data.ty === 0 || this.data.xt ? this.compInterface = o(this) : this.data.ty === 4 ? (this.layerInterface.shapeInterface = a(this.shapesData, this.itemsData, this.layerInterface), this.layerInterface.content = this.layerInterface.shapeInterface) : this.data.ty === 5 && (this.layerInterface.textInterface = s(this), this.layerInterface.text = this.layerInterface.textInterface);
      }
    }, setBlendMode: function() {
      var t = getBlendMode(this.data.bm);
      (this.baseElement || this.layerElement).style["mix-blend-mode"] = t;
    }, initBaseData: function(t, r, n) {
      this.globalData = r, this.comp = n, this.data = t, this.layerId = createElementID(), this.data.sr || (this.data.sr = 1), this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
    }, getType: function() {
      return this.type;
    }, sourceRectAtTime: function() {
    } }, FrameElement.prototype = { initFrame: function() {
      this._isFirstFrame = !1, this.dynamicProperties = [], this._mdf = !1;
    }, prepareProperties: function(t, r) {
      var n, a = this.dynamicProperties.length;
      for (n = 0; n < a; n += 1) (r || this._isParent && this.dynamicProperties[n].propType === "transform") && (this.dynamicProperties[n].getValue(), this.dynamicProperties[n]._mdf && (this.globalData._mdf = !0, this._mdf = !0));
    }, addDynamicProperty: function(t) {
      this.dynamicProperties.indexOf(t) === -1 && this.dynamicProperties.push(t);
    } }, FootageElement.prototype.prepareFrame = function() {
    }, extendPrototype([RenderableElement, BaseElement, FrameElement], FootageElement), FootageElement.prototype.getBaseElement = function() {
      return null;
    }, FootageElement.prototype.renderFrame = function() {
    }, FootageElement.prototype.destroy = function() {
    }, FootageElement.prototype.initExpressions = function() {
      var t = getExpressionInterfaces();
      if (t) {
        var r = t("footage");
        this.layerInterface = r(this);
      }
    }, FootageElement.prototype.getFootageData = function() {
      return this.footageData;
    }, AudioElement.prototype.prepareFrame = function(t) {
      if (this.prepareRenderableFrame(t, !0), this.prepareProperties(t, !0), this.tm._placeholder) this._currentTime = t / this.data.sr;
      else {
        var r = this.tm.v;
        this._currentTime = r;
      }
      this._volume = this.lv.v[0];
      var n = this._volume * this._volumeMultiplier;
      this._previousVolume !== n && (this._previousVolume = n, this.audio.volume(n));
    }, extendPrototype([RenderableElement, BaseElement, FrameElement], AudioElement), AudioElement.prototype.renderFrame = function() {
      this.isInRange && this._canPlay && (this._isPlaying ? (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > 0.1) && this.audio.seek(this._currentTime / this.globalData.frameRate) : (this.audio.play(), this.audio.seek(this._currentTime / this.globalData.frameRate), this._isPlaying = !0));
    }, AudioElement.prototype.show = function() {
    }, AudioElement.prototype.hide = function() {
      this.audio.pause(), this._isPlaying = !1;
    }, AudioElement.prototype.pause = function() {
      this.audio.pause(), this._isPlaying = !1, this._canPlay = !1;
    }, AudioElement.prototype.resume = function() {
      this._canPlay = !0;
    }, AudioElement.prototype.setRate = function(t) {
      this.audio.rate(t);
    }, AudioElement.prototype.volume = function(t) {
      this._volumeMultiplier = t, this._previousVolume = t * this._volume, this.audio.volume(this._previousVolume);
    }, AudioElement.prototype.getBaseElement = function() {
      return null;
    }, AudioElement.prototype.destroy = function() {
    }, AudioElement.prototype.sourceRectAtTime = function() {
    }, AudioElement.prototype.initExpressions = function() {
    }, BaseRenderer.prototype.checkLayers = function(t) {
      var r, n, a = this.layers.length;
      for (this.completeLayers = !0, r = a - 1; r >= 0; r -= 1) this.elements[r] || (n = this.layers[r]).ip - n.st <= t - this.layers[r].st && n.op - n.st > t - this.layers[r].st && this.buildItem(r), this.completeLayers = !!this.elements[r] && this.completeLayers;
      this.checkPendingElements();
    }, BaseRenderer.prototype.createItem = function(t) {
      switch (t.ty) {
        case 2:
          return this.createImage(t);
        case 0:
          return this.createComp(t);
        case 1:
          return this.createSolid(t);
        case 3:
          return this.createNull(t);
        case 4:
          return this.createShape(t);
        case 5:
          return this.createText(t);
        case 6:
          return this.createAudio(t);
        case 13:
          return this.createCamera(t);
        case 15:
          return this.createFootage(t);
        default:
          return this.createNull(t);
      }
    }, BaseRenderer.prototype.createCamera = function() {
      throw new Error("You're using a 3d camera. Try the html renderer.");
    }, BaseRenderer.prototype.createAudio = function(t) {
      return new AudioElement(t, this.globalData, this);
    }, BaseRenderer.prototype.createFootage = function(t) {
      return new FootageElement(t, this.globalData, this);
    }, BaseRenderer.prototype.buildAllItems = function() {
      var t, r = this.layers.length;
      for (t = 0; t < r; t += 1) this.buildItem(t);
      this.checkPendingElements();
    }, BaseRenderer.prototype.includeLayers = function(t) {
      var r;
      this.completeLayers = !1;
      var n, a = t.length, s = this.layers.length;
      for (r = 0; r < a; r += 1) for (n = 0; n < s; ) {
        if (this.layers[n].id === t[r].id) {
          this.layers[n] = t[r];
          break;
        }
        n += 1;
      }
    }, BaseRenderer.prototype.setProjectInterface = function(t) {
      this.globalData.projectInterface = t;
    }, BaseRenderer.prototype.initItems = function() {
      this.globalData.progressiveLoad || this.buildAllItems();
    }, BaseRenderer.prototype.buildElementParenting = function(t, r, n) {
      for (var a = this.elements, s = this.layers, o = 0, l = s.length; o < l; ) s[o].ind == r && (a[o] && a[o] !== !0 ? (n.push(a[o]), a[o].setAsParent(), s[o].parent !== void 0 ? this.buildElementParenting(t, s[o].parent, n) : t.setHierarchy(n)) : (this.buildItem(o), this.addPendingElement(t))), o += 1;
    }, BaseRenderer.prototype.addPendingElement = function(t) {
      this.pendingElements.push(t);
    }, BaseRenderer.prototype.searchExtraCompositions = function(t) {
      var r, n = t.length;
      for (r = 0; r < n; r += 1) if (t[r].xt) {
        var a = this.createComp(t[r]);
        a.initExpressions(), this.globalData.projectInterface.registerComposition(a);
      }
    }, BaseRenderer.prototype.getElementById = function(t) {
      var r, n = this.elements.length;
      for (r = 0; r < n; r += 1) if (this.elements[r].data.ind === t) return this.elements[r];
      return null;
    }, BaseRenderer.prototype.getElementByPath = function(t) {
      var r, n = t.shift();
      if (typeof n == "number") r = this.elements[n];
      else {
        var a, s = this.elements.length;
        for (a = 0; a < s; a += 1) if (this.elements[a].data.nm === n) {
          r = this.elements[a];
          break;
        }
      }
      return t.length === 0 ? r : r.getElementByPath(t);
    }, BaseRenderer.prototype.setupGlobalData = function(t, r) {
      this.globalData.fontManager = new FontManager(), this.globalData.slotManager = slotFactory(t), this.globalData.fontManager.addChars(t.chars), this.globalData.fontManager.addFonts(t.fonts, r), this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem), this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem), this.globalData.imageLoader = this.animationItem.imagePreloader, this.globalData.audioController = this.animationItem.audioController, this.globalData.frameId = 0, this.globalData.frameRate = t.fr, this.globalData.nm = t.nm, this.globalData.compSize = { w: t.w, h: t.h };
    };
    var effectTypes = { TRANSFORM_EFFECT: "transformEFfect" };
    function TransformElement() {
    }
    function MaskElement(t, r, n) {
      this.data = t, this.element = r, this.globalData = n, this.storedData = [], this.masksProperties = this.data.masksProperties || [], this.maskElement = null;
      var a, s, o = this.globalData.defs, l = this.masksProperties ? this.masksProperties.length : 0;
      this.viewData = createSizedArray(l), this.solidPath = "";
      var x, j, Z, V, $, X, W = this.masksProperties, Y = 0, U = [], G = createElementID(), K = "clipPath", J = "clip-path";
      for (a = 0; a < l; a += 1) if ((W[a].mode !== "a" && W[a].mode !== "n" || W[a].inv || W[a].o.k !== 100 || W[a].o.x) && (K = "mask", J = "mask"), W[a].mode !== "s" && W[a].mode !== "i" || Y !== 0 ? Z = null : ((Z = createNS("rect")).setAttribute("fill", "#ffffff"), Z.setAttribute("width", this.element.comp.data.w || 0), Z.setAttribute("height", this.element.comp.data.h || 0), U.push(Z)), s = createNS("path"), W[a].mode === "n") this.viewData[a] = { op: PropertyFactory.getProp(this.element, W[a].o, 0, 0.01, this.element), prop: ShapePropertyFactory.getShapeProp(this.element, W[a], 3), elem: s, lastPath: "" }, o.appendChild(s);
      else {
        var ee;
        if (Y += 1, s.setAttribute("fill", W[a].mode === "s" ? "#000000" : "#ffffff"), s.setAttribute("clip-rule", "nonzero"), W[a].x.k !== 0 ? (K = "mask", J = "mask", X = PropertyFactory.getProp(this.element, W[a].x, 0, null, this.element), ee = createElementID(), (V = createNS("filter")).setAttribute("id", ee), ($ = createNS("feMorphology")).setAttribute("operator", "erode"), $.setAttribute("in", "SourceGraphic"), $.setAttribute("radius", "0"), V.appendChild($), o.appendChild(V), s.setAttribute("stroke", W[a].mode === "s" ? "#000000" : "#ffffff")) : ($ = null, X = null), this.storedData[a] = { elem: s, x: X, expan: $, lastPath: "", lastOperator: "", filterId: ee, lastRadius: 0 }, W[a].mode === "i") {
          j = U.length;
          var te = createNS("g");
          for (x = 0; x < j; x += 1) te.appendChild(U[x]);
          var re = createNS("mask");
          re.setAttribute("mask-type", "alpha"), re.setAttribute("id", G + "_" + Y), re.appendChild(s), o.appendChild(re), te.setAttribute("mask", "url(" + getLocationHref() + "#" + G + "_" + Y + ")"), U.length = 0, U.push(te);
        } else U.push(s);
        W[a].inv && !this.solidPath && (this.solidPath = this.createLayerSolidPath()), this.viewData[a] = { elem: s, lastPath: "", op: PropertyFactory.getProp(this.element, W[a].o, 0, 0.01, this.element), prop: ShapePropertyFactory.getShapeProp(this.element, W[a], 3), invRect: Z }, this.viewData[a].prop.k || this.drawPath(W[a], this.viewData[a].prop.v, this.viewData[a]);
      }
      for (this.maskElement = createNS(K), l = U.length, a = 0; a < l; a += 1) this.maskElement.appendChild(U[a]);
      Y > 0 && (this.maskElement.setAttribute("id", G), this.element.maskedElement.setAttribute(J, "url(" + getLocationHref() + "#" + G + ")"), o.appendChild(this.maskElement)), this.viewData.length && this.element.addRenderableComponent(this);
    }
    TransformElement.prototype = { initTransform: function() {
      var t = new Matrix();
      this.finalTransform = { mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : { o: 0 }, _matMdf: !1, _localMatMdf: !1, _opMdf: !1, mat: t, localMat: t, localOpacity: 1 }, this.data.ao && (this.finalTransform.mProp.autoOriented = !0), this.data.ty;
    }, renderTransform: function() {
      if (this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame, this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame, this.hierarchy) {
        var t, r = this.finalTransform.mat, n = 0, a = this.hierarchy.length;
        if (!this.finalTransform._matMdf) for (; n < a; ) {
          if (this.hierarchy[n].finalTransform.mProp._mdf) {
            this.finalTransform._matMdf = !0;
            break;
          }
          n += 1;
        }
        if (this.finalTransform._matMdf) for (t = this.finalTransform.mProp.v.props, r.cloneFromProps(t), n = 0; n < a; n += 1) r.multiply(this.hierarchy[n].finalTransform.mProp.v);
      }
      this.finalTransform._matMdf && (this.finalTransform._localMatMdf = this.finalTransform._matMdf), this.finalTransform._opMdf && (this.finalTransform.localOpacity = this.finalTransform.mProp.o.v);
    }, renderLocalTransform: function() {
      if (this.localTransforms) {
        var t = 0, r = this.localTransforms.length;
        if (this.finalTransform._localMatMdf = this.finalTransform._matMdf, !this.finalTransform._localMatMdf || !this.finalTransform._opMdf) for (; t < r; ) this.localTransforms[t]._mdf && (this.finalTransform._localMatMdf = !0), this.localTransforms[t]._opMdf && !this.finalTransform._opMdf && (this.finalTransform.localOpacity = this.finalTransform.mProp.o.v, this.finalTransform._opMdf = !0), t += 1;
        if (this.finalTransform._localMatMdf) {
          var n = this.finalTransform.localMat;
          for (this.localTransforms[0].matrix.clone(n), t = 1; t < r; t += 1) {
            var a = this.localTransforms[t].matrix;
            n.multiply(a);
          }
          n.multiply(this.finalTransform.mat);
        }
        if (this.finalTransform._opMdf) {
          var s = this.finalTransform.localOpacity;
          for (t = 0; t < r; t += 1) s *= 0.01 * this.localTransforms[t].opacity;
          this.finalTransform.localOpacity = s;
        }
      }
    }, searchEffectTransforms: function() {
      if (this.renderableEffectsManager) {
        var t = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
        if (t.length) {
          this.localTransforms = [], this.finalTransform.localMat = new Matrix();
          var r = 0, n = t.length;
          for (r = 0; r < n; r += 1) this.localTransforms.push(t[r]);
        }
      }
    }, globalToLocal: function(t) {
      var r = [];
      r.push(this.finalTransform);
      for (var n, a = !0, s = this.comp; a; ) s.finalTransform ? (s.data.hasMask && r.splice(0, 0, s.finalTransform), s = s.comp) : a = !1;
      var o, l = r.length;
      for (n = 0; n < l; n += 1) o = r[n].mat.applyToPointArray(0, 0, 0), t = [t[0] - o[0], t[1] - o[1], 0];
      return t;
    }, mHelper: new Matrix() }, MaskElement.prototype.getMaskProperty = function(t) {
      return this.viewData[t].prop;
    }, MaskElement.prototype.renderFrame = function(t) {
      var r, n = this.element.finalTransform.mat, a = this.masksProperties.length;
      for (r = 0; r < a; r += 1) if ((this.viewData[r].prop._mdf || t) && this.drawPath(this.masksProperties[r], this.viewData[r].prop.v, this.viewData[r]), (this.viewData[r].op._mdf || t) && this.viewData[r].elem.setAttribute("fill-opacity", this.viewData[r].op.v), this.masksProperties[r].mode !== "n" && (this.viewData[r].invRect && (this.element.finalTransform.mProp._mdf || t) && this.viewData[r].invRect.setAttribute("transform", n.getInverseMatrix().to2dCSS()), this.storedData[r].x && (this.storedData[r].x._mdf || t))) {
        var s = this.storedData[r].expan;
        this.storedData[r].x.v < 0 ? (this.storedData[r].lastOperator !== "erode" && (this.storedData[r].lastOperator = "erode", this.storedData[r].elem.setAttribute("filter", "url(" + getLocationHref() + "#" + this.storedData[r].filterId + ")")), s.setAttribute("radius", -this.storedData[r].x.v)) : (this.storedData[r].lastOperator !== "dilate" && (this.storedData[r].lastOperator = "dilate", this.storedData[r].elem.setAttribute("filter", null)), this.storedData[r].elem.setAttribute("stroke-width", 2 * this.storedData[r].x.v));
      }
    }, MaskElement.prototype.getMaskelement = function() {
      return this.maskElement;
    }, MaskElement.prototype.createLayerSolidPath = function() {
      var t = "M0,0 ";
      return t += " h" + this.globalData.compSize.w, t += " v" + this.globalData.compSize.h, t += " h-" + this.globalData.compSize.w, t += " v-" + this.globalData.compSize.h + " ";
    }, MaskElement.prototype.drawPath = function(t, r, n) {
      var a, s, o = " M" + r.v[0][0] + "," + r.v[0][1];
      for (s = r._length, a = 1; a < s; a += 1) o += " C" + r.o[a - 1][0] + "," + r.o[a - 1][1] + " " + r.i[a][0] + "," + r.i[a][1] + " " + r.v[a][0] + "," + r.v[a][1];
      if (r.c && s > 1 && (o += " C" + r.o[a - 1][0] + "," + r.o[a - 1][1] + " " + r.i[0][0] + "," + r.i[0][1] + " " + r.v[0][0] + "," + r.v[0][1]), n.lastPath !== o) {
        var l = "";
        n.elem && (r.c && (l = t.inv ? this.solidPath + o : o), n.elem.setAttribute("d", l)), n.lastPath = o;
      }
    }, MaskElement.prototype.destroy = function() {
      this.element = null, this.globalData = null, this.maskElement = null, this.data = null, this.masksProperties = null;
    };
    var filtersFactory = (function() {
      var t = {};
      return t.createFilter = function(r, n) {
        var a = createNS("filter");
        return a.setAttribute("id", r), n !== !0 && (a.setAttribute("filterUnits", "objectBoundingBox"), a.setAttribute("x", "0%"), a.setAttribute("y", "0%"), a.setAttribute("width", "100%"), a.setAttribute("height", "100%")), a;
      }, t.createAlphaToLuminanceFilter = function() {
        var r = createNS("feColorMatrix");
        return r.setAttribute("type", "matrix"), r.setAttribute("color-interpolation-filters", "sRGB"), r.setAttribute("values", "0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1"), r;
      }, t;
    })(), featureSupport = (function() {
      var t = { maskType: !0, svgLumaHidden: !0, offscreenCanvas: typeof OffscreenCanvas != "undefined" };
      return (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) && (t.maskType = !1), /firefox/i.test(navigator.userAgent) && (t.svgLumaHidden = !1), t;
    })(), registeredEffects$1 = {}, idPrefix = "filter_result_";
    function SVGEffects(t) {
      var r, n, a = "SourceGraphic", s = t.data.ef ? t.data.ef.length : 0, o = createElementID(), l = filtersFactory.createFilter(o, !0), x = 0;
      for (this.filters = [], r = 0; r < s; r += 1) {
        n = null;
        var j = t.data.ef[r].ty;
        registeredEffects$1[j] && (n = new registeredEffects$1[j].effect(l, t.effectsManager.effectElements[r], t, idPrefix + x, a), a = idPrefix + x, registeredEffects$1[j].countsAsEffect && (x += 1)), n && this.filters.push(n);
      }
      x && (t.globalData.defs.appendChild(l), t.layerElement.setAttribute("filter", "url(" + getLocationHref() + "#" + o + ")")), this.filters.length && t.addRenderableComponent(this);
    }
    function registerEffect$1(t, r, n) {
      registeredEffects$1[t] = { effect: r, countsAsEffect: n };
    }
    function SVGBaseElement() {
    }
    function HierarchyElement() {
    }
    function RenderableDOMElement() {
    }
    function IImageElement(t, r, n) {
      this.assetData = r.getAssetData(t.refId), this.assetData && this.assetData.sid && (this.assetData = r.slotManager.getProp(this.assetData)), this.initElement(t, r, n), this.sourceRect = { top: 0, left: 0, width: this.assetData.w, height: this.assetData.h };
    }
    function ProcessedElement(t, r) {
      this.elem = t, this.pos = r;
    }
    function IShapeElement() {
    }
    SVGEffects.prototype.renderFrame = function(t) {
      var r, n = this.filters.length;
      for (r = 0; r < n; r += 1) this.filters[r].renderFrame(t);
    }, SVGEffects.prototype.getEffects = function(t) {
      var r, n = this.filters.length, a = [];
      for (r = 0; r < n; r += 1) this.filters[r].type === t && a.push(this.filters[r]);
      return a;
    }, SVGBaseElement.prototype = { initRendererElement: function() {
      this.layerElement = createNS("g");
    }, createContainerElements: function() {
      this.matteElement = createNS("g"), this.transformedElement = this.layerElement, this.maskedElement = this.layerElement, this._sizeChanged = !1;
      var t = null;
      if (this.data.td) {
        this.matteMasks = {};
        var r = createNS("g");
        r.setAttribute("id", this.layerId), r.appendChild(this.layerElement), t = r, this.globalData.defs.appendChild(r);
      } else this.data.tt ? (this.matteElement.appendChild(this.layerElement), t = this.matteElement, this.baseElement = this.matteElement) : this.baseElement = this.layerElement;
      if (this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), this.data.ty === 0 && !this.data.hd) {
        var n = createNS("clipPath"), a = createNS("path");
        a.setAttribute("d", "M0,0 L" + this.data.w + ",0 L" + this.data.w + "," + this.data.h + " L0," + this.data.h + "z");
        var s = createElementID();
        if (n.setAttribute("id", s), n.appendChild(a), this.globalData.defs.appendChild(n), this.checkMasks()) {
          var o = createNS("g");
          o.setAttribute("clip-path", "url(" + getLocationHref() + "#" + s + ")"), o.appendChild(this.layerElement), this.transformedElement = o, t ? t.appendChild(this.transformedElement) : this.baseElement = this.transformedElement;
        } else this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + s + ")");
      }
      this.data.bm !== 0 && this.setBlendMode();
    }, renderElement: function() {
      this.finalTransform._localMatMdf && this.transformedElement.setAttribute("transform", this.finalTransform.localMat.to2dCSS()), this.finalTransform._opMdf && this.transformedElement.setAttribute("opacity", this.finalTransform.localOpacity);
    }, destroyBaseElement: function() {
      this.layerElement = null, this.matteElement = null, this.maskManager.destroy();
    }, getBaseElement: function() {
      return this.data.hd ? null : this.baseElement;
    }, createRenderableComponents: function() {
      this.maskManager = new MaskElement(this.data, this, this.globalData), this.renderableEffectsManager = new SVGEffects(this), this.searchEffectTransforms();
    }, getMatte: function(t) {
      if (this.matteMasks || (this.matteMasks = {}), !this.matteMasks[t]) {
        var r, n, a, s, o = this.layerId + "_" + t;
        if (t === 1 || t === 3) {
          var l = createNS("mask");
          l.setAttribute("id", o), l.setAttribute("mask-type", t === 3 ? "luminance" : "alpha"), (a = createNS("use")).setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId), l.appendChild(a), this.globalData.defs.appendChild(l), featureSupport.maskType || t !== 1 || (l.setAttribute("mask-type", "luminance"), r = createElementID(), n = filtersFactory.createFilter(r), this.globalData.defs.appendChild(n), n.appendChild(filtersFactory.createAlphaToLuminanceFilter()), (s = createNS("g")).appendChild(a), l.appendChild(s), s.setAttribute("filter", "url(" + getLocationHref() + "#" + r + ")"));
        } else if (t === 2) {
          var x = createNS("mask");
          x.setAttribute("id", o), x.setAttribute("mask-type", "alpha");
          var j = createNS("g");
          x.appendChild(j), r = createElementID(), n = filtersFactory.createFilter(r);
          var Z = createNS("feComponentTransfer");
          Z.setAttribute("in", "SourceGraphic"), n.appendChild(Z);
          var V = createNS("feFuncA");
          V.setAttribute("type", "table"), V.setAttribute("tableValues", "1.0 0.0"), Z.appendChild(V), this.globalData.defs.appendChild(n);
          var $ = createNS("rect");
          $.setAttribute("width", this.comp.data.w), $.setAttribute("height", this.comp.data.h), $.setAttribute("x", "0"), $.setAttribute("y", "0"), $.setAttribute("fill", "#ffffff"), $.setAttribute("opacity", "0"), j.setAttribute("filter", "url(" + getLocationHref() + "#" + r + ")"), j.appendChild($), (a = createNS("use")).setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId), j.appendChild(a), featureSupport.maskType || (x.setAttribute("mask-type", "luminance"), n.appendChild(filtersFactory.createAlphaToLuminanceFilter()), s = createNS("g"), j.appendChild($), s.appendChild(this.layerElement), j.appendChild(s)), this.globalData.defs.appendChild(x);
        }
        this.matteMasks[t] = o;
      }
      return this.matteMasks[t];
    }, setMatte: function(t) {
      this.matteElement && this.matteElement.setAttribute("mask", "url(" + getLocationHref() + "#" + t + ")");
    } }, HierarchyElement.prototype = { initHierarchy: function() {
      this.hierarchy = [], this._isParent = !1, this.checkParenting();
    }, setHierarchy: function(t) {
      this.hierarchy = t;
    }, setAsParent: function() {
      this._isParent = !0;
    }, checkParenting: function() {
      this.data.parent !== void 0 && this.comp.buildElementParenting(this, this.data.parent, []);
    } }, extendPrototype([RenderableElement, createProxyFunction({ initElement: function(t, r, n) {
      this.initFrame(), this.initBaseData(t, r, n), this.initTransform(t, r, n), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide();
    }, hide: function() {
      this.hidden || this.isInRange && !this.isTransparent || ((this.baseElement || this.layerElement).style.display = "none", this.hidden = !0);
    }, show: function() {
      this.isInRange && !this.isTransparent && (this.data.hd || ((this.baseElement || this.layerElement).style.display = "block"), this.hidden = !1, this._isFirstFrame = !0);
    }, renderFrame: function() {
      this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderLocalTransform(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
    }, renderInnerContent: function() {
    }, prepareFrame: function(t) {
      this._mdf = !1, this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange), this.checkTransparency();
    }, destroy: function() {
      this.innerElem = null, this.destroyBaseElement();
    } })], RenderableDOMElement), extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], IImageElement), IImageElement.prototype.createContent = function() {
      var t = this.globalData.getAssetsPath(this.assetData);
      this.innerElem = createNS("image"), this.innerElem.setAttribute("width", this.assetData.w + "px"), this.innerElem.setAttribute("height", this.assetData.h + "px"), this.innerElem.setAttribute("preserveAspectRatio", this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio), this.innerElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", t), this.layerElement.appendChild(this.innerElem);
    }, IImageElement.prototype.sourceRectAtTime = function() {
      return this.sourceRect;
    }, IShapeElement.prototype = { addShapeToModifiers: function(t) {
      var r, n = this.shapeModifiers.length;
      for (r = 0; r < n; r += 1) this.shapeModifiers[r].addShape(t);
    }, isShapeInAnimatedModifiers: function(t) {
      for (var r = this.shapeModifiers.length; 0 < r; ) if (this.shapeModifiers[0].isAnimatedWithShape(t)) return !0;
      return !1;
    }, renderModifiers: function() {
      if (this.shapeModifiers.length) {
        var t, r = this.shapes.length;
        for (t = 0; t < r; t += 1) this.shapes[t].sh.reset();
        for (t = (r = this.shapeModifiers.length) - 1; t >= 0 && !this.shapeModifiers[t].processShapes(this._isFirstFrame); t -= 1) ;
      }
    }, searchProcessedElement: function(t) {
      for (var r = this.processedElements, n = 0, a = r.length; n < a; ) {
        if (r[n].elem === t) return r[n].pos;
        n += 1;
      }
      return 0;
    }, addProcessedElement: function(t, r) {
      for (var n = this.processedElements, a = n.length; a; ) if (n[a -= 1].elem === t) return void (n[a].pos = r);
      n.push(new ProcessedElement(t, r));
    }, prepareFrame: function(t) {
      this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange);
    } };
    var lineCapEnum = { 1: "butt", 2: "round", 3: "square" }, lineJoinEnum = { 1: "miter", 2: "round", 3: "bevel" };
    function SVGShapeData(t, r, n) {
      this.caches = [], this.styles = [], this.transformers = t, this.lStr = "", this.sh = n, this.lvl = r, this._isAnimated = !!n.k;
      for (var a = 0, s = t.length; a < s; ) {
        if (t[a].mProps.dynamicProperties.length) {
          this._isAnimated = !0;
          break;
        }
        a += 1;
      }
    }
    function SVGStyleData(t, r) {
      this.data = t, this.type = t.ty, this.d = "", this.lvl = r, this._mdf = !1, this.closed = t.hd === !0, this.pElem = createNS("path"), this.msElem = null;
    }
    function DashProperty(t, r, n, a) {
      var s;
      this.elem = t, this.frameId = -1, this.dataProps = createSizedArray(r.length), this.renderer = n, this.k = !1, this.dashStr = "", this.dashArray = createTypedArray("float32", r.length ? r.length - 1 : 0), this.dashoffset = createTypedArray("float32", 1), this.initDynamicPropertyContainer(a);
      var o, l = r.length || 0;
      for (s = 0; s < l; s += 1) o = PropertyFactory.getProp(t, r[s].v, 0, 0, this), this.k = o.k || this.k, this.dataProps[s] = { n: r[s].n, p: o };
      this.k || this.getValue(!0), this._isAnimated = this.k;
    }
    function SVGStrokeStyleData(t, r, n) {
      this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(t, r.o, 0, 0.01, this), this.w = PropertyFactory.getProp(t, r.w, 0, null, this), this.d = new DashProperty(t, r.d || {}, "svg", this), this.c = PropertyFactory.getProp(t, r.c, 1, 255, this), this.style = n, this._isAnimated = !!this._isAnimated;
    }
    function SVGFillStyleData(t, r, n) {
      this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(t, r.o, 0, 0.01, this), this.c = PropertyFactory.getProp(t, r.c, 1, 255, this), this.style = n;
    }
    function SVGNoStyleData(t, r, n) {
      this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.style = n;
    }
    function GradientProperty(t, r, n) {
      this.data = r, this.c = createTypedArray("uint8c", 4 * r.p);
      var a = r.k.k[0].s ? r.k.k[0].s.length - 4 * r.p : r.k.k.length - 4 * r.p;
      this.o = createTypedArray("float32", a), this._cmdf = !1, this._omdf = !1, this._collapsable = this.checkCollapsable(), this._hasOpacity = a, this.initDynamicPropertyContainer(n), this.prop = PropertyFactory.getProp(t, r.k, 1, null, this), this.k = this.prop.k, this.getValue(!0);
    }
    function SVGGradientFillStyleData(t, r, n) {
      this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.initGradientData(t, r, n);
    }
    function SVGGradientStrokeStyleData(t, r, n) {
      this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.w = PropertyFactory.getProp(t, r.w, 0, null, this), this.d = new DashProperty(t, r.d || {}, "svg", this), this.initGradientData(t, r, n), this._isAnimated = !!this._isAnimated;
    }
    function ShapeGroupData() {
      this.it = [], this.prevViewData = [], this.gr = createNS("g");
    }
    function SVGTransformData(t, r, n) {
      this.transform = { mProps: t, op: r, container: n }, this.elements = [], this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
    }
    SVGShapeData.prototype.setAsAnimated = function() {
      this._isAnimated = !0;
    }, SVGStyleData.prototype.reset = function() {
      this.d = "", this._mdf = !1;
    }, DashProperty.prototype.getValue = function(t) {
      if ((this.elem.globalData.frameId !== this.frameId || t) && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf = this._mdf || t, this._mdf)) {
        var r = 0, n = this.dataProps.length;
        for (this.renderer === "svg" && (this.dashStr = ""), r = 0; r < n; r += 1) this.dataProps[r].n !== "o" ? this.renderer === "svg" ? this.dashStr += " " + this.dataProps[r].p.v : this.dashArray[r] = this.dataProps[r].p.v : this.dashoffset[0] = this.dataProps[r].p.v;
      }
    }, extendPrototype([DynamicPropertyContainer], DashProperty), extendPrototype([DynamicPropertyContainer], SVGStrokeStyleData), extendPrototype([DynamicPropertyContainer], SVGFillStyleData), extendPrototype([DynamicPropertyContainer], SVGNoStyleData), GradientProperty.prototype.comparePoints = function(t, r) {
      for (var n = 0, a = this.o.length / 2; n < a; ) {
        if (Math.abs(t[4 * n] - t[4 * r + 2 * n]) > 0.01) return !1;
        n += 1;
      }
      return !0;
    }, GradientProperty.prototype.checkCollapsable = function() {
      if (this.o.length / 2 != this.c.length / 4) return !1;
      if (this.data.k.k[0].s) for (var t = 0, r = this.data.k.k.length; t < r; ) {
        if (!this.comparePoints(this.data.k.k[t].s, this.data.p)) return !1;
        t += 1;
      }
      else if (!this.comparePoints(this.data.k.k, this.data.p)) return !1;
      return !0;
    }, GradientProperty.prototype.getValue = function(t) {
      if (this.prop.getValue(), this._mdf = !1, this._cmdf = !1, this._omdf = !1, this.prop._mdf || t) {
        var r, n, a, s = 4 * this.data.p;
        for (r = 0; r < s; r += 1) n = r % 4 == 0 ? 100 : 255, a = Math.round(this.prop.v[r] * n), this.c[r] !== a && (this.c[r] = a, this._cmdf = !t);
        if (this.o.length) for (s = this.prop.v.length, r = 4 * this.data.p; r < s; r += 1) n = r % 2 == 0 ? 100 : 1, a = r % 2 == 0 ? Math.round(100 * this.prop.v[r]) : this.prop.v[r], this.o[r - 4 * this.data.p] !== a && (this.o[r - 4 * this.data.p] = a, this._omdf = !t);
        this._mdf = !t;
      }
    }, extendPrototype([DynamicPropertyContainer], GradientProperty), SVGGradientFillStyleData.prototype.initGradientData = function(t, r, n) {
      this.o = PropertyFactory.getProp(t, r.o, 0, 0.01, this), this.s = PropertyFactory.getProp(t, r.s, 1, null, this), this.e = PropertyFactory.getProp(t, r.e, 1, null, this), this.h = PropertyFactory.getProp(t, r.h || { k: 0 }, 0, 0.01, this), this.a = PropertyFactory.getProp(t, r.a || { k: 0 }, 0, degToRads, this), this.g = new GradientProperty(t, r.g, this), this.style = n, this.stops = [], this.setGradientData(n.pElem, r), this.setGradientOpacity(r, n), this._isAnimated = !!this._isAnimated;
    }, SVGGradientFillStyleData.prototype.setGradientData = function(t, r) {
      var n = createElementID(), a = createNS(r.t === 1 ? "linearGradient" : "radialGradient");
      a.setAttribute("id", n), a.setAttribute("spreadMethod", "pad"), a.setAttribute("gradientUnits", "userSpaceOnUse");
      var s, o, l, x = [];
      for (l = 4 * r.g.p, o = 0; o < l; o += 4) s = createNS("stop"), a.appendChild(s), x.push(s);
      t.setAttribute(r.ty === "gf" ? "fill" : "stroke", "url(" + getLocationHref() + "#" + n + ")"), this.gf = a, this.cst = x;
    }, SVGGradientFillStyleData.prototype.setGradientOpacity = function(t, r) {
      if (this.g._hasOpacity && !this.g._collapsable) {
        var n, a, s, o = createNS("mask"), l = createNS("path");
        o.appendChild(l);
        var x = createElementID(), j = createElementID();
        o.setAttribute("id", j);
        var Z = createNS(t.t === 1 ? "linearGradient" : "radialGradient");
        Z.setAttribute("id", x), Z.setAttribute("spreadMethod", "pad"), Z.setAttribute("gradientUnits", "userSpaceOnUse"), s = t.g.k.k[0].s ? t.g.k.k[0].s.length : t.g.k.k.length;
        var V = this.stops;
        for (a = 4 * t.g.p; a < s; a += 2) (n = createNS("stop")).setAttribute("stop-color", "rgb(255,255,255)"), Z.appendChild(n), V.push(n);
        l.setAttribute(t.ty === "gf" ? "fill" : "stroke", "url(" + getLocationHref() + "#" + x + ")"), t.ty === "gs" && (l.setAttribute("stroke-linecap", lineCapEnum[t.lc || 2]), l.setAttribute("stroke-linejoin", lineJoinEnum[t.lj || 2]), t.lj === 1 && l.setAttribute("stroke-miterlimit", t.ml)), this.of = Z, this.ms = o, this.ost = V, this.maskId = j, r.msElem = l;
      }
    }, extendPrototype([DynamicPropertyContainer], SVGGradientFillStyleData), extendPrototype([SVGGradientFillStyleData, DynamicPropertyContainer], SVGGradientStrokeStyleData);
    var buildShapeString = function(t, r, n, a) {
      if (r === 0) return "";
      var s, o = t.o, l = t.i, x = t.v, j = " M" + a.applyToPointStringified(x[0][0], x[0][1]);
      for (s = 1; s < r; s += 1) j += " C" + a.applyToPointStringified(o[s - 1][0], o[s - 1][1]) + " " + a.applyToPointStringified(l[s][0], l[s][1]) + " " + a.applyToPointStringified(x[s][0], x[s][1]);
      return n && r && (j += " C" + a.applyToPointStringified(o[s - 1][0], o[s - 1][1]) + " " + a.applyToPointStringified(l[0][0], l[0][1]) + " " + a.applyToPointStringified(x[0][0], x[0][1]), j += "z"), j;
    }, SVGElementsRenderer = (function() {
      var t = new Matrix(), r = new Matrix();
      function n(Z, V, $) {
        ($ || V.transform.op._mdf) && V.transform.container.setAttribute("opacity", V.transform.op.v), ($ || V.transform.mProps._mdf) && V.transform.container.setAttribute("transform", V.transform.mProps.v.to2dCSS());
      }
      function a() {
      }
      function s(Z, V, $) {
        var X, W, Y, U, G, K, J, ee, te, re, ae = V.styles.length, ie = V.lvl;
        for (K = 0; K < ae; K += 1) {
          if (U = V.sh._mdf || $, V.styles[K].lvl < ie) {
            for (ee = r.reset(), te = ie - V.styles[K].lvl, re = V.transformers.length - 1; !U && te > 0; ) U = V.transformers[re].mProps._mdf || U, te -= 1, re -= 1;
            if (U) for (te = ie - V.styles[K].lvl, re = V.transformers.length - 1; te > 0; ) ee.multiply(V.transformers[re].mProps.v), te -= 1, re -= 1;
          } else ee = t;
          if (W = (J = V.sh.paths)._length, U) {
            for (Y = "", X = 0; X < W; X += 1) (G = J.shapes[X]) && G._length && (Y += buildShapeString(G, G._length, G.c, ee));
            V.caches[K] = Y;
          } else Y = V.caches[K];
          V.styles[K].d += Z.hd === !0 ? "" : Y, V.styles[K]._mdf = U || V.styles[K]._mdf;
        }
      }
      function o(Z, V, $) {
        var X = V.style;
        (V.c._mdf || $) && X.pElem.setAttribute("fill", "rgb(" + bmFloor(V.c.v[0]) + "," + bmFloor(V.c.v[1]) + "," + bmFloor(V.c.v[2]) + ")"), (V.o._mdf || $) && X.pElem.setAttribute("fill-opacity", V.o.v);
      }
      function l(Z, V, $) {
        x(Z, V, $), j(Z, V, $);
      }
      function x(Z, V, $) {
        var X, W, Y, U, G, K = V.gf, J = V.g._hasOpacity, ee = V.s.v, te = V.e.v;
        if (V.o._mdf || $) {
          var re = Z.ty === "gf" ? "fill-opacity" : "stroke-opacity";
          V.style.pElem.setAttribute(re, V.o.v);
        }
        if (V.s._mdf || $) {
          var ae = Z.t === 1 ? "x1" : "cx", ie = ae === "x1" ? "y1" : "cy";
          K.setAttribute(ae, ee[0]), K.setAttribute(ie, ee[1]), J && !V.g._collapsable && (V.of.setAttribute(ae, ee[0]), V.of.setAttribute(ie, ee[1]));
        }
        if (V.g._cmdf || $) {
          X = V.cst;
          var ce = V.g.c;
          for (Y = X.length, W = 0; W < Y; W += 1) (U = X[W]).setAttribute("offset", ce[4 * W] + "%"), U.setAttribute("stop-color", "rgb(" + ce[4 * W + 1] + "," + ce[4 * W + 2] + "," + ce[4 * W + 3] + ")");
        }
        if (J && (V.g._omdf || $)) {
          var he = V.g.o;
          for (Y = (X = V.g._collapsable ? V.cst : V.ost).length, W = 0; W < Y; W += 1) U = X[W], V.g._collapsable || U.setAttribute("offset", he[2 * W] + "%"), U.setAttribute("stop-opacity", he[2 * W + 1]);
        }
        if (Z.t === 1) (V.e._mdf || $) && (K.setAttribute("x2", te[0]), K.setAttribute("y2", te[1]), J && !V.g._collapsable && (V.of.setAttribute("x2", te[0]), V.of.setAttribute("y2", te[1])));
        else if ((V.s._mdf || V.e._mdf || $) && (G = Math.sqrt(Math.pow(ee[0] - te[0], 2) + Math.pow(ee[1] - te[1], 2)), K.setAttribute("r", G), J && !V.g._collapsable && V.of.setAttribute("r", G)), V.e._mdf || V.h._mdf || V.a._mdf || $) {
          G || (G = Math.sqrt(Math.pow(ee[0] - te[0], 2) + Math.pow(ee[1] - te[1], 2)));
          var oe = Math.atan2(te[1] - ee[1], te[0] - ee[0]), le = V.h.v;
          le >= 1 ? le = 0.99 : le <= -1 && (le = -0.99);
          var pe = G * le, de = Math.cos(oe + V.a.v) * pe + ee[0], se = Math.sin(oe + V.a.v) * pe + ee[1];
          K.setAttribute("fx", de), K.setAttribute("fy", se), J && !V.g._collapsable && (V.of.setAttribute("fx", de), V.of.setAttribute("fy", se));
        }
      }
      function j(Z, V, $) {
        var X = V.style, W = V.d;
        W && (W._mdf || $) && W.dashStr && (X.pElem.setAttribute("stroke-dasharray", W.dashStr), X.pElem.setAttribute("stroke-dashoffset", W.dashoffset[0])), V.c && (V.c._mdf || $) && X.pElem.setAttribute("stroke", "rgb(" + bmFloor(V.c.v[0]) + "," + bmFloor(V.c.v[1]) + "," + bmFloor(V.c.v[2]) + ")"), (V.o._mdf || $) && X.pElem.setAttribute("stroke-opacity", V.o.v), (V.w._mdf || $) && (X.pElem.setAttribute("stroke-width", V.w.v), X.msElem && X.msElem.setAttribute("stroke-width", V.w.v));
      }
      return { createRenderFunction: function(Z) {
        switch (Z.ty) {
          case "fl":
            return o;
          case "gf":
            return x;
          case "gs":
            return l;
          case "st":
            return j;
          case "sh":
          case "el":
          case "rc":
          case "sr":
            return s;
          case "tr":
            return n;
          case "no":
            return a;
          default:
            return null;
        }
      } };
    })();
    function SVGShapeElement(t, r, n) {
      this.shapes = [], this.shapesData = t.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.initElement(t, r, n), this.prevViewData = [];
    }
    function LetterProps(t, r, n, a, s, o) {
      this.o = t, this.sw = r, this.sc = n, this.fc = a, this.m = s, this.p = o, this._mdf = { o: !0, sw: !!r, sc: !!n, fc: !!a, m: !0, p: !0 };
    }
    function TextProperty(t, r) {
      this._frameId = initialDefaultFrame, this.pv = "", this.v = "", this.kf = !1, this._isFirstFrame = !0, this._mdf = !1, r.d && r.d.sid && (r.d = t.globalData.slotManager.getProp(r.d)), this.data = r, this.elem = t, this.comp = this.elem.comp, this.keysIndex = 0, this.canResize = !1, this.minimumFontSize = 1, this.effectsSequence = [], this.currentData = { ascent: 0, boxWidth: this.defaultBoxWidth, f: "", fStyle: "", fWeight: "", fc: "", j: "", justifyOffset: "", l: [], lh: 0, lineWidths: [], ls: "", of: "", s: "", sc: "", sw: 0, t: 0, tr: 0, sz: 0, ps: null, fillColorAnim: !1, strokeColorAnim: !1, strokeWidthAnim: !1, yOffset: 0, finalSize: 0, finalText: [], finalLineHeight: 0, __complete: !1 }, this.copyData(this.currentData, this.data.d.k[0].s), this.searchProperty() || this.completeTextData(this.currentData);
    }
    extendPrototype([BaseElement, TransformElement, SVGBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableDOMElement], SVGShapeElement), SVGShapeElement.prototype.initSecondaryElement = function() {
    }, SVGShapeElement.prototype.identityMatrix = new Matrix(), SVGShapeElement.prototype.buildExpressionInterface = function() {
    }, SVGShapeElement.prototype.createContent = function() {
      this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes();
    }, SVGShapeElement.prototype.filterUniqueShapes = function() {
      var t, r, n, a, s = this.shapes.length, o = this.stylesList.length, l = [], x = !1;
      for (n = 0; n < o; n += 1) {
        for (a = this.stylesList[n], x = !1, l.length = 0, t = 0; t < s; t += 1) (r = this.shapes[t]).styles.indexOf(a) !== -1 && (l.push(r), x = r._isAnimated || x);
        l.length > 1 && x && this.setShapesAsAnimated(l);
      }
    }, SVGShapeElement.prototype.setShapesAsAnimated = function(t) {
      var r, n = t.length;
      for (r = 0; r < n; r += 1) t[r].setAsAnimated();
    }, SVGShapeElement.prototype.createStyleElement = function(t, r) {
      var n, a = new SVGStyleData(t, r), s = a.pElem;
      return t.ty === "st" ? n = new SVGStrokeStyleData(this, t, a) : t.ty === "fl" ? n = new SVGFillStyleData(this, t, a) : t.ty === "gf" || t.ty === "gs" ? (n = new (t.ty === "gf" ? SVGGradientFillStyleData : SVGGradientStrokeStyleData)(this, t, a), this.globalData.defs.appendChild(n.gf), n.maskId && (this.globalData.defs.appendChild(n.ms), this.globalData.defs.appendChild(n.of), s.setAttribute("mask", "url(" + getLocationHref() + "#" + n.maskId + ")"))) : t.ty === "no" && (n = new SVGNoStyleData(this, t, a)), t.ty !== "st" && t.ty !== "gs" || (s.setAttribute("stroke-linecap", lineCapEnum[t.lc || 2]), s.setAttribute("stroke-linejoin", lineJoinEnum[t.lj || 2]), s.setAttribute("fill-opacity", "0"), t.lj === 1 && s.setAttribute("stroke-miterlimit", t.ml)), t.r === 2 && s.setAttribute("fill-rule", "evenodd"), t.ln && s.setAttribute("id", t.ln), t.cl && s.setAttribute("class", t.cl), t.bm && (s.style["mix-blend-mode"] = getBlendMode(t.bm)), this.stylesList.push(a), this.addToAnimatedContents(t, n), n;
    }, SVGShapeElement.prototype.createGroupElement = function(t) {
      var r = new ShapeGroupData();
      return t.ln && r.gr.setAttribute("id", t.ln), t.cl && r.gr.setAttribute("class", t.cl), t.bm && (r.gr.style["mix-blend-mode"] = getBlendMode(t.bm)), r;
    }, SVGShapeElement.prototype.createTransformElement = function(t, r) {
      var n = TransformPropertyFactory.getTransformProperty(this, t, this), a = new SVGTransformData(n, n.o, r);
      return this.addToAnimatedContents(t, a), a;
    }, SVGShapeElement.prototype.createShapeElement = function(t, r, n) {
      var a = 4;
      t.ty === "rc" ? a = 5 : t.ty === "el" ? a = 6 : t.ty === "sr" && (a = 7);
      var s = new SVGShapeData(r, n, ShapePropertyFactory.getShapeProp(this, t, a, this));
      return this.shapes.push(s), this.addShapeToModifiers(s), this.addToAnimatedContents(t, s), s;
    }, SVGShapeElement.prototype.addToAnimatedContents = function(t, r) {
      for (var n = 0, a = this.animatedContents.length; n < a; ) {
        if (this.animatedContents[n].element === r) return;
        n += 1;
      }
      this.animatedContents.push({ fn: SVGElementsRenderer.createRenderFunction(t), element: r, data: t });
    }, SVGShapeElement.prototype.setElementStyles = function(t) {
      var r, n = t.styles, a = this.stylesList.length;
      for (r = 0; r < a; r += 1) this.stylesList[r].closed || n.push(this.stylesList[r]);
    }, SVGShapeElement.prototype.reloadShapes = function() {
      var t;
      this._isFirstFrame = !0;
      var r = this.itemsData.length;
      for (t = 0; t < r; t += 1) this.prevViewData[t] = this.itemsData[t];
      for (this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes(), r = this.dynamicProperties.length, t = 0; t < r; t += 1) this.dynamicProperties[t].getValue();
      this.renderModifiers();
    }, SVGShapeElement.prototype.searchShapes = function(t, r, n, a, s, o, l) {
      var x, j, Z, V, $, X, W = [].concat(o), Y = t.length - 1, U = [], G = [];
      for (x = Y; x >= 0; x -= 1) {
        if ((X = this.searchProcessedElement(t[x])) ? r[x] = n[X - 1] : t[x]._render = l, t[x].ty === "fl" || t[x].ty === "st" || t[x].ty === "gf" || t[x].ty === "gs" || t[x].ty === "no") X ? r[x].style.closed = !1 : r[x] = this.createStyleElement(t[x], s), t[x]._render && r[x].style.pElem.parentNode !== a && a.appendChild(r[x].style.pElem), U.push(r[x].style);
        else if (t[x].ty === "gr") {
          if (X) for (Z = r[x].it.length, j = 0; j < Z; j += 1) r[x].prevViewData[j] = r[x].it[j];
          else r[x] = this.createGroupElement(t[x]);
          this.searchShapes(t[x].it, r[x].it, r[x].prevViewData, r[x].gr, s + 1, W, l), t[x]._render && r[x].gr.parentNode !== a && a.appendChild(r[x].gr);
        } else t[x].ty === "tr" ? (X || (r[x] = this.createTransformElement(t[x], a)), V = r[x].transform, W.push(V)) : t[x].ty === "sh" || t[x].ty === "rc" || t[x].ty === "el" || t[x].ty === "sr" ? (X || (r[x] = this.createShapeElement(t[x], W, s)), this.setElementStyles(r[x])) : t[x].ty === "tm" || t[x].ty === "rd" || t[x].ty === "ms" || t[x].ty === "pb" || t[x].ty === "zz" || t[x].ty === "op" ? (X ? ($ = r[x]).closed = !1 : (($ = ShapeModifiers.getModifier(t[x].ty)).init(this, t[x]), r[x] = $, this.shapeModifiers.push($)), G.push($)) : t[x].ty === "rp" && (X ? ($ = r[x]).closed = !0 : ($ = ShapeModifiers.getModifier(t[x].ty), r[x] = $, $.init(this, t, x, r), this.shapeModifiers.push($), l = !1), G.push($));
        this.addProcessedElement(t[x], x + 1);
      }
      for (Y = U.length, x = 0; x < Y; x += 1) U[x].closed = !0;
      for (Y = G.length, x = 0; x < Y; x += 1) G[x].closed = !0;
    }, SVGShapeElement.prototype.renderInnerContent = function() {
      var t;
      this.renderModifiers();
      var r = this.stylesList.length;
      for (t = 0; t < r; t += 1) this.stylesList[t].reset();
      for (this.renderShape(), t = 0; t < r; t += 1) (this.stylesList[t]._mdf || this._isFirstFrame) && (this.stylesList[t].msElem && (this.stylesList[t].msElem.setAttribute("d", this.stylesList[t].d), this.stylesList[t].d = "M0 0" + this.stylesList[t].d), this.stylesList[t].pElem.setAttribute("d", this.stylesList[t].d || "M0 0"));
    }, SVGShapeElement.prototype.renderShape = function() {
      var t, r, n = this.animatedContents.length;
      for (t = 0; t < n; t += 1) r = this.animatedContents[t], (this._isFirstFrame || r.element._isAnimated) && r.data !== !0 && r.fn(r.data, r.element, this._isFirstFrame);
    }, SVGShapeElement.prototype.destroy = function() {
      this.destroyBaseElement(), this.shapesData = null, this.itemsData = null;
    }, LetterProps.prototype.update = function(t, r, n, a, s, o) {
      this._mdf.o = !1, this._mdf.sw = !1, this._mdf.sc = !1, this._mdf.fc = !1, this._mdf.m = !1, this._mdf.p = !1;
      var l = !1;
      return this.o !== t && (this.o = t, this._mdf.o = !0, l = !0), this.sw !== r && (this.sw = r, this._mdf.sw = !0, l = !0), this.sc !== n && (this.sc = n, this._mdf.sc = !0, l = !0), this.fc !== a && (this.fc = a, this._mdf.fc = !0, l = !0), this.m !== s && (this.m = s, this._mdf.m = !0, l = !0), !o.length || this.p[0] === o[0] && this.p[1] === o[1] && this.p[4] === o[4] && this.p[5] === o[5] && this.p[12] === o[12] && this.p[13] === o[13] || (this.p = o, this._mdf.p = !0, l = !0), l;
    }, TextProperty.prototype.defaultBoxWidth = [0, 0], TextProperty.prototype.copyData = function(t, r) {
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
      return t;
    }, TextProperty.prototype.setCurrentData = function(t) {
      t.__complete || this.completeTextData(t), this.currentData = t, this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth, this._mdf = !0;
    }, TextProperty.prototype.searchProperty = function() {
      return this.searchKeyframes();
    }, TextProperty.prototype.searchKeyframes = function() {
      return this.kf = this.data.d.k.length > 1, this.kf && this.addEffect(this.getKeyframeValue.bind(this)), this.kf;
    }, TextProperty.prototype.addEffect = function(t) {
      this.effectsSequence.push(t), this.elem.addDynamicProperty(this);
    }, TextProperty.prototype.getValue = function(t) {
      if (this.elem.globalData.frameId !== this.frameId && this.effectsSequence.length || t) {
        this.currentData.t = this.data.d.k[this.keysIndex].s.t;
        var r = this.currentData, n = this.keysIndex;
        if (this.lock) this.setCurrentData(this.currentData);
        else {
          var a;
          this.lock = !0, this._mdf = !1;
          var s = this.effectsSequence.length, o = t || this.data.d.k[this.keysIndex].s;
          for (a = 0; a < s; a += 1) o = n !== this.keysIndex ? this.effectsSequence[a](o, o.t) : this.effectsSequence[a](this.currentData, o.t);
          r !== o && this.setCurrentData(o), this.v = this.currentData, this.pv = this.v, this.lock = !1, this.frameId = this.elem.globalData.frameId;
        }
      }
    }, TextProperty.prototype.getKeyframeValue = function() {
      for (var t = this.data.d.k, r = this.elem.comp.renderedFrame, n = 0, a = t.length; n <= a - 1 && !(n === a - 1 || t[n + 1].t > r); ) n += 1;
      return this.keysIndex !== n && (this.keysIndex = n), this.data.d.k[this.keysIndex].s;
    }, TextProperty.prototype.buildFinalText = function(t) {
      for (var r, n, a = [], s = 0, o = t.length, l = !1, x = !1, j = ""; s < o; ) l = x, x = !1, r = t.charCodeAt(s), j = t.charAt(s), FontManager.isCombinedCharacter(r) ? l = !0 : r >= 55296 && r <= 56319 ? FontManager.isRegionalFlag(t, s) ? j = t.substr(s, 14) : (n = t.charCodeAt(s + 1)) >= 56320 && n <= 57343 && (FontManager.isModifier(r, n) ? (j = t.substr(s, 2), l = !0) : j = FontManager.isFlagEmoji(t.substr(s, 4)) ? t.substr(s, 4) : t.substr(s, 2)) : r > 56319 ? (n = t.charCodeAt(s + 1), FontManager.isVariationSelector(r) && (l = !0)) : FontManager.isZeroWidthJoiner(r) && (l = !0, x = !0), l ? (a[a.length - 1] += j, l = !1) : a.push(j), s += j.length;
      return a;
    }, TextProperty.prototype.completeTextData = function(t) {
      t.__complete = !0;
      var r, n, a, s, o, l, x, j = this.elem.globalData.fontManager, Z = this.data, V = [], $ = 0, X = Z.m.g, W = 0, Y = 0, U = 0, G = [], K = 0, J = 0, ee = j.getFontByName(t.f), te = 0, re = getFontProperties(ee);
      t.fWeight = re.weight, t.fStyle = re.style, t.finalSize = t.s, t.finalText = this.buildFinalText(t.t), n = t.finalText.length, t.finalLineHeight = t.lh;
      var ae, ie = t.tr / 1e3 * t.finalSize;
      if (t.sz) for (var ce, he, oe = !0, le = t.sz[0], pe = t.sz[1]; oe; ) {
        ce = 0, K = 0, n = (he = this.buildFinalText(t.t)).length, ie = t.tr / 1e3 * t.finalSize;
        var de = -1;
        for (r = 0; r < n; r += 1) ae = he[r].charCodeAt(0), a = !1, he[r] === " " ? de = r : ae !== 13 && ae !== 3 || (K = 0, a = !0, ce += t.finalLineHeight || 1.2 * t.finalSize), j.chars ? (x = j.getCharData(he[r], ee.fStyle, ee.fFamily), te = a ? 0 : x.w * t.finalSize / 100) : te = j.measureText(he[r], t.f, t.finalSize), K + te > le && he[r] !== " " ? (de === -1 ? n += 1 : r = de, ce += t.finalLineHeight || 1.2 * t.finalSize, he.splice(r, de === r ? 1 : 0, "\r"), de = -1, K = 0) : (K += te, K += ie);
        ce += ee.ascent * t.finalSize / 100, this.canResize && t.finalSize > this.minimumFontSize && pe < ce ? (t.finalSize -= 1, t.finalLineHeight = t.finalSize * t.lh / t.s) : (t.finalText = he, n = t.finalText.length, oe = !1);
      }
      K = -ie, te = 0;
      var se, ue = 0;
      for (r = 0; r < n; r += 1) if (a = !1, (ae = (se = t.finalText[r]).charCodeAt(0)) === 13 || ae === 3 ? (ue = 0, G.push(K), J = K > J ? K : J, K = -2 * ie, s = "", a = !0, U += 1) : s = se, j.chars ? (x = j.getCharData(se, ee.fStyle, j.getFontByName(t.f).fFamily), te = a ? 0 : x.w * t.finalSize / 100) : te = j.measureText(s, t.f, t.finalSize), se === " " ? ue += te + ie : (K += te + ie + ue, ue = 0), V.push({ l: te, an: te, add: W, n: a, anIndexes: [], val: s, line: U, animatorJustifyOffset: 0 }), X == 2) {
        if (W += te, s === "" || s === " " || r === n - 1) {
          for (s !== "" && s !== " " || (W -= te); Y <= r; ) V[Y].an = W, V[Y].ind = $, V[Y].extra = te, Y += 1;
          $ += 1, W = 0;
        }
      } else if (X == 3) {
        if (W += te, s === "" || r === n - 1) {
          for (s === "" && (W -= te); Y <= r; ) V[Y].an = W, V[Y].ind = $, V[Y].extra = te, Y += 1;
          W = 0, $ += 1;
        }
      } else V[$].ind = $, V[$].extra = 0, $ += 1;
      if (t.l = V, J = K > J ? K : J, G.push(K), t.sz) t.boxWidth = t.sz[0], t.justifyOffset = 0;
      else switch (t.boxWidth = J, t.j) {
        case 1:
          t.justifyOffset = -t.boxWidth;
          break;
        case 2:
          t.justifyOffset = -t.boxWidth / 2;
          break;
        default:
          t.justifyOffset = 0;
      }
      t.lineWidths = G;
      var fe, ge, ne, ve, me = Z.a;
      l = me.length;
      var xe = [];
      for (o = 0; o < l; o += 1) {
        for ((fe = me[o]).a.sc && (t.strokeColorAnim = !0), fe.a.sw && (t.strokeWidthAnim = !0), (fe.a.fc || fe.a.fh || fe.a.fs || fe.a.fb) && (t.fillColorAnim = !0), ve = 0, ne = fe.s.b, r = 0; r < n; r += 1) (ge = V[r]).anIndexes[o] = ve, (ne == 1 && ge.val !== "" || ne == 2 && ge.val !== "" && ge.val !== " " || ne == 3 && (ge.n || ge.val == " " || r == n - 1) || ne == 4 && (ge.n || r == n - 1)) && (fe.s.rn === 1 && xe.push(ve), ve += 1);
        Z.a[o].s.totalChars = ve;
        var Ee, Se = -1;
        if (fe.s.rn === 1) for (r = 0; r < n; r += 1) Se != (ge = V[r]).anIndexes[o] && (Se = ge.anIndexes[o], Ee = xe.splice(Math.floor(Math.random() * xe.length), 1)[0]), ge.anIndexes[o] = Ee;
      }
      t.yOffset = t.finalLineHeight || 1.2 * t.finalSize, t.ls = t.ls || 0, t.ascent = ee.ascent * t.finalSize / 100;
    }, TextProperty.prototype.updateDocumentData = function(t, r) {
      r = r === void 0 ? this.keysIndex : r;
      var n = this.copyData({}, this.data.d.k[r].s);
      n = this.copyData(n, t), this.data.d.k[r].s = n, this.recalculate(r), this.setCurrentData(n), this.elem.addDynamicProperty(this);
    }, TextProperty.prototype.recalculate = function(t) {
      var r = this.data.d.k[t].s;
      r.__complete = !1, this.keysIndex = 0, this._isFirstFrame = !0, this.getValue(r);
    }, TextProperty.prototype.canResizeFont = function(t) {
      this.canResize = t, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
    }, TextProperty.prototype.setMinimumFontSize = function(t) {
      this.minimumFontSize = Math.floor(t) || 1, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
    };
    var TextSelectorProp = (function() {
      var t = Math.max, r = Math.min, n = Math.floor;
      function a(s, o) {
        this._currentTextLength = -1, this.k = !1, this.data = o, this.elem = s, this.comp = s.comp, this.finalS = 0, this.finalE = 0, this.initDynamicPropertyContainer(s), this.s = PropertyFactory.getProp(s, o.s || { k: 0 }, 0, 0, this), this.e = "e" in o ? PropertyFactory.getProp(s, o.e, 0, 0, this) : { v: 100 }, this.o = PropertyFactory.getProp(s, o.o || { k: 0 }, 0, 0, this), this.xe = PropertyFactory.getProp(s, o.xe || { k: 0 }, 0, 0, this), this.ne = PropertyFactory.getProp(s, o.ne || { k: 0 }, 0, 0, this), this.sm = PropertyFactory.getProp(s, o.sm || { k: 100 }, 0, 0, this), this.a = PropertyFactory.getProp(s, o.a, 0, 0.01, this), this.dynamicProperties.length || this.getValue();
      }
      return a.prototype = { getMult: function(s) {
        this._currentTextLength !== this.elem.textProperty.currentData.l.length && this.getValue();
        var o = 0, l = 0, x = 1, j = 1;
        this.ne.v > 0 ? o = this.ne.v / 100 : l = -this.ne.v / 100, this.xe.v > 0 ? x = 1 - this.xe.v / 100 : j = 1 + this.xe.v / 100;
        var Z = BezierFactory.getBezierEasing(o, l, x, j).get, V = 0, $ = this.finalS, X = this.finalE, W = this.data.sh;
        if (W === 2) V = Z(V = X === $ ? s >= X ? 1 : 0 : t(0, r(0.5 / (X - $) + (s - $) / (X - $), 1)));
        else if (W === 3) V = Z(V = X === $ ? s >= X ? 0 : 1 : 1 - t(0, r(0.5 / (X - $) + (s - $) / (X - $), 1)));
        else if (W === 4) X === $ ? V = 0 : (V = t(0, r(0.5 / (X - $) + (s - $) / (X - $), 1))) < 0.5 ? V *= 2 : V = 1 - 2 * (V - 0.5), V = Z(V);
        else if (W === 5) {
          if (X === $) V = 0;
          else {
            var Y = X - $, U = -Y / 2 + (s = r(t(0, s + 0.5 - $), X - $)), G = Y / 2;
            V = Math.sqrt(1 - U * U / (G * G));
          }
          V = Z(V);
        } else W === 6 ? (X === $ ? V = 0 : (s = r(t(0, s + 0.5 - $), X - $), V = (1 + Math.cos(Math.PI + 2 * Math.PI * s / (X - $))) / 2), V = Z(V)) : (s >= n($) && (V = t(0, r(s - $ < 0 ? r(X, 1) - ($ - s) : X - s, 1))), V = Z(V));
        if (this.sm.v !== 100) {
          var K = 0.01 * this.sm.v;
          K === 0 && (K = 1e-8);
          var J = 0.5 - 0.5 * K;
          V < J ? V = 0 : (V = (V - J) / K) > 1 && (V = 1);
        }
        return V * this.a.v;
      }, getValue: function(s) {
        this.iterateDynamicProperties(), this._mdf = s || this._mdf, this._currentTextLength = this.elem.textProperty.currentData.l.length || 0, s && this.data.r === 2 && (this.e.v = this._currentTextLength);
        var o = this.data.r === 2 ? 1 : 100 / this.data.totalChars, l = this.o.v / o, x = this.s.v / o + l, j = this.e.v / o + l;
        if (x > j) {
          var Z = x;
          x = j, j = Z;
        }
        this.finalS = x, this.finalE = j;
      } }, extendPrototype([DynamicPropertyContainer], a), { getTextSelectorProp: function(s, o, l) {
        return new a(s, o);
      } };
    })();
    function TextAnimatorDataProperty(t, r, n) {
      var a = { propType: !1 }, s = PropertyFactory.getProp, o = r.a;
      this.a = { r: o.r ? s(t, o.r, 0, degToRads, n) : a, rx: o.rx ? s(t, o.rx, 0, degToRads, n) : a, ry: o.ry ? s(t, o.ry, 0, degToRads, n) : a, sk: o.sk ? s(t, o.sk, 0, degToRads, n) : a, sa: o.sa ? s(t, o.sa, 0, degToRads, n) : a, s: o.s ? s(t, o.s, 1, 0.01, n) : a, a: o.a ? s(t, o.a, 1, 0, n) : a, o: o.o ? s(t, o.o, 0, 0.01, n) : a, p: o.p ? s(t, o.p, 1, 0, n) : a, sw: o.sw ? s(t, o.sw, 0, 0, n) : a, sc: o.sc ? s(t, o.sc, 1, 0, n) : a, fc: o.fc ? s(t, o.fc, 1, 0, n) : a, fh: o.fh ? s(t, o.fh, 0, 0, n) : a, fs: o.fs ? s(t, o.fs, 0, 0.01, n) : a, fb: o.fb ? s(t, o.fb, 0, 0.01, n) : a, t: o.t ? s(t, o.t, 0, 0, n) : a }, this.s = TextSelectorProp.getTextSelectorProp(t, r.s, n), this.s.t = r.s.t;
    }
    function TextAnimatorProperty(t, r, n) {
      this._isFirstFrame = !0, this._hasMaskedPath = !1, this._frameId = -1, this._textData = t, this._renderType = r, this._elem = n, this._animatorsData = createSizedArray(this._textData.a.length), this._pathData = {}, this._moreOptions = { alignment: {} }, this.renderedLetters = [], this.lettersChangedFlag = !1, this.initDynamicPropertyContainer(n);
    }
    function ITextElement() {
    }
    TextAnimatorProperty.prototype.searchProperties = function() {
      var t, r, n = this._textData.a.length, a = PropertyFactory.getProp;
      for (t = 0; t < n; t += 1) r = this._textData.a[t], this._animatorsData[t] = new TextAnimatorDataProperty(this._elem, r, this);
      this._textData.p && "m" in this._textData.p ? (this._pathData = { a: a(this._elem, this._textData.p.a, 0, 0, this), f: a(this._elem, this._textData.p.f, 0, 0, this), l: a(this._elem, this._textData.p.l, 0, 0, this), r: a(this._elem, this._textData.p.r, 0, 0, this), p: a(this._elem, this._textData.p.p, 0, 0, this), m: this._elem.maskManager.getMaskProperty(this._textData.p.m) }, this._hasMaskedPath = !0) : this._hasMaskedPath = !1, this._moreOptions.alignment = a(this._elem, this._textData.m.a, 1, 0, this);
    }, TextAnimatorProperty.prototype.getMeasures = function(t, r) {
      if (this.lettersChangedFlag = r, this._mdf || this._isFirstFrame || r || this._hasMaskedPath && this._pathData.m._mdf) {
        this._isFirstFrame = !1;
        var n, a, s, o, l, x, j, Z, V, $, X, W, Y, U, G, K, J, ee, te, re = this._moreOptions.alignment.v, ae = this._animatorsData, ie = this._textData, ce = this.mHelper, he = this._renderType, oe = this.renderedLetters.length, le = t.l;
        if (this._hasMaskedPath) {
          if (te = this._pathData.m, !this._pathData.n || this._pathData._mdf) {
            var pe, de = te.v;
            for (this._pathData.r.v && (de = de.reverse()), l = { tLength: 0, segments: [] }, o = de._length - 1, K = 0, s = 0; s < o; s += 1) pe = bez.buildBezierData(de.v[s], de.v[s + 1], [de.o[s][0] - de.v[s][0], de.o[s][1] - de.v[s][1]], [de.i[s + 1][0] - de.v[s + 1][0], de.i[s + 1][1] - de.v[s + 1][1]]), l.tLength += pe.segmentLength, l.segments.push(pe), K += pe.segmentLength;
            s = o, te.v.c && (pe = bez.buildBezierData(de.v[s], de.v[0], [de.o[s][0] - de.v[s][0], de.o[s][1] - de.v[s][1]], [de.i[0][0] - de.v[0][0], de.i[0][1] - de.v[0][1]]), l.tLength += pe.segmentLength, l.segments.push(pe), K += pe.segmentLength), this._pathData.pi = l;
          }
          if (l = this._pathData.pi, x = this._pathData.f.v, X = 0, $ = 1, Z = 0, V = !0, U = l.segments, x < 0 && te.v.c) for (l.tLength < Math.abs(x) && (x = -Math.abs(x) % l.tLength), $ = (Y = U[X = U.length - 1].points).length - 1; x < 0; ) x += Y[$].partialLength, ($ -= 1) < 0 && ($ = (Y = U[X -= 1].points).length - 1);
          W = (Y = U[X].points)[$ - 1], G = (j = Y[$]).partialLength;
        }
        o = le.length, n = 0, a = 0;
        var se, ue, fe, ge, ne, ve = 1.2 * t.finalSize * 0.714, me = !0;
        fe = ae.length;
        var xe, Ee, Se, _e, Ce, Te, we, Re, Ae, Pe, ke, ye, Me = -1, be = x, De = X, Fe = $, Le = -1, Ne = "", Ie = this.defaultPropsArray;
        if (t.j === 2 || t.j === 1) {
          var je = 0, Ze = 0, $e = t.j === 2 ? -0.5 : -1, We = 0, Be = !0;
          for (s = 0; s < o; s += 1) if (le[s].n) {
            for (je && (je += Ze); We < s; ) le[We].animatorJustifyOffset = je, We += 1;
            je = 0, Be = !0;
          } else {
            for (ue = 0; ue < fe; ue += 1) (se = ae[ue].a).t.propType && (Be && t.j === 2 && (Ze += se.t.v * $e), (ne = ae[ue].s.getMult(le[s].anIndexes[ue], ie.a[ue].s.totalChars)).length ? je += se.t.v * ne[0] * $e : je += se.t.v * ne * $e);
            Be = !1;
          }
          for (je && (je += Ze); We < s; ) le[We].animatorJustifyOffset = je, We += 1;
        }
        for (s = 0; s < o; s += 1) {
          if (ce.reset(), _e = 1, le[s].n) n = 0, a += t.yOffset, a += me ? 1 : 0, x = be, me = !1, this._hasMaskedPath && ($ = Fe, W = (Y = U[X = De].points)[$ - 1], G = (j = Y[$]).partialLength, Z = 0), Ne = "", ke = "", Ae = "", ye = "", Ie = this.defaultPropsArray;
          else {
            if (this._hasMaskedPath) {
              if (Le !== le[s].line) {
                switch (t.j) {
                  case 1:
                    x += K - t.lineWidths[le[s].line];
                    break;
                  case 2:
                    x += (K - t.lineWidths[le[s].line]) / 2;
                }
                Le = le[s].line;
              }
              Me !== le[s].ind && (le[Me] && (x += le[Me].extra), x += le[s].an / 2, Me = le[s].ind), x += re[0] * le[s].an * 5e-3;
              var Ue = 0;
              for (ue = 0; ue < fe; ue += 1) (se = ae[ue].a).p.propType && ((ne = ae[ue].s.getMult(le[s].anIndexes[ue], ie.a[ue].s.totalChars)).length ? Ue += se.p.v[0] * ne[0] : Ue += se.p.v[0] * ne), se.a.propType && ((ne = ae[ue].s.getMult(le[s].anIndexes[ue], ie.a[ue].s.totalChars)).length ? Ue += se.a.v[0] * ne[0] : Ue += se.a.v[0] * ne);
              for (V = !0, this._pathData.a.v && (x = 0.5 * le[0].an + (K - this._pathData.f.v - 0.5 * le[0].an - 0.5 * le[le.length - 1].an) * Me / (o - 1), x += this._pathData.f.v); V; ) Z + G >= x + Ue || !Y ? (J = (x + Ue - Z) / j.partialLength, Ee = W.point[0] + (j.point[0] - W.point[0]) * J, Se = W.point[1] + (j.point[1] - W.point[1]) * J, ce.translate(-re[0] * le[s].an * 5e-3, -re[1] * ve * 0.01), V = !1) : Y && (Z += j.partialLength, ($ += 1) >= Y.length && ($ = 0, U[X += 1] ? Y = U[X].points : te.v.c ? ($ = 0, Y = U[X = 0].points) : (Z -= j.partialLength, Y = null)), Y && (W = j, G = (j = Y[$]).partialLength));
              xe = le[s].an / 2 - le[s].add, ce.translate(-xe, 0, 0);
            } else xe = le[s].an / 2 - le[s].add, ce.translate(-xe, 0, 0), ce.translate(-re[0] * le[s].an * 5e-3, -re[1] * ve * 0.01, 0);
            for (ue = 0; ue < fe; ue += 1) (se = ae[ue].a).t.propType && (ne = ae[ue].s.getMult(le[s].anIndexes[ue], ie.a[ue].s.totalChars), n === 0 && t.j === 0 || (this._hasMaskedPath ? ne.length ? x += se.t.v * ne[0] : x += se.t.v * ne : ne.length ? n += se.t.v * ne[0] : n += se.t.v * ne));
            for (t.strokeWidthAnim && (Te = t.sw || 0), t.strokeColorAnim && (Ce = t.sc ? [t.sc[0], t.sc[1], t.sc[2]] : [0, 0, 0]), t.fillColorAnim && t.fc && (we = [t.fc[0], t.fc[1], t.fc[2]]), ue = 0; ue < fe; ue += 1) (se = ae[ue].a).a.propType && ((ne = ae[ue].s.getMult(le[s].anIndexes[ue], ie.a[ue].s.totalChars)).length ? ce.translate(-se.a.v[0] * ne[0], -se.a.v[1] * ne[1], se.a.v[2] * ne[2]) : ce.translate(-se.a.v[0] * ne, -se.a.v[1] * ne, se.a.v[2] * ne));
            for (ue = 0; ue < fe; ue += 1) (se = ae[ue].a).s.propType && ((ne = ae[ue].s.getMult(le[s].anIndexes[ue], ie.a[ue].s.totalChars)).length ? ce.scale(1 + (se.s.v[0] - 1) * ne[0], 1 + (se.s.v[1] - 1) * ne[1], 1) : ce.scale(1 + (se.s.v[0] - 1) * ne, 1 + (se.s.v[1] - 1) * ne, 1));
            for (ue = 0; ue < fe; ue += 1) {
              if (se = ae[ue].a, ne = ae[ue].s.getMult(le[s].anIndexes[ue], ie.a[ue].s.totalChars), se.sk.propType && (ne.length ? ce.skewFromAxis(-se.sk.v * ne[0], se.sa.v * ne[1]) : ce.skewFromAxis(-se.sk.v * ne, se.sa.v * ne)), se.r.propType && (ne.length ? ce.rotateZ(-se.r.v * ne[2]) : ce.rotateZ(-se.r.v * ne)), se.ry.propType && (ne.length ? ce.rotateY(se.ry.v * ne[1]) : ce.rotateY(se.ry.v * ne)), se.rx.propType && (ne.length ? ce.rotateX(se.rx.v * ne[0]) : ce.rotateX(se.rx.v * ne)), se.o.propType && (ne.length ? _e += (se.o.v * ne[0] - _e) * ne[0] : _e += (se.o.v * ne - _e) * ne), t.strokeWidthAnim && se.sw.propType && (ne.length ? Te += se.sw.v * ne[0] : Te += se.sw.v * ne), t.strokeColorAnim && se.sc.propType) for (Re = 0; Re < 3; Re += 1) ne.length ? Ce[Re] += (se.sc.v[Re] - Ce[Re]) * ne[0] : Ce[Re] += (se.sc.v[Re] - Ce[Re]) * ne;
              if (t.fillColorAnim && t.fc) {
                if (se.fc.propType) for (Re = 0; Re < 3; Re += 1) ne.length ? we[Re] += (se.fc.v[Re] - we[Re]) * ne[0] : we[Re] += (se.fc.v[Re] - we[Re]) * ne;
                se.fh.propType && (we = ne.length ? addHueToRGB(we, se.fh.v * ne[0]) : addHueToRGB(we, se.fh.v * ne)), se.fs.propType && (we = ne.length ? addSaturationToRGB(we, se.fs.v * ne[0]) : addSaturationToRGB(we, se.fs.v * ne)), se.fb.propType && (we = ne.length ? addBrightnessToRGB(we, se.fb.v * ne[0]) : addBrightnessToRGB(we, se.fb.v * ne));
              }
            }
            for (ue = 0; ue < fe; ue += 1) (se = ae[ue].a).p.propType && (ne = ae[ue].s.getMult(le[s].anIndexes[ue], ie.a[ue].s.totalChars), this._hasMaskedPath ? ne.length ? ce.translate(0, se.p.v[1] * ne[0], -se.p.v[2] * ne[1]) : ce.translate(0, se.p.v[1] * ne, -se.p.v[2] * ne) : ne.length ? ce.translate(se.p.v[0] * ne[0], se.p.v[1] * ne[1], -se.p.v[2] * ne[2]) : ce.translate(se.p.v[0] * ne, se.p.v[1] * ne, -se.p.v[2] * ne));
            if (t.strokeWidthAnim && (Ae = Te < 0 ? 0 : Te), t.strokeColorAnim && (Pe = "rgb(" + Math.round(255 * Ce[0]) + "," + Math.round(255 * Ce[1]) + "," + Math.round(255 * Ce[2]) + ")"), t.fillColorAnim && t.fc && (ke = "rgb(" + Math.round(255 * we[0]) + "," + Math.round(255 * we[1]) + "," + Math.round(255 * we[2]) + ")"), this._hasMaskedPath) {
              if (ce.translate(0, -t.ls), ce.translate(0, re[1] * ve * 0.01 + a, 0), this._pathData.p.v) {
                ee = (j.point[1] - W.point[1]) / (j.point[0] - W.point[0]);
                var Qe = 180 * Math.atan(ee) / Math.PI;
                j.point[0] < W.point[0] && (Qe += 180), ce.rotate(-Qe * Math.PI / 180);
              }
              ce.translate(Ee, Se, 0), x -= re[0] * le[s].an * 5e-3, le[s + 1] && Me !== le[s + 1].ind && (x += le[s].an / 2, x += 1e-3 * t.tr * t.finalSize);
            } else {
              switch (ce.translate(n, a, 0), t.ps && ce.translate(t.ps[0], t.ps[1] + t.ascent, 0), t.j) {
                case 1:
                  ce.translate(le[s].animatorJustifyOffset + t.justifyOffset + (t.boxWidth - t.lineWidths[le[s].line]), 0, 0);
                  break;
                case 2:
                  ce.translate(le[s].animatorJustifyOffset + t.justifyOffset + (t.boxWidth - t.lineWidths[le[s].line]) / 2, 0, 0);
              }
              ce.translate(0, -t.ls), ce.translate(xe, 0, 0), ce.translate(re[0] * le[s].an * 5e-3, re[1] * ve * 0.01, 0), n += le[s].l + 1e-3 * t.tr * t.finalSize;
            }
            he === "html" ? Ne = ce.toCSS() : he === "svg" ? Ne = ce.to2dCSS() : Ie = [ce.props[0], ce.props[1], ce.props[2], ce.props[3], ce.props[4], ce.props[5], ce.props[6], ce.props[7], ce.props[8], ce.props[9], ce.props[10], ce.props[11], ce.props[12], ce.props[13], ce.props[14], ce.props[15]], ye = _e;
          }
          oe <= s ? (ge = new LetterProps(ye, Ae, Pe, ke, Ne, Ie), this.renderedLetters.push(ge), oe += 1, this.lettersChangedFlag = !0) : (ge = this.renderedLetters[s], this.lettersChangedFlag = ge.update(ye, Ae, Pe, ke, Ne, Ie) || this.lettersChangedFlag);
        }
      }
    }, TextAnimatorProperty.prototype.getValue = function() {
      this._elem.globalData.frameId !== this._frameId && (this._frameId = this._elem.globalData.frameId, this.iterateDynamicProperties());
    }, TextAnimatorProperty.prototype.mHelper = new Matrix(), TextAnimatorProperty.prototype.defaultPropsArray = [], extendPrototype([DynamicPropertyContainer], TextAnimatorProperty), ITextElement.prototype.initElement = function(t, r, n) {
      this.lettersChangedFlag = !0, this.initFrame(), this.initBaseData(t, r, n), this.textProperty = new TextProperty(this, t.t, this.dynamicProperties), this.textAnimator = new TextAnimatorProperty(t.t, this.renderType, this), this.initTransform(t, r, n), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide(), this.textAnimator.searchProperties(this.dynamicProperties);
    }, ITextElement.prototype.prepareFrame = function(t) {
      this._mdf = !1, this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange);
    }, ITextElement.prototype.createPathShape = function(t, r) {
      var n, a, s = r.length, o = "";
      for (n = 0; n < s; n += 1) r[n].ty === "sh" && (a = r[n].ks.k, o += buildShapeString(a, a.i.length, !0, t));
      return o;
    }, ITextElement.prototype.updateDocumentData = function(t, r) {
      this.textProperty.updateDocumentData(t, r);
    }, ITextElement.prototype.canResizeFont = function(t) {
      this.textProperty.canResizeFont(t);
    }, ITextElement.prototype.setMinimumFontSize = function(t) {
      this.textProperty.setMinimumFontSize(t);
    }, ITextElement.prototype.applyTextPropertiesToMatrix = function(t, r, n, a, s) {
      switch (t.ps && r.translate(t.ps[0], t.ps[1] + t.ascent, 0), r.translate(0, -t.ls, 0), t.j) {
        case 1:
          r.translate(t.justifyOffset + (t.boxWidth - t.lineWidths[n]), 0, 0);
          break;
        case 2:
          r.translate(t.justifyOffset + (t.boxWidth - t.lineWidths[n]) / 2, 0, 0);
      }
      r.translate(a, s, 0);
    }, ITextElement.prototype.buildColor = function(t) {
      return "rgb(" + Math.round(255 * t[0]) + "," + Math.round(255 * t[1]) + "," + Math.round(255 * t[2]) + ")";
    }, ITextElement.prototype.emptyProp = new LetterProps(), ITextElement.prototype.destroy = function() {
    }, ITextElement.prototype.validateText = function() {
      (this.textProperty._mdf || this.textProperty._isFirstFrame) && (this.buildNewText(), this.textProperty._isFirstFrame = !1, this.textProperty._mdf = !1);
    };
    var emptyShapeData = { shapes: [] };
    function SVGTextLottieElement(t, r, n) {
      this.textSpans = [], this.renderType = "svg", this.initElement(t, r, n);
    }
    function ISolidElement(t, r, n) {
      this.initElement(t, r, n);
    }
    function NullElement(t, r, n) {
      this.initFrame(), this.initBaseData(t, r, n), this.initFrame(), this.initTransform(t, r, n), this.initHierarchy();
    }
    function SVGRendererBase() {
    }
    function ICompElement() {
    }
    function SVGCompElement(t, r, n) {
      this.layers = t.layers, this.supports3d = !0, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(t, r, n), this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, r.frameRate, this) : { _placeholder: !0 };
    }
    function SVGRenderer(t, r) {
      this.animationItem = t, this.layers = null, this.renderedFrame = -1, this.svgElement = createNS("svg");
      var n = "";
      if (r && r.title) {
        var a = createNS("title"), s = createElementID();
        a.setAttribute("id", s), a.textContent = r.title, this.svgElement.appendChild(a), n += s;
      }
      if (r && r.description) {
        var o = createNS("desc"), l = createElementID();
        o.setAttribute("id", l), o.textContent = r.description, this.svgElement.appendChild(o), n += " " + l;
      }
      n && this.svgElement.setAttribute("aria-labelledby", n);
      var x = createNS("defs");
      this.svgElement.appendChild(x);
      var j = createNS("g");
      this.svgElement.appendChild(j), this.layerElement = j, this.renderConfig = { preserveAspectRatio: r && r.preserveAspectRatio || "xMidYMid meet", imagePreserveAspectRatio: r && r.imagePreserveAspectRatio || "xMidYMid slice", contentVisibility: r && r.contentVisibility || "visible", progressiveLoad: r && r.progressiveLoad || !1, hideOnTransparent: !(r && r.hideOnTransparent === !1), viewBoxOnly: r && r.viewBoxOnly || !1, viewBoxSize: r && r.viewBoxSize || !1, className: r && r.className || "", id: r && r.id || "", focusable: r && r.focusable, filterSize: { width: r && r.filterSize && r.filterSize.width || "100%", height: r && r.filterSize && r.filterSize.height || "100%", x: r && r.filterSize && r.filterSize.x || "0%", y: r && r.filterSize && r.filterSize.y || "0%" }, width: r && r.width, height: r && r.height, runExpressions: !r || r.runExpressions === void 0 || r.runExpressions }, this.globalData = { _mdf: !1, frameNum: -1, defs: x, renderConfig: this.renderConfig }, this.elements = [], this.pendingElements = [], this.destroyed = !1, this.rendererType = "svg";
    }
    function ShapeTransformManager() {
      this.sequences = {}, this.sequenceList = [], this.transform_key_count = 0;
    }
    extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], SVGTextLottieElement), SVGTextLottieElement.prototype.createContent = function() {
      this.data.singleShape && !this.globalData.fontManager.chars && (this.textContainer = createNS("text"));
    }, SVGTextLottieElement.prototype.buildTextContents = function(t) {
      for (var r = 0, n = t.length, a = [], s = ""; r < n; ) t[r] === "\r" || t[r] === "" ? (a.push(s), s = "") : s += t[r], r += 1;
      return a.push(s), a;
    }, SVGTextLottieElement.prototype.buildShapeData = function(t, r) {
      if (t.shapes && t.shapes.length) {
        var n = t.shapes[0];
        if (n.it) {
          var a = n.it[n.it.length - 1];
          a.s && (a.s.k[0] = r, a.s.k[1] = r);
        }
      }
      return t;
    }, SVGTextLottieElement.prototype.buildNewText = function() {
      var t, r;
      this.addDynamicProperty(this);
      var n = this.textProperty.currentData;
      this.renderedLetters = createSizedArray(n ? n.l.length : 0), n.fc ? this.layerElement.setAttribute("fill", this.buildColor(n.fc)) : this.layerElement.setAttribute("fill", "rgba(0,0,0,0)"), n.sc && (this.layerElement.setAttribute("stroke", this.buildColor(n.sc)), this.layerElement.setAttribute("stroke-width", n.sw)), this.layerElement.setAttribute("font-size", n.finalSize);
      var a = this.globalData.fontManager.getFontByName(n.f);
      if (a.fClass) this.layerElement.setAttribute("class", a.fClass);
      else {
        this.layerElement.setAttribute("font-family", a.fFamily);
        var s = n.fWeight, o = n.fStyle;
        this.layerElement.setAttribute("font-style", o), this.layerElement.setAttribute("font-weight", s);
      }
      this.layerElement.setAttribute("aria-label", n.t);
      var l, x = n.l || [], j = !!this.globalData.fontManager.chars;
      r = x.length;
      var Z = this.mHelper, V = this.data.singleShape, $ = 0, X = 0, W = !0, Y = 1e-3 * n.tr * n.finalSize;
      if (!V || j || n.sz) {
        var U, G = this.textSpans.length;
        for (t = 0; t < r; t += 1) {
          if (this.textSpans[t] || (this.textSpans[t] = { span: null, childSpan: null, glyph: null }), !j || !V || t === 0) {
            if (l = G > t ? this.textSpans[t].span : createNS(j ? "g" : "text"), G <= t) {
              if (l.setAttribute("stroke-linecap", "butt"), l.setAttribute("stroke-linejoin", "round"), l.setAttribute("stroke-miterlimit", "4"), this.textSpans[t].span = l, j) {
                var K = createNS("g");
                l.appendChild(K), this.textSpans[t].childSpan = K;
              }
              this.textSpans[t].span = l, this.layerElement.appendChild(l);
            }
            l.style.display = "inherit";
          }
          if (Z.reset(), V && (x[t].n && ($ = -Y, X += n.yOffset, X += W ? 1 : 0, W = !1), this.applyTextPropertiesToMatrix(n, Z, x[t].line, $, X), $ += x[t].l || 0, $ += Y), j) {
            var J;
            if ((U = this.globalData.fontManager.getCharData(n.finalText[t], a.fStyle, this.globalData.fontManager.getFontByName(n.f).fFamily)).t === 1) J = new SVGCompElement(U.data, this.globalData, this);
            else {
              var ee = emptyShapeData;
              U.data && U.data.shapes && (ee = this.buildShapeData(U.data, n.finalSize)), J = new SVGShapeElement(ee, this.globalData, this);
            }
            if (this.textSpans[t].glyph) {
              var te = this.textSpans[t].glyph;
              this.textSpans[t].childSpan.removeChild(te.layerElement), te.destroy();
            }
            this.textSpans[t].glyph = J, J._debug = !0, J.prepareFrame(0), J.renderFrame(), this.textSpans[t].childSpan.appendChild(J.layerElement), U.t === 1 && this.textSpans[t].childSpan.setAttribute("transform", "scale(" + n.finalSize / 100 + "," + n.finalSize / 100 + ")");
          } else V && l.setAttribute("transform", "translate(" + Z.props[12] + "," + Z.props[13] + ")"), l.textContent = x[t].val, l.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve");
        }
        V && l && l.setAttribute("d", "");
      } else {
        var re = this.textContainer, ae = "start";
        switch (n.j) {
          case 1:
            ae = "end";
            break;
          case 2:
            ae = "middle";
            break;
          default:
            ae = "start";
        }
        re.setAttribute("text-anchor", ae), re.setAttribute("letter-spacing", Y);
        var ie = this.buildTextContents(n.finalText);
        for (r = ie.length, X = n.ps ? n.ps[1] + n.ascent : 0, t = 0; t < r; t += 1) (l = this.textSpans[t].span || createNS("tspan")).textContent = ie[t], l.setAttribute("x", 0), l.setAttribute("y", X), l.style.display = "inherit", re.appendChild(l), this.textSpans[t] || (this.textSpans[t] = { span: null, glyph: null }), this.textSpans[t].span = l, X += n.finalLineHeight;
        this.layerElement.appendChild(re);
      }
      for (; t < this.textSpans.length; ) this.textSpans[t].span.style.display = "none", t += 1;
      this._sizeChanged = !0;
    }, SVGTextLottieElement.prototype.sourceRectAtTime = function() {
      if (this.prepareFrame(this.comp.renderedFrame - this.data.st), this.renderInnerContent(), this._sizeChanged) {
        this._sizeChanged = !1;
        var t = this.layerElement.getBBox();
        this.bbox = { top: t.y, left: t.x, width: t.width, height: t.height };
      }
      return this.bbox;
    }, SVGTextLottieElement.prototype.getValue = function() {
      var t, r, n = this.textSpans.length;
      for (this.renderedFrame = this.comp.renderedFrame, t = 0; t < n; t += 1) (r = this.textSpans[t].glyph) && (r.prepareFrame(this.comp.renderedFrame - this.data.st), r._mdf && (this._mdf = !0));
    }, SVGTextLottieElement.prototype.renderInnerContent = function() {
      if (this.validateText(), (!this.data.singleShape || this._mdf) && (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag)) {
        var t, r;
        this._sizeChanged = !0;
        var n, a, s, o = this.textAnimator.renderedLetters, l = this.textProperty.currentData.l;
        for (r = l.length, t = 0; t < r; t += 1) l[t].n || (n = o[t], a = this.textSpans[t].span, (s = this.textSpans[t].glyph) && s.renderFrame(), n._mdf.m && a.setAttribute("transform", n.m), n._mdf.o && a.setAttribute("opacity", n.o), n._mdf.sw && a.setAttribute("stroke-width", n.sw), n._mdf.sc && a.setAttribute("stroke", n.sc), n._mdf.fc && a.setAttribute("fill", n.fc));
      }
    }, extendPrototype([IImageElement], ISolidElement), ISolidElement.prototype.createContent = function() {
      var t = createNS("rect");
      t.setAttribute("width", this.data.sw), t.setAttribute("height", this.data.sh), t.setAttribute("fill", this.data.sc), this.layerElement.appendChild(t);
    }, NullElement.prototype.prepareFrame = function(t) {
      this.prepareProperties(t, !0);
    }, NullElement.prototype.renderFrame = function() {
    }, NullElement.prototype.getBaseElement = function() {
      return null;
    }, NullElement.prototype.destroy = function() {
    }, NullElement.prototype.sourceRectAtTime = function() {
    }, NullElement.prototype.hide = function() {
    }, extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement], NullElement), extendPrototype([BaseRenderer], SVGRendererBase), SVGRendererBase.prototype.createNull = function(t) {
      return new NullElement(t, this.globalData, this);
    }, SVGRendererBase.prototype.createShape = function(t) {
      return new SVGShapeElement(t, this.globalData, this);
    }, SVGRendererBase.prototype.createText = function(t) {
      return new SVGTextLottieElement(t, this.globalData, this);
    }, SVGRendererBase.prototype.createImage = function(t) {
      return new IImageElement(t, this.globalData, this);
    }, SVGRendererBase.prototype.createSolid = function(t) {
      return new ISolidElement(t, this.globalData, this);
    }, SVGRendererBase.prototype.configAnimation = function(t) {
      this.svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg"), this.svgElement.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink"), this.renderConfig.viewBoxSize ? this.svgElement.setAttribute("viewBox", this.renderConfig.viewBoxSize) : this.svgElement.setAttribute("viewBox", "0 0 " + t.w + " " + t.h), this.renderConfig.viewBoxOnly || (this.svgElement.setAttribute("width", t.w), this.svgElement.setAttribute("height", t.h), this.svgElement.style.width = "100%", this.svgElement.style.height = "100%", this.svgElement.style.transform = "translate3d(0,0,0)", this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility), this.renderConfig.width && this.svgElement.setAttribute("width", this.renderConfig.width), this.renderConfig.height && this.svgElement.setAttribute("height", this.renderConfig.height), this.renderConfig.className && this.svgElement.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.svgElement.setAttribute("id", this.renderConfig.id), this.renderConfig.focusable !== void 0 && this.svgElement.setAttribute("focusable", this.renderConfig.focusable), this.svgElement.setAttribute("preserveAspectRatio", this.renderConfig.preserveAspectRatio), this.animationItem.wrapper.appendChild(this.svgElement);
      var r = this.globalData.defs;
      this.setupGlobalData(t, r), this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.data = t;
      var n = createNS("clipPath"), a = createNS("rect");
      a.setAttribute("width", t.w), a.setAttribute("height", t.h), a.setAttribute("x", 0), a.setAttribute("y", 0);
      var s = createElementID();
      n.setAttribute("id", s), n.appendChild(a), this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + s + ")"), r.appendChild(n), this.layers = t.layers, this.elements = createSizedArray(t.layers.length);
    }, SVGRendererBase.prototype.destroy = function() {
      var t;
      this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.layerElement = null, this.globalData.defs = null;
      var r = this.layers ? this.layers.length : 0;
      for (t = 0; t < r; t += 1) this.elements[t] && this.elements[t].destroy && this.elements[t].destroy();
      this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
    }, SVGRendererBase.prototype.updateContainerSize = function() {
    }, SVGRendererBase.prototype.findIndexByInd = function(t) {
      var r = 0, n = this.layers.length;
      for (r = 0; r < n; r += 1) if (this.layers[r].ind === t) return r;
      return -1;
    }, SVGRendererBase.prototype.buildItem = function(t) {
      var r = this.elements;
      if (!r[t] && this.layers[t].ty !== 99) {
        r[t] = !0;
        var n = this.createItem(this.layers[t]);
        if (r[t] = n, getExpressionsPlugin() && (this.layers[t].ty === 0 && this.globalData.projectInterface.registerComposition(n), n.initExpressions()), this.appendElementInPos(n, t), this.layers[t].tt) {
          var a = "tp" in this.layers[t] ? this.findIndexByInd(this.layers[t].tp) : t - 1;
          if (a === -1) return;
          if (this.elements[a] && this.elements[a] !== !0) {
            var s = r[a].getMatte(this.layers[t].tt);
            n.setMatte(s);
          } else this.buildItem(a), this.addPendingElement(n);
        }
      }
    }, SVGRendererBase.prototype.checkPendingElements = function() {
      for (; this.pendingElements.length; ) {
        var t = this.pendingElements.pop();
        if (t.checkParenting(), t.data.tt) for (var r = 0, n = this.elements.length; r < n; ) {
          if (this.elements[r] === t) {
            var a = "tp" in t.data ? this.findIndexByInd(t.data.tp) : r - 1, s = this.elements[a].getMatte(this.layers[r].tt);
            t.setMatte(s);
            break;
          }
          r += 1;
        }
      }
    }, SVGRendererBase.prototype.renderFrame = function(t) {
      if (this.renderedFrame !== t && !this.destroyed) {
        var r;
        t === null ? t = this.renderedFrame : this.renderedFrame = t, this.globalData.frameNum = t, this.globalData.frameId += 1, this.globalData.projectInterface.currentFrame = t, this.globalData._mdf = !1;
        var n = this.layers.length;
        for (this.completeLayers || this.checkLayers(t), r = n - 1; r >= 0; r -= 1) (this.completeLayers || this.elements[r]) && this.elements[r].prepareFrame(t - this.layers[r].st);
        if (this.globalData._mdf) for (r = 0; r < n; r += 1) (this.completeLayers || this.elements[r]) && this.elements[r].renderFrame();
      }
    }, SVGRendererBase.prototype.appendElementInPos = function(t, r) {
      var n = t.getBaseElement();
      if (n) {
        for (var a, s = 0; s < r; ) this.elements[s] && this.elements[s] !== !0 && this.elements[s].getBaseElement() && (a = this.elements[s].getBaseElement()), s += 1;
        a ? this.layerElement.insertBefore(n, a) : this.layerElement.appendChild(n);
      }
    }, SVGRendererBase.prototype.hide = function() {
      this.layerElement.style.display = "none";
    }, SVGRendererBase.prototype.show = function() {
      this.layerElement.style.display = "block";
    }, extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement, RenderableDOMElement], ICompElement), ICompElement.prototype.initElement = function(t, r, n) {
      this.initFrame(), this.initBaseData(t, r, n), this.initTransform(t, r, n), this.initRenderable(), this.initHierarchy(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), !this.data.xt && r.progressiveLoad || this.buildAllItems(), this.hide();
    }, ICompElement.prototype.prepareFrame = function(t) {
      if (this._mdf = !1, this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange), this.isInRange || this.data.xt) {
        if (this.tm._placeholder) this.renderedFrame = t / this.data.sr;
        else {
          var r = this.tm.v;
          r === this.data.op && (r = this.data.op - 1), this.renderedFrame = r;
        }
        var n, a = this.elements.length;
        for (this.completeLayers || this.checkLayers(this.renderedFrame), n = a - 1; n >= 0; n -= 1) (this.completeLayers || this.elements[n]) && (this.elements[n].prepareFrame(this.renderedFrame - this.layers[n].st), this.elements[n]._mdf && (this._mdf = !0));
      }
    }, ICompElement.prototype.renderInnerContent = function() {
      var t, r = this.layers.length;
      for (t = 0; t < r; t += 1) (this.completeLayers || this.elements[t]) && this.elements[t].renderFrame();
    }, ICompElement.prototype.setElements = function(t) {
      this.elements = t;
    }, ICompElement.prototype.getElements = function() {
      return this.elements;
    }, ICompElement.prototype.destroyElements = function() {
      var t, r = this.layers.length;
      for (t = 0; t < r; t += 1) this.elements[t] && this.elements[t].destroy();
    }, ICompElement.prototype.destroy = function() {
      this.destroyElements(), this.destroyBaseElement();
    }, extendPrototype([SVGRendererBase, ICompElement, SVGBaseElement], SVGCompElement), SVGCompElement.prototype.createComp = function(t) {
      return new SVGCompElement(t, this.globalData, this);
    }, extendPrototype([SVGRendererBase], SVGRenderer), SVGRenderer.prototype.createComp = function(t) {
      return new SVGCompElement(t, this.globalData, this);
    }, ShapeTransformManager.prototype = { addTransformSequence: function(t) {
      var r, n = t.length, a = "_";
      for (r = 0; r < n; r += 1) a += t[r].transform.key + "_";
      var s = this.sequences[a];
      return s || (s = { transforms: [].concat(t), finalTransform: new Matrix(), _mdf: !1 }, this.sequences[a] = s, this.sequenceList.push(s)), s;
    }, processSequence: function(t, r) {
      for (var n = 0, a = t.transforms.length, s = r; n < a && !r; ) {
        if (t.transforms[n].transform.mProps._mdf) {
          s = !0;
          break;
        }
        n += 1;
      }
      if (s) for (t.finalTransform.reset(), n = a - 1; n >= 0; n -= 1) t.finalTransform.multiply(t.transforms[n].transform.mProps.v);
      t._mdf = s;
    }, processSequences: function(t) {
      var r, n = this.sequenceList.length;
      for (r = 0; r < n; r += 1) this.processSequence(this.sequenceList[r], t);
    }, getNewKey: function() {
      return this.transform_key_count += 1, "_" + this.transform_key_count;
    } };
    var lumaLoader = function() {
      var t = "__lottie_element_luma_buffer", r = null, n = null, a = null;
      function s() {
        var o, l, x;
        r || (o = createNS("svg"), l = createNS("filter"), x = createNS("feColorMatrix"), l.setAttribute("id", t), x.setAttribute("type", "matrix"), x.setAttribute("color-interpolation-filters", "sRGB"), x.setAttribute("values", "0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0"), l.appendChild(x), o.appendChild(l), o.setAttribute("id", t + "_svg"), featureSupport.svgLumaHidden && (o.style.display = "none"), a = o, document.body.appendChild(a), r = createTag("canvas"), (n = r.getContext("2d")).filter = "url(#" + t + ")", n.fillStyle = "rgba(0,0,0,0)", n.fillRect(0, 0, 1, 1));
      }
      return { load: s, get: function(o) {
        return r || s(), r.width = o.width, r.height = o.height, n.filter = "url(#" + t + ")", r;
      } };
    };
    function createCanvas(t, r) {
      if (featureSupport.offscreenCanvas) return new OffscreenCanvas(t, r);
      var n = createTag("canvas");
      return n.width = t, n.height = r, n;
    }
    var assetLoader = { loadLumaCanvas: lumaLoader.load, getLumaCanvas: lumaLoader.get, createCanvas }, registeredEffects = {};
    function CVEffects(t) {
      var r, n, a = t.data.ef ? t.data.ef.length : 0;
      for (this.filters = [], r = 0; r < a; r += 1) {
        n = null;
        var s = t.data.ef[r].ty;
        registeredEffects[s] && (n = new registeredEffects[s].effect(t.effectsManager.effectElements[r], t)), n && this.filters.push(n);
      }
      this.filters.length && t.addRenderableComponent(this);
    }
    function registerEffect(t, r) {
      registeredEffects[t] = { effect: r };
    }
    function CVMaskElement(t, r) {
      var n;
      this.data = t, this.element = r, this.masksProperties = this.data.masksProperties || [], this.viewData = createSizedArray(this.masksProperties.length);
      var a = this.masksProperties.length, s = !1;
      for (n = 0; n < a; n += 1) this.masksProperties[n].mode !== "n" && (s = !0), this.viewData[n] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[n], 3);
      this.hasMasks = s, s && this.element.addRenderableComponent(this);
    }
    function CVBaseElement() {
    }
    CVEffects.prototype.renderFrame = function(t) {
      var r, n = this.filters.length;
      for (r = 0; r < n; r += 1) this.filters[r].renderFrame(t);
    }, CVEffects.prototype.getEffects = function(t) {
      var r, n = this.filters.length, a = [];
      for (r = 0; r < n; r += 1) this.filters[r].type === t && a.push(this.filters[r]);
      return a;
    }, CVMaskElement.prototype.renderFrame = function() {
      if (this.hasMasks) {
        var t, r, n, a, s = this.element.finalTransform.mat, o = this.element.canvasContext, l = this.masksProperties.length;
        for (o.beginPath(), t = 0; t < l; t += 1) if (this.masksProperties[t].mode !== "n") {
          var x;
          this.masksProperties[t].inv && (o.moveTo(0, 0), o.lineTo(this.element.globalData.compSize.w, 0), o.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h), o.lineTo(0, this.element.globalData.compSize.h), o.lineTo(0, 0)), a = this.viewData[t].v, r = s.applyToPointArray(a.v[0][0], a.v[0][1], 0), o.moveTo(r[0], r[1]);
          var j = a._length;
          for (x = 1; x < j; x += 1) n = s.applyToTriplePoints(a.o[x - 1], a.i[x], a.v[x]), o.bezierCurveTo(n[0], n[1], n[2], n[3], n[4], n[5]);
          n = s.applyToTriplePoints(a.o[x - 1], a.i[0], a.v[0]), o.bezierCurveTo(n[0], n[1], n[2], n[3], n[4], n[5]);
        }
        this.element.globalData.renderer.save(!0), o.clip();
      }
    }, CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty, CVMaskElement.prototype.destroy = function() {
      this.element = null;
    };
    var operationsMap = { 1: "source-in", 2: "source-out", 3: "source-in", 4: "source-out" };
    function CVShapeData(t, r, n, a) {
      this.styledShapes = [], this.tr = [0, 0, 0, 0, 0, 0];
      var s, o = 4;
      r.ty === "rc" ? o = 5 : r.ty === "el" ? o = 6 : r.ty === "sr" && (o = 7), this.sh = ShapePropertyFactory.getShapeProp(t, r, o, t);
      var l, x = n.length;
      for (s = 0; s < x; s += 1) n[s].closed || (l = { transforms: a.addTransformSequence(n[s].transforms), trNodes: [] }, this.styledShapes.push(l), n[s].elements.push(l));
    }
    function CVShapeElement(t, r, n) {
      this.shapes = [], this.shapesData = t.shapes, this.stylesList = [], this.itemsData = [], this.prevViewData = [], this.shapeModifiers = [], this.processedElements = [], this.transformsManager = new ShapeTransformManager(), this.initElement(t, r, n);
    }
    function CVTextElement(t, r, n) {
      this.textSpans = [], this.yOffset = 0, this.fillColorAnim = !1, this.strokeColorAnim = !1, this.strokeWidthAnim = !1, this.stroke = !1, this.fill = !1, this.justifyOffset = 0, this.currentRender = null, this.renderType = "canvas", this.values = { fill: "rgba(0,0,0,0)", stroke: "rgba(0,0,0,0)", sWidth: 0, fValue: "" }, this.initElement(t, r, n);
    }
    function CVImageElement(t, r, n) {
      this.assetData = r.getAssetData(t.refId), this.img = r.imageLoader.getAsset(this.assetData), this.initElement(t, r, n);
    }
    function CVSolidElement(t, r, n) {
      this.initElement(t, r, n);
    }
    function CanvasRendererBase() {
    }
    function CanvasContext() {
      this.opacity = -1, this.transform = createTypedArray("float32", 16), this.fillStyle = "", this.strokeStyle = "", this.lineWidth = "", this.lineCap = "", this.lineJoin = "", this.miterLimit = "", this.id = Math.random();
    }
    function CVContextData() {
      var t;
      for (this.stack = [], this.cArrPos = 0, this.cTr = new Matrix(), t = 0; t < 15; t += 1) {
        var r = new CanvasContext();
        this.stack[t] = r;
      }
      this._length = 15, this.nativeContext = null, this.transformMat = new Matrix(), this.currentOpacity = 1, this.currentFillStyle = "", this.appliedFillStyle = "", this.currentStrokeStyle = "", this.appliedStrokeStyle = "", this.currentLineWidth = "", this.appliedLineWidth = "", this.currentLineCap = "", this.appliedLineCap = "", this.currentLineJoin = "", this.appliedLineJoin = "", this.appliedMiterLimit = "", this.currentMiterLimit = "";
    }
    function CVCompElement(t, r, n) {
      this.completeLayers = !1, this.layers = t.layers, this.pendingElements = [], this.elements = createSizedArray(this.layers.length), this.initElement(t, r, n), this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, r.frameRate, this) : { _placeholder: !0 };
    }
    function CanvasRenderer(t, r) {
      this.animationItem = t, this.renderConfig = { clearCanvas: !r || r.clearCanvas === void 0 || r.clearCanvas, context: r && r.context || null, progressiveLoad: r && r.progressiveLoad || !1, preserveAspectRatio: r && r.preserveAspectRatio || "xMidYMid meet", imagePreserveAspectRatio: r && r.imagePreserveAspectRatio || "xMidYMid slice", contentVisibility: r && r.contentVisibility || "visible", className: r && r.className || "", id: r && r.id || "", runExpressions: !r || r.runExpressions === void 0 || r.runExpressions }, this.renderConfig.dpr = r && r.dpr || 1, this.animationItem.wrapper && (this.renderConfig.dpr = r && r.dpr || window.devicePixelRatio || 1), this.renderedFrame = -1, this.globalData = { frameNum: -1, _mdf: !1, renderConfig: this.renderConfig, currentGlobalAlpha: -1 }, this.contextData = new CVContextData(), this.elements = [], this.pendingElements = [], this.transformMat = new Matrix(), this.completeLayers = !1, this.rendererType = "canvas", this.renderConfig.clearCanvas && (this.ctxTransform = this.contextData.transform.bind(this.contextData), this.ctxOpacity = this.contextData.opacity.bind(this.contextData), this.ctxFillStyle = this.contextData.fillStyle.bind(this.contextData), this.ctxStrokeStyle = this.contextData.strokeStyle.bind(this.contextData), this.ctxLineWidth = this.contextData.lineWidth.bind(this.contextData), this.ctxLineCap = this.contextData.lineCap.bind(this.contextData), this.ctxLineJoin = this.contextData.lineJoin.bind(this.contextData), this.ctxMiterLimit = this.contextData.miterLimit.bind(this.contextData), this.ctxFill = this.contextData.fill.bind(this.contextData), this.ctxFillRect = this.contextData.fillRect.bind(this.contextData), this.ctxStroke = this.contextData.stroke.bind(this.contextData), this.save = this.contextData.save.bind(this.contextData));
    }
    function HBaseElement() {
    }
    function HSolidElement(t, r, n) {
      this.initElement(t, r, n);
    }
    function HShapeElement(t, r, n) {
      this.shapes = [], this.shapesData = t.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.shapesContainer = createNS("g"), this.initElement(t, r, n), this.prevViewData = [], this.currentBBox = { x: 999999, y: -999999, h: 0, w: 0 };
    }
    function HTextElement(t, r, n) {
      this.textSpans = [], this.textPaths = [], this.currentBBox = { x: 999999, y: -999999, h: 0, w: 0 }, this.renderType = "svg", this.isMasked = !1, this.initElement(t, r, n);
    }
    function HCameraElement(t, r, n) {
      this.initFrame(), this.initBaseData(t, r, n), this.initHierarchy();
      var a = PropertyFactory.getProp;
      if (this.pe = a(this, t.pe, 0, 0, this), t.ks.p.s ? (this.px = a(this, t.ks.p.x, 1, 0, this), this.py = a(this, t.ks.p.y, 1, 0, this), this.pz = a(this, t.ks.p.z, 1, 0, this)) : this.p = a(this, t.ks.p, 1, 0, this), t.ks.a && (this.a = a(this, t.ks.a, 1, 0, this)), t.ks.or.k.length && t.ks.or.k[0].to) {
        var s, o = t.ks.or.k.length;
        for (s = 0; s < o; s += 1) t.ks.or.k[s].to = null, t.ks.or.k[s].ti = null;
      }
      this.or = a(this, t.ks.or, 1, degToRads, this), this.or.sh = !0, this.rx = a(this, t.ks.rx, 0, degToRads, this), this.ry = a(this, t.ks.ry, 0, degToRads, this), this.rz = a(this, t.ks.rz, 0, degToRads, this), this.mat = new Matrix(), this._prevMat = new Matrix(), this._isFirstFrame = !0, this.finalTransform = { mProp: this };
    }
    function HImageElement(t, r, n) {
      this.assetData = r.getAssetData(t.refId), this.initElement(t, r, n);
    }
    function HybridRendererBase(t, r) {
      this.animationItem = t, this.layers = null, this.renderedFrame = -1, this.renderConfig = { className: r && r.className || "", imagePreserveAspectRatio: r && r.imagePreserveAspectRatio || "xMidYMid slice", hideOnTransparent: !(r && r.hideOnTransparent === !1), filterSize: { width: r && r.filterSize && r.filterSize.width || "400%", height: r && r.filterSize && r.filterSize.height || "400%", x: r && r.filterSize && r.filterSize.x || "-100%", y: r && r.filterSize && r.filterSize.y || "-100%" } }, this.globalData = { _mdf: !1, frameNum: -1, renderConfig: this.renderConfig }, this.pendingElements = [], this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null, this.supports3d = !0, this.rendererType = "html";
    }
    function HCompElement(t, r, n) {
      this.layers = t.layers, this.supports3d = !t.hasMask, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(t, r, n), this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, r.frameRate, this) : { _placeholder: !0 };
    }
    function HybridRenderer(t, r) {
      this.animationItem = t, this.layers = null, this.renderedFrame = -1, this.renderConfig = { className: r && r.className || "", imagePreserveAspectRatio: r && r.imagePreserveAspectRatio || "xMidYMid slice", hideOnTransparent: !(r && r.hideOnTransparent === !1), filterSize: { width: r && r.filterSize && r.filterSize.width || "400%", height: r && r.filterSize && r.filterSize.height || "400%", x: r && r.filterSize && r.filterSize.x || "-100%", y: r && r.filterSize && r.filterSize.y || "-100%" }, runExpressions: !r || r.runExpressions === void 0 || r.runExpressions }, this.globalData = { _mdf: !1, frameNum: -1, renderConfig: this.renderConfig }, this.pendingElements = [], this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null, this.supports3d = !0, this.rendererType = "html";
    }
    CVBaseElement.prototype = { createElements: function() {
    }, initRendererElement: function() {
    }, createContainerElements: function() {
      if (this.data.tt >= 1) {
        this.buffers = [];
        var t = this.globalData.canvasContext, r = assetLoader.createCanvas(t.canvas.width, t.canvas.height);
        this.buffers.push(r);
        var n = assetLoader.createCanvas(t.canvas.width, t.canvas.height);
        this.buffers.push(n), this.data.tt >= 3 && !document._isProxy && assetLoader.loadLumaCanvas();
      }
      this.canvasContext = this.globalData.canvasContext, this.transformCanvas = this.globalData.transformCanvas, this.renderableEffectsManager = new CVEffects(this), this.searchEffectTransforms();
    }, createContent: function() {
    }, setBlendMode: function() {
      var t = this.globalData;
      if (t.blendMode !== this.data.bm) {
        t.blendMode = this.data.bm;
        var r = getBlendMode(this.data.bm);
        t.canvasContext.globalCompositeOperation = r;
      }
    }, createRenderableComponents: function() {
      this.maskManager = new CVMaskElement(this.data, this), this.transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
    }, hideElement: function() {
      this.hidden || this.isInRange && !this.isTransparent || (this.hidden = !0);
    }, showElement: function() {
      this.isInRange && !this.isTransparent && (this.hidden = !1, this._isFirstFrame = !0, this.maskManager._isFirstFrame = !0);
    }, clearCanvas: function(t) {
      t.clearRect(this.transformCanvas.tx, this.transformCanvas.ty, this.transformCanvas.w * this.transformCanvas.sx, this.transformCanvas.h * this.transformCanvas.sy);
    }, prepareLayer: function() {
      if (this.data.tt >= 1) {
        var t = this.buffers[0].getContext("2d");
        this.clearCanvas(t), t.drawImage(this.canvasContext.canvas, 0, 0), this.currentTransform = this.canvasContext.getTransform(), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.setTransform(this.currentTransform);
      }
    }, exitLayer: function() {
      if (this.data.tt >= 1) {
        var t = this.buffers[1], r = t.getContext("2d");
        if (this.clearCanvas(r), r.drawImage(this.canvasContext.canvas, 0, 0), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.setTransform(this.currentTransform), this.comp.getElementById("tp" in this.data ? this.data.tp : this.data.ind - 1).renderFrame(!0), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.data.tt >= 3 && !document._isProxy) {
          var n = assetLoader.getLumaCanvas(this.canvasContext.canvas);
          n.getContext("2d").drawImage(this.canvasContext.canvas, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.drawImage(n, 0, 0);
        }
        this.canvasContext.globalCompositeOperation = operationsMap[this.data.tt], this.canvasContext.drawImage(t, 0, 0), this.canvasContext.globalCompositeOperation = "destination-over", this.canvasContext.drawImage(this.buffers[0], 0, 0), this.canvasContext.setTransform(this.currentTransform), this.canvasContext.globalCompositeOperation = "source-over";
      }
    }, renderFrame: function(t) {
      if (!this.hidden && !this.data.hd && (this.data.td !== 1 || t)) {
        this.renderTransform(), this.renderRenderable(), this.renderLocalTransform(), this.setBlendMode();
        var r = this.data.ty === 0;
        this.prepareLayer(), this.globalData.renderer.save(r), this.globalData.renderer.ctxTransform(this.finalTransform.localMat.props), this.globalData.renderer.ctxOpacity(this.finalTransform.localOpacity), this.renderInnerContent(), this.globalData.renderer.restore(r), this.exitLayer(), this.maskManager.hasMasks && this.globalData.renderer.restore(!0), this._isFirstFrame && (this._isFirstFrame = !1);
      }
    }, destroy: function() {
      this.canvasContext = null, this.data = null, this.globalData = null, this.maskManager.destroy();
    }, mHelper: new Matrix() }, CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement, CVBaseElement.prototype.show = CVBaseElement.prototype.showElement, CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated, extendPrototype([BaseElement, TransformElement, CVBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableElement], CVShapeElement), CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement, CVShapeElement.prototype.transformHelper = { opacity: 1, _opMdf: !1 }, CVShapeElement.prototype.dashResetter = [], CVShapeElement.prototype.createContent = function() {
      this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []);
    }, CVShapeElement.prototype.createStyleElement = function(t, r) {
      var n = { data: t, type: t.ty, preTransforms: this.transformsManager.addTransformSequence(r), transforms: [], elements: [], closed: t.hd === !0 }, a = {};
      if (t.ty === "fl" || t.ty === "st" ? (a.c = PropertyFactory.getProp(this, t.c, 1, 255, this), a.c.k || (n.co = "rgb(" + bmFloor(a.c.v[0]) + "," + bmFloor(a.c.v[1]) + "," + bmFloor(a.c.v[2]) + ")")) : t.ty !== "gf" && t.ty !== "gs" || (a.s = PropertyFactory.getProp(this, t.s, 1, null, this), a.e = PropertyFactory.getProp(this, t.e, 1, null, this), a.h = PropertyFactory.getProp(this, t.h || { k: 0 }, 0, 0.01, this), a.a = PropertyFactory.getProp(this, t.a || { k: 0 }, 0, degToRads, this), a.g = new GradientProperty(this, t.g, this)), a.o = PropertyFactory.getProp(this, t.o, 0, 0.01, this), t.ty === "st" || t.ty === "gs") {
        if (n.lc = lineCapEnum[t.lc || 2], n.lj = lineJoinEnum[t.lj || 2], t.lj == 1 && (n.ml = t.ml), a.w = PropertyFactory.getProp(this, t.w, 0, null, this), a.w.k || (n.wi = a.w.v), t.d) {
          var s = new DashProperty(this, t.d, "canvas", this);
          a.d = s, a.d.k || (n.da = a.d.dashArray, n.do = a.d.dashoffset[0]);
        }
      } else n.r = t.r === 2 ? "evenodd" : "nonzero";
      return this.stylesList.push(n), a.style = n, a;
    }, CVShapeElement.prototype.createGroupElement = function() {
      return { it: [], prevViewData: [] };
    }, CVShapeElement.prototype.createTransformElement = function(t) {
      return { transform: { opacity: 1, _opMdf: !1, key: this.transformsManager.getNewKey(), op: PropertyFactory.getProp(this, t.o, 0, 0.01, this), mProps: TransformPropertyFactory.getTransformProperty(this, t, this) } };
    }, CVShapeElement.prototype.createShapeElement = function(t) {
      var r = new CVShapeData(this, t, this.stylesList, this.transformsManager);
      return this.shapes.push(r), this.addShapeToModifiers(r), r;
    }, CVShapeElement.prototype.reloadShapes = function() {
      var t;
      this._isFirstFrame = !0;
      var r = this.itemsData.length;
      for (t = 0; t < r; t += 1) this.prevViewData[t] = this.itemsData[t];
      for (this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []), r = this.dynamicProperties.length, t = 0; t < r; t += 1) this.dynamicProperties[t].getValue();
      this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame);
    }, CVShapeElement.prototype.addTransformToStyleList = function(t) {
      var r, n = this.stylesList.length;
      for (r = 0; r < n; r += 1) this.stylesList[r].closed || this.stylesList[r].transforms.push(t);
    }, CVShapeElement.prototype.removeTransformFromStyleList = function() {
      var t, r = this.stylesList.length;
      for (t = 0; t < r; t += 1) this.stylesList[t].closed || this.stylesList[t].transforms.pop();
    }, CVShapeElement.prototype.closeStyles = function(t) {
      var r, n = t.length;
      for (r = 0; r < n; r += 1) t[r].closed = !0;
    }, CVShapeElement.prototype.searchShapes = function(t, r, n, a, s) {
      var o, l, x, j, Z, V, $ = t.length - 1, X = [], W = [], Y = [].concat(s);
      for (o = $; o >= 0; o -= 1) {
        if ((j = this.searchProcessedElement(t[o])) ? r[o] = n[j - 1] : t[o]._shouldRender = a, t[o].ty === "fl" || t[o].ty === "st" || t[o].ty === "gf" || t[o].ty === "gs") j ? r[o].style.closed = !1 : r[o] = this.createStyleElement(t[o], Y), X.push(r[o].style);
        else if (t[o].ty === "gr") {
          if (j) for (x = r[o].it.length, l = 0; l < x; l += 1) r[o].prevViewData[l] = r[o].it[l];
          else r[o] = this.createGroupElement(t[o]);
          this.searchShapes(t[o].it, r[o].it, r[o].prevViewData, a, Y);
        } else t[o].ty === "tr" ? (j || (V = this.createTransformElement(t[o]), r[o] = V), Y.push(r[o]), this.addTransformToStyleList(r[o])) : t[o].ty === "sh" || t[o].ty === "rc" || t[o].ty === "el" || t[o].ty === "sr" ? j || (r[o] = this.createShapeElement(t[o])) : t[o].ty === "tm" || t[o].ty === "rd" || t[o].ty === "pb" || t[o].ty === "zz" || t[o].ty === "op" ? (j ? (Z = r[o]).closed = !1 : ((Z = ShapeModifiers.getModifier(t[o].ty)).init(this, t[o]), r[o] = Z, this.shapeModifiers.push(Z)), W.push(Z)) : t[o].ty === "rp" && (j ? (Z = r[o]).closed = !0 : (Z = ShapeModifiers.getModifier(t[o].ty), r[o] = Z, Z.init(this, t, o, r), this.shapeModifiers.push(Z), a = !1), W.push(Z));
        this.addProcessedElement(t[o], o + 1);
      }
      for (this.removeTransformFromStyleList(), this.closeStyles(X), $ = W.length, o = 0; o < $; o += 1) W[o].closed = !0;
    }, CVShapeElement.prototype.renderInnerContent = function() {
      this.transformHelper.opacity = 1, this.transformHelper._opMdf = !1, this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame), this.renderShape(this.transformHelper, this.shapesData, this.itemsData, !0);
    }, CVShapeElement.prototype.renderShapeTransform = function(t, r) {
      (t._opMdf || r.op._mdf || this._isFirstFrame) && (r.opacity = t.opacity, r.opacity *= r.op.v, r._opMdf = !0);
    }, CVShapeElement.prototype.drawLayer = function() {
      var t, r, n, a, s, o, l, x, j, Z = this.stylesList.length, V = this.globalData.renderer, $ = this.globalData.canvasContext;
      for (t = 0; t < Z; t += 1) if (((x = (j = this.stylesList[t]).type) !== "st" && x !== "gs" || j.wi !== 0) && j.data._shouldRender && j.coOp !== 0 && this.globalData.currentGlobalAlpha !== 0) {
        for (V.save(), o = j.elements, x === "st" || x === "gs" ? (V.ctxStrokeStyle(x === "st" ? j.co : j.grd), V.ctxLineWidth(j.wi), V.ctxLineCap(j.lc), V.ctxLineJoin(j.lj), V.ctxMiterLimit(j.ml || 0)) : V.ctxFillStyle(x === "fl" ? j.co : j.grd), V.ctxOpacity(j.coOp), x !== "st" && x !== "gs" && $.beginPath(), V.ctxTransform(j.preTransforms.finalTransform.props), n = o.length, r = 0; r < n; r += 1) {
          for (x !== "st" && x !== "gs" || ($.beginPath(), j.da && ($.setLineDash(j.da), $.lineDashOffset = j.do)), s = (l = o[r].trNodes).length, a = 0; a < s; a += 1) l[a].t === "m" ? $.moveTo(l[a].p[0], l[a].p[1]) : l[a].t === "c" ? $.bezierCurveTo(l[a].pts[0], l[a].pts[1], l[a].pts[2], l[a].pts[3], l[a].pts[4], l[a].pts[5]) : $.closePath();
          x !== "st" && x !== "gs" || (V.ctxStroke(), j.da && $.setLineDash(this.dashResetter));
        }
        x !== "st" && x !== "gs" && this.globalData.renderer.ctxFill(j.r), V.restore();
      }
    }, CVShapeElement.prototype.renderShape = function(t, r, n, a) {
      var s, o;
      for (o = t, s = r.length - 1; s >= 0; s -= 1) r[s].ty === "tr" ? (o = n[s].transform, this.renderShapeTransform(t, o)) : r[s].ty === "sh" || r[s].ty === "el" || r[s].ty === "rc" || r[s].ty === "sr" ? this.renderPath(r[s], n[s]) : r[s].ty === "fl" ? this.renderFill(r[s], n[s], o) : r[s].ty === "st" ? this.renderStroke(r[s], n[s], o) : r[s].ty === "gf" || r[s].ty === "gs" ? this.renderGradientFill(r[s], n[s], o) : r[s].ty === "gr" ? this.renderShape(o, r[s].it, n[s].it) : r[s].ty;
      a && this.drawLayer();
    }, CVShapeElement.prototype.renderStyledShape = function(t, r) {
      if (this._isFirstFrame || r._mdf || t.transforms._mdf) {
        var n, a, s, o = t.trNodes, l = r.paths, x = l._length;
        o.length = 0;
        var j = t.transforms.finalTransform;
        for (s = 0; s < x; s += 1) {
          var Z = l.shapes[s];
          if (Z && Z.v) {
            for (a = Z._length, n = 1; n < a; n += 1) n === 1 && o.push({ t: "m", p: j.applyToPointArray(Z.v[0][0], Z.v[0][1], 0) }), o.push({ t: "c", pts: j.applyToTriplePoints(Z.o[n - 1], Z.i[n], Z.v[n]) });
            a === 1 && o.push({ t: "m", p: j.applyToPointArray(Z.v[0][0], Z.v[0][1], 0) }), Z.c && a && (o.push({ t: "c", pts: j.applyToTriplePoints(Z.o[n - 1], Z.i[0], Z.v[0]) }), o.push({ t: "z" }));
          }
        }
        t.trNodes = o;
      }
    }, CVShapeElement.prototype.renderPath = function(t, r) {
      if (t.hd !== !0 && t._shouldRender) {
        var n, a = r.styledShapes.length;
        for (n = 0; n < a; n += 1) this.renderStyledShape(r.styledShapes[n], r.sh);
      }
    }, CVShapeElement.prototype.renderFill = function(t, r, n) {
      var a = r.style;
      (r.c._mdf || this._isFirstFrame) && (a.co = "rgb(" + bmFloor(r.c.v[0]) + "," + bmFloor(r.c.v[1]) + "," + bmFloor(r.c.v[2]) + ")"), (r.o._mdf || n._opMdf || this._isFirstFrame) && (a.coOp = r.o.v * n.opacity);
    }, CVShapeElement.prototype.renderGradientFill = function(t, r, n) {
      var a, s = r.style;
      if (!s.grd || r.g._mdf || r.s._mdf || r.e._mdf || t.t !== 1 && (r.h._mdf || r.a._mdf)) {
        var o, l = this.globalData.canvasContext, x = r.s.v, j = r.e.v;
        if (t.t === 1) a = l.createLinearGradient(x[0], x[1], j[0], j[1]);
        else {
          var Z = Math.sqrt(Math.pow(x[0] - j[0], 2) + Math.pow(x[1] - j[1], 2)), V = Math.atan2(j[1] - x[1], j[0] - x[0]), $ = r.h.v;
          $ >= 1 ? $ = 0.99 : $ <= -1 && ($ = -0.99);
          var X = Z * $, W = Math.cos(V + r.a.v) * X + x[0], Y = Math.sin(V + r.a.v) * X + x[1];
          a = l.createRadialGradient(W, Y, 0, x[0], x[1], Z);
        }
        var U = t.g.p, G = r.g.c, K = 1;
        for (o = 0; o < U; o += 1) r.g._hasOpacity && r.g._collapsable && (K = r.g.o[2 * o + 1]), a.addColorStop(G[4 * o] / 100, "rgba(" + G[4 * o + 1] + "," + G[4 * o + 2] + "," + G[4 * o + 3] + "," + K + ")");
        s.grd = a;
      }
      s.coOp = r.o.v * n.opacity;
    }, CVShapeElement.prototype.renderStroke = function(t, r, n) {
      var a = r.style, s = r.d;
      s && (s._mdf || this._isFirstFrame) && (a.da = s.dashArray, a.do = s.dashoffset[0]), (r.c._mdf || this._isFirstFrame) && (a.co = "rgb(" + bmFloor(r.c.v[0]) + "," + bmFloor(r.c.v[1]) + "," + bmFloor(r.c.v[2]) + ")"), (r.o._mdf || n._opMdf || this._isFirstFrame) && (a.coOp = r.o.v * n.opacity), (r.w._mdf || this._isFirstFrame) && (a.wi = r.w.v);
    }, CVShapeElement.prototype.destroy = function() {
      this.shapesData = null, this.globalData = null, this.canvasContext = null, this.stylesList.length = 0, this.itemsData.length = 0;
    }, extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement, ITextElement], CVTextElement), CVTextElement.prototype.tHelper = createTag("canvas").getContext("2d"), CVTextElement.prototype.buildNewText = function() {
      var t = this.textProperty.currentData;
      this.renderedLetters = createSizedArray(t.l ? t.l.length : 0);
      var r = !1;
      t.fc ? (r = !0, this.values.fill = this.buildColor(t.fc)) : this.values.fill = "rgba(0,0,0,0)", this.fill = r;
      var n = !1;
      t.sc && (n = !0, this.values.stroke = this.buildColor(t.sc), this.values.sWidth = t.sw);
      var a, s, o, l, x, j, Z, V, $, X, W, Y, U = this.globalData.fontManager.getFontByName(t.f), G = t.l, K = this.mHelper;
      this.stroke = n, this.values.fValue = t.finalSize + "px " + this.globalData.fontManager.getFontByName(t.f).fFamily, s = t.finalText.length;
      var J = this.data.singleShape, ee = 1e-3 * t.tr * t.finalSize, te = 0, re = 0, ae = !0, ie = 0;
      for (a = 0; a < s; a += 1) {
        l = (o = this.globalData.fontManager.getCharData(t.finalText[a], U.fStyle, this.globalData.fontManager.getFontByName(t.f).fFamily)) && o.data || {}, K.reset(), J && G[a].n && (te = -ee, re += t.yOffset, re += ae ? 1 : 0, ae = !1), $ = (Z = l.shapes ? l.shapes[0].it : []).length, K.scale(t.finalSize / 100, t.finalSize / 100), J && this.applyTextPropertiesToMatrix(t, K, G[a].line, te, re), W = createSizedArray($ - 1);
        var ce = 0;
        for (V = 0; V < $; V += 1) if (Z[V].ty === "sh") {
          for (j = Z[V].ks.k.i.length, X = Z[V].ks.k, Y = [], x = 1; x < j; x += 1) x === 1 && Y.push(K.applyToX(X.v[0][0], X.v[0][1], 0), K.applyToY(X.v[0][0], X.v[0][1], 0)), Y.push(K.applyToX(X.o[x - 1][0], X.o[x - 1][1], 0), K.applyToY(X.o[x - 1][0], X.o[x - 1][1], 0), K.applyToX(X.i[x][0], X.i[x][1], 0), K.applyToY(X.i[x][0], X.i[x][1], 0), K.applyToX(X.v[x][0], X.v[x][1], 0), K.applyToY(X.v[x][0], X.v[x][1], 0));
          Y.push(K.applyToX(X.o[x - 1][0], X.o[x - 1][1], 0), K.applyToY(X.o[x - 1][0], X.o[x - 1][1], 0), K.applyToX(X.i[0][0], X.i[0][1], 0), K.applyToY(X.i[0][0], X.i[0][1], 0), K.applyToX(X.v[0][0], X.v[0][1], 0), K.applyToY(X.v[0][0], X.v[0][1], 0)), W[ce] = Y, ce += 1;
        }
        J && (te += G[a].l, te += ee), this.textSpans[ie] ? this.textSpans[ie].elem = W : this.textSpans[ie] = { elem: W }, ie += 1;
      }
    }, CVTextElement.prototype.renderInnerContent = function() {
      var t, r, n, a, s, o;
      this.validateText(), this.canvasContext.font = this.values.fValue, this.globalData.renderer.ctxLineCap("butt"), this.globalData.renderer.ctxLineJoin("miter"), this.globalData.renderer.ctxMiterLimit(4), this.data.singleShape || this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
      var l, x = this.textAnimator.renderedLetters, j = this.textProperty.currentData.l;
      r = j.length;
      var Z, V, $ = null, X = null, W = null, Y = this.globalData.renderer;
      for (t = 0; t < r; t += 1) if (!j[t].n) {
        if ((l = x[t]) && (Y.save(), Y.ctxTransform(l.p), Y.ctxOpacity(l.o)), this.fill) {
          for (l && l.fc ? $ !== l.fc && (Y.ctxFillStyle(l.fc), $ = l.fc) : $ !== this.values.fill && ($ = this.values.fill, Y.ctxFillStyle(this.values.fill)), a = (Z = this.textSpans[t].elem).length, this.globalData.canvasContext.beginPath(), n = 0; n < a; n += 1) for (o = (V = Z[n]).length, this.globalData.canvasContext.moveTo(V[0], V[1]), s = 2; s < o; s += 6) this.globalData.canvasContext.bezierCurveTo(V[s], V[s + 1], V[s + 2], V[s + 3], V[s + 4], V[s + 5]);
          this.globalData.canvasContext.closePath(), Y.ctxFill();
        }
        if (this.stroke) {
          for (l && l.sw ? W !== l.sw && (W = l.sw, Y.ctxLineWidth(l.sw)) : W !== this.values.sWidth && (W = this.values.sWidth, Y.ctxLineWidth(this.values.sWidth)), l && l.sc ? X !== l.sc && (X = l.sc, Y.ctxStrokeStyle(l.sc)) : X !== this.values.stroke && (X = this.values.stroke, Y.ctxStrokeStyle(this.values.stroke)), a = (Z = this.textSpans[t].elem).length, this.globalData.canvasContext.beginPath(), n = 0; n < a; n += 1) for (o = (V = Z[n]).length, this.globalData.canvasContext.moveTo(V[0], V[1]), s = 2; s < o; s += 6) this.globalData.canvasContext.bezierCurveTo(V[s], V[s + 1], V[s + 2], V[s + 3], V[s + 4], V[s + 5]);
          this.globalData.canvasContext.closePath(), Y.ctxStroke();
        }
        l && this.globalData.renderer.restore();
      }
    }, extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVImageElement), CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement, CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame, CVImageElement.prototype.createContent = function() {
      if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
        var t = createTag("canvas");
        t.width = this.assetData.w, t.height = this.assetData.h;
        var r, n, a = t.getContext("2d"), s = this.img.width, o = this.img.height, l = s / o, x = this.assetData.w / this.assetData.h, j = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
        l > x && j === "xMidYMid slice" || l < x && j !== "xMidYMid slice" ? r = (n = o) * x : n = (r = s) / x, a.drawImage(this.img, (s - r) / 2, (o - n) / 2, r, n, 0, 0, this.assetData.w, this.assetData.h), this.img = t;
      }
    }, CVImageElement.prototype.renderInnerContent = function() {
      this.canvasContext.drawImage(this.img, 0, 0);
    }, CVImageElement.prototype.destroy = function() {
      this.img = null;
    }, extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVSolidElement), CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement, CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame, CVSolidElement.prototype.renderInnerContent = function() {
      this.globalData.renderer.ctxFillStyle(this.data.sc), this.globalData.renderer.ctxFillRect(0, 0, this.data.sw, this.data.sh);
    }, extendPrototype([BaseRenderer], CanvasRendererBase), CanvasRendererBase.prototype.createShape = function(t) {
      return new CVShapeElement(t, this.globalData, this);
    }, CanvasRendererBase.prototype.createText = function(t) {
      return new CVTextElement(t, this.globalData, this);
    }, CanvasRendererBase.prototype.createImage = function(t) {
      return new CVImageElement(t, this.globalData, this);
    }, CanvasRendererBase.prototype.createSolid = function(t) {
      return new CVSolidElement(t, this.globalData, this);
    }, CanvasRendererBase.prototype.createNull = SVGRenderer.prototype.createNull, CanvasRendererBase.prototype.ctxTransform = function(t) {
      t[0] === 1 && t[1] === 0 && t[4] === 0 && t[5] === 1 && t[12] === 0 && t[13] === 0 || this.canvasContext.transform(t[0], t[1], t[4], t[5], t[12], t[13]);
    }, CanvasRendererBase.prototype.ctxOpacity = function(t) {
      this.canvasContext.globalAlpha *= t < 0 ? 0 : t;
    }, CanvasRendererBase.prototype.ctxFillStyle = function(t) {
      this.canvasContext.fillStyle = t;
    }, CanvasRendererBase.prototype.ctxStrokeStyle = function(t) {
      this.canvasContext.strokeStyle = t;
    }, CanvasRendererBase.prototype.ctxLineWidth = function(t) {
      this.canvasContext.lineWidth = t;
    }, CanvasRendererBase.prototype.ctxLineCap = function(t) {
      this.canvasContext.lineCap = t;
    }, CanvasRendererBase.prototype.ctxLineJoin = function(t) {
      this.canvasContext.lineJoin = t;
    }, CanvasRendererBase.prototype.ctxMiterLimit = function(t) {
      this.canvasContext.miterLimit = t;
    }, CanvasRendererBase.prototype.ctxFill = function(t) {
      this.canvasContext.fill(t);
    }, CanvasRendererBase.prototype.ctxFillRect = function(t, r, n, a) {
      this.canvasContext.fillRect(t, r, n, a);
    }, CanvasRendererBase.prototype.ctxStroke = function() {
      this.canvasContext.stroke();
    }, CanvasRendererBase.prototype.reset = function() {
      this.renderConfig.clearCanvas ? this.contextData.reset() : this.canvasContext.restore();
    }, CanvasRendererBase.prototype.save = function() {
      this.canvasContext.save();
    }, CanvasRendererBase.prototype.restore = function(t) {
      this.renderConfig.clearCanvas ? (t && (this.globalData.blendMode = "source-over"), this.contextData.restore(t)) : this.canvasContext.restore();
    }, CanvasRendererBase.prototype.configAnimation = function(t) {
      if (this.animationItem.wrapper) {
        this.animationItem.container = createTag("canvas");
        var r = this.animationItem.container.style;
        r.width = "100%", r.height = "100%";
        var n = "0px 0px 0px";
        r.transformOrigin = n, r.mozTransformOrigin = n, r.webkitTransformOrigin = n, r["-webkit-transform"] = n, r.contentVisibility = this.renderConfig.contentVisibility, this.animationItem.wrapper.appendChild(this.animationItem.container), this.canvasContext = this.animationItem.container.getContext("2d"), this.renderConfig.className && this.animationItem.container.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.animationItem.container.setAttribute("id", this.renderConfig.id);
      } else this.canvasContext = this.renderConfig.context;
      this.contextData.setContext(this.canvasContext), this.data = t, this.layers = t.layers, this.transformCanvas = { w: t.w, h: t.h, sx: 0, sy: 0, tx: 0, ty: 0 }, this.setupGlobalData(t, document.body), this.globalData.canvasContext = this.canvasContext, this.globalData.renderer = this, this.globalData.isDashed = !1, this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.globalData.transformCanvas = this.transformCanvas, this.elements = createSizedArray(t.layers.length), this.updateContainerSize();
    }, CanvasRendererBase.prototype.updateContainerSize = function(t, r) {
      var n, a, s, o;
      if (this.reset(), t ? (n = t, a = r, this.canvasContext.canvas.width = n, this.canvasContext.canvas.height = a) : (this.animationItem.wrapper && this.animationItem.container ? (n = this.animationItem.wrapper.offsetWidth, a = this.animationItem.wrapper.offsetHeight) : (n = this.canvasContext.canvas.width, a = this.canvasContext.canvas.height), this.canvasContext.canvas.width = n * this.renderConfig.dpr, this.canvasContext.canvas.height = a * this.renderConfig.dpr), this.renderConfig.preserveAspectRatio.indexOf("meet") !== -1 || this.renderConfig.preserveAspectRatio.indexOf("slice") !== -1) {
        var l = this.renderConfig.preserveAspectRatio.split(" "), x = l[1] || "meet", j = l[0] || "xMidYMid", Z = j.substr(0, 4), V = j.substr(4);
        s = n / a, (o = this.transformCanvas.w / this.transformCanvas.h) > s && x === "meet" || o < s && x === "slice" ? (this.transformCanvas.sx = n / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = n / (this.transformCanvas.w / this.renderConfig.dpr)) : (this.transformCanvas.sx = a / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.sy = a / (this.transformCanvas.h / this.renderConfig.dpr)), this.transformCanvas.tx = Z === "xMid" && (o < s && x === "meet" || o > s && x === "slice") ? (n - this.transformCanvas.w * (a / this.transformCanvas.h)) / 2 * this.renderConfig.dpr : Z === "xMax" && (o < s && x === "meet" || o > s && x === "slice") ? (n - this.transformCanvas.w * (a / this.transformCanvas.h)) * this.renderConfig.dpr : 0, this.transformCanvas.ty = V === "YMid" && (o > s && x === "meet" || o < s && x === "slice") ? (a - this.transformCanvas.h * (n / this.transformCanvas.w)) / 2 * this.renderConfig.dpr : V === "YMax" && (o > s && x === "meet" || o < s && x === "slice") ? (a - this.transformCanvas.h * (n / this.transformCanvas.w)) * this.renderConfig.dpr : 0;
      } else this.renderConfig.preserveAspectRatio === "none" ? (this.transformCanvas.sx = n / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = a / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.tx = 0, this.transformCanvas.ty = 0) : (this.transformCanvas.sx = this.renderConfig.dpr, this.transformCanvas.sy = this.renderConfig.dpr, this.transformCanvas.tx = 0, this.transformCanvas.ty = 0);
      this.transformCanvas.props = [this.transformCanvas.sx, 0, 0, 0, 0, this.transformCanvas.sy, 0, 0, 0, 0, 1, 0, this.transformCanvas.tx, this.transformCanvas.ty, 0, 1], this.ctxTransform(this.transformCanvas.props), this.canvasContext.beginPath(), this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h), this.canvasContext.closePath(), this.canvasContext.clip(), this.renderFrame(this.renderedFrame, !0);
    }, CanvasRendererBase.prototype.destroy = function() {
      var t;
      for (this.renderConfig.clearCanvas && this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), t = (this.layers ? this.layers.length : 0) - 1; t >= 0; t -= 1) this.elements[t] && this.elements[t].destroy && this.elements[t].destroy();
      this.elements.length = 0, this.globalData.canvasContext = null, this.animationItem.container = null, this.destroyed = !0;
    }, CanvasRendererBase.prototype.renderFrame = function(t, r) {
      if ((this.renderedFrame !== t || this.renderConfig.clearCanvas !== !0 || r) && !this.destroyed && t !== -1) {
        var n;
        this.renderedFrame = t, this.globalData.frameNum = t - this.animationItem._isFirstFrame, this.globalData.frameId += 1, this.globalData._mdf = !this.renderConfig.clearCanvas || r, this.globalData.projectInterface.currentFrame = t;
        var a = this.layers.length;
        for (this.completeLayers || this.checkLayers(t), n = a - 1; n >= 0; n -= 1) (this.completeLayers || this.elements[n]) && this.elements[n].prepareFrame(t - this.layers[n].st);
        if (this.globalData._mdf) {
          for (this.renderConfig.clearCanvas === !0 ? this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h) : this.save(), n = a - 1; n >= 0; n -= 1) (this.completeLayers || this.elements[n]) && this.elements[n].renderFrame();
          this.renderConfig.clearCanvas !== !0 && this.restore();
        }
      }
    }, CanvasRendererBase.prototype.buildItem = function(t) {
      var r = this.elements;
      if (!r[t] && this.layers[t].ty !== 99) {
        var n = this.createItem(this.layers[t], this, this.globalData);
        r[t] = n, n.initExpressions();
      }
    }, CanvasRendererBase.prototype.checkPendingElements = function() {
      for (; this.pendingElements.length; )
        this.pendingElements.pop().checkParenting();
    }, CanvasRendererBase.prototype.hide = function() {
      this.animationItem.container.style.display = "none";
    }, CanvasRendererBase.prototype.show = function() {
      this.animationItem.container.style.display = "block";
    }, CVContextData.prototype.duplicate = function() {
      var t = 2 * this._length, r = 0;
      for (r = this._length; r < t; r += 1) this.stack[r] = new CanvasContext();
      this._length = t;
    }, CVContextData.prototype.reset = function() {
      this.cArrPos = 0, this.cTr.reset(), this.stack[this.cArrPos].opacity = 1;
    }, CVContextData.prototype.restore = function(t) {
      this.cArrPos -= 1;
      var r, n = this.stack[this.cArrPos], a = n.transform, s = this.cTr.props;
      for (r = 0; r < 16; r += 1) s[r] = a[r];
      if (t) {
        this.nativeContext.restore();
        var o = this.stack[this.cArrPos + 1];
        this.appliedFillStyle = o.fillStyle, this.appliedStrokeStyle = o.strokeStyle, this.appliedLineWidth = o.lineWidth, this.appliedLineCap = o.lineCap, this.appliedLineJoin = o.lineJoin, this.appliedMiterLimit = o.miterLimit;
      }
      this.nativeContext.setTransform(a[0], a[1], a[4], a[5], a[12], a[13]), (t || n.opacity !== -1 && this.currentOpacity !== n.opacity) && (this.nativeContext.globalAlpha = n.opacity, this.currentOpacity = n.opacity), this.currentFillStyle = n.fillStyle, this.currentStrokeStyle = n.strokeStyle, this.currentLineWidth = n.lineWidth, this.currentLineCap = n.lineCap, this.currentLineJoin = n.lineJoin, this.currentMiterLimit = n.miterLimit;
    }, CVContextData.prototype.save = function(t) {
      t && this.nativeContext.save();
      var r = this.cTr.props;
      this._length <= this.cArrPos && this.duplicate();
      var n, a = this.stack[this.cArrPos];
      for (n = 0; n < 16; n += 1) a.transform[n] = r[n];
      this.cArrPos += 1;
      var s = this.stack[this.cArrPos];
      s.opacity = a.opacity, s.fillStyle = a.fillStyle, s.strokeStyle = a.strokeStyle, s.lineWidth = a.lineWidth, s.lineCap = a.lineCap, s.lineJoin = a.lineJoin, s.miterLimit = a.miterLimit;
    }, CVContextData.prototype.setOpacity = function(t) {
      this.stack[this.cArrPos].opacity = t;
    }, CVContextData.prototype.setContext = function(t) {
      this.nativeContext = t;
    }, CVContextData.prototype.fillStyle = function(t) {
      this.stack[this.cArrPos].fillStyle !== t && (this.currentFillStyle = t, this.stack[this.cArrPos].fillStyle = t);
    }, CVContextData.prototype.strokeStyle = function(t) {
      this.stack[this.cArrPos].strokeStyle !== t && (this.currentStrokeStyle = t, this.stack[this.cArrPos].strokeStyle = t);
    }, CVContextData.prototype.lineWidth = function(t) {
      this.stack[this.cArrPos].lineWidth !== t && (this.currentLineWidth = t, this.stack[this.cArrPos].lineWidth = t);
    }, CVContextData.prototype.lineCap = function(t) {
      this.stack[this.cArrPos].lineCap !== t && (this.currentLineCap = t, this.stack[this.cArrPos].lineCap = t);
    }, CVContextData.prototype.lineJoin = function(t) {
      this.stack[this.cArrPos].lineJoin !== t && (this.currentLineJoin = t, this.stack[this.cArrPos].lineJoin = t);
    }, CVContextData.prototype.miterLimit = function(t) {
      this.stack[this.cArrPos].miterLimit !== t && (this.currentMiterLimit = t, this.stack[this.cArrPos].miterLimit = t);
    }, CVContextData.prototype.transform = function(t) {
      this.transformMat.cloneFromProps(t);
      var r = this.cTr;
      this.transformMat.multiply(r), r.cloneFromProps(this.transformMat.props);
      var n = r.props;
      this.nativeContext.setTransform(n[0], n[1], n[4], n[5], n[12], n[13]);
    }, CVContextData.prototype.opacity = function(t) {
      var r = this.stack[this.cArrPos].opacity;
      r *= t < 0 ? 0 : t, this.stack[this.cArrPos].opacity !== r && (this.currentOpacity !== t && (this.nativeContext.globalAlpha = t, this.currentOpacity = t), this.stack[this.cArrPos].opacity = r);
    }, CVContextData.prototype.fill = function(t) {
      this.appliedFillStyle !== this.currentFillStyle && (this.appliedFillStyle = this.currentFillStyle, this.nativeContext.fillStyle = this.appliedFillStyle), this.nativeContext.fill(t);
    }, CVContextData.prototype.fillRect = function(t, r, n, a) {
      this.appliedFillStyle !== this.currentFillStyle && (this.appliedFillStyle = this.currentFillStyle, this.nativeContext.fillStyle = this.appliedFillStyle), this.nativeContext.fillRect(t, r, n, a);
    }, CVContextData.prototype.stroke = function() {
      this.appliedStrokeStyle !== this.currentStrokeStyle && (this.appliedStrokeStyle = this.currentStrokeStyle, this.nativeContext.strokeStyle = this.appliedStrokeStyle), this.appliedLineWidth !== this.currentLineWidth && (this.appliedLineWidth = this.currentLineWidth, this.nativeContext.lineWidth = this.appliedLineWidth), this.appliedLineCap !== this.currentLineCap && (this.appliedLineCap = this.currentLineCap, this.nativeContext.lineCap = this.appliedLineCap), this.appliedLineJoin !== this.currentLineJoin && (this.appliedLineJoin = this.currentLineJoin, this.nativeContext.lineJoin = this.appliedLineJoin), this.appliedMiterLimit !== this.currentMiterLimit && (this.appliedMiterLimit = this.currentMiterLimit, this.nativeContext.miterLimit = this.appliedMiterLimit), this.nativeContext.stroke();
    }, extendPrototype([CanvasRendererBase, ICompElement, CVBaseElement], CVCompElement), CVCompElement.prototype.renderInnerContent = function() {
      var t, r = this.canvasContext;
      for (r.beginPath(), r.moveTo(0, 0), r.lineTo(this.data.w, 0), r.lineTo(this.data.w, this.data.h), r.lineTo(0, this.data.h), r.lineTo(0, 0), r.clip(), t = this.layers.length - 1; t >= 0; t -= 1) (this.completeLayers || this.elements[t]) && this.elements[t].renderFrame();
    }, CVCompElement.prototype.destroy = function() {
      var t;
      for (t = this.layers.length - 1; t >= 0; t -= 1) this.elements[t] && this.elements[t].destroy();
      this.layers = null, this.elements = null;
    }, CVCompElement.prototype.createComp = function(t) {
      return new CVCompElement(t, this.globalData, this);
    }, extendPrototype([CanvasRendererBase], CanvasRenderer), CanvasRenderer.prototype.createComp = function(t) {
      return new CVCompElement(t, this.globalData, this);
    }, HBaseElement.prototype = { checkBlendMode: function() {
    }, initRendererElement: function() {
      this.baseElement = createTag(this.data.tg || "div"), this.data.hasMask ? (this.svgElement = createNS("svg"), this.layerElement = createNS("g"), this.maskedElement = this.layerElement, this.svgElement.appendChild(this.layerElement), this.baseElement.appendChild(this.svgElement)) : this.layerElement = this.baseElement, styleDiv(this.baseElement);
    }, createContainerElements: function() {
      this.renderableEffectsManager = new CVEffects(this), this.transformedElement = this.baseElement, this.maskedElement = this.layerElement, this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), this.data.bm !== 0 && this.setBlendMode();
    }, renderElement: function() {
      var t = this.transformedElement ? this.transformedElement.style : {};
      if (this.finalTransform._matMdf) {
        var r = this.finalTransform.mat.toCSS();
        t.transform = r, t.webkitTransform = r;
      }
      this.finalTransform._opMdf && (t.opacity = this.finalTransform.mProp.o.v);
    }, renderFrame: function() {
      this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
    }, destroy: function() {
      this.layerElement = null, this.transformedElement = null, this.matteElement && (this.matteElement = null), this.maskManager && (this.maskManager.destroy(), this.maskManager = null);
    }, createRenderableComponents: function() {
      this.maskManager = new MaskElement(this.data, this, this.globalData);
    }, addEffects: function() {
    }, setMatte: function() {
    } }, HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement, HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy, HBaseElement.prototype.buildElementParenting = BaseRenderer.prototype.buildElementParenting, extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], HSolidElement), HSolidElement.prototype.createContent = function() {
      var t;
      this.data.hasMask ? ((t = createNS("rect")).setAttribute("width", this.data.sw), t.setAttribute("height", this.data.sh), t.setAttribute("fill", this.data.sc), this.svgElement.setAttribute("width", this.data.sw), this.svgElement.setAttribute("height", this.data.sh)) : ((t = createTag("div")).style.width = this.data.sw + "px", t.style.height = this.data.sh + "px", t.style.backgroundColor = this.data.sc), this.layerElement.appendChild(t);
    }, extendPrototype([BaseElement, TransformElement, HSolidElement, SVGShapeElement, HBaseElement, HierarchyElement, FrameElement, RenderableElement], HShapeElement), HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent, HShapeElement.prototype.createContent = function() {
      var t;
      if (this.baseElement.style.fontSize = 0, this.data.hasMask) this.layerElement.appendChild(this.shapesContainer), t = this.svgElement;
      else {
        t = createNS("svg");
        var r = this.comp.data ? this.comp.data : this.globalData.compSize;
        t.setAttribute("width", r.w), t.setAttribute("height", r.h), t.appendChild(this.shapesContainer), this.layerElement.appendChild(t);
      }
      this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], !0), this.filterUniqueShapes(), this.shapeCont = t;
    }, HShapeElement.prototype.getTransformedPoint = function(t, r) {
      var n, a = t.length;
      for (n = 0; n < a; n += 1) r = t[n].mProps.v.applyToPointArray(r[0], r[1], 0);
      return r;
    }, HShapeElement.prototype.calculateShapeBoundingBox = function(t, r) {
      var n, a, s, o, l, x = t.sh.v, j = t.transformers, Z = x._length;
      if (!(Z <= 1)) {
        for (n = 0; n < Z - 1; n += 1) a = this.getTransformedPoint(j, x.v[n]), s = this.getTransformedPoint(j, x.o[n]), o = this.getTransformedPoint(j, x.i[n + 1]), l = this.getTransformedPoint(j, x.v[n + 1]), this.checkBounds(a, s, o, l, r);
        x.c && (a = this.getTransformedPoint(j, x.v[n]), s = this.getTransformedPoint(j, x.o[n]), o = this.getTransformedPoint(j, x.i[0]), l = this.getTransformedPoint(j, x.v[0]), this.checkBounds(a, s, o, l, r));
      }
    }, HShapeElement.prototype.checkBounds = function(t, r, n, a, s) {
      this.getBoundsOfCurve(t, r, n, a);
      var o = this.shapeBoundingBox;
      s.x = bmMin(o.left, s.x), s.xMax = bmMax(o.right, s.xMax), s.y = bmMin(o.top, s.y), s.yMax = bmMax(o.bottom, s.yMax);
    }, HShapeElement.prototype.shapeBoundingBox = { left: 0, right: 0, top: 0, bottom: 0 }, HShapeElement.prototype.tempBoundingBox = { x: 0, xMax: 0, y: 0, yMax: 0, width: 0, height: 0 }, HShapeElement.prototype.getBoundsOfCurve = function(t, r, n, a) {
      for (var s, o, l, x, j, Z, V, $ = [[t[0], a[0]], [t[1], a[1]]], X = 0; X < 2; ++X) o = 6 * t[X] - 12 * r[X] + 6 * n[X], s = -3 * t[X] + 9 * r[X] - 9 * n[X] + 3 * a[X], l = 3 * r[X] - 3 * t[X], o |= 0, l |= 0, (s |= 0) === 0 && o === 0 || (s === 0 ? (x = -l / o) > 0 && x < 1 && $[X].push(this.calculateF(x, t, r, n, a, X)) : (j = o * o - 4 * l * s) >= 0 && ((Z = (-o + bmSqrt(j)) / (2 * s)) > 0 && Z < 1 && $[X].push(this.calculateF(Z, t, r, n, a, X)), (V = (-o - bmSqrt(j)) / (2 * s)) > 0 && V < 1 && $[X].push(this.calculateF(V, t, r, n, a, X))));
      this.shapeBoundingBox.left = bmMin.apply(null, $[0]), this.shapeBoundingBox.top = bmMin.apply(null, $[1]), this.shapeBoundingBox.right = bmMax.apply(null, $[0]), this.shapeBoundingBox.bottom = bmMax.apply(null, $[1]);
    }, HShapeElement.prototype.calculateF = function(t, r, n, a, s, o) {
      return bmPow(1 - t, 3) * r[o] + 3 * bmPow(1 - t, 2) * t * n[o] + 3 * (1 - t) * bmPow(t, 2) * a[o] + bmPow(t, 3) * s[o];
    }, HShapeElement.prototype.calculateBoundingBox = function(t, r) {
      var n, a = t.length;
      for (n = 0; n < a; n += 1) t[n] && t[n].sh ? this.calculateShapeBoundingBox(t[n], r) : t[n] && t[n].it ? this.calculateBoundingBox(t[n].it, r) : t[n] && t[n].style && t[n].w && this.expandStrokeBoundingBox(t[n].w, r);
    }, HShapeElement.prototype.expandStrokeBoundingBox = function(t, r) {
      var n = 0;
      if (t.keyframes) {
        for (var a = 0; a < t.keyframes.length; a += 1) {
          var s = t.keyframes[a].s;
          s > n && (n = s);
        }
        n *= t.mult;
      } else n = t.v * t.mult;
      r.x -= n, r.xMax += n, r.y -= n, r.yMax += n;
    }, HShapeElement.prototype.currentBoxContains = function(t) {
      return this.currentBBox.x <= t.x && this.currentBBox.y <= t.y && this.currentBBox.width + this.currentBBox.x >= t.x + t.width && this.currentBBox.height + this.currentBBox.y >= t.y + t.height;
    }, HShapeElement.prototype.renderInnerContent = function() {
      if (this._renderShapeFrame(), !this.hidden && (this._isFirstFrame || this._mdf)) {
        var t = this.tempBoundingBox, r = 999999;
        if (t.x = r, t.xMax = -r, t.y = r, t.yMax = -r, this.calculateBoundingBox(this.itemsData, t), t.width = t.xMax < t.x ? 0 : t.xMax - t.x, t.height = t.yMax < t.y ? 0 : t.yMax - t.y, this.currentBoxContains(t)) return;
        var n = !1;
        if (this.currentBBox.w !== t.width && (this.currentBBox.w = t.width, this.shapeCont.setAttribute("width", t.width), n = !0), this.currentBBox.h !== t.height && (this.currentBBox.h = t.height, this.shapeCont.setAttribute("height", t.height), n = !0), n || this.currentBBox.x !== t.x || this.currentBBox.y !== t.y) {
          this.currentBBox.w = t.width, this.currentBBox.h = t.height, this.currentBBox.x = t.x, this.currentBBox.y = t.y, this.shapeCont.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h);
          var a = this.shapeCont.style, s = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
          a.transform = s, a.webkitTransform = s;
        }
      }
    }, extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], HTextElement), HTextElement.prototype.createContent = function() {
      if (this.isMasked = this.checkMasks(), this.isMasked) {
        this.renderType = "svg", this.compW = this.comp.data.w, this.compH = this.comp.data.h, this.svgElement.setAttribute("width", this.compW), this.svgElement.setAttribute("height", this.compH);
        var t = createNS("g");
        this.maskedElement.appendChild(t), this.innerElem = t;
      } else this.renderType = "html", this.innerElem = this.layerElement;
      this.checkParenting();
    }, HTextElement.prototype.buildNewText = function() {
      var t = this.textProperty.currentData;
      this.renderedLetters = createSizedArray(t.l ? t.l.length : 0);
      var r = this.innerElem.style, n = t.fc ? this.buildColor(t.fc) : "rgba(0,0,0,0)";
      r.fill = n, r.color = n, t.sc && (r.stroke = this.buildColor(t.sc), r.strokeWidth = t.sw + "px");
      var a, s, o = this.globalData.fontManager.getFontByName(t.f);
      if (!this.globalData.fontManager.chars) if (r.fontSize = t.finalSize + "px", r.lineHeight = t.finalSize + "px", o.fClass) this.innerElem.className = o.fClass;
      else {
        r.fontFamily = o.fFamily;
        var l = t.fWeight, x = t.fStyle;
        r.fontStyle = x, r.fontWeight = l;
      }
      var j, Z, V, $ = t.l;
      s = $.length;
      var X, W = this.mHelper, Y = "", U = 0;
      for (a = 0; a < s; a += 1) {
        if (this.globalData.fontManager.chars ? (this.textPaths[U] ? j = this.textPaths[U] : ((j = createNS("path")).setAttribute("stroke-linecap", lineCapEnum[1]), j.setAttribute("stroke-linejoin", lineJoinEnum[2]), j.setAttribute("stroke-miterlimit", "4")), this.isMasked || (this.textSpans[U] ? V = (Z = this.textSpans[U]).children[0] : ((Z = createTag("div")).style.lineHeight = 0, (V = createNS("svg")).appendChild(j), styleDiv(Z)))) : this.isMasked ? j = this.textPaths[U] ? this.textPaths[U] : createNS("text") : this.textSpans[U] ? (Z = this.textSpans[U], j = this.textPaths[U]) : (styleDiv(Z = createTag("span")), styleDiv(j = createTag("span")), Z.appendChild(j)), this.globalData.fontManager.chars) {
          var G, K = this.globalData.fontManager.getCharData(t.finalText[a], o.fStyle, this.globalData.fontManager.getFontByName(t.f).fFamily);
          if (G = K ? K.data : null, W.reset(), G && G.shapes && G.shapes.length && (X = G.shapes[0].it, W.scale(t.finalSize / 100, t.finalSize / 100), Y = this.createPathShape(W, X), j.setAttribute("d", Y)), this.isMasked) this.innerElem.appendChild(j);
          else {
            if (this.innerElem.appendChild(Z), G && G.shapes) {
              document.body.appendChild(V);
              var J = V.getBBox();
              V.setAttribute("width", J.width + 2), V.setAttribute("height", J.height + 2), V.setAttribute("viewBox", J.x - 1 + " " + (J.y - 1) + " " + (J.width + 2) + " " + (J.height + 2));
              var ee = V.style, te = "translate(" + (J.x - 1) + "px," + (J.y - 1) + "px)";
              ee.transform = te, ee.webkitTransform = te, $[a].yOffset = J.y - 1;
            } else V.setAttribute("width", 1), V.setAttribute("height", 1);
            Z.appendChild(V);
          }
        } else if (j.textContent = $[a].val, j.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve"), this.isMasked) this.innerElem.appendChild(j);
        else {
          this.innerElem.appendChild(Z);
          var re = j.style, ae = "translate3d(0," + -t.finalSize / 1.2 + "px,0)";
          re.transform = ae, re.webkitTransform = ae;
        }
        this.isMasked ? this.textSpans[U] = j : this.textSpans[U] = Z, this.textSpans[U].style.display = "block", this.textPaths[U] = j, U += 1;
      }
      for (; U < this.textSpans.length; ) this.textSpans[U].style.display = "none", U += 1;
    }, HTextElement.prototype.renderInnerContent = function() {
      var t;
      if (this.validateText(), this.data.singleShape) {
        if (!this._isFirstFrame && !this.lettersChangedFlag) return;
        if (this.isMasked && this.finalTransform._matMdf) {
          this.svgElement.setAttribute("viewBox", -this.finalTransform.mProp.p.v[0] + " " + -this.finalTransform.mProp.p.v[1] + " " + this.compW + " " + this.compH), t = this.svgElement.style;
          var r = "translate(" + -this.finalTransform.mProp.p.v[0] + "px," + -this.finalTransform.mProp.p.v[1] + "px)";
          t.transform = r, t.webkitTransform = r;
        }
      }
      if (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag) {
        var n, a, s, o, l, x = 0, j = this.textAnimator.renderedLetters, Z = this.textProperty.currentData.l;
        for (a = Z.length, n = 0; n < a; n += 1) Z[n].n ? x += 1 : (o = this.textSpans[n], l = this.textPaths[n], s = j[x], x += 1, s._mdf.m && (this.isMasked ? o.setAttribute("transform", s.m) : (o.style.webkitTransform = s.m, o.style.transform = s.m)), o.style.opacity = s.o, s.sw && s._mdf.sw && l.setAttribute("stroke-width", s.sw), s.sc && s._mdf.sc && l.setAttribute("stroke", s.sc), s.fc && s._mdf.fc && (l.setAttribute("fill", s.fc), l.style.color = s.fc));
        if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
          var V = this.innerElem.getBBox();
          if (this.currentBBox.w !== V.width && (this.currentBBox.w = V.width, this.svgElement.setAttribute("width", V.width)), this.currentBBox.h !== V.height && (this.currentBBox.h = V.height, this.svgElement.setAttribute("height", V.height)), this.currentBBox.w !== V.width + 2 || this.currentBBox.h !== V.height + 2 || this.currentBBox.x !== V.x - 1 || this.currentBBox.y !== V.y - 1) {
            this.currentBBox.w = V.width + 2, this.currentBBox.h = V.height + 2, this.currentBBox.x = V.x - 1, this.currentBBox.y = V.y - 1, this.svgElement.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h), t = this.svgElement.style;
            var $ = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
            t.transform = $, t.webkitTransform = $;
          }
        }
      }
    }, extendPrototype([BaseElement, FrameElement, HierarchyElement], HCameraElement), HCameraElement.prototype.setup = function() {
      var t, r, n, a, s = this.comp.threeDElements.length;
      for (t = 0; t < s; t += 1) if ((r = this.comp.threeDElements[t]).type === "3d") {
        n = r.perspectiveElem.style, a = r.container.style;
        var o = this.pe.v + "px", l = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
        n.perspective = o, n.webkitPerspective = o, a.transformOrigin = "0px 0px 0px", a.mozTransformOrigin = "0px 0px 0px", a.webkitTransformOrigin = "0px 0px 0px", n.transform = l, n.webkitTransform = l;
      }
    }, HCameraElement.prototype.createElements = function() {
    }, HCameraElement.prototype.hide = function() {
    }, HCameraElement.prototype.renderFrame = function() {
      var t, r, n = this._isFirstFrame;
      if (this.hierarchy) for (r = this.hierarchy.length, t = 0; t < r; t += 1) n = this.hierarchy[t].finalTransform.mProp._mdf || n;
      if (n || this.pe._mdf || this.p && this.p._mdf || this.px && (this.px._mdf || this.py._mdf || this.pz._mdf) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || this.a && this.a._mdf) {
        if (this.mat.reset(), this.hierarchy) for (t = r = this.hierarchy.length - 1; t >= 0; t -= 1) {
          var a = this.hierarchy[t].finalTransform.mProp;
          this.mat.translate(-a.p.v[0], -a.p.v[1], a.p.v[2]), this.mat.rotateX(-a.or.v[0]).rotateY(-a.or.v[1]).rotateZ(a.or.v[2]), this.mat.rotateX(-a.rx.v).rotateY(-a.ry.v).rotateZ(a.rz.v), this.mat.scale(1 / a.s.v[0], 1 / a.s.v[1], 1 / a.s.v[2]), this.mat.translate(a.a.v[0], a.a.v[1], a.a.v[2]);
        }
        if (this.p ? this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]) : this.mat.translate(-this.px.v, -this.py.v, this.pz.v), this.a) {
          var s;
          s = this.p ? [this.p.v[0] - this.a.v[0], this.p.v[1] - this.a.v[1], this.p.v[2] - this.a.v[2]] : [this.px.v - this.a.v[0], this.py.v - this.a.v[1], this.pz.v - this.a.v[2]];
          var o = Math.sqrt(Math.pow(s[0], 2) + Math.pow(s[1], 2) + Math.pow(s[2], 2)), l = [s[0] / o, s[1] / o, s[2] / o], x = Math.sqrt(l[2] * l[2] + l[0] * l[0]), j = Math.atan2(l[1], x), Z = Math.atan2(l[0], -l[2]);
          this.mat.rotateY(Z).rotateX(-j);
        }
        this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v), this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]), this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0), this.mat.translate(0, 0, this.pe.v);
        var V = !this._prevMat.equals(this.mat);
        if ((V || this.pe._mdf) && this.comp.threeDElements) {
          var $, X, W;
          for (r = this.comp.threeDElements.length, t = 0; t < r; t += 1) if (($ = this.comp.threeDElements[t]).type === "3d") {
            if (V) {
              var Y = this.mat.toCSS();
              (W = $.container.style).transform = Y, W.webkitTransform = Y;
            }
            this.pe._mdf && ((X = $.perspectiveElem.style).perspective = this.pe.v + "px", X.webkitPerspective = this.pe.v + "px");
          }
          this.mat.clone(this._prevMat);
        }
      }
      this._isFirstFrame = !1;
    }, HCameraElement.prototype.prepareFrame = function(t) {
      this.prepareProperties(t, !0);
    }, HCameraElement.prototype.destroy = function() {
    }, HCameraElement.prototype.getBaseElement = function() {
      return null;
    }, extendPrototype([BaseElement, TransformElement, HBaseElement, HSolidElement, HierarchyElement, FrameElement, RenderableElement], HImageElement), HImageElement.prototype.createContent = function() {
      var t = this.globalData.getAssetsPath(this.assetData), r = new Image();
      this.data.hasMask ? (this.imageElem = createNS("image"), this.imageElem.setAttribute("width", this.assetData.w + "px"), this.imageElem.setAttribute("height", this.assetData.h + "px"), this.imageElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", t), this.layerElement.appendChild(this.imageElem), this.baseElement.setAttribute("width", this.assetData.w), this.baseElement.setAttribute("height", this.assetData.h)) : this.layerElement.appendChild(r), r.crossOrigin = "anonymous", r.src = t, this.data.ln && this.baseElement.setAttribute("id", this.data.ln);
    }, extendPrototype([BaseRenderer], HybridRendererBase), HybridRendererBase.prototype.buildItem = SVGRenderer.prototype.buildItem, HybridRendererBase.prototype.checkPendingElements = function() {
      for (; this.pendingElements.length; )
        this.pendingElements.pop().checkParenting();
    }, HybridRendererBase.prototype.appendElementInPos = function(t, r) {
      var n = t.getBaseElement();
      if (n) {
        var a = this.layers[r];
        if (a.ddd && this.supports3d) this.addTo3dContainer(n, r);
        else if (this.threeDElements) this.addTo3dContainer(n, r);
        else {
          for (var s, o, l = 0; l < r; ) this.elements[l] && this.elements[l] !== !0 && this.elements[l].getBaseElement && (o = this.elements[l], s = (this.layers[l].ddd ? this.getThreeDContainerByPos(l) : o.getBaseElement()) || s), l += 1;
          s ? a.ddd && this.supports3d || this.layerElement.insertBefore(n, s) : a.ddd && this.supports3d || this.layerElement.appendChild(n);
        }
      }
    }, HybridRendererBase.prototype.createShape = function(t) {
      return this.supports3d ? new HShapeElement(t, this.globalData, this) : new SVGShapeElement(t, this.globalData, this);
    }, HybridRendererBase.prototype.createText = function(t) {
      return this.supports3d ? new HTextElement(t, this.globalData, this) : new SVGTextLottieElement(t, this.globalData, this);
    }, HybridRendererBase.prototype.createCamera = function(t) {
      return this.camera = new HCameraElement(t, this.globalData, this), this.camera;
    }, HybridRendererBase.prototype.createImage = function(t) {
      return this.supports3d ? new HImageElement(t, this.globalData, this) : new IImageElement(t, this.globalData, this);
    }, HybridRendererBase.prototype.createSolid = function(t) {
      return this.supports3d ? new HSolidElement(t, this.globalData, this) : new ISolidElement(t, this.globalData, this);
    }, HybridRendererBase.prototype.createNull = SVGRenderer.prototype.createNull, HybridRendererBase.prototype.getThreeDContainerByPos = function(t) {
      for (var r = 0, n = this.threeDElements.length; r < n; ) {
        if (this.threeDElements[r].startPos <= t && this.threeDElements[r].endPos >= t) return this.threeDElements[r].perspectiveElem;
        r += 1;
      }
      return null;
    }, HybridRendererBase.prototype.createThreeDContainer = function(t, r) {
      var n, a, s = createTag("div");
      styleDiv(s);
      var o = createTag("div");
      if (styleDiv(o), r === "3d") {
        (n = s.style).width = this.globalData.compSize.w + "px", n.height = this.globalData.compSize.h + "px", n.webkitTransformOrigin = "50% 50%", n.mozTransformOrigin = "50% 50%", n.transformOrigin = "50% 50%";
        var l = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
        (a = o.style).transform = l, a.webkitTransform = l;
      }
      s.appendChild(o);
      var x = { container: o, perspectiveElem: s, startPos: t, endPos: t, type: r };
      return this.threeDElements.push(x), x;
    }, HybridRendererBase.prototype.build3dContainers = function() {
      var t, r, n = this.layers.length, a = "";
      for (t = 0; t < n; t += 1) this.layers[t].ddd && this.layers[t].ty !== 3 ? (a !== "3d" && (a = "3d", r = this.createThreeDContainer(t, "3d")), r.endPos = Math.max(r.endPos, t)) : (a !== "2d" && (a = "2d", r = this.createThreeDContainer(t, "2d")), r.endPos = Math.max(r.endPos, t));
      for (t = (n = this.threeDElements.length) - 1; t >= 0; t -= 1) this.resizerElem.appendChild(this.threeDElements[t].perspectiveElem);
    }, HybridRendererBase.prototype.addTo3dContainer = function(t, r) {
      for (var n = 0, a = this.threeDElements.length; n < a; ) {
        if (r <= this.threeDElements[n].endPos) {
          for (var s, o = this.threeDElements[n].startPos; o < r; ) this.elements[o] && this.elements[o].getBaseElement && (s = this.elements[o].getBaseElement()), o += 1;
          s ? this.threeDElements[n].container.insertBefore(t, s) : this.threeDElements[n].container.appendChild(t);
          break;
        }
        n += 1;
      }
    }, HybridRendererBase.prototype.configAnimation = function(t) {
      var r = createTag("div"), n = this.animationItem.wrapper, a = r.style;
      a.width = t.w + "px", a.height = t.h + "px", this.resizerElem = r, styleDiv(r), a.transformStyle = "flat", a.mozTransformStyle = "flat", a.webkitTransformStyle = "flat", this.renderConfig.className && r.setAttribute("class", this.renderConfig.className), n.appendChild(r), a.overflow = "hidden";
      var s = createNS("svg");
      s.setAttribute("width", "1"), s.setAttribute("height", "1"), styleDiv(s), this.resizerElem.appendChild(s);
      var o = createNS("defs");
      s.appendChild(o), this.data = t, this.setupGlobalData(t, s), this.globalData.defs = o, this.layers = t.layers, this.layerElement = this.resizerElem, this.build3dContainers(), this.updateContainerSize();
    }, HybridRendererBase.prototype.destroy = function() {
      var t;
      this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.animationItem.container = null, this.globalData.defs = null;
      var r = this.layers ? this.layers.length : 0;
      for (t = 0; t < r; t += 1) this.elements[t] && this.elements[t].destroy && this.elements[t].destroy();
      this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
    }, HybridRendererBase.prototype.updateContainerSize = function() {
      var t, r, n, a, s = this.animationItem.wrapper.offsetWidth, o = this.animationItem.wrapper.offsetHeight, l = s / o;
      this.globalData.compSize.w / this.globalData.compSize.h > l ? (t = s / this.globalData.compSize.w, r = s / this.globalData.compSize.w, n = 0, a = (o - this.globalData.compSize.h * (s / this.globalData.compSize.w)) / 2) : (t = o / this.globalData.compSize.h, r = o / this.globalData.compSize.h, n = (s - this.globalData.compSize.w * (o / this.globalData.compSize.h)) / 2, a = 0);
      var x = this.resizerElem.style;
      x.webkitTransform = "matrix3d(" + t + ",0,0,0,0," + r + ",0,0,0,0,1,0," + n + "," + a + ",0,1)", x.transform = x.webkitTransform;
    }, HybridRendererBase.prototype.renderFrame = SVGRenderer.prototype.renderFrame, HybridRendererBase.prototype.hide = function() {
      this.resizerElem.style.display = "none";
    }, HybridRendererBase.prototype.show = function() {
      this.resizerElem.style.display = "block";
    }, HybridRendererBase.prototype.initItems = function() {
      if (this.buildAllItems(), this.camera) this.camera.setup();
      else {
        var t, r = this.globalData.compSize.w, n = this.globalData.compSize.h, a = this.threeDElements.length;
        for (t = 0; t < a; t += 1) {
          var s = this.threeDElements[t].perspectiveElem.style;
          s.webkitPerspective = Math.sqrt(Math.pow(r, 2) + Math.pow(n, 2)) + "px", s.perspective = s.webkitPerspective;
        }
      }
    }, HybridRendererBase.prototype.searchExtraCompositions = function(t) {
      var r, n = t.length, a = createTag("div");
      for (r = 0; r < n; r += 1) if (t[r].xt) {
        var s = this.createComp(t[r], a, this.globalData.comp, null);
        s.initExpressions(), this.globalData.projectInterface.registerComposition(s);
      }
    }, extendPrototype([HybridRendererBase, ICompElement, HBaseElement], HCompElement), HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements, HCompElement.prototype.createContainerElements = function() {
      this._createBaseContainerElements(), this.data.hasMask ? (this.svgElement.setAttribute("width", this.data.w), this.svgElement.setAttribute("height", this.data.h), this.transformedElement = this.baseElement) : this.transformedElement = this.layerElement;
    }, HCompElement.prototype.addTo3dContainer = function(t, r) {
      for (var n, a = 0; a < r; ) this.elements[a] && this.elements[a].getBaseElement && (n = this.elements[a].getBaseElement()), a += 1;
      n ? this.layerElement.insertBefore(t, n) : this.layerElement.appendChild(t);
    }, HCompElement.prototype.createComp = function(t) {
      return this.supports3d ? new HCompElement(t, this.globalData, this) : new SVGCompElement(t, this.globalData, this);
    }, extendPrototype([HybridRendererBase], HybridRenderer), HybridRenderer.prototype.createComp = function(t) {
      return this.supports3d ? new HCompElement(t, this.globalData, this) : new SVGCompElement(t, this.globalData, this);
    };
    var CompExpressionInterface = function(t) {
      function r(n) {
        for (var a = 0, s = t.layers.length; a < s; ) {
          if (t.layers[a].nm === n || t.layers[a].ind === n) return t.elements[a].layerInterface;
          a += 1;
        }
        return null;
      }
      return Object.defineProperty(r, "_name", { value: t.data.nm }), r.layer = r, r.pixelAspect = 1, r.height = t.data.h || t.globalData.compSize.h, r.width = t.data.w || t.globalData.compSize.w, r.pixelAspect = 1, r.frameDuration = 1 / t.globalData.frameRate, r.displayStartTime = 0, r.numLayers = t.layers.length, r;
    };
    function _typeof$2(t) {
      return (_typeof$2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
        return typeof r;
      } : function(r) {
        return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
      })(t);
    }
    function seedRandom(t, r) {
      var n = this, a = r.pow(256, 6), s = r.pow(2, 52), o = 2 * s;
      function l(V) {
        var $, X = V.length, W = this, Y = 0, U = W.i = W.j = 0, G = W.S = [];
        for (X || (V = [X++]); Y < 256; ) G[Y] = Y++;
        for (Y = 0; Y < 256; Y++) G[Y] = G[U = 255 & U + V[Y % X] + ($ = G[Y])], G[U] = $;
        W.g = function(K) {
          for (var J, ee = 0, te = W.i, re = W.j, ae = W.S; K--; ) J = ae[te = 255 & te + 1], ee = 256 * ee + ae[255 & (ae[te] = ae[re = 255 & re + J]) + (ae[re] = J)];
          return W.i = te, W.j = re, ee;
        };
      }
      function x(V, $) {
        return $.i = V.i, $.j = V.j, $.S = V.S.slice(), $;
      }
      function j(V, $) {
        for (var X, W = V + "", Y = 0; Y < W.length; ) $[255 & Y] = 255 & (X ^= 19 * $[255 & Y]) + W.charCodeAt(Y++);
        return Z($);
      }
      function Z(V) {
        return String.fromCharCode.apply(0, V);
      }
      r.seedrandom = function(V, $, X) {
        var W = [], Y = j((function K(J, ee) {
          var te, re = [], ae = _typeof$2(J);
          if (ee && ae == "object") for (te in J) try {
            re.push(K(J[te], ee - 1));
          } catch {
          }
          return re.length ? re : ae == "string" ? J : J + "\0";
        })(($ = $ === !0 ? { entropy: !0 } : $ || {}).entropy ? [V, Z(t)] : V === null ? (function() {
          try {
            var K = new Uint8Array(256);
            return (n.crypto || n.msCrypto).getRandomValues(K), Z(K);
          } catch {
            var J = n.navigator, ee = J && J.plugins;
            return [+/* @__PURE__ */ new Date(), n, ee, n.screen, Z(t)];
          }
        })() : V, 3), W), U = new l(W), G = function() {
          for (var K = U.g(6), J = a, ee = 0; K < s; ) K = 256 * (K + ee), J *= 256, ee = U.g(1);
          for (; K >= o; ) K /= 2, J /= 2, ee >>>= 1;
          return (K + ee) / J;
        };
        return G.int32 = function() {
          return 0 | U.g(4);
        }, G.quick = function() {
          return U.g(4) / 4294967296;
        }, G.double = G, j(Z(U.S), t), ($.pass || X || function(K, J, ee, te) {
          return te && (te.S && x(te, U), K.state = function() {
            return x(U, {});
          }), ee ? (r.random = K, J) : K;
        })(G, Y, "global" in $ ? $.global : this == r, $.state);
      }, j(r.random(), t);
    }
    function initialize$2(t) {
      seedRandom([], t);
    }
    var propTypes = { SHAPE: "shape" };
    function _typeof$1(t) {
      return (_typeof$1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
        return typeof r;
      } : function(r) {
        return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
      })(t);
    }
    var ExpressionManager = (function() {
      var ob = {}, Math = BMMath, window = null, document = null, XMLHttpRequest = null, fetch = null, frames = null, _lottieGlobal = {};
      function resetFrame() {
        _lottieGlobal = {};
      }
      function $bm_isInstanceOfArray(t) {
        return t.constructor === Array || t.constructor === Float32Array;
      }
      function isNumerable(t, r) {
        return t === "number" || r instanceof Number || t === "boolean" || t === "string";
      }
      function $bm_neg(t) {
        var r = _typeof$1(t);
        if (r === "number" || t instanceof Number || r === "boolean") return -t;
        if ($bm_isInstanceOfArray(t)) {
          var n, a = t.length, s = [];
          for (n = 0; n < a; n += 1) s[n] = -t[n];
          return s;
        }
        return t.propType ? t.v : -t;
      }
      initialize$2(BMMath);
      var easeInBez = BezierFactory.getBezierEasing(0.333, 0, 0.833, 0.833, "easeIn").get, easeOutBez = BezierFactory.getBezierEasing(0.167, 0.167, 0.667, 1, "easeOut").get, easeInOutBez = BezierFactory.getBezierEasing(0.33, 0, 0.667, 1, "easeInOut").get;
      function sum(t, r) {
        var n = _typeof$1(t), a = _typeof$1(r);
        if (isNumerable(n, t) && isNumerable(a, r) || n === "string" || a === "string") return t + r;
        if ($bm_isInstanceOfArray(t) && isNumerable(a, r)) return (t = t.slice(0))[0] += r, t;
        if (isNumerable(n, t) && $bm_isInstanceOfArray(r)) return (r = r.slice(0))[0] = t + r[0], r;
        if ($bm_isInstanceOfArray(t) && $bm_isInstanceOfArray(r)) {
          for (var s = 0, o = t.length, l = r.length, x = []; s < o || s < l; ) (typeof t[s] == "number" || t[s] instanceof Number) && (typeof r[s] == "number" || r[s] instanceof Number) ? x[s] = t[s] + r[s] : x[s] = r[s] === void 0 ? t[s] : t[s] || r[s], s += 1;
          return x;
        }
        return 0;
      }
      var add = sum;
      function sub(t, r) {
        var n = _typeof$1(t), a = _typeof$1(r);
        if (isNumerable(n, t) && isNumerable(a, r)) return n === "string" && (t = parseInt(t, 10)), a === "string" && (r = parseInt(r, 10)), t - r;
        if ($bm_isInstanceOfArray(t) && isNumerable(a, r)) return (t = t.slice(0))[0] -= r, t;
        if (isNumerable(n, t) && $bm_isInstanceOfArray(r)) return (r = r.slice(0))[0] = t - r[0], r;
        if ($bm_isInstanceOfArray(t) && $bm_isInstanceOfArray(r)) {
          for (var s = 0, o = t.length, l = r.length, x = []; s < o || s < l; ) (typeof t[s] == "number" || t[s] instanceof Number) && (typeof r[s] == "number" || r[s] instanceof Number) ? x[s] = t[s] - r[s] : x[s] = r[s] === void 0 ? t[s] : t[s] || r[s], s += 1;
          return x;
        }
        return 0;
      }
      function mul(t, r) {
        var n, a, s, o = _typeof$1(t), l = _typeof$1(r);
        if (isNumerable(o, t) && isNumerable(l, r)) return t * r;
        if ($bm_isInstanceOfArray(t) && isNumerable(l, r)) {
          for (s = t.length, n = createTypedArray("float32", s), a = 0; a < s; a += 1) n[a] = t[a] * r;
          return n;
        }
        if (isNumerable(o, t) && $bm_isInstanceOfArray(r)) {
          for (s = r.length, n = createTypedArray("float32", s), a = 0; a < s; a += 1) n[a] = t * r[a];
          return n;
        }
        return 0;
      }
      function div(t, r) {
        var n, a, s, o = _typeof$1(t), l = _typeof$1(r);
        if (isNumerable(o, t) && isNumerable(l, r)) return t / r;
        if ($bm_isInstanceOfArray(t) && isNumerable(l, r)) {
          for (s = t.length, n = createTypedArray("float32", s), a = 0; a < s; a += 1) n[a] = t[a] / r;
          return n;
        }
        if (isNumerable(o, t) && $bm_isInstanceOfArray(r)) {
          for (s = r.length, n = createTypedArray("float32", s), a = 0; a < s; a += 1) n[a] = t / r[a];
          return n;
        }
        return 0;
      }
      function mod(t, r) {
        return typeof t == "string" && (t = parseInt(t, 10)), typeof r == "string" && (r = parseInt(r, 10)), t % r;
      }
      var $bm_sum = sum, $bm_sub = sub, $bm_mul = mul, $bm_div = div, $bm_mod = mod;
      function clamp(t, r, n) {
        if (r > n) {
          var a = n;
          n = r, r = a;
        }
        return Math.min(Math.max(t, r), n);
      }
      function radiansToDegrees(t) {
        return t / degToRads;
      }
      var radians_to_degrees = radiansToDegrees;
      function degreesToRadians(t) {
        return t * degToRads;
      }
      var degrees_to_radians = radiansToDegrees, helperLengthArray = [0, 0, 0, 0, 0, 0];
      function length(t, r) {
        if (typeof t == "number" || t instanceof Number) return r = r || 0, Math.abs(t - r);
        var n;
        r || (r = helperLengthArray);
        var a = Math.min(t.length, r.length), s = 0;
        for (n = 0; n < a; n += 1) s += Math.pow(r[n] - t[n], 2);
        return Math.sqrt(s);
      }
      function normalize(t) {
        return div(t, length(t));
      }
      function rgbToHsl(t) {
        var r, n, a = t[0], s = t[1], o = t[2], l = Math.max(a, s, o), x = Math.min(a, s, o), j = (l + x) / 2;
        if (l === x) r = 0, n = 0;
        else {
          var Z = l - x;
          switch (n = j > 0.5 ? Z / (2 - l - x) : Z / (l + x), l) {
            case a:
              r = (s - o) / Z + (s < o ? 6 : 0);
              break;
            case s:
              r = (o - a) / Z + 2;
              break;
            case o:
              r = (a - s) / Z + 4;
          }
          r /= 6;
        }
        return [r, n, j, t[3]];
      }
      function hue2rgb(t, r, n) {
        return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? t + 6 * (r - t) * n : n < 0.5 ? r : n < 2 / 3 ? t + (r - t) * (2 / 3 - n) * 6 : t;
      }
      function hslToRgb(t) {
        var r, n, a, s = t[0], o = t[1], l = t[2];
        if (o === 0) r = l, a = l, n = l;
        else {
          var x = l < 0.5 ? l * (1 + o) : l + o - l * o, j = 2 * l - x;
          r = hue2rgb(j, x, s + 1 / 3), n = hue2rgb(j, x, s), a = hue2rgb(j, x, s - 1 / 3);
        }
        return [r, n, a, t[3]];
      }
      function linear(t, r, n, a, s) {
        if (a !== void 0 && s !== void 0 || (a = r, s = n, r = 0, n = 1), n < r) {
          var o = n;
          n = r, r = o;
        }
        if (t <= r) return a;
        if (t >= n) return s;
        var l, x = n === r ? 0 : (t - r) / (n - r);
        if (!a.length) return a + (s - a) * x;
        var j = a.length, Z = createTypedArray("float32", j);
        for (l = 0; l < j; l += 1) Z[l] = a[l] + (s[l] - a[l]) * x;
        return Z;
      }
      function random(t, r) {
        if (r === void 0 && (t === void 0 ? (t = 0, r = 1) : (r = t, t = void 0)), r.length) {
          var n, a = r.length;
          t || (t = createTypedArray("float32", a));
          var s = createTypedArray("float32", a), o = BMMath.random();
          for (n = 0; n < a; n += 1) s[n] = t[n] + o * (r[n] - t[n]);
          return s;
        }
        return t === void 0 && (t = 0), t + BMMath.random() * (r - t);
      }
      function createPath(t, r, n, a) {
        var s, o = t.length, l = shapePool.newElement();
        l.setPathData(!!a, o);
        var x, j, Z = [0, 0];
        for (s = 0; s < o; s += 1) x = r && r[s] ? r[s] : Z, j = n && n[s] ? n[s] : Z, l.setTripleAt(t[s][0], t[s][1], j[0] + t[s][0], j[1] + t[s][1], x[0] + t[s][0], x[1] + t[s][1], s, !0);
        return l;
      }
      function initiateExpression(elem, data, property) {
        function noOp(t) {
          return t;
        }
        if (!elem.globalData.renderConfig.runExpressions) return noOp;
        var val = data.x, needsVelocity = /velocity(?![\w\d])/.test(val), _needsRandom = val.indexOf("random") !== -1, elemType = elem.data.ty, transform, $bm_transform, content, effect, thisProperty = property;
        thisProperty.valueAtTime = thisProperty.getValueAtTime, Object.defineProperty(thisProperty, "value", { get: function() {
          return thisProperty.v;
        } }), elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate, elem.comp.displayStartTime = 0;
        var inPoint = elem.data.ip / elem.comp.globalData.frameRate, outPoint = elem.data.op / elem.comp.globalData.frameRate, width = elem.data.sw ? elem.data.sw : 0, height = elem.data.sh ? elem.data.sh : 0, name = elem.data.nm, loopIn, loop_in, loopOut, loop_out, smooth, toWorld, fromWorld, fromComp, toComp, fromCompToSurface, position, rotation, anchorPoint, scale, thisLayer, thisComp, mask, valueAtTime, velocityAtTime, scoped_bm_rt, expression_function = eval("[function _expression_function(){" + val + ";scoped_bm_rt=$bm_rt}]")[0], numKeys = property.kf ? data.k.length : 0, active = !this.data || this.data.hd !== !0, wiggle = function(t, r) {
          var n, a, s = this.pv.length ? this.pv.length : 1, o = createTypedArray("float32", s), l = Math.floor(5 * time);
          for (n = 0, a = 0; n < l; ) {
            for (a = 0; a < s; a += 1) o[a] += -r + 2 * r * BMMath.random();
            n += 1;
          }
          var x = 5 * time, j = x - Math.floor(x), Z = createTypedArray("float32", s);
          if (s > 1) {
            for (a = 0; a < s; a += 1) Z[a] = this.pv[a] + o[a] + (-r + 2 * r * BMMath.random()) * j;
            return Z;
          }
          return this.pv + o[0] + (-r + 2 * r * BMMath.random()) * j;
        }.bind(this);
        function loopInDuration(t, r) {
          return loopIn(t, r, !0);
        }
        function loopOutDuration(t, r) {
          return loopOut(t, r, !0);
        }
        thisProperty.loopIn && (loopIn = thisProperty.loopIn.bind(thisProperty), loop_in = loopIn), thisProperty.loopOut && (loopOut = thisProperty.loopOut.bind(thisProperty), loop_out = loopOut), thisProperty.smooth && (smooth = thisProperty.smooth.bind(thisProperty)), this.getValueAtTime && (valueAtTime = this.getValueAtTime.bind(this)), this.getVelocityAtTime && (velocityAtTime = this.getVelocityAtTime.bind(this));
        var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface), time, velocity, value, text, textIndex, textTotal, selectorValue;
        function lookAt(t, r) {
          var n = [r[0] - t[0], r[1] - t[1], r[2] - t[2]], a = Math.atan2(n[0], Math.sqrt(n[1] * n[1] + n[2] * n[2])) / degToRads;
          return [-Math.atan2(n[1], n[2]) / degToRads, a, 0];
        }
        function easeOut(t, r, n, a, s) {
          return applyEase(easeOutBez, t, r, n, a, s);
        }
        function easeIn(t, r, n, a, s) {
          return applyEase(easeInBez, t, r, n, a, s);
        }
        function ease(t, r, n, a, s) {
          return applyEase(easeInOutBez, t, r, n, a, s);
        }
        function applyEase(t, r, n, a, s, o) {
          s === void 0 ? (s = n, o = a) : r = (r - n) / (a - n), r > 1 ? r = 1 : r < 0 && (r = 0);
          var l = t(r);
          if ($bm_isInstanceOfArray(s)) {
            var x, j = s.length, Z = createTypedArray("float32", j);
            for (x = 0; x < j; x += 1) Z[x] = (o[x] - s[x]) * l + s[x];
            return Z;
          }
          return (o - s) * l + s;
        }
        function nearestKey(t) {
          var r, n, a, s = data.k.length;
          if (data.k.length && typeof data.k[0] != "number") if (n = -1, (t *= elem.comp.globalData.frameRate) < data.k[0].t) n = 1, a = data.k[0].t;
          else {
            for (r = 0; r < s - 1; r += 1) {
              if (t === data.k[r].t) {
                n = r + 1, a = data.k[r].t;
                break;
              }
              if (t > data.k[r].t && t < data.k[r + 1].t) {
                t - data.k[r].t > data.k[r + 1].t - t ? (n = r + 2, a = data.k[r + 1].t) : (n = r + 1, a = data.k[r].t);
                break;
              }
            }
            n === -1 && (n = r + 1, a = data.k[r].t);
          }
          else n = 0, a = 0;
          var o = {};
          return o.index = n, o.time = a / elem.comp.globalData.frameRate, o;
        }
        function key(t) {
          var r, n, a;
          if (!data.k.length || typeof data.k[0] == "number") throw new Error("The property has no keyframe at index " + t);
          t -= 1, r = { time: data.k[t].t / elem.comp.globalData.frameRate, value: [] };
          var s = Object.prototype.hasOwnProperty.call(data.k[t], "s") ? data.k[t].s : data.k[t - 1].e;
          for (a = s.length, n = 0; n < a; n += 1) r[n] = s[n], r.value[n] = s[n];
          return r;
        }
        function framesToTime(t, r) {
          return r || (r = elem.comp.globalData.frameRate), t / r;
        }
        function timeToFrames(t, r) {
          return t || t === 0 || (t = time), r || (r = elem.comp.globalData.frameRate), t * r;
        }
        function seedRandom(t) {
          BMMath.seedrandom(randSeed + t);
        }
        function sourceRectAtTime() {
          return elem.sourceRectAtTime();
        }
        function substring(t, r) {
          return typeof value == "string" ? r === void 0 ? value.substring(t) : value.substring(t, r) : "";
        }
        function substr(t, r) {
          return typeof value == "string" ? r === void 0 ? value.substr(t) : value.substr(t, r) : "";
        }
        function posterizeTime(t) {
          time = t === 0 ? 0 : Math.floor(time * t) / t, value = valueAtTime(time);
        }
        var index = elem.data.ind;
        !elem.hierarchy || elem.hierarchy.length;
        var parent, randSeed = Math.floor(1e6 * Math.random()), globalData = elem.globalData;
        function executeExpression(t) {
          return value = t, this.frameExpressionId === elem.globalData.frameId && this.propType !== "textSelector" ? value : (this.propType === "textSelector" && (textIndex = this.textIndex, textTotal = this.textTotal, selectorValue = this.selectorValue), thisLayer || (text = elem.layerInterface.text, thisLayer = elem.layerInterface, thisComp = elem.comp.compInterface, toWorld = thisLayer.toWorld.bind(thisLayer), fromWorld = thisLayer.fromWorld.bind(thisLayer), fromComp = thisLayer.fromComp.bind(thisLayer), toComp = thisLayer.toComp.bind(thisLayer), mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null, fromCompToSurface = fromComp), transform || (transform = elem.layerInterface("ADBE Transform Group"), $bm_transform = transform, transform && (anchorPoint = transform.anchorPoint)), elemType !== 4 || content || (content = thisLayer("ADBE Root Vectors Group")), effect || (effect = thisLayer(4)), !(!elem.hierarchy || !elem.hierarchy.length) && !parent && (parent = elem.hierarchy[0].layerInterface), time = this.comp.renderedFrame / this.comp.globalData.frameRate, _needsRandom && seedRandom(randSeed + time), needsVelocity && (velocity = velocityAtTime(time)), expression_function(), this.frameExpressionId = elem.globalData.frameId, scoped_bm_rt = scoped_bm_rt.propType === propTypes.SHAPE ? scoped_bm_rt.v : scoped_bm_rt);
        }
        return executeExpression.__preventDeadCodeRemoval = [$bm_transform, anchorPoint, time, velocity, inPoint, outPoint, width, height, name, loop_in, loop_out, smooth, toComp, fromCompToSurface, toWorld, fromWorld, mask, position, rotation, scale, thisComp, numKeys, active, wiggle, loopInDuration, loopOutDuration, comp, lookAt, easeOut, easeIn, ease, nearestKey, key, text, textIndex, textTotal, selectorValue, framesToTime, timeToFrames, sourceRectAtTime, substring, substr, posterizeTime, index, globalData], executeExpression;
      }
      return ob.initiateExpression = initiateExpression, ob.__preventDeadCodeRemoval = [window, document, XMLHttpRequest, fetch, frames, $bm_neg, add, $bm_sum, $bm_sub, $bm_mul, $bm_div, $bm_mod, clamp, radians_to_degrees, degreesToRadians, degrees_to_radians, normalize, rgbToHsl, hslToRgb, linear, random, createPath, _lottieGlobal], ob.resetFrame = resetFrame, ob;
    })(), Expressions = (function() {
      var t = {};
      return t.initExpressions = function(r) {
        var n = 0, a = [];
        r.renderer.compInterface = CompExpressionInterface(r.renderer), r.renderer.globalData.projectInterface.registerComposition(r.renderer), r.renderer.globalData.pushExpression = function() {
          n += 1;
        }, r.renderer.globalData.popExpression = function() {
          (n -= 1) === 0 && (function() {
            var s, o = a.length;
            for (s = 0; s < o; s += 1) a[s].release();
            a.length = 0;
          })();
        }, r.renderer.globalData.registerExpressionProperty = function(s) {
          a.indexOf(s) === -1 && a.push(s);
        };
      }, t.resetFrame = ExpressionManager.resetFrame, t;
    })(), MaskManagerInterface = (function() {
      function t(r, n) {
        this._mask = r, this._data = n;
      }
      return Object.defineProperty(t.prototype, "maskPath", { get: function() {
        return this._mask.prop.k && this._mask.prop.getValue(), this._mask.prop;
      } }), Object.defineProperty(t.prototype, "maskOpacity", { get: function() {
        return this._mask.op.k && this._mask.op.getValue(), 100 * this._mask.op.v;
      } }), function(r) {
        var n, a = createSizedArray(r.viewData.length), s = r.viewData.length;
        for (n = 0; n < s; n += 1) a[n] = new t(r.viewData[n], r.masksProperties[n]);
        return function(o) {
          for (n = 0; n < s; ) {
            if (r.masksProperties[n].nm === o) return a[n];
            n += 1;
          }
          return null;
        };
      };
    })(), ExpressionPropertyInterface = /* @__PURE__ */ (function() {
      var t = { pv: 0, v: 0, mult: 1 }, r = { pv: [0, 0, 0], v: [0, 0, 0], mult: 1 };
      function n(s, o, l) {
        Object.defineProperty(s, "velocity", { get: function() {
          return o.getVelocityAtTime(o.comp.currentFrame);
        } }), s.numKeys = o.keyframes ? o.keyframes.length : 0, s.key = function(x) {
          if (!s.numKeys) return 0;
          var j = "";
          j = "s" in o.keyframes[x - 1] ? o.keyframes[x - 1].s : "e" in o.keyframes[x - 2] ? o.keyframes[x - 2].e : o.keyframes[x - 2].s;
          var Z = l === "unidimensional" ? new Number(j) : Object.assign({}, j);
          return Z.time = o.keyframes[x - 1].t / o.elem.comp.globalData.frameRate, Z.value = l === "unidimensional" ? j[0] : j, Z;
        }, s.valueAtTime = o.getValueAtTime, s.speedAtTime = o.getSpeedAtTime, s.velocityAtTime = o.getVelocityAtTime, s.propertyGroup = o.propertyGroup;
      }
      function a() {
        return t;
      }
      return function(s) {
        return s ? s.propType === "unidimensional" ? (function(o) {
          o && "pv" in o || (o = t);
          var l = 1 / o.mult, x = o.pv * l, j = new Number(x);
          return j.value = x, n(j, o, "unidimensional"), function() {
            return o.k && o.getValue(), x = o.v * l, j.value !== x && ((j = new Number(x)).value = x, n(j, o, "unidimensional")), j;
          };
        })(s) : (function(o) {
          o && "pv" in o || (o = r);
          var l = 1 / o.mult, x = o.data && o.data.l || o.pv.length, j = createTypedArray("float32", x), Z = createTypedArray("float32", x);
          return j.value = Z, n(j, o, "multidimensional"), function() {
            o.k && o.getValue();
            for (var V = 0; V < x; V += 1) Z[V] = o.v[V] * l, j[V] = Z[V];
            return j;
          };
        })(s) : a;
      };
    })(), TransformExpressionInterface = function(t) {
      function r(l) {
        switch (l) {
          case "scale":
          case "Scale":
          case "ADBE Scale":
          case 6:
            return r.scale;
          case "rotation":
          case "Rotation":
          case "ADBE Rotation":
          case "ADBE Rotate Z":
          case 10:
            return r.rotation;
          case "ADBE Rotate X":
            return r.xRotation;
          case "ADBE Rotate Y":
            return r.yRotation;
          case "position":
          case "Position":
          case "ADBE Position":
          case 2:
            return r.position;
          case "ADBE Position_0":
            return r.xPosition;
          case "ADBE Position_1":
            return r.yPosition;
          case "ADBE Position_2":
            return r.zPosition;
          case "anchorPoint":
          case "AnchorPoint":
          case "Anchor Point":
          case "ADBE AnchorPoint":
          case 1:
            return r.anchorPoint;
          case "opacity":
          case "Opacity":
          case 11:
            return r.opacity;
          default:
            return null;
        }
      }
      var n, a, s, o;
      return Object.defineProperty(r, "rotation", { get: ExpressionPropertyInterface(t.r || t.rz) }), Object.defineProperty(r, "zRotation", { get: ExpressionPropertyInterface(t.rz || t.r) }), Object.defineProperty(r, "xRotation", { get: ExpressionPropertyInterface(t.rx) }), Object.defineProperty(r, "yRotation", { get: ExpressionPropertyInterface(t.ry) }), Object.defineProperty(r, "scale", { get: ExpressionPropertyInterface(t.s) }), t.p ? o = ExpressionPropertyInterface(t.p) : (n = ExpressionPropertyInterface(t.px), a = ExpressionPropertyInterface(t.py), t.pz && (s = ExpressionPropertyInterface(t.pz))), Object.defineProperty(r, "position", { get: function() {
        return t.p ? o() : [n(), a(), s ? s() : 0];
      } }), Object.defineProperty(r, "xPosition", { get: ExpressionPropertyInterface(t.px) }), Object.defineProperty(r, "yPosition", { get: ExpressionPropertyInterface(t.py) }), Object.defineProperty(r, "zPosition", { get: ExpressionPropertyInterface(t.pz) }), Object.defineProperty(r, "anchorPoint", { get: ExpressionPropertyInterface(t.a) }), Object.defineProperty(r, "opacity", { get: ExpressionPropertyInterface(t.o) }), Object.defineProperty(r, "skew", { get: ExpressionPropertyInterface(t.sk) }), Object.defineProperty(r, "skewAxis", { get: ExpressionPropertyInterface(t.sa) }), Object.defineProperty(r, "orientation", { get: ExpressionPropertyInterface(t.or) }), r;
    }, LayerExpressionInterface = /* @__PURE__ */ (function() {
      function t(Z) {
        var V = new Matrix();
        return Z !== void 0 ? this._elem.finalTransform.mProp.getValueAtTime(Z).clone(V) : this._elem.finalTransform.mProp.applyToMatrix(V), V;
      }
      function r(Z, V) {
        var $ = this.getMatrix(V);
        return $.props[12] = 0, $.props[13] = 0, $.props[14] = 0, this.applyPoint($, Z);
      }
      function n(Z, V) {
        var $ = this.getMatrix(V);
        return this.applyPoint($, Z);
      }
      function a(Z, V) {
        var $ = this.getMatrix(V);
        return $.props[12] = 0, $.props[13] = 0, $.props[14] = 0, this.invertPoint($, Z);
      }
      function s(Z, V) {
        var $ = this.getMatrix(V);
        return this.invertPoint($, Z);
      }
      function o(Z, V) {
        if (this._elem.hierarchy && this._elem.hierarchy.length) {
          var $, X = this._elem.hierarchy.length;
          for ($ = 0; $ < X; $ += 1) this._elem.hierarchy[$].finalTransform.mProp.applyToMatrix(Z);
        }
        return Z.applyToPointArray(V[0], V[1], V[2] || 0);
      }
      function l(Z, V) {
        if (this._elem.hierarchy && this._elem.hierarchy.length) {
          var $, X = this._elem.hierarchy.length;
          for ($ = 0; $ < X; $ += 1) this._elem.hierarchy[$].finalTransform.mProp.applyToMatrix(Z);
        }
        return Z.inversePoint(V);
      }
      function x(Z) {
        var V = new Matrix();
        if (V.reset(), this._elem.finalTransform.mProp.applyToMatrix(V), this._elem.hierarchy && this._elem.hierarchy.length) {
          var $, X = this._elem.hierarchy.length;
          for ($ = 0; $ < X; $ += 1) this._elem.hierarchy[$].finalTransform.mProp.applyToMatrix(V);
          return V.inversePoint(Z);
        }
        return V.inversePoint(Z);
      }
      function j() {
        return [1, 1, 1, 1];
      }
      return function(Z) {
        var V;
        function $(W) {
          switch (W) {
            case "ADBE Root Vectors Group":
            case "Contents":
            case 2:
              return $.shapeInterface;
            case 1:
            case 6:
            case "Transform":
            case "transform":
            case "ADBE Transform Group":
              return V;
            case 4:
            case "ADBE Effect Parade":
            case "effects":
            case "Effects":
              return $.effect;
            case "ADBE Text Properties":
              return $.textInterface;
            default:
              return null;
          }
        }
        $.getMatrix = t, $.invertPoint = l, $.applyPoint = o, $.toWorld = n, $.toWorldVec = r, $.fromWorld = s, $.fromWorldVec = a, $.toComp = n, $.fromComp = x, $.sampleImage = j, $.sourceRectAtTime = Z.sourceRectAtTime.bind(Z), $._elem = Z;
        var X = getDescriptor(V = TransformExpressionInterface(Z.finalTransform.mProp), "anchorPoint");
        return Object.defineProperties($, { hasParent: { get: function() {
          return Z.hierarchy.length;
        } }, parent: { get: function() {
          return Z.hierarchy[0].layerInterface;
        } }, rotation: getDescriptor(V, "rotation"), scale: getDescriptor(V, "scale"), position: getDescriptor(V, "position"), opacity: getDescriptor(V, "opacity"), anchorPoint: X, anchor_point: X, transform: { get: function() {
          return V;
        } }, active: { get: function() {
          return Z.isInRange;
        } } }), $.startTime = Z.data.st, $.index = Z.data.ind, $.source = Z.data.refId, $.height = Z.data.ty === 0 ? Z.data.h : 100, $.width = Z.data.ty === 0 ? Z.data.w : 100, $.inPoint = Z.data.ip / Z.comp.globalData.frameRate, $.outPoint = Z.data.op / Z.comp.globalData.frameRate, $._name = Z.data.nm, $.registerMaskInterface = function(W) {
          $.mask = new MaskManagerInterface(W, Z);
        }, $.registerEffectsInterface = function(W) {
          $.effect = W;
        }, $;
      };
    })(), propertyGroupFactory = function(t, r) {
      return function(n) {
        return (n = n === void 0 ? 1 : n) <= 0 ? t : r(n - 1);
      };
    }, PropertyInterface = function(t, r) {
      var n = { _name: t };
      return function(a) {
        return (a = a === void 0 ? 1 : a) <= 0 ? n : r(a - 1);
      };
    }, EffectsExpressionInterface = /* @__PURE__ */ (function() {
      function t(n, a, s, o) {
        function l($) {
          for (var X = n.ef, W = 0, Y = X.length; W < Y; ) {
            if ($ === X[W].nm || $ === X[W].mn || $ === X[W].ix) return X[W].ty === 5 ? Z[W] : Z[W]();
            W += 1;
          }
          throw new Error();
        }
        var x, j = propertyGroupFactory(l, s), Z = [], V = n.ef.length;
        for (x = 0; x < V; x += 1) n.ef[x].ty === 5 ? Z.push(t(n.ef[x], a.effectElements[x], a.effectElements[x].propertyGroup, o)) : Z.push(r(a.effectElements[x], n.ef[x].ty, o, j));
        return n.mn === "ADBE Color Control" && Object.defineProperty(l, "color", { get: function() {
          return Z[0]();
        } }), Object.defineProperties(l, { numProperties: { get: function() {
          return n.np;
        } }, _name: { value: n.nm }, propertyGroup: { value: j } }), l.enabled = n.en !== 0, l.active = l.enabled, l;
      }
      function r(n, a, s, o) {
        var l = ExpressionPropertyInterface(n.p);
        return n.p.setGroupProperty && n.p.setGroupProperty(PropertyInterface("", o)), function() {
          return a === 10 ? s.comp.compInterface(n.p.v) : l();
        };
      }
      return { createEffectsInterface: function(n, a) {
        if (n.effectsManager) {
          var s, o = [], l = n.data.ef, x = n.effectsManager.effectElements.length;
          for (s = 0; s < x; s += 1) o.push(t(l[s], n.effectsManager.effectElements[s], a, n));
          var j = n.data.ef || [], Z = function(V) {
            for (s = 0, x = j.length; s < x; ) {
              if (V === j[s].nm || V === j[s].mn || V === j[s].ix) return o[s];
              s += 1;
            }
            return null;
          };
          return Object.defineProperty(Z, "numProperties", { get: function() {
            return j.length;
          } }), Z;
        }
        return null;
      } };
    })(), ShapePathInterface = function(t, r, n) {
      var a = r.sh;
      function s(l) {
        return l === "Shape" || l === "shape" || l === "Path" || l === "path" || l === "ADBE Vector Shape" || l === 2 ? s.path : null;
      }
      var o = propertyGroupFactory(s, n);
      return a.setGroupProperty(PropertyInterface("Path", o)), Object.defineProperties(s, { path: { get: function() {
        return a.k && a.getValue(), a;
      } }, shape: { get: function() {
        return a.k && a.getValue(), a;
      } }, _name: { value: t.nm }, ix: { value: t.ix }, propertyIndex: { value: t.ix }, mn: { value: t.mn }, propertyGroup: { value: n } }), s;
    }, ShapeExpressionInterface = /* @__PURE__ */ (function() {
      function t(W, Y, U) {
        var G, K = [], J = W ? W.length : 0;
        for (G = 0; G < J; G += 1) W[G].ty === "gr" ? K.push(r(W[G], Y[G], U)) : W[G].ty === "fl" ? K.push(n(W[G], Y[G], U)) : W[G].ty === "st" ? K.push(o(W[G], Y[G], U)) : W[G].ty === "tm" ? K.push(l(W[G], Y[G], U)) : W[G].ty === "tr" || (W[G].ty === "el" ? K.push(j(W[G], Y[G], U)) : W[G].ty === "sr" ? K.push(Z(W[G], Y[G], U)) : W[G].ty === "sh" ? K.push(ShapePathInterface(W[G], Y[G], U)) : W[G].ty === "rc" ? K.push(V(W[G], Y[G], U)) : W[G].ty === "rd" ? K.push($(W[G], Y[G], U)) : W[G].ty === "rp" ? K.push(X(W[G], Y[G], U)) : W[G].ty === "gf" ? K.push(a(W[G], Y[G], U)) : K.push(s(W[G], Y[G])));
        return K;
      }
      function r(W, Y, U) {
        var G = function(ee) {
          switch (ee) {
            case "ADBE Vectors Group":
            case "Contents":
            case 2:
              return G.content;
            default:
              return G.transform;
          }
        };
        G.propertyGroup = propertyGroupFactory(G, U);
        var K = (function(ee, te, re) {
          var ae, ie = function(he) {
            for (var oe = 0, le = ae.length; oe < le; ) {
              if (ae[oe]._name === he || ae[oe].mn === he || ae[oe].propertyIndex === he || ae[oe].ix === he || ae[oe].ind === he) return ae[oe];
              oe += 1;
            }
            return typeof he == "number" ? ae[he - 1] : null;
          };
          ie.propertyGroup = propertyGroupFactory(ie, re), ae = t(ee.it, te.it, ie.propertyGroup), ie.numProperties = ae.length;
          var ce = x(ee.it[ee.it.length - 1], te.it[te.it.length - 1], ie.propertyGroup);
          return ie.transform = ce, ie.propertyIndex = ee.cix, ie._name = ee.nm, ie;
        })(W, Y, G.propertyGroup), J = x(W.it[W.it.length - 1], Y.it[Y.it.length - 1], G.propertyGroup);
        return G.content = K, G.transform = J, Object.defineProperty(G, "_name", { get: function() {
          return W.nm;
        } }), G.numProperties = W.np, G.propertyIndex = W.ix, G.nm = W.nm, G.mn = W.mn, G;
      }
      function n(W, Y, U) {
        function G(K) {
          return K === "Color" || K === "color" ? G.color : K === "Opacity" || K === "opacity" ? G.opacity : null;
        }
        return Object.defineProperties(G, { color: { get: ExpressionPropertyInterface(Y.c) }, opacity: { get: ExpressionPropertyInterface(Y.o) }, _name: { value: W.nm }, mn: { value: W.mn } }), Y.c.setGroupProperty(PropertyInterface("Color", U)), Y.o.setGroupProperty(PropertyInterface("Opacity", U)), G;
      }
      function a(W, Y, U) {
        function G(K) {
          return K === "Start Point" || K === "start point" ? G.startPoint : K === "End Point" || K === "end point" ? G.endPoint : K === "Opacity" || K === "opacity" ? G.opacity : null;
        }
        return Object.defineProperties(G, { startPoint: { get: ExpressionPropertyInterface(Y.s) }, endPoint: { get: ExpressionPropertyInterface(Y.e) }, opacity: { get: ExpressionPropertyInterface(Y.o) }, type: { get: function() {
          return "a";
        } }, _name: { value: W.nm }, mn: { value: W.mn } }), Y.s.setGroupProperty(PropertyInterface("Start Point", U)), Y.e.setGroupProperty(PropertyInterface("End Point", U)), Y.o.setGroupProperty(PropertyInterface("Opacity", U)), G;
      }
      function s() {
        return function() {
          return null;
        };
      }
      function o(W, Y, U) {
        var G, K = propertyGroupFactory(ae, U), J = propertyGroupFactory(re, K);
        function ee(ie) {
          Object.defineProperty(re, W.d[ie].nm, { get: ExpressionPropertyInterface(Y.d.dataProps[ie].p) });
        }
        var te = W.d ? W.d.length : 0, re = {};
        for (G = 0; G < te; G += 1) ee(G), Y.d.dataProps[G].p.setGroupProperty(J);
        function ae(ie) {
          return ie === "Color" || ie === "color" ? ae.color : ie === "Opacity" || ie === "opacity" ? ae.opacity : ie === "Stroke Width" || ie === "stroke width" ? ae.strokeWidth : null;
        }
        return Object.defineProperties(ae, { color: { get: ExpressionPropertyInterface(Y.c) }, opacity: { get: ExpressionPropertyInterface(Y.o) }, strokeWidth: { get: ExpressionPropertyInterface(Y.w) }, dash: { get: function() {
          return re;
        } }, _name: { value: W.nm }, mn: { value: W.mn } }), Y.c.setGroupProperty(PropertyInterface("Color", K)), Y.o.setGroupProperty(PropertyInterface("Opacity", K)), Y.w.setGroupProperty(PropertyInterface("Stroke Width", K)), ae;
      }
      function l(W, Y, U) {
        function G(J) {
          return J === W.e.ix || J === "End" || J === "end" ? G.end : J === W.s.ix ? G.start : J === W.o.ix ? G.offset : null;
        }
        var K = propertyGroupFactory(G, U);
        return G.propertyIndex = W.ix, Y.s.setGroupProperty(PropertyInterface("Start", K)), Y.e.setGroupProperty(PropertyInterface("End", K)), Y.o.setGroupProperty(PropertyInterface("Offset", K)), G.propertyIndex = W.ix, G.propertyGroup = U, Object.defineProperties(G, { start: { get: ExpressionPropertyInterface(Y.s) }, end: { get: ExpressionPropertyInterface(Y.e) }, offset: { get: ExpressionPropertyInterface(Y.o) }, _name: { value: W.nm } }), G.mn = W.mn, G;
      }
      function x(W, Y, U) {
        function G(J) {
          return W.a.ix === J || J === "Anchor Point" ? G.anchorPoint : W.o.ix === J || J === "Opacity" ? G.opacity : W.p.ix === J || J === "Position" ? G.position : W.r.ix === J || J === "Rotation" || J === "ADBE Vector Rotation" ? G.rotation : W.s.ix === J || J === "Scale" ? G.scale : W.sk && W.sk.ix === J || J === "Skew" ? G.skew : W.sa && W.sa.ix === J || J === "Skew Axis" ? G.skewAxis : null;
        }
        var K = propertyGroupFactory(G, U);
        return Y.transform.mProps.o.setGroupProperty(PropertyInterface("Opacity", K)), Y.transform.mProps.p.setGroupProperty(PropertyInterface("Position", K)), Y.transform.mProps.a.setGroupProperty(PropertyInterface("Anchor Point", K)), Y.transform.mProps.s.setGroupProperty(PropertyInterface("Scale", K)), Y.transform.mProps.r.setGroupProperty(PropertyInterface("Rotation", K)), Y.transform.mProps.sk && (Y.transform.mProps.sk.setGroupProperty(PropertyInterface("Skew", K)), Y.transform.mProps.sa.setGroupProperty(PropertyInterface("Skew Angle", K))), Y.transform.op.setGroupProperty(PropertyInterface("Opacity", K)), Object.defineProperties(G, { opacity: { get: ExpressionPropertyInterface(Y.transform.mProps.o) }, position: { get: ExpressionPropertyInterface(Y.transform.mProps.p) }, anchorPoint: { get: ExpressionPropertyInterface(Y.transform.mProps.a) }, scale: { get: ExpressionPropertyInterface(Y.transform.mProps.s) }, rotation: { get: ExpressionPropertyInterface(Y.transform.mProps.r) }, skew: { get: ExpressionPropertyInterface(Y.transform.mProps.sk) }, skewAxis: { get: ExpressionPropertyInterface(Y.transform.mProps.sa) }, _name: { value: W.nm } }), G.ty = "tr", G.mn = W.mn, G.propertyGroup = U, G;
      }
      function j(W, Y, U) {
        function G(ee) {
          return W.p.ix === ee ? G.position : W.s.ix === ee ? G.size : null;
        }
        var K = propertyGroupFactory(G, U);
        G.propertyIndex = W.ix;
        var J = Y.sh.ty === "tm" ? Y.sh.prop : Y.sh;
        return J.s.setGroupProperty(PropertyInterface("Size", K)), J.p.setGroupProperty(PropertyInterface("Position", K)), Object.defineProperties(G, { size: { get: ExpressionPropertyInterface(J.s) }, position: { get: ExpressionPropertyInterface(J.p) }, _name: { value: W.nm } }), G.mn = W.mn, G;
      }
      function Z(W, Y, U) {
        function G(ee) {
          return W.p.ix === ee ? G.position : W.r.ix === ee ? G.rotation : W.pt.ix === ee ? G.points : W.or.ix === ee || ee === "ADBE Vector Star Outer Radius" ? G.outerRadius : W.os.ix === ee ? G.outerRoundness : !W.ir || W.ir.ix !== ee && ee !== "ADBE Vector Star Inner Radius" ? W.is && W.is.ix === ee ? G.innerRoundness : null : G.innerRadius;
        }
        var K = propertyGroupFactory(G, U), J = Y.sh.ty === "tm" ? Y.sh.prop : Y.sh;
        return G.propertyIndex = W.ix, J.or.setGroupProperty(PropertyInterface("Outer Radius", K)), J.os.setGroupProperty(PropertyInterface("Outer Roundness", K)), J.pt.setGroupProperty(PropertyInterface("Points", K)), J.p.setGroupProperty(PropertyInterface("Position", K)), J.r.setGroupProperty(PropertyInterface("Rotation", K)), W.ir && (J.ir.setGroupProperty(PropertyInterface("Inner Radius", K)), J.is.setGroupProperty(PropertyInterface("Inner Roundness", K))), Object.defineProperties(G, { position: { get: ExpressionPropertyInterface(J.p) }, rotation: { get: ExpressionPropertyInterface(J.r) }, points: { get: ExpressionPropertyInterface(J.pt) }, outerRadius: { get: ExpressionPropertyInterface(J.or) }, outerRoundness: { get: ExpressionPropertyInterface(J.os) }, innerRadius: { get: ExpressionPropertyInterface(J.ir) }, innerRoundness: { get: ExpressionPropertyInterface(J.is) }, _name: { value: W.nm } }), G.mn = W.mn, G;
      }
      function V(W, Y, U) {
        function G(ee) {
          return W.p.ix === ee ? G.position : W.r.ix === ee ? G.roundness : W.s.ix === ee || ee === "Size" || ee === "ADBE Vector Rect Size" ? G.size : null;
        }
        var K = propertyGroupFactory(G, U), J = Y.sh.ty === "tm" ? Y.sh.prop : Y.sh;
        return G.propertyIndex = W.ix, J.p.setGroupProperty(PropertyInterface("Position", K)), J.s.setGroupProperty(PropertyInterface("Size", K)), J.r.setGroupProperty(PropertyInterface("Rotation", K)), Object.defineProperties(G, { position: { get: ExpressionPropertyInterface(J.p) }, roundness: { get: ExpressionPropertyInterface(J.r) }, size: { get: ExpressionPropertyInterface(J.s) }, _name: { value: W.nm } }), G.mn = W.mn, G;
      }
      function $(W, Y, U) {
        function G(ee) {
          return W.r.ix === ee || ee === "Round Corners 1" ? G.radius : null;
        }
        var K = propertyGroupFactory(G, U), J = Y;
        return G.propertyIndex = W.ix, J.rd.setGroupProperty(PropertyInterface("Radius", K)), Object.defineProperties(G, { radius: { get: ExpressionPropertyInterface(J.rd) }, _name: { value: W.nm } }), G.mn = W.mn, G;
      }
      function X(W, Y, U) {
        function G(ee) {
          return W.c.ix === ee || ee === "Copies" ? G.copies : W.o.ix === ee || ee === "Offset" ? G.offset : null;
        }
        var K = propertyGroupFactory(G, U), J = Y;
        return G.propertyIndex = W.ix, J.c.setGroupProperty(PropertyInterface("Copies", K)), J.o.setGroupProperty(PropertyInterface("Offset", K)), Object.defineProperties(G, { copies: { get: ExpressionPropertyInterface(J.c) }, offset: { get: ExpressionPropertyInterface(J.o) }, _name: { value: W.nm } }), G.mn = W.mn, G;
      }
      return function(W, Y, U) {
        var G;
        function K(J) {
          if (typeof J == "number") return (J = J === void 0 ? 1 : J) === 0 ? U : G[J - 1];
          for (var ee = 0, te = G.length; ee < te; ) {
            if (G[ee]._name === J) return G[ee];
            ee += 1;
          }
          return null;
        }
        return K.propertyGroup = propertyGroupFactory(K, (function() {
          return U;
        })), G = t(W, Y, K.propertyGroup), K.numProperties = G.length, K._name = "Contents", K;
      };
    })(), TextExpressionInterface = function(t) {
      var r;
      function n(a) {
        return a === "ADBE Text Document" ? n.sourceText : null;
      }
      return Object.defineProperty(n, "sourceText", { get: function() {
        t.textProperty.getValue();
        var a = t.textProperty.currentData.t;
        return r && a === r.value || ((r = new String(a)).value = a || new String(a), Object.defineProperty(r, "style", { get: function() {
          return { fillColor: t.textProperty.currentData.fc };
        } })), r;
      } }), n;
    };
    function _typeof(t) {
      return (_typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
        return typeof r;
      } : function(r) {
        return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
      })(t);
    }
    var FootageInterface = (dataInterfaceFactory = function(t) {
      function r(n) {
        return n === "Outline" ? r.outlineInterface() : null;
      }
      return r._name = "Outline", r.outlineInterface = (function(n) {
        var a = "", s = n.getFootageData();
        function o(l) {
          if (s[l]) return a = l, _typeof(s = s[l]) === "object" ? o : s;
          var x = l.indexOf(a);
          if (x !== -1) {
            var j = parseInt(l.substr(x + a.length), 10);
            return _typeof(s = s[j]) === "object" ? o : s;
          }
          return "";
        }
        return function() {
          return a = "", s = n.getFootageData(), o;
        };
      })(t), r;
    }, function(t) {
      function r(n) {
        return n === "Data" ? r.dataInterface : null;
      }
      return r._name = "Data", r.dataInterface = dataInterfaceFactory(t), r;
    }), dataInterfaceFactory, interfaces = { layer: LayerExpressionInterface, effects: EffectsExpressionInterface, comp: CompExpressionInterface, shape: ShapeExpressionInterface, text: TextExpressionInterface, footage: FootageInterface };
    function getInterface(t) {
      return interfaces[t] || null;
    }
    var expressionHelpers = { searchExpressions: function(t, r, n) {
      r.x && (n.k = !0, n.x = !0, n.initiateExpression = ExpressionManager.initiateExpression, n.effectsSequence.push(n.initiateExpression(t, r, n).bind(n)));
    }, getSpeedAtTime: function(t) {
      var r = this.getValueAtTime(t), n = this.getValueAtTime(t + -0.01), a = 0;
      if (r.length) {
        var s;
        for (s = 0; s < r.length; s += 1) a += Math.pow(n[s] - r[s], 2);
        a = 100 * Math.sqrt(a);
      } else a = 0;
      return a;
    }, getVelocityAtTime: function(t) {
      if (this.vel !== void 0) return this.vel;
      var r, n, a = this.getValueAtTime(t), s = this.getValueAtTime(t + -1e-3);
      if (a.length) for (r = createTypedArray("float32", a.length), n = 0; n < a.length; n += 1) r[n] = (s[n] - a[n]) / -1e-3;
      else r = (s - a) / -1e-3;
      return r;
    }, getValueAtTime: function(t) {
      return t *= this.elem.globalData.frameRate, (t -= this.offsetTime) !== this._cachingAtTime.lastFrame && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < t ? this._cachingAtTime.lastIndex : 0, this._cachingAtTime.value = this.interpolateValue(t, this._cachingAtTime), this._cachingAtTime.lastFrame = t), this._cachingAtTime.value;
    }, getStaticValueAtTime: function() {
      return this.pv;
    }, setGroupProperty: function(t) {
      this.propertyGroup = t;
    } };
    function addPropertyDecorator() {
      function t($, X, W) {
        if (!this.k || !this.keyframes) return this.pv;
        $ = $ ? $.toLowerCase() : "";
        var Y, U, G, K, J, ee = this.comp.renderedFrame, te = this.keyframes, re = te[te.length - 1].t;
        if (ee <= re) return this.pv;
        if (W ? U = re - (Y = X ? Math.abs(re - this.elem.comp.globalData.frameRate * X) : Math.max(0, re - this.elem.data.ip)) : ((!X || X > te.length - 1) && (X = te.length - 1), Y = re - (U = te[te.length - 1 - X].t)), $ === "pingpong") {
          if (Math.floor((ee - U) / Y) % 2 != 0) return this.getValueAtTime((Y - (ee - U) % Y + U) / this.comp.globalData.frameRate, 0);
        } else {
          if ($ === "offset") {
            var ae = this.getValueAtTime(U / this.comp.globalData.frameRate, 0), ie = this.getValueAtTime(re / this.comp.globalData.frameRate, 0), ce = this.getValueAtTime(((ee - U) % Y + U) / this.comp.globalData.frameRate, 0), he = Math.floor((ee - U) / Y);
            if (this.pv.length) {
              for (K = (J = new Array(ae.length)).length, G = 0; G < K; G += 1) J[G] = (ie[G] - ae[G]) * he + ce[G];
              return J;
            }
            return (ie - ae) * he + ce;
          }
          if ($ === "continue") {
            var oe = this.getValueAtTime(re / this.comp.globalData.frameRate, 0), le = this.getValueAtTime((re - 1e-3) / this.comp.globalData.frameRate, 0);
            if (this.pv.length) {
              for (K = (J = new Array(oe.length)).length, G = 0; G < K; G += 1) J[G] = oe[G] + (oe[G] - le[G]) * ((ee - re) / this.comp.globalData.frameRate) / 5e-4;
              return J;
            }
            return oe + (ee - re) / 1e-3 * (oe - le);
          }
        }
        return this.getValueAtTime(((ee - U) % Y + U) / this.comp.globalData.frameRate, 0);
      }
      function r($, X, W) {
        if (!this.k) return this.pv;
        $ = $ ? $.toLowerCase() : "";
        var Y, U, G, K, J, ee = this.comp.renderedFrame, te = this.keyframes, re = te[0].t;
        if (ee >= re) return this.pv;
        if (W ? U = re + (Y = X ? Math.abs(this.elem.comp.globalData.frameRate * X) : Math.max(0, this.elem.data.op - re)) : ((!X || X > te.length - 1) && (X = te.length - 1), Y = (U = te[X].t) - re), $ === "pingpong") {
          if (Math.floor((re - ee) / Y) % 2 == 0) return this.getValueAtTime(((re - ee) % Y + re) / this.comp.globalData.frameRate, 0);
        } else {
          if ($ === "offset") {
            var ae = this.getValueAtTime(re / this.comp.globalData.frameRate, 0), ie = this.getValueAtTime(U / this.comp.globalData.frameRate, 0), ce = this.getValueAtTime((Y - (re - ee) % Y + re) / this.comp.globalData.frameRate, 0), he = Math.floor((re - ee) / Y) + 1;
            if (this.pv.length) {
              for (K = (J = new Array(ae.length)).length, G = 0; G < K; G += 1) J[G] = ce[G] - (ie[G] - ae[G]) * he;
              return J;
            }
            return ce - (ie - ae) * he;
          }
          if ($ === "continue") {
            var oe = this.getValueAtTime(re / this.comp.globalData.frameRate, 0), le = this.getValueAtTime((re + 1e-3) / this.comp.globalData.frameRate, 0);
            if (this.pv.length) {
              for (K = (J = new Array(oe.length)).length, G = 0; G < K; G += 1) J[G] = oe[G] + (oe[G] - le[G]) * (re - ee) / 1e-3;
              return J;
            }
            return oe + (oe - le) * (re - ee) / 1e-3;
          }
        }
        return this.getValueAtTime((Y - ((re - ee) % Y + re)) / this.comp.globalData.frameRate, 0);
      }
      function n($, X) {
        if (!this.k) return this.pv;
        if ($ = 0.5 * ($ || 0.4), (X = Math.floor(X || 5)) <= 1) return this.pv;
        var W, Y, U = this.comp.renderedFrame / this.comp.globalData.frameRate, G = U - $, K = X > 1 ? (U + $ - G) / (X - 1) : 1, J = 0, ee = 0;
        for (W = this.pv.length ? createTypedArray("float32", this.pv.length) : 0; J < X; ) {
          if (Y = this.getValueAtTime(G + J * K), this.pv.length) for (ee = 0; ee < this.pv.length; ee += 1) W[ee] += Y[ee];
          else W += Y;
          J += 1;
        }
        if (this.pv.length) for (ee = 0; ee < this.pv.length; ee += 1) W[ee] /= X;
        else W /= X;
        return W;
      }
      function a($) {
        this._transformCachingAtTime || (this._transformCachingAtTime = { v: new Matrix() });
        var X = this._transformCachingAtTime.v;
        if (X.cloneFromProps(this.pre.props), this.appliedTransformations < 1) {
          var W = this.a.getValueAtTime($);
          X.translate(-W[0] * this.a.mult, -W[1] * this.a.mult, W[2] * this.a.mult);
        }
        if (this.appliedTransformations < 2) {
          var Y = this.s.getValueAtTime($);
          X.scale(Y[0] * this.s.mult, Y[1] * this.s.mult, Y[2] * this.s.mult);
        }
        if (this.sk && this.appliedTransformations < 3) {
          var U = this.sk.getValueAtTime($), G = this.sa.getValueAtTime($);
          X.skewFromAxis(-U * this.sk.mult, G * this.sa.mult);
        }
        if (this.r && this.appliedTransformations < 4) {
          var K = this.r.getValueAtTime($);
          X.rotate(-K * this.r.mult);
        } else if (!this.r && this.appliedTransformations < 4) {
          var J = this.rz.getValueAtTime($), ee = this.ry.getValueAtTime($), te = this.rx.getValueAtTime($), re = this.or.getValueAtTime($);
          X.rotateZ(-J * this.rz.mult).rotateY(ee * this.ry.mult).rotateX(te * this.rx.mult).rotateZ(-re[2] * this.or.mult).rotateY(re[1] * this.or.mult).rotateX(re[0] * this.or.mult);
        }
        if (this.data.p && this.data.p.s) {
          var ae = this.px.getValueAtTime($), ie = this.py.getValueAtTime($);
          if (this.data.p.z) {
            var ce = this.pz.getValueAtTime($);
            X.translate(ae * this.px.mult, ie * this.py.mult, -ce * this.pz.mult);
          } else X.translate(ae * this.px.mult, ie * this.py.mult, 0);
        } else {
          var he = this.p.getValueAtTime($);
          X.translate(he[0] * this.p.mult, he[1] * this.p.mult, -he[2] * this.p.mult);
        }
        return X;
      }
      function s() {
        return this.v.clone(new Matrix());
      }
      var o = TransformPropertyFactory.getTransformProperty;
      TransformPropertyFactory.getTransformProperty = function($, X, W) {
        var Y = o($, X, W);
        return Y.dynamicProperties.length ? Y.getValueAtTime = a.bind(Y) : Y.getValueAtTime = s.bind(Y), Y.setGroupProperty = expressionHelpers.setGroupProperty, Y;
      };
      var l = PropertyFactory.getProp;
      PropertyFactory.getProp = function($, X, W, Y, U) {
        var G = l($, X, W, Y, U);
        G.kf ? G.getValueAtTime = expressionHelpers.getValueAtTime.bind(G) : G.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(G), G.setGroupProperty = expressionHelpers.setGroupProperty, G.loopOut = t, G.loopIn = r, G.smooth = n, G.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(G), G.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(G), G.numKeys = X.a === 1 ? X.k.length : 0, G.propertyIndex = X.ix;
        var K = 0;
        return W !== 0 && (K = createTypedArray("float32", X.a === 1 ? X.k[0].s.length : X.k.length)), G._cachingAtTime = { lastFrame: initialDefaultFrame, lastIndex: 0, value: K }, expressionHelpers.searchExpressions($, X, G), G.k && U.addDynamicProperty(G), G;
      };
      var x = ShapePropertyFactory.getConstructorFunction(), j = ShapePropertyFactory.getKeyframedConstructorFunction();
      function Z() {
      }
      Z.prototype = { vertices: function($, X) {
        this.k && this.getValue();
        var W, Y = this.v;
        X !== void 0 && (Y = this.getValueAtTime(X, 0));
        var U = Y._length, G = Y[$], K = Y.v, J = createSizedArray(U);
        for (W = 0; W < U; W += 1) J[W] = $ === "i" || $ === "o" ? [G[W][0] - K[W][0], G[W][1] - K[W][1]] : [G[W][0], G[W][1]];
        return J;
      }, points: function($) {
        return this.vertices("v", $);
      }, inTangents: function($) {
        return this.vertices("i", $);
      }, outTangents: function($) {
        return this.vertices("o", $);
      }, isClosed: function() {
        return this.v.c;
      }, pointOnPath: function($, X) {
        var W = this.v;
        X !== void 0 && (W = this.getValueAtTime(X, 0)), this._segmentsLength || (this._segmentsLength = bez.getSegmentsLength(W));
        for (var Y, U = this._segmentsLength, G = U.lengths, K = U.totalLength * $, J = 0, ee = G.length, te = 0; J < ee; ) {
          if (te + G[J].addedLength > K) {
            var re = J, ae = W.c && J === ee - 1 ? 0 : J + 1, ie = (K - te) / G[J].addedLength;
            Y = bez.getPointInSegment(W.v[re], W.v[ae], W.o[re], W.i[ae], ie, G[J]);
            break;
          }
          te += G[J].addedLength, J += 1;
        }
        return Y || (Y = W.c ? [W.v[0][0], W.v[0][1]] : [W.v[W._length - 1][0], W.v[W._length - 1][1]]), Y;
      }, vectorOnPath: function($, X, W) {
        $ == 1 ? $ = this.v.c : $ == 0 && ($ = 0.999);
        var Y = this.pointOnPath($, X), U = this.pointOnPath($ + 1e-3, X), G = U[0] - Y[0], K = U[1] - Y[1], J = Math.sqrt(Math.pow(G, 2) + Math.pow(K, 2));
        return J === 0 ? [0, 0] : W === "tangent" ? [G / J, K / J] : [-K / J, G / J];
      }, tangentOnPath: function($, X) {
        return this.vectorOnPath($, X, "tangent");
      }, normalOnPath: function($, X) {
        return this.vectorOnPath($, X, "normal");
      }, setGroupProperty: expressionHelpers.setGroupProperty, getValueAtTime: expressionHelpers.getStaticValueAtTime }, extendPrototype([Z], x), extendPrototype([Z], j), j.prototype.getValueAtTime = function($) {
        return this._cachingAtTime || (this._cachingAtTime = { shapeValue: shapePool.clone(this.pv), lastIndex: 0, lastTime: initialDefaultFrame }), $ *= this.elem.globalData.frameRate, ($ -= this.offsetTime) !== this._cachingAtTime.lastTime && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < $ ? this._caching.lastIndex : 0, this._cachingAtTime.lastTime = $, this.interpolateShape($, this._cachingAtTime.shapeValue, this._cachingAtTime)), this._cachingAtTime.shapeValue;
      }, j.prototype.initiateExpression = ExpressionManager.initiateExpression;
      var V = ShapePropertyFactory.getShapeProp;
      ShapePropertyFactory.getShapeProp = function($, X, W, Y, U) {
        var G = V($, X, W, Y, U);
        return G.propertyIndex = X.ix, G.lock = !1, W === 3 ? expressionHelpers.searchExpressions($, X.pt, G) : W === 4 && expressionHelpers.searchExpressions($, X.ks, G), G.k && $.addDynamicProperty(G), G;
      };
    }
    function initialize$1() {
      addPropertyDecorator();
    }
    function addDecorator() {
      TextProperty.prototype.getExpressionValue = function(t, r) {
        var n = this.calculateExpression(r);
        if (t.t !== n) {
          var a = {};
          return this.copyData(a, t), a.t = n.toString(), a.__complete = !1, a;
        }
        return t;
      }, TextProperty.prototype.searchProperty = function() {
        var t = this.searchKeyframes(), r = this.searchExpressions();
        return this.kf = t || r, this.kf;
      }, TextProperty.prototype.searchExpressions = function() {
        return this.data.d.x ? (this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this), this.addEffect(this.getExpressionValue.bind(this)), !0) : null;
      };
    }
    function initialize() {
      addDecorator();
    }
    function SVGComposableEffect() {
    }
    SVGComposableEffect.prototype = { createMergeNode: function(t, r) {
      var n, a, s = createNS("feMerge");
      for (s.setAttribute("result", t), a = 0; a < r.length; a += 1) (n = createNS("feMergeNode")).setAttribute("in", r[a]), s.appendChild(n), s.appendChild(n);
      return s;
    } };
    var linearFilterValue = "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0";
    function SVGTintFilter(t, r, n, a, s) {
      this.filterManager = r;
      var o = createNS("feColorMatrix");
      o.setAttribute("type", "matrix"), o.setAttribute("color-interpolation-filters", "linearRGB"), o.setAttribute("values", linearFilterValue + " 1 0"), this.linearFilter = o, o.setAttribute("result", a + "_tint_1"), t.appendChild(o), (o = createNS("feColorMatrix")).setAttribute("type", "matrix"), o.setAttribute("color-interpolation-filters", "sRGB"), o.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), o.setAttribute("result", a + "_tint_2"), t.appendChild(o), this.matrixFilter = o;
      var l = this.createMergeNode(a, [s, a + "_tint_1", a + "_tint_2"]);
      t.appendChild(l);
    }
    function SVGFillFilter(t, r, n, a) {
      this.filterManager = r;
      var s = createNS("feColorMatrix");
      s.setAttribute("type", "matrix"), s.setAttribute("color-interpolation-filters", "sRGB"), s.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), s.setAttribute("result", a), t.appendChild(s), this.matrixFilter = s;
    }
    function SVGStrokeEffect(t, r, n) {
      this.initialized = !1, this.filterManager = r, this.elem = n, this.paths = [];
    }
    function SVGTritoneFilter(t, r, n, a) {
      this.filterManager = r;
      var s = createNS("feColorMatrix");
      s.setAttribute("type", "matrix"), s.setAttribute("color-interpolation-filters", "linearRGB"), s.setAttribute("values", "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"), t.appendChild(s);
      var o = createNS("feComponentTransfer");
      o.setAttribute("color-interpolation-filters", "sRGB"), o.setAttribute("result", a), this.matrixFilter = o;
      var l = createNS("feFuncR");
      l.setAttribute("type", "table"), o.appendChild(l), this.feFuncR = l;
      var x = createNS("feFuncG");
      x.setAttribute("type", "table"), o.appendChild(x), this.feFuncG = x;
      var j = createNS("feFuncB");
      j.setAttribute("type", "table"), o.appendChild(j), this.feFuncB = j, t.appendChild(o);
    }
    function SVGProLevelsFilter(t, r, n, a) {
      this.filterManager = r;
      var s = this.filterManager.effectElements, o = createNS("feComponentTransfer");
      (s[10].p.k || s[10].p.v !== 0 || s[11].p.k || s[11].p.v !== 1 || s[12].p.k || s[12].p.v !== 1 || s[13].p.k || s[13].p.v !== 0 || s[14].p.k || s[14].p.v !== 1) && (this.feFuncR = this.createFeFunc("feFuncR", o)), (s[17].p.k || s[17].p.v !== 0 || s[18].p.k || s[18].p.v !== 1 || s[19].p.k || s[19].p.v !== 1 || s[20].p.k || s[20].p.v !== 0 || s[21].p.k || s[21].p.v !== 1) && (this.feFuncG = this.createFeFunc("feFuncG", o)), (s[24].p.k || s[24].p.v !== 0 || s[25].p.k || s[25].p.v !== 1 || s[26].p.k || s[26].p.v !== 1 || s[27].p.k || s[27].p.v !== 0 || s[28].p.k || s[28].p.v !== 1) && (this.feFuncB = this.createFeFunc("feFuncB", o)), (s[31].p.k || s[31].p.v !== 0 || s[32].p.k || s[32].p.v !== 1 || s[33].p.k || s[33].p.v !== 1 || s[34].p.k || s[34].p.v !== 0 || s[35].p.k || s[35].p.v !== 1) && (this.feFuncA = this.createFeFunc("feFuncA", o)), (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) && (o.setAttribute("color-interpolation-filters", "sRGB"), t.appendChild(o)), (s[3].p.k || s[3].p.v !== 0 || s[4].p.k || s[4].p.v !== 1 || s[5].p.k || s[5].p.v !== 1 || s[6].p.k || s[6].p.v !== 0 || s[7].p.k || s[7].p.v !== 1) && ((o = createNS("feComponentTransfer")).setAttribute("color-interpolation-filters", "sRGB"), o.setAttribute("result", a), t.appendChild(o), this.feFuncRComposed = this.createFeFunc("feFuncR", o), this.feFuncGComposed = this.createFeFunc("feFuncG", o), this.feFuncBComposed = this.createFeFunc("feFuncB", o));
    }
    function SVGDropShadowEffect(t, r, n, a, s) {
      var o = r.container.globalData.renderConfig.filterSize, l = r.data.fs || o;
      t.setAttribute("x", l.x || o.x), t.setAttribute("y", l.y || o.y), t.setAttribute("width", l.width || o.width), t.setAttribute("height", l.height || o.height), this.filterManager = r;
      var x = createNS("feGaussianBlur");
      x.setAttribute("in", "SourceAlpha"), x.setAttribute("result", a + "_drop_shadow_1"), x.setAttribute("stdDeviation", "0"), this.feGaussianBlur = x, t.appendChild(x);
      var j = createNS("feOffset");
      j.setAttribute("dx", "25"), j.setAttribute("dy", "0"), j.setAttribute("in", a + "_drop_shadow_1"), j.setAttribute("result", a + "_drop_shadow_2"), this.feOffset = j, t.appendChild(j);
      var Z = createNS("feFlood");
      Z.setAttribute("flood-color", "#00ff00"), Z.setAttribute("flood-opacity", "1"), Z.setAttribute("result", a + "_drop_shadow_3"), this.feFlood = Z, t.appendChild(Z);
      var V = createNS("feComposite");
      V.setAttribute("in", a + "_drop_shadow_3"), V.setAttribute("in2", a + "_drop_shadow_2"), V.setAttribute("operator", "in"), V.setAttribute("result", a + "_drop_shadow_4"), t.appendChild(V);
      var $ = this.createMergeNode(a, [a + "_drop_shadow_4", s]);
      t.appendChild($);
    }
    extendPrototype([SVGComposableEffect], SVGTintFilter), SVGTintFilter.prototype.renderFrame = function(t) {
      if (t || this.filterManager._mdf) {
        var r = this.filterManager.effectElements[0].p.v, n = this.filterManager.effectElements[1].p.v, a = this.filterManager.effectElements[2].p.v / 100;
        this.linearFilter.setAttribute("values", linearFilterValue + " " + a + " 0"), this.matrixFilter.setAttribute("values", n[0] - r[0] + " 0 0 0 " + r[0] + " " + (n[1] - r[1]) + " 0 0 0 " + r[1] + " " + (n[2] - r[2]) + " 0 0 0 " + r[2] + " 0 0 0 1 0");
      }
    }, SVGFillFilter.prototype.renderFrame = function(t) {
      if (t || this.filterManager._mdf) {
        var r = this.filterManager.effectElements[2].p.v, n = this.filterManager.effectElements[6].p.v;
        this.matrixFilter.setAttribute("values", "0 0 0 0 " + r[0] + " 0 0 0 0 " + r[1] + " 0 0 0 0 " + r[2] + " 0 0 0 " + n + " 0");
      }
    }, SVGStrokeEffect.prototype.initialize = function() {
      var t, r, n, a, s = this.elem.layerElement.children || this.elem.layerElement.childNodes;
      for (this.filterManager.effectElements[1].p.v === 1 ? (a = this.elem.maskManager.masksProperties.length, n = 0) : a = (n = this.filterManager.effectElements[0].p.v - 1) + 1, (r = createNS("g")).setAttribute("fill", "none"), r.setAttribute("stroke-linecap", "round"), r.setAttribute("stroke-dashoffset", 1); n < a; n += 1) t = createNS("path"), r.appendChild(t), this.paths.push({ p: t, m: n });
      if (this.filterManager.effectElements[10].p.v === 3) {
        var o = createNS("mask"), l = createElementID();
        o.setAttribute("id", l), o.setAttribute("mask-type", "alpha"), o.appendChild(r), this.elem.globalData.defs.appendChild(o);
        var x = createNS("g");
        for (x.setAttribute("mask", "url(" + getLocationHref() + "#" + l + ")"); s[0]; ) x.appendChild(s[0]);
        this.elem.layerElement.appendChild(x), this.masker = o, r.setAttribute("stroke", "#fff");
      } else if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
        if (this.filterManager.effectElements[10].p.v === 2) for (s = this.elem.layerElement.children || this.elem.layerElement.childNodes; s.length; ) this.elem.layerElement.removeChild(s[0]);
        this.elem.layerElement.appendChild(r), this.elem.layerElement.removeAttribute("mask"), r.setAttribute("stroke", "#fff");
      }
      this.initialized = !0, this.pathMasker = r;
    }, SVGStrokeEffect.prototype.renderFrame = function(t) {
      var r;
      this.initialized || this.initialize();
      var n, a, s = this.paths.length;
      for (r = 0; r < s; r += 1) if (this.paths[r].m !== -1 && (n = this.elem.maskManager.viewData[this.paths[r].m], a = this.paths[r].p, (t || this.filterManager._mdf || n.prop._mdf) && a.setAttribute("d", n.lastPath), t || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || n.prop._mdf)) {
        var o;
        if (this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100) {
          var l = 0.01 * Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v), x = 0.01 * Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v), j = a.getTotalLength();
          o = "0 0 0 " + j * l + " ";
          var Z, V = j * (x - l), $ = 1 + 2 * this.filterManager.effectElements[4].p.v * this.filterManager.effectElements[9].p.v * 0.01, X = Math.floor(V / $);
          for (Z = 0; Z < X; Z += 1) o += "1 " + 2 * this.filterManager.effectElements[4].p.v * this.filterManager.effectElements[9].p.v * 0.01 + " ";
          o += "0 " + 10 * j + " 0 0";
        } else o = "1 " + 2 * this.filterManager.effectElements[4].p.v * this.filterManager.effectElements[9].p.v * 0.01;
        a.setAttribute("stroke-dasharray", o);
      }
      if ((t || this.filterManager.effectElements[4].p._mdf) && this.pathMasker.setAttribute("stroke-width", 2 * this.filterManager.effectElements[4].p.v), (t || this.filterManager.effectElements[6].p._mdf) && this.pathMasker.setAttribute("opacity", this.filterManager.effectElements[6].p.v), (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) && (t || this.filterManager.effectElements[3].p._mdf)) {
        var W = this.filterManager.effectElements[3].p.v;
        this.pathMasker.setAttribute("stroke", "rgb(" + bmFloor(255 * W[0]) + "," + bmFloor(255 * W[1]) + "," + bmFloor(255 * W[2]) + ")");
      }
    }, SVGTritoneFilter.prototype.renderFrame = function(t) {
      if (t || this.filterManager._mdf) {
        var r = this.filterManager.effectElements[0].p.v, n = this.filterManager.effectElements[1].p.v, a = this.filterManager.effectElements[2].p.v, s = a[0] + " " + n[0] + " " + r[0], o = a[1] + " " + n[1] + " " + r[1], l = a[2] + " " + n[2] + " " + r[2];
        this.feFuncR.setAttribute("tableValues", s), this.feFuncG.setAttribute("tableValues", o), this.feFuncB.setAttribute("tableValues", l);
      }
    }, SVGProLevelsFilter.prototype.createFeFunc = function(t, r) {
      var n = createNS(t);
      return n.setAttribute("type", "table"), r.appendChild(n), n;
    }, SVGProLevelsFilter.prototype.getTableValue = function(t, r, n, a, s) {
      for (var o, l, x = 0, j = Math.min(t, r), Z = Math.max(t, r), V = Array.call(null, { length: 256 }), $ = 0, X = s - a, W = r - t; x <= 256; ) l = (o = x / 256) <= j ? W < 0 ? s : a : o >= Z ? W < 0 ? a : s : a + X * Math.pow((o - t) / W, 1 / n), V[$] = l, $ += 1, x += 256 / 255;
      return V.join(" ");
    }, SVGProLevelsFilter.prototype.renderFrame = function(t) {
      if (t || this.filterManager._mdf) {
        var r, n = this.filterManager.effectElements;
        this.feFuncRComposed && (t || n[3].p._mdf || n[4].p._mdf || n[5].p._mdf || n[6].p._mdf || n[7].p._mdf) && (r = this.getTableValue(n[3].p.v, n[4].p.v, n[5].p.v, n[6].p.v, n[7].p.v), this.feFuncRComposed.setAttribute("tableValues", r), this.feFuncGComposed.setAttribute("tableValues", r), this.feFuncBComposed.setAttribute("tableValues", r)), this.feFuncR && (t || n[10].p._mdf || n[11].p._mdf || n[12].p._mdf || n[13].p._mdf || n[14].p._mdf) && (r = this.getTableValue(n[10].p.v, n[11].p.v, n[12].p.v, n[13].p.v, n[14].p.v), this.feFuncR.setAttribute("tableValues", r)), this.feFuncG && (t || n[17].p._mdf || n[18].p._mdf || n[19].p._mdf || n[20].p._mdf || n[21].p._mdf) && (r = this.getTableValue(n[17].p.v, n[18].p.v, n[19].p.v, n[20].p.v, n[21].p.v), this.feFuncG.setAttribute("tableValues", r)), this.feFuncB && (t || n[24].p._mdf || n[25].p._mdf || n[26].p._mdf || n[27].p._mdf || n[28].p._mdf) && (r = this.getTableValue(n[24].p.v, n[25].p.v, n[26].p.v, n[27].p.v, n[28].p.v), this.feFuncB.setAttribute("tableValues", r)), this.feFuncA && (t || n[31].p._mdf || n[32].p._mdf || n[33].p._mdf || n[34].p._mdf || n[35].p._mdf) && (r = this.getTableValue(n[31].p.v, n[32].p.v, n[33].p.v, n[34].p.v, n[35].p.v), this.feFuncA.setAttribute("tableValues", r));
      }
    }, extendPrototype([SVGComposableEffect], SVGDropShadowEffect), SVGDropShadowEffect.prototype.renderFrame = function(t) {
      if (t || this.filterManager._mdf) {
        if ((t || this.filterManager.effectElements[4].p._mdf) && this.feGaussianBlur.setAttribute("stdDeviation", this.filterManager.effectElements[4].p.v / 4), t || this.filterManager.effectElements[0].p._mdf) {
          var r = this.filterManager.effectElements[0].p.v;
          this.feFlood.setAttribute("flood-color", rgbToHex(Math.round(255 * r[0]), Math.round(255 * r[1]), Math.round(255 * r[2])));
        }
        if ((t || this.filterManager.effectElements[1].p._mdf) && this.feFlood.setAttribute("flood-opacity", this.filterManager.effectElements[1].p.v / 255), t || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
          var n = this.filterManager.effectElements[3].p.v, a = (this.filterManager.effectElements[2].p.v - 90) * degToRads, s = n * Math.cos(a), o = n * Math.sin(a);
          this.feOffset.setAttribute("dx", s), this.feOffset.setAttribute("dy", o);
        }
      }
    };
    var _svgMatteSymbols = [];
    function SVGMatte3Effect(t, r, n) {
      this.initialized = !1, this.filterManager = r, this.filterElem = t, this.elem = n, n.matteElement = createNS("g"), n.matteElement.appendChild(n.layerElement), n.matteElement.appendChild(n.transformedElement), n.baseElement = n.matteElement;
    }
    function SVGGaussianBlurEffect(t, r, n, a) {
      t.setAttribute("x", "-100%"), t.setAttribute("y", "-100%"), t.setAttribute("width", "300%"), t.setAttribute("height", "300%"), this.filterManager = r;
      var s = createNS("feGaussianBlur");
      s.setAttribute("result", a), t.appendChild(s), this.feGaussianBlur = s;
    }
    function TransformEffect() {
    }
    function SVGTransformEffect(t, r) {
      this.init(r);
    }
    function CVTransformEffect(t) {
      this.init(t);
    }
    return SVGMatte3Effect.prototype.findSymbol = function(t) {
      for (var r = 0, n = _svgMatteSymbols.length; r < n; ) {
        if (_svgMatteSymbols[r] === t) return _svgMatteSymbols[r];
        r += 1;
      }
      return null;
    }, SVGMatte3Effect.prototype.replaceInParent = function(t, r) {
      var n = t.layerElement.parentNode;
      if (n) {
        for (var a, s = n.children, o = 0, l = s.length; o < l && s[o] !== t.layerElement; ) o += 1;
        o <= l - 2 && (a = s[o + 1]);
        var x = createNS("use");
        x.setAttribute("href", "#" + r), a ? n.insertBefore(x, a) : n.appendChild(x);
      }
    }, SVGMatte3Effect.prototype.setElementAsMask = function(t, r) {
      if (!this.findSymbol(r)) {
        var n = createElementID(), a = createNS("mask");
        a.setAttribute("id", r.layerId), a.setAttribute("mask-type", "alpha"), _svgMatteSymbols.push(r);
        var s = t.globalData.defs;
        s.appendChild(a);
        var o = createNS("symbol");
        o.setAttribute("id", n), this.replaceInParent(r, n), o.appendChild(r.layerElement), s.appendChild(o);
        var l = createNS("use");
        l.setAttribute("href", "#" + n), a.appendChild(l), r.data.hd = !1, r.show();
      }
      t.setMatte(r.layerId);
    }, SVGMatte3Effect.prototype.initialize = function() {
      for (var t = this.filterManager.effectElements[0].p.v, r = this.elem.comp.elements, n = 0, a = r.length; n < a; ) r[n] && r[n].data.ind === t && this.setElementAsMask(this.elem, r[n]), n += 1;
      this.initialized = !0;
    }, SVGMatte3Effect.prototype.renderFrame = function() {
      this.initialized || this.initialize();
    }, SVGGaussianBlurEffect.prototype.renderFrame = function(t) {
      if (t || this.filterManager._mdf) {
        var r = 0.3 * this.filterManager.effectElements[0].p.v, n = this.filterManager.effectElements[1].p.v, a = n == 3 ? 0 : r, s = n == 2 ? 0 : r;
        this.feGaussianBlur.setAttribute("stdDeviation", a + " " + s);
        var o = this.filterManager.effectElements[2].p.v == 1 ? "wrap" : "duplicate";
        this.feGaussianBlur.setAttribute("edgeMode", o);
      }
    }, TransformEffect.prototype.init = function(t) {
      this.effectsManager = t, this.type = effectTypes.TRANSFORM_EFFECT, this.matrix = new Matrix(), this.opacity = -1, this._mdf = !1, this._opMdf = !1;
    }, TransformEffect.prototype.renderFrame = function(t) {
      if (this._opMdf = !1, this._mdf = !1, t || this.effectsManager._mdf) {
        var r = this.effectsManager.effectElements, n = r[0].p.v, a = r[1].p.v, s = r[2].p.v === 1, o = r[3].p.v, l = s ? o : r[4].p.v, x = r[5].p.v, j = r[6].p.v, Z = r[7].p.v;
        this.matrix.reset(), this.matrix.translate(-n[0], -n[1], n[2]), this.matrix.scale(0.01 * l, 0.01 * o, 1), this.matrix.rotate(-Z * degToRads), this.matrix.skewFromAxis(-x * degToRads, (j + 90) * degToRads), this.matrix.translate(a[0], a[1], 0), this._mdf = !0, this.opacity !== r[8].p.v && (this.opacity = r[8].p.v, this._opMdf = !0);
      }
    }, extendPrototype([TransformEffect], SVGTransformEffect), extendPrototype([TransformEffect], CVTransformEffect), registerRenderer("canvas", CanvasRenderer), registerRenderer("html", HybridRenderer), registerRenderer("svg", SVGRenderer), ShapeModifiers.registerModifier("tm", TrimModifier), ShapeModifiers.registerModifier("pb", PuckerAndBloatModifier), ShapeModifiers.registerModifier("rp", RepeaterModifier), ShapeModifiers.registerModifier("rd", RoundCornersModifier), ShapeModifiers.registerModifier("zz", ZigZagModifier), ShapeModifiers.registerModifier("op", OffsetPathModifier), setExpressionsPlugin(Expressions), setExpressionInterfaces(getInterface), initialize$1(), initialize(), registerEffect$1(20, SVGTintFilter, !0), registerEffect$1(21, SVGFillFilter, !0), registerEffect$1(22, SVGStrokeEffect, !1), registerEffect$1(23, SVGTritoneFilter, !0), registerEffect$1(24, SVGProLevelsFilter, !0), registerEffect$1(25, SVGDropShadowEffect, !0), registerEffect$1(28, SVGMatte3Effect, !1), registerEffect$1(29, SVGGaussianBlurEffect, !0), registerEffect$1(35, SVGTransformEffect, !1), registerEffect(35, CVTransformEffect), lottie;
  }));
})), REACT_LOTTIE_PLAYER_VERSION = "3.6.0", LOTTIE_WEB_VERSION = "^5.12.2", PlayerState, PlayerEvent;
function parseSrc(t) {
  if (typeof t == "object") return t;
  try {
    return JSON.parse(t);
  } catch {
  }
  try {
    return new URL(t).toString();
  } catch {
  }
  return t;
}
(function(t) {
  t.Loading = "loading", t.Playing = "playing", t.Paused = "paused", t.Stopped = "stopped", t.Frozen = "frozen", t.Error = "error";
})(PlayerState || (PlayerState = {})), (function(t) {
  t.Load = "load", t.InstanceSaved = "instanceSaved", t.Error = "error", t.Ready = "ready", t.Play = "play", t.Pause = "pause", t.Stop = "stop", t.Freeze = "freeze", t.Loop = "loop", t.Complete = "complete", t.Frame = "frame";
})(PlayerEvent || (PlayerEvent = {}));
var defaultOptions = { clearCanvas: !1, hideOnTransparent: !0, progressiveLoad: !0 }, Player = (function(t) {
  function r(n) {
    var a = t.call(this, n) || this;
    return a.container = null, a.unmounted = !1, a.handleBgChange = function(s) {
      a.setState({ background: s });
    }, a.triggerDownload = function(s, o) {
      var l = document.createElement("a");
      l.href = s, l.download = o, document.body.appendChild(l), l.click(), document.body.removeChild(l);
    }, a.snapshot = function(s) {
      var o;
      s === void 0 && (s = !0);
      var l = a.props.id ? a.props.id : "lottie", x = document.getElementById(l);
      if (a.props.renderer === "svg") {
        if (x) {
          var j = x.querySelector("svg");
          if (j) {
            var Z = new XMLSerializer().serializeToString(j);
            o = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(Z);
          }
        }
        s && a.triggerDownload(o, "snapshot.svg");
      } else if (a.props.renderer === "canvas") {
        if (x) {
          var V = x.querySelector("canvas");
          V && (o = V.toDataURL("image/png"));
        }
        s && a.triggerDownload(o, "snapshot.png");
      }
      return o;
    }, typeof window != "undefined" && (window.lottie = lottie), a.state = { animationData: null, background: "transparent", containerRef: React.createRef(), debug: !0, instance: null, playerState: PlayerState.Loading, seeker: 0 }, a;
  }
  return __extends$1(r, t), r.getDerivedStateFromProps = function(n, a) {
    return __awaiter(this, void 0, void 0, (function() {
      return __generator(this, (function(s) {
        return n.background !== a.background ? [2, { background: n.background }] : [2, null];
      }));
    }));
  }, r.prototype.getVersions = function() {
    return { lottieWebVersion: LOTTIE_WEB_VERSION, lottiePlayerVersion: REACT_LOTTIE_PLAYER_VERSION };
  }, r.prototype.componentDidMount = function() {
    return __awaiter(this, void 0, void 0, (function() {
      return __generator(this, (function(n) {
        switch (n.label) {
          case 0:
            return this.unmounted ? [3, 2] : [4, this.createLottie()];
          case 1:
            n.sent(), n.label = 2;
          case 2:
            return [2];
        }
      }));
    }));
  }, r.prototype.componentWillUnmount = function() {
    this.unmounted = !0, this.state.instance && this.state.instance.destroy();
  }, r.prototype.componentDidUpdate = function(n) {
    return __awaiter(this, void 0, void 0, (function() {
      return __generator(this, (function(a) {
        switch (a.label) {
          case 0:
            return this.props.src === n.src ? [3, 2] : (this.state.instance && this.state.instance.destroy(), [4, this.createLottie()]);
          case 1:
            a.sent(), a.label = 2;
          case 2:
            return [2];
        }
      }));
    }));
  }, r.prototype.render = function() {
    var n = this, a = this.props, s = a.children, o = a.loop, l = a.style, x = a.onBackgroundChange, j = a.className, Z = this.state, V = Z.animationData, $ = Z.instance, X = Z.playerState, W = Z.seeker, Y = Z.debug, U = Z.background;
    return React.createElement("div", { className: "lf-player-container" }, this.state.playerState === PlayerState.Error ? React.createElement("div", { className: "lf-error" }, React.createElement("span", { "aria-label": "error-symbol", role: "img" }, "⚠️")) : React.createElement("div", { id: this.props.id ? this.props.id : "lottie", ref: function(G) {
      return n.container = G;
    }, style: __assign$1({ background: U, margin: "0 auto", outline: "none", overflow: "hidden" }, l), className: j }), React.Children.map(s, (function(G) {
      return React.isValidElement(G) ? React.cloneElement(G, { animationData: V, background: U, debug: Y, instance: $, loop: o, pause: function() {
        return n.pause();
      }, play: function() {
        return n.play();
      }, playerState: X, seeker: W, setBackground: function(K) {
        n.setState({ background: K }), typeof x == "function" && x(K);
      }, setSeeker: function(K, J) {
        return n.setSeeker(K, J);
      }, stop: function() {
        return n.stop();
      }, toggleDebug: function() {
        return n.toggleDebug();
      }, setLoop: function(K) {
        return n.setLoop(K);
      }, colorChangedEvent: function(K) {
        n.handleBgChange(K);
      }, snapshot: function() {
        n.snapshot();
      } }) : null;
    })));
  }, r.prototype.toggleDebug = function() {
    this.setState({ debug: !this.state.debug });
  }, r.prototype.createLottie = function() {
    return __awaiter(this, void 0, void 0, (function() {
      var n, a, s, o, l, x, j, Z, V, $, X, W, Y, U, G = this;
      return __generator(this, (function(K) {
        switch (K.label) {
          case 0:
            if (n = this.props, a = n.autoplay, s = n.direction, o = n.loop, l = n.lottieRef, x = n.renderer, j = n.speed, Z = n.src, V = n.background, $ = n.rendererSettings, X = n.hover, W = this.state.instance, !Z || !this.container) return [2];
            K.label = 1;
          case 1:
            return K.trys.push([1, 5, , 6]), typeof (Y = parseSrc(Z)) != "string" ? [3, 4] : [4, fetch(Y).catch((function() {
              throw G.setState({ playerState: PlayerState.Error }), G.triggerEvent(PlayerEvent.Error), new Error("@LottieFiles/lottie-react: Animation data could not be fetched.");
            }))];
          case 2:
            return [4, K.sent().json().catch((function() {
              throw G.setState({ playerState: PlayerState.Error }), G.triggerEvent(PlayerEvent.Error), new Error("@LottieFiles/lottie-react: Animation data could not be fetched.");
            }))];
          case 3:
            Y = K.sent(), K.label = 4;
          case 4:
            return W && W.destroy(), U = lottie.loadAnimation({ rendererSettings: $ || defaultOptions, animationData: Y, autoplay: a || !1, container: this.container, loop: o || !1, renderer: x }), j && U.setSpeed(j), this.setState({ animationData: Y }), this.setState({ instance: U }, (function() {
              G.triggerEvent(PlayerEvent.InstanceSaved), typeof l == "function" && l(U), a && G.play();
            })), U.addEventListener("enterFrame", (function() {
              G.triggerEvent(PlayerEvent.Frame), G.setState({ seeker: Math.floor(U.currentFrame) });
            })), U.addEventListener("DOMLoaded", (function() {
              G.triggerEvent(PlayerEvent.Load);
            })), U.addEventListener("data_ready", (function() {
              G.triggerEvent(PlayerEvent.Ready);
            })), U.addEventListener("data_failed", (function() {
              G.setState({ playerState: PlayerState.Error }), G.triggerEvent(PlayerEvent.Error);
            })), U.addEventListener("loopComplete", (function() {
              G.triggerEvent(PlayerEvent.Loop);
            })), U.addEventListener("complete", (function() {
              G.triggerEvent(PlayerEvent.Complete), G.setState({ playerState: PlayerState.Paused }), G.props.keepLastFrame && !G.props.loop || G.setSeeker(0);
            })), this.container && (this.container.addEventListener("mouseenter", (function() {
              X && G.state.playerState !== PlayerState.Playing && (G.props.keepLastFrame && G.stop(), G.play());
            })), this.container.addEventListener("mouseleave", (function() {
              X && G.state.playerState === PlayerState.Playing && G.stop();
            }))), j && this.setPlayerSpeed(j), s && this.setPlayerDirection(s), V && this.setState({ background: V }), [3, 6];
          case 5:
            return K.sent(), this.setState({ playerState: PlayerState.Error }), this.triggerEvent(PlayerEvent.Error), [3, 6];
          case 6:
            return [2];
        }
      }));
    }));
  }, r.prototype.play = function() {
    var n = this.state.instance;
    n && (this.triggerEvent(PlayerEvent.Play), n.play(), this.setState({ playerState: PlayerState.Playing }));
  }, r.prototype.pause = function() {
    var n = this.state.instance;
    n && (this.triggerEvent(PlayerEvent.Pause), n.pause(), this.setState({ playerState: PlayerState.Paused }));
  }, r.prototype.stop = function() {
    var n = this.state.instance;
    n && (this.triggerEvent(PlayerEvent.Stop), n.stop(), this.setState({ playerState: PlayerState.Stopped }));
  }, r.prototype.setPlayerSpeed = function(n) {
    var a = this.state.instance;
    a && a.setSpeed(n);
  }, r.prototype.setPlayerDirection = function(n) {
    var a = this.state.instance;
    a && a.setDirection(n);
  }, r.prototype.setSeeker = function(n, a) {
    a === void 0 && (a = !1);
    var s = this.state, o = s.instance, l = s.playerState;
    o && (a && l === PlayerState.Playing ? o.goToAndPlay(n, !0) : (o.goToAndStop(n, !0), this.triggerEvent(PlayerEvent.Pause), this.setState({ playerState: PlayerState.Paused })));
  }, r.prototype.setLoop = function(n) {
    var a = this.state.instance;
    a && (a.loop = n, this.setState({ instance: a }));
  }, r.prototype.triggerEvent = function(n) {
    var a = this.props.onEvent;
    a && a(n);
  }, r.defaultProps = { loop: !1 }, r;
})(React.Component);
function styleInject(t, r) {
  r === void 0 && (r = {});
  var n = r.insertAt;
  if (typeof document != "undefined") {
    var a = document.head || document.getElementsByTagName("head")[0], s = document.createElement("style");
    s.type = "text/css", n === "top" && a.firstChild ? a.insertBefore(s, a.firstChild) : a.appendChild(s), s.styleSheet ? s.styleSheet.cssText = t : s.appendChild(document.createTextNode(t));
  }
}
var css_248z = `.lf-progress {
  -webkit-appearance: none;
  -moz-apperance: none;
  width: 100%;
  /* margin: 0 10px; */
  height: 4px;
  border-radius: 3px;
  cursor: pointer;
}
.lf-progress:focus {
  outline: none;
  border: none;
}
.lf-progress::-moz-range-track {
  cursor: pointer;
  background: none;
  border: none;
  outline: none;
}
.lf-progress::-webkit-slider-thumb {
  -webkit-appearance: none !important;
  height: 13px;
  width: 13px;
  border: 0;
  border-radius: 50%;
  background: #0fccce;
  cursor: pointer;
}
.lf-progress::-moz-range-thumb {
  -moz-appearance: none !important;
  height: 13px;
  width: 13px;
  border: 0;
  border-radius: 50%;
  background: #0fccce;
  cursor: pointer;
}
.lf-progress::-ms-track {
  width: 100%;
  height: 3px;
  cursor: pointer;
  background: transparent;
  border-color: transparent;
  color: transparent;
}
.lf-progress::-ms-fill-lower {
  background: #ccc;
  border-radius: 3px;
}
.lf-progress::-ms-fill-upper {
  background: #ccc;
  border-radius: 3px;
}
.lf-progress::-ms-thumb {
  border: 0;
  height: 15px;
  width: 15px;
  border-radius: 50%;
  background: #0fccce;
  cursor: pointer;
}
.lf-progress:focus::-ms-fill-lower {
  background: #ccc;
}
.lf-progress:focus::-ms-fill-upper {
  background: #ccc;
}
.lf-player-container :focus {
  outline: 0;
}
.lf-popover {
  position: relative;
}

.lf-popover-content {
  display: inline-block;
  position: absolute;
  opacity: 1;
  visibility: visible;
  transform: translate(0, -10px);
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
  transition: all 0.3s cubic-bezier(0.75, -0.02, 0.2, 0.97);
}

.lf-popover-content.hidden {
  opacity: 0;
  visibility: hidden;
  transform: translate(0, 0px);
}

.lf-player-btn-container {
  display: flex;
  align-items: center;
}
.lf-player-btn {
  cursor: pointer;
  fill: #999;
  width: 14px;
}

.lf-player-btn.active {
  fill: #555;
}

.lf-popover {
  position: relative;
}

.lf-popover-content {
  display: inline-block;
  position: absolute;
  background-color: #ffffff;
  opacity: 1;

  transform: translate(0, -10px);
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
  transition: all 0.3s cubic-bezier(0.75, -0.02, 0.2, 0.97);
  padding: 10px;
}

.lf-popover-content.hidden {
  opacity: 0;
  visibility: hidden;
  transform: translate(0, 0px);
}

.lf-arrow {
  position: absolute;
  z-index: -1;
  content: '';
  bottom: -9px;
  border-style: solid;
  border-width: 10px 10px 0px 10px;
}

.lf-left-align,
.lf-left-align .lfarrow {
  left: 0;
  right: unset;
}

.lf-right-align,
.lf-right-align .lf-arrow {
  right: 0;
  left: unset;
}

.lf-text-input {
  border: 1px #ccc solid;
  border-radius: 5px;
  padding: 3px;
  width: 60px;
  margin: 0;
}

.lf-color-picker {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 90px;
}

.lf-color-selectors {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.lf-color-component {
  display: flex;
  flex-direction: row;
  font-size: 12px;
  align-items: center;
  justify-content: center;
}

.lf-color-component strong {
  width: 40px;
}

.lf-color-component input[type='range'] {
  margin: 0 0 0 10px;
}

.lf-color-component input[type='number'] {
  width: 50px;
  margin: 0 0 0 10px;
}

.lf-color-preview {
  font-size: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding-left: 5px;
}

.lf-preview {
  height: 60px;
  width: 60px;
}

.lf-popover-snapshot {
  width: 150px;
}
.lf-popover-snapshot h5 {
  margin: 5px 0 10px 0;
  font-size: 0.75rem;
}
.lf-popover-snapshot a {
  display: block;
  text-decoration: none;
}
.lf-popover-snapshot a:before {
  content: '⥼';
  margin-right: 5px;
}
.lf-popover-snapshot .lf-note {
  display: block;
  margin-top: 10px;
  color: #999;
}
.lf-player-controls > div {
  margin-right: 5px;
  margin-left: 5px;
}
.lf-player-controls > div:first-child {
  margin-left: 0px;
}
.lf-player-controls > div:last-child {
  margin-right: 0px;
}
`;
styleInject(css_248z);
var ColorPicker$1 = (function(t) {
  function r() {
    var n = t !== null && t.apply(this, arguments) || this;
    return n.state = { red: 0, green: 0, blue: 0, rgba: null, hex: "#000000", colorComponents: [] }, n.handleChange = function(a, s) {
      if (a === "r") {
        var o = "#" + (256 | s).toString(16).slice(1) + (256 | n.state.green).toString(16).slice(1) + (256 | n.state.blue).toString(16).slice(1);
        n.setState({ hex: o });
      } else a === "g" ? (o = "#" + (256 | n.state.red).toString(16).slice(1) + (256 | s).toString(16).slice(1) + (256 | n.state.blue).toString(16).slice(1), n.setState({ hex: o })) : a === "b" && (o = "#" + (256 | n.state.red).toString(16).slice(1) + (256 | n.state.green).toString(16).slice(1) + (256 | s).toString(16).slice(1), n.setState({ hex: o }));
    }, n.parseColor = function(a) {
      var s;
      if (typeof a == "string") {
        if (a[0] === "#") {
          var o = a.length === 4 ? [a.slice(1, 2), a.slice(2, 3), a.slice(3, 4)].map((function(l) {
            return parseInt("" + l + l, 16);
          })) : [a.slice(1, 3), a.slice(3, 5), a.slice(5, 7)].map((function(l) {
            return parseInt(l, 16);
          }));
          n.setState({ colorComponents: o });
        } else a.startsWith("rgb") && (o = (s = a.match(/\d+/g)) === null || s === void 0 ? void 0 : s.map((function(l) {
          return parseInt(l);
        }))) !== void 0 && n.setState({ colorComponents: o });
        n.state.colorComponents.length && (n.setState({ red: n.state.colorComponents[0] }), n.setState({ green: n.state.colorComponents[1] }), n.setState({ blue: n.state.colorComponents[2] }));
      }
    }, n;
  }
  return __extends$1(r, t), r.prototype.componentDidUpdate = function(n, a) {
    return this.props.colorChangedEvent && this.state.hex !== a.hex && this.props.colorChangedEvent(this.state.hex), !0;
  }, r.prototype.render = function() {
    var n = this;
    return React.createElement("div", { className: "lf-color-picker" }, React.createElement("div", { className: "lf-color-selectors" }, React.createElement("div", { className: "lf-color-component" }, React.createElement("strong", null, "Red"), React.createElement("input", { type: "range", min: "0", max: "255", value: this.state.red, onChange: function(a) {
      n.setState({ red: a.target.value }), n.handleChange("r", a.target.value);
    } }), React.createElement("input", { className: "lf-text-input", type: "number", min: "0", max: "255", value: this.state.red, onChange: function(a) {
      n.setState({ red: a.target.value }), n.handleChange("r", a.target.value);
    } })), React.createElement("div", { className: "lf-color-component" }, React.createElement("strong", null, "Green"), React.createElement("input", { type: "range", min: "0", max: "255", value: this.state.green, onChange: function(a) {
      n.setState({ green: a.target.value }), n.handleChange("g", a.target.value);
    } }), React.createElement("input", { className: "lf-text-input", type: "number", min: "0", max: "255", value: this.state.green, onChange: function(a) {
      n.setState({ green: a.target.value }), n.handleChange("g", a.target.value);
    } })), React.createElement("div", { className: "lf-color-component" }, React.createElement("strong", null, "Blue"), React.createElement("input", { type: "range", min: "0", max: "255", value: this.state.blue, onChange: function(a) {
      n.setState({ blue: a.target.value }), n.handleChange("b", a.target.value);
    } }), React.createElement("input", { className: "lf-text-input", type: "number", min: "0", max: "255", value: this.state.blue, onChange: function(a) {
      n.setState({ blue: a.target.value }), n.handleChange("b", a.target.value);
    } }))), React.createElement("div", { className: "lf-color-preview" }, React.createElement("div", { className: "lf-preview", style: { background: "rgb(" + this.state.red + ", " + this.state.green + ", " + this.state.blue + ")" } }), React.createElement("div", null, React.createElement("input", { className: "lf-text-input", type: "text", value: this.state.hex, onChange: function(a) {
      n.setState({ hex: a.target.value }), n.parseColor(a.target.value);
    } }))));
  }, r;
})(React.Component), Popover = function(t) {
  var r = t.children, n = t.icon, a = useState$1(null), s = a[0], o = a[1], l = useState$1(null), x = l[0], j = l[1], Z = useState$1(null), V = Z[0], $ = Z[1], X = useState$1(!1), W = X[0], Y = X[1];
  return useEffect((function() {
    if (s && x) {
      var U = s.getBoundingClientRect(), G = x.getBoundingClientRect(), K = U.left + G.width > window.innerWidth ? -1 : 0;
      $(K);
    }
  }), [V, x, s]), React.createElement("div", { className: "lf-popover", onMouseOver: function() {
    Y(!0);
  }, onMouseLeave: function() {
    Y(!1);
  }, ref: function(U) {
    o(U);
  } }, React.createElement("div", { className: " lf-player-btn" }, n), React.createElement("div", { className: "lf-popover-content", ref: function(U) {
    j(U);
  }, style: { bottom: "22px", right: "0px", zIndex: 2, visibility: W ? "visible" : "hidden" } }, r));
}, Seeker = (function(t) {
  function r(n) {
    var a = t.call(this, n) || this;
    return a.inputRef = React.createRef(), a.handleChange = function() {
      return function(s) {
        var o = s.target.value, l = Math.floor(o / 100 * a.props.max);
        a.props.onChange(l);
      };
    }, a.state = { value: 0 }, a;
  }
  return __extends$1(r, t), r.prototype.render = function() {
    var n = this.props.value / this.props.max * 100, a = { backgroundImage: "-webkit-gradient(linear, left top, right top, color-stop(" + n + "%, rgba(15, 204, 206, 0.4)), color-stop(" + n + "%, #DAE1E7))" }, s = { position: "absolute", left: 0, marginTop: "8px", width: "20px", display: "block", border: "0px", backgroundColor: this.props.darkTheme ? "#505050" : "rgb(218, 225, 231)", color: this.props.darkTheme ? "#B9B9B9" : "#555", padding: "2px", textAlign: "center", borderRadius: "3px", fontSize: "8px", fontWeight: "bold" }, o = { position: "absolute", right: 0, marginTop: "8px", width: "20px", display: "block", border: "0px", backgroundColor: this.props.darkTheme ? "#505050" : "rgb(218, 225, 231)", color: this.props.darkTheme ? "#B9B9B9" : "#555", padding: "2px", textAlign: "center", borderRadius: "3px", fontSize: "8px", fontWeight: "bold" };
    return React.createElement("div", { style: { display: "flex", flexDirection: "column", alignItems: "center", width: "100%", marginRight: "5px", marginLeft: "5px", position: "relative" } }, React.createElement("input", { ref: this.inputRef, id: "track", className: "lf-progress", name: "progress", "aria-label": "progress", type: "range", min: "0", max: "100", step: "0.1", value: n, onInput: this.handleChange(), onChange: this.handleChange(), style: a }), this.props.showLabels && React.createElement("div", { style: { display: "flex", justifyContent: "space-between" } }, React.createElement("div", { style: s }, this.props.min), React.createElement("div", { style: o }, this.props.max)));
  }, r;
})(React.Component), ControlButtonStyle = { display: "inline-flex", cursor: "pointer" };
(function(t) {
  function r(n) {
    var a = t.call(this, n) || this;
    return a.state = { activeFrame: 0, mouseDown: !1 }, a;
  }
  return __extends$1(r, t), r.prototype.render = function() {
    var n = this, a = this.props, s = a.instance, o = a.playerState, l = a.seeker, x = a.setLoop, j = a.setSeeker, Z = a.play, V = a.pause, $ = a.stop, X = a.visible, W = a.buttons;
    if (!s || !X) return null;
    var Y = !W || W.includes("play"), U = !W || W.includes("stop"), G = !W || W.includes("repeat"), K = !W || W.includes("frame"), J = !W || W.includes("background"), ee = !W || W.includes("snapshot"), te = { width: 14, height: 14, viewBox: "0 0 24 24" }, re = Math.round(s.currentFrame);
    return React.createElement("div", { className: "lf-player-controls", style: { display: "flex", justifyContent: "space-between", height: "60px", alignItems: "center", backgroundColor: this.props.transparentTheme ? "transparent" : this.props.darkTheme ? "#3C3C3C" : "#ffffff", paddingLeft: "10px", paddingRight: "10px" } }, Y && React.createElement("div", { role: "button", "aria-label": o === PlayerState.Playing ? PlayerEvent.Pause : PlayerEvent.Play, tabIndex: 0, onClick: function() {
      o === PlayerState.Playing ? typeof V == "function" && V() : typeof Z == "function" && Z();
    }, onKeyDown: function() {
      o === PlayerState.Playing ? typeof V == "function" && V() : typeof Z == "function" && Z();
    }, className: "lf-player-btn", style: ControlButtonStyle }, o === PlayerState.Playing ? React.createElement("svg", __assign$1({}, te), React.createElement("rect", { height: "22.9", rx: "1.9", width: "7.6", x: "14", y: ".5" }), React.createElement("rect", { height: "22.9", rx: "1.9", width: "7.6", x: "2", y: ".5" })) : React.createElement("svg", __assign$1({}, te), React.createElement("path", { d: "M2 3.4C2 1.9 3.5 1 4.8 1.8l16.5 9.6c1.2.7 1.2 2.5 0 3.2L4.8 24.2C3.5 25 2 24.1 2 22.6V3.4z" }))), U && React.createElement("div", { tabIndex: 0, role: "button", "aria-label": PlayerEvent.Stop, onClick: function() {
      return $ && $();
    }, onKeyDown: function() {
      return $ && $();
    }, className: o === PlayerState.Stopped ? "lf-player-btn active" : "lf-player-btn", style: ControlButtonStyle }, React.createElement("svg", __assign$1({}, te), React.createElement("path", { d: `M2 3.667A1.67 1.67 0 0 1 3.667 2h16.666A1.67 1.67 0 0 1 22 3.667v16.666A1.67 1.67 0 0 1 20.333
            22H3.667A1.67 1.67 0 0 1 2 20.333z` }))), React.createElement(Seeker, { min: 0, step: 1, max: s ? s.totalFrames : 1, value: l || 0, onChange: function(ae) {
      j && n.setState({ activeFrame: ae }, (function() {
        j(ae, !1);
      }));
    }, onChangeEnd: function(ae) {
      j && n.setState({ activeFrame: ae }, (function() {
        j(ae, !1);
      }));
    }, showLabels: this.props.showLabels, darkTheme: this.props.darkTheme }), K && React.createElement("div", { role: "button", className: "lf-player-btn-container" }, React.createElement("input", { style: { outline: "none", border: this.props.darkTheme ? "1px #505050 solid" : "1px #ccc solid", borderRadius: "3px", width: "40px", textAlign: "center", backgroundColor: this.props.darkTheme ? "#505050" : "#ffffff", color: this.props.darkTheme ? "#B9B9B9" : "#999", fontSize: "0.7rem", padding: "0", fontFamily: "inherit" }, type: "text", value: re, readOnly: !0 })), G && React.createElement("div", { role: "button", "aria-label": PlayerEvent.Loop, tabIndex: 0, onClick: function() {
      s && x && x(!s.loop);
    }, onKeyDown: function() {
      s && x && x(!s.loop);
    }, className: s.loop ? "lf-player-btn active" : "lf-player-btn", style: ControlButtonStyle }, React.createElement("svg", __assign$1({}, te), React.createElement("path", { d: `M12.5 16.8137h-.13v1.8939h4.9696c3.6455 0 6.6113-2.9658 6.6113-6.6116
            0-3.64549-2.9658-6.61131-6.6113-6.61131-.5231 0-.947.42391-.947.94696 0 .52304.4239.94696.947.94696 2.6011 0
            4.7174 2.11634 4.7174 4.71739 0 2.6014-2.1166 4.7177-4.7174 4.7177H12.5zM13.6025
            5.61469v-.13H7.48137C3.83582 5.48469.87 8.45051.87 12.096c0 3.6509 3.17269 6.6117 6.81304 6.6117.52304 0
            .94696-.424.94696-.947 0-.5231-.42392-.947-.94696-.947-2.60804 0-4.91907-2.1231-4.91907-4.7176 0-2.60115
            2.11634-4.71744 4.7174-4.71744h6.12113V5.61469z`, stroke: "#8795A1", strokeWidth: ".26" }), React.createElement("path", { d: `M11.1482
            2.20355h0l-.001-.00116c-.3412-.40061-.9405-.44558-1.33668-.0996h-.00001c-.39526.34519-.43936.94795-.09898
            1.34767l2.51487 3.03683-2.51894 3.06468c-.33872.40088-.29282 1.00363.10347
            1.34723l.08517-.0982-.08517.0982c.17853.1549.39807.2308.61647.2308.2671 0 .5328-.114.72-.3347h0l.0011-.0014
            3.0435-3.68655.0006-.00068c.3035-.35872.3025-.88754-.0019-1.24526l-3.0425-3.65786zM13.9453
            21.7965h0l.001.0011c.3413.4006.9407.4456 1.337.0996h0c.3953-.3452.4395-.9479.099-1.3477l-2.5154-3.0368
            2.5195-3.0647c.3388-.4008.2929-1.0036-.1035-1.3472l-.0852.0982.0852-.0982c-.1786-.1549-.3981-.2308-.6166-.2308-.2671
            0-.5329.114-.7202.3347h0l-.0011.0014-3.0442
            3.6865c-.0001.0003-.0003.0005-.0005.0007-.3036.3587-.3027.8876.0019 1.2453l3.0431 3.6579z`, fill: "#8795A1", stroke: "#8795A1", strokeWidth: ".26" }))), J && React.createElement(Popover, { icon: React.createElement("svg", __assign$1({}, te), React.createElement("path", { d: `M12 3.1L6.1 8.6a7.6 7.6 0 00-2.2 4 7.2 7.2 0 00.4 4.4 7.9 7.9 0 003 3.5 8.7 8.7 0 004.7 1.3c1.6 0
            3.2-.5 4.6-1.3s2.4-2 3-3.5a7.2 7.2 0 00.5-4.5 7.6 7.6 0 00-2.2-4L12 3.2zM12 0l7.5 7a9.8 9.8 0 013 5.1
            9.3 9.3 0 01-.6 5.8c-.9 1.8-2.2 3.3-4 4.4A11.2 11.2 0 0112 24a11.2 11.2 0
            01-6-1.7c-1.7-1-3-2.6-3.9-4.4a9.3 9.3 0 01-.6-5.8c.4-2 1.5-3.7 3-5L12 0zM6 14h12c0 1.5-.7 3-1.8 4s-2.6
            1.6-4.2 1.6S9 19 7.8 18s-1.7-2.5-1.7-4z` })) }, React.createElement("div", { slot: "content", className: "lf-popover popover-background" }, React.createElement(ColorPicker$1, { colorChangedEvent: this.props.colorChangedEvent }))), ee && React.createElement(Popover, { icon: React.createElement("svg", __assign$1({}, te), React.createElement("path", { clipRule: "evenodd", d: `M0 3.01A2.983 2.983 0 012.983.027H16.99a2.983 2.983 0 012.983 2.983v14.008a2.982 2.982 0 01-2.983
              2.983H2.983A2.983 2.983 0 010 17.018zm2.983-.941a.941.941 0 00-.942.94v14.01c0
              .52.422.94.942.94H16.99a.94.94 0 00.941-.94V3.008a.941.941 0 00-.94-.94H2.981z`, fillRule: "evenodd" }), React.createElement("path", { d: "M12.229 7.945l-2.07 4.598-2.586-2.605-2.414 2.758v2.146h9.656V11.93z" }), React.createElement("circle", { cx: "7.444", cy: "6.513", r: "2.032" }), React.createElement("path", { d: `M9.561 23.916h11.25a2.929 2.929 0 002.926-2.927V9.954a1.06 1.06 0 10-2.122 0v11.035a.805.805 0
              01-.803.804H9.562a1.061 1.061 0 100 2.123z`, stroke: "#8795a1", strokeWidth: ".215" })) }, React.createElement("div", { slot: "content", className: "lf-popover lf-popover-snapshot", onWheel: function(ae) {
      j && j(re + (ae.deltaY > 0 ? -1 : 1), !1);
    } }, React.createElement("h5", null, "Frame ", re), React.createElement("div", { style: { cursor: "pointer", color: "#0FCCCE" }, onClick: this.props.snapshot }, "Download SVG"), React.createElement("div", { style: { cursor: "pointer", color: "#0FCCCE" }, onClick: this.props.snapshot }, "Download PNG"), React.createElement("i", { className: "lf-note" }, "Scroll with mousewheel to find exact frame"))));
  }, r;
})(React.Component);
const v$1 = "4.8.0", meta = { g: "LottieFiles AE 3.4.5", a: "", k: "", d: "", tc: "" }, fr = 60, ip = 0, op = 180, w$1 = 400, h$1 = 400, nm = "Comp 1", ddd = 0, assets = [], layers = [{ ddd: 0, ind: 1, ty: 4, nm: "White", sr: 1, ks: { o: { a: 0, k: 100, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [200, 200, 0], ix: 2 }, a: { a: 0, k: [0, 0, 0], ix: 1 }, s: { a: 0, k: [100, 100, 100], ix: 6 } }, ao: 0, shapes: [{ ty: "gr", it: [{ d: 1, ty: "el", s: { a: 0, k: [193.48, 193.48], ix: 2 }, p: { a: 0, k: [0, 0], ix: 3 }, nm: "Контур эллипса 1", mn: "ADBE Vector Shape - Ellipse", hd: !1 }, { ty: "tm", s: { a: 1, k: [{ i: { x: [0.584], y: [1] }, o: { x: [0.166], y: [0] }, t: 0, s: [50.1] }, { i: { x: [0.833], y: [1] }, o: { x: [0.417], y: [0] }, t: 91, s: [91] }, { t: 179, s: [50.1] }], ix: 1 }, e: { a: 1, k: [{ i: { x: [0.584], y: [1] }, o: { x: [0.166], y: [0] }, t: 0, s: [49.9] }, { i: { x: [0.833], y: [1] }, o: { x: [0.417], y: [0] }, t: 91, s: [69.9] }, { t: 179, s: [49.9] }], ix: 2 }, o: { a: 1, k: [{ i: { x: [0.849], y: [0.886] }, o: { x: [0.218], y: [0.164] }, t: 0, s: [-180] }, { t: 179, s: [540] }], ix: 3 }, m: 1, ix: 2, nm: "Обрезать контуры 1", mn: "ADBE Vector Filter - Trim", hd: !1 }, { ty: "st", c: { a: 0, k: [1, 1, 1, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 32, ix: 5 }, lc: 2, lj: 2, bm: 0, nm: "Обводка 1", mn: "ADBE Vector Graphic - Stroke", hd: !1 }, { ty: "fl", c: { a: 0, k: [1, 1, 1, 1], ix: 4 }, o: { a: 0, k: 0, ix: 5 }, r: 1, bm: 0, nm: "Заливка 1", mn: "ADBE Vector Graphic - Fill", hd: !1 }, { ty: "tr", p: { a: 0, k: [-0.267, 3.317], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [165.707, 165.707], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: "Преобразовать" }], nm: "Эллипс 1", np: 4, cix: 2, bm: 0, ix: 1, mn: "ADBE Vector Group", hd: !1 }], ip: 0, op: 192, st: 0, bm: 0 }, { ddd: 0, ind: 2, ty: 4, nm: "blue", sr: 1, ks: { o: { a: 0, k: 100, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [200, 200, 0], ix: 2 }, a: { a: 0, k: [0, 0, 0], ix: 1 }, s: { a: 0, k: [100, 100, 100], ix: 6 } }, ao: 0, shapes: [{ ty: "gr", it: [{ d: 1, ty: "el", s: { a: 0, k: [193.48, 193.48], ix: 2 }, p: { a: 0, k: [0, 0], ix: 3 }, nm: "Контур эллипса 1", mn: "ADBE Vector Shape - Ellipse", hd: !1 }, { ty: "tm", s: { a: 1, k: [{ i: { x: [0.584], y: [1] }, o: { x: [0.166], y: [0] }, t: 0, s: [50.1] }, { i: { x: [0.833], y: [1] }, o: { x: [0.417], y: [0] }, t: 91, s: [85] }, { t: 179, s: [50.1] }], ix: 1 }, e: { a: 1, k: [{ i: { x: [0.584], y: [1.109] }, o: { x: [0.166], y: [0] }, t: 0, s: [49.9] }, { i: { x: [0.833], y: [1] }, o: { x: [0.417], y: [0.106] }, t: 91, s: [56.89] }, { t: 179, s: [49.9] }], ix: 2 }, o: { a: 1, k: [{ i: { x: [0.843], y: [0.941] }, o: { x: [0.2], y: [0.075] }, t: 0, s: [-540] }, { t: 179, s: [900] }], ix: 3 }, m: 1, ix: 2, nm: "Обрезать контуры 1", mn: "ADBE Vector Filter - Trim", hd: !1 }, { ty: "st", c: { a: 0, k: [0.223529413342, 0.329411774874, 0.815686285496, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 32, ix: 5 }, lc: 2, lj: 2, bm: 0, nm: "Обводка 1", mn: "ADBE Vector Graphic - Stroke", hd: !1 }, { ty: "fl", c: { a: 0, k: [1, 1, 1, 1], ix: 4 }, o: { a: 0, k: 0, ix: 5 }, r: 1, bm: 0, nm: "Заливка 1", mn: "ADBE Vector Graphic - Fill", hd: !1 }, { ty: "tr", p: { a: 0, k: [-0.267, 3.317], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [165.707, 165.707], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: "Преобразовать" }], nm: "Эллипс 1", np: 4, cix: 2, bm: 0, ix: 1, mn: "ADBE Vector Group", hd: !1 }], ip: 0, op: 197, st: 0, bm: 0 }, { ddd: 0, ind: 3, ty: 4, nm: "Dark", sr: 1, ks: { o: { a: 0, k: 100, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [200, 200, 0], ix: 2 }, a: { a: 0, k: [0, 0, 0], ix: 1 }, s: { a: 0, k: [100, 100, 100], ix: 6 } }, ao: 0, shapes: [{ ty: "gr", it: [{ d: 1, ty: "el", s: { a: 0, k: [193.48, 193.48], ix: 2 }, p: { a: 0, k: [0, 0], ix: 3 }, nm: "Контур эллипса 1", mn: "ADBE Vector Shape - Ellipse", hd: !1 }, { ty: "tm", s: { a: 1, k: [{ i: { x: [0.584], y: [1] }, o: { x: [0.166], y: [0] }, t: 0, s: [50.1] }, { i: { x: [0.833], y: [1] }, o: { x: [0.417], y: [0] }, t: 91, s: [70] }, { t: 179, s: [50.1] }], ix: 1 }, e: { a: 1, k: [{ i: { x: [0.584], y: [1] }, o: { x: [0.166], y: [0] }, t: 0, s: [49.9] }, { i: { x: [0.833], y: [1] }, o: { x: [0.417], y: [0] }, t: 91, s: [36.9] }, { t: 179, s: [49.9] }], ix: 2 }, o: { a: 1, k: [{ i: { x: [0.601], y: [0.735] }, o: { x: [0.194], y: [0.058] }, t: 0, s: [-900] }, { t: 179, s: [900] }], ix: 3 }, m: 1, ix: 2, nm: "Обрезать контуры 1", mn: "ADBE Vector Filter - Trim", hd: !1 }, { ty: "st", c: { a: 0, k: [0.156862750649, 0.168627455831, 0.192156866193, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 32, ix: 5 }, lc: 2, lj: 2, bm: 0, nm: "Обводка 1", mn: "ADBE Vector Graphic - Stroke", hd: !1 }, { ty: "fl", c: { a: 0, k: [1, 1, 1, 1], ix: 4 }, o: { a: 0, k: 0, ix: 5 }, r: 1, bm: 0, nm: "Заливка 1", mn: "ADBE Vector Graphic - Fill", hd: !1 }, { ty: "tr", p: { a: 0, k: [-0.267, 3.317], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [165.707, 165.707], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: "Преобразовать" }], nm: "Эллипс 1", np: 4, cix: 2, bm: 0, ix: 1, mn: "ADBE Vector Group", hd: !1 }], ip: 0, op: 182, st: 0, bm: 0 }, { ddd: 0, ind: 4, ty: 4, nm: "bg", sr: 1, ks: { o: { a: 0, k: 100, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [200, 200, 0], ix: 2 }, a: { a: 0, k: [0, 0, 0], ix: 1 }, s: { a: 0, k: [100, 100, 100], ix: 6 } }, ao: 0, shapes: [{ ty: "gr", it: [{ d: 1, ty: "el", s: { a: 0, k: [193.48, 193.48], ix: 2 }, p: { a: 0, k: [0, 0], ix: 3 }, nm: "Контур эллипса 1", mn: "ADBE Vector Shape - Ellipse", hd: !1 }, { ty: "st", c: { a: 0, k: [0.541176497936, 0.666666686535, 0.858823537827, 1], ix: 3 }, o: { a: 0, k: 35, ix: 4 }, w: { a: 0, k: 38, ix: 5 }, lc: 2, lj: 2, bm: 0, nm: "Обводка 1", mn: "ADBE Vector Graphic - Stroke", hd: !1 }, { ty: "fl", c: { a: 0, k: [1, 1, 1, 1], ix: 4 }, o: { a: 0, k: 0, ix: 5 }, r: 1, bm: 0, nm: "Заливка 1", mn: "ADBE Vector Graphic - Fill", hd: !1 }, { ty: "tr", p: { a: 0, k: [-0.267, 3.317], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [165.707, 165.707], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: "Преобразовать" }], nm: "Эллипс 1", np: 3, cix: 2, bm: 0, ix: 1, mn: "ADBE Vector Group", hd: !1 }], ip: 0, op: 208, st: 0, bm: 0 }], markers = [], loaderSrc = {
  v: v$1,
  meta,
  fr,
  ip,
  op,
  w: w$1,
  h: h$1,
  nm,
  ddd,
  assets,
  layers,
  markers
}, loaderSizeClassNames = {
  s: "go-loader__icon_size_s",
  m: "go-loader__icon_size_m",
  l: "go-loader__icon_size_l"
}, LoaderIcon = ({ size: t = "m", className: r, style: n }) => /* @__PURE__ */ jsx("div", { className: clsx(r, "go-loader__icon", loaderSizeClassNames[t]), style: n, children: /* @__PURE__ */ jsx(Player, { src: loaderSrc, autoplay: !0, loop: !0, renderer: "svg", speed: 1 }) }), Loader = ({ size: t = "m", className: r, style: n }) => /* @__PURE__ */ jsx("div", { className: clsx(r, "go-loader"), style: n, children: /* @__PURE__ */ jsx(LoaderIcon, { size: t }) });
function getIcons({
  suffixIcon: t,
  clearIcon: r,
  menuItemSelectedIcon: n,
  removeIcon: a,
  loading: s,
  multiple: o,
  hasFeedback: l,
  prefixCls: x,
  showArrow: j,
  feedbackIcon: Z
}) {
  const V = r != null ? r : /* @__PURE__ */ jsx(CloseMiniLine, {}), $ = (U) => /* @__PURE__ */ jsxs(Fragment, { children: [
    U,
    l && Z
  ] });
  let X = null;
  if (t !== void 0)
    X = $(t);
  else if (s)
    X = $(/* @__PURE__ */ jsx(LoaderIcon, { size: "s" }));
  else {
    const U = `${x}-suffix`;
    X = ({ open: G, showSearch: K }) => $(G && K ? /* @__PURE__ */ jsx(SearchLight, { className: U }) : /* @__PURE__ */ jsx(ArrowDropDown, { className: U }));
  }
  let W = null;
  n !== void 0 ? W = n : o ? W = /* @__PURE__ */ jsx(DoneRoundLight, {}) : W = null;
  let Y = null;
  return a !== void 0 ? Y = a : Y = /* @__PURE__ */ jsx(CloseMiniLine, {}), {
    clearIcon: V,
    suffixIcon: X,
    itemIcon: W,
    removeIcon: Y
  };
}
const inputSizeClassNames$1 = {
  s: "go-select_size_s",
  m: "go-select_size_m"
}, statusClassNames$3 = {
  error: "go-select-status-error"
}, prefixCls = "go-select";
function naturalSort(t) {
  return [...t].sort((r, n) => {
    var x, j;
    const a = typeof r.label == "string" ? r.label : ((x = r.label) == null ? void 0 : x.toString()) || "", s = typeof n.label == "string" ? n.label : ((j = n.label) == null ? void 0 : j.toString()) || "", o = a.split(/(\d+)/).filter(Boolean), l = s.split(/(\d+)/).filter(Boolean);
    for (let Z = 0; Z < Math.min(o.length, l.length); Z++)
      if (!isNaN(Number(o[Z])) && !isNaN(Number(l[Z]))) {
        const V = parseInt(o[Z], 10) - parseInt(l[Z], 10);
        if (V !== 0)
          return V;
      } else {
        const V = o[Z].localeCompare(l[Z], void 0, { sensitivity: "base" });
        if (V !== 0)
          return V;
      }
    return o.length - l.length;
  });
}
const InternalSelect = ({
  className: t,
  getPopupContainer: r,
  popupClassName: n,
  listHeight: a = 256,
  placement: s,
  listItemHeight: o = 24,
  size: l,
  disabled: x,
  notFoundContent: j,
  status: Z,
  virtual: V,
  mode: $,
  sortOptions: X,
  options: W,
  maxTagPlaceholder: Y,
  ...U
}, G) => {
  const K = useContext(ConfigContext), J = $ === "multiple" || $ === "tags", { size: ee } = useGlobalComponentConfig({ size: l }), { suffixIcon: te, itemIcon: re, removeIcon: ae, clearIcon: ie } = getIcons({
    ...U,
    multiple: J,
    showArrow: !0,
    prefixCls: "go-icon"
  }), ce = useMemo$1(() => {
    if (!(W != null && W.length))
      return W;
    const de = !hasValue(U.value) || Array.isArray(U.value) && !U.value.length ? [] : Array.isArray(U.value) ? U.value : (() => {
      if (["string", "number"].includes(typeof U.value))
        return [U.value];
      if (typeof U.value == "object" && "value" in U.value)
        return [U.value.value];
    })();
    if (J) {
      const { selectedOptions: se, unSelectedOptions: ue } = de != null && de.length ? W.reduce(
        (fe, ge) => (de.includes(ge.value) ? fe.selectedOptions.push(ge) : fe.unSelectedOptions.push(ge), fe),
        { selectedOptions: [], unSelectedOptions: [] }
      ) : { selectedOptions: [], unSelectedOptions: W };
      return X ? [...naturalSort([...se]), ...naturalSort([...ue])] : [...se, ...ue];
    } else
      return X ? naturalSort(W) : W;
  }, [X, W, U.value, J]), he = omit(U, ["suffixIcon", "itemIcon"]), oe = clsx("go-select", inputSizeClassNames$1[ee], Z && statusClassNames$3[Z], t), le = useCallback(
    (de) => Y === void 0 ? /* @__PURE__ */ jsxs("span", { children: [
      "+",
      de.length
    ] }) : typeof Y == "function" ? Y(de) : Y,
    [Y]
  ), pe = useMemo$1(() => {
    if (r)
      return r;
    if (K.rootElement)
      return () => K.rootElement;
  }, [r, K.rootElement]);
  return /* @__PURE__ */ jsx(
    TypedSelect,
    {
      ref: G,
      virtual: V,
      dropdownMatchSelectWidth: !0,
      options: ce,
      ...he,
      listHeight: a,
      listItemHeight: o,
      mode: $,
      prefixCls,
      placement: s != null ? s : "bottomLeft",
      suffixIcon: te,
      menuItemSelectedIcon: re,
      removeIcon: ae,
      allowClear: he.allowClear && { clearIcon: ie },
      notFoundContent: j,
      className: oe,
      getPopupContainer: pe,
      dropdownClassName: clsx(
        K.theme === "dark" && "go-theme_dark",
        K.theme === "light" && "go-theme_light",
        n
      ),
      disabled: x,
      maxTagPlaceholder: le
    }
  );
}, Select = forwardRef(InternalSelect);
Select.Option = Option;
Select.OptGroup = OptGroup;
const InternalAutoComplete = (t, r) => {
  const { className: n, popupClassName: a, children: s } = t, o = toArray$3(s);
  let l;
  o.length === 1 && isValidElement(o[0]) && ([l] = o);
  const x = l ? () => l : void 0;
  return /* @__PURE__ */ jsx(
    Select,
    {
      ref: r,
      ...t,
      popupClassName: a,
      className: clsx("go-select-auto-complete", n),
      mode: "combobox",
      // Internal api
      getInputElement: x
    }
  );
}, AutoComplete = forwardRef(InternalAutoComplete), buttonVariantStyles = {
  primary: "go-button_variant_primary",
  secondary: "go-button_variant_secondary",
  flat: "go-button_variant_flat",
  danger: "go-button_variant_danger",
  success: "go-button_variant_success"
}, buttonSizeStyles = {
  s: "go-button_size_s",
  m: "go-button_size_m"
}, iconPositionClassNames = {
  before: "go-button_icon-position_before",
  after: "go-button_icon-position_after"
}, Button = forwardRef(
  ({
    variant: t = "primary",
    size: r,
    className: n,
    type: a,
    title: s,
    icon: o,
    iconPosition: l = "before",
    style: x,
    disabled: j,
    loading: Z = !1,
    children: V,
    onPointerDown: $,
    onPointerUp: X,
    onClick: W
  }, Y) => {
    const { size: U } = useGlobalComponentConfig({ size: r });
    return /* @__PURE__ */ jsxs(
      "button",
      {
        ref: Y,
        className: clsx(
          n,
          "go-button",
          buttonVariantStyles[t],
          buttonSizeStyles[U],
          iconPositionClassNames[l],
          Z && "go-button_loading",
          !V && "go-button_without-content"
        ),
        title: s,
        type: a,
        disabled: j,
        style: x,
        onClick: W,
        onPointerDown: $,
        onPointerUp: X,
        children: [
          (!!o || Z) && /* @__PURE__ */ jsx("div", { className: "go-button__icon-wrapper", children: Z ? /* @__PURE__ */ jsx(LoaderIcon, {}) : o }),
          !!V && /* @__PURE__ */ jsx("div", { className: "go-button__inner", children: V })
        ]
      }
    );
  }
);
Button.displayName = "Button";
const CLICK_DISTANCE_SQUARED = Math.pow(15, 2);
function useScroll({ element: t, scrollDistance: r = 40, onMove: n, onMoveEnd: a, onScroll: s }) {
  const o = useRef({ x: 0, y: 0 }), l = useRef(0), x = useRef(null), j = useRef(null), Z = useRef(!1), V = useCallback(
    (Y) => {
      t && (x.current = {
        id: Y.pointerId,
        coordinate: {
          x: Y.clientX,
          y: Y.clientY
        }
      }, Z.current = !1);
    },
    [t]
  ), $ = useCallback(
    (Y) => {
      const U = x.current;
      !t || !U || (j.current !== null && cancelAnimationFrame(j.current), j.current = requestAnimationFrame(() => {
        t.setPointerCapture(Y.pointerId);
        const G = U.coordinate.x, K = Y.clientX, J = K - G, ee = U.coordinate.y, te = Y.clientY, re = ee - te;
        if (o.current = {
          x: o.current.x + J,
          y: o.current.y + re
        }, Math.pow(o.current.x, 2) + Math.pow(o.current.y, 2) < CLICK_DISTANCE_SQUARED && !Z.current) {
          t.releasePointerCapture(Y.pointerId);
          return;
        }
        Z.current = !0, n == null || n({ x: J, y: re }, { ...o.current }), x.current = {
          id: Y.pointerId,
          coordinate: {
            x: K,
            y: te
          }
        };
      }));
    },
    [t, n]
  ), X = useCallback(() => {
    j.current !== null && cancelAnimationFrame(j.current), x.current = null, o.current = { x: 0, y: 0 }, Z.current = !1, j.current = requestAnimationFrame(() => {
      a == null || a();
    });
  }, [a]), W = useCallback(
    (Y) => {
      Y.preventDefault(), !Z.current && (j.current !== null && cancelAnimationFrame(j.current), j.current = requestAnimationFrame(() => {
        l.current += Y.deltaY, Math.abs(l.current) > Math.abs(r) && (s == null || s(Y.deltaY, l.current), l.current = 0);
      }));
    },
    [s, r]
  );
  useEffect(() => {
    if (t)
      return t.addEventListener("pointerdown", V), t.addEventListener("pointermove", $), t.addEventListener("pointerup", X), t.addEventListener("pointercancel", X), t.addEventListener("wheel", W, { passive: !1 }), () => {
        t.removeEventListener("pointerdown", V), t.removeEventListener("pointermove", $), t.removeEventListener("pointerup", X), t.removeEventListener("pointercancel", X), t.removeEventListener("wheel", W);
      };
  }, [t, V, $, X, W]);
}
const getRemainingTime = (t, r) => {
  const n = Date.now() - t, a = r - n;
  return a < 0 ? 0 : a;
};
function useThrottledFn(t, r) {
  const n = useRef(Date.now()), a = useRef(null), s = useCallback(() => {
    a.current && (clearTimeout(a.current), a.current = null);
  }, []), o = useCallback(
    (...l) => {
      let x = getRemainingTime(n.current, r);
      x === 0 ? (n.current = Date.now(), t(...l), s()) : a.current || (a.current = setTimeout(() => {
        x = getRemainingTime(n.current, r), x === 0 && (n.current = Date.now(), t(...l), s());
      }, x));
    },
    [t, s, r]
  );
  return useEffect(() => s, [s]), o;
}
const NUMBER_OF_WEEKS_ON_PAGE = 6, YEARS_IN_ROW = 4, DEFAULT_CALENDAR_CONFIG = {
  weekRowHeight: 24
}, DEFAULT_YEARS_CALENDAR_CONFIG = {
  rowHeight: 40,
  numberOfYearsInRow: 3,
  numberOfRows: 5
};
function numberRangeMap(t, r, n) {
  const a = [];
  for (let s = t; s <= r; s++)
    a.push(n(s));
  return a;
}
function numberRange(t, r) {
  const n = [];
  for (let a = t; a <= r; a++)
    n.push(a);
  return n;
}
function getCalendarYearPage() {
  return {
    months: numberRangeMap(0, 11, (t) => ({
      key: t.toString(),
      value: t
    }))
  };
}
function getYears(t, r) {
  return numberRange(t, t + r - 1);
}
function getTimeOptions() {
  return {
    hours: numberRangeMap(0, 23, (t) => ({
      key: t.toString(),
      value: t
    })),
    minutes: numberRangeMap(0, 59, (t) => ({
      key: t.toString(),
      value: t
    }))
  };
}
function isSelectedDate(t, r) {
  return r === null ? !1 : isSameDay(t, r);
}
function extractTime(t) {
  return {
    hours: getHours(t),
    minutes: getMinutes(t)
  };
}
function applyTime(t, r, n) {
  let a = t;
  return r !== null && (a = setHours(a, r)), n !== null && (a = setMinutes(a, n)), a;
}
function applyTimeV2(t, r, n) {
  let a = t;
  return r !== null && (a = setHours(a, r).getTime()), n !== null && (a = setMinutes(a, n).getTime()), a;
}
function isActiveMonth(t, r) {
  return t === getMonth(r);
}
function getWeeks(t, r) {
  const n = startOfWeek(sub$1(t, { weeks: 6 }), { locale: r }), a = add$1(t, { weeks: 10 });
  return eachDayOfInterval({ start: n, end: a }, { step: 7 }).map((s) => s.getTime());
}
function getStartOfMonth(t, r) {
  const n = new Date(r, t), a = isNaN(n.getTime()) ? /* @__PURE__ */ new Date() : n;
  return startOfMonth(a).getTime();
}
function getViewportByDate(t, r, n, a) {
  const s = startOfWeek(startOfMonth(t), { locale: a });
  return differenceInWeeks(s, r, { roundingMethod: "round" }) * n;
}
function getViewportPoint(t, r, n) {
  return differenceInWeeks(t, r, { roundingMethod: "round" }) * n;
}
function getStartOfYearRow(t, r, n) {
  const a = (r - t) / n;
  return t + Math.floor(a) * n;
}
function getYearRowStartPoints(t, r, n) {
  const a = [];
  let s = 0, o = t;
  for (; o <= r; )
    a.push(o), s += 1, o = t + s * n;
  return a;
}
const CalendarDate = ({ value: t, onClick: r, isSelected: n, isActive: a, disabled: s }) => {
  var l;
  const { localization: o } = useContext(ConfigContext);
  return /* @__PURE__ */ jsx(
    "button",
    {
      disabled: s,
      className: clsx(
        "go-calendar__date",
        isWeekend(t) && "go-calendar__date_weekend",
        n && "go-calendar__date_selected",
        a && "go-calendar__date_in-view"
      ),
      onClick: r,
      children: /* @__PURE__ */ jsx("span", { className: "go-calendar__date-inner", children: format(t, "d", { locale: (l = o == null ? void 0 : o.calendar) == null ? void 0 : l.locale }) })
    }
  );
}, Week = forwardRef(function t({ weekStart: r, month: n, selectedDate: a, isDateDisabled: s, onDateChange: o, config: l, onUnmount: x }, j) {
  var $;
  const { localization: Z } = useContext(ConfigContext), V = useMemo$1(() => {
    var Y, U;
    const X = startOfWeek(toDate(r), { locale: (Y = Z == null ? void 0 : Z.calendar) == null ? void 0 : Y.locale }), W = endOfWeek(X, { locale: (U = Z == null ? void 0 : Z.calendar) == null ? void 0 : U.locale });
    return eachDayOfInterval({ start: X, end: W });
  }, [($ = Z == null ? void 0 : Z.calendar) == null ? void 0 : $.locale, r]);
  return useEffect(() => () => x(r), [x, r]), /* @__PURE__ */ jsx(
    "div",
    {
      ref: j,
      id: `${format(r, "dd.MM.yyyy")}`,
      className: "go-calendar__week-row",
      style: { height: `${l.weekRowHeight}px` },
      children: V.map((X) => {
        var W;
        return /* @__PURE__ */ jsx(
          CalendarDate,
          {
            value: X,
            onClick: () => o(X),
            isSelected: isSelectedDate(X, a),
            isActive: isActiveMonth(n, X),
            disabled: (W = s == null ? void 0 : s(X)) != null ? W : !1
          },
          X.getTime().toString()
        );
      })
    }
  );
});
function moveWeekRows$1(t, r, n, a) {
  for (const [s, o] of t) {
    const l = getViewportPoint(s, r, a);
    o.style.transform = `translateY(${l - n}px)`;
  }
}
const CalendarDates = ({
  month: t,
  year: r,
  selectedDate: n,
  config: a,
  onDateChange: s,
  onMonthChange: o,
  isDateDisabled: l
}) => {
  var oe, le;
  const { localization: x } = useContext(ConfigContext), j = (oe = x == null ? void 0 : x.calendar) == null ? void 0 : oe.locale, Z = useRef(startOfWeek(startOfMonth(/* @__PURE__ */ new Date()), { locale: j })), [V, $] = useState$1(() => getStartOfMonth(t, r));
  useEffect(() => $(getStartOfMonth(t, r)), [t, r]);
  const [X, W] = useState$1(() => getWeeks(V, j));
  useEffect(() => W(getWeeks(V, j)), [j, V]);
  const Y = useRef(/* @__PURE__ */ new Map()), U = useRef(null), G = useRef(
    // eslint-disable-next-line react-hooks/refs
    getViewportByDate(V, Z.current, a.weekRowHeight, j)
  ), K = useRef(null), [J, ee] = useState$1(!1);
  useEffect(() => {
    var se;
    if (J)
      return;
    const pe = G.current, de = getViewportByDate(V, Z.current, a.weekRowHeight, j);
    (se = K.current) == null || se.call(K), K.current = animate(
      pe,
      de,
      (ue) => {
        G.current = ue, moveWeekRows$1(Y.current, Z.current, ue, a.weekRowHeight);
      },
      (ue) => G.current = ue
    );
  }, [a.weekRowHeight, V, J, j]);
  const te = useCallback(
    ({ y: pe }) => {
      ee(!0), G.current += pe;
      const de = Math.ceil(G.current / a.weekRowHeight), se = startOfWeek(
        // Add (NUMBER_OF_WEEKS_ON_PAGE / 2) weeks to switch months in header when month is half displayed.
        startOfMonth(add$1(Z.current, { weeks: de + NUMBER_OF_WEEKS_ON_PAGE / 2 })),
        {
          locale: j
        }
      );
      moveWeekRows$1(Y.current, Z.current, G.current, a.weekRowHeight);
      const ue = endOfWeek(se, { locale: j }), fe = getMonth(ue), ge = getYear(ue);
      $(getStartOfMonth(getMonth(ue), getYear(ue))), o(fe, ge);
    },
    [a.weekRowHeight, j, o]
  ), re = useCallback(() => {
    ee(!1);
  }, []), ae = useThrottledFn((pe) => {
    const de = pe > 0 ? 1 : -1, se = startOfWeek(startOfMonth(add$1(V, { months: 1 * de })), {
      locale: j
    }).getTime();
    if (Y.current.get(se)) {
      const fe = endOfWeek(se, { locale: j });
      o(getMonth(fe), getYear(fe));
    }
  }, 300);
  useScroll({
    // eslint-disable-next-line react-hooks/refs
    element: (le = U.current) != null ? le : null,
    onMove: te,
    onMoveEnd: re,
    onScroll: ae
  });
  const ie = (pe, de) => {
    if (pe !== null) {
      Y.current.set(de, pe);
      const se = G.current, ue = getViewportPoint(de, Z.current, a.weekRowHeight);
      pe.style.transform = `translateY(${ue - se}px)`;
    }
  }, ce = useCallback((pe) => {
    Y.current.delete(pe);
  }, []), he = useMemo$1(() => eachDayOfInterval({
    start: startOfWeek(V, { locale: j }),
    end: endOfWeek(V, { locale: j })
  }), [V, j]);
  return /* @__PURE__ */ jsxs("div", { className: "go-calendar__dates-container", children: [
    /* @__PURE__ */ jsx("div", { className: "go-calendar__week-days-row", children: he.map((pe) => /* @__PURE__ */ jsx(
      "div",
      {
        className: clsx("go-calendar__week-day", isWeekend(pe) && "go-calendar__date_weekend"),
        children: /* @__PURE__ */ jsx("span", { className: "go-calendar__week-day-inner", children: format(pe, "cccccc", { locale: j }) })
      },
      pe.getTime().toString()
    )) }),
    /* @__PURE__ */ jsx("div", { ref: U, className: "go-calendar__dates", children: X.map((pe) => /* @__PURE__ */ jsx(
      Week,
      {
        ref: (de) => ie(de, pe),
        onUnmount: ce,
        selectedDate: n,
        month: t,
        weekStart: pe,
        config: a,
        onDateChange: s,
        isDateDisabled: l
      },
      pe.toString()
    )) })
  ] });
}, CalendarMonthPage = ({
  month: t,
  year: r,
  selectedDate: n,
  config: a,
  onDateChange: s,
  onMonthChange: o,
  isDateDisabled: l
}) => /* @__PURE__ */ jsx("div", { className: "go-calendar__month-page", children: /* @__PURE__ */ jsx(
  CalendarDates,
  {
    month: t,
    year: r,
    selectedDate: n,
    config: a,
    onDateChange: s,
    onMonthChange: o,
    isDateDisabled: l
  }
) }), yearPage = getCalendarYearPage(), CalendarMonths = ({ selectedMonth: t, onChange: r }) => {
  const { localization: n } = useContext(ConfigContext);
  return /* @__PURE__ */ jsx("div", { className: "go-calendar__month-container", children: yearPage.months.map((a) => {
    var s;
    return /* @__PURE__ */ jsx(
      "button",
      {
        className: clsx("go-calendar__month", t === a.value && "go-calendar__month_selected"),
        onClick: () => r(a.value),
        children: /* @__PURE__ */ jsx("span", { className: "go-calendar__month-inner", children: format(setMonth(/* @__PURE__ */ new Date(), a.value), "LLLL", { locale: (s = n == null ? void 0 : n.calendar) == null ? void 0 : s.locale }) })
      },
      a.key
    );
  }) });
}, CalendarYear = forwardRef(function t({ value: r, isSelected: n, onClick: a, onUnmount: s }, o) {
  return useEffect(() => () => s(r), [s, r]), /* @__PURE__ */ jsx(
    "button",
    {
      ref: o,
      onClick: a,
      className: clsx("go-calendar__year", n && "go-calendar__year_selected"),
      style: { width: `${100 / YEARS_IN_ROW}%` },
      children: /* @__PURE__ */ jsx("span", { className: "go-calendar__year-inner", children: r })
    }
  );
});
function normalizeViewport(t) {
  const r = t % 100;
  return Math.abs(r) <= 50 ? t - r : t >= 0 ? t + (100 - r) : t - (100 + r);
}
function moveYears(t, r, n) {
  for (const [a, s] of t) {
    const o = (a - r) * 100;
    s.style.transform = `translateX(${o - n}%)`;
  }
}
const CalendarYears = ({ selectedYear: t, onChange: r }) => {
  const n = useRef(null), a = useRef(t != null ? t : getYear(/* @__PURE__ */ new Date())), s = useRef(0), o = useRef(/* @__PURE__ */ new Map()), l = useRef(null), [x, j] = useState$1(() => getYears(a.current - YEARS_IN_ROW * 2, YEARS_IN_ROW * 4)), [Z, V] = useState$1(null);
  useEffect(() => {
    const J = n.current;
    if (J) {
      const ee = new IntersectionObserver((te) => {
        const re = te.at(0);
        re && V(re.boundingClientRect);
      });
      return ee.observe(J), () => ee.unobserve(J);
    }
  }, []);
  const $ = useThrottledFn(() => {
    var ae;
    if (!Z)
      return;
    const J = s.current, te = a.current + normalizeViewport(s.current) / 100 - YEARS_IN_ROW, re = (te - a.current) * 100;
    j(getYears(te - YEARS_IN_ROW * 2, YEARS_IN_ROW * 4)), (ae = l.current) == null || ae.call(l), l.current = animate(
      J,
      re,
      (ie) => {
        s.current = ie, moveYears(o.current, a.current, ie);
      },
      (ie) => {
        s.current = normalizeViewport(ie);
      }
    );
  }, 200), X = useThrottledFn(() => {
    var ae;
    if (!Z)
      return;
    const J = s.current, te = a.current + normalizeViewport(s.current) / 100 + YEARS_IN_ROW, re = (te - a.current) * 100;
    j(getYears(te - YEARS_IN_ROW * 2, YEARS_IN_ROW * 4)), (ae = l.current) == null || ae.call(l), l.current = animate(
      J,
      re,
      (ie) => {
        s.current = ie, moveYears(o.current, a.current, ie);
      },
      (ie) => {
        s.current = normalizeViewport(ie);
      }
    );
  }, 200), W = useCallback(
    ({ x: J }) => {
      if (!Z || J === 0)
        return;
      const ee = Z.width * J / 100;
      s.current -= ee;
      const re = a.current + normalizeViewport(s.current) / 100 - YEARS_IN_ROW;
      j(getYears(re - YEARS_IN_ROW, YEARS_IN_ROW * 4)), moveYears(o.current, a.current, s.current);
    },
    [Z]
  ), Y = useCallback(() => {
    var te;
    const J = s.current, ee = normalizeViewport(s.current);
    (te = l.current) == null || te.call(l), l.current = animate(
      J,
      ee,
      (re) => {
        s.current = re, moveYears(o.current, a.current, re);
      },
      (re) => {
        s.current = re;
      }
    );
  }, []), U = useThrottledFn((J) => {
    var ce;
    const ee = J > 0 ? 1 : -1, te = s.current, ae = a.current + normalizeViewport(s.current) / 100 + YEARS_IN_ROW * ee, ie = (ae - a.current) * 100;
    j(getYears(ae - YEARS_IN_ROW * 2, YEARS_IN_ROW * 4)), (ce = l.current) == null || ce.call(l), l.current = animate(
      te,
      ie,
      (he) => {
        s.current = he, moveYears(o.current, a.current, he);
      },
      (he) => {
        s.current = normalizeViewport(he);
      }
    );
  }, 200);
  useScroll({
    // eslint-disable-next-line react-hooks/refs
    element: n.current,
    onMove: W,
    onMoveEnd: Y,
    onScroll: U
  }), useEffect(() => {
    var J;
    return (J = l.current) == null ? void 0 : J.call(l);
  }, []);
  const G = (J, ee) => {
    if (J !== null) {
      o.current.set(ee, J);
      const te = (ee - a.current) * 100;
      J.style.transform = `translateX(${te - s.current}%)`;
    }
  }, K = useCallback((J) => {
    o.current.delete(J);
  }, []);
  return /* @__PURE__ */ jsxs("div", { className: "go-calendar__years", children: [
    /* @__PURE__ */ jsx("button", { className: "go-calendar__header-navigation-button", onClick: $, children: /* @__PURE__ */ jsx(ArrowLeftLight, {}) }),
    /* @__PURE__ */ jsx("div", { ref: n, className: "go-calendar__years-container", children: x.map((J) => /* @__PURE__ */ jsx(
      CalendarYear,
      {
        ref: (ee) => G(ee, J),
        value: J,
        isSelected: J === t,
        onClick: () => r(J),
        onUnmount: K
      },
      J.toString()
    )) }),
    /* @__PURE__ */ jsx("button", { className: "go-calendar__header-navigation-button", onClick: X, children: /* @__PURE__ */ jsx(ArrowRightLight, {}) })
  ] });
}, CalendarYearPage = ({ month: t, year: r, onMonthChange: n, onYearChange: a }) => /* @__PURE__ */ jsxs("div", { className: "go-calendar__year-page", children: [
  /* @__PURE__ */ jsx(CalendarYears, { selectedYear: r, onChange: a }),
  /* @__PURE__ */ jsx(CalendarMonths, { selectedMonth: t, onChange: n })
] });
function exhaustiveCheck(t) {
  throw new Error(`Unreachable case: ${t}`);
}
const initialState = {
  mode: "month",
  hours: null,
  minutes: null,
  month: getMonth(/* @__PURE__ */ new Date()),
  year: getYear(/* @__PURE__ */ new Date())
};
function initStore(t, r, n, a, s) {
  var l;
  const o = (l = r != null ? r : a) != null ? l : n;
  if (s === "year")
    return {
      ...t,
      mode: s,
      year: o && getYear(o),
      month: o && getMonth(o),
      hours: o && getHours(o),
      minutes: o && getMinutes(o)
    };
  if (s === "month") {
    const x = /* @__PURE__ */ new Date();
    return {
      ...t,
      mode: s,
      year: o ? getYear(o) : getYear(x),
      month: o ? getMonth(o) : getMonth(x),
      hours: o && getHours(o),
      minutes: o && getMinutes(o)
    };
  }
  if (s === "years")
    return t;
  exhaustiveCheck(s);
}
function reducer(t, r) {
  var n, a, s, o;
  if (r.type === "SET_MINUTES")
    return {
      ...t,
      minutes: r.payload
    };
  if (r.type === "SET_HOURS")
    return {
      ...t,
      hours: r.payload
    };
  if (r.type === "SET_MONTH")
    return {
      ...t,
      mode: "month",
      month: r.payload.month,
      year: (a = (n = r.payload.year) != null ? n : t.year) != null ? a : getYear(/* @__PURE__ */ new Date())
    };
  if (r.type === "SET_YEAR")
    return {
      ...t,
      year: r.payload
    };
  if (r.type === "SET_DATE") {
    const { hours: l, minutes: x } = extractTime(r.payload);
    return {
      ...t,
      hours: l,
      minutes: x,
      month: getMonth(r.payload),
      year: getYear(r.payload)
    };
  }
  return r.type === "TOGGLE_MODE" ? t.mode === r.payload ? t : r.payload === "year" || !r.payload && t.mode === "month" ? {
    ...t,
    mode: "year"
  } : r.payload === "month" || !r.payload && t.mode === "year" ? {
    ...t,
    mode: "month",
    year: (s = t.year) != null ? s : getYear(/* @__PURE__ */ new Date()),
    month: (o = t.month) != null ? o : getMonth(/* @__PURE__ */ new Date())
  } : t : t;
}
const CalendarHeader = ({ month: t, year: r, mode: n, onChange: a, onTitleClick: s }) => {
  var Z, V;
  const { localization: o } = useContext(ConfigContext), l = new Date(r, t), x = useThrottledFn(() => {
    const $ = sub$1(l, { months: 1 });
    a(getMonth($), getYear($));
  }, 300), j = useThrottledFn(() => {
    const $ = add$1(l, { months: 1 });
    a(getMonth($), getYear($));
  }, 300);
  return /* @__PURE__ */ jsxs("div", { className: "go-calendar__header", children: [
    n === "month" && /* @__PURE__ */ jsx("button", { className: "go-calendar__header-navigation-button", onClick: x, tabIndex: -1, children: /* @__PURE__ */ jsx(ArrowLeftLight, {}) }),
    /* @__PURE__ */ jsxs("button", { className: "go-calendar__header-title", onClick: s, children: [
      /* @__PURE__ */ jsx("span", { className: "go-calendar__header-month", children: format(l, "LLLL", { locale: (Z = o == null ? void 0 : o.calendar) == null ? void 0 : Z.locale }) }),
      /* @__PURE__ */ jsx("span", { className: "go-calendar__header-year", children: format(l, "yyyy", { locale: (V = o == null ? void 0 : o.calendar) == null ? void 0 : V.locale }) }),
      /* @__PURE__ */ jsx(
        ArrowDropUp,
        {
          className: clsx("go-calendar__header-arrow", n === "month" && "go-calendar__header-arrow_down")
        }
      )
    ] }),
    n === "month" && /* @__PURE__ */ jsx("button", { className: "go-calendar__header-navigation-button", onClick: j, tabIndex: -1, children: /* @__PURE__ */ jsx(ArrowRightLight, {}) })
  ] });
};
var isArray = Array.isArray, toClassName = function(t) {
  var r = "";
  if (typeof t == "string")
    r += t;
  else if (typeof t == "object") {
    var n = void 0;
    if (isArray(t))
      for (var a = 0, s = t.length; a < s; )
        n = toClassName(t[a++]), n && (r && (r += " "), r += n);
    else
      for (n in t)
        n && t[n] && (r && (r += " "), r += n);
  }
  return r;
};
function cnb() {
  for (var t = arguments.length, r = 0, n, a, s = ""; r < t; )
    n = arguments[r++], n && (a = toClassName(n), a && (s && (s += " "), s += a));
  return s;
}
function e(t, r, n, a) {
  for (; r >= n && !t("(min-resolution: " + r / a + "dppx)").matches; ) r--;
  return r;
}
function i(t) {
  if (t === void 0 && (t = window), !t) return 1;
  if (t.devicePixelRatio !== void 0) return t.devicePixelRatio;
  var r = t.document.frames;
  return r !== void 0 ? r.devicePixelRatio !== void 0 ? r.devicePixelRatio : r.screen.deviceXDPI / r.screen.systemXDPI : t.matchMedia !== void 0 ? (function(n) {
    for (var a = n.matchMedia, s = 10, o = 0.1, l = 1, x = s, j = 0; j < 4; j++) s = (x = 10 * e(a, s, o, l)) + 9, o = x, l *= 10;
    return x / l;
  })(t) : 1;
}
var propTypes = { exports: {} }, reactIs = { exports: {} }, reactIs_production_min = {};
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var t = typeof Symbol == "function" && Symbol.for, r = t ? /* @__PURE__ */ Symbol.for("react.element") : 60103, n = t ? /* @__PURE__ */ Symbol.for("react.portal") : 60106, a = t ? /* @__PURE__ */ Symbol.for("react.fragment") : 60107, s = t ? /* @__PURE__ */ Symbol.for("react.strict_mode") : 60108, o = t ? /* @__PURE__ */ Symbol.for("react.profiler") : 60114, l = t ? /* @__PURE__ */ Symbol.for("react.provider") : 60109, x = t ? /* @__PURE__ */ Symbol.for("react.context") : 60110, j = t ? /* @__PURE__ */ Symbol.for("react.async_mode") : 60111, Z = t ? /* @__PURE__ */ Symbol.for("react.concurrent_mode") : 60111, V = t ? /* @__PURE__ */ Symbol.for("react.forward_ref") : 60112, $ = t ? /* @__PURE__ */ Symbol.for("react.suspense") : 60113, X = t ? /* @__PURE__ */ Symbol.for("react.suspense_list") : 60120, W = t ? /* @__PURE__ */ Symbol.for("react.memo") : 60115, Y = t ? /* @__PURE__ */ Symbol.for("react.lazy") : 60116, U = t ? /* @__PURE__ */ Symbol.for("react.block") : 60121, G = t ? /* @__PURE__ */ Symbol.for("react.fundamental") : 60117, K = t ? /* @__PURE__ */ Symbol.for("react.responder") : 60118, J = t ? /* @__PURE__ */ Symbol.for("react.scope") : 60119;
  function ee(re) {
    if (typeof re == "object" && re !== null) {
      var ae = re.$$typeof;
      switch (ae) {
        case r:
          switch (re = re.type, re) {
            case j:
            case Z:
            case a:
            case o:
            case s:
            case $:
              return re;
            default:
              switch (re = re && re.$$typeof, re) {
                case x:
                case V:
                case Y:
                case W:
                case l:
                  return re;
                default:
                  return ae;
              }
          }
        case n:
          return ae;
      }
    }
  }
  function te(re) {
    return ee(re) === Z;
  }
  return reactIs_production_min.AsyncMode = j, reactIs_production_min.ConcurrentMode = Z, reactIs_production_min.ContextConsumer = x, reactIs_production_min.ContextProvider = l, reactIs_production_min.Element = r, reactIs_production_min.ForwardRef = V, reactIs_production_min.Fragment = a, reactIs_production_min.Lazy = Y, reactIs_production_min.Memo = W, reactIs_production_min.Portal = n, reactIs_production_min.Profiler = o, reactIs_production_min.StrictMode = s, reactIs_production_min.Suspense = $, reactIs_production_min.isAsyncMode = function(re) {
    return te(re) || ee(re) === j;
  }, reactIs_production_min.isConcurrentMode = te, reactIs_production_min.isContextConsumer = function(re) {
    return ee(re) === x;
  }, reactIs_production_min.isContextProvider = function(re) {
    return ee(re) === l;
  }, reactIs_production_min.isElement = function(re) {
    return typeof re == "object" && re !== null && re.$$typeof === r;
  }, reactIs_production_min.isForwardRef = function(re) {
    return ee(re) === V;
  }, reactIs_production_min.isFragment = function(re) {
    return ee(re) === a;
  }, reactIs_production_min.isLazy = function(re) {
    return ee(re) === Y;
  }, reactIs_production_min.isMemo = function(re) {
    return ee(re) === W;
  }, reactIs_production_min.isPortal = function(re) {
    return ee(re) === n;
  }, reactIs_production_min.isProfiler = function(re) {
    return ee(re) === o;
  }, reactIs_production_min.isStrictMode = function(re) {
    return ee(re) === s;
  }, reactIs_production_min.isSuspense = function(re) {
    return ee(re) === $;
  }, reactIs_production_min.isValidElementType = function(re) {
    return typeof re == "string" || typeof re == "function" || re === a || re === Z || re === o || re === s || re === $ || re === X || typeof re == "object" && re !== null && (re.$$typeof === Y || re.$$typeof === W || re.$$typeof === l || re.$$typeof === x || re.$$typeof === V || re.$$typeof === G || re.$$typeof === K || re.$$typeof === J || re.$$typeof === U);
  }, reactIs_production_min.typeOf = ee, reactIs_production_min;
}
var reactIs_development = {};
var hasRequiredReactIs_development;
function requireReactIs_development() {
  return hasRequiredReactIs_development || (hasRequiredReactIs_development = 1, process.env.NODE_ENV !== "production" && (function() {
    var t = typeof Symbol == "function" && Symbol.for, r = t ? /* @__PURE__ */ Symbol.for("react.element") : 60103, n = t ? /* @__PURE__ */ Symbol.for("react.portal") : 60106, a = t ? /* @__PURE__ */ Symbol.for("react.fragment") : 60107, s = t ? /* @__PURE__ */ Symbol.for("react.strict_mode") : 60108, o = t ? /* @__PURE__ */ Symbol.for("react.profiler") : 60114, l = t ? /* @__PURE__ */ Symbol.for("react.provider") : 60109, x = t ? /* @__PURE__ */ Symbol.for("react.context") : 60110, j = t ? /* @__PURE__ */ Symbol.for("react.async_mode") : 60111, Z = t ? /* @__PURE__ */ Symbol.for("react.concurrent_mode") : 60111, V = t ? /* @__PURE__ */ Symbol.for("react.forward_ref") : 60112, $ = t ? /* @__PURE__ */ Symbol.for("react.suspense") : 60113, X = t ? /* @__PURE__ */ Symbol.for("react.suspense_list") : 60120, W = t ? /* @__PURE__ */ Symbol.for("react.memo") : 60115, Y = t ? /* @__PURE__ */ Symbol.for("react.lazy") : 60116, U = t ? /* @__PURE__ */ Symbol.for("react.block") : 60121, G = t ? /* @__PURE__ */ Symbol.for("react.fundamental") : 60117, K = t ? /* @__PURE__ */ Symbol.for("react.responder") : 60118, J = t ? /* @__PURE__ */ Symbol.for("react.scope") : 60119;
    function ee(ye) {
      return typeof ye == "string" || typeof ye == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      ye === a || ye === Z || ye === o || ye === s || ye === $ || ye === X || typeof ye == "object" && ye !== null && (ye.$$typeof === Y || ye.$$typeof === W || ye.$$typeof === l || ye.$$typeof === x || ye.$$typeof === V || ye.$$typeof === G || ye.$$typeof === K || ye.$$typeof === J || ye.$$typeof === U);
    }
    function te(ye) {
      if (typeof ye == "object" && ye !== null) {
        var Me = ye.$$typeof;
        switch (Me) {
          case r:
            var be = ye.type;
            switch (be) {
              case j:
              case Z:
              case a:
              case o:
              case s:
              case $:
                return be;
              default:
                var De = be && be.$$typeof;
                switch (De) {
                  case x:
                  case V:
                  case Y:
                  case W:
                  case l:
                    return De;
                  default:
                    return Me;
                }
            }
          case n:
            return Me;
        }
      }
    }
    var re = j, ae = Z, ie = x, ce = l, he = r, oe = V, le = a, pe = Y, de = W, se = n, ue = o, fe = s, ge = $, ne = !1;
    function ve(ye) {
      return ne || (ne = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), me(ye) || te(ye) === j;
    }
    function me(ye) {
      return te(ye) === Z;
    }
    function xe(ye) {
      return te(ye) === x;
    }
    function Ee(ye) {
      return te(ye) === l;
    }
    function Se(ye) {
      return typeof ye == "object" && ye !== null && ye.$$typeof === r;
    }
    function _e(ye) {
      return te(ye) === V;
    }
    function Ce(ye) {
      return te(ye) === a;
    }
    function Te(ye) {
      return te(ye) === Y;
    }
    function we(ye) {
      return te(ye) === W;
    }
    function Re(ye) {
      return te(ye) === n;
    }
    function Ae(ye) {
      return te(ye) === o;
    }
    function Pe(ye) {
      return te(ye) === s;
    }
    function ke(ye) {
      return te(ye) === $;
    }
    reactIs_development.AsyncMode = re, reactIs_development.ConcurrentMode = ae, reactIs_development.ContextConsumer = ie, reactIs_development.ContextProvider = ce, reactIs_development.Element = he, reactIs_development.ForwardRef = oe, reactIs_development.Fragment = le, reactIs_development.Lazy = pe, reactIs_development.Memo = de, reactIs_development.Portal = se, reactIs_development.Profiler = ue, reactIs_development.StrictMode = fe, reactIs_development.Suspense = ge, reactIs_development.isAsyncMode = ve, reactIs_development.isConcurrentMode = me, reactIs_development.isContextConsumer = xe, reactIs_development.isContextProvider = Ee, reactIs_development.isElement = Se, reactIs_development.isForwardRef = _e, reactIs_development.isFragment = Ce, reactIs_development.isLazy = Te, reactIs_development.isMemo = we, reactIs_development.isPortal = Re, reactIs_development.isProfiler = Ae, reactIs_development.isStrictMode = Pe, reactIs_development.isSuspense = ke, reactIs_development.isValidElementType = ee, reactIs_development.typeOf = te;
  })()), reactIs_development;
}
var hasRequiredReactIs;
function requireReactIs() {
  return hasRequiredReactIs || (hasRequiredReactIs = 1, process.env.NODE_ENV === "production" ? reactIs.exports = requireReactIs_production_min() : reactIs.exports = requireReactIs_development()), reactIs.exports;
}
var objectAssign, hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign) return objectAssign;
  hasRequiredObjectAssign = 1;
  var t = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function a(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function s() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var l = {}, x = 0; x < 10; x++)
        l["_" + String.fromCharCode(x)] = x;
      var j = Object.getOwnPropertyNames(l).map(function(V) {
        return l[V];
      });
      if (j.join("") !== "0123456789")
        return !1;
      var Z = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(V) {
        Z[V] = V;
      }), Object.keys(Object.assign({}, Z)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return objectAssign = s() ? Object.assign : function(o, l) {
    for (var x, j = a(o), Z, V = 1; V < arguments.length; V++) {
      x = Object(arguments[V]);
      for (var $ in x)
        r.call(x, $) && (j[$] = x[$]);
      if (t) {
        Z = t(x);
        for (var X = 0; X < Z.length; X++)
          n.call(x, Z[X]) && (j[Z[X]] = x[Z[X]]);
      }
    }
    return j;
  }, objectAssign;
}
var ReactPropTypesSecret_1, hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ReactPropTypesSecret_1 = t, ReactPropTypesSecret_1;
}
var has, hasRequiredHas;
function requireHas() {
  return hasRequiredHas || (hasRequiredHas = 1, has = Function.call.bind(Object.prototype.hasOwnProperty)), has;
}
var checkPropTypes_1, hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes) return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var t = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var r = /* @__PURE__ */ requireReactPropTypesSecret(), n = {}, a = /* @__PURE__ */ requireHas();
    t = function(o) {
      var l = "Warning: " + o;
      typeof console != "undefined" && console.error(l);
      try {
        throw new Error(l);
      } catch {
      }
    };
  }
  function s(o, l, x, j, Z) {
    if (process.env.NODE_ENV !== "production") {
      for (var V in o)
        if (a(o, V)) {
          var $;
          try {
            if (typeof o[V] != "function") {
              var X = Error(
                (j || "React class") + ": " + x + " type `" + V + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[V] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw X.name = "Invariant Violation", X;
            }
            $ = o[V](l, V, j, x, null, r);
          } catch (Y) {
            $ = Y;
          }
          if ($ && !($ instanceof Error) && t(
            (j || "React class") + ": type specification of " + x + " `" + V + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof $ + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), $ instanceof Error && !($.message in n)) {
            n[$.message] = !0;
            var W = Z ? Z() : "";
            t(
              "Failed " + x + " type: " + $.message + (W != null ? W : "")
            );
          }
        }
    }
  }
  return s.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, checkPropTypes_1 = s, checkPropTypes_1;
}
var factoryWithTypeCheckers, hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var t = requireReactIs(), r = requireObjectAssign(), n = /* @__PURE__ */ requireReactPropTypesSecret(), a = /* @__PURE__ */ requireHas(), s = /* @__PURE__ */ requireCheckPropTypes(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(x) {
    var j = "Warning: " + x;
    typeof console != "undefined" && console.error(j);
    try {
      throw new Error(j);
    } catch {
    }
  });
  function l() {
    return null;
  }
  return factoryWithTypeCheckers = function(x, j) {
    var Z = typeof Symbol == "function" && Symbol.iterator, V = "@@iterator";
    function $(me) {
      var xe = me && (Z && me[Z] || me[V]);
      if (typeof xe == "function")
        return xe;
    }
    var X = "<<anonymous>>", W = {
      array: K("array"),
      bigint: K("bigint"),
      bool: K("boolean"),
      func: K("function"),
      number: K("number"),
      object: K("object"),
      string: K("string"),
      symbol: K("symbol"),
      any: J(),
      arrayOf: ee,
      element: te(),
      elementType: re(),
      instanceOf: ae,
      node: oe(),
      objectOf: ce,
      oneOf: ie,
      oneOfType: he,
      shape: pe,
      exact: de
    };
    function Y(me, xe) {
      return me === xe ? me !== 0 || 1 / me === 1 / xe : me !== me && xe !== xe;
    }
    function U(me, xe) {
      this.message = me, this.data = xe && typeof xe == "object" ? xe : {}, this.stack = "";
    }
    U.prototype = Error.prototype;
    function G(me) {
      if (process.env.NODE_ENV !== "production")
        var xe = {}, Ee = 0;
      function Se(Ce, Te, we, Re, Ae, Pe, ke) {
        if (Re = Re || X, Pe = Pe || we, ke !== n) {
          if (j) {
            var ye = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw ye.name = "Invariant Violation", ye;
          } else if (process.env.NODE_ENV !== "production" && typeof console != "undefined") {
            var Me = Re + ":" + we;
            !xe[Me] && // Avoid spamming the console because they are often not actionable except for lib authors
            Ee < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + Pe + "` prop on `" + Re + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), xe[Me] = !0, Ee++);
          }
        }
        return Te[we] == null ? Ce ? Te[we] === null ? new U("The " + Ae + " `" + Pe + "` is marked as required " + ("in `" + Re + "`, but its value is `null`.")) : new U("The " + Ae + " `" + Pe + "` is marked as required in " + ("`" + Re + "`, but its value is `undefined`.")) : null : me(Te, we, Re, Ae, Pe);
      }
      var _e = Se.bind(null, !1);
      return _e.isRequired = Se.bind(null, !0), _e;
    }
    function K(me) {
      function xe(Ee, Se, _e, Ce, Te, we) {
        var Re = Ee[Se], Ae = fe(Re);
        if (Ae !== me) {
          var Pe = ge(Re);
          return new U(
            "Invalid " + Ce + " `" + Te + "` of type " + ("`" + Pe + "` supplied to `" + _e + "`, expected ") + ("`" + me + "`."),
            { expectedType: me }
          );
        }
        return null;
      }
      return G(xe);
    }
    function J() {
      return G(l);
    }
    function ee(me) {
      function xe(Ee, Se, _e, Ce, Te) {
        if (typeof me != "function")
          return new U("Property `" + Te + "` of component `" + _e + "` has invalid PropType notation inside arrayOf.");
        var we = Ee[Se];
        if (!Array.isArray(we)) {
          var Re = fe(we);
          return new U("Invalid " + Ce + " `" + Te + "` of type " + ("`" + Re + "` supplied to `" + _e + "`, expected an array."));
        }
        for (var Ae = 0; Ae < we.length; Ae++) {
          var Pe = me(we, Ae, _e, Ce, Te + "[" + Ae + "]", n);
          if (Pe instanceof Error)
            return Pe;
        }
        return null;
      }
      return G(xe);
    }
    function te() {
      function me(xe, Ee, Se, _e, Ce) {
        var Te = xe[Ee];
        if (!x(Te)) {
          var we = fe(Te);
          return new U("Invalid " + _e + " `" + Ce + "` of type " + ("`" + we + "` supplied to `" + Se + "`, expected a single ReactElement."));
        }
        return null;
      }
      return G(me);
    }
    function re() {
      function me(xe, Ee, Se, _e, Ce) {
        var Te = xe[Ee];
        if (!t.isValidElementType(Te)) {
          var we = fe(Te);
          return new U("Invalid " + _e + " `" + Ce + "` of type " + ("`" + we + "` supplied to `" + Se + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return G(me);
    }
    function ae(me) {
      function xe(Ee, Se, _e, Ce, Te) {
        if (!(Ee[Se] instanceof me)) {
          var we = me.name || X, Re = ve(Ee[Se]);
          return new U("Invalid " + Ce + " `" + Te + "` of type " + ("`" + Re + "` supplied to `" + _e + "`, expected ") + ("instance of `" + we + "`."));
        }
        return null;
      }
      return G(xe);
    }
    function ie(me) {
      if (!Array.isArray(me))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), l;
      function xe(Ee, Se, _e, Ce, Te) {
        for (var we = Ee[Se], Re = 0; Re < me.length; Re++)
          if (Y(we, me[Re]))
            return null;
        var Ae = JSON.stringify(me, function(ke, ye) {
          var Me = ge(ye);
          return Me === "symbol" ? String(ye) : ye;
        });
        return new U("Invalid " + Ce + " `" + Te + "` of value `" + String(we) + "` " + ("supplied to `" + _e + "`, expected one of " + Ae + "."));
      }
      return G(xe);
    }
    function ce(me) {
      function xe(Ee, Se, _e, Ce, Te) {
        if (typeof me != "function")
          return new U("Property `" + Te + "` of component `" + _e + "` has invalid PropType notation inside objectOf.");
        var we = Ee[Se], Re = fe(we);
        if (Re !== "object")
          return new U("Invalid " + Ce + " `" + Te + "` of type " + ("`" + Re + "` supplied to `" + _e + "`, expected an object."));
        for (var Ae in we)
          if (a(we, Ae)) {
            var Pe = me(we, Ae, _e, Ce, Te + "." + Ae, n);
            if (Pe instanceof Error)
              return Pe;
          }
        return null;
      }
      return G(xe);
    }
    function he(me) {
      if (!Array.isArray(me))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), l;
      for (var xe = 0; xe < me.length; xe++) {
        var Ee = me[xe];
        if (typeof Ee != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + ne(Ee) + " at index " + xe + "."
          ), l;
      }
      function Se(_e, Ce, Te, we, Re) {
        for (var Ae = [], Pe = 0; Pe < me.length; Pe++) {
          var ke = me[Pe], ye = ke(_e, Ce, Te, we, Re, n);
          if (ye == null)
            return null;
          ye.data && a(ye.data, "expectedType") && Ae.push(ye.data.expectedType);
        }
        var Me = Ae.length > 0 ? ", expected one of type [" + Ae.join(", ") + "]" : "";
        return new U("Invalid " + we + " `" + Re + "` supplied to " + ("`" + Te + "`" + Me + "."));
      }
      return G(Se);
    }
    function oe() {
      function me(xe, Ee, Se, _e, Ce) {
        return se(xe[Ee]) ? null : new U("Invalid " + _e + " `" + Ce + "` supplied to " + ("`" + Se + "`, expected a ReactNode."));
      }
      return G(me);
    }
    function le(me, xe, Ee, Se, _e) {
      return new U(
        (me || "React class") + ": " + xe + " type `" + Ee + "." + Se + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + _e + "`."
      );
    }
    function pe(me) {
      function xe(Ee, Se, _e, Ce, Te) {
        var we = Ee[Se], Re = fe(we);
        if (Re !== "object")
          return new U("Invalid " + Ce + " `" + Te + "` of type `" + Re + "` " + ("supplied to `" + _e + "`, expected `object`."));
        for (var Ae in me) {
          var Pe = me[Ae];
          if (typeof Pe != "function")
            return le(_e, Ce, Te, Ae, ge(Pe));
          var ke = Pe(we, Ae, _e, Ce, Te + "." + Ae, n);
          if (ke)
            return ke;
        }
        return null;
      }
      return G(xe);
    }
    function de(me) {
      function xe(Ee, Se, _e, Ce, Te) {
        var we = Ee[Se], Re = fe(we);
        if (Re !== "object")
          return new U("Invalid " + Ce + " `" + Te + "` of type `" + Re + "` " + ("supplied to `" + _e + "`, expected `object`."));
        var Ae = r({}, Ee[Se], me);
        for (var Pe in Ae) {
          var ke = me[Pe];
          if (a(me, Pe) && typeof ke != "function")
            return le(_e, Ce, Te, Pe, ge(ke));
          if (!ke)
            return new U(
              "Invalid " + Ce + " `" + Te + "` key `" + Pe + "` supplied to `" + _e + "`.\nBad object: " + JSON.stringify(Ee[Se], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(me), null, "  ")
            );
          var ye = ke(we, Pe, _e, Ce, Te + "." + Pe, n);
          if (ye)
            return ye;
        }
        return null;
      }
      return G(xe);
    }
    function se(me) {
      switch (typeof me) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !me;
        case "object":
          if (Array.isArray(me))
            return me.every(se);
          if (me === null || x(me))
            return !0;
          var xe = $(me);
          if (xe) {
            var Ee = xe.call(me), Se;
            if (xe !== me.entries) {
              for (; !(Se = Ee.next()).done; )
                if (!se(Se.value))
                  return !1;
            } else
              for (; !(Se = Ee.next()).done; ) {
                var _e = Se.value;
                if (_e && !se(_e[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function ue(me, xe) {
      return me === "symbol" ? !0 : xe ? xe["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && xe instanceof Symbol : !1;
    }
    function fe(me) {
      var xe = typeof me;
      return Array.isArray(me) ? "array" : me instanceof RegExp ? "object" : ue(xe, me) ? "symbol" : xe;
    }
    function ge(me) {
      if (typeof me == "undefined" || me === null)
        return "" + me;
      var xe = fe(me);
      if (xe === "object") {
        if (me instanceof Date)
          return "date";
        if (me instanceof RegExp)
          return "regexp";
      }
      return xe;
    }
    function ne(me) {
      var xe = ge(me);
      switch (xe) {
        case "array":
        case "object":
          return "an " + xe;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + xe;
        default:
          return xe;
      }
    }
    function ve(me) {
      return !me.constructor || !me.constructor.name ? X : me.constructor.name;
    }
    return W.checkPropTypes = s, W.resetWarningCache = s.resetWarningCache, W.PropTypes = W, W;
  }, factoryWithTypeCheckers;
}
var factoryWithThrowingShims, hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var t = /* @__PURE__ */ requireReactPropTypesSecret();
  function r() {
  }
  function n() {
  }
  return n.resetWarningCache = r, factoryWithThrowingShims = function() {
    function a(l, x, j, Z, V, $) {
      if ($ !== t) {
        var X = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw X.name = "Invariant Violation", X;
      }
    }
    a.isRequired = a;
    function s() {
      return a;
    }
    var o = {
      array: a,
      bigint: a,
      bool: a,
      func: a,
      number: a,
      object: a,
      string: a,
      symbol: a,
      any: a,
      arrayOf: s,
      element: a,
      elementType: a,
      instanceOf: s,
      node: a,
      objectOf: s,
      oneOf: s,
      oneOfType: s,
      shape: s,
      exact: s,
      checkPropTypes: n,
      resetWarningCache: r
    };
    return o.PropTypes = o, o;
  }, factoryWithThrowingShims;
}
var hasRequiredPropTypes;
function requirePropTypes() {
  if (hasRequiredPropTypes) return propTypes.exports;
  if (hasRequiredPropTypes = 1, process.env.NODE_ENV !== "production") {
    var t = requireReactIs(), r = !0;
    propTypes.exports = /* @__PURE__ */ requireFactoryWithTypeCheckers()(t.isElement, r);
  } else
    propTypes.exports = /* @__PURE__ */ requireFactoryWithThrowingShims()();
  return propTypes.exports;
}
var propTypesExports = /* @__PURE__ */ requirePropTypes();
const PropTypes2 = /* @__PURE__ */ getDefaultExportFromCjs(propTypesExports);
function findInArray(t, r) {
  for (let n = 0, a = t.length; n < a; n++)
    if (r.apply(r, [t[n], n, t])) return t[n];
}
function isFunction(t) {
  return typeof t == "function" || Object.prototype.toString.call(t) === "[object Function]";
}
function isNum$1(t) {
  return typeof t == "number" && !isNaN(t);
}
function int(t) {
  return parseInt(t, 10);
}
function dontSetMe(t, r, n) {
  if (t[r])
    return new Error(`Invalid prop ${r} passed to ${n} - do not set this, set it on the child.`);
}
var prefixes = ["Moz", "Webkit", "O", "ms"];
function getPrefix(t = "transform") {
  var r, n;
  if (typeof window == "undefined") return "";
  const a = (n = (r = window.document) == null ? void 0 : r.documentElement) == null ? void 0 : n.style;
  if (!a || t in a) return "";
  for (let s = 0; s < prefixes.length; s++)
    if (browserPrefixToKey(t, prefixes[s]) in a) return prefixes[s];
  return "";
}
function browserPrefixToKey(t, r) {
  return r ? `${r}${kebabToTitleCase(t)}` : t;
}
function kebabToTitleCase(t) {
  let r = "", n = !0;
  for (let a = 0; a < t.length; a++)
    n ? (r += t[a].toUpperCase(), n = !1) : t[a] === "-" ? n = !0 : r += t[a];
  return r;
}
var getPrefix_default = getPrefix(), matchesSelectorFunc = "";
function matchesSelector(t, r) {
  var n;
  matchesSelectorFunc || (matchesSelectorFunc = (n = findInArray([
    "matches",
    "webkitMatchesSelector",
    "mozMatchesSelector",
    "msMatchesSelector",
    "oMatchesSelector"
  ], function(s) {
    return isFunction(t[s]);
  })) != null ? n : "");
  const a = t[matchesSelectorFunc];
  return isFunction(a) ? !!a.call(t, r) : !1;
}
function matchesSelectorAndParentsTo(t, r, n) {
  let a = t;
  do {
    if (matchesSelector(a, r)) return !0;
    if (a === n) return !1;
    a = a.parentNode;
  } while (a);
  return !1;
}
function addEvent(t, r, n, a) {
  if (!t) return;
  const s = { capture: !0, ...a }, o = n;
  t.addEventListener ? t.addEventListener(r, o, s) : t.attachEvent ? t.attachEvent("on" + r, o) : t["on" + r] = o;
}
function removeEvent(t, r, n, a) {
  if (!t) return;
  const s = { capture: !0, ...a }, o = n;
  t.removeEventListener ? t.removeEventListener(r, o, s) : t.detachEvent ? t.detachEvent("on" + r, o) : t["on" + r] = null;
}
function outerHeight(t) {
  let r = t.clientHeight;
  const n = t.ownerDocument.defaultView.getComputedStyle(t);
  return r += int(n.borderTopWidth), r += int(n.borderBottomWidth), r;
}
function outerWidth(t) {
  let r = t.clientWidth;
  const n = t.ownerDocument.defaultView.getComputedStyle(t);
  return r += int(n.borderLeftWidth), r += int(n.borderRightWidth), r;
}
function innerHeight(t) {
  let r = t.clientHeight;
  const n = t.ownerDocument.defaultView.getComputedStyle(t);
  return r -= int(n.paddingTop), r -= int(n.paddingBottom), r;
}
function innerWidth(t) {
  let r = t.clientWidth;
  const n = t.ownerDocument.defaultView.getComputedStyle(t);
  return r -= int(n.paddingLeft), r -= int(n.paddingRight), r;
}
function offsetXYFromParent(t, r, n) {
  const s = r === r.ownerDocument.body ? { left: 0, top: 0 } : r.getBoundingClientRect(), o = (t.clientX + r.scrollLeft - s.left) / n, l = (t.clientY + r.scrollTop - s.top) / n;
  return { x: o, y: l };
}
function createCSSTransform(t, r) {
  const n = getTranslation(t, r, "px");
  return { [browserPrefixToKey("transform", getPrefix_default)]: n };
}
function createSVGTransform(t, r) {
  return getTranslation(t, r, "");
}
function getTranslation({ x: t, y: r }, n, a) {
  let s = `translate(${t}${a},${r}${a})`;
  if (n) {
    const o = `${typeof n.x == "string" ? n.x : n.x + a}`, l = `${typeof n.y == "string" ? n.y : n.y + a}`;
    s = `translate(${o}, ${l})` + s;
  }
  return s;
}
function getTouch(t, r) {
  return t.targetTouches && findInArray(t.targetTouches, (n) => r === n.identifier) || t.changedTouches && findInArray(t.changedTouches, (n) => r === n.identifier);
}
function getTouchIdentifier(t) {
  if (t.targetTouches && t.targetTouches[0]) return t.targetTouches[0].identifier;
  if (t.changedTouches && t.changedTouches[0]) return t.changedTouches[0].identifier;
}
function getDefaultNonce() {
  return typeof __webpack_nonce__ != "undefined" ? __webpack_nonce__ : void 0;
}
function addUserSelectStyles(t, r) {
  if (!t) return;
  let n = t.getElementById("react-draggable-style-el");
  if (!n) {
    n = t.createElement("style"), n.type = "text/css", n.id = "react-draggable-style-el";
    const a = r != null ? r : getDefaultNonce();
    a && n.setAttribute("nonce", a), n.innerHTML = `.react-draggable-transparent-selection *::-moz-selection {all: inherit;}
`, n.innerHTML += `.react-draggable-transparent-selection *::selection {all: inherit;}
`, t.getElementsByTagName("head")[0].appendChild(n);
  }
  t.body && addClassName(t.body, "react-draggable-transparent-selection");
}
function scheduleRemoveUserSelectStyles(t) {
  window.requestAnimationFrame ? window.requestAnimationFrame(() => {
    removeUserSelectStyles(t);
  }) : removeUserSelectStyles(t);
}
function removeUserSelectStyles(t) {
  if (t)
    try {
      t.body && removeClassName(t.body, "react-draggable-transparent-selection");
      const r = t.selection;
      if (r)
        r.empty();
      else {
        const n = (t.defaultView || window).getSelection();
        n && n.type !== "Caret" && n.removeAllRanges();
      }
    } catch {
    }
}
function addClassName(t, r) {
  t.classList ? t.classList.add(r) : t.className.match(new RegExp(`(?:^|\\s)${r}(?!\\S)`)) || (t.className += ` ${r}`);
}
function removeClassName(t, r) {
  t.classList ? t.classList.remove(r) : t.className = t.className.replace(new RegExp(`(?:^|\\s)${r}(?!\\S)`, "g"), "");
}
function getBoundPosition(t, r, n) {
  if (!t.props.bounds) return [r, n];
  let { bounds: a } = t.props;
  a = typeof a == "string" ? a : cloneBounds(a);
  const s = findDOMNode(t);
  if (typeof a == "string") {
    const { ownerDocument: o } = s, l = o.defaultView;
    if (!l)
      throw new Error("Cannot resolve the owner window of the draggable node.");
    let x;
    if (a === "parent" ? x = s.parentNode : x = s.getRootNode().querySelector(a), !(x instanceof l.HTMLElement))
      throw new Error('Bounds selector "' + a + '" could not find an element.');
    const j = x, Z = l.getComputedStyle(s), V = l.getComputedStyle(j);
    a = {
      left: -s.offsetLeft + int(V.paddingLeft) + int(Z.marginLeft),
      top: -s.offsetTop + int(V.paddingTop) + int(Z.marginTop),
      right: innerWidth(j) - outerWidth(s) - s.offsetLeft + int(V.paddingRight) - int(Z.marginRight),
      bottom: innerHeight(j) - outerHeight(s) - s.offsetTop + int(V.paddingBottom) - int(Z.marginBottom)
    };
  }
  return isNum$1(a.right) && (r = Math.min(r, a.right)), isNum$1(a.bottom) && (n = Math.min(n, a.bottom)), isNum$1(a.left) && (r = Math.max(r, a.left)), isNum$1(a.top) && (n = Math.max(n, a.top)), [r, n];
}
function snapToGrid(t, r, n) {
  const a = Math.round(r / t[0]) * t[0], s = Math.round(n / t[1]) * t[1];
  return [a, s];
}
function canDragX(t) {
  return t.props.axis === "both" || t.props.axis === "x";
}
function canDragY(t) {
  return t.props.axis === "both" || t.props.axis === "y";
}
function getControlPosition(t, r, n) {
  const a = typeof r == "number" ? getTouch(t, r) : null;
  if (typeof r == "number" && !a) return null;
  const s = findDOMNode(n), o = n.props.offsetParent || s.offsetParent || s.ownerDocument.body;
  return offsetXYFromParent(a || t, o, n.props.scale);
}
function createCoreData(t, r, n) {
  const a = !isNum$1(t.lastX), s = findDOMNode(t);
  return a ? {
    node: s,
    deltaX: 0,
    deltaY: 0,
    lastX: r,
    lastY: n,
    x: r,
    y: n
  } : {
    node: s,
    deltaX: r - t.lastX,
    deltaY: n - t.lastY,
    lastX: t.lastX,
    lastY: t.lastY,
    x: r,
    y: n
  };
}
function createDraggableData(t, r) {
  const n = t.props.scale;
  return {
    node: r.node,
    x: t.state.x + r.deltaX / n,
    y: t.state.y + r.deltaY / n,
    deltaX: r.deltaX / n,
    deltaY: r.deltaY / n,
    lastX: t.state.x,
    lastY: t.state.y
  };
}
function cloneBounds(t) {
  return {
    left: t.left,
    top: t.top,
    right: t.right,
    bottom: t.bottom
  };
}
function findDOMNode(t) {
  const r = t.findDOMNode();
  if (!r)
    throw new Error("<DraggableCore>: Unmounted during event!");
  return r;
}
function log$1(...t) {
  process.env.DRAGGABLE_DEBUG && console.log(...t);
}
var eventsFor = {
  touch: {
    start: "touchstart",
    move: "touchmove",
    stop: "touchend"
  },
  mouse: {
    start: "mousedown",
    move: "mousemove",
    stop: "mouseup"
  }
}, dragEventFor = eventsFor.mouse, DraggableCore = class extends React.Component {
  constructor() {
    super(...arguments), this.dragging = !1, this.lastX = NaN, this.lastY = NaN, this.touchIdentifier = null, this.mounted = !1, this.handleDragStart = (t) => {
      if (this.props.onMouseDown(t), !this.props.allowAnyClick && (typeof t.button == "number" && t.button !== 0 || t.ctrlKey)) return !1;
      const r = this.findDOMNode();
      if (!r || !r.ownerDocument || !r.ownerDocument.body)
        throw new Error("<DraggableCore> not mounted on DragStart!");
      const { ownerDocument: n } = r;
      if (this.props.disabled || !(t.target instanceof n.defaultView.Node) || this.props.handle && !matchesSelectorAndParentsTo(t.target, this.props.handle, r) || this.props.cancel && matchesSelectorAndParentsTo(t.target, this.props.cancel, r))
        return;
      t.type === "touchstart" && !this.props.allowMobileScroll && t.preventDefault();
      const a = getTouchIdentifier(t);
      this.touchIdentifier = a;
      const s = getControlPosition(t, a, this);
      if (s == null) return;
      const { x: o, y: l } = s, x = createCoreData(this, o, l);
      log$1("DraggableCore: handleDragStart: %j", x), log$1("calling", this.props.onStart), !(this.props.onStart(t, x) === !1 || this.mounted === !1) && (this.props.enableUserSelectHack && addUserSelectStyles(n, this.props.nonce), this.dragging = !0, this.lastX = o, this.lastY = l, addEvent(n, dragEventFor.move, this.handleDrag), addEvent(n, dragEventFor.stop, this.handleDragStop));
    }, this.handleDrag = (t) => {
      const r = getControlPosition(t, this.touchIdentifier, this);
      if (r == null) return;
      let { x: n, y: a } = r;
      if (Array.isArray(this.props.grid)) {
        let l = n - this.lastX, x = a - this.lastY;
        if ([l, x] = snapToGrid(this.props.grid, l, x), !l && !x) return;
        n = this.lastX + l, a = this.lastY + x;
      }
      const s = createCoreData(this, n, a);
      if (log$1("DraggableCore: handleDrag: %j", s), this.props.onDrag(t, s) === !1 || this.mounted === !1) {
        try {
          this.handleDragStop(new MouseEvent("mouseup"));
        } catch {
          const l = document.createEvent("MouseEvents");
          l.initMouseEvent("mouseup", !0, !0, window, 0, 0, 0, 0, 0, !1, !1, !1, !1, 0, null), this.handleDragStop(l);
        }
        return;
      }
      this.lastX = n, this.lastY = a;
    }, this.handleDragStop = (t) => {
      if (!this.dragging) return;
      const r = getControlPosition(t, this.touchIdentifier, this);
      if (r == null) return;
      let { x: n, y: a } = r;
      if (Array.isArray(this.props.grid)) {
        let x = n - this.lastX || 0, j = a - this.lastY || 0;
        [x, j] = snapToGrid(this.props.grid, x, j), n = this.lastX + x, a = this.lastY + j;
      }
      const s = createCoreData(this, n, a);
      if (this.props.onStop(t, s) === !1 || this.mounted === !1) return !1;
      const l = this.findDOMNode();
      l && this.props.enableUserSelectHack && scheduleRemoveUserSelectStyles(l.ownerDocument), log$1("DraggableCore: handleDragStop: %j", s), this.dragging = !1, this.lastX = NaN, this.lastY = NaN, l && (log$1("DraggableCore: Removing handlers"), removeEvent(l.ownerDocument, dragEventFor.move, this.handleDrag), removeEvent(l.ownerDocument, dragEventFor.stop, this.handleDragStop));
    }, this.onMouseDown = (t) => (dragEventFor = eventsFor.mouse, this.handleDragStart(t)), this.onMouseUp = (t) => (dragEventFor = eventsFor.mouse, this.handleDragStop(t)), this.onTouchStart = (t) => (dragEventFor = eventsFor.touch, this.handleDragStart(t)), this.onTouchEnd = (t) => (dragEventFor = eventsFor.touch, this.handleDragStop(t));
  }
  componentDidMount() {
    this.mounted = !0;
    const t = this.findDOMNode();
    t && addEvent(t, eventsFor.touch.start, this.onTouchStart, { passive: !1 });
  }
  componentWillUnmount() {
    this.mounted = !1;
    const t = this.findDOMNode();
    if (t) {
      const { ownerDocument: r } = t;
      removeEvent(r, eventsFor.mouse.move, this.handleDrag), removeEvent(r, eventsFor.touch.move, this.handleDrag), removeEvent(r, eventsFor.mouse.stop, this.handleDragStop), removeEvent(r, eventsFor.touch.stop, this.handleDragStop), removeEvent(t, eventsFor.touch.start, this.onTouchStart, { passive: !1 }), this.props.enableUserSelectHack && scheduleRemoveUserSelectStyles(r);
    }
  }
  // React 19 removed ReactDOM.findDOMNode, so nodeRef is now required.
  // For backward compatibility with React 18 and earlier, we still support findDOMNode if available.
  findDOMNode() {
    var t;
    if ((t = this.props) != null && t.nodeRef)
      return this.props.nodeRef.current;
    const r = ReactDOM__default;
    return typeof r.findDOMNode == "function" ? r.findDOMNode(this) : (log$1(
      "react-draggable: ReactDOM.findDOMNode is not available in React 19+. You must provide a nodeRef prop. See: https://github.com/react-grid-layout/react-draggable#noderef"
    ), null);
  }
  render() {
    return React.cloneElement(React.Children.only(this.props.children), {
      // Note: mouseMove handler is attached to document so it will still function
      // when the user drags quickly and leaves the bounds of the element.
      onMouseDown: this.onMouseDown,
      onMouseUp: this.onMouseUp,
      // onTouchStart is added on `componentDidMount` so they can be added with
      // {passive: false}, which allows it to cancel. See
      // https://developers.google.com/web/updates/2017/01/scrolling-intervention
      onTouchEnd: this.onTouchEnd
    });
  }
};
DraggableCore.displayName = "DraggableCore";
DraggableCore.propTypes = {
  /**
   * `allowAnyClick` allows dragging using any mouse button.
   * By default, we only accept the left button.
   *
   * Defaults to `false`.
   */
  allowAnyClick: PropTypes2.bool,
  /**
   * `allowMobileScroll` turns off cancellation of the 'touchstart' event
   * on mobile devices. Only enable this if you are having trouble with click
   * events. Prefer using 'handle' / 'cancel' instead.
   *
   * Defaults to `false`.
   */
  allowMobileScroll: PropTypes2.bool,
  children: PropTypes2.node.isRequired,
  /**
   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
   * with the exception of `onMouseDown`, will not fire.
   */
  disabled: PropTypes2.bool,
  /**
   * By default, we add 'user-select:none' attributes to the document body
   * to prevent ugly text selection during drag. If this is causing problems
   * for your app, set this to `false`.
   */
  enableUserSelectHack: PropTypes2.bool,
  /**
   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
   * instead of using the parent node.
   */
  offsetParent: function(t, r) {
    if (t[r] && t[r].nodeType !== 1)
      throw new Error("Draggable's offsetParent must be a DOM Node.");
  },
  /**
   * `grid` specifies the x and y that dragging should snap to.
   */
  grid: PropTypes2.arrayOf(PropTypes2.number),
  /**
   * `handle` specifies a selector to be used as the handle that initiates drag.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable handle=".handle">
   *              <div>
   *                  <div className="handle">Click me to drag</div>
   *                  <div>This is some other content</div>
   *              </div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */
  handle: PropTypes2.string,
  /**
   * `cancel` specifies a selector to be used to prevent drag initialization.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *           return(
   *               <Draggable cancel=".cancel">
   *                   <div>
   *                     <div className="cancel">You can't drag from here</div>
   *                     <div>Dragging here works fine</div>
   *                   </div>
   *               </Draggable>
   *           );
   *       }
   *   });
   * ```
   */
  cancel: PropTypes2.string,
  /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
   * Unfortunately, in order for <Draggable> to work properly, we need raw access
   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
   * as in this example:
   *
   * function MyComponent() {
   *   const nodeRef = React.useRef(null);
   *   return (
   *     <Draggable nodeRef={nodeRef}>
   *       <div ref={nodeRef}>Example Target</div>
   *     </Draggable>
   *   );
   * }
   *
   * This can be used for arbitrarily nested components, so long as the ref ends up
   * pointing to the actual child DOM node and not a custom component.
   */
  nodeRef: PropTypes2.object,
  /**
   * `nonce` is applied to the dynamically-injected <style> element used by the
   * user-select hack, so it isn't blocked under a strict Content Security
   * Policy (`style-src` without `'unsafe-inline'`). If omitted, webpack's
   * `__webpack_nonce__` global is used when available.
   */
  nonce: PropTypes2.string,
  /**
   * Called when dragging starts.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onStart: PropTypes2.func,
  /**
   * Called while dragging.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onDrag: PropTypes2.func,
  /**
   * Called when dragging stops.
   * If this function returns the boolean false, the drag will remain active.
   */
  onStop: PropTypes2.func,
  /**
   * A workaround option which can be passed if onMouseDown needs to be accessed,
   * since it'll always be blocked (as there is internal use of onMouseDown)
   */
  onMouseDown: PropTypes2.func,
  /**
   * `scale`, if set, applies scaling while dragging an element
   */
  scale: PropTypes2.number,
  /**
   * These properties should be defined on the child, not here.
   */
  className: dontSetMe,
  style: dontSetMe,
  transform: dontSetMe
};
DraggableCore.defaultProps = {
  allowAnyClick: !1,
  // by default only accept left click
  allowMobileScroll: !1,
  disabled: !1,
  enableUserSelectHack: !0,
  onStart: function() {
  },
  onDrag: function() {
  },
  onStop: function() {
  },
  onMouseDown: function() {
  },
  scale: 1
};
var Draggable = class extends React.Component {
  constructor(t) {
    super(t), this.onDragStart = (r, n) => {
      if (log$1("Draggable: onDragStart: %j", n), this.props.onStart(r, createDraggableData(this, n)) === !1) return !1;
      this.setState({ dragging: !0, dragged: !0 });
    }, this.onDrag = (r, n) => {
      if (!this.state.dragging) return !1;
      log$1("Draggable: onDrag: %j", n);
      const a = createDraggableData(this, n), s = {
        x: a.x,
        y: a.y,
        slackX: 0,
        slackY: 0
      };
      if (this.props.bounds) {
        const { x: l, y: x } = s;
        s.x += this.state.slackX, s.y += this.state.slackY;
        const [j, Z] = getBoundPosition(this, s.x, s.y);
        s.x = j, s.y = Z, s.slackX = this.state.slackX + (l - s.x), s.slackY = this.state.slackY + (x - s.y), a.x = s.x, a.y = s.y, a.deltaX = s.x - this.state.x, a.deltaY = s.y - this.state.y;
      }
      if (this.props.onDrag(r, a) === !1) return !1;
      this.setState(s);
    }, this.onDragStop = (r, n) => {
      if (!this.state.dragging || this.props.onStop(r, createDraggableData(this, n)) === !1) return !1;
      log$1("Draggable: onDragStop: %j", n);
      const s = {
        dragging: !1,
        slackX: 0,
        slackY: 0
      };
      if (!!this.props.position) {
        const { x: l, y: x } = this.props.position;
        s.x = l, s.y = x;
      }
      this.setState(s);
    }, this.state = {
      // Whether or not we are currently dragging.
      dragging: !1,
      // Whether or not we have been dragged before.
      dragged: !1,
      // Current transform x and y.
      x: t.position ? t.position.x : t.defaultPosition.x,
      y: t.position ? t.position.y : t.defaultPosition.y,
      prevPropsPosition: { ...t.position },
      // Used for compensating for out-of-bounds drags
      slackX: 0,
      slackY: 0,
      // Can only determine if SVG after mounting
      isElementSVG: !1
    }, t.position && !(t.onDrag || t.onStop) && console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element.");
  }
  // React 16.3+
  // Arity (props, state)
  static getDerivedStateFromProps({ position: t }, { prevPropsPosition: r }) {
    return t && (!r || t.x !== r.x || t.y !== r.y) ? (log$1("Draggable: getDerivedStateFromProps %j", { position: t, prevPropsPosition: r }), {
      x: t.x,
      y: t.y,
      prevPropsPosition: { ...t }
    }) : null;
  }
  componentDidMount() {
    typeof window.SVGElement != "undefined" && this.findDOMNode() instanceof window.SVGElement && this.setState({ isElementSVG: !0 });
  }
  componentWillUnmount() {
    this.state.dragging && this.setState({ dragging: !1 });
  }
  // React 19 removed ReactDOM.findDOMNode, so nodeRef is now required.
  // For backward compatibility with React 18 and earlier, we still support findDOMNode if available.
  findDOMNode() {
    var t;
    if ((t = this.props) != null && t.nodeRef)
      return this.props.nodeRef.current;
    const r = ReactDOM__default;
    return typeof r.findDOMNode == "function" ? r.findDOMNode(this) : null;
  }
  render() {
    const {
      axis: t,
      bounds: r,
      children: n,
      defaultPosition: a,
      defaultClassName: s,
      defaultClassNameDragging: o,
      defaultClassNameDragged: l,
      position: x,
      positionOffset: j,
      scale: Z,
      ...V
    } = this.props;
    let $ = {}, X = null;
    const Y = !!!x || this.state.dragging, U = x || a, G = {
      // Set left if horizontal drag is enabled
      x: canDragX(this) && Y ? this.state.x : U.x,
      // Set top if vertical drag is enabled
      y: canDragY(this) && Y ? this.state.y : U.y
    };
    this.state.isElementSVG ? X = createSVGTransform(G, j) : $ = createCSSTransform(G, j);
    const K = React.Children.only(n), J = clsx(K.props.className || "", s, {
      [o]: this.state.dragging,
      [l]: this.state.dragged
    });
    return /* @__PURE__ */ React.createElement(DraggableCore, { ...V, onStart: this.onDragStart, onDrag: this.onDrag, onStop: this.onDragStop }, React.cloneElement(K, {
      className: J,
      style: { ...K.props.style, ...$ },
      transform: X
    }));
  }
};
Draggable.displayName = "Draggable";
Draggable.propTypes = {
  // Accepts all props <DraggableCore> accepts.
  ...DraggableCore.propTypes,
  /**
   * `axis` determines which axis the draggable can move.
   *
   *  Note that all callbacks will still return data as normal. This only
   *  controls flushing to the DOM.
   *
   * 'both' allows movement horizontally and vertically.
   * 'x' limits movement to horizontal axis.
   * 'y' limits movement to vertical axis.
   * 'none' limits all movement.
   *
   * Defaults to 'both'.
   */
  axis: PropTypes2.oneOf(["both", "x", "y", "none"]),
  /**
   * `bounds` determines the range of movement available to the element.
   * Available values are:
   *
   * 'parent' restricts movement within the Draggable's parent node.
   *
   * Alternatively, pass an object with the following properties, all of which are optional:
   *
   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
   *
   * All values are in px.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable bounds={{right: 300, bottom: 300}}>
   *              <div>Content</div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */
  bounds: PropTypes2.oneOfType([
    PropTypes2.shape({
      left: PropTypes2.number,
      right: PropTypes2.number,
      top: PropTypes2.number,
      bottom: PropTypes2.number
    }),
    PropTypes2.string,
    PropTypes2.oneOf([!1])
  ]),
  defaultClassName: PropTypes2.string,
  defaultClassNameDragging: PropTypes2.string,
  defaultClassNameDragged: PropTypes2.string,
  /**
   * `defaultPosition` specifies the x and y that the dragged item should start at
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */
  defaultPosition: PropTypes2.shape({
    x: PropTypes2.number,
    y: PropTypes2.number
  }),
  positionOffset: PropTypes2.shape({
    x: PropTypes2.oneOfType([PropTypes2.number, PropTypes2.string]),
    y: PropTypes2.oneOfType([PropTypes2.number, PropTypes2.string])
  }),
  /**
   * `position`, if present, defines the current position of the element.
   *
   *  This is similar to how form elements in React work - if no `position` is supplied, the component
   *  is uncontrolled.
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable position={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */
  position: PropTypes2.shape({
    x: PropTypes2.number,
    y: PropTypes2.number
  }),
  /**
   * These properties should be defined on the child, not here.
   */
  className: dontSetMe,
  style: dontSetMe,
  transform: dontSetMe
};
Draggable.defaultProps = {
  ...DraggableCore.defaultProps,
  axis: "both",
  bounds: !1,
  defaultClassName: "react-draggable",
  defaultClassNameDragging: "react-draggable-dragging",
  defaultClassNameDragged: "react-draggable-dragged",
  defaultPosition: { x: 0, y: 0 },
  scale: 1
};
var extendStatics = function(t, r) {
  return extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, a) {
    n.__proto__ = a;
  } || function(n, a) {
    for (var s in a) Object.prototype.hasOwnProperty.call(a, s) && (n[s] = a[s]);
  }, extendStatics(t, r);
};
function __extends(t, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
  extendStatics(t, r);
  function n() {
    this.constructor = t;
  }
  t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
}
var __assign = function() {
  return __assign = Object.assign || function(r) {
    for (var n, a = 1, s = arguments.length; a < s; a++) {
      n = arguments[a];
      for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (r[o] = n[o]);
    }
    return r;
  }, __assign.apply(this, arguments);
};
function __rest(t, r) {
  var n = {};
  for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && r.indexOf(a) < 0 && (n[a] = t[a]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var s = 0, a = Object.getOwnPropertySymbols(t); s < a.length; s++)
      r.indexOf(a[s]) < 0 && Object.prototype.propertyIsEnumerable.call(t, a[s]) && (n[a[s]] = t[a[s]]);
  return n;
}
function __spreadArray(t, r, n) {
  for (var a = 0, s = r.length, o; a < s; a++)
    (o || !(a in r)) && (o || (o = Array.prototype.slice.call(r, 0, a)), o[a] = r[a]);
  return t.concat(o || Array.prototype.slice.call(r));
}
function _typeof(t) {
  "@babel/helpers - typeof";
  return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, _typeof(t);
}
var doc = (typeof document == "undefined" ? "undefined" : _typeof(document)) === "object" ? document : null, isBrowser = typeof window != "undefined" && typeof navigator != "undefined" && typeof document != "undefined", isUndef = function t(r) {
  return typeof r == "undefined";
}, isFun = function t(r) {
  return typeof r == "function";
}, isNum = function t(r) {
  return typeof r == "number";
}, renderDivWithRenderer = function t(r, n) {
  if (isFun(r.renderer)) {
    r.elementRef = n;
    var a = r.renderer;
    return delete r.renderer, a(r);
  }
  return delete r.elementRef, React.createElement("div", __assign({}, r, {
    ref: n
  }));
}, getInnerSize = function t(r, n, a, s) {
  var o = getComputedStyle(r);
  return o.boxSizing === "border-box" ? Math.max(0, (Number.parseFloat(o[n]) || 0) - (Number.parseFloat(o[a]) || 0) - (Number.parseFloat(o[s]) || 0)) : Number.parseFloat(o[n]) || 0;
}, getInnerHeight = function t(r) {
  return getInnerSize(r, "height", "paddingTop", "paddingBottom");
}, getInnerWidth = function t(r) {
  return getInnerSize(r, "width", "paddingLeft", "paddingRight");
}, uuid = function t() {
  for (var r = "", n = 0; n < 32; n++)
    switch (n) {
      case 8:
      case 20: {
        r += "-".concat(Math.trunc(Math.random() * 16).toString(16));
        break;
      }
      case 12: {
        r += "-4";
        break;
      }
      case 16: {
        r += "-".concat((Math.random() * 16 | 0 | 8).toString(16));
        break;
      }
      default:
        r += Math.trunc(Math.random() * 16).toString(16);
    }
  return r;
}, calcThumbSize = function t(r, n, a, s, o) {
  if (n >= r)
    return 0;
  var l = n / r * a;
  return isNum(o) && (l = Math.min(o, l)), isNum(s) && (l = Math.max(s, l)), l;
}, calcThumbOffset = function t(r, n, a, s, o) {
  return !o || !s || n >= r ? 0 : (a - s) * o / (r - n);
}, calcScrollForThumbOffset = function t(r, n, a, s, o) {
  return !o || !s || n >= r ? 0 : o * (r - n) / (a - s);
}, getScrollbarWidth = function t(r) {
  if (r === void 0 && (r = !1), !doc)
    return t._cache = 0, t._cache;
  if (!r && !isUndef(t._cache))
    return t._cache;
  var n = doc.createElement("div");
  if (n.setAttribute("style", "position:absolute;width:100px;height:100px;top:-999px;left:-999px;overflow:scroll;"), doc.body.append(n), n.clientWidth === 0) {
    n.remove();
    return;
  }
  return t._cache = 100 - n.clientWidth, n.remove(), t._cache;
}, shouldReverseRtlScroll = function t(r) {
  if (r === void 0 && (r = !1), !r && !isUndef(t._cache))
    return t._cache;
  if (!doc)
    return t._cache = !1, t._cache;
  var n = doc.createElement("div"), a = doc.createElement("div");
  return n.append(a), n.setAttribute("style", "position:absolute;width:100px;height:100px;top:-999px;left:-999px;overflow:scroll;direction:rtl"), a.setAttribute("style", "width:1000px;height:1000px"), doc.body.append(n), n.scrollLeft = -50, t._cache = n.scrollLeft === -50, n.remove(), t._cache;
}, Emittr = (
  /** @class */
  (function() {
    function t(r) {
      r === void 0 && (r = 10), this.setMaxHandlers(r), this._handlers = /* @__PURE__ */ Object.create(null);
    }
    return t._callEventHandlers = function(r, n, a) {
      if (n.length) {
        if (n.length === 1) {
          Reflect.apply(n[0], r, a);
          return;
        }
        n = __spreadArray([], n);
        var s;
        for (s = 0; s < n.length; s++)
          Reflect.apply(n[s], r, a);
      }
    }, t.prototype.setMaxHandlers = function(r) {
      if (!isNum(r) || r <= 0)
        throw new TypeError("Expected maxHandlers to be a positive number, got '".concat(r, "' of type ").concat(_typeof(r)));
      return this._maxHandlers = r, this;
    }, t.prototype.getMaxHandlers = function() {
      return this._maxHandlers;
    }, t.prototype.emit = function(r) {
      for (var n = [], a = 1; a < arguments.length; a++)
        n[a - 1] = arguments[a];
      return _typeof(this._handlers[r]) !== "object" || !Array.isArray(this._handlers[r]) ? !1 : (t._callEventHandlers(this, this._handlers[r], n), !0);
    }, t.prototype.on = function(r, n) {
      return t._addHandler(this, r, n), this;
    }, t.prototype.prependOn = function(r, n) {
      return t._addHandler(this, r, n, !0), this;
    }, t.prototype.once = function(r, n) {
      if (!isFun(n))
        throw new TypeError("Expected event handler to be a function, got ".concat(_typeof(n)));
      return t._addHandler(this, r, this._wrapOnceHandler(r, n)), this;
    }, t.prototype.prependOnce = function(r, n) {
      if (!isFun(n))
        throw new TypeError("Expected event handler to be a function, got ".concat(_typeof(n)));
      return t._addHandler(this, r, this._wrapOnceHandler(r, n), !0), this;
    }, t.prototype.off = function(r, n) {
      return t._removeHandler(this, r, n), this;
    }, t.prototype.removeAllHandlers = function() {
      var r = this._handlers;
      this._handlers = /* @__PURE__ */ Object.create(null);
      var n = r.removeHandler;
      delete r.removeHandler;
      var a, s;
      for (s in r)
        for (a = r[s].length - 1; a >= 0; a--)
          t._callEventHandlers(this, n, [s, r[s][a].handler || r[s][a]]);
      return this;
    }, t.prototype._wrapOnceHandler = function(r, n) {
      var a = {
        fired: !1,
        handler: n,
        wrappedHandler: void 0,
        emitter: this,
        event: r
      }, s = t._onceWrapper.bind(a);
      return a.wrappedHandler = s, s.handler = n, s.event = r, s;
    }, t._addHandler = function(r, n, a, s) {
      if (s === void 0 && (s = !1), !isFun(a))
        throw new TypeError("Expected event handler to be a function, got ".concat(_typeof(a)));
      return r._handlers[n] = r._handlers[n] || [], r.emit("addHandler", n, a), s ? r._handlers[n].unshift(a) : r._handlers[n].push(a), r;
    }, t._onceWrapper = function() {
      for (var n = [], a = 0; a < arguments.length; a++)
        n[a] = arguments[a];
      this.fired || (this.fired = !0, this.emitter.off(this.event, this.wrappedHandler), Reflect.apply(this.handler, this.emitter, n));
    }, t._removeHandler = function(r, n, a) {
      if (!isFun(a))
        throw new TypeError("Expected event handler to be a function, got ".concat(_typeof(a)));
      if (isUndef(r._handlers[n]) || !r._handlers[n].length)
        return r;
      var s = -1;
      if (r._handlers[n].length === 1)
        (r._handlers[n][0] === a || r._handlers[n][0].handler === a) && (s = 0, a = r._handlers[n][0].handler || r._handlers[n][0]);
      else
        for (s = r._handlers[n].length - 1; s >= 0; s--)
          if (r._handlers[n][s] === a || r._handlers[n][s].handler === a) {
            a = r._handlers[n][s].handler || r._handlers[n][s];
            break;
          }
      return s === -1 || (s === 0 ? r._handlers[n].shift() : r._handlers[n].splice(s, 1), r.emit("removeHandler", n, a)), r;
    }, t;
  })()
), RAFLoop = (
  /** @class */
  (function() {
    function t() {
      var r = this;
      this.targets = [], this.animationFrameID = 0, this._isActive = !1, this.start = function() {
        return !r._isActive && r.targets.length && (r._isActive = !0, r.animationFrameID && cancelAnimationFrame(r.animationFrameID), r.animationFrameID = requestAnimationFrame(r.rafCallback)), r;
      }, this.stop = function() {
        return r._isActive && (r._isActive = !1, r.animationFrameID && cancelAnimationFrame(r.animationFrameID), r.animationFrameID = 0), r;
      }, this.addTarget = function(n, a) {
        return a === void 0 && (a = !1), r.targets.includes(n) || (r.targets.push(n), r.targets.length === 1 && !a && r.start()), r;
      }, this.removeTarget = function(n) {
        var a = r.targets.indexOf(n);
        return a !== -1 && (r.targets.splice(a, 1), r.targets.length === 0 && r.stop()), r;
      }, this.rafCallback = function() {
        if (!r._isActive)
          return 0;
        for (var n = 0; n < r.targets.length; n++)
          r.targets[n]._unmounted || r.targets[n].update();
        return r.animationFrameID = requestAnimationFrame(r.rafCallback), r.animationFrameID;
      };
    }
    return Object.defineProperty(t.prototype, "isActive", {
      /**
       * @description Loop's state.
       */
      get: function() {
        return this._isActive;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  })()
), Loop = new RAFLoop(), AXIS_DIRECTION;
(function(t) {
  t.X = "x", t.Y = "y";
})(AXIS_DIRECTION || (AXIS_DIRECTION = {}));
var TRACK_CLICK_BEHAVIOR;
(function(t) {
  t.JUMP = "jump", t.STEP = "step";
})(TRACK_CLICK_BEHAVIOR || (TRACK_CLICK_BEHAVIOR = {}));
var ScrollbarThumb = (
  /** @class */
  (function(t) {
    __extends(r, t);
    function r() {
      var n = t !== null && t.apply(this, arguments) || this;
      return n.element = null, n.initialOffsetX = 0, n.initialOffsetY = 0, n.elementRefHack = React.createRef(), n.lastDragData = {
        x: 0,
        y: 0,
        deltaX: 0,
        deltaY: 0,
        lastX: 0,
        lastY: 0
      }, n.handleOnDragStart = function(a, s) {
        if (!n.element) {
          n.handleOnDragStop(a, s);
          return;
        }
        isBrowser && (n.prevUserSelect = document.body.style.userSelect, document.body.style.userSelect = "none", n.prevOnSelectStart = document.onselectstart, document.addEventListener("selectstart", r.selectStartReplacer)), n.props.onDragStart && n.props.onDragStart(n.lastDragData = {
          x: s.x - n.initialOffsetX,
          y: s.y - n.initialOffsetY,
          lastX: s.lastX - n.initialOffsetX,
          lastY: s.lastY - n.initialOffsetY,
          deltaX: s.deltaX,
          deltaY: s.deltaY
        }), n.element.classList.add("dragging");
      }, n.handleOnDrag = function(a, s) {
        if (!n.element) {
          n.handleOnDragStop(a, s);
          return;
        }
        n.props.onDrag && n.props.onDrag(n.lastDragData = {
          x: s.x - n.initialOffsetX,
          y: s.y - n.initialOffsetY,
          lastX: s.lastX - n.initialOffsetX,
          lastY: s.lastY - n.initialOffsetY,
          deltaX: s.deltaX,
          deltaY: s.deltaY
        });
      }, n.handleOnDragStop = function(a, s) {
        var o = s ? {
          x: s.x - n.initialOffsetX,
          y: s.y - n.initialOffsetY,
          lastX: s.lastX - n.initialOffsetX,
          lastY: s.lastY - n.initialOffsetY,
          deltaX: s.deltaX,
          deltaY: s.deltaY
        } : n.lastDragData;
        n.props.onDragEnd && n.props.onDragEnd(o), n.element && n.element.classList.remove("dragging"), isBrowser && (document.body.style.userSelect = n.prevUserSelect, n.prevOnSelectStart && document.addEventListener("selectstart", n.prevOnSelectStart), n.prevOnSelectStart = null), n.initialOffsetX = 0, n.initialOffsetY = 0, n.lastDragData = {
          x: 0,
          y: 0,
          deltaX: 0,
          deltaY: 0,
          lastX: 0,
          lastY: 0
        };
      }, n.handleOnMouseDown = function(a) {
        if (n.element)
          if (a.preventDefault(), a.stopPropagation(), !isUndef(a.offsetX))
            n.initialOffsetX = a.offsetX, n.initialOffsetY = a.offsetY;
          else {
            var s = n.element.getBoundingClientRect();
            n.initialOffsetX = (a.clientX || a.touches[0].clientX) - s.left, n.initialOffsetY = (a.clientY || a.touches[0].clientY) - s.top;
          }
      }, n.elementRef = function(a) {
        isFun(n.props.elementRef) && n.props.elementRef(a), n.element = a, n.elementRefHack.current = a;
      }, n;
    }
    return r.prototype.componentDidMount = function() {
      this.element || this.setState(function() {
        throw new Error("<ScrollbarThumb> Element was not created. Possibly you haven't provided HTMLDivElement to renderer's `elementRef` function.");
      });
    }, r.prototype.componentWillUnmount = function() {
      this.handleOnDragStop(), this.elementRef(null);
    }, r.prototype.render = function() {
      var n = this.props;
      n.elementRef;
      var a = n.axis;
      n.onDrag, n.onDragEnd, n.onDragStart;
      var s = __rest(n, ["elementRef", "axis", "onDrag", "onDragEnd", "onDragStart"]);
      return s.className = cnb("ScrollbarsCustom-Thumb", a === AXIS_DIRECTION.X ? "ScrollbarsCustom-ThumbX" : "ScrollbarsCustom-ThumbY", s.className), s.renderer && (s.axis = a), React.createElement(DraggableCore, {
        allowAnyClick: !1,
        enableUserSelectHack: !1,
        onMouseDown: this.handleOnMouseDown,
        onDrag: this.handleOnDrag,
        onStart: this.handleOnDragStart,
        onStop: this.handleOnDragStop,
        nodeRef: this.elementRefHack
      }, renderDivWithRenderer(s, this.elementRef));
    }, r.selectStartReplacer = function() {
      return !1;
    }, r;
  })(React.Component)
), ScrollbarTrack = (
  /** @class */
  (function(t) {
    __extends(r, t);
    function r() {
      var n = t !== null && t.apply(this, arguments) || this;
      return n.element = null, n.elementRef = function(a) {
        isFun(n.props.elementRef) && n.props.elementRef(a), n.element = a;
      }, n.handleClick = function(a) {
        if (!(!a || !n.element || a.button !== 0)) {
          if (isFun(n.props.onClick) && a.target === n.element)
            if (!isUndef(a.offsetX))
              n.props.onClick(a, {
                axis: n.props.axis,
                offset: n.props.axis === AXIS_DIRECTION.X ? a.offsetX : a.offsetY
              });
            else {
              var s = n.element.getBoundingClientRect();
              n.props.onClick(a, {
                axis: n.props.axis,
                offset: n.props.axis === AXIS_DIRECTION.X ? (a.clientX || a.touches[0].clientX) - s.left : (a.clientY || a.touches[0].clientY) - s.top
              });
            }
          return !0;
        }
      }, n;
    }
    return r.prototype.componentDidMount = function() {
      if (!this.element) {
        this.setState(function() {
          throw new Error("Element was not created. Possibly you haven't provided HTMLDivElement to renderer's `elementRef` function.");
        });
        return;
      }
      this.element.addEventListener("click", this.handleClick);
    }, r.prototype.componentWillUnmount = function() {
      this.element && (this.element.removeEventListener("click", this.handleClick), this.element = null, this.elementRef(null));
    }, r.prototype.render = function() {
      var n = this.props;
      n.elementRef;
      var a = n.axis;
      n.onClick;
      var s = __rest(n, ["elementRef", "axis", "onClick"]);
      return s.className = cnb("ScrollbarsCustom-Track", a === AXIS_DIRECTION.X ? "ScrollbarsCustom-TrackX" : "ScrollbarsCustom-TrackY", s.className), s.renderer && (s.axis = a), renderDivWithRenderer(s, this.elementRef);
    }, r;
  })(React.Component)
), style = {
  holder: {
    position: "relative",
    width: "100%",
    height: "100%"
  },
  wrapper: {
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
  },
  content: {
    boxSizing: "border-box"
  },
  track: {
    common: {
      position: "absolute",
      overflow: "hidden",
      borderRadius: 4,
      background: "rgba(0,0,0,.1)",
      userSelect: "none"
    },
    x: {
      height: 10,
      width: "calc(100% - 20px)",
      bottom: 0,
      left: 10
    },
    y: {
      width: 10,
      height: "calc(100% - 20px)",
      top: 10
    }
  },
  thumb: {
    common: {
      cursor: "pointer",
      borderRadius: 4,
      background: "rgba(0,0,0,.4)"
    },
    x: {
      height: "100%",
      width: 0
    },
    y: {
      width: "100%",
      height: 0
    }
  }
}, pageZoomLevel = isBrowser ? i() : 1;
isBrowser && window.addEventListener("resize", function() {
  pageZoomLevel = i();
}, {
  passive: !0
});
var ScrollbarContext = React.createContext({
  parentScrollbar: null
}), Scrollbar$1 = (
  /** @class */
  (function(t) {
    __extends(r, t);
    function r(n) {
      var a = t.call(this, n) || this;
      return a.getScrollState = function(s) {
        if (s === void 0 && (s = !1), a.scrollValues && !s)
          return __assign({}, a.scrollValues);
        var o = {
          clientHeight: 0,
          clientWidth: 0,
          contentScrollHeight: 0,
          contentScrollWidth: 0,
          scrollHeight: 0,
          scrollWidth: 0,
          scrollTop: 0,
          scrollLeft: 0,
          scrollYBlocked: !1,
          scrollXBlocked: !1,
          scrollYPossible: !1,
          scrollXPossible: !1,
          trackYVisible: !1,
          trackXVisible: !1,
          zoomLevel: pageZoomLevel * 1,
          isRTL: void 0
        }, l = a.props;
        return o.isRTL = a.state.isRTL, o.scrollYBlocked = l.noScroll || l.noScrollY, o.scrollXBlocked = l.noScroll || l.noScrollX, a.scrollerElement && (o.clientHeight = a.scrollerElement.clientHeight, o.clientWidth = a.scrollerElement.clientWidth, o.scrollHeight = a.scrollerElement.scrollHeight, o.scrollWidth = a.scrollerElement.scrollWidth, o.scrollTop = a.scrollerElement.scrollTop, o.scrollLeft = a.scrollerElement.scrollLeft, o.scrollYPossible = !o.scrollYBlocked && o.scrollHeight > o.clientHeight, o.scrollXPossible = !o.scrollXBlocked && o.scrollWidth > o.clientWidth, o.trackYVisible = o.scrollYPossible || l.permanentTracks || l.permanentTrackY, o.trackXVisible = o.scrollXPossible || l.permanentTracks || l.permanentTrackX), a.contentElement && (o.contentScrollHeight = a.contentElement.scrollHeight, o.contentScrollWidth = a.contentElement.scrollWidth), o;
      }, a.scrollToTop = function() {
        return a.scrollerElement && (a.scrollerElement.scrollTop = 0), a;
      }, a.scrollToLeft = function() {
        return a.scrollerElement && (a.scrollerElement.scrollLeft = 0), a;
      }, a.scrollToBottom = function() {
        return a.scrollerElement && (a.scrollerElement.scrollTop = a.scrollerElement.scrollHeight - a.scrollerElement.clientHeight), a;
      }, a.scrollToRight = function() {
        return a.scrollerElement && (a.scrollerElement.scrollLeft = a.scrollerElement.scrollWidth - a.scrollerElement.clientWidth), a;
      }, a.scrollTo = function(s, o) {
        return a.scrollerElement && (isNum(s) && (a.scrollerElement.scrollLeft = s), isNum(o) && (a.scrollerElement.scrollTop = o)), a;
      }, a.centerAt = function(s, o) {
        return a.scrollerElement && (isNum(s) && (a.scrollerElement.scrollLeft = s - a.scrollerElement.clientWidth / 2), isNum(o) && (a.scrollerElement.scrollTop = o - a.scrollerElement.clientHeight / 2)), a;
      }, a.update = function(s) {
        if (s === void 0 && (s = !1), !!a.scrollerElement) {
          if (isUndef(a.state.isRTL))
            return a.setState({
              isRTL: getComputedStyle(a.scrollerElement).direction === "rtl"
            }), a.getScrollState();
          var o = a.getScrollState(!0), l = __assign({}, a.scrollValues), x = a.props, j = 0;
          if (s)
            j = 32767;
          else if (l.clientHeight !== o.clientHeight && (j |= Math.trunc(1)), l.clientWidth !== o.clientWidth && (j |= 2), l.scrollHeight !== o.scrollHeight && (j |= 4), l.scrollWidth !== o.scrollWidth && (j |= 8), l.scrollTop !== o.scrollTop && (j |= 16), l.scrollLeft !== o.scrollLeft && (j |= 32), l.scrollYBlocked !== o.scrollYBlocked && (j |= 64), l.scrollXBlocked !== o.scrollXBlocked && (j |= 128), l.scrollYPossible !== o.scrollYPossible && (j |= 256), l.scrollXPossible !== o.scrollXPossible && (j |= 512), l.trackYVisible !== o.trackYVisible && (j |= 1024), l.trackXVisible !== o.trackXVisible && (j |= 2048), l.isRTL !== o.isRTL && (j |= 4096), l.contentScrollHeight !== o.contentScrollHeight && (j |= 8192), l.contentScrollWidth !== o.contentScrollWidth && (j |= 16384), l.zoomLevel !== o.zoomLevel && (j |= 32768), j === 0)
            return l;
          if (!(!x.native && a.holderElement && (j & 8192 && (x.translateContentSizesToHolder || x.translateContentSizeYToHolder) && (a.holderElement.style.height = "".concat(o.contentScrollHeight, "px")), j & 16384 && (x.translateContentSizesToHolder || x.translateContentSizeXToHolder) && (a.holderElement.style.width = "".concat(o.contentScrollWidth, "px")), (x.translateContentSizesToHolder || x.translateContentSizeYToHolder || x.translateContentSizeXToHolder) && (!o.clientHeight && o.contentScrollHeight || !o.clientWidth && o.contentScrollWidth)))) {
            if (j & 1024 || j & 2048) {
              l.scrollYBlocked = o.scrollYBlocked, l.scrollXBlocked = o.scrollXBlocked, l.scrollYPossible = o.scrollYPossible, l.scrollXPossible = o.scrollXPossible, a.trackYElement && j & 1024 && (a.trackYElement.style.display = o.trackYVisible ? "" : "none"), a.trackXElement && j & 2048 && (a.trackXElement.style.display = o.trackXVisible ? "" : "none"), a.scrollValues = l, a.setState({
                trackYVisible: a.scrollValues.trackYVisible = o.trackYVisible,
                trackXVisible: a.scrollValues.trackXVisible = o.trackXVisible
              });
              return;
            }
            return (x.native ? a.updaterNative : a.updaterCustom)(j, o), a.scrollValues = o, !x.native && j & 32768 && (getScrollbarWidth(!0), a.forceUpdate()), a.eventEmitter.emit("update", __assign({}, o), l), (j & 16 || j & 32) && a.eventEmitter.emit("scroll", __assign({}, o), l), a.scrollValues;
          }
        }
      }, a.updaterNative = function() {
        return !0;
      }, a.updaterCustom = function(s, o) {
        var l = a.props;
        if (a.trackYElement && a.thumbYElement && (s & Math.trunc(1) || s & 4 || s & 16 || s & 64 || s & 256))
          if (o.scrollYPossible) {
            var x = getInnerHeight(a.trackYElement), j = calcThumbSize(o.scrollHeight, o.clientHeight, x, l.minimalThumbYSize || l.minimalThumbSize, l.maximalThumbYSize || l.maximalThumbSize), Z = calcThumbOffset(o.scrollHeight, o.clientHeight, x, j, o.scrollTop);
            a.thumbYElement.style.transform = "translateY(".concat(Z, "px)"), a.thumbYElement.style.height = "".concat(j, "px"), a.thumbYElement.style.display = "";
          } else
            a.thumbYElement.style.transform = "", a.thumbYElement.style.height = "0px", a.thumbYElement.style.display = "none";
        if (a.trackXElement && a.thumbXElement && (s & 2 || s & 8 || s & 32 || s & 128 || s & 512 || s & 4096))
          if (o.scrollXPossible) {
            var x = getInnerWidth(a.trackXElement), j = calcThumbSize(o.scrollWidth, o.clientWidth, x, l.minimalThumbXSize || l.minimalThumbSize, l.maximalThumbXSize || l.maximalThumbSize), Z = calcThumbOffset(o.scrollWidth, o.clientWidth, x, j, o.scrollLeft);
            a.state.isRTL && shouldReverseRtlScroll() && (Z += x - j), a.thumbXElement.style.transform = "translateX(".concat(Z, "px)"), a.thumbXElement.style.width = "".concat(j, "px"), a.thumbXElement.style.display = "";
          } else
            a.thumbXElement.style.transform = "", a.thumbXElement.style.width = "0px", a.thumbXElement.style.display = "none";
        return !0;
      }, a.elementRefHolder = function(s) {
        a.holderElement = s, isFun(a.props.elementRef) && a.props.elementRef(s);
      }, a.elementRefWrapper = function(s) {
        a.wrapperElement = s, isFun(a.props.wrapperProps.elementRef) && a.props.wrapperProps.elementRef(s);
      }, a.elementRefScroller = function(s) {
        a.scrollerElement = s, isFun(a.props.scrollerProps.elementRef) && a.props.scrollerProps.elementRef(s);
      }, a.elementRefContent = function(s) {
        a.contentElement = s, isFun(a.props.contentProps.elementRef) && a.props.contentProps.elementRef(s);
      }, a.elementRefTrackX = function(s) {
        a.trackXElement = s, isFun(a.props.trackXProps.elementRef) && a.props.trackXProps.elementRef(s);
      }, a.elementRefTrackY = function(s) {
        a.trackYElement = s, isFun(a.props.trackYProps.elementRef) && a.props.trackYProps.elementRef(s);
      }, a.elementRefThumbX = function(s) {
        a.thumbXElement = s, isFun(a.props.thumbXProps.elementRef) && a.props.thumbXProps.elementRef(s);
      }, a.elementRefThumbY = function(s) {
        a.thumbYElement = s, isFun(a.props.thumbYProps.elementRef) && a.props.thumbYProps.elementRef(s);
      }, a.handleTrackXClick = function(s, o) {
        if (a.props.trackXProps.onClick && a.props.trackXProps.onClick(s, o), !(!a.scrollerElement || !a.trackXElement || !a.thumbXElement || !a.scrollValues || !a.scrollValues.scrollXPossible)) {
          a._scrollDetection();
          var l = a.thumbXElement.clientWidth, x = getInnerWidth(a.trackXElement), j = (a.scrollValues.isRTL && shouldReverseRtlScroll() ? o.offset + l / 2 - x : o.offset - l / 2) - (Number.parseFloat(getComputedStyle(a.trackXElement).paddingLeft) || 0), Z = calcScrollForThumbOffset(a.scrollValues.scrollWidth, a.scrollValues.clientWidth, x, l, j);
          a.props.trackClickBehavior === TRACK_CLICK_BEHAVIOR.STEP && (Z = (a.scrollValues.isRTL ? a.scrollValues.scrollLeft > Z : a.scrollValues.scrollLeft < Z) ? a.scrollValues.scrollLeft + a.scrollValues.clientWidth : a.scrollValues.scrollLeft - a.scrollValues.clientWidth), a.scrollerElement.scrollLeft = Z;
        }
      }, a.handleTrackYClick = function(s, o) {
        if (a.props.trackYProps.onClick && a.props.trackYProps.onClick(s, o), !(!a.scrollerElement || !a.trackYElement || !a.thumbYElement || !a.scrollValues || !a.scrollValues.scrollYPossible)) {
          a._scrollDetection();
          var l = a.thumbYElement.clientHeight, x = calcScrollForThumbOffset(a.scrollValues.scrollHeight, a.scrollValues.clientHeight, getInnerHeight(a.trackYElement), l, o.offset - l / 2) - (Number.parseFloat(getComputedStyle(a.trackYElement).paddingTop) || 0);
          a.props.trackClickBehavior === TRACK_CLICK_BEHAVIOR.JUMP ? a.scrollerElement.scrollTop = x : a.scrollerElement.scrollTop = a.scrollValues.scrollTop < x ? a.scrollValues.scrollTop + a.scrollValues.clientHeight : a.scrollValues.scrollTop - a.scrollValues.clientHeight;
        }
      }, a.handleTrackYMouseWheel = function(s) {
        var o = a.props;
        o.trackYProps && o.trackYProps.onWheel && o.trackYProps.onWheel(s), !(o.disableTracksMousewheelScrolling || o.disableTrackYMousewheelScrolling) && (a._scrollDetection(), !(!a.scrollerElement || a.scrollValues.scrollYBlocked) && (a.scrollTop += s.deltaY));
      }, a.handleTrackXMouseWheel = function(s) {
        var o = a.props;
        o.trackXProps && o.trackXProps.onWheel && o.trackXProps.onWheel(s), !(o.disableTracksMousewheelScrolling || o.disableTrackXMousewheelScrolling) && (a._scrollDetection(), !(!a.scrollerElement || a.scrollValues.scrollXBlocked) && (a.scrollLeft += s.deltaX));
      }, a.handleThumbXDrag = function(s) {
        var o;
        if (!(!a.trackXElement || !a.thumbXElement || !a.scrollerElement || !a.scrollValues || !a.scrollValues.scrollXPossible)) {
          a._scrollDetection();
          var l = a.trackXElement.getBoundingClientRect(), x = getComputedStyle(a.trackXElement), j = Number.parseFloat(x.paddingLeft) || 0, Z = Number.parseFloat(x.paddingRight) || 0, V = l.width - j - Z, $ = a.thumbXElement.clientWidth, X = a.scrollValues.isRTL && shouldReverseRtlScroll() ? s.x + $ - V + j : s.lastX - j;
          a.scrollerElement.scrollLeft = calcScrollForThumbOffset(a.scrollValues.scrollWidth, a.scrollValues.clientWidth, V, $, X), !((o = a.props.thumbXProps) === null || o === void 0) && o.onDrag && a.props.thumbXProps.onDrag(s);
        }
      }, a.handleThumbXDragEnd = function(s) {
        var o;
        a.handleThumbXDrag(s), !((o = a.props.thumbXProps) === null || o === void 0) && o.onDragEnd && a.props.thumbXProps.onDragEnd(s);
      }, a.handleThumbYDrag = function(s) {
        var o;
        if (!(!a.scrollerElement || !a.trackYElement || !a.thumbYElement || !a.scrollValues || !a.scrollValues.scrollYPossible)) {
          a._scrollDetection();
          var l = a.trackYElement.getBoundingClientRect(), x = getComputedStyle(a.trackYElement), j = Number.parseFloat(x.paddingTop) || 0, Z = Number.parseFloat(x.paddingBottom) || 0, V = l.height - j - Z, $ = a.thumbYElement.clientHeight, X = s.y - j;
          a.scrollerElement.scrollTop = calcScrollForThumbOffset(a.scrollValues.scrollHeight, a.scrollValues.clientHeight, V, $, X), !((o = a.props.thumbYProps) === null || o === void 0) && o.onDrag && a.props.thumbYProps.onDrag(s);
        }
      }, a.handleThumbYDragEnd = function(s) {
        var o;
        a.handleThumbYDrag(s), !((o = a.props.thumbYProps) === null || o === void 0) && o.onDragEnd && a.props.thumbYProps.onDragEnd(s);
      }, a.handleScrollerScroll = function() {
        a._scrollDetection();
      }, a._scrollDetection = function() {
        a._scrollDetectionTO ? isBrowser && window.clearTimeout(a._scrollDetectionTO) : a.eventEmitter.emit("scrollStart", a.getScrollState()), a._scrollDetectionTO = isBrowser ? window.setTimeout(a._scrollDetectionCallback, a.props.scrollDetectionThreshold || 0) : null;
      }, a._scrollDetectionCallback = function() {
        a._scrollDetectionTO = null, a.eventEmitter.emit("scrollStop", a.getScrollState());
      }, a.state = {
        trackXVisible: !1,
        trackYVisible: !1,
        isRTL: n.rtl
      }, a.scrollValues = a.getScrollState(!0), a.eventEmitter = new Emittr(15), n.onUpdate && a.eventEmitter.on("update", n.onUpdate), n.onScroll && a.eventEmitter.on("scroll", n.onScroll), n.onScrollStart && a.eventEmitter.on("scrollStart", n.onScrollStart), n.onScrollStop && a.eventEmitter.on("scrollStop", n.onScrollStop), a.id = uuid(), a;
    }
    return Object.defineProperty(r.prototype, "scrollTop", {
      // eslint-disable-next-line react/sort-comp
      get: function() {
        return this.scrollerElement ? this.scrollerElement.scrollTop : 0;
      },
      set: function(a) {
        this.scrollerElement && (this.scrollerElement.scrollTop = a, this.update());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "scrollLeft", {
      get: function() {
        return this.scrollerElement ? this.scrollerElement.scrollLeft : 0;
      },
      set: function(a) {
        this.scrollerElement && (this.scrollerElement.scrollLeft = a);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "scrollHeight", {
      get: function() {
        return this.scrollerElement ? this.scrollerElement.scrollHeight : 0;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "scrollWidth", {
      get: function() {
        return this.scrollerElement ? this.scrollerElement.scrollWidth : 0;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "clientHeight", {
      get: function() {
        return this.scrollerElement ? this.scrollerElement.clientHeight : 0;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "clientWidth", {
      get: function() {
        return this.scrollerElement ? this.scrollerElement.clientWidth : 0;
      },
      enumerable: !1,
      configurable: !0
    }), r.calculateStyles = function(n, a, s, o) {
      var l, x, j, Z, V = !n.noDefaultStyles;
      return {
        holder: __assign(__assign(__assign({}, V && style.holder), {
          position: "relative"
        }), n.style),
        wrapper: __assign(__assign(__assign({}, V && __assign(__assign(__assign({}, style.wrapper), !n.disableTracksWidthCompensation && !n.disableTrackYWidthCompensation && (l = {}, l[a.isRTL ? "left" : "right"] = a.trackYVisible ? 10 : 0, l)), !n.disableTracksWidthCompensation && !n.disableTrackXWidthCompensation && {
          bottom: a.trackXVisible ? 10 : 0
        })), n.wrapperProps.style), {
          position: "absolute",
          overflow: "hidden"
        }),
        content: __assign(__assign(__assign(__assign(__assign({}, V && style.content), n.translateContentSizesToHolder || n.translateContentSizeYToHolder || n.translateContentSizeXToHolder ? {
          display: "table-cell"
        } : {
          padding: 0.05
          // needed to disable margin collapsing without flexboxes, other possible solutions here: https://stackoverflow.com/questions/19718634/how-to-disable-margin-collapsing
        }), V && !(n.translateContentSizesToHolder || n.translateContentSizeYToHolder) && {
          minHeight: "100%"
        }), V && !(n.translateContentSizesToHolder || n.translateContentSizeXToHolder) && {
          minWidth: "100%"
        }), n.contentProps.style),
        scroller: __assign(__assign(__assign(__assign((x = {
          position: "absolute",
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          paddingBottom: !o && s.scrollXPossible ? n.fallbackScrollbarWidth : void 0
        }, x[a.isRTL ? "paddingLeft" : "paddingRight"] = !o && s.scrollYPossible ? n.fallbackScrollbarWidth : void 0, x), n.scrollerProps.style), !isUndef(n.rtl) && {
          direction: n.rtl ? "rtl" : "ltr"
        }), n.momentum && {
          WebkitOverflowScrolling: "touch"
        }), (j = {
          overflowY: s.scrollYPossible ? "scroll" : "hidden",
          overflowX: s.scrollXPossible ? "scroll" : "hidden",
          marginBottom: s.scrollXPossible ? -(o || n.fallbackScrollbarWidth) - +(s.zoomLevel !== 1) : void 0
        }, j[a.isRTL ? "marginLeft" : "marginRight"] = s.scrollYPossible ? -(o || n.fallbackScrollbarWidth) - +(s.zoomLevel !== 1) : void 0, j)),
        trackX: __assign(__assign(__assign(__assign({}, V && style.track.common), V && style.track.x), n.trackXProps.style), !a.trackXVisible && {
          display: "none"
        }),
        trackY: __assign(__assign(__assign(__assign(__assign({}, V && style.track.common), V && style.track.y), V && (Z = {}, Z[a.isRTL ? "left" : "right"] = 0, Z)), n.trackYProps.style), !a.trackYVisible && {
          display: "none"
        }),
        thumbX: __assign(__assign(__assign({}, V && style.thumb.common), V && style.thumb.x), n.thumbXProps.style),
        thumbY: __assign(__assign(__assign({}, V && style.thumb.common), V && style.thumb.y), n.thumbYProps.style)
      };
    }, r.prototype.componentDidMount = function() {
      if (!this.scrollerElement) {
        this.setState(function() {
          throw new Error("scroller element was not created. Possibly you haven't provided HTMLDivElement to renderer's `elementRef` function.");
        });
        return;
      }
      if (!this.contentElement) {
        this.setState(function() {
          throw new Error("content element was not created. Possibly you haven't provided HTMLDivElement to renderer's `elementRef` function.");
        });
        return;
      }
      var n = this.props;
      if (!n.native && !n.mobileNative) {
        if (!this.holderElement) {
          this.setState(function() {
            throw new Error("holder element was not created. Possibly you haven't provided HTMLDivElement to renderer's `elementRef` function.");
          });
          return;
        }
        if (!this.wrapperElement) {
          this.setState(function() {
            throw new Error("wrapper element was not created. Possibly you haven't provided HTMLDivElement to renderer's `elementRef` function.");
          });
          return;
        }
      }
      Loop.addTarget(this), isUndef(n.scrollTop) || (this.scrollerElement.scrollTop = n.scrollTop), isUndef(n.scrollLeft) || (this.scrollerElement.scrollLeft = n.scrollLeft), this.update(!0);
    }, r.prototype.componentWillUnmount = function() {
      Loop.removeTarget(this);
    }, r.prototype.componentDidUpdate = function(n, a) {
      if (this.scrollerElement) {
        var s = this.props;
        s.rtl !== n.rtl && s.rtl !== this.state.isRTL && this.setState({
          isRTL: s.rtl
        }), this.state.isRTL !== a.isRTL && this.update(), !isUndef(s.scrollTop) && s.scrollTop !== this.scrollerElement.scrollTop && (this.scrollerElement.scrollTop = s.scrollTop), !isUndef(s.scrollLeft) && s.scrollLeft !== this.scrollerElement.scrollLeft && (this.scrollerElement.scrollLeft = s.scrollLeft), n.onUpdate !== s.onUpdate && (n.onUpdate && this.eventEmitter.off("update", n.onUpdate), s.onUpdate && this.eventEmitter.on("update", s.onUpdate)), n.onScroll !== s.onScroll && (n.onScroll && this.eventEmitter.off("scroll", n.onScroll), s.onScroll && this.eventEmitter.on("scroll", s.onScroll)), n.onScrollStart !== s.onScrollStart && (n.onScrollStart && this.eventEmitter.off("scrollStart", n.onScrollStart), s.onScrollStart && this.eventEmitter.on("scrollStart", s.onScrollStart)), n.onScrollStop !== s.onScrollStop && (n.onScrollStop && this.eventEmitter.off("scrollStop", n.onScrollStop), s.onScrollStop && this.eventEmitter.on("scrollStop", s.onScrollStop));
      }
    }, r.prototype.render = function() {
      var n = this.props, a = n.createContext, s = n.rtl, o = n.native, l = n.mobileNative, x = n.momentum;
      n.noDefaultStyles;
      var j = n.disableTracksMousewheelScrolling, Z = n.disableTrackXMousewheelScrolling, V = n.disableTrackYMousewheelScrolling;
      n.disableTracksWidthCompensation, n.disableTrackXWidthCompensation, n.disableTrackYWidthCompensation;
      var $ = n.noScrollX, X = n.noScrollY, W = n.noScroll, Y = n.permanentTrackX, U = n.permanentTrackY, G = n.permanentTracks, K = n.removeTracksWhenNotUsed, J = n.removeTrackYWhenNotUsed, ee = n.removeTrackXWhenNotUsed;
      n.minimalThumbSize, n.maximalThumbSize, n.minimalThumbXSize, n.maximalThumbXSize, n.minimalThumbYSize, n.maximalThumbYSize, n.fallbackScrollbarWidth, n.scrollTop, n.scrollLeft, n.trackClickBehavior, n.scrollDetectionThreshold;
      var te = n.wrapperProps, re = n.scrollerProps, ae = n.contentProps, ie = n.trackXProps, ce = n.trackYProps, he = n.thumbXProps, oe = n.thumbYProps, le = n.scrollbarWidth;
      n.elementRef, n.onUpdate, n.onScroll, n.onScrollStart, n.onScrollStop, n.translateContentSizesToHolder, n.translateContentSizeYToHolder, n.translateContentSizeXToHolder;
      var pe = n.children, de = __rest(n, ["createContext", "rtl", "native", "mobileNative", "momentum", "noDefaultStyles", "disableTracksMousewheelScrolling", "disableTrackXMousewheelScrolling", "disableTrackYMousewheelScrolling", "disableTracksWidthCompensation", "disableTrackXWidthCompensation", "disableTrackYWidthCompensation", "noScrollX", "noScrollY", "noScroll", "permanentTrackX", "permanentTrackY", "permanentTracks", "removeTracksWhenNotUsed", "removeTrackYWhenNotUsed", "removeTrackXWhenNotUsed", "minimalThumbSize", "maximalThumbSize", "minimalThumbXSize", "maximalThumbXSize", "minimalThumbYSize", "maximalThumbYSize", "fallbackScrollbarWidth", "scrollTop", "scrollLeft", "trackClickBehavior", "scrollDetectionThreshold", "wrapperProps", "scrollerProps", "contentProps", "trackXProps", "trackYProps", "thumbXProps", "thumbYProps", "scrollbarWidth", "elementRef", "onUpdate", "onScroll", "onScrollStart", "onScrollStop", "translateContentSizesToHolder", "translateContentSizeYToHolder", "translateContentSizeXToHolder", "children"]), se = isUndef(le) ? getScrollbarWidth() || 0 : le;
      if (o || !se && l) {
        this.elementRefHolder(null), this.elementRefWrapper(null), this.elementRefTrackX(null), this.elementRefTrackY(null), this.elementRefThumbX(null), this.elementRefThumbY(null);
        var ue = __assign(__assign({}, ae), {
          key: "ScrollbarsCustom-Content",
          className: cnb("ScrollbarsCustom-Content", ae.className),
          children: pe
        }), fe = __assign(__assign({}, de), {
          className: cnb("ScrollbarsCustom native", this.state.trackYVisible && "trackYVisible", this.state.trackXVisible && "trackXVisible", this.state.isRTL && "rtl", de.className),
          style: __assign(__assign(__assign(__assign({}, de.style), !isUndef(s) && {
            direction: s ? "rtl" : "ltr"
          }), x && {
            WebkitOverflowScrolling: "touch"
          }), {
            overflowX: W || $ ? "hidden" : G || Y ? "scroll" : "auto",
            overflowY: W || X ? "hidden" : G || U ? "scroll" : "auto"
          }),
          onScroll: this.handleScrollerScroll,
          children: renderDivWithRenderer(ue, this.elementRefContent),
          renderer: re.renderer,
          elementRef: re.elementRef
        });
        return renderDivWithRenderer(fe, this.elementRefScroller);
      }
      var ge = r.calculateStyles(this.props, this.state, this.scrollValues, se), ne = [], ve = __assign(__assign({}, ae), {
        key: "ScrollbarsCustom-Content",
        className: cnb("ScrollbarsCustom-Content", ae.className),
        style: ge.content,
        children: a ? (
          // eslint-disable-next-line react/jsx-no-constructed-context-values
          React.createElement(ScrollbarContext.Provider, {
            value: {
              parentScrollbar: this
            }
          }, pe)
        ) : pe
      }), me = __assign(__assign({}, re), {
        key: "ScrollbarsCustom-Scroller",
        className: cnb("ScrollbarsCustom-Scroller", re.className),
        style: ge.scroller,
        children: renderDivWithRenderer(ve, this.elementRefContent),
        onScroll: this.handleScrollerScroll
      }), xe = __assign(__assign({}, te), {
        key: "ScrollbarsCustom-Wrapper",
        className: cnb("ScrollbarsCustom-Wrapper", te.className),
        style: ge.wrapper,
        children: renderDivWithRenderer(me, this.elementRefScroller)
      });
      if (ne.push(renderDivWithRenderer(xe, this.elementRefWrapper)), this.state.trackYVisible || !K && !J) {
        var Ee = __assign(__assign({}, oe), {
          key: "ScrollbarsCustom-ThumbY",
          style: ge.thumbY,
          elementRef: this.elementRefThumbY,
          onDrag: this.handleThumbYDrag,
          onDragEnd: this.handleThumbYDragEnd,
          axis: AXIS_DIRECTION.Y
        }), Se = __assign(__assign(__assign(__assign({}, ce), {
          key: "ScrollbarsCustom-TrackY",
          style: ge.trackY,
          elementRef: this.elementRefTrackY,
          onClick: this.handleTrackYClick
        }), (j || V) && {
          onWheel: this.handleTrackYMouseWheel
        }), {
          axis: AXIS_DIRECTION.Y
        });
        Se.children = React.createElement(ScrollbarThumb, __assign({}, Ee)), ne.push(React.createElement(ScrollbarTrack, __assign({}, Se)));
      } else
        this.elementRefTrackY(null), this.elementRefThumbY(null);
      if (this.state.trackXVisible || !K && !ee) {
        var _e = __assign(__assign({}, he), {
          key: "ScrollbarsCustom-ThumbX",
          style: ge.thumbX,
          elementRef: this.elementRefThumbX,
          onDrag: this.handleThumbXDrag,
          onDragEnd: this.handleThumbXDragEnd,
          axis: AXIS_DIRECTION.X
        }), Ce = __assign(__assign(__assign(__assign({}, ie), {
          key: "ScrollbarsCustom-TrackX",
          style: ge.trackX,
          elementRef: this.elementRefTrackX,
          onClick: this.handleTrackXClick
        }), (j || Z) && {
          onWheel: this.handleTrackXMouseWheel
        }), {
          axis: AXIS_DIRECTION.X
        });
        Ce.children = React.createElement(ScrollbarThumb, __assign({}, _e)), ne.push(React.createElement(ScrollbarTrack, __assign({}, Ce)));
      } else
        this.elementRefTrackX(null), this.elementRefThumbX(null);
      var Te = __assign(__assign({}, de), {
        className: cnb("ScrollbarsCustom", this.state.trackYVisible && "trackYVisible", this.state.trackXVisible && "trackXVisible", this.state.isRTL && "rtl", de.className),
        style: ge.holder,
        children: ne
      });
      return renderDivWithRenderer(Te, this.elementRefHolder);
    }, r.contextType = ScrollbarContext, r.defaultProps = {
      momentum: !0,
      minimalThumbSize: 30,
      fallbackScrollbarWidth: 20,
      trackClickBehavior: TRACK_CLICK_BEHAVIOR.JUMP,
      scrollDetectionThreshold: 100,
      wrapperProps: {},
      scrollerProps: {},
      contentProps: {},
      trackXProps: {},
      trackYProps: {},
      thumbXProps: {},
      thumbYProps: {}
    }, r;
  })(React.Component)
);
function Scrollbar({
  className: t,
  style: r,
  noScrollX: n,
  noScrollY: a,
  wrapperClassName: s,
  contentClassName: o,
  createContext: l,
  scrollTop: x,
  scrollLeft: j,
  scrollDetectionThreshold: Z,
  onUpdate: V,
  onScroll: $,
  onScrollStart: X,
  onScrollStop: W,
  children: Y
}) {
  const [U, G] = useState$1(!1), [K, J] = useState$1(!1), ee = U || K, te = useCallback(() => G(!0), []), re = useCallback(() => G(!1), []), ae = useCallback(() => J(!0), []), ie = useCallback(() => J(!1), []);
  return /* @__PURE__ */ jsx(
    Scrollbar$1,
    {
      className: t,
      style: r,
      noScrollX: n,
      noScrollY: a,
      createContext: l,
      scrollTop: x,
      scrollLeft: j,
      scrollDetectionThreshold: Z,
      onUpdate: V,
      onScroll: $,
      onScrollStart: X,
      onScrollStop: W,
      wrapperProps: {
        className: clsx(s, "go-scrollbar__wrapper"),
        onMouseEnter: te,
        onMouseLeave: re
      },
      scrollerProps: {
        onTouchStart: te,
        onTouchEnd: re,
        onTouchCancel: re
      },
      contentProps: {
        className: clsx(o, "go-scrollbar__content")
      },
      trackYProps: {
        className: clsx(
          "go-scrollbar__track",
          "go-scrollbar__track_orientation_vertical",
          !ee && "go-scrollbar__track_hidden"
        ),
        onMouseEnter: ae,
        onMouseLeave: ie
      },
      trackXProps: {
        className: clsx(
          "go-scrollbar__track",
          "go-scrollbar__track_orientation_horizontal",
          !ee && "go-scrollbar__track_hidden"
        ),
        onMouseEnter: ae,
        onMouseLeave: ie
      },
      thumbXProps: {
        style: {
          background: "var(--go-scrollbar-thumb-bg)",
          border: "var(--go-scrollbar-thumb-border)"
        }
      },
      thumbYProps: {
        style: {
          background: "var(--go-scrollbar-thumb-bg)",
          border: "var(--go-scrollbar-thumb-border)"
        }
      },
      children: Y
    }
  );
}
const KEY_DIVIDER = "_";
function generateId(t, r) {
  return `${t}${KEY_DIVIDER}${r}`;
}
function CalendarTimeOptions({
  options: t,
  selectedOption: r,
  onChange: n,
  title: a,
  disabled: s,
  isOptionDisabled: o = () => !1
}) {
  const x = `go-calendar-time-option-${useId$3()}`, j = useRef(null), [Z, V] = useState$1(0), $ = useRef(0);
  useEffect(() => {
    const W = j.current;
    if (!r || !W)
      return;
    const Y = document.getElementById(generateId(x, r.key));
    if (!Y)
      return;
    const U = W.getBoundingClientRect(), G = Y.getBoundingClientRect(), K = animate(
      $.current,
      G.top - U.top,
      V,
      (J) => {
        $.current = J;
      }
    );
    return () => K();
  }, [x, r]);
  const X = useCallback((W) => {
    "scrollTop" in W && ($.current = W.scrollTop, V(W.scrollTop));
  }, []);
  return /* @__PURE__ */ jsxs("div", { className: "go-calendar__time-options-wrapper", children: [
    renderNode(a, "p", "go-calendar__time-options-header"),
    /* @__PURE__ */ jsx(Scrollbar, { noScrollX: !0, scrollTop: Z, onScroll: X, children: /* @__PURE__ */ jsx("div", { ref: j, className: "go-calendar__time-options", children: t.map((W) => /* @__PURE__ */ jsx(
      "button",
      {
        id: generateId(x, W.key),
        disabled: s || o(W.value),
        className: clsx(
          "go-calendar__time-option",
          W.key === (r == null ? void 0 : r.key) && "go-calendar__time-option_selected"
        ),
        onClick: () => n(W),
        children: /* @__PURE__ */ jsx("span", { className: "go-calendar__time-option-inner", children: W.value })
      },
      W.key
    )) }) })
  ] });
}
const { hours: hourOptions, minutes: minuteOptions } = getTimeOptions();
function CalendarTime({
  hours: t,
  minutes: r,
  viewSettings: n = { hours: !0, minutes: !0 },
  className: a,
  disabled: s,
  onHourChange: o,
  onMinuteChange: l,
  isHourDisabled: x = () => !1,
  isMinuteDisabled: j = () => !1
}) {
  var X, W, Y, U;
  const { localization: Z } = useContext(ConfigContext), V = hourOptions.find((G) => G.value === t), $ = minuteOptions.find((G) => G.value === r);
  return /* @__PURE__ */ jsxs("div", { className: clsx("go-calendar__time-wrapper", s && "go-calendar__time-wrapper_disabled", a), children: [
    n.hours && /* @__PURE__ */ jsx(
      CalendarTimeOptions,
      {
        options: hourOptions,
        selectedOption: V,
        title: (W = (X = Z == null ? void 0 : Z.calendar) == null ? void 0 : X.values) == null ? void 0 : W.hour,
        onChange: o,
        isOptionDisabled: x,
        disabled: s
      }
    ),
    n.minutes && /* @__PURE__ */ jsx(
      CalendarTimeOptions,
      {
        options: minuteOptions,
        selectedOption: $,
        title: (U = (Y = Z == null ? void 0 : Z.calendar) == null ? void 0 : Y.values) == null ? void 0 : U.minuteShort,
        onChange: l,
        isOptionDisabled: j,
        disabled: s
      }
    )
  ] });
}
function shouldShowTime$1(t) {
  return typeof t == "boolean" ? t : typeof t == "object" ? !!t.hours || !!t.minutes : !1;
}
const Calendar$1 = ({
  value: t = null,
  defaultValue: r = null,
  showTime: n = !1,
  mode: a = "month",
  config: s,
  className: o,
  style: l,
  onChange: x,
  isDateDisabled: j,
  isHourDisabled: Z,
  isMinuteDisabled: V
}) => {
  var re, ae;
  const [$, X] = useReducer(
    reducer,
    initialState,
    (ie) => initStore(ie, t, r, null, a)
  );
  useEffect(() => {
    t !== null && X({ type: "SET_DATE", payload: t });
  }, [t]);
  const W = useMemo$1(
    () => ({ ...DEFAULT_CALENDAR_CONFIG, ...s }),
    [s]
  ), Y = useCallback(
    (ie) => {
      var oe, le, pe;
      const ce = /* @__PURE__ */ new Date(), he = applyTime(ie, (oe = $.hours) != null ? oe : getHours(ce), (le = $.minutes) != null ? le : getMinutes(ce));
      x == null || x((pe = he == null ? void 0 : he.getTime()) != null ? pe : null);
    },
    [x, $.hours, $.minutes]
  ), U = useCallback(
    (ie) => {
      var he;
      if (X({ type: "SET_HOURS", payload: ie.value }), $.mode !== "month" || $.minutes === null || t === null)
        return;
      const ce = applyTime(toDate(t), ie.value, $.minutes);
      x == null || x((he = ce == null ? void 0 : ce.getTime()) != null ? he : null);
    },
    [x, t, $.minutes, $.mode]
  ), G = useCallback(
    (ie) => {
      var he;
      if (X({ type: "SET_MINUTES", payload: ie.value }), $.mode !== "month" || $.hours === null || t === null)
        return;
      const ce = applyTime(toDate(t), $.hours, ie.value);
      x == null || x((he = ce == null ? void 0 : ce.getTime()) != null ? he : null);
    },
    [x, $.hours, $.mode, t]
  ), K = useCallback(
    (ie) => Z ? $.mode === "year" ? !0 : Z(ie, t !== null ? applyTime(toDate(t), ie, $.minutes) : null) : !1,
    [Z, $.minutes, $.mode, t]
  ), J = useCallback(
    (ie) => V ? $.mode === "year" ? !0 : V(
      ie,
      $.hours,
      t !== null ? applyTime(toDate(t), $.hours, ie) : null
    ) : !1,
    [V, $.hours, $.mode, t]
  ), ee = useCallback((ie, ce) => {
    X({ type: "SET_MONTH", payload: { month: ie, year: ce } });
  }, []), te = shouldShowTime$1(n);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: clsx("go-calendar", te && "go-calendar_with-time", o),
      style: {
        ...l,
        "--dates-container-height": `${W.weekRowHeight * NUMBER_OF_WEEKS_ON_PAGE}px`
      },
      children: [
        /* @__PURE__ */ jsx(
          CalendarHeader,
          {
            month: (re = $.month) != null ? re : getMonth(/* @__PURE__ */ new Date()),
            year: (ae = $.year) != null ? ae : getYear(/* @__PURE__ */ new Date()),
            mode: $.mode,
            onChange: (ie, ce) => {
              X({ type: "SET_MONTH", payload: { month: ie, year: ce } });
            },
            onTitleClick: () => {
              X({ type: "TOGGLE_MODE" });
            }
          }
        ),
        $.mode === "month" && /* @__PURE__ */ jsx(
          CalendarMonthPage,
          {
            month: $.month,
            year: $.year,
            selectedDate: t,
            config: W,
            onDateChange: Y,
            onMonthChange: ee,
            isDateDisabled: j
          }
        ),
        $.mode === "year" && /* @__PURE__ */ jsx(
          CalendarYearPage,
          {
            month: $.month,
            year: $.year,
            onYearChange: (ie) => {
              X({ type: "SET_YEAR", payload: ie });
            },
            onMonthChange: (ie) => {
              X({ type: "SET_MONTH", payload: { month: ie } });
            }
          }
        ),
        te && /* @__PURE__ */ jsx(
          CalendarTime,
          {
            hours: $.hours,
            minutes: $.minutes,
            onHourChange: U,
            onMinuteChange: G,
            viewSettings: typeof n == "object" ? n : void 0,
            isHourDisabled: K,
            isMinuteDisabled: J,
            disabled: $.mode === "year"
          }
        )
      ]
    }
  );
};
function toUnix(t) {
  return t == null || Number.isNaN(t) || typeof t == "number" && !Number.isFinite(t) ? null : toDate(t).getTime();
}
function useDisabledRange({ minDate: t, maxDate: r }) {
  const n = toUnix(t), a = toUnix(r);
  return useMemo$1(
    () => ({
      isDateDisabled(s) {
        return n !== null && isBefore(s, startOfDay(n)) || a !== null && isAfter(s, endOfDay(a));
      },
      isHourDisabled(s, o) {
        return o === null ? !1 : n !== null && isBefore(o, startOfHour(n)) || a !== null && isAfter(o, endOfHour(a));
      },
      isMinuteDisabled(s, o, l) {
        return l === null ? !1 : n !== null && isBefore(l, startOfMinute(n)) || a !== null && isAfter(l, endOfMinute(a));
      }
    }),
    [a, n]
  );
}
const stateClassNames = {
  checked: "go-checkbox_state_checked",
  unchecked: "go-checkbox_state_unchecked",
  intermediate: "go-checkbox_state_intermediate"
}, sizeClassNames$4 = {
  s: "go-checkbox_size_s",
  m: "go-checkbox_size_m"
};
function getCheckboxState(t, r) {
  return r ? "intermediate" : t ? "checked" : "unchecked";
}
const Checkbox = forwardRef(function t({
  initialValue: r = !1,
  checked: n,
  intermediate: a = !1,
  name: s,
  disabled: o,
  className: l,
  labelClassName: x,
  style: j,
  size: Z,
  loading: V = !1,
  onChange: $,
  children: X,
  tabIndex: W,
  autoFocus: Y,
  onKeyDown: U
}, G) {
  const { size: K } = useGlobalComponentConfig({ size: Z }), ee = `go-checkbox-${useId$3()}`, [te, re] = useState$1(r);
  useEffect(() => {
    re(r);
  }, [r]);
  const ae = useMemo$1(
    () => getCheckboxState(n != null ? n : te, a),
    [a, n, te]
  ), ie = (ce) => {
    const { checked: he } = ce.currentTarget;
    n == null && re(he), $ && $(he, ce);
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: clsx(
        l,
        "go-checkbox",
        stateClassNames[ae],
        sizeClassNames$4[K],
        V && "go-checkbox_loading"
      ),
      style: j,
      children: [
        V ? /* @__PURE__ */ jsx(LoaderIcon, { size: "s" }) : /* @__PURE__ */ jsxs("div", { className: "go-checkbox__field", children: [
          /* @__PURE__ */ jsx(
            "input",
            {
              ref: G,
              id: ee,
              type: "checkbox",
              name: s,
              checked: n != null ? n : te,
              disabled: o,
              className: "go-checkbox__input",
              tabIndex: W,
              autoFocus: Y,
              onChange: ie,
              onKeyDown: U
            }
          ),
          /* @__PURE__ */ jsx("label", { htmlFor: ee, className: "go-checkbox__container" }),
          /* @__PURE__ */ jsx("div", { className: clsx("go-checkbox__inner") })
        ] }),
        !!X && /* @__PURE__ */ jsx("label", { htmlFor: ee, className: clsx("go-checkbox__label", x), children: X })
      ]
    }
  );
}), CheckboxGroup = ({
  value: t,
  name: r,
  items: n,
  itemClassName: a,
  onChange: s,
  style: o,
  className: l
}) => {
  const [x, j] = useState$1(t || []);
  useEffect(() => {
    t && j(t);
  }, [t]);
  const Z = (V) => {
    const $ = x.indexOf(V.value), X = [...x];
    $ === -1 ? X.push(V.value) : X.splice($, 1), t || j(X), s == null || s(
      X.sort((W, Y) => {
        const U = n.findIndex((K) => K.value === W), G = n.findIndex((K) => K.value === Y);
        return U - G;
      })
    );
  };
  return /* @__PURE__ */ jsx("div", { style: o, className: clsx("go-checkbox-group", l), children: n.map((V) => /* @__PURE__ */ jsx(
    Checkbox,
    {
      checked: x.includes(V.value),
      onChange: () => Z(V),
      className: a,
      disabled: V.disabled,
      name: r,
      ref: V.ref,
      style: V.style,
      loading: V.loading,
      children: V.label
    },
    V.value.toString()
  )) });
};
var RGB_MAX = 255, HUE_MAX = 360, SV_MAX = 100, rgbaToHsva = (t) => {
  var {
    r,
    g: n,
    b: a,
    a: s
  } = t, o = Math.max(r, n, a), l = o - Math.min(r, n, a), x = l ? o === r ? (n - a) / l : o === n ? 2 + (a - r) / l : 4 + (r - n) / l : 0;
  return {
    h: 60 * (x < 0 ? x + 6 : x),
    s: o ? l / o * SV_MAX : 0,
    v: o / RGB_MAX * SV_MAX,
    a: s
  };
}, hsvaToHslaString = (t) => {
  var {
    h: r,
    s: n,
    l: a,
    a: s
  } = hsvaToHsla(t);
  return "hsla(" + r + ", " + n + "%, " + a + "%, " + s + ")";
}, hslaStringToHsva = (t) => {
  var r = /hsla?\(?\s*(-?\d*\.?\d+)(deg|rad|grad|turn)?[,\s]+(-?\d*\.?\d+)%?[,\s]+(-?\d*\.?\d+)%?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i, n = r.exec(t);
  return n ? hslaToHsva({
    h: parseHue(n[1], n[2]),
    s: Number(n[3]),
    l: Number(n[4]),
    a: n[5] === void 0 ? 1 : Number(n[5]) / (n[6] ? 100 : 1)
  }) : {
    h: 0,
    s: 0,
    v: 0,
    a: 1
  };
}, hslStringToHsva = hslaStringToHsva, hslaToHsva = (t) => {
  var {
    h: r,
    s: n,
    l: a,
    a: s
  } = t;
  return n *= (a < 50 ? a : SV_MAX - a) / SV_MAX, {
    h: r,
    s: n > 0 ? 2 * n / (a + n) * SV_MAX : 0,
    v: a + n,
    a: s
  };
}, hsvaToHsla = (t) => {
  var {
    h: r,
    s: n,
    v: a,
    a: s
  } = t, o = (200 - n) * a / SV_MAX;
  return {
    h: r,
    s: o > 0 && o < 200 ? n * a / SV_MAX / (o <= SV_MAX ? o : 200 - o) * SV_MAX : 0,
    l: o / 2,
    a: s
  };
}, angleUnits = {
  grad: HUE_MAX / 400,
  turn: HUE_MAX,
  rad: HUE_MAX / (Math.PI * 2)
}, parseHue = function t(r, n) {
  return n === void 0 && (n = "deg"), Number(r) * (angleUnits[n] || 1);
}, rgbaStringToHsva = (t) => {
  var r = /rgba?\(?\s*(-?\d*\.?\d+)(%)?[,\s]+(-?\d*\.?\d+)(%)?[,\s]+(-?\d*\.?\d+)(%)?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i, n = r.exec(t);
  return n ? rgbaToHsva({
    r: Number(n[1]) / (n[2] ? SV_MAX / RGB_MAX : 1),
    g: Number(n[3]) / (n[4] ? SV_MAX / RGB_MAX : 1),
    b: Number(n[5]) / (n[6] ? SV_MAX / RGB_MAX : 1),
    a: n[7] === void 0 ? 1 : Number(n[7]) / (n[8] ? SV_MAX : 1)
  }) : {
    h: 0,
    s: 0,
    v: 0,
    a: 1
  };
}, rgbToHex = (t) => {
  var {
    r,
    g: n,
    b: a
  } = t, s = r << 16 | n << 8 | a;
  return "#" + ((o) => new Array(7 - o.length).join("0") + o)(s.toString(16));
}, rgbaToHexa = (t) => {
  var {
    r,
    g: n,
    b: a,
    a: s
  } = t, o = typeof s == "number" && (s * 255 | 256).toString(16).slice(1);
  return "" + rgbToHex({
    r,
    g: n,
    b: a
  }) + (o || "");
}, hexToHsva = (t) => rgbaToHsva(hexToRgba(t)), hexToRgba = (t) => {
  var r = t.replace("#", "");
  /^#?/.test(t) && r.length === 3 && (t = "#" + r.charAt(0) + r.charAt(0) + r.charAt(1) + r.charAt(1) + r.charAt(2) + r.charAt(2));
  var n = new RegExp("[A-Za-z0-9]{2}", "g"), [a, s, o = 0, l] = t.match(n).map((x) => parseInt(x, 16));
  return {
    r: a,
    g: s,
    b: o,
    a: (l != null ? l : 255) / RGB_MAX
  };
}, hsvaToRgba = (t) => {
  var {
    h: r,
    s: n,
    v: a,
    a: s
  } = t, o = r / 60, l = n / SV_MAX, x = a / SV_MAX, j = Math.floor(o) % 6, Z = o - Math.floor(o), V = RGB_MAX * x * (1 - l), $ = RGB_MAX * x * (1 - l * Z), X = RGB_MAX * x * (1 - l * (1 - Z));
  x *= RGB_MAX;
  var W = {};
  switch (j) {
    case 0:
      W.r = x, W.g = X, W.b = V;
      break;
    case 1:
      W.r = $, W.g = x, W.b = V;
      break;
    case 2:
      W.r = V, W.g = x, W.b = X;
      break;
    case 3:
      W.r = V, W.g = $, W.b = x;
      break;
    case 4:
      W.r = X, W.g = V, W.b = x;
      break;
    case 5:
      W.r = x, W.g = V, W.b = $;
      break;
  }
  return W.r = Math.round(W.r), W.g = Math.round(W.g), W.b = Math.round(W.b), _extends({}, W, {
    a: s
  });
}, hsvaToRgbaString = (t) => {
  var {
    r,
    g: n,
    b: a,
    a: s
  } = hsvaToRgba(t);
  return "rgba(" + r + ", " + n + ", " + a + ", " + s + ")";
}, rgbaToRgb = (t) => {
  var {
    r,
    g: n,
    b: a
  } = t;
  return {
    r,
    g: n,
    b: a
  };
}, hslaToHsl = (t) => {
  var {
    h: r,
    s: n,
    l: a
  } = t;
  return {
    h: r,
    s: n,
    l: a
  };
}, hsvaToHex = (t) => rgbToHex(hsvaToRgba(t)), hsvaToHexa = (t) => rgbaToHexa(hsvaToRgba(t)), hsvaToHsv = (t) => {
  var {
    h: r,
    s: n,
    v: a
  } = t;
  return {
    h: r,
    s: n,
    v: a
  };
}, rgbToXY = (t) => {
  var {
    r,
    g: n,
    b: a
  } = t, s = function(V) {
    return V <= 0.04045 ? V / 12.92 : Math.pow((V + 0.055) / 1.055, 2.4);
  }, o = s(r / 255), l = s(n / 255), x = s(a / 255), j = {};
  return j.x = o * 0.4124 + l * 0.3576 + x * 0.1805, j.y = o * 0.2126 + l * 0.7152 + x * 0.0722, j.bri = o * 0.0193 + l * 0.1192 + x * 0.9505, j;
}, color = (t) => {
  var r, n, a, s, o, l, x, j, Z;
  return typeof t == "string" && validHex$1(t) ? (l = hexToHsva(t), j = t) : typeof t != "string" && (l = t), l && (a = hsvaToHsv(l), o = hsvaToHsla(l), s = hsvaToRgba(l), Z = rgbaToHexa(s), j = hsvaToHex(l), n = hslaToHsl(o), r = rgbaToRgb(s), x = rgbToXY(r)), {
    rgb: r,
    hsl: n,
    hsv: a,
    rgba: s,
    hsla: o,
    hsva: l,
    hex: j,
    hexa: Z,
    xy: x
  };
}, validHex$1 = (t) => /^#?([A-Fa-f0-9]{3,4}){1,2}$/.test(t), _excluded$8 = ["prefixCls", "placement", "label", "value", "className", "style", "labelStyle", "inputStyle", "onChange", "onBlur", "renderInput"], validHex = (t) => /^#?([A-Fa-f0-9]{3,4}){1,2}$/.test(t), getNumberValue = (t) => Number(String(t).replace(/%/g, "")), EditableInput = /* @__PURE__ */ React__default.forwardRef((t, r) => {
  var {
    prefixCls: n = "w-color-editable-input",
    placement: a = "bottom",
    label: s,
    value: o,
    className: l,
    style: x,
    labelStyle: j,
    inputStyle: Z,
    onChange: V,
    onBlur: $,
    renderInput: X
  } = t, W = _objectWithoutPropertiesLoose(t, _excluded$8), [Y, U] = useState$1(o), G = useRef(!1), K = useRef(W.id || n + "-" + Math.random().toString(36).slice(2, 11)), J = W.id || K.current;
  useEffect(() => {
    t.value !== Y && (G.current || U(t.value));
  }, [t.value]);
  function ee(he, oe) {
    var le = (oe || he.target.value).trim().replace(/^#/, "");
    validHex(le) && V && V(he, le);
    var pe = getNumberValue(le);
    isNaN(pe) || V && V(he, pe), U(le);
  }
  function te(he) {
    G.current = !1, U(t.value), $ && $(he);
  }
  var re = {};
  a === "bottom" && (re.flexDirection = "column"), a === "top" && (re.flexDirection = "column-reverse"), a === "left" && (re.flexDirection = "row-reverse");
  var ae = _extends({
    "--editable-input-label-color": "rgb(153, 153, 153)",
    "--editable-input-box-shadow": "rgb(204 204 204) 0px 0px 0px 1px inset",
    "--editable-input-color": "#666",
    position: "relative",
    alignItems: "center",
    display: "flex",
    fontSize: 11
  }, re, x), ie = _extends({
    width: "100%",
    paddingTop: 2,
    paddingBottom: 2,
    paddingLeft: 3,
    paddingRight: 3,
    fontSize: 11,
    background: "transparent",
    boxSizing: "border-box",
    border: "none",
    color: "var(--editable-input-color)",
    boxShadow: "var(--editable-input-box-shadow)"
  }, Z), ce = _extends({
    value: Y,
    onChange: ee,
    onBlur: te,
    autoComplete: "off",
    onFocus: () => G.current = !0
  }, W, {
    id: J,
    style: ie,
    onFocusCapture: (he) => {
      var oe = he.target;
      oe.setSelectionRange(oe.value.length, oe.value.length);
    }
  });
  return /* @__PURE__ */ jsxs("div", {
    className: [n, l || ""].filter(Boolean).join(" "),
    style: ae,
    children: [X ? X(ce, r) : /* @__PURE__ */ jsx("input", _extends({
      ref: r
    }, ce)), s && /* @__PURE__ */ jsx("label", {
      htmlFor: J,
      style: _extends({
        color: "var(--editable-input-label-color)",
        textTransform: "capitalize"
      }, j),
      children: s
    })]
  });
});
EditableInput.displayName = "EditableInput";
var _excluded$7 = ["prefixCls", "hsva", "placement", "rProps", "gProps", "bProps", "aProps", "className", "style", "onChange"], EditableInputRGBA = /* @__PURE__ */ React__default.forwardRef((t, r) => {
  var {
    prefixCls: n = "w-color-editable-input-rgba",
    hsva: a,
    placement: s = "bottom",
    rProps: o = {},
    gProps: l = {},
    bProps: x = {},
    aProps: j = {},
    className: Z,
    style: V,
    onChange: $
  } = t, X = _objectWithoutPropertiesLoose(t, _excluded$7), W = a ? hsvaToRgba(a) : {};
  function Y(J) {
    var ee = Number(J.target.value);
    ee && ee > 255 && (J.target.value = "255"), ee && ee < 0 && (J.target.value = "0");
  }
  var U = (J) => {
    var ee = Number(J.target.value);
    ee && ee > 100 && (J.target.value = "100"), ee && ee < 0 && (J.target.value = "0");
  }, G = (J, ee, te) => {
    typeof J == "number" && (ee === "a" && (J < 0 && (J = 0), J > 100 && (J = 100), $ && $(color(rgbaToHsva(_extends({}, W, {
      a: J / 100
    }))))), J > 255 && (J = 255, te.target.value = "255"), J < 0 && (J = 0, te.target.value = "0"), ee === "r" && $ && $(color(rgbaToHsva(_extends({}, W, {
      r: J
    })))), ee === "g" && $ && $(color(rgbaToHsva(_extends({}, W, {
      g: J
    })))), ee === "b" && $ && $(color(rgbaToHsva(_extends({}, W, {
      b: J
    })))));
  }, K = W.a ? Math.round(W.a * 100) / 100 : 0;
  return /* @__PURE__ */ jsxs("div", _extends({
    ref: r,
    className: [n, Z || ""].filter(Boolean).join(" ")
  }, X, {
    style: _extends({
      fontSize: 11,
      display: "flex"
    }, V),
    children: [/* @__PURE__ */ jsx(EditableInput, _extends({
      label: "R",
      value: W.r || 0,
      onBlur: Y,
      placement: s,
      onChange: (J, ee) => G(ee, "r", J)
    }, o, {
      style: _extends({}, o.style)
    })), /* @__PURE__ */ jsx(EditableInput, _extends({
      label: "G",
      value: W.g || 0,
      onBlur: Y,
      placement: s,
      onChange: (J, ee) => G(ee, "g", J)
    }, l, {
      style: _extends({
        marginLeft: 5
      }, l.style)
    })), /* @__PURE__ */ jsx(EditableInput, _extends({
      label: "B",
      value: W.b || 0,
      onBlur: Y,
      placement: s,
      onChange: (J, ee) => G(ee, "b", J)
    }, x, {
      style: _extends({
        marginLeft: 5
      }, x.style)
    })), j && /* @__PURE__ */ jsx(EditableInput, _extends({
      label: "A",
      value: parseInt(String(K * 100), 10),
      onBlur: U,
      placement: s,
      onChange: (J, ee) => G(ee, "a", J)
    }, j, {
      style: _extends({
        marginLeft: 5
      }, j.style)
    }))]
  }));
});
EditableInputRGBA.displayName = "EditableInputRGBA";
function useEventCallback(t) {
  var r = useRef(t);
  return useEffect(() => {
    r.current = t;
  }), useCallback((n, a) => r.current && r.current(n, a), []);
}
var isTouch = (t) => "touches" in t, preventDefaultMove = (t) => {
  !isTouch(t) && t.preventDefault && t.preventDefault();
}, clamp$2 = function t(r, n, a) {
  return n === void 0 && (n = 0), a === void 0 && (a = 1), r > a ? a : r < n ? n : r;
}, getRelativePosition = (t, r) => {
  var n = t.getBoundingClientRect(), a = isTouch(r) ? r.touches[0] : r;
  return {
    left: clamp$2((a.pageX - (n.left + window.pageXOffset)) / n.width),
    top: clamp$2((a.pageY - (n.top + window.pageYOffset)) / n.height),
    width: n.width,
    height: n.height,
    x: a.pageX - (n.left + window.pageXOffset),
    y: a.pageY - (n.top + window.pageYOffset)
  };
}, _excluded$6 = ["prefixCls", "className", "onMove", "onDown"], Interactive = /* @__PURE__ */ React__default.forwardRef((t, r) => {
  var {
    prefixCls: n = "w-color-interactive",
    className: a,
    onMove: s,
    onDown: o
  } = t, l = _objectWithoutPropertiesLoose(t, _excluded$6), x = useRef(null), j = useRef(!1), [Z, V] = useState$1(!1), $ = useEventCallback(s), X = useEventCallback(o), W = (J) => j.current && !isTouch(J) ? !1 : (j.current = isTouch(J), !0), Y = useCallback((J) => {
    if (preventDefaultMove(J), !!x.current) {
      var ee = isTouch(J) ? J.touches.length > 0 : J.buttons > 0;
      if (!ee) {
        V(!1);
        return;
      }
      $ == null || $(getRelativePosition(x.current, J), J);
    }
  }, [$]), U = useCallback(() => V(!1), []), G = useCallback((J) => {
    J ? (window.addEventListener(j.current ? "touchmove" : "mousemove", Y), window.addEventListener(j.current ? "touchend" : "mouseup", U)) : (window.removeEventListener("mousemove", Y), window.removeEventListener("mouseup", U), window.removeEventListener("touchmove", Y), window.removeEventListener("touchend", U));
  }, [Y, U]);
  useEffect(() => (G(Z), () => {
    G(!1);
  }), [Z, Y, U, G]);
  var K = useCallback((J) => {
    var ee = document.activeElement;
    ee == null || ee.blur(), preventDefaultMove(J.nativeEvent), W(J.nativeEvent) && x.current && (X == null || X(getRelativePosition(x.current, J.nativeEvent), J.nativeEvent), V(!0));
  }, [X]);
  return /* @__PURE__ */ jsx("div", _extends({}, l, {
    className: [n, a || ""].filter(Boolean).join(" "),
    style: _extends({}, l.style, {
      touchAction: "none"
    }),
    ref: x,
    tabIndex: 0,
    onMouseDown: K,
    onTouchStart: K
  }));
});
Interactive.displayName = "Interactive";
var _excluded$5 = ["className", "prefixCls", "left", "top", "style", "fillProps"], Pointer$1 = (t) => {
  var {
    className: r,
    prefixCls: n,
    left: a,
    top: s,
    style: o,
    fillProps: l
  } = t, x = _objectWithoutPropertiesLoose(t, _excluded$5), j = _extends({}, o, {
    position: "absolute",
    left: a,
    top: s
  }), Z = _extends({
    width: 18,
    height: 18,
    boxShadow: "var(--alpha-pointer-box-shadow)",
    borderRadius: "50%",
    backgroundColor: "var(--alpha-pointer-background-color)"
  }, l == null ? void 0 : l.style, {
    transform: a ? "translate(-9px, -1px)" : "translate(-1px, -9px)"
  });
  return /* @__PURE__ */ jsx("div", _extends({
    className: n + "-pointer " + (r || ""),
    style: j
  }, x, {
    children: /* @__PURE__ */ jsx("div", _extends({
      className: n + "-fill"
    }, l, {
      style: Z
    }))
  }));
}, _excluded$4 = ["prefixCls", "className", "hsva", "background", "bgProps", "innerProps", "pointerProps", "radius", "width", "height", "direction", "reverse", "style", "onChange", "pointer"], BACKGROUND_IMG = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAMUlEQVQ4T2NkYGAQYcAP3uCTZhw1gGGYhAGBZIA/nYDCgBDAm9BGDWAAJyRCgLaBCAAgXwixzAS0pgAAAABJRU5ErkJggg==", Alpha = /* @__PURE__ */ React__default.forwardRef((t, r) => {
  var {
    prefixCls: n = "w-color-alpha",
    className: a,
    hsva: s,
    background: o,
    bgProps: l = {},
    innerProps: x = {},
    pointerProps: j = {},
    radius: Z = 0,
    width: V,
    height: $ = 16,
    direction: X = "horizontal",
    reverse: W = !1,
    style: Y,
    onChange: U,
    pointer: G
  } = t, K = _objectWithoutPropertiesLoose(t, _excluded$4), J = useCallback((se) => {
    var ue = X === "horizontal" ? se.left : se.top;
    return X === "horizontal" ? W ? 1 - ue : ue : W ? ue : 1 - ue;
  }, [X, W]), ee = useCallback((se) => X === "horizontal" ? W ? 1 - se : se : W ? se : 1 - se, [X, W]), te = (se) => {
    var ue = J(se);
    U && U(_extends({}, s, {
      a: ue
    }), se);
  }, re = hsvaToHslaString(Object.assign({}, s, {
    a: 1
  })), ae = W ? "linear-gradient(to right, " + re + " 0%, rgba(244, 67, 54, 0) 100%)" : "linear-gradient(to right, rgba(244, 67, 54, 0) 0%, " + re + " 100%)", ie = W ? "linear-gradient(to bottom, rgba(244, 67, 54, 0) 0%, " + re + " 100%)" : "linear-gradient(to bottom, " + re + " 0%, rgba(244, 67, 54, 0) 100%)", ce = X === "horizontal" ? ae : ie, he = {};
  X === "horizontal" ? he.left = ee(s.a) * 100 + "%" : he.top = ee(s.a) * 100 + "%";
  var oe = _extends({
    "--alpha-background-color": "#fff",
    "--alpha-pointer-background-color": "rgb(248, 248, 248)",
    "--alpha-pointer-box-shadow": "rgb(0 0 0 / 37%) 0px 1px 4px 0px",
    borderRadius: Z,
    background: "url(" + BACKGROUND_IMG + ") left center",
    backgroundColor: "var(--alpha-background-color)"
  }, {
    width: V,
    height: $
  }, Y, {
    position: "relative"
  }), le = useCallback((se) => {
    var ue = 0.01, fe = s.a, ge = fe;
    switch (se.key) {
      case "ArrowLeft":
        X === "horizontal" && (ge = W ? Math.min(1, fe + ue) : Math.max(0, fe - ue), se.preventDefault());
        break;
      case "ArrowRight":
        X === "horizontal" && (ge = W ? Math.max(0, fe - ue) : Math.min(1, fe + ue), se.preventDefault());
        break;
      case "ArrowUp":
        X === "vertical" && (ge = W ? Math.max(0, fe - ue) : Math.min(1, fe + ue), se.preventDefault());
        break;
      case "ArrowDown":
        X === "vertical" && (ge = W ? Math.min(1, fe + ue) : Math.max(0, fe - ue), se.preventDefault());
        break;
      default:
        return;
    }
    if (ge !== fe) {
      var ne = ee(ge), ve = {
        left: X === "horizontal" ? ne : s.a,
        top: X === "vertical" ? ne : s.a,
        width: 0,
        height: 0,
        x: 0,
        y: 0
      };
      U && U(_extends({}, s, {
        a: ge
      }), ve);
    }
  }, [ee, s, X, U, W]), pe = useCallback((se) => {
    se.target.focus();
  }, []), de = G && typeof G == "function" ? G(_extends({
    prefixCls: n
  }, j, he)) : /* @__PURE__ */ jsx(Pointer$1, _extends({}, j, {
    prefixCls: n
  }, he));
  return /* @__PURE__ */ jsxs("div", _extends({}, K, {
    className: [n, n + "-" + X, a || ""].filter(Boolean).join(" "),
    style: oe,
    ref: r,
    children: [/* @__PURE__ */ jsx("div", _extends({}, l, {
      style: _extends({
        inset: 0,
        position: "absolute",
        background: o || ce,
        borderRadius: Z
      }, l.style)
    })), /* @__PURE__ */ jsx(Interactive, _extends({}, x, {
      style: _extends({}, x.style, {
        inset: 0,
        zIndex: 1,
        position: "absolute",
        outline: "none"
      }),
      onMove: te,
      onDown: te,
      onClick: pe,
      onKeyDown: le,
      children: de
    }))]
  }));
});
Alpha.displayName = "Alpha";
var _excluded$3 = ["prefixCls", "className", "hue", "onChange", "direction", "reverse"], NORMAL_COLORS = "rgb(255, 0, 0) 0%, rgb(255, 255, 0) 17%, rgb(0, 255, 0) 33%, rgb(0, 255, 255) 50%, rgb(0, 0, 255) 67%, rgb(255, 0, 255) 83%, rgb(255, 0, 0) 100%", REVERSED_COLORS = "rgb(255, 0, 0) 0%, rgb(255, 0, 255) 17%, rgb(0, 0, 255) 33%, rgb(0, 255, 255) 50%, rgb(0, 255, 0) 67%, rgb(255, 255, 0) 83%, rgb(255, 0, 0) 100%", Hue = /* @__PURE__ */ React__default.forwardRef((t, r) => {
  var {
    prefixCls: n = "w-color-hue",
    className: a,
    hue: s = 0,
    onChange: o,
    direction: l = "horizontal",
    reverse: x = !1
  } = t, j = _objectWithoutPropertiesLoose(t, _excluded$3), Z = useCallback(() => {
    if (l === "horizontal") {
      var X = x ? REVERSED_COLORS : NORMAL_COLORS, W = "right";
      return "linear-gradient(to " + W + ", " + X + ")";
    } else {
      var Y = x ? NORMAL_COLORS : REVERSED_COLORS, U = "bottom";
      return "linear-gradient(to " + U + ", " + Y + ")";
    }
  }, [l, x]), V = useCallback((X) => {
    var W = l === "horizontal" ? X.left : X.top, Y;
    return l === "horizontal" ? Y = x ? 1 - W : W : Y = x ? W : 1 - W, 360 * Y;
  }, [l, x]), $ = useMemo$1(() => Z(), [Z]);
  return /* @__PURE__ */ jsx(Alpha, _extends({
    ref: r,
    className: n + " " + (a || "")
  }, j, {
    direction: l,
    reverse: x,
    background: $,
    hsva: {
      h: s,
      s: 100,
      v: 100,
      a: s / 360
    },
    onChange: (X, W) => {
      o && o({
        h: V(W)
      });
    }
  }));
});
Hue.displayName = "Hue";
var Pointer = (t) => {
  var {
    className: r,
    color: n,
    left: a,
    top: s,
    prefixCls: o
  } = t, l = {
    position: "absolute",
    top: s,
    left: a
  }, x = {
    "--saturation-pointer-box-shadow": "rgb(255 255 255) 0px 0px 0px 1.5px, rgb(0 0 0 / 30%) 0px 0px 1px 1px inset, rgb(0 0 0 / 40%) 0px 0px 1px 2px",
    width: 6,
    height: 6,
    transform: "translate(-3px, -3px)",
    boxShadow: "var(--saturation-pointer-box-shadow)",
    borderRadius: "50%",
    backgroundColor: n
  };
  return useMemo$1(() => /* @__PURE__ */ jsx("div", {
    className: o + "-pointer " + (r || ""),
    style: l,
    children: /* @__PURE__ */ jsx("div", {
      className: o + "-fill",
      style: x
    })
  }), [s, a, n, r, o]);
}, _excluded$2 = ["prefixCls", "radius", "pointer", "className", "hue", "style", "hsva", "onChange"], Saturation = /* @__PURE__ */ React__default.forwardRef((t, r) => {
  var n, {
    prefixCls: a = "w-color-saturation",
    radius: s = 0,
    pointer: o,
    className: l,
    hue: x = 0,
    style: j,
    hsva: Z,
    onChange: V
  } = t, $ = _objectWithoutPropertiesLoose(t, _excluded$2), X = _extends({
    width: 200,
    height: 200,
    borderRadius: s
  }, j, {
    position: "relative"
  }), W = useRef(null), Y = useCallback((ee) => {
    W.current = ee, typeof r == "function" ? r(ee) : r && "current" in r && (r.current = ee);
  }, [r]), U = useCallback((ee, te) => {
    V && Z && V({
      h: Z.h,
      s: ee.left * 100,
      v: (1 - ee.top) * 100,
      a: Z.a
      // source: 'hsv',
    });
    var re = W.current;
    re && re.focus();
  }, [Z, V]), G = useCallback((ee) => {
    if (!(!Z || !V)) {
      var te = 1, re = Z.s, ae = Z.v, ie = !1;
      switch (ee.key) {
        case "ArrowLeft":
          re = Math.max(0, Z.s - te), ie = !0, ee.preventDefault();
          break;
        case "ArrowRight":
          re = Math.min(100, Z.s + te), ie = !0, ee.preventDefault();
          break;
        case "ArrowUp":
          ae = Math.min(100, Z.v + te), ie = !0, ee.preventDefault();
          break;
        case "ArrowDown":
          ae = Math.max(0, Z.v - te), ie = !0, ee.preventDefault();
          break;
        default:
          return;
      }
      ie && V({
        h: Z.h,
        s: re,
        v: ae,
        a: Z.a
      });
    }
  }, [Z, V]), K = useMemo$1(() => {
    if (!Z) return null;
    var ee = {
      top: 100 - Z.v + "%",
      left: Z.s + "%",
      color: hsvaToHslaString(Z)
    };
    return o && typeof o == "function" ? o(_extends({
      prefixCls: a
    }, ee)) : /* @__PURE__ */ jsx(Pointer, _extends({
      prefixCls: a
    }, ee));
  }, [Z, o, a]), J = useCallback((ee) => {
    ee.target.focus();
  }, []);
  return /* @__PURE__ */ jsx(Interactive, _extends({
    className: [a, l || ""].filter(Boolean).join(" ")
  }, $, {
    style: _extends({
      position: "absolute",
      inset: 0,
      cursor: "crosshair",
      backgroundImage: "linear-gradient(0deg, #000, transparent), linear-gradient(90deg, #fff, hsl(" + ((n = Z == null ? void 0 : Z.h) != null ? n : x) + ", 100%, 50%))"
    }, X, {
      outline: "none"
    }),
    ref: Y,
    onMove: U,
    onDown: U,
    onKeyDown: G,
    onClick: J,
    children: K
  }));
});
Saturation.displayName = "Saturation";
const DEFAULT_COLOR = "rgba(0, 0, 0, 1)", colorInputStyles = {
  width: "100%",
  display: "flex",
  flexFlow: "row nowrap",
  backgroundColor: "var(--go-input-bg)",
  boxShadow: "none",
  borderRadius: 4,
  fontSize: 13,
  padding: "4px 8px",
  color: "var(--go-input-placeholder-text)"
};
function parseColorValue(t) {
  if (!t)
    return rgbaStringToHsva(DEFAULT_COLOR);
  const r = t.trim();
  return validHex$1(r) ? hexToHsva(r) : r.startsWith("hsl") ? hslStringToHsva(r) : rgbaStringToHsva(r);
}
function getChangeDetails(t) {
  return {
    hex: hsvaToHex(t),
    hexa: hsvaToHexa(t),
    rgba: hsvaToRgbaString(t),
    hsva: t
  };
}
function formatColor(t, r) {
  return r === "hex" ? hsvaToHex(t) : r === "hexa" ? hsvaToHexa(t) : hsvaToRgbaString(t);
}
const ColorPicker = forwardRef(function t({
  value: r,
  defaultValue: n = DEFAULT_COLOR,
  format: a = "rgba",
  disabled: s = !1,
  className: o,
  style: l,
  classNames: x,
  styles: j,
  showHexInput: Z = !0,
  showRgbaInputs: V = !0,
  showSaturation: $ = !0,
  showHue: X = !0,
  hexInputProps: W,
  rgbaInputProps: Y,
  saturationProps: U,
  hueProps: G,
  onChange: K
}, J) {
  const ee = r !== void 0, [te, re] = useState$1(() => parseColorValue(n)), ae = ee ? parseColorValue(r) : te, {
    className: ie,
    inputStyle: ce,
    onChange: he,
    disabled: oe,
    ...le
  } = W != null ? W : {}, {
    className: pe,
    rProps: de,
    gProps: se,
    bProps: ue,
    aProps: fe,
    onChange: ge,
    ...ne
  } = Y != null ? Y : {}, {
    className: ve,
    style: me,
    radius: xe,
    onChange: Ee,
    ...Se
  } = U != null ? U : {}, {
    className: _e,
    style: Ce,
    radius: Te,
    onChange: we,
    ...Re
  } = G != null ? G : {}, Ae = (ye) => {
    s || (ee || re(ye), K == null || K(formatColor(ye, a), getChangeDetails(ye)));
  }, Pe = (ye) => {
    const { className: Me, inputStyle: be, disabled: De, label: Fe = !1, ...Le } = ye != null ? ye : {};
    return {
      label: Fe,
      ...Le,
      className: clsx("go-color-picker__rgba-input", x == null ? void 0 : x.rgbaInput, Me),
      disabled: s || De,
      inputStyle: {
        ...colorInputStyles,
        ...j == null ? void 0 : j.input,
        ...j == null ? void 0 : j.rgbaInput,
        ...be
      }
    };
  }, ke = Z || V;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      ref: J,
      className: clsx("go-color-picker", s && "go-color-picker_disabled", x == null ? void 0 : x.root, o),
      style: { ...j == null ? void 0 : j.root, ...l },
      children: [
        ke && /* @__PURE__ */ jsxs("div", { className: clsx("go-color-picker__controls", x == null ? void 0 : x.controls), style: j == null ? void 0 : j.controls, children: [
          Z && /* @__PURE__ */ jsx(
            EditableInput,
            {
              ...le,
              value: hsvaToHex(ae),
              disabled: s || oe,
              className: clsx("go-color-picker__hex-input", x == null ? void 0 : x.hexInput, ie),
              inputStyle: {
                ...colorInputStyles,
                width: 105,
                ...j == null ? void 0 : j.input,
                ...j == null ? void 0 : j.hexInput,
                ...ce
              },
              onChange: (ye, Me) => {
                he == null || he(ye, Me);
                const be = String(Me);
                validHex$1(be) && Ae(hexToHsva(be));
              }
            }
          ),
          Z && V && /* @__PURE__ */ jsx("div", { className: clsx("go-color-picker__divider", x == null ? void 0 : x.divider), style: j == null ? void 0 : j.divider }),
          V && /* @__PURE__ */ jsx(
            EditableInputRGBA,
            {
              ...ne,
              className: clsx(
                "go-color-picker__rgba-inputs",
                fe && "go-color-picker__rgba-inputs_with-alpha",
                x == null ? void 0 : x.rgbaInputs,
                pe
              ),
              rProps: Pe(de),
              gProps: Pe(se),
              bProps: Pe(ue),
              aProps: fe ? Pe(fe) : !1,
              hsva: ae,
              onChange: (ye) => {
                ge == null || ge(ye), Ae(ye.hsva);
              }
            }
          )
        ] }),
        $ && /* @__PURE__ */ jsx(
          Saturation,
          {
            ...Se,
            className: clsx("go-color-picker__saturation", x == null ? void 0 : x.saturation, ve),
            style: { width: "100%", ...j == null ? void 0 : j.saturation, ...me },
            radius: xe != null ? xe : 4,
            hsva: ae,
            onChange: (ye) => {
              Ee == null || Ee(ye), Ae(ye);
            }
          }
        ),
        X && /* @__PURE__ */ jsx(
          Hue,
          {
            ...Re,
            className: clsx("go-color-picker__hue", x == null ? void 0 : x.hue, _e),
            style: { width: "100%", ...j == null ? void 0 : j.hue, ...Ce },
            radius: Te != null ? Te : 4,
            hue: ae.h,
            onChange: (ye) => {
              we == null || we(ye), Ae({ ...ae, ...ye });
            }
          }
        )
      ]
    }
  );
});
ColorPicker.displayName = "ColorPicker";
var useMergedState$1 = {}, slicedToArray = { exports: {} }, arrayWithHoles = { exports: {} }, hasRequiredArrayWithHoles;
function requireArrayWithHoles() {
  return hasRequiredArrayWithHoles || (hasRequiredArrayWithHoles = 1, (function(t) {
    function r(n) {
      if (Array.isArray(n)) return n;
    }
    t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
  })(arrayWithHoles)), arrayWithHoles.exports;
}
var iterableToArrayLimit = { exports: {} }, hasRequiredIterableToArrayLimit;
function requireIterableToArrayLimit() {
  return hasRequiredIterableToArrayLimit || (hasRequiredIterableToArrayLimit = 1, (function(t) {
    function r(n, a) {
      var s = n == null ? null : typeof Symbol != "undefined" && n[Symbol.iterator] || n["@@iterator"];
      if (s != null) {
        var o, l, x, j, Z = [], V = !0, $ = !1;
        try {
          if (x = (s = s.call(n)).next, a === 0) {
            if (Object(s) !== s) return;
            V = !1;
          } else for (; !(V = (o = x.call(s)).done) && (Z.push(o.value), Z.length !== a); V = !0) ;
        } catch (X) {
          $ = !0, l = X;
        } finally {
          try {
            if (!V && s.return != null && (j = s.return(), Object(j) !== j)) return;
          } finally {
            if ($) throw l;
          }
        }
        return Z;
      }
    }
    t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
  })(iterableToArrayLimit)), iterableToArrayLimit.exports;
}
var unsupportedIterableToArray = { exports: {} }, arrayLikeToArray = { exports: {} }, hasRequiredArrayLikeToArray;
function requireArrayLikeToArray() {
  return hasRequiredArrayLikeToArray || (hasRequiredArrayLikeToArray = 1, (function(t) {
    function r(n, a) {
      (a == null || a > n.length) && (a = n.length);
      for (var s = 0, o = Array(a); s < a; s++) o[s] = n[s];
      return o;
    }
    t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
  })(arrayLikeToArray)), arrayLikeToArray.exports;
}
var hasRequiredUnsupportedIterableToArray;
function requireUnsupportedIterableToArray() {
  return hasRequiredUnsupportedIterableToArray || (hasRequiredUnsupportedIterableToArray = 1, (function(t) {
    var r = requireArrayLikeToArray();
    function n(a, s) {
      if (a) {
        if (typeof a == "string") return r(a, s);
        var o = {}.toString.call(a).slice(8, -1);
        return o === "Object" && a.constructor && (o = a.constructor.name), o === "Map" || o === "Set" ? Array.from(a) : o === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? r(a, s) : void 0;
      }
    }
    t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
  })(unsupportedIterableToArray)), unsupportedIterableToArray.exports;
}
var nonIterableRest = { exports: {} }, hasRequiredNonIterableRest;
function requireNonIterableRest() {
  return hasRequiredNonIterableRest || (hasRequiredNonIterableRest = 1, (function(t) {
    function r() {
      throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
  })(nonIterableRest)), nonIterableRest.exports;
}
var hasRequiredSlicedToArray;
function requireSlicedToArray() {
  return hasRequiredSlicedToArray || (hasRequiredSlicedToArray = 1, (function(t) {
    var r = requireArrayWithHoles(), n = requireIterableToArrayLimit(), a = requireUnsupportedIterableToArray(), s = requireNonIterableRest();
    function o(l, x) {
      return r(l) || n(l, x) || a(l, x) || s();
    }
    t.exports = o, t.exports.__esModule = !0, t.exports.default = t.exports;
  })(slicedToArray)), slicedToArray.exports;
}
var useEvent = {}, interopRequireWildcard = { exports: {} }, hasRequiredInteropRequireWildcard;
function requireInteropRequireWildcard() {
  return hasRequiredInteropRequireWildcard || (hasRequiredInteropRequireWildcard = 1, (function(t) {
    var r = require_typeof().default;
    function n(a, s) {
      if (typeof WeakMap == "function") var o = /* @__PURE__ */ new WeakMap(), l = /* @__PURE__ */ new WeakMap();
      return (t.exports = n = function(j, Z) {
        if (!Z && j && j.__esModule) return j;
        var V, $, X = {
          __proto__: null,
          default: j
        };
        if (j === null || r(j) != "object" && typeof j != "function") return X;
        if (V = Z ? l : o) {
          if (V.has(j)) return V.get(j);
          V.set(j, X);
        }
        for (var W in j) W !== "default" && {}.hasOwnProperty.call(j, W) && (($ = (V = Object.defineProperty) && Object.getOwnPropertyDescriptor(j, W)) && ($.get || $.set) ? V(X, W, $) : X[W] = j[W]);
        return X;
      }, t.exports.__esModule = !0, t.exports.default = t.exports)(a, s);
    }
    t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
  })(interopRequireWildcard)), interopRequireWildcard.exports;
}
var hasRequiredUseEvent;
function requireUseEvent() {
  if (hasRequiredUseEvent) return useEvent;
  hasRequiredUseEvent = 1;
  var t = requireInteropRequireWildcard().default;
  Object.defineProperty(useEvent, "__esModule", {
    value: !0
  }), useEvent.default = n;
  var r = t(React__default);
  function n(a) {
    var s = r.useRef();
    s.current = a;
    var o = r.useCallback(function() {
      for (var l, x = arguments.length, j = new Array(x), Z = 0; Z < x; Z++)
        j[Z] = arguments[Z];
      return (l = s.current) === null || l === void 0 ? void 0 : l.call.apply(l, [s].concat(j));
    }, []);
    return o;
  }
  return useEvent;
}
var useLayoutEffect = {}, canUseDom = {}, hasRequiredCanUseDom;
function requireCanUseDom() {
  if (hasRequiredCanUseDom) return canUseDom;
  hasRequiredCanUseDom = 1, Object.defineProperty(canUseDom, "__esModule", {
    value: !0
  }), canUseDom.default = t;
  function t() {
    return !!(typeof window != "undefined" && window.document && window.document.createElement);
  }
  return canUseDom;
}
var hasRequiredUseLayoutEffect;
function requireUseLayoutEffect() {
  if (hasRequiredUseLayoutEffect) return useLayoutEffect;
  hasRequiredUseLayoutEffect = 1;
  var t = requireInteropRequireDefault().default, r = requireInteropRequireWildcard().default;
  Object.defineProperty(useLayoutEffect, "__esModule", {
    value: !0
  }), useLayoutEffect.useLayoutUpdateEffect = useLayoutEffect.default = void 0;
  var n = r(React__default), a = t(requireCanUseDom()), s = process.env.NODE_ENV !== "test" && (0, a.default)() ? n.useLayoutEffect : n.useEffect, o = function(x, j) {
    var Z = n.useRef(!0);
    s(function() {
      return x(Z.current);
    }, j), s(function() {
      return Z.current = !1, function() {
        Z.current = !0;
      };
    }, []);
  };
  return useLayoutEffect.useLayoutUpdateEffect = function(x, j) {
    o(function(Z) {
      if (!Z)
        return x();
    }, j);
  }, useLayoutEffect.default = o, useLayoutEffect;
}
var useState = {}, hasRequiredUseState;
function requireUseState() {
  if (hasRequiredUseState) return useState;
  hasRequiredUseState = 1;
  var t = requireInteropRequireWildcard().default, r = requireInteropRequireDefault().default;
  Object.defineProperty(useState, "__esModule", {
    value: !0
  }), useState.default = s;
  var n = r(requireSlicedToArray()), a = t(React__default);
  function s(o) {
    var l = a.useRef(!1), x = a.useState(o), j = (0, n.default)(x, 2), Z = j[0], V = j[1];
    a.useEffect(function() {
      return l.current = !1, function() {
        l.current = !0;
      };
    }, []);
    function $(X, W) {
      W && l.current || V(X);
    }
    return [Z, $];
  }
  return useState;
}
var hasRequiredUseMergedState;
function requireUseMergedState() {
  if (hasRequiredUseMergedState) return useMergedState$1;
  hasRequiredUseMergedState = 1;
  var t = requireInteropRequireDefault().default;
  Object.defineProperty(useMergedState$1, "__esModule", {
    value: !0
  }), useMergedState$1.default = l;
  var r = t(requireSlicedToArray()), n = t(requireUseEvent()), a = requireUseLayoutEffect(), s = t(requireUseState());
  function o(x) {
    return x !== void 0;
  }
  function l(x, j) {
    var Z = j || {}, V = Z.defaultValue, $ = Z.value, X = Z.onChange, W = Z.postState, Y = (0, s.default)(function() {
      return o($) ? $ : o(V) ? typeof V == "function" ? V() : V : typeof x == "function" ? x() : x;
    }), U = (0, r.default)(Y, 2), G = U[0], K = U[1], J = $ !== void 0 ? $ : G, ee = W ? W(J) : J, te = (0, n.default)(X), re = (0, s.default)([J]), ae = (0, r.default)(re, 2), ie = ae[0], ce = ae[1];
    (0, a.useLayoutUpdateEffect)(function() {
      var oe = ie[0];
      G !== oe && te(G, oe);
    }, [ie]), (0, a.useLayoutUpdateEffect)(function() {
      o($) || K($);
    }, [$]);
    var he = (0, n.default)(function(oe, le) {
      K(oe, le), ce([J], le);
    });
    return [ee, he];
  }
  return useMergedState$1;
}
var useMergedStateExports = requireUseMergedState();
const useMergedState = /* @__PURE__ */ getDefaultExportFromCjs(useMergedStateExports), DefaultHeader = ({ text: t, open: r, iconOpen: n, iconClosed: a, iconPlacement: s = "start" }) => {
  const o = n && a && r ? a : n;
  return /* @__PURE__ */ jsxs("div", { className: clsx("go-collapse__default-header", s === "end" && "space-between"), children: [
    s === "end" && t,
    /* @__PURE__ */ jsx("div", { className: clsx("go-collapse__expand-button", r && !a && "open"), children: n ? o : /* @__PURE__ */ jsx(ExpandDown, {}) }),
    s === "start" && t
  ] });
}, CollapsePanel = ({
  onItemClick: t,
  panelKey: r,
  children: n,
  header: a,
  styleHeader: s,
  styleBody: o,
  styleWrapper: l,
  className: x,
  disabled: j,
  iconOpen: Z,
  iconClosed: V,
  stickyHeader: $,
  isActive: X,
  iconPlacement: W
}) => {
  const [Y, U] = useState$1(X != null ? X : !1), G = typeof a == "number" || typeof a == "string" || typeof a == "boolean", K = () => {
    j || U((J) => !J);
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      style: l,
      className: clsx("go-collapse__panel", x, j && "go-collapse__panel_disabled"),
      children: [
        /* @__PURE__ */ jsx(
          "div",
          {
            className: clsx($ && "go-collapse__header_sticky"),
            style: s,
            onClick: () => {
              t && !j ? t(r) : K();
            },
            children: G || !a ? /* @__PURE__ */ jsx(
              DefaultHeader,
              {
                iconPlacement: W,
                iconOpen: Z,
                iconClosed: V,
                open: X != null ? X : Y,
                text: a ? String(a) : ""
              }
            ) : a
          }
        ),
        /* @__PURE__ */ jsx(CollapseBody, { styleBody: o, open: X != null ? X : Y, children: n })
      ]
    },
    r
  );
}, Collapse = ({
  activeKeys: t,
  onChange: r,
  children: n,
  collapseClassname: a,
  collapseStyle: s,
  defaultValue: o
}) => {
  const [l, x] = useMergedState([], {
    defaultValue: o,
    value: t,
    onChange: (Z) => r == null ? void 0 : r(Z)
  }), j = (Z) => {
    x(() => l.indexOf(Z) > -1 ? l.filter((X) => X !== Z) : [...l, Z]);
  };
  return /* @__PURE__ */ jsx("div", { className: clsx("go-collapse", a), style: s, children: Array.isArray(n) ? n.map((Z) => /* @__PURE__ */ jsx(
    CollapsePanel,
    {
      onItemClick: j,
      isActive: l.includes(Z.props.panelKey),
      ...Z.props,
      children: Z.props.children
    },
    Z.props.panelKey
  )) : /* @__PURE__ */ jsx(
    CollapsePanel,
    {
      onItemClick: j,
      isActive: l.includes(n.props.panelKey),
      ...n.props,
      children: n.props.children
    },
    n.props.panelKey
  ) });
}, CollapseBody = ({ styleBody: t, classNameBody: r, open: n, children: a }) => /* @__PURE__ */ jsx("div", { style: t, className: clsx("go-collapse__body", n && "open", r), children: /* @__PURE__ */ jsx("div", { style: { minHeight: 0 }, children: a }) }), collapse = Object.assign(Collapse, { Panel: CollapsePanel, Body: CollapseBody });
function hasWindow() {
  return typeof window != "undefined";
}
function getNodeName(t) {
  return isNode(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function getWindow(t) {
  var r;
  return (t == null || (r = t.ownerDocument) == null ? void 0 : r.defaultView) || window;
}
function getDocumentElement(t) {
  var r;
  return (r = (isNode(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : r.documentElement;
}
function isNode(t) {
  return hasWindow() ? t instanceof Node || t instanceof getWindow(t).Node : !1;
}
function isElement(t) {
  return hasWindow() ? t instanceof Element || t instanceof getWindow(t).Element : !1;
}
function isHTMLElement(t) {
  return hasWindow() ? t instanceof HTMLElement || t instanceof getWindow(t).HTMLElement : !1;
}
function isShadowRoot(t) {
  return !hasWindow() || typeof ShadowRoot == "undefined" ? !1 : t instanceof ShadowRoot || t instanceof getWindow(t).ShadowRoot;
}
function isOverflowElement(t) {
  const {
    overflow: r,
    overflowX: n,
    overflowY: a,
    display: s
  } = getComputedStyle$1(t);
  return /auto|scroll|overlay|hidden|clip/.test(r + a + n) && s !== "inline" && s !== "contents";
}
function isTableElement(t) {
  return /^(table|td|th)$/.test(getNodeName(t));
}
function isTopLayer(t) {
  try {
    if (t.matches(":popover-open"))
      return !0;
  } catch {
  }
  try {
    return t.matches(":modal");
  } catch {
    return !1;
  }
}
const willChangeRe = /transform|translate|scale|rotate|perspective|filter/, containRe = /paint|layout|strict|content/, isNotNone = (t) => !!t && t !== "none";
let isWebKitValue;
function isContainingBlock(t) {
  const r = isElement(t) ? getComputedStyle$1(t) : t;
  return isNotNone(r.transform) || isNotNone(r.translate) || isNotNone(r.scale) || isNotNone(r.rotate) || isNotNone(r.perspective) || !isWebKit() && (isNotNone(r.backdropFilter) || isNotNone(r.filter)) || willChangeRe.test(r.willChange || "") || containRe.test(r.contain || "");
}
function getContainingBlock(t) {
  let r = getParentNode(t);
  for (; isHTMLElement(r) && !isLastTraversableNode(r); ) {
    if (isContainingBlock(r))
      return r;
    if (isTopLayer(r))
      return null;
    r = getParentNode(r);
  }
  return null;
}
function isWebKit() {
  return isWebKitValue == null && (isWebKitValue = typeof CSS != "undefined" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), isWebKitValue;
}
function isLastTraversableNode(t) {
  return /^(html|body|#document)$/.test(getNodeName(t));
}
function getComputedStyle$1(t) {
  return getWindow(t).getComputedStyle(t);
}
function getNodeScroll(t) {
  return isElement(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function getParentNode(t) {
  if (getNodeName(t) === "html")
    return t;
  const r = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    isShadowRoot(t) && t.host || // Fallback.
    getDocumentElement(t)
  );
  return isShadowRoot(r) ? r.host : r;
}
function getNearestOverflowAncestor(t) {
  const r = getParentNode(t);
  return isLastTraversableNode(r) ? (t.ownerDocument || t).body : isHTMLElement(r) && isOverflowElement(r) ? r : getNearestOverflowAncestor(r);
}
function getOverflowAncestors(t, r, n) {
  var a;
  r === void 0 && (r = []), n === void 0 && (n = !0);
  const s = getNearestOverflowAncestor(t), o = s === ((a = t.ownerDocument) == null ? void 0 : a.body), l = getWindow(s);
  if (o) {
    const x = getFrameElement(l);
    return r.concat(l, l.visualViewport || [], isOverflowElement(s) ? s : [], x && n ? getOverflowAncestors(x) : []);
  } else
    return r.concat(s, getOverflowAncestors(s, [], n));
}
function getFrameElement(t) {
  return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
const min$1 = Math.min, max$1 = Math.max, round$1 = Math.round, floor$1 = Math.floor, createCoords = (t) => ({
  x: t,
  y: t
}), oppositeSideMap = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function clamp$1(t, r, n) {
  return max$1(t, min$1(r, n));
}
function evaluate(t, r) {
  return typeof t == "function" ? t(r) : t;
}
function getSide(t) {
  return t.split("-")[0];
}
function getAlignment(t) {
  return t.split("-")[1];
}
function getOppositeAxis(t) {
  return t === "x" ? "y" : "x";
}
function getAxisLength(t) {
  return t === "y" ? "height" : "width";
}
function getSideAxis(t) {
  const r = t[0];
  return r === "t" || r === "b" ? "y" : "x";
}
function getAlignmentAxis(t) {
  return getOppositeAxis(getSideAxis(t));
}
function getAlignmentSides(t, r, n) {
  n === void 0 && (n = !1);
  const a = getAlignment(t), s = getAlignmentAxis(t), o = getAxisLength(s);
  let l = s === "x" ? a === (n ? "end" : "start") ? "right" : "left" : a === "start" ? "bottom" : "top";
  return r.reference[o] > r.floating[o] && (l = getOppositePlacement(l)), [l, getOppositePlacement(l)];
}
function getExpandedPlacements(t) {
  const r = getOppositePlacement(t);
  return [getOppositeAlignmentPlacement(t), r, getOppositeAlignmentPlacement(r)];
}
function getOppositeAlignmentPlacement(t) {
  return t.includes("start") ? t.replace("start", "end") : t.replace("end", "start");
}
const lrPlacement = ["left", "right"], rlPlacement = ["right", "left"], tbPlacement = ["top", "bottom"], btPlacement = ["bottom", "top"];
function getSideList(t, r, n) {
  switch (t) {
    case "top":
    case "bottom":
      return n ? r ? rlPlacement : lrPlacement : r ? lrPlacement : rlPlacement;
    case "left":
    case "right":
      return r ? tbPlacement : btPlacement;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(t, r, n, a) {
  const s = getAlignment(t);
  let o = getSideList(getSide(t), n === "start", a);
  return s && (o = o.map((l) => l + "-" + s), r && (o = o.concat(o.map(getOppositeAlignmentPlacement)))), o;
}
function getOppositePlacement(t) {
  const r = getSide(t);
  return oppositeSideMap[r] + t.slice(r.length);
}
function expandPaddingObject(t) {
  var r, n, a, s;
  return {
    top: (r = t.top) != null ? r : 0,
    right: (n = t.right) != null ? n : 0,
    bottom: (a = t.bottom) != null ? a : 0,
    left: (s = t.left) != null ? s : 0
  };
}
function getPaddingObject(t) {
  return typeof t != "number" ? expandPaddingObject(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function rectToClientRect(t) {
  const {
    x: r,
    y: n,
    width: a,
    height: s
  } = t;
  return {
    width: a,
    height: s,
    top: n,
    left: r,
    right: r + a,
    bottom: n + s,
    x: r,
    y: n
  };
}
var candidateSelectors = ["input:not([inert]):not([inert] *)", "select:not([inert]):not([inert] *)", "textarea:not([inert]):not([inert] *)", "a[href]:not([inert]):not([inert] *)", "area[href]:not([inert]):not([inert] *)", "button:not([inert]):not([inert] *)", "[tabindex]:not(slot):not([inert]):not([inert] *)", "audio[controls]:not([inert]):not([inert] *)", "video[controls]:not([inert]):not([inert] *)", '[contenteditable]:not([contenteditable="false"]):not([inert]):not([inert] *)', "details>summary:first-of-type:not([inert]):not([inert] *)", "details:not([inert]):not([inert] *)"], candidateSelector = /* @__PURE__ */ candidateSelectors.join(","), NoElement = typeof Element == "undefined", matches = NoElement ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, getRootNode = !NoElement && Element.prototype.getRootNode ? function(t) {
  var r;
  return t == null || (r = t.getRootNode) === null || r === void 0 ? void 0 : r.call(t);
} : function(t) {
  return t == null ? void 0 : t.ownerDocument;
}, _isInert = function t(r, n) {
  var a;
  n === void 0 && (n = !0);
  var s = r == null || (a = r.getAttribute) === null || a === void 0 ? void 0 : a.call(r, "inert"), o = s === "" || s === "true", l = o || n && r && // closest does not exist on shadow roots, so we fall back to a manual
  // lookup upward, in case it is not defined.
  (typeof r.closest == "function" ? r.closest("[inert]") : _isInert(r.parentNode));
  return l;
}, isContentEditable = function t(r) {
  var n, a = r == null || (n = r.getAttribute) === null || n === void 0 ? void 0 : n.call(r, "contenteditable");
  return a === "" || a === "true";
}, getCandidates = function t(r, n, a) {
  if (_isInert(r))
    return [];
  var s = Array.prototype.slice.apply(r.querySelectorAll(candidateSelector));
  return n && matches.call(r, candidateSelector) && s.unshift(r), s = s.filter(a), s;
}, _getCandidatesIteratively = function t(r, n, a) {
  for (var s = [], o = Array.from(r); o.length; ) {
    var l = o.shift();
    if (!_isInert(l, !1))
      if (l.tagName === "SLOT") {
        var x = l.assignedElements(), j = x.length ? x : l.children, Z = _getCandidatesIteratively(j, !0, a);
        a.flatten ? s.push.apply(s, Z) : s.push({
          scopeParent: l,
          candidates: Z
        });
      } else {
        var V = matches.call(l, candidateSelector);
        V && a.filter(l) && (n || !r.includes(l)) && s.push(l);
        var $ = l.shadowRoot || // check for an undisclosed shadow
        typeof a.getShadowRoot == "function" && a.getShadowRoot(l), X = !_isInert($, !1) && (!a.shadowRootFilter || a.shadowRootFilter(l));
        if ($ && X) {
          var W = _getCandidatesIteratively($ === !0 ? l.children : $.children, !0, a);
          a.flatten ? s.push.apply(s, W) : s.push({
            scopeParent: l,
            candidates: W
          });
        } else
          o.unshift.apply(o, l.children);
      }
  }
  return s;
}, hasTabIndex = function t(r) {
  return !isNaN(parseInt(r.getAttribute("tabindex"), 10));
}, getTabIndex = function t(r) {
  if (!r)
    throw new Error("No node provided");
  return r.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(r.tagName) || isContentEditable(r)) && !hasTabIndex(r) ? 0 : r.tabIndex;
}, getSortOrderTabIndex = function t(r, n) {
  var a = getTabIndex(r);
  return a < 0 && n && !hasTabIndex(r) ? 0 : a;
}, sortOrderedTabbables = function t(r, n) {
  return r.tabIndex === n.tabIndex ? r.documentOrder - n.documentOrder : r.tabIndex - n.tabIndex;
}, isInput = function t(r) {
  return r.tagName === "INPUT";
}, isHiddenInput = function t(r) {
  return isInput(r) && r.type === "hidden";
}, isDetailsWithSummary = function t(r) {
  var n = r.tagName === "DETAILS" && Array.prototype.slice.apply(r.children).some(function(a) {
    return a.tagName === "SUMMARY";
  });
  return n;
}, getCheckedRadio = function t(r, n) {
  for (var a = 0; a < r.length; a++)
    if (r[a].checked && r[a].form === n)
      return r[a];
}, isTabbableRadio = function t(r) {
  if (!r.name)
    return !0;
  var n = r.form || getRootNode(r), a = function(x) {
    return n.querySelectorAll('input[type="radio"][name="' + x + '"]');
  }, s;
  if (typeof window != "undefined" && typeof window.CSS != "undefined" && typeof window.CSS.escape == "function")
    s = a(window.CSS.escape(r.name));
  else
    try {
      s = a(r.name);
    } catch (l) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", l.message), !1;
    }
  var o = getCheckedRadio(s, r.form);
  return !o || o === r;
}, isRadio = function t(r) {
  return isInput(r) && r.type === "radio";
}, isNonTabbableRadio = function t(r) {
  return isRadio(r) && !isTabbableRadio(r);
}, isNodeAttached = function t(r) {
  var n, a = r && getRootNode(r), s = (n = a) === null || n === void 0 ? void 0 : n.host, o = !1;
  if (a && a !== r) {
    var l, x, j;
    for (o = !!((l = s) !== null && l !== void 0 && (x = l.ownerDocument) !== null && x !== void 0 && x.contains(s) || r != null && (j = r.ownerDocument) !== null && j !== void 0 && j.contains(r)); !o && s; ) {
      var Z, V, $;
      a = getRootNode(s), s = (Z = a) === null || Z === void 0 ? void 0 : Z.host, o = !!((V = s) !== null && V !== void 0 && ($ = V.ownerDocument) !== null && $ !== void 0 && $.contains(s));
    }
  }
  return o;
}, isZeroArea = function t(r) {
  var n = r.getBoundingClientRect(), a = n.width, s = n.height;
  return a === 0 && s === 0;
}, isHidden = function t(r, n) {
  var a = n.displayCheck, s = n.getShadowRoot;
  if (a === "full-native" && "checkVisibility" in r) {
    var o = r.checkVisibility({
      // Checking opacity might be desirable for some use cases, but natively,
      // opacity zero elements _are_ focusable and tabbable.
      checkOpacity: !1,
      opacityProperty: !1,
      contentVisibilityAuto: !0,
      visibilityProperty: !0,
      // This is an alias for `visibilityProperty`. Contemporary browsers
      // support both. However, this alias has wider browser support (Chrome
      // >= 105 and Firefox >= 106, vs. Chrome >= 121 and Firefox >= 122), so
      // we include it anyway.
      checkVisibilityCSS: !0
    });
    return !o;
  }
  var l = getComputedStyle(r), x = l.visibility;
  if (x === "hidden" || x === "collapse")
    return !0;
  var j = matches.call(r, "details>summary:first-of-type"), Z = j ? r.parentElement : r;
  if (matches.call(Z, "details:not([open]) *"))
    return !0;
  if (!a || a === "full" || // full-native can run this branch when it falls through in case
  // Element#checkVisibility is unsupported
  a === "full-native" || a === "legacy-full") {
    if (typeof s == "function") {
      for (var V = r; r; ) {
        var $ = r.parentElement, X = getRootNode(r);
        if ($ && !$.shadowRoot && s($) === !0)
          return isZeroArea(r);
        r.assignedSlot ? r = r.assignedSlot : !$ && X !== r.ownerDocument ? r = X.host : r = $;
      }
      r = V;
    }
    if (isNodeAttached(r))
      return !r.getClientRects().length;
    if (a !== "legacy-full")
      return !0;
  } else if (a === "non-zero-area")
    return isZeroArea(r);
  return !1;
}, isDisabledFromFieldset = function t(r) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(r.tagName))
    for (var n = r.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var a = 0; a < n.children.length; a++) {
          var s = n.children.item(a);
          if (s.tagName === "LEGEND")
            return matches.call(n, "fieldset[disabled] *") ? !0 : !s.contains(r);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, isNodeMatchingSelectorFocusable = function t(r, n) {
  return !(n.disabled || isHiddenInput(n) || isHidden(n, r) || // For a details element with a summary, the summary element gets the focus
  isDetailsWithSummary(n) || isDisabledFromFieldset(n));
}, isNodeMatchingSelectorTabbable = function t(r, n) {
  return !(isNonTabbableRadio(n) || getTabIndex(n) < 0 || !isNodeMatchingSelectorFocusable(r, n));
}, isShadowRootTabbable = function t(r) {
  var n = parseInt(r.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, _sortByOrder = function t(r) {
  var n = [], a = [];
  return r.forEach(function(s, o) {
    var l = !!s.scopeParent, x = l ? s.scopeParent : s, j = getSortOrderTabIndex(x, l), Z = l ? _sortByOrder(s.candidates) : x;
    j === 0 ? l ? n.push.apply(n, Z) : n.push(x) : a.push({
      documentOrder: o,
      tabIndex: j,
      item: s,
      isScope: l,
      content: Z
    });
  }), a.sort(sortOrderedTabbables).reduce(function(s, o) {
    return o.isScope ? s.push.apply(s, o.content) : s.push(o.content), s;
  }, []).concat(n);
}, tabbable = function t(r, n) {
  n = n || {};
  var a;
  return n.getShadowRoot ? a = _getCandidatesIteratively([r], n.includeContainer, {
    filter: isNodeMatchingSelectorTabbable.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: isShadowRootTabbable
  }) : a = getCandidates(r, n.includeContainer, isNodeMatchingSelectorTabbable.bind(null, n)), _sortByOrder(a);
}, focusable = function t(r, n) {
  n = n || {};
  var a;
  return n.getShadowRoot ? a = _getCandidatesIteratively([r], n.includeContainer, {
    filter: isNodeMatchingSelectorFocusable.bind(null, n),
    flatten: !0,
    getShadowRoot: n.getShadowRoot
  }) : a = getCandidates(r, n.includeContainer, isNodeMatchingSelectorFocusable.bind(null, n)), a;
}, isTabbable = function t(r, n) {
  if (n = n || {}, !r)
    throw new Error("No node provided");
  return matches.call(r, candidateSelector) === !1 ? !1 : isNodeMatchingSelectorTabbable(n, r);
};
function getPlatform() {
  const t = navigator.userAgentData;
  return t != null && t.platform ? t.platform : navigator.platform;
}
function getUserAgent() {
  const t = navigator.userAgentData;
  return t && Array.isArray(t.brands) ? t.brands.map((r) => {
    let {
      brand: n,
      version: a
    } = r;
    return n + "/" + a;
  }).join(" ") : navigator.userAgent;
}
function isSafari() {
  return /apple/i.test(navigator.vendor);
}
function isAndroid() {
  const t = /android/i;
  return t.test(getPlatform()) || t.test(getUserAgent());
}
function isMac() {
  return getPlatform().toLowerCase().startsWith("mac") && !navigator.maxTouchPoints;
}
function isJSDOM() {
  return getUserAgent().includes("jsdom/");
}
const FOCUSABLE_ATTRIBUTE$1 = "data-floating-ui-focusable", TYPEABLE_SELECTOR = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function activeElement(t) {
  let r = t.activeElement;
  for (; ((n = r) == null || (n = n.shadowRoot) == null ? void 0 : n.activeElement) != null; ) {
    var n;
    r = r.shadowRoot.activeElement;
  }
  return r;
}
function contains$1(t, r) {
  if (!t || !r)
    return !1;
  const n = r.getRootNode == null ? void 0 : r.getRootNode();
  if (t.contains(r))
    return !0;
  if (n && isShadowRoot(n)) {
    let a = r;
    for (; a; ) {
      if (t === a)
        return !0;
      a = a.parentNode || a.host;
    }
  }
  return !1;
}
function getTarget$1(t) {
  return "composedPath" in t ? t.composedPath()[0] : t.target;
}
function isEventTargetWithin(t, r) {
  if (r == null)
    return !1;
  if ("composedPath" in t)
    return t.composedPath().includes(r);
  const n = t;
  return n.target != null && r.contains(n.target);
}
function isRootElement(t) {
  return t.matches("html,body");
}
function getDocument$1(t) {
  return (t == null ? void 0 : t.ownerDocument) || document;
}
function isTypeableElement(t) {
  return isHTMLElement(t) && t.matches(TYPEABLE_SELECTOR);
}
function isTypeableCombobox(t) {
  return t ? t.getAttribute("role") === "combobox" && isTypeableElement(t) : !1;
}
function matchesFocusVisible(t) {
  if (!t || isJSDOM()) return !0;
  try {
    return t.matches(":focus-visible");
  } catch {
    return !0;
  }
}
function getFloatingFocusElement(t) {
  return t ? t.hasAttribute(FOCUSABLE_ATTRIBUTE$1) ? t : t.querySelector("[" + FOCUSABLE_ATTRIBUTE$1 + "]") || t : null;
}
function getNodeChildren$1(t, r, n) {
  return n === void 0 && (n = !0), t.filter((s) => {
    var o;
    return s.parentId === r && (!n || ((o = s.context) == null ? void 0 : o.open));
  }).flatMap((s) => [s, ...getNodeChildren$1(t, s.id, n)]);
}
function getNodeAncestors(t, r) {
  var n;
  let a = [], s = (n = t.find((o) => o.id === r)) == null ? void 0 : n.parentId;
  for (; s; ) {
    const o = t.find((l) => l.id === s);
    s = o == null ? void 0 : o.parentId, o && (a = a.concat(o));
  }
  return a;
}
function stopEvent(t) {
  t.preventDefault(), t.stopPropagation();
}
function isReactEvent(t) {
  return "nativeEvent" in t;
}
function isVirtualClick(t) {
  return t.mozInputSource === 0 && t.isTrusted ? !0 : isAndroid() && t.pointerType ? t.type === "click" && t.buttons === 1 : t.detail === 0 && !t.pointerType;
}
function isVirtualPointerEvent(t) {
  return isJSDOM() ? !1 : !isAndroid() && t.width === 0 && t.height === 0 || isAndroid() && t.width === 1 && t.height === 1 && t.pressure === 0 && t.detail === 0 && t.pointerType === "mouse" || // iOS VoiceOver returns 0.333• for width/height.
  t.width < 1 && t.height < 1 && t.pressure === 0 && t.detail === 0 && t.pointerType === "touch";
}
function isMouseLikePointerType(t, r) {
  const n = ["mouse", "pen"];
  return r || n.push("", void 0), n.includes(t);
}
var isClient$1 = typeof document != "undefined", noop$1 = function t() {
}, index$1 = isClient$1 ? useLayoutEffect$3 : noop$1;
const SafeReact$1 = {
  ...React
};
function useLatestRef$1(t) {
  const r = React.useRef(t);
  return index$1(() => {
    r.current = t;
  }), r;
}
const useInsertionEffect = SafeReact$1.useInsertionEffect, useSafeInsertionEffect = useInsertionEffect || ((t) => t());
function useEffectEvent(t) {
  const r = React.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return useSafeInsertionEffect(() => {
    r.current = t;
  }), React.useCallback(function() {
    for (var n = arguments.length, a = new Array(n), s = 0; s < n; s++)
      a[s] = arguments[s];
    return r.current == null ? void 0 : r.current(...a);
  }, []);
}
const getTabbableOptions = () => ({
  getShadowRoot: !0,
  displayCheck: (
    // JSDOM does not support the `tabbable` library. To solve this we can
    // check if `ResizeObserver` is a real function (not polyfilled), which
    // determines if the current environment is JSDOM-like.
    typeof ResizeObserver == "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
  )
});
function getTabbableIn(t, r) {
  const n = tabbable(t, getTabbableOptions()), a = n.length;
  if (a === 0) return;
  const s = activeElement(getDocument$1(t)), o = n.indexOf(s), l = o === -1 ? r === 1 ? 0 : a - 1 : o + r;
  return n[l];
}
function getNextTabbable(t) {
  return getTabbableIn(getDocument$1(t).body, 1) || t;
}
function getPreviousTabbable(t) {
  return getTabbableIn(getDocument$1(t).body, -1) || t;
}
function isOutsideEvent(t, r) {
  const n = r || t.currentTarget, a = t.relatedTarget;
  return !a || !contains$1(n, a);
}
function disableFocusInside(t) {
  tabbable(t, getTabbableOptions()).forEach((n) => {
    n.dataset.tabindex = n.getAttribute("tabindex") || "", n.setAttribute("tabindex", "-1");
  });
}
function enableFocusInside(t) {
  t.querySelectorAll("[data-tabindex]").forEach((n) => {
    const a = n.dataset.tabindex;
    delete n.dataset.tabindex, a ? n.setAttribute("tabindex", a) : n.removeAttribute("tabindex");
  });
}
function computeCoordsFromPlacement(t, r, n) {
  let {
    reference: a,
    floating: s
  } = t;
  const o = getSideAxis(r), l = getAlignmentAxis(r), x = getAxisLength(l), j = getSide(r), Z = o === "y", V = a.x + a.width / 2 - s.width / 2, $ = a.y + a.height / 2 - s.height / 2, X = a[x] / 2 - s[x] / 2;
  let W;
  switch (j) {
    case "top":
      W = {
        x: V,
        y: a.y - s.height
      };
      break;
    case "bottom":
      W = {
        x: V,
        y: a.y + a.height
      };
      break;
    case "right":
      W = {
        x: a.x + a.width,
        y: $
      };
      break;
    case "left":
      W = {
        x: a.x - s.width,
        y: $
      };
      break;
    default:
      W = {
        x: a.x,
        y: a.y
      };
  }
  const Y = getAlignment(r);
  return Y && (W[l] += X * (Y === "end" ? 1 : -1) * (n && Z ? -1 : 1)), W;
}
async function detectOverflow(t, r) {
  var n;
  r === void 0 && (r = {});
  const {
    x: a,
    y: s,
    platform: o,
    rects: l,
    elements: x,
    strategy: j
  } = t, {
    boundary: Z = "clippingAncestors",
    rootBoundary: V = "viewport",
    elementContext: $ = "floating",
    altBoundary: X = !1,
    padding: W = 0
  } = evaluate(r, t), Y = getPaddingObject(W), G = x[X ? $ === "floating" ? "reference" : "floating" : $], K = rectToClientRect(await o.getClippingRect({
    element: (n = await (o.isElement == null ? void 0 : o.isElement(G))) == null || n ? G : G.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(x.floating)),
    boundary: Z,
    rootBoundary: V,
    strategy: j
  })), J = $ === "floating" ? {
    x: a,
    y: s,
    width: l.floating.width,
    height: l.floating.height
  } : l.reference, ee = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(x.floating)), te = await (o.isElement == null ? void 0 : o.isElement(ee)) && await (o.getScale == null ? void 0 : o.getScale(ee)) || {
    x: 1,
    y: 1
  }, re = rectToClientRect(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: x,
    rect: J,
    offsetParent: ee,
    strategy: j
  }) : J);
  return {
    top: (K.top - re.top + Y.top) / te.y,
    bottom: (re.bottom - K.bottom + Y.bottom) / te.y,
    left: (K.left - re.left + Y.left) / te.x,
    right: (re.right - K.right + Y.right) / te.x
  };
}
const MAX_RESET_COUNT = 50, computePosition$1 = async (t, r, n) => {
  const {
    placement: a = "bottom",
    strategy: s = "absolute",
    middleware: o = [],
    platform: l
  } = n, x = l.detectOverflow ? l : {
    ...l,
    detectOverflow
  }, j = await (l.isRTL == null ? void 0 : l.isRTL(r));
  let Z = await l.getElementRects({
    reference: t,
    floating: r,
    strategy: s
  }), {
    x: V,
    y: $
  } = computeCoordsFromPlacement(Z, a, j), X = a, W = 0;
  const Y = {};
  for (let U = 0; U < o.length; U++) {
    const G = o[U];
    if (!G)
      continue;
    const {
      name: K,
      fn: J
    } = G, {
      x: ee,
      y: te,
      data: re,
      reset: ae
    } = await J({
      x: V,
      y: $,
      initialPlacement: a,
      placement: X,
      strategy: s,
      middlewareData: Y,
      rects: Z,
      platform: x,
      elements: {
        reference: t,
        floating: r
      }
    });
    V = ee != null ? ee : V, $ = te != null ? te : $, Y[K] = {
      ...Y[K],
      ...re
    }, ae && W < MAX_RESET_COUNT && (W++, typeof ae == "object" && (ae.placement && (X = ae.placement), ae.rects && (Z = ae.rects === !0 ? await l.getElementRects({
      reference: t,
      floating: r,
      strategy: s
    }) : ae.rects), {
      x: V,
      y: $
    } = computeCoordsFromPlacement(Z, X, j)), U = -1);
  }
  return {
    x: V,
    y: $,
    placement: X,
    strategy: s,
    middlewareData: Y
  };
}, arrow$3 = (t) => ({
  name: "arrow",
  options: t,
  async fn(r) {
    const {
      x: n,
      y: a,
      placement: s,
      rects: o,
      platform: l,
      elements: x,
      middlewareData: j
    } = r, {
      element: Z,
      padding: V = 0
    } = evaluate(t, r) || {};
    if (Z == null)
      return {};
    const $ = getPaddingObject(V), X = {
      x: n,
      y: a
    }, W = getAlignmentAxis(s), Y = getAxisLength(W), U = await l.getDimensions(Z), G = W === "y", K = G ? "top" : "left", J = G ? "bottom" : "right", ee = G ? "clientHeight" : "clientWidth", te = o.reference[Y] + o.reference[W] - X[W] - o.floating[Y], re = X[W] - o.reference[W], ae = await (l.getOffsetParent == null ? void 0 : l.getOffsetParent(Z));
    let ie = ae ? ae[ee] : 0;
    (!ie || !await (l.isElement == null ? void 0 : l.isElement(ae))) && (ie = x.floating[ee] || o.floating[Y]);
    const ce = te / 2 - re / 2, he = ie / 2 - U[Y] / 2 - 1, oe = min$1($[K], he), le = min$1($[J], he), pe = ie - U[Y] - le, de = ie / 2 - U[Y] / 2 + ce, se = clamp$1(oe, de, pe), ue = !j.arrow && getAlignment(s) != null && de !== se && o.reference[Y] / 2 - (de < oe ? oe : le) - U[Y] / 2 < 0, fe = ue ? de < oe ? de - oe : de - pe : 0;
    return {
      [W]: X[W] + fe,
      data: {
        [W]: se,
        centerOffset: de - se - fe,
        ...ue && {
          alignmentOffset: fe
        }
      },
      reset: ue
    };
  }
}), flip$2 = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(r) {
      var n, a;
      const {
        placement: s,
        middlewareData: o,
        rects: l,
        initialPlacement: x,
        platform: j,
        elements: Z
      } = r, {
        mainAxis: V = !0,
        crossAxis: $ = !0,
        fallbackPlacements: X,
        fallbackStrategy: W = "bestFit",
        fallbackAxisSideDirection: Y = "none",
        flipAlignment: U = !0,
        ...G
      } = evaluate(t, r);
      if ((n = o.arrow) != null && n.alignmentOffset)
        return {};
      const K = getSide(s), J = getSideAxis(x), ee = getSide(x) === x, te = await (j.isRTL == null ? void 0 : j.isRTL(Z.floating)), re = X || (ee || !U ? [getOppositePlacement(x)] : getExpandedPlacements(x)), ae = Y !== "none";
      !X && ae && re.push(...getOppositeAxisPlacements(x, U, Y, te));
      const ie = [x, ...re], ce = await j.detectOverflow(r, G), he = [];
      let oe = ((a = o.flip) == null ? void 0 : a.overflows) || [];
      if (V && he.push(ce[K]), $) {
        const se = getAlignmentSides(s, l, te);
        he.push(ce[se[0]], ce[se[1]]);
      }
      if (oe = [...oe, {
        placement: s,
        overflows: he
      }], !he.every((se) => se <= 0)) {
        var le, pe;
        const se = (((le = o.flip) == null ? void 0 : le.index) || 0) + 1, ue = ie[se];
        if (ue && (!($ === "alignment" ? J !== getSideAxis(ue) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        oe.every((ne) => getSideAxis(ne.placement) === J ? ne.overflows[0] > 0 : !0)))
          return {
            data: {
              index: se,
              overflows: oe
            },
            reset: {
              placement: ue
            }
          };
        let fe = (pe = oe.filter((ge) => ge.overflows[0] <= 0).sort((ge, ne) => ge.overflows[1] - ne.overflows[1])[0]) == null ? void 0 : pe.placement;
        if (!fe)
          switch (W) {
            case "bestFit": {
              var de;
              const ge = (de = oe.filter((ne) => {
                if (ae) {
                  const ve = getSideAxis(ne.placement);
                  return ve === J || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  ve === "y";
                }
                return !0;
              }).map((ne) => [ne.placement, ne.overflows.filter((ve) => ve > 0).reduce((ve, me) => ve + me, 0)]).sort((ne, ve) => ne[1] - ve[1])[0]) == null ? void 0 : de[0];
              ge && (fe = ge);
              break;
            }
            case "initialPlacement":
              fe = x;
              break;
          }
        if (s !== fe)
          return {
            reset: {
              placement: fe
            }
          };
      }
      return {};
    }
  };
}, originSides = /* @__PURE__ */ new Set(["left", "top"]);
async function convertValueToCoords(t, r) {
  const {
    placement: n,
    platform: a,
    elements: s
  } = t, o = await (a.isRTL == null ? void 0 : a.isRTL(s.floating)), l = getSide(n), x = getAlignment(n), j = getSideAxis(n) === "y", Z = originSides.has(l) ? -1 : 1, V = o && j ? -1 : 1, $ = evaluate(r, t);
  let {
    mainAxis: X,
    crossAxis: W,
    alignmentAxis: Y
  } = typeof $ == "number" ? {
    mainAxis: $,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: $.mainAxis || 0,
    crossAxis: $.crossAxis || 0,
    alignmentAxis: $.alignmentAxis
  };
  return x && typeof Y == "number" && (W = x === "end" ? Y * -1 : Y), j ? {
    x: W * V,
    y: X * Z
  } : {
    x: X * Z,
    y: W * V
  };
}
const offset$2 = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(r) {
      var n, a;
      const {
        x: s,
        y: o,
        placement: l,
        middlewareData: x
      } = r, j = await convertValueToCoords(r, t);
      return l === ((n = x.offset) == null ? void 0 : n.placement) && (a = x.arrow) != null && a.alignmentOffset ? {} : {
        x: s + j.x,
        y: o + j.y,
        data: {
          ...j,
          placement: l
        }
      };
    }
  };
}, shift$2 = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(r) {
      const {
        x: n,
        y: a,
        placement: s,
        platform: o
      } = r, {
        mainAxis: l = !0,
        crossAxis: x = !1,
        limiter: j = {
          fn: (J) => {
            let {
              x: ee,
              y: te
            } = J;
            return {
              x: ee,
              y: te
            };
          }
        },
        ...Z
      } = evaluate(t, r), V = {
        x: n,
        y: a
      }, $ = await o.detectOverflow(r, Z), X = getSideAxis(s), W = getOppositeAxis(X);
      let Y = V[W], U = V[X];
      const G = (J, ee) => clamp$1(ee + $[J === "y" ? "top" : "left"], ee, ee - $[J === "y" ? "bottom" : "right"]);
      l && (Y = G(W, Y)), x && (U = G(X, U));
      const K = j.fn({
        ...r,
        [W]: Y,
        [X]: U
      });
      return {
        ...K,
        data: {
          x: K.x - n,
          y: K.y - a,
          enabled: {
            [W]: l,
            [X]: x
          }
        }
      };
    }
  };
};
function getCssDimensions(t) {
  const r = getComputedStyle$1(t);
  let n = parseFloat(r.width) || 0, a = parseFloat(r.height) || 0;
  const s = isHTMLElement(t), o = s ? t.offsetWidth : n, l = s ? t.offsetHeight : a, x = round$1(n) !== o || round$1(a) !== l;
  return x && (n = o, a = l), {
    width: n,
    height: a,
    $: x
  };
}
function unwrapElement(t) {
  return isElement(t) ? t : t.contextElement;
}
function getScale(t) {
  const r = unwrapElement(t);
  if (!isHTMLElement(r))
    return createCoords(1);
  const n = r.getBoundingClientRect(), {
    width: a,
    height: s,
    $: o
  } = getCssDimensions(r);
  let l = (o ? round$1(n.width) : n.width) / a, x = (o ? round$1(n.height) : n.height) / s;
  return (!l || !Number.isFinite(l)) && (l = 1), (!x || !Number.isFinite(x)) && (x = 1), {
    x: l,
    y: x
  };
}
const noOffsets = /* @__PURE__ */ createCoords(0);
function getVisualOffsets(t) {
  const r = getWindow(t);
  return !isWebKit() || !r.visualViewport ? noOffsets : {
    x: r.visualViewport.offsetLeft,
    y: r.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(t, r, n) {
  return r === void 0 && (r = !1), !!n && r && n === getWindow(t);
}
function getBoundingClientRect(t, r, n, a) {
  r === void 0 && (r = !1), n === void 0 && (n = !1);
  const s = t.getBoundingClientRect(), o = unwrapElement(t);
  let l = createCoords(1);
  r && (a ? isElement(a) && (l = getScale(a)) : l = getScale(t));
  const x = shouldAddVisualOffsets(o, n, a) ? getVisualOffsets(o) : createCoords(0);
  let j = (s.left + x.x) / l.x, Z = (s.top + x.y) / l.y, V = s.width / l.x, $ = s.height / l.y;
  if (o && a) {
    const X = getWindow(o), W = isElement(a) ? getWindow(a) : a;
    let Y = X, U = getFrameElement(Y);
    for (; U && W !== Y; ) {
      const G = getScale(U), K = U.getBoundingClientRect(), J = getComputedStyle$1(U), ee = K.left + (U.clientLeft + parseFloat(J.paddingLeft)) * G.x, te = K.top + (U.clientTop + parseFloat(J.paddingTop)) * G.y;
      j *= G.x, Z *= G.y, V *= G.x, $ *= G.y, j += ee, Z += te, Y = getWindow(U), U = getFrameElement(Y);
    }
  }
  return rectToClientRect({
    width: V,
    height: $,
    x: j,
    y: Z
  });
}
function getWindowScrollBarX(t, r) {
  const n = getNodeScroll(t).scrollLeft;
  return r ? r.left + n : getBoundingClientRect(getDocumentElement(t)).left + n;
}
function getHTMLOffset(t, r) {
  const n = t.getBoundingClientRect(), a = n.left + r.scrollLeft - getWindowScrollBarX(t, n), s = n.top + r.scrollTop;
  return {
    x: a,
    y: s
  };
}
function convertOffsetParentRelativeRectToViewportRelativeRect(t) {
  let {
    elements: r,
    rect: n,
    offsetParent: a,
    strategy: s
  } = t;
  const o = s === "fixed", l = getDocumentElement(a), x = r ? isTopLayer(r.floating) : !1;
  if (a === l || x && o)
    return n;
  let j = {
    scrollLeft: 0,
    scrollTop: 0
  }, Z = createCoords(1);
  const V = createCoords(0), $ = isHTMLElement(a);
  if (($ || !o) && ((getNodeName(a) !== "body" || isOverflowElement(l)) && (j = getNodeScroll(a)), $)) {
    const W = getBoundingClientRect(a);
    Z = getScale(a), V.x = W.x + a.clientLeft, V.y = W.y + a.clientTop;
  }
  const X = l && !$ && !o ? getHTMLOffset(l, j) : createCoords(0);
  return {
    width: n.width * Z.x,
    height: n.height * Z.y,
    x: n.x * Z.x - j.scrollLeft * Z.x + V.x + X.x,
    y: n.y * Z.y - j.scrollTop * Z.y + V.y + X.y
  };
}
function getClientRects(t) {
  return t.getClientRects ? Array.from(t.getClientRects()) : [];
}
function getDocumentRect(t) {
  const r = getNodeScroll(t), n = t.ownerDocument.body, a = max$1(t.scrollWidth, t.clientWidth, n.scrollWidth, n.clientWidth), s = max$1(t.scrollHeight, t.clientHeight, n.scrollHeight, n.clientHeight);
  let o = -r.scrollLeft + getWindowScrollBarX(t);
  const l = -r.scrollTop;
  return getComputedStyle$1(n).direction === "rtl" && (o += max$1(t.clientWidth, n.clientWidth) - a), {
    width: a,
    height: s,
    x: o,
    y: l
  };
}
const SCROLLBAR_MAX = 25;
function getViewportRect(t, r, n) {
  n === void 0 && (n = "viewport");
  const a = n === "layoutViewport", s = getWindow(t), o = getDocumentElement(t), l = s.visualViewport;
  let x = o.clientWidth, j = o.clientHeight, Z = 0, V = 0;
  if (l) {
    const X = !isWebKit() || r === "fixed";
    a ? X || (Z = -l.offsetLeft, V = -l.offsetTop) : (x = l.width, j = l.height, X && (Z = l.offsetLeft, V = l.offsetTop));
  }
  if (getWindowScrollBarX(o) <= 0) {
    const X = o.ownerDocument, W = X.body, Y = getComputedStyle(W), U = X.compatMode === "CSS1Compat" && parseFloat(Y.marginLeft) + parseFloat(Y.marginRight) || 0, G = Math.abs(o.clientWidth - W.clientWidth - U), K = getComputedStyle(o).scrollbarGutter === "stable both-edges" ? G / 2 : G;
    K <= SCROLLBAR_MAX && (x -= K);
  }
  return {
    width: x,
    height: j,
    x: Z,
    y: V
  };
}
function getInnerBoundingClientRect(t, r) {
  const n = getBoundingClientRect(t, !0, r === "fixed"), a = n.top + t.clientTop, s = n.left + t.clientLeft, o = getScale(t), l = t.clientWidth * o.x, x = t.clientHeight * o.y, j = s * o.x, Z = a * o.y;
  return {
    width: l,
    height: x,
    x: j,
    y: Z
  };
}
function getClientRectFromClippingAncestor(t, r, n) {
  let a;
  if (r === "viewport" || r === "layoutViewport")
    a = getViewportRect(t, n, r);
  else if (r === "document")
    a = getDocumentRect(getDocumentElement(t));
  else if (isElement(r))
    a = getInnerBoundingClientRect(r, n);
  else {
    const s = getVisualOffsets(t);
    a = {
      x: r.x - s.x,
      y: r.y - s.y,
      width: r.width,
      height: r.height
    };
  }
  return rectToClientRect(a);
}
function getClippingElementAncestors(t, r) {
  const n = r.get(t);
  if (n)
    return n;
  let a = getOverflowAncestors(t, [], !1).filter((x) => isElement(x) && getNodeName(x) !== "body"), s = null;
  const o = getComputedStyle$1(t).position === "fixed";
  let l = o ? getParentNode(t) : t;
  for (; isElement(l) && !isLastTraversableNode(l); ) {
    const x = getComputedStyle$1(l), j = isContainingBlock(l), Z = s ? s.position : o ? "fixed" : "";
    !j && (Z === "fixed" || Z === "absolute" && x.position === "static") ? a = a.filter(($) => $ !== l) : s = x, l = getParentNode(l);
  }
  return r.set(t, a), a;
}
function getClippingRect(t) {
  let {
    element: r,
    boundary: n,
    rootBoundary: a,
    strategy: s
  } = t;
  const l = [...n === "clippingAncestors" ? isTopLayer(r) ? [] : getClippingElementAncestors(r, this._c) : [].concat(n), a], x = getClientRectFromClippingAncestor(r, l[0], s);
  let j = x.top, Z = x.right, V = x.bottom, $ = x.left;
  for (let X = 1; X < l.length; X++) {
    const W = getClientRectFromClippingAncestor(r, l[X], s);
    j = max$1(W.top, j), Z = min$1(W.right, Z), V = min$1(W.bottom, V), $ = max$1(W.left, $);
  }
  return {
    width: Z - $,
    height: V - j,
    x: $,
    y: j
  };
}
function getDimensions(t) {
  const {
    width: r,
    height: n
  } = getCssDimensions(t);
  return {
    width: r,
    height: n
  };
}
function getRectRelativeToOffsetParent(t, r, n) {
  const a = isHTMLElement(r), s = getDocumentElement(r), o = n === "fixed", l = getBoundingClientRect(t, !0, o, r);
  let x = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const j = createCoords(0);
  if ((a || !o) && ((getNodeName(r) !== "body" || isOverflowElement(s)) && (x = getNodeScroll(r)), a)) {
    const X = getBoundingClientRect(r, !0, o, r);
    j.x = X.x + r.clientLeft, j.y = X.y + r.clientTop;
  }
  !a && s && (j.x = getWindowScrollBarX(s));
  const Z = s && !a && !o ? getHTMLOffset(s, x) : createCoords(0), V = l.left + x.scrollLeft - j.x - Z.x, $ = l.top + x.scrollTop - j.y - Z.y;
  return {
    x: V,
    y: $,
    width: l.width,
    height: l.height
  };
}
function isStaticPositioned(t) {
  return getComputedStyle$1(t).position === "static";
}
function getTrueOffsetParent(t, r) {
  if (!isHTMLElement(t) || getComputedStyle$1(t).position === "fixed")
    return null;
  if (r)
    return r(t);
  let n = t.offsetParent;
  return getDocumentElement(t) === n && (n = n.ownerDocument.body), n;
}
function getOffsetParent(t, r) {
  const n = getWindow(t);
  if (isTopLayer(t))
    return n;
  if (!isHTMLElement(t)) {
    let s = getParentNode(t);
    for (; s && !isLastTraversableNode(s); ) {
      if (isElement(s) && !isStaticPositioned(s))
        return s;
      s = getParentNode(s);
    }
    return n;
  }
  let a = getTrueOffsetParent(t, r);
  for (; a && isTableElement(a) && isStaticPositioned(a); )
    a = getTrueOffsetParent(a, r);
  return a && isLastTraversableNode(a) && isStaticPositioned(a) && !isContainingBlock(a) ? n : a || getContainingBlock(t) || n;
}
const getElementRects = async function(t) {
  const r = this.getOffsetParent || getOffsetParent, n = this.getDimensions, a = await n(t.floating);
  return {
    reference: getRectRelativeToOffsetParent(t.reference, await r(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: a.width,
      height: a.height
    }
  };
};
function isRTL(t) {
  return getComputedStyle$1(t).direction === "rtl";
}
const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement,
  isRTL
};
function rectsAreEqual(t, r) {
  return t.x === r.x && t.y === r.y && t.width === r.width && t.height === r.height;
}
function observeMove(t, r, n) {
  let a = null, s;
  const o = getDocumentElement(t);
  function l() {
    var V;
    clearTimeout(s), (V = a) == null || V.disconnect(), a = null;
  }
  function x(V, $) {
    V === void 0 && (V = !1), $ === void 0 && ($ = 1), l();
    const X = t.getBoundingClientRect(), {
      left: W,
      top: Y,
      width: U,
      height: G
    } = X;
    if (V || r(), !U || !G)
      return;
    const K = floor$1(Y), J = floor$1(o.clientWidth - (W + U)), ee = floor$1(o.clientHeight - (Y + G)), te = floor$1(W), ae = {
      rootMargin: -K + "px " + -J + "px " + -ee + "px " + -te + "px",
      threshold: max$1(0, min$1(1, $)) || 1
    };
    let ie = !0;
    function ce(he) {
      const oe = he[0].intersectionRatio;
      if (!rectsAreEqual(X, t.getBoundingClientRect()))
        return x();
      if (oe !== $) {
        if (!ie)
          return x();
        oe ? x(!1, oe) : s = setTimeout(() => {
          x(!1, 1e-7);
        }, 1e3);
      }
      ie = !1;
    }
    try {
      a = new IntersectionObserver(ce, {
        ...ae,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      a = new IntersectionObserver(ce, ae);
    }
    a.observe(t);
  }
  const j = getWindow(t), Z = () => x(n);
  return j.addEventListener("resize", Z), x(!0), () => {
    j.removeEventListener("resize", Z), l();
  };
}
function autoUpdate(t, r, n, a) {
  a === void 0 && (a = {});
  const {
    ancestorScroll: s = !0,
    ancestorResize: o = !0,
    elementResize: l = typeof ResizeObserver == "function",
    layoutShift: x = typeof IntersectionObserver == "function",
    animationFrame: j = !1
  } = a, Z = unwrapElement(t), V = s || o ? [...Z ? getOverflowAncestors(Z) : [], ...r ? getOverflowAncestors(r) : []] : [];
  V.forEach((K) => {
    s && K.addEventListener("scroll", n), o && K.addEventListener("resize", n);
  });
  const $ = Z && x ? observeMove(Z, n, o) : null;
  let X = -1, W = null;
  l && (W = new ResizeObserver((K) => {
    let [J] = K;
    J && J.target === Z && W && r && (W.unobserve(r), cancelAnimationFrame(X), X = requestAnimationFrame(() => {
      var ee;
      (ee = W) == null || ee.observe(r);
    })), n();
  }), Z && !j && W.observe(Z), r && W.observe(r));
  let Y, U = j ? getBoundingClientRect(t) : null;
  j && G();
  function G() {
    const K = getBoundingClientRect(t);
    U && !rectsAreEqual(U, K) && n(), U = K, Y = requestAnimationFrame(G);
  }
  return n(), () => {
    var K;
    V.forEach((J) => {
      s && J.removeEventListener("scroll", n), o && J.removeEventListener("resize", n);
    }), $ == null || $(), (K = W) == null || K.disconnect(), W = null, j && cancelAnimationFrame(Y);
  };
}
const offset$1 = offset$2, shift$1 = shift$2, flip$1 = flip$2, arrow$2 = arrow$3, computePosition = (t, r, n) => {
  const a = /* @__PURE__ */ new Map(), s = n != null ? n : {}, o = {
    ...platform,
    ...s.platform,
    _c: a
  };
  return computePosition$1(t, r, {
    ...s,
    platform: o
  });
};
var isClient = typeof document != "undefined", noop = function t() {
}, index = isClient ? useLayoutEffect$3 : noop;
function deepEqual(t, r) {
  if (t === r)
    return !0;
  if (typeof t != typeof r)
    return !1;
  if (typeof t == "function" && t.toString() === r.toString())
    return !0;
  let n, a, s;
  if (t && r && typeof t == "object") {
    if (Array.isArray(t)) {
      if (n = t.length, n !== r.length) return !1;
      for (a = n; a-- !== 0; )
        if (!deepEqual(t[a], r[a]))
          return !1;
      return !0;
    }
    if (s = Object.keys(t), n = s.length, n !== Object.keys(r).length)
      return !1;
    for (a = n; a-- !== 0; )
      if (!{}.hasOwnProperty.call(r, s[a]))
        return !1;
    for (a = n; a-- !== 0; ) {
      const o = s[a];
      if (!(o === "_owner" && t.$$typeof) && !deepEqual(t[o], r[o]))
        return !1;
    }
    return !0;
  }
  return t !== t && r !== r;
}
function getDPR(t) {
  return typeof window == "undefined" ? 1 : (t.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function roundByDPR(t, r) {
  const n = getDPR(t);
  return Math.round(r * n) / n;
}
function useLatestRef(t) {
  const r = React.useRef(t);
  return index(() => {
    r.current = t;
  }), r;
}
function useFloating$1(t) {
  t === void 0 && (t = {});
  const {
    placement: r = "bottom",
    strategy: n = "absolute",
    middleware: a = [],
    platform: s,
    elements: {
      reference: o,
      floating: l
    } = {},
    transform: x = !0,
    whileElementsMounted: j,
    open: Z
  } = t, [V, $] = React.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: r,
    middlewareData: {},
    isPositioned: !1
  }), [X, W] = React.useState(a);
  deepEqual(X, a) || W(a);
  const [Y, U] = React.useState(null), [G, K] = React.useState(null), J = React.useCallback((ne) => {
    ne !== ae.current && (ae.current = ne, U(ne));
  }, []), ee = React.useCallback((ne) => {
    ne !== ie.current && (ie.current = ne, K(ne));
  }, []), te = o || Y, re = l || G, ae = React.useRef(null), ie = React.useRef(null), ce = React.useRef(V), he = j != null, oe = useLatestRef(j), le = useLatestRef(s), pe = useLatestRef(Z), de = React.useCallback(() => {
    if (!ae.current || !ie.current)
      return;
    const ne = {
      placement: r,
      strategy: n,
      middleware: X
    };
    le.current && (ne.platform = le.current), computePosition(ae.current, ie.current, ne).then((ve) => {
      const me = {
        ...ve,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: pe.current !== !1
      };
      se.current && !deepEqual(ce.current, me) && (ce.current = me, ReactDOM.flushSync(() => {
        $(me);
      }));
    });
  }, [X, r, n, le, pe]);
  index(() => {
    Z === !1 && ce.current.isPositioned && (ce.current.isPositioned = !1, $((ne) => ({
      ...ne,
      isPositioned: !1
    })));
  }, [Z]);
  const se = React.useRef(!1);
  index(() => (se.current = !0, () => {
    se.current = !1;
  }), []), index(() => {
    if (te && (ae.current = te), re && (ie.current = re), te && re) {
      if (oe.current)
        return oe.current(te, re, de);
      de();
    }
  }, [te, re, de, oe, he]);
  const ue = React.useMemo(() => ({
    reference: ae,
    floating: ie,
    setReference: J,
    setFloating: ee
  }), [J, ee]), fe = React.useMemo(() => ({
    reference: te,
    floating: re
  }), [te, re]), ge = React.useMemo(() => {
    const ne = {
      position: n,
      left: 0,
      top: 0
    };
    if (!fe.floating)
      return ne;
    const ve = roundByDPR(fe.floating, V.x), me = roundByDPR(fe.floating, V.y);
    return x ? {
      ...ne,
      transform: "translate(" + ve + "px, " + me + "px)",
      ...getDPR(fe.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: ve,
      top: me
    };
  }, [n, x, fe.floating, V.x, V.y]);
  return React.useMemo(() => ({
    ...V,
    update: de,
    refs: ue,
    elements: fe,
    floatingStyles: ge
  }), [V, de, ue, fe, ge]);
}
const arrow$1 = (t) => {
  function r(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: t,
    fn(n) {
      const {
        element: a,
        padding: s
      } = typeof t == "function" ? t(n) : t;
      return a && r(a) ? a.current != null ? arrow$2({
        element: a.current,
        padding: s
      }).fn(n) : {} : a ? arrow$2({
        element: a,
        padding: s
      }).fn(n) : {};
    }
  };
}, offset = (t, r) => {
  const n = offset$1(t);
  return {
    name: n.name,
    fn: n.fn,
    options: [t, r]
  };
}, shift = (t, r) => {
  const n = shift$1(t);
  return {
    name: n.name,
    fn: n.fn,
    options: [t, r]
  };
}, flip = (t, r) => {
  const n = flip$1(t);
  return {
    name: n.name,
    fn: n.fn,
    options: [t, r]
  };
}, arrow = (t, r) => {
  const n = arrow$1(t);
  return {
    name: n.name,
    fn: n.fn,
    options: [t, r]
  };
};
function useMergeRefs(t) {
  const r = React.useRef(void 0), n = React.useCallback((a) => {
    const s = t.map((o) => {
      if (o != null) {
        if (typeof o == "function") {
          const l = o, x = l(a);
          return typeof x == "function" ? x : () => {
            l(null);
          };
        }
        return o.current = a, () => {
          o.current = null;
        };
      }
    });
    return () => {
      s.forEach((o) => o == null ? void 0 : o());
    };
  }, t);
  return React.useMemo(() => t.every((a) => a == null) ? null : (a) => {
    r.current && (r.current(), r.current = void 0), a != null && (r.current = n(a));
  }, t);
}
const FOCUSABLE_ATTRIBUTE = "data-floating-ui-focusable", ACTIVE_KEY = "active", SELECTED_KEY = "selected", SafeReact = {
  ...React
};
let serverHandoffComplete = !1, count = 0;
const genId = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + count++
);
function useFloatingId() {
  const [t, r] = React.useState(() => serverHandoffComplete ? genId() : void 0);
  return index$1(() => {
    t == null && r(genId());
  }, []), React.useEffect(() => {
    serverHandoffComplete = !0;
  }, []), t;
}
const useReactId = SafeReact.useId, useId = useReactId || useFloatingId;
let devMessageSet;
process.env.NODE_ENV !== "production" && (devMessageSet = /* @__PURE__ */ new Set());
function warn() {
  for (var t, r = arguments.length, n = new Array(r), a = 0; a < r; a++)
    n[a] = arguments[a];
  const s = "Floating UI: " + n.join(" ");
  if (!((t = devMessageSet) != null && t.has(s))) {
    var o;
    (o = devMessageSet) == null || o.add(s), console.warn(s);
  }
}
function error() {
  for (var t, r = arguments.length, n = new Array(r), a = 0; a < r; a++)
    n[a] = arguments[a];
  const s = "Floating UI: " + n.join(" ");
  if (!((t = devMessageSet) != null && t.has(s))) {
    var o;
    (o = devMessageSet) == null || o.add(s), console.error(s);
  }
}
const FloatingArrow = /* @__PURE__ */ React.forwardRef(function t(r, n) {
  const {
    context: {
      placement: a,
      elements: {
        floating: s
      },
      middlewareData: {
        arrow: o,
        shift: l
      }
    },
    width: x = 14,
    height: j = 7,
    tipRadius: Z = 0,
    strokeWidth: V = 0,
    staticOffset: $,
    stroke: X,
    d: W,
    style: {
      transform: Y,
      ...U
    } = {},
    ...G
  } = r;
  process.env.NODE_ENV !== "production" && (n || warn("The `ref` prop is required for `FloatingArrow`."));
  const K = useId(), [J, ee] = React.useState(!1);
  if (index$1(() => {
    if (!s) return;
    getComputedStyle$1(s).direction === "rtl" && ee(!0);
  }, [s]), !s)
    return null;
  const [te, re] = a.split("-"), ae = te === "top" || te === "bottom";
  let ie = $;
  (ae && l != null && l.x || !ae && l != null && l.y) && (ie = null);
  const ce = V * 2, he = ce / 2, oe = x / 2 * (Z / -8 + 1), le = j / 2 * Z / 4, pe = !!W, de = ie && re === "end" ? "bottom" : "top";
  let se = ie && re === "end" ? "right" : "left";
  ie && J && (se = re === "end" ? "left" : "right");
  const ue = (o == null ? void 0 : o.x) != null ? ie || o.x : "", fe = (o == null ? void 0 : o.y) != null ? ie || o.y : "", ge = W || "M0,0" + (" H" + x) + (" L" + (x - oe) + "," + (j - le)) + (" Q" + x / 2 + "," + j + " " + oe + "," + (j - le)) + " Z", ne = {
    top: pe ? "rotate(180deg)" : "",
    left: pe ? "rotate(90deg)" : "rotate(-90deg)",
    bottom: pe ? "" : "rotate(180deg)",
    right: pe ? "rotate(-90deg)" : "rotate(90deg)"
  }[te];
  return /* @__PURE__ */ jsxs("svg", {
    ...G,
    "aria-hidden": !0,
    ref: n,
    width: pe ? x : x + ce,
    height: x,
    viewBox: "0 0 " + x + " " + (j > x ? j : x),
    style: {
      position: "absolute",
      pointerEvents: "none",
      [se]: ue,
      [de]: fe,
      [te]: ae || pe ? "100%" : "calc(100% - " + ce / 2 + "px)",
      transform: [ne, Y].filter((ve) => !!ve).join(" "),
      ...U
    },
    children: [ce > 0 && /* @__PURE__ */ jsx("path", {
      clipPath: "url(#" + K + ")",
      fill: "none",
      stroke: X,
      strokeWidth: ce + (W ? 0 : 1),
      d: ge
    }), /* @__PURE__ */ jsx("path", {
      stroke: ce && !W ? G.fill : "none",
      d: ge
    }), /* @__PURE__ */ jsx("clipPath", {
      id: K,
      children: /* @__PURE__ */ jsx("rect", {
        x: -he,
        y: he * (pe ? -1 : 1),
        width: x + ce,
        height: x
      })
    })]
  });
});
function createEventEmitter() {
  const t = /* @__PURE__ */ new Map();
  return {
    emit(r, n) {
      var a;
      (a = t.get(r)) == null || a.forEach((s) => s(n));
    },
    on(r, n) {
      t.has(r) || t.set(r, /* @__PURE__ */ new Set()), t.get(r).add(n);
    },
    off(r, n) {
      var a;
      (a = t.get(r)) == null || a.delete(n);
    }
  };
}
const FloatingNodeContext = /* @__PURE__ */ React.createContext(null), FloatingTreeContext = /* @__PURE__ */ React.createContext(null), useFloatingParentNodeId = () => {
  var t;
  return ((t = React.useContext(FloatingNodeContext)) == null ? void 0 : t.id) || null;
}, useFloatingTree = () => React.useContext(FloatingTreeContext);
function useFloatingNodeId(t) {
  const r = useId(), n = useFloatingTree(), a = useFloatingParentNodeId(), s = t || a;
  return index$1(() => {
    if (!r) return;
    const o = {
      id: r,
      parentId: s
    };
    return n == null || n.addNode(o), () => {
      n == null || n.removeNode(o);
    };
  }, [n, r, s]), r;
}
function FloatingNode(t) {
  const {
    children: r,
    id: n
  } = t, a = useFloatingParentNodeId();
  return /* @__PURE__ */ jsx(FloatingNodeContext.Provider, {
    value: React.useMemo(() => ({
      id: n,
      parentId: a
    }), [n, a]),
    children: r
  });
}
function FloatingTree(t) {
  const {
    children: r
  } = t, n = React.useRef([]), a = React.useCallback((l) => {
    n.current = [...n.current, l];
  }, []), s = React.useCallback((l) => {
    n.current = n.current.filter((x) => x !== l);
  }, []), [o] = React.useState(() => createEventEmitter());
  return /* @__PURE__ */ jsx(FloatingTreeContext.Provider, {
    value: React.useMemo(() => ({
      nodesRef: n,
      addNode: a,
      removeNode: s,
      events: o
    }), [a, s, o]),
    children: r
  });
}
function createAttribute(t) {
  return "data-floating-ui-" + t;
}
function clearTimeoutIfSet(t) {
  t.current !== -1 && (clearTimeout(t.current), t.current = -1);
}
const safePolygonIdentifier = /* @__PURE__ */ createAttribute("safe-polygon");
function getDelay(t, r, n) {
  if (n && !isMouseLikePointerType(n))
    return 0;
  if (typeof t == "number")
    return t;
  if (typeof t == "function") {
    const a = t();
    return typeof a == "number" ? a : a == null ? void 0 : a[r];
  }
  return t == null ? void 0 : t[r];
}
function getRestMs(t) {
  return typeof t == "function" ? t() : t;
}
function useHover(t, r) {
  r === void 0 && (r = {});
  const {
    open: n,
    onOpenChange: a,
    dataRef: s,
    events: o,
    elements: l
  } = t, {
    enabled: x = !0,
    delay: j = 0,
    handleClose: Z = null,
    mouseOnly: V = !1,
    restMs: $ = 0,
    move: X = !0
  } = r, W = useFloatingTree(), Y = useFloatingParentNodeId(), U = useLatestRef$1(Z), G = useLatestRef$1(j), K = useLatestRef$1(n), J = useLatestRef$1($), ee = React.useRef(), te = React.useRef(-1), re = React.useRef(), ae = React.useRef(-1), ie = React.useRef(!0), ce = React.useRef(!1), he = React.useRef(() => {
  }), oe = React.useRef(!1), le = useEffectEvent(() => {
    var ge;
    const ne = (ge = s.current.openEvent) == null ? void 0 : ge.type;
    return (ne == null ? void 0 : ne.includes("mouse")) && ne !== "mousedown";
  });
  React.useEffect(() => {
    if (!x) return;
    function ge(ne) {
      let {
        open: ve
      } = ne;
      ve || (clearTimeoutIfSet(te), clearTimeoutIfSet(ae), ie.current = !0, oe.current = !1);
    }
    return o.on("openchange", ge), () => {
      o.off("openchange", ge);
    };
  }, [x, o]), React.useEffect(() => {
    if (!x || !U.current || !n) return;
    function ge(ve) {
      le() && a(!1, ve, "hover");
    }
    const ne = getDocument$1(l.floating).documentElement;
    return ne.addEventListener("mouseleave", ge), () => {
      ne.removeEventListener("mouseleave", ge);
    };
  }, [l.floating, n, a, x, U, le]);
  const pe = React.useCallback(function(ge, ne, ve) {
    ne === void 0 && (ne = !0), ve === void 0 && (ve = "hover");
    const me = getDelay(G.current, "close", ee.current);
    me && !re.current ? (clearTimeoutIfSet(te), te.current = window.setTimeout(() => a(!1, ge, ve), me)) : ne && (clearTimeoutIfSet(te), a(!1, ge, ve));
  }, [G, a]), de = useEffectEvent(() => {
    he.current(), re.current = void 0;
  }), se = useEffectEvent(() => {
    if (ce.current) {
      const ge = getDocument$1(l.floating).body;
      ge.style.pointerEvents = "", ge.removeAttribute(safePolygonIdentifier), ce.current = !1;
    }
  }), ue = useEffectEvent(() => s.current.openEvent ? ["click", "mousedown"].includes(s.current.openEvent.type) : !1);
  React.useEffect(() => {
    if (!x) return;
    function ge(Ee) {
      if (clearTimeoutIfSet(te), ie.current = !1, V && !isMouseLikePointerType(ee.current) || getRestMs(J.current) > 0 && !getDelay(G.current, "open"))
        return;
      const Se = getDelay(G.current, "open", ee.current);
      Se ? te.current = window.setTimeout(() => {
        K.current || a(!0, Ee, "hover");
      }, Se) : n || a(!0, Ee, "hover");
    }
    function ne(Ee) {
      if (ue()) {
        se();
        return;
      }
      he.current();
      const Se = getDocument$1(l.floating);
      if (clearTimeoutIfSet(ae), oe.current = !1, U.current && s.current.floatingContext) {
        n || clearTimeoutIfSet(te), re.current = U.current({
          ...s.current.floatingContext,
          tree: W,
          x: Ee.clientX,
          y: Ee.clientY,
          onClose() {
            se(), de(), ue() || pe(Ee, !0, "safe-polygon");
          }
        });
        const Ce = re.current;
        Se.addEventListener("mousemove", Ce), he.current = () => {
          Se.removeEventListener("mousemove", Ce);
        };
        return;
      }
      (ee.current !== "touch" || !contains$1(l.floating, Ee.relatedTarget)) && pe(Ee);
    }
    function ve(Ee) {
      ue() || s.current.floatingContext && (U.current == null || U.current({
        ...s.current.floatingContext,
        tree: W,
        x: Ee.clientX,
        y: Ee.clientY,
        onClose() {
          se(), de(), ue() || pe(Ee);
        }
      })(Ee));
    }
    function me() {
      clearTimeoutIfSet(te);
    }
    function xe(Ee) {
      ue() || pe(Ee, !1);
    }
    if (isElement(l.domReference)) {
      const Ee = l.domReference, Se = l.floating;
      return n && Ee.addEventListener("mouseleave", ve), X && Ee.addEventListener("mousemove", ge, {
        once: !0
      }), Ee.addEventListener("mouseenter", ge), Ee.addEventListener("mouseleave", ne), Se && (Se.addEventListener("mouseleave", ve), Se.addEventListener("mouseenter", me), Se.addEventListener("mouseleave", xe)), () => {
        n && Ee.removeEventListener("mouseleave", ve), X && Ee.removeEventListener("mousemove", ge), Ee.removeEventListener("mouseenter", ge), Ee.removeEventListener("mouseleave", ne), Se && (Se.removeEventListener("mouseleave", ve), Se.removeEventListener("mouseenter", me), Se.removeEventListener("mouseleave", xe));
      };
    }
  }, [l, x, t, V, X, pe, de, se, a, n, K, W, G, U, s, ue, J]), index$1(() => {
    var ge;
    if (x && n && (ge = U.current) != null && (ge = ge.__options) != null && ge.blockPointerEvents && le()) {
      ce.current = !0;
      const ve = l.floating;
      if (isElement(l.domReference) && ve) {
        var ne;
        const me = getDocument$1(l.floating).body;
        me.setAttribute(safePolygonIdentifier, "");
        const xe = l.domReference, Ee = W == null || (ne = W.nodesRef.current.find((Se) => Se.id === Y)) == null || (ne = ne.context) == null ? void 0 : ne.elements.floating;
        return Ee && (Ee.style.pointerEvents = ""), me.style.pointerEvents = "none", xe.style.pointerEvents = "auto", ve.style.pointerEvents = "auto", () => {
          me.style.pointerEvents = "", xe.style.pointerEvents = "", ve.style.pointerEvents = "";
        };
      }
    }
  }, [x, n, Y, l, W, U, le]), index$1(() => {
    n || (ee.current = void 0, oe.current = !1, de(), se());
  }, [n, de, se]), React.useEffect(() => () => {
    de(), clearTimeoutIfSet(te), clearTimeoutIfSet(ae), se();
  }, [x, l.domReference, de, se]);
  const fe = React.useMemo(() => {
    function ge(ne) {
      ee.current = ne.pointerType;
    }
    return {
      onPointerDown: ge,
      onPointerEnter: ge,
      onMouseMove(ne) {
        const {
          nativeEvent: ve
        } = ne;
        function me() {
          !ie.current && !K.current && a(!0, ve, "hover");
        }
        V && !isMouseLikePointerType(ee.current) || n || getRestMs(J.current) === 0 || oe.current && ne.movementX ** 2 + ne.movementY ** 2 < 2 || (clearTimeoutIfSet(ae), ee.current === "touch" ? me() : (oe.current = !0, ae.current = window.setTimeout(me, getRestMs(J.current))));
      }
    };
  }, [V, a, n, K, J]);
  return React.useMemo(() => x ? {
    reference: fe
  } : {}, [x, fe]);
}
let rafId = 0;
function enqueueFocus(t, r) {
  r === void 0 && (r = {});
  const {
    preventScroll: n = !1,
    cancelPrevious: a = !0,
    sync: s = !1
  } = r;
  a && cancelAnimationFrame(rafId);
  const o = () => t == null ? void 0 : t.focus({
    preventScroll: n
  });
  s ? o() : rafId = requestAnimationFrame(o);
}
function contains(t, r) {
  if (!t || !r)
    return !1;
  const n = r.getRootNode == null ? void 0 : r.getRootNode();
  if (t.contains(r))
    return !0;
  if (n && isShadowRoot(n)) {
    let a = r;
    for (; a; ) {
      if (t === a)
        return !0;
      a = a.parentNode || a.host;
    }
  }
  return !1;
}
function getTarget(t) {
  return "composedPath" in t ? t.composedPath()[0] : t.target;
}
function getDocument(t) {
  return (t == null ? void 0 : t.ownerDocument) || document;
}
const counters = {
  inert: /* @__PURE__ */ new WeakMap(),
  "aria-hidden": /* @__PURE__ */ new WeakMap(),
  none: /* @__PURE__ */ new WeakMap()
};
function getCounterMap(t) {
  return t === "inert" ? counters.inert : t === "aria-hidden" ? counters["aria-hidden"] : counters.none;
}
let uncontrolledElementsSet = /* @__PURE__ */ new WeakSet(), markerMap = {}, lockCount$1 = 0;
const supportsInert = () => typeof HTMLElement != "undefined" && "inert" in HTMLElement.prototype, unwrapHost = (t) => t && (t.host || unwrapHost(t.parentNode)), correctElements = (t, r) => r.map((n) => {
  if (t.contains(n))
    return n;
  const a = unwrapHost(n);
  return t.contains(a) ? a : null;
}).filter((n) => n != null);
function applyAttributeToOthers(t, r, n, a) {
  const s = "data-floating-ui-inert", o = a ? "inert" : n ? "aria-hidden" : null, l = correctElements(r, t), x = /* @__PURE__ */ new Set(), j = new Set(l), Z = [];
  markerMap[s] || (markerMap[s] = /* @__PURE__ */ new WeakMap());
  const V = markerMap[s];
  l.forEach($), X(r), x.clear();
  function $(W) {
    !W || x.has(W) || (x.add(W), W.parentNode && $(W.parentNode));
  }
  function X(W) {
    !W || j.has(W) || [].forEach.call(W.children, (Y) => {
      if (getNodeName(Y) !== "script")
        if (x.has(Y))
          X(Y);
        else {
          const U = o ? Y.getAttribute(o) : null, G = U !== null && U !== "false", K = getCounterMap(o), J = (K.get(Y) || 0) + 1, ee = (V.get(Y) || 0) + 1;
          K.set(Y, J), V.set(Y, ee), Z.push(Y), J === 1 && G && uncontrolledElementsSet.add(Y), ee === 1 && Y.setAttribute(s, ""), !G && o && Y.setAttribute(o, o === "inert" ? "" : "true");
        }
    });
  }
  return lockCount$1++, () => {
    Z.forEach((W) => {
      const Y = getCounterMap(o), G = (Y.get(W) || 0) - 1, K = (V.get(W) || 0) - 1;
      Y.set(W, G), V.set(W, K), G || (!uncontrolledElementsSet.has(W) && o && W.removeAttribute(o), uncontrolledElementsSet.delete(W)), K || W.removeAttribute(s);
    }), lockCount$1--, lockCount$1 || (counters.inert = /* @__PURE__ */ new WeakMap(), counters["aria-hidden"] = /* @__PURE__ */ new WeakMap(), counters.none = /* @__PURE__ */ new WeakMap(), uncontrolledElementsSet = /* @__PURE__ */ new WeakSet(), markerMap = {});
  };
}
function markOthers(t, r, n) {
  r === void 0 && (r = !1), n === void 0 && (n = !1);
  const a = getDocument(t[0]).body;
  return applyAttributeToOthers(t.concat(Array.from(a.querySelectorAll('[aria-live],[role="status"],output'))), a, r, n);
}
const HIDDEN_STYLES = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "fixed",
  whiteSpace: "nowrap",
  width: "1px",
  top: 0,
  left: 0
}, FocusGuard = /* @__PURE__ */ React.forwardRef(function t(r, n) {
  const [a, s] = React.useState();
  index$1(() => {
    isSafari() && s("button");
  }, []);
  const o = {
    ref: n,
    tabIndex: 0,
    // Role is only for VoiceOver
    role: a,
    "aria-hidden": a ? void 0 : !0,
    [createAttribute("focus-guard")]: "",
    style: HIDDEN_STYLES
  };
  return /* @__PURE__ */ jsx("span", {
    ...r,
    ...o
  });
}), PortalContext = /* @__PURE__ */ React.createContext(null), attr = /* @__PURE__ */ createAttribute("portal");
function useFloatingPortalNode(t) {
  t === void 0 && (t = {});
  const {
    id: r,
    root: n
  } = t, a = useId(), s = usePortalContext(), [o, l] = React.useState(null), x = React.useRef(null);
  return index$1(() => () => {
    o == null || o.remove(), queueMicrotask(() => {
      x.current = null;
    });
  }, [o]), index$1(() => {
    if (!a || x.current) return;
    const j = r ? document.getElementById(r) : null;
    if (!j) return;
    const Z = document.createElement("div");
    Z.id = a, Z.setAttribute(attr, ""), j.appendChild(Z), x.current = Z, l(Z);
  }, [r, a]), index$1(() => {
    if (n === null || !a || x.current) return;
    let j = n || (s == null ? void 0 : s.portalNode);
    j && !isNode(j) && (j = j.current), j = j || document.body;
    let Z = null;
    r && (Z = document.createElement("div"), Z.id = r, j.appendChild(Z));
    const V = document.createElement("div");
    V.id = a, V.setAttribute(attr, ""), j = Z || j, j.appendChild(V), x.current = V, l(V);
  }, [r, n, a, s]), o;
}
function FloatingPortal(t) {
  const {
    children: r,
    id: n,
    root: a,
    preserveTabOrder: s = !0
  } = t, o = useFloatingPortalNode({
    id: n,
    root: a
  }), [l, x] = React.useState(null), j = React.useRef(null), Z = React.useRef(null), V = React.useRef(null), $ = React.useRef(null), X = l == null ? void 0 : l.modal, W = l == null ? void 0 : l.open, Y = (
    // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!l && // Guards are only for non-modal focus management.
    !l.modal && // Don't render if unmount is transitioning.
    l.open && s && !!(a || o)
  );
  return React.useEffect(() => {
    if (!o || !s || X)
      return;
    function U(G) {
      o && isOutsideEvent(G) && (G.type === "focusin" ? enableFocusInside : disableFocusInside)(o);
    }
    return o.addEventListener("focusin", U, !0), o.addEventListener("focusout", U, !0), () => {
      o.removeEventListener("focusin", U, !0), o.removeEventListener("focusout", U, !0);
    };
  }, [o, s, X]), React.useEffect(() => {
    o && (W || enableFocusInside(o));
  }, [W, o]), /* @__PURE__ */ jsxs(PortalContext.Provider, {
    value: React.useMemo(() => ({
      preserveTabOrder: s,
      beforeOutsideRef: j,
      afterOutsideRef: Z,
      beforeInsideRef: V,
      afterInsideRef: $,
      portalNode: o,
      setFocusManagerState: x
    }), [s, o]),
    children: [Y && o && /* @__PURE__ */ jsx(FocusGuard, {
      "data-type": "outside",
      ref: j,
      onFocus: (U) => {
        if (isOutsideEvent(U, o)) {
          var G;
          (G = V.current) == null || G.focus();
        } else {
          const K = l ? l.domReference : null, J = getPreviousTabbable(K);
          J == null || J.focus();
        }
      }
    }), Y && o && /* @__PURE__ */ jsx("span", {
      "aria-owns": o.id,
      style: HIDDEN_STYLES
    }), o && /* @__PURE__ */ ReactDOM.createPortal(r, o), Y && o && /* @__PURE__ */ jsx(FocusGuard, {
      "data-type": "outside",
      ref: Z,
      onFocus: (U) => {
        if (isOutsideEvent(U, o)) {
          var G;
          (G = $.current) == null || G.focus();
        } else {
          const K = l ? l.domReference : null, J = getNextTabbable(K);
          J == null || J.focus(), l != null && l.closeOnFocusOut && (l == null || l.onOpenChange(!1, U.nativeEvent, "focus-out"));
        }
      }
    })]
  });
}
const usePortalContext = () => React.useContext(PortalContext);
function useLiteMergeRefs(t) {
  return React.useMemo(() => (r) => {
    t.forEach((n) => {
      n && (n.current = r);
    });
  }, t);
}
const LIST_LIMIT = 20;
let previouslyFocusedElements = [];
function clearDisconnectedPreviouslyFocusedElements() {
  previouslyFocusedElements = previouslyFocusedElements.filter((t) => t.isConnected);
}
function addPreviouslyFocusedElement(t) {
  clearDisconnectedPreviouslyFocusedElements(), t && getNodeName(t) !== "body" && (previouslyFocusedElements.push(t), previouslyFocusedElements.length > LIST_LIMIT && (previouslyFocusedElements = previouslyFocusedElements.slice(-20)));
}
function getPreviouslyFocusedElement() {
  return clearDisconnectedPreviouslyFocusedElements(), previouslyFocusedElements[previouslyFocusedElements.length - 1];
}
function getFirstTabbableElement(t) {
  const r = getTabbableOptions();
  return isTabbable(t, r) ? t : tabbable(t, r)[0] || t;
}
function handleTabIndex(t, r) {
  var n;
  if (!r.current.includes("floating") && !((n = t.getAttribute("role")) != null && n.includes("dialog")))
    return;
  const a = getTabbableOptions(), o = focusable(t, a).filter((x) => {
    const j = x.getAttribute("data-tabindex") || "";
    return isTabbable(x, a) || x.hasAttribute("data-tabindex") && !j.startsWith("-");
  }), l = t.getAttribute("tabindex");
  r.current.includes("floating") || o.length === 0 ? l !== "0" && t.setAttribute("tabindex", "0") : (l !== "-1" || t.hasAttribute("data-tabindex") && t.getAttribute("data-tabindex") !== "-1") && (t.setAttribute("tabindex", "-1"), t.setAttribute("data-tabindex", "-1"));
}
const VisuallyHiddenDismiss = /* @__PURE__ */ React.forwardRef(function t(r, n) {
  return /* @__PURE__ */ jsx("button", {
    ...r,
    type: "button",
    ref: n,
    tabIndex: -1,
    style: HIDDEN_STYLES
  });
});
function FloatingFocusManager(t) {
  const {
    context: r,
    children: n,
    disabled: a = !1,
    order: s = ["content"],
    guards: o = !0,
    initialFocus: l = 0,
    returnFocus: x = !0,
    restoreFocus: j = !1,
    modal: Z = !0,
    visuallyHiddenDismiss: V = !1,
    closeOnFocusOut: $ = !0,
    outsideElementsInert: X = !1,
    getInsideElements: W = () => []
  } = t, {
    open: Y,
    onOpenChange: U,
    events: G,
    dataRef: K,
    elements: {
      domReference: J,
      floating: ee
    }
  } = r, te = useEffectEvent(() => {
    var ye;
    return (ye = K.current.floatingContext) == null ? void 0 : ye.nodeId;
  }), re = useEffectEvent(W), ae = typeof l == "number" && l < 0, ie = isTypeableCombobox(J) && ae, ce = supportsInert(), he = ce ? o : !0, oe = !he || ce && X, le = useLatestRef$1(s), pe = useLatestRef$1(l), de = useLatestRef$1(x), se = useFloatingTree(), ue = usePortalContext(), fe = React.useRef(null), ge = React.useRef(null), ne = React.useRef(!1), ve = React.useRef(!1), me = React.useRef(-1), xe = React.useRef(-1), Ee = ue != null, Se = getFloatingFocusElement(ee), _e = useEffectEvent(function(ye) {
    return ye === void 0 && (ye = Se), ye ? tabbable(ye, getTabbableOptions()) : [];
  }), Ce = useEffectEvent((ye) => {
    const Me = _e(ye);
    return le.current.map((be) => J && be === "reference" ? J : Se && be === "floating" ? Se : Me).filter(Boolean).flat();
  });
  React.useEffect(() => {
    if (a || !Z) return;
    function ye(be) {
      if (be.key === "Tab") {
        contains$1(Se, activeElement(getDocument$1(Se))) && _e().length === 0 && !ie && stopEvent(be);
        const De = Ce(), Fe = getTarget$1(be);
        le.current[0] === "reference" && Fe === J && (stopEvent(be), be.shiftKey ? enqueueFocus(De[De.length - 1]) : enqueueFocus(De[1])), le.current[1] === "floating" && Fe === Se && be.shiftKey && (stopEvent(be), enqueueFocus(De[0]));
      }
    }
    const Me = getDocument$1(Se);
    return Me.addEventListener("keydown", ye), () => {
      Me.removeEventListener("keydown", ye);
    };
  }, [a, J, Se, Z, le, ie, _e, Ce]), React.useEffect(() => {
    if (a || !ee) return;
    function ye(Me) {
      const be = getTarget$1(Me), Fe = _e().indexOf(be);
      Fe !== -1 && (me.current = Fe);
    }
    return ee.addEventListener("focusin", ye), () => {
      ee.removeEventListener("focusin", ye);
    };
  }, [a, ee, _e]), React.useEffect(() => {
    if (a || !$) return;
    function ye() {
      ve.current = !0, setTimeout(() => {
        ve.current = !1;
      });
    }
    function Me(Fe) {
      const Le = Fe.relatedTarget, Ne = Fe.currentTarget, Ie = getTarget$1(Fe);
      queueMicrotask(() => {
        const je = te(), Ze = !(contains$1(J, Le) || contains$1(ee, Le) || contains$1(Le, ee) || contains$1(ue == null ? void 0 : ue.portalNode, Le) || Le != null && Le.hasAttribute(createAttribute("focus-guard")) || se && (getNodeChildren$1(se.nodesRef.current, je).find(($e) => {
          var We, Be;
          return contains$1((We = $e.context) == null ? void 0 : We.elements.floating, Le) || contains$1((Be = $e.context) == null ? void 0 : Be.elements.domReference, Le);
        }) || getNodeAncestors(se.nodesRef.current, je).find(($e) => {
          var We, Be, Ue;
          return [(We = $e.context) == null ? void 0 : We.elements.floating, getFloatingFocusElement((Be = $e.context) == null ? void 0 : Be.elements.floating)].includes(Le) || ((Ue = $e.context) == null ? void 0 : Ue.elements.domReference) === Le;
        })));
        if (Ne === J && Se && handleTabIndex(Se, le), j && Ne !== J && !(Ie != null && Ie.isConnected) && activeElement(getDocument$1(Se)) === getDocument$1(Se).body) {
          isHTMLElement(Se) && Se.focus();
          const $e = me.current, We = _e(), Be = We[$e] || We[We.length - 1] || Se;
          isHTMLElement(Be) && Be.focus();
        }
        if (K.current.insideReactTree) {
          K.current.insideReactTree = !1;
          return;
        }
        (ie || !Z) && Le && Ze && !ve.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
        Le !== getPreviouslyFocusedElement() && (ne.current = !0, U(!1, Fe, "focus-out"));
      });
    }
    const be = !!(!se && ue);
    function De() {
      clearTimeoutIfSet(xe), K.current.insideReactTree = !0, xe.current = window.setTimeout(() => {
        K.current.insideReactTree = !1;
      });
    }
    if (ee && isHTMLElement(J))
      return J.addEventListener("focusout", Me), J.addEventListener("pointerdown", ye), ee.addEventListener("focusout", Me), be && ee.addEventListener("focusout", De, !0), () => {
        J.removeEventListener("focusout", Me), J.removeEventListener("pointerdown", ye), ee.removeEventListener("focusout", Me), be && ee.removeEventListener("focusout", De, !0);
      };
  }, [a, J, ee, Se, Z, se, ue, U, $, j, _e, ie, te, le, K]);
  const Te = React.useRef(null), we = React.useRef(null), Re = useLiteMergeRefs([Te, ue == null ? void 0 : ue.beforeInsideRef]), Ae = useLiteMergeRefs([we, ue == null ? void 0 : ue.afterInsideRef]);
  React.useEffect(() => {
    var ye, Me;
    if (a || !ee) return;
    const be = Array.from((ue == null || (ye = ue.portalNode) == null ? void 0 : ye.querySelectorAll("[" + createAttribute("portal") + "]")) || []), Fe = (Me = (se ? getNodeAncestors(se.nodesRef.current, te()) : []).find((Ie) => {
      var je;
      return isTypeableCombobox(((je = Ie.context) == null ? void 0 : je.elements.domReference) || null);
    })) == null || (Me = Me.context) == null ? void 0 : Me.elements.domReference, Le = [ee, Fe, ...be, ...re(), fe.current, ge.current, Te.current, we.current, ue == null ? void 0 : ue.beforeOutsideRef.current, ue == null ? void 0 : ue.afterOutsideRef.current, le.current.includes("reference") || ie ? J : null].filter((Ie) => Ie != null), Ne = Z || ie ? markOthers(Le, !oe, oe) : markOthers(Le);
    return () => {
      Ne();
    };
  }, [a, J, ee, Z, le, ue, ie, he, oe, se, te, re]), index$1(() => {
    if (a || !isHTMLElement(Se)) return;
    const ye = getDocument$1(Se), Me = activeElement(ye);
    queueMicrotask(() => {
      const be = Ce(Se), De = pe.current, Fe = (typeof De == "number" ? be[De] : De.current) || Se, Le = contains$1(Se, Me);
      !ae && !Le && Y && enqueueFocus(Fe, {
        preventScroll: Fe === Se
      });
    });
  }, [a, Y, Se, ae, Ce, pe]), index$1(() => {
    if (a || !Se) return;
    const ye = getDocument$1(Se), Me = activeElement(ye);
    addPreviouslyFocusedElement(Me);
    function be(Le) {
      let {
        reason: Ne,
        event: Ie,
        nested: je
      } = Le;
      if (["hover", "safe-polygon"].includes(Ne) && Ie.type === "mouseleave" && (ne.current = !0), Ne === "outside-press")
        if (je)
          ne.current = !1;
        else if (isVirtualClick(Ie) || isVirtualPointerEvent(Ie))
          ne.current = !1;
        else {
          let Ze = !1;
          document.createElement("div").focus({
            get preventScroll() {
              return Ze = !0, !1;
            }
          }), Ze ? ne.current = !1 : ne.current = !0;
        }
    }
    G.on("openchange", be);
    const De = ye.createElement("span");
    De.setAttribute("tabindex", "-1"), De.setAttribute("aria-hidden", "true"), Object.assign(De.style, HIDDEN_STYLES), Ee && J && J.insertAdjacentElement("afterend", De);
    function Fe() {
      if (typeof de.current == "boolean") {
        const Le = J || getPreviouslyFocusedElement();
        return Le && Le.isConnected ? Le : De;
      }
      return de.current.current || De;
    }
    return () => {
      G.off("openchange", be);
      const Le = activeElement(ye), Ne = contains$1(ee, Le) || se && getNodeChildren$1(se.nodesRef.current, te(), !1).some((je) => {
        var Ze;
        return contains$1((Ze = je.context) == null ? void 0 : Ze.elements.floating, Le);
      }), Ie = Fe();
      queueMicrotask(() => {
        const je = getFirstTabbableElement(Ie);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        de.current && !ne.current && isHTMLElement(je) && // If the focus moved somewhere else after mount, avoid returning focus
        // since it likely entered a different element which should be
        // respected: https://github.com/floating-ui/floating-ui/issues/2607
        (!(je !== Le && Le !== ye.body) || Ne) && je.focus({
          preventScroll: !0
        }), De.remove();
      });
    };
  }, [a, ee, Se, de, K, G, se, Ee, J, te]), React.useEffect(() => (queueMicrotask(() => {
    ne.current = !1;
  }), () => {
    queueMicrotask(clearDisconnectedPreviouslyFocusedElements);
  }), [a]), index$1(() => {
    if (!a && ue)
      return ue.setFocusManagerState({
        modal: Z,
        closeOnFocusOut: $,
        open: Y,
        onOpenChange: U,
        domReference: J
      }), () => {
        ue.setFocusManagerState(null);
      };
  }, [a, ue, Z, Y, U, $, J]), index$1(() => {
    a || Se && handleTabIndex(Se, le);
  }, [a, Se, le]);
  function Pe(ye) {
    return a || !V || !Z ? null : /* @__PURE__ */ jsx(VisuallyHiddenDismiss, {
      ref: ye === "start" ? fe : ge,
      onClick: (Me) => U(!1, Me.nativeEvent),
      children: typeof V == "string" ? V : "Dismiss"
    });
  }
  const ke = !a && he && (Z ? !ie : !0) && (Ee || Z);
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [ke && /* @__PURE__ */ jsx(FocusGuard, {
      "data-type": "inside",
      ref: Re,
      onFocus: (ye) => {
        if (Z) {
          const be = Ce();
          enqueueFocus(s[0] === "reference" ? be[0] : be[be.length - 1]);
        } else if (ue != null && ue.preserveTabOrder && ue.portalNode)
          if (ne.current = !1, isOutsideEvent(ye, ue.portalNode)) {
            const be = getNextTabbable(J);
            be == null || be.focus();
          } else {
            var Me;
            (Me = ue.beforeOutsideRef.current) == null || Me.focus();
          }
      }
    }), !ie && Pe("start"), n, Pe("end"), ke && /* @__PURE__ */ jsx(FocusGuard, {
      "data-type": "inside",
      ref: Ae,
      onFocus: (ye) => {
        if (Z)
          enqueueFocus(Ce()[0]);
        else if (ue != null && ue.preserveTabOrder && ue.portalNode)
          if ($ && (ne.current = !0), isOutsideEvent(ye, ue.portalNode)) {
            const be = getPreviousTabbable(J);
            be == null || be.focus();
          } else {
            var Me;
            (Me = ue.afterOutsideRef.current) == null || Me.focus();
          }
      }
    })]
  });
}
function isButtonTarget(t) {
  return isHTMLElement(t.target) && t.target.tagName === "BUTTON";
}
function isAnchorTarget(t) {
  return isHTMLElement(t.target) && t.target.tagName === "A";
}
function isSpaceIgnored(t) {
  return isTypeableElement(t);
}
function useClick(t, r) {
  r === void 0 && (r = {});
  const {
    open: n,
    onOpenChange: a,
    dataRef: s,
    elements: {
      domReference: o
    }
  } = t, {
    enabled: l = !0,
    event: x = "click",
    toggle: j = !0,
    ignoreMouse: Z = !1,
    keyboardHandlers: V = !0,
    stickIfOpen: $ = !0
  } = r, X = React.useRef(), W = React.useRef(!1), Y = React.useMemo(() => ({
    onPointerDown(U) {
      X.current = U.pointerType;
    },
    onMouseDown(U) {
      const G = X.current;
      U.button === 0 && x !== "click" && (isMouseLikePointerType(G, !0) && Z || (n && j && (!(s.current.openEvent && $) || s.current.openEvent.type === "mousedown") ? a(!1, U.nativeEvent, "click") : (U.preventDefault(), a(!0, U.nativeEvent, "click"))));
    },
    onClick(U) {
      const G = X.current;
      if (x === "mousedown" && X.current) {
        X.current = void 0;
        return;
      }
      isMouseLikePointerType(G, !0) && Z || (n && j && (!(s.current.openEvent && $) || s.current.openEvent.type === "click") ? a(!1, U.nativeEvent, "click") : a(!0, U.nativeEvent, "click"));
    },
    onKeyDown(U) {
      X.current = void 0, !(U.defaultPrevented || !V || isButtonTarget(U)) && (U.key === " " && !isSpaceIgnored(o) && (U.preventDefault(), W.current = !0), !isAnchorTarget(U) && U.key === "Enter" && a(!(n && j), U.nativeEvent, "click"));
    },
    onKeyUp(U) {
      U.defaultPrevented || !V || isButtonTarget(U) || isSpaceIgnored(o) || U.key === " " && W.current && (W.current = !1, a(!(n && j), U.nativeEvent, "click"));
    }
  }), [s, o, x, Z, V, a, n, $, j]);
  return React.useMemo(() => l ? {
    reference: Y
  } : {}, [l, Y]);
}
const bubbleHandlerKeys = {
  pointerdown: "onPointerDown",
  mousedown: "onMouseDown",
  click: "onClick"
}, captureHandlerKeys = {
  pointerdown: "onPointerDownCapture",
  mousedown: "onMouseDownCapture",
  click: "onClickCapture"
}, normalizeProp = (t) => {
  var r, n;
  return {
    escapeKey: typeof t == "boolean" ? t : (r = t == null ? void 0 : t.escapeKey) != null ? r : !1,
    outsidePress: typeof t == "boolean" ? t : (n = t == null ? void 0 : t.outsidePress) != null ? n : !0
  };
};
function useDismiss(t, r) {
  r === void 0 && (r = {});
  const {
    open: n,
    onOpenChange: a,
    elements: s,
    dataRef: o
  } = t, {
    enabled: l = !0,
    escapeKey: x = !0,
    outsidePress: j = !0,
    outsidePressEvent: Z = "pointerdown",
    referencePress: V = !1,
    referencePressEvent: $ = "pointerdown",
    ancestorScroll: X = !1,
    bubbles: W,
    capture: Y
  } = r, U = useFloatingTree(), G = useEffectEvent(typeof j == "function" ? j : () => !1), K = typeof j == "function" ? G : j, J = React.useRef(!1), {
    escapeKey: ee,
    outsidePress: te
  } = normalizeProp(W), {
    escapeKey: re,
    outsidePress: ae
  } = normalizeProp(Y), ie = React.useRef(!1), ce = useEffectEvent((se) => {
    var ue;
    if (!n || !l || !x || se.key !== "Escape" || ie.current)
      return;
    const fe = (ue = o.current.floatingContext) == null ? void 0 : ue.nodeId, ge = U ? getNodeChildren$1(U.nodesRef.current, fe) : [];
    if (!ee && (se.stopPropagation(), ge.length > 0)) {
      let ne = !0;
      if (ge.forEach((ve) => {
        var me;
        if ((me = ve.context) != null && me.open && !ve.context.dataRef.current.__escapeKeyBubbles) {
          ne = !1;
          return;
        }
      }), !ne)
        return;
    }
    a(!1, isReactEvent(se) ? se.nativeEvent : se, "escape-key");
  }), he = useEffectEvent((se) => {
    var ue;
    const fe = () => {
      var ge;
      ce(se), (ge = getTarget$1(se)) == null || ge.removeEventListener("keydown", fe);
    };
    (ue = getTarget$1(se)) == null || ue.addEventListener("keydown", fe);
  }), oe = useEffectEvent((se) => {
    var ue;
    const fe = o.current.insideReactTree;
    o.current.insideReactTree = !1;
    const ge = J.current;
    if (J.current = !1, Z === "click" && ge || fe || typeof K == "function" && !K(se))
      return;
    const ne = getTarget$1(se), ve = "[" + createAttribute("inert") + "]", me = getDocument$1(s.floating).querySelectorAll(ve);
    let xe = isElement(ne) ? ne : null;
    for (; xe && !isLastTraversableNode(xe); ) {
      const Ce = getParentNode(xe);
      if (isLastTraversableNode(Ce) || !isElement(Ce))
        break;
      xe = Ce;
    }
    if (me.length && isElement(ne) && !isRootElement(ne) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
    !contains$1(ne, s.floating) && // If the target root element contains none of the markers, then the
    // element was injected after the floating element rendered.
    Array.from(me).every((Ce) => !contains$1(xe, Ce)))
      return;
    if (isHTMLElement(ne) && de) {
      const Ce = isLastTraversableNode(ne), Te = getComputedStyle$1(ne), we = /auto|scroll/, Re = Ce || we.test(Te.overflowX), Ae = Ce || we.test(Te.overflowY), Pe = Re && ne.clientWidth > 0 && ne.scrollWidth > ne.clientWidth, ke = Ae && ne.clientHeight > 0 && ne.scrollHeight > ne.clientHeight, ye = Te.direction === "rtl", Me = ke && (ye ? se.offsetX <= ne.offsetWidth - ne.clientWidth : se.offsetX > ne.clientWidth), be = Pe && se.offsetY > ne.clientHeight;
      if (Me || be)
        return;
    }
    const Ee = (ue = o.current.floatingContext) == null ? void 0 : ue.nodeId, Se = U && getNodeChildren$1(U.nodesRef.current, Ee).some((Ce) => {
      var Te;
      return isEventTargetWithin(se, (Te = Ce.context) == null ? void 0 : Te.elements.floating);
    });
    if (isEventTargetWithin(se, s.floating) || isEventTargetWithin(se, s.domReference) || Se)
      return;
    const _e = U ? getNodeChildren$1(U.nodesRef.current, Ee) : [];
    if (_e.length > 0) {
      let Ce = !0;
      if (_e.forEach((Te) => {
        var we;
        if ((we = Te.context) != null && we.open && !Te.context.dataRef.current.__outsidePressBubbles) {
          Ce = !1;
          return;
        }
      }), !Ce)
        return;
    }
    a(!1, se, "outside-press");
  }), le = useEffectEvent((se) => {
    var ue;
    const fe = () => {
      var ge;
      oe(se), (ge = getTarget$1(se)) == null || ge.removeEventListener(Z, fe);
    };
    (ue = getTarget$1(se)) == null || ue.addEventListener(Z, fe);
  });
  React.useEffect(() => {
    if (!n || !l)
      return;
    o.current.__escapeKeyBubbles = ee, o.current.__outsidePressBubbles = te;
    let se = -1;
    function ue(me) {
      a(!1, me, "ancestor-scroll");
    }
    function fe() {
      window.clearTimeout(se), ie.current = !0;
    }
    function ge() {
      se = window.setTimeout(
        () => {
          ie.current = !1;
        },
        // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
        // Only apply to WebKit for the test to remain 0ms.
        isWebKit() ? 5 : 0
      );
    }
    const ne = getDocument$1(s.floating);
    x && (ne.addEventListener("keydown", re ? he : ce, re), ne.addEventListener("compositionstart", fe), ne.addEventListener("compositionend", ge)), K && ne.addEventListener(Z, ae ? le : oe, ae);
    let ve = [];
    return X && (isElement(s.domReference) && (ve = getOverflowAncestors(s.domReference)), isElement(s.floating) && (ve = ve.concat(getOverflowAncestors(s.floating))), !isElement(s.reference) && s.reference && s.reference.contextElement && (ve = ve.concat(getOverflowAncestors(s.reference.contextElement)))), ve = ve.filter((me) => {
      var xe;
      return me !== ((xe = ne.defaultView) == null ? void 0 : xe.visualViewport);
    }), ve.forEach((me) => {
      me.addEventListener("scroll", ue, {
        passive: !0
      });
    }), () => {
      x && (ne.removeEventListener("keydown", re ? he : ce, re), ne.removeEventListener("compositionstart", fe), ne.removeEventListener("compositionend", ge)), K && ne.removeEventListener(Z, ae ? le : oe, ae), ve.forEach((me) => {
        me.removeEventListener("scroll", ue);
      }), window.clearTimeout(se);
    };
  }, [o, s, x, K, Z, n, a, X, l, ee, te, ce, re, he, oe, ae, le]), React.useEffect(() => {
    o.current.insideReactTree = !1;
  }, [o, K, Z]);
  const pe = React.useMemo(() => ({
    onKeyDown: ce,
    ...V && {
      [bubbleHandlerKeys[$]]: (se) => {
        a(!1, se.nativeEvent, "reference-press");
      },
      ...$ !== "click" && {
        onClick(se) {
          a(!1, se.nativeEvent, "reference-press");
        }
      }
    }
  }), [ce, a, V, $]), de = React.useMemo(() => ({
    onKeyDown: ce,
    onMouseDown() {
      J.current = !0;
    },
    onMouseUp() {
      J.current = !0;
    },
    [captureHandlerKeys[Z]]: () => {
      o.current.insideReactTree = !0;
    }
  }), [ce, Z, o]);
  return React.useMemo(() => l ? {
    reference: pe,
    floating: de
  } : {}, [l, pe, de]);
}
function useFloatingRootContext(t) {
  const {
    open: r = !1,
    onOpenChange: n,
    elements: a
  } = t, s = useId(), o = React.useRef({}), [l] = React.useState(() => createEventEmitter()), x = useFloatingParentNodeId() != null;
  if (process.env.NODE_ENV !== "production") {
    const W = a.reference;
    W && !isElement(W) && error("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
  }
  const [j, Z] = React.useState(a.reference), V = useEffectEvent((W, Y, U) => {
    o.current.openEvent = W ? Y : void 0, l.emit("openchange", {
      open: W,
      event: Y,
      reason: U,
      nested: x
    }), n == null || n(W, Y, U);
  }), $ = React.useMemo(() => ({
    setPositionReference: Z
  }), []), X = React.useMemo(() => ({
    reference: j || a.reference || null,
    floating: a.floating || null,
    domReference: a.reference
  }), [j, a.reference, a.floating]);
  return React.useMemo(() => ({
    dataRef: o,
    open: r,
    onOpenChange: V,
    elements: X,
    events: l,
    floatingId: s,
    refs: $
  }), [r, V, X, l, s, $]);
}
function useFloating(t) {
  t === void 0 && (t = {});
  const {
    nodeId: r
  } = t, n = useFloatingRootContext({
    ...t,
    elements: {
      reference: null,
      floating: null,
      ...t.elements
    }
  }), a = t.rootContext || n, s = a.elements, [o, l] = React.useState(null), [x, j] = React.useState(null), V = (s == null ? void 0 : s.domReference) || o, $ = React.useRef(null), X = useFloatingTree();
  index$1(() => {
    V && ($.current = V);
  }, [V]);
  const W = useFloating$1({
    ...t,
    elements: {
      ...s,
      ...x && {
        reference: x
      }
    }
  }), Y = React.useCallback((ee) => {
    const te = isElement(ee) ? {
      getBoundingClientRect: () => ee.getBoundingClientRect(),
      getClientRects: () => ee.getClientRects(),
      contextElement: ee
    } : ee;
    j(te), W.refs.setReference(te);
  }, [W.refs]), U = React.useCallback((ee) => {
    (isElement(ee) || ee === null) && ($.current = ee, l(ee)), (isElement(W.refs.reference.current) || W.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    ee !== null && !isElement(ee)) && W.refs.setReference(ee);
  }, [W.refs]), G = React.useMemo(() => ({
    ...W.refs,
    setReference: U,
    setPositionReference: Y,
    domReference: $
  }), [W.refs, U, Y]), K = React.useMemo(() => ({
    ...W.elements,
    domReference: V
  }), [W.elements, V]), J = React.useMemo(() => ({
    ...W,
    ...a,
    refs: G,
    elements: K,
    nodeId: r
  }), [W, G, K, r, a]);
  return index$1(() => {
    a.dataRef.current.floatingContext = J;
    const ee = X == null ? void 0 : X.nodesRef.current.find((te) => te.id === r);
    ee && (ee.context = J);
  }), React.useMemo(() => ({
    ...W,
    context: J,
    refs: G,
    elements: K
  }), [W, G, K, J]);
}
function isMacSafari() {
  return isMac() && isSafari();
}
function useFocus(t, r) {
  r === void 0 && (r = {});
  const {
    open: n,
    onOpenChange: a,
    events: s,
    dataRef: o,
    elements: l
  } = t, {
    enabled: x = !0,
    visibleOnly: j = !0
  } = r, Z = React.useRef(!1), V = React.useRef(-1), $ = React.useRef(!0);
  React.useEffect(() => {
    if (!x) return;
    const W = getWindow(l.domReference);
    function Y() {
      !n && isHTMLElement(l.domReference) && l.domReference === activeElement(getDocument$1(l.domReference)) && (Z.current = !0);
    }
    function U() {
      $.current = !0;
    }
    function G() {
      $.current = !1;
    }
    return W.addEventListener("blur", Y), isMacSafari() && (W.addEventListener("keydown", U, !0), W.addEventListener("pointerdown", G, !0)), () => {
      W.removeEventListener("blur", Y), isMacSafari() && (W.removeEventListener("keydown", U, !0), W.removeEventListener("pointerdown", G, !0));
    };
  }, [l.domReference, n, x]), React.useEffect(() => {
    if (!x) return;
    function W(Y) {
      let {
        reason: U
      } = Y;
      (U === "reference-press" || U === "escape-key") && (Z.current = !0);
    }
    return s.on("openchange", W), () => {
      s.off("openchange", W);
    };
  }, [s, x]), React.useEffect(() => () => {
    clearTimeoutIfSet(V);
  }, []);
  const X = React.useMemo(() => ({
    onMouseLeave() {
      Z.current = !1;
    },
    onFocus(W) {
      if (Z.current) return;
      const Y = getTarget$1(W.nativeEvent);
      if (j && isElement(Y)) {
        if (isMacSafari() && !W.relatedTarget) {
          if (!$.current && !isTypeableElement(Y))
            return;
        } else if (!matchesFocusVisible(Y))
          return;
      }
      a(!0, W.nativeEvent, "focus");
    },
    onBlur(W) {
      Z.current = !1;
      const Y = W.relatedTarget, U = W.nativeEvent, G = isElement(Y) && Y.hasAttribute(createAttribute("focus-guard")) && Y.getAttribute("data-type") === "outside";
      V.current = window.setTimeout(() => {
        var K;
        const J = activeElement(l.domReference ? l.domReference.ownerDocument : document);
        !Y && J === l.domReference || contains$1((K = o.current.floatingContext) == null ? void 0 : K.refs.floating.current, J) || contains$1(l.domReference, J) || G || a(!1, U, "focus");
      });
    }
  }), [o, l.domReference, a, j]);
  return React.useMemo(() => x ? {
    reference: X
  } : {}, [x, X]);
}
function mergeProps(t, r, n) {
  const a = /* @__PURE__ */ new Map(), s = n === "item";
  let o = t;
  if (s && t) {
    const {
      [ACTIVE_KEY]: l,
      [SELECTED_KEY]: x,
      ...j
    } = t;
    o = j;
  }
  return {
    ...n === "floating" && {
      tabIndex: -1,
      [FOCUSABLE_ATTRIBUTE]: ""
    },
    ...o,
    ...r.map((l) => {
      const x = l ? l[n] : null;
      return typeof x == "function" ? t ? x(t) : null : x;
    }).concat(t).reduce((l, x) => (x && Object.entries(x).forEach((j) => {
      let [Z, V] = j;
      if (!(s && [ACTIVE_KEY, SELECTED_KEY].includes(Z)))
        if (Z.indexOf("on") === 0) {
          if (a.has(Z) || a.set(Z, []), typeof V == "function") {
            var $;
            ($ = a.get(Z)) == null || $.push(V), l[Z] = function() {
              for (var X, W = arguments.length, Y = new Array(W), U = 0; U < W; U++)
                Y[U] = arguments[U];
              return (X = a.get(Z)) == null ? void 0 : X.map((G) => G(...Y)).find((G) => G !== void 0);
            };
          }
        } else
          l[Z] = V;
    }), l), {})
  };
}
function useInteractions(t) {
  t === void 0 && (t = []);
  const r = t.map((x) => x == null ? void 0 : x.reference), n = t.map((x) => x == null ? void 0 : x.floating), a = t.map((x) => x == null ? void 0 : x.item), s = React.useCallback(
    (x) => mergeProps(x, t, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    r
  ), o = React.useCallback(
    (x) => mergeProps(x, t, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    n
  ), l = React.useCallback(
    (x) => mergeProps(x, t, "item"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    a
  );
  return React.useMemo(() => ({
    getReferenceProps: s,
    getFloatingProps: o,
    getItemProps: l
  }), [s, o, l]);
}
const componentRoleToAriaRoleMap = /* @__PURE__ */ new Map([["select", "listbox"], ["combobox", "listbox"], ["label", !1]]);
function useRole(t, r) {
  var n, a;
  r === void 0 && (r = {});
  const {
    open: s,
    elements: o,
    floatingId: l
  } = t, {
    enabled: x = !0,
    role: j = "dialog"
  } = r, Z = useId(), V = ((n = o.domReference) == null ? void 0 : n.id) || Z, $ = React.useMemo(() => {
    var J;
    return ((J = getFloatingFocusElement(o.floating)) == null ? void 0 : J.id) || l;
  }, [o.floating, l]), X = (a = componentRoleToAriaRoleMap.get(j)) != null ? a : j, Y = useFloatingParentNodeId() != null, U = React.useMemo(() => X === "tooltip" || j === "label" ? {
    ["aria-" + (j === "label" ? "labelledby" : "describedby")]: s ? $ : void 0
  } : {
    "aria-expanded": s ? "true" : "false",
    "aria-haspopup": X === "alertdialog" ? "dialog" : X,
    "aria-controls": s ? $ : void 0,
    ...X === "listbox" && {
      role: "combobox"
    },
    ...X === "menu" && {
      id: V
    },
    ...X === "menu" && Y && {
      role: "menuitem"
    },
    ...j === "select" && {
      "aria-autocomplete": "none"
    },
    ...j === "combobox" && {
      "aria-autocomplete": "list"
    }
  }, [X, $, Y, s, V, j]), G = React.useMemo(() => {
    const J = {
      id: $,
      ...X && {
        role: X
      }
    };
    return X === "tooltip" || j === "label" ? J : {
      ...J,
      ...X === "menu" && {
        "aria-labelledby": V
      }
    };
  }, [X, $, V, j]), K = React.useCallback((J) => {
    let {
      active: ee,
      selected: te
    } = J;
    const re = {
      role: "option",
      ...ee && {
        id: $ + "-fui-option"
      }
    };
    switch (j) {
      case "select":
      case "combobox":
        return {
          ...re,
          "aria-selected": te
        };
    }
    return {};
  }, [$, j]);
  return React.useMemo(() => x ? {
    reference: U,
    floating: G,
    item: K
  } : {}, [x, U, G, K]);
}
const camelCaseToKebabCase = (t) => t.replace(/[A-Z]+(?![a-z])|[A-Z]/g, (r, n) => (n ? "-" : "") + r.toLowerCase());
function execWithArgsOrReturn(t, r) {
  return typeof t == "function" ? t(r) : t;
}
function useDelayUnmount(t, r) {
  const [n, a] = React.useState(t);
  return t && !n && a(!0), React.useEffect(() => {
    if (!t && n) {
      const s = setTimeout(() => a(!1), r);
      return () => clearTimeout(s);
    }
  }, [t, n, r]), n;
}
function useTransitionStatus(t, r) {
  r === void 0 && (r = {});
  const {
    open: n,
    elements: {
      floating: a
    }
  } = t, {
    duration: s = 250
  } = r, l = (typeof s == "number" ? s : s.close) || 0, [x, j] = React.useState("unmounted"), Z = useDelayUnmount(n, l);
  return !Z && x === "close" && j("unmounted"), index$1(() => {
    if (a) {
      if (n) {
        j("initial");
        const V = requestAnimationFrame(() => {
          ReactDOM.flushSync(() => {
            j("open");
          });
        });
        return () => {
          cancelAnimationFrame(V);
        };
      }
      j("close");
    }
  }, [n, a]), {
    isMounted: Z,
    status: x
  };
}
function useTransitionStyles(t, r) {
  r === void 0 && (r = {});
  const {
    initial: n = {
      opacity: 0
    },
    open: a,
    close: s,
    common: o,
    duration: l = 250
  } = r, x = t.placement, j = x.split("-")[0], Z = React.useMemo(() => ({
    side: j,
    placement: x
  }), [j, x]), V = typeof l == "number", $ = (V ? l : l.open) || 0, X = (V ? l : l.close) || 0, [W, Y] = React.useState(() => ({
    ...execWithArgsOrReturn(o, Z),
    ...execWithArgsOrReturn(n, Z)
  })), {
    isMounted: U,
    status: G
  } = useTransitionStatus(t, {
    duration: l
  }), K = useLatestRef$1(n), J = useLatestRef$1(a), ee = useLatestRef$1(s), te = useLatestRef$1(o);
  return index$1(() => {
    const re = execWithArgsOrReturn(K.current, Z), ae = execWithArgsOrReturn(ee.current, Z), ie = execWithArgsOrReturn(te.current, Z), ce = execWithArgsOrReturn(J.current, Z) || Object.keys(re).reduce((he, oe) => (he[oe] = "", he), {});
    if (G === "initial" && Y((he) => ({
      transitionProperty: he.transitionProperty,
      ...ie,
      ...re
    })), G === "open" && Y({
      transitionProperty: Object.keys(ce).map(camelCaseToKebabCase).join(","),
      transitionDuration: $ + "ms",
      ...ie,
      ...ce
    }), G === "close") {
      const he = ae || re;
      Y({
        transitionProperty: Object.keys(he).map(camelCaseToKebabCase).join(","),
        transitionDuration: X + "ms",
        ...ie,
        ...he
      });
    }
  }, [X, ee, K, J, te, $, G, Z]), {
    isMounted: U,
    styles: W
  };
}
function getNodeChildren(t, r, n) {
  return n === void 0 && (n = !0), t.filter((s) => {
    var o;
    return s.parentId === r && (!n || ((o = s.context) == null ? void 0 : o.open));
  }).flatMap((s) => [s, ...getNodeChildren(t, s.id, n)]);
}
function isPointInPolygon(t, r) {
  const [n, a] = t;
  let s = !1;
  const o = r.length;
  for (let l = 0, x = o - 1; l < o; x = l++) {
    const [j, Z] = r[l] || [0, 0], [V, $] = r[x] || [0, 0];
    Z >= a != $ >= a && n <= (V - j) * (a - Z) / ($ - Z) + j && (s = !s);
  }
  return s;
}
function isInside(t, r) {
  return t[0] >= r.x && t[0] <= r.x + r.width && t[1] >= r.y && t[1] <= r.y + r.height;
}
function safePolygon(t) {
  t === void 0 && (t = {});
  const {
    buffer: r = 0.5,
    blockPointerEvents: n = !1,
    requireIntent: a = !0
  } = t, s = {
    current: -1
  };
  let o = !1, l = null, x = null, j = typeof performance != "undefined" ? performance.now() : 0;
  function Z($, X) {
    const W = performance.now(), Y = W - j;
    if (l === null || x === null || Y === 0)
      return l = $, x = X, j = W, null;
    const U = $ - l, G = X - x, J = Math.sqrt(U * U + G * G) / Y;
    return l = $, x = X, j = W, J;
  }
  const V = ($) => {
    let {
      x: X,
      y: W,
      placement: Y,
      elements: U,
      onClose: G,
      nodeId: K,
      tree: J
    } = $;
    return function(te) {
      function re() {
        clearTimeoutIfSet(s), G();
      }
      if (clearTimeoutIfSet(s), !U.domReference || !U.floating || Y == null || X == null || W == null)
        return;
      const {
        clientX: ae,
        clientY: ie
      } = te, ce = [ae, ie], he = getTarget(te), oe = te.type === "mouseleave", le = contains(U.floating, he), pe = contains(U.domReference, he), de = U.domReference.getBoundingClientRect(), se = U.floating.getBoundingClientRect(), ue = Y.split("-")[0], fe = X > se.right - se.width / 2, ge = W > se.bottom - se.height / 2, ne = isInside(ce, de), ve = se.width > de.width, me = se.height > de.height, xe = (ve ? de : se).left, Ee = (ve ? de : se).right, Se = (me ? de : se).top, _e = (me ? de : se).bottom;
      if (le && (o = !0, !oe))
        return;
      if (pe && (o = !1), pe && !oe) {
        o = !0;
        return;
      }
      if (oe && isElement(te.relatedTarget) && contains(U.floating, te.relatedTarget) || J && getNodeChildren(J.nodesRef.current, K).length)
        return;
      if (ue === "top" && W >= de.bottom - 1 || ue === "bottom" && W <= de.top + 1 || ue === "left" && X >= de.right - 1 || ue === "right" && X <= de.left + 1)
        return re();
      let Ce = [];
      switch (ue) {
        case "top":
          Ce = [[xe, de.top + 1], [xe, se.bottom - 1], [Ee, se.bottom - 1], [Ee, de.top + 1]];
          break;
        case "bottom":
          Ce = [[xe, se.top + 1], [xe, de.bottom - 1], [Ee, de.bottom - 1], [Ee, se.top + 1]];
          break;
        case "left":
          Ce = [[se.right - 1, _e], [se.right - 1, Se], [de.left + 1, Se], [de.left + 1, _e]];
          break;
        case "right":
          Ce = [[de.right - 1, _e], [de.right - 1, Se], [se.left + 1, Se], [se.left + 1, _e]];
          break;
      }
      function Te(we) {
        let [Re, Ae] = we;
        switch (ue) {
          case "top": {
            const Pe = [ve ? Re + r / 2 : fe ? Re + r * 4 : Re - r * 4, Ae + r + 1], ke = [ve ? Re - r / 2 : fe ? Re + r * 4 : Re - r * 4, Ae + r + 1], ye = [[se.left, fe || ve ? se.bottom - r : se.top], [se.right, fe ? ve ? se.bottom - r : se.top : se.bottom - r]];
            return [Pe, ke, ...ye];
          }
          case "bottom": {
            const Pe = [ve ? Re + r / 2 : fe ? Re + r * 4 : Re - r * 4, Ae - r], ke = [ve ? Re - r / 2 : fe ? Re + r * 4 : Re - r * 4, Ae - r], ye = [[se.left, fe || ve ? se.top + r : se.bottom], [se.right, fe ? ve ? se.top + r : se.bottom : se.top + r]];
            return [Pe, ke, ...ye];
          }
          case "left": {
            const Pe = [Re + r + 1, me ? Ae + r / 2 : ge ? Ae + r * 4 : Ae - r * 4], ke = [Re + r + 1, me ? Ae - r / 2 : ge ? Ae + r * 4 : Ae - r * 4];
            return [...[[ge || me ? se.right - r : se.left, se.top], [ge ? me ? se.right - r : se.left : se.right - r, se.bottom]], Pe, ke];
          }
          case "right": {
            const Pe = [Re - r, me ? Ae + r / 2 : ge ? Ae + r * 4 : Ae - r * 4], ke = [Re - r, me ? Ae - r / 2 : ge ? Ae + r * 4 : Ae - r * 4], ye = [[ge || me ? se.left + r : se.right, se.top], [ge ? me ? se.left + r : se.right : se.left + r, se.bottom]];
            return [Pe, ke, ...ye];
          }
        }
      }
      if (!isPointInPolygon([ae, ie], Ce)) {
        if (o && !ne)
          return re();
        if (!oe && a) {
          const we = Z(te.clientX, te.clientY);
          if (we !== null && we < 0.1)
            return re();
        }
        isPointInPolygon([ae, ie], Te([X, W])) ? !o && a && (s.current = window.setTimeout(re, 40)) : re();
      }
    };
  };
  return V.__options = {
    blockPointerEvents: n
  }, V;
}
const TooltipContext = createContext(null), DEFAULT_ARROW_OPTIONS = {
  width: 14,
  height: 8,
  strokeWidth: 1,
  d: "m 7.5077259,7.50555 -7.49999991,7.5 H 15.007725 Z",
  padding: 8,
  tipRadius: 0,
  staticOffset: null,
  fill: "black",
  stroke: "none",
  className: null
}, DEFAULT_TOOLTIP_OPTIONS = {
  placement: "bottom",
  gap: 2,
  positioningBy: "trigger"
}, TOOLTIP_TRANSITION_DURATION = 200;
function getMiddlewares(t, r, n, a) {
  return [
    offset(t.height + r.gap),
    flip({
      crossAxis: r.placement.includes("-"),
      fallbackAxisSideDirection: "start",
      padding: 5
    }),
    shift({ padding: 5 }),
    n && arrow({
      element: a,
      padding: t == null ? void 0 : t.padding
    })
  ];
}
function useMergedTooltipOptions(t, r, n) {
  return useMemo$1(
    () => {
      var a, s, o, l, x, j;
      return {
        placement: (s = (a = t == null ? void 0 : t.placement) != null ? a : r == null ? void 0 : r.placement) != null ? s : n.placement,
        gap: (l = (o = t == null ? void 0 : t.gap) != null ? o : r == null ? void 0 : r.gap) != null ? l : n.gap,
        positioningBy: (j = (x = t == null ? void 0 : t.positioningBy) != null ? x : r == null ? void 0 : r.positioningBy) != null ? j : n.positioningBy
      };
    },
    [n, t, r]
  );
}
function useMergedArrowOptions(t, r, n, a) {
  return useMemo$1(
    () => {
      var s, o, l, x;
      return {
        ...a,
        ...n,
        ...r,
        width: t ? (o = (s = r == null ? void 0 : r.width) != null ? s : n == null ? void 0 : n.width) != null ? o : a.width : 0,
        height: t ? (x = (l = r == null ? void 0 : r.height) != null ? l : n == null ? void 0 : n.height) != null ? x : a.height : 0
      };
    },
    [a, r, n, t]
  );
}
function useTooltip({
  triggerSet: t,
  placement: r,
  withArrow: n,
  arrowOptions: a,
  gap: s,
  delay: o,
  open: l,
  triggerRef: x,
  onOpenChange: j,
  positioningBy: Z,
  parentContext: V,
  nodeId: $,
  floatingRef: X,
  useSafePolygon: W = !0
}) {
  var pe;
  const Y = V !== null, U = useMergedTooltipOptions(
    { placement: r, gap: s, positioningBy: Z },
    V == null ? void 0 : V.tooltipOptions,
    DEFAULT_TOOLTIP_OPTIONS
  ), G = (pe = n != null ? n : V == null ? void 0 : V.withArrow) != null ? pe : !0, K = useRef(null), J = useMergedArrowOptions(
    G,
    a,
    V == null ? void 0 : V.arrowOptions,
    DEFAULT_ARROW_OPTIONS
  ), { context: ee, middlewareData: te } = useFloating({
    nodeId: $,
    placement: U.placement,
    open: l,
    onOpenChange: j,
    whileElementsMounted: autoUpdate,
    // eslint-disable-next-line react-hooks/refs
    middleware: getMiddlewares(J, U, G, K)
  });
  useEffect(() => {
    var fe;
    const de = U.positioningBy === "parent-tooltip" && (fe = V == null ? void 0 : V.elements.floating) != null ? fe : ee.elements.reference, se = ee.elements.floating;
    if (!se || !de)
      return;
    const ue = autoUpdate(de, se, () => {
      computePosition(de, se, {
        placement: U.placement,
        middleware: getMiddlewares(J, U, G, K)
      }).then(({ x: ge, y: ne }) => {
        se.style.top = `${ne}px`, se.style.left = `${ge}px`, se.style.transform = "";
      });
    });
    return () => ue();
  }, [
    J,
    ee.elements.floating,
    ee.elements.reference,
    Y,
    $,
    V,
    U,
    G
  ]), useEffect(() => {
    const de = te.arrow, se = K.current, ue = {
      top: "bottom",
      right: "left",
      bottom: "top",
      left: "right"
    }[ee.placement.split("-")[0]];
    se && (ue === "top" || ue === "bottom" || ue === "left" || ue === "right") && (se.style.left = de != null && de.x ? `${de.x}px` : "", se.style.top = de != null && de.y ? `${de.y}px` : "", se.style[ue] = `-${J.width - 1}px`);
  }, [J.width, ee.placement, te.arrow]);
  const re = useInteractions([
    useClick(ee, {
      enabled: t.has("click"),
      event: "click"
    }),
    useHover(ee, {
      move: !1,
      enabled: t.has("hover"),
      delay: o,
      handleClose: W ? safePolygon() : void 0
    }),
    useFocus(ee, {
      enabled: t.has("focus")
    }),
    useDismiss(ee, { bubbles: !0 }),
    useRole(ee, { role: "tooltip" })
  ]), { isMounted: ae, styles: ie } = useTransitionStyles(ee, {
    duration: TOOLTIP_TRANSITION_DURATION
  }), ce = useMergeRefs([ee.refs.setFloating, X]), he = useMergeRefs([ee.refs.setReference, x]), oe = useMemo$1(
    () => (de) => ({
      ...re.getReferenceProps(de),
      ref: he
    }),
    [re, he]
  ), le = useMemo$1(
    () => () => ({
      ...re.getFloatingProps(),
      ref: ce,
      style: { ...ee.floatingStyles, ...ie }
    }),
    [ee.floatingStyles, ce, re, ie]
  );
  return useMemo$1(
    () => ({
      getReferenceProps: oe,
      getFloatingProps: le,
      arrowOptions: G ? { ...J, ref: K } : null,
      context: { ...ee, ...re, tooltipOptions: U, arrowOptions: J, withArrow: G },
      open: ee.open && ae
    }),
    [J, ee, le, oe, re, ae, U, G]
  );
}
const TooltipComponent = forwardRef(function t({
  trigger: r,
  title: n,
  children: a,
  initialOpen: s,
  placement: o,
  withArrow: l,
  arrowOptions: x,
  style: j,
  className: Z,
  containerClassName: V,
  gap: $,
  delay: X,
  open: W,
  triggerRef: Y,
  onOpenChange: U,
  onPointerDown: G,
  positioningBy: K,
  useSafePolygon: J,
  setReferenceProps: ee,
  tooltipWrapperProps: te,
  focusManagerProps: re,
  canTooltipBeFocused: ae = !0,
  rootContainer: ie
}, ce) {
  const he = useContext(ConfigContext), oe = useContext(TooltipContext), le = useFloatingParentNodeId(), pe = useFloatingNodeId(le != null ? le : void 0), de = ie != null ? ie : he.rootElement, se = useMemo$1(
    () => {
      var Se;
      return new Set((Se = r != null ? r : oe == null ? void 0 : oe.trigger) != null ? Se : ["hover", "focus"]);
    },
    [r, oe == null ? void 0 : oe.trigger]
  ), [ue, fe] = useState$1(s), { getReferenceProps: ge, getFloatingProps: ne, arrowOptions: ve, context: me, open: xe } = useTooltip({
    open: W != null ? W : ue,
    onOpenChange: U != null ? U : fe,
    gap: $,
    parentContext: oe,
    delay: X,
    arrowOptions: x,
    withArrow: l,
    nodeId: pe,
    placement: o,
    triggerRef: Y,
    triggerSet: se,
    positioningBy: K,
    floatingRef: ce,
    useSafePolygon: J
  });
  useEffect(() => {
    const Se = ge();
    ee == null || ee((_e) => ({ ..._e, ...Se, ref: mergeRefs(_e == null ? void 0 : _e.ref, Se.ref) }));
  }, [ge, ee]);
  const Ee = /* @__PURE__ */ jsx(
    "div",
    {
      onClick: (Se) => Se.stopPropagation(),
      onPointerDown: (Se) => Se.stopPropagation(),
      onPointerUp: (Se) => Se.stopPropagation(),
      ...te,
      children: /* @__PURE__ */ jsxs("div", { ...ne(), className: clsx("go-tooltip__container", V), children: [
        /* @__PURE__ */ jsx("div", { className: clsx(Z, "go-tooltip"), style: j, onPointerDown: G, children: n }),
        !!ve && /* @__PURE__ */ jsx(
          FloatingArrow,
          {
            ref: ve.ref,
            context: me,
            className: clsx(ve.className, "go-tooltip__arrow"),
            d: ve.d,
            strokeWidth: ve.strokeWidth,
            width: ve.width,
            height: ve.height,
            staticOffset: ve.staticOffset,
            fill: ve.fill,
            stroke: ve.stroke,
            tipRadius: ve.tipRadius
          }
        )
      ] })
    }
  );
  return /* @__PURE__ */ jsxs(FloatingNode, { id: pe, children: [
    isValidElement(a) && cloneElement(a, ge(a.props)),
    /* @__PURE__ */ jsx(TooltipContext.Provider, { value: me, children: xe && /* @__PURE__ */ jsx(FloatingPortal, { root: de, children: /* @__PURE__ */ jsx(ConfigProvider, { config: he, children: ae ? /* @__PURE__ */ jsx(FloatingFocusManager, { initialFocus: -1, ...re, context: me, modal: !1, children: Ee }) : Ee }) }) })
  ] });
}), Tooltip = forwardRef(function t({ children: r, ...n }, a) {
  const s = r ? Children.only(r) : void 0;
  return useFloatingParentNodeId() === null ? /* @__PURE__ */ jsx(FloatingTree, { children: /* @__PURE__ */ jsx(TooltipComponent, { ...n, ref: a, children: s }) }) : /* @__PURE__ */ jsx(TooltipComponent, { ...n, ref: a, children: s });
}), MultiTooltip = ({ children: t, tooltips: r }) => {
  const n = useRef(null), [a, s] = useState$1();
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    isValidElement(t) && cloneElement(t, a),
    r.map(({ key: o, ...l }) => /* @__PURE__ */ jsx(Tooltip, { ...l, triggerRef: n, setReferenceProps: s }, o))
  ] });
}, Tooltip$1 = Object.assign(Tooltip, { Multi: MultiTooltip }), inputSizeClassNames = {
  s: "go-input_size_s",
  m: "go-input_size_m"
}, statusClassNames$2 = {
  error: "go-input_status_error"
}, Input = forwardRef(function t({
  value: r,
  id: n,
  prefix: a,
  suffix: s,
  placeholder: o,
  size: l,
  status: x,
  maxLength: j,
  allowClear: Z = !0,
  disabled: V = !1,
  loading: $ = !1,
  tabIndex: X = 0,
  type: W = "text",
  autoFocus: Y,
  className: U,
  fieldClassName: G,
  inputClassName: K,
  style: J,
  onChange: ee,
  onClear: te,
  onFocus: re,
  onBlur: ae,
  onKeyDown: ie,
  onKeyUp: ce,
  onClick: he,
  onMouseEnter: oe,
  onMouseLeave: le
}, pe) {
  var Me, be;
  const { localization: de } = useContext(ConfigContext), { size: se } = useGlobalComponentConfig({ size: l }), ue = useRef(null), [fe, ge] = useState$1(""), ne = r != null ? r : fe, ve = ee != null ? ee : ((De) => ge(De.currentTarget.value)), [me, xe] = useState$1(!1), [Ee, Se] = useState$1(!1), _e = Z && (!!(ne != null && ne.length) && Ee || me) && !V, Ce = !(ne != null && ne.length && Ee) || me || !Z || V, Te = (De) => {
    ve == null || ve(De);
  }, we = (De) => {
    xe(!0), re == null || re(De), De.currentTarget.setSelectionRange(0, ne.length);
  }, Re = (De) => {
    xe(!1), ae == null || ae(De);
  }, Ae = (De) => {
    if (De.preventDefault(), te == null || te(), !!ve && ue.current) {
      let Fe = De;
      const Le = ue.current.cloneNode(!0);
      Fe = Object.create(De, {
        target: { value: Le },
        currentTarget: { value: Le }
      }), Le.value = "", ve(Fe);
      return;
    }
  }, Pe = (De) => {
    Se(!0), oe == null || oe(De);
  }, ke = (De) => {
    Se(!1), le == null || le(De);
  }, ye = (De) => {
    De.target !== ue.current && De.preventDefault();
  };
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: clsx(
        "go-input",
        inputSizeClassNames[se],
        x && statusClassNames$2[x],
        V && "go-input_disabled",
        me && "go-input_focused",
        $ && "go-input_loading",
        Ee && "go-input_hovered",
        _e && "go-input_has-clear-button",
        U
      ),
      style: J,
      onMouseEnter: Pe,
      onMouseLeave: ke,
      children: /* @__PURE__ */ jsxs("label", { className: clsx("go-input__container", G), onPointerDown: ye, children: [
        !!a && /* @__PURE__ */ jsx("div", { className: "go-input__prefix", children: renderNode(a, "p") }),
        /* @__PURE__ */ jsx(
          "input",
          {
            ref: mergeRefs(ue, pe),
            id: n,
            value: ne != null ? ne : "",
            placeholder: o,
            className: clsx("go-input__field", K),
            disabled: V,
            maxLength: j,
            tabIndex: X,
            type: W,
            onChange: Te,
            onFocus: we,
            onBlur: Re,
            onKeyDown: ie,
            onKeyUp: ce,
            onClick: he,
            autoFocus: Y
          }
        ),
        !!s && Ce && /* @__PURE__ */ jsx("div", { className: "go-input__suffix", children: renderNode(s, "p") }),
        $ ? /* @__PURE__ */ jsx(LoaderIcon, { className: "go-input__loader" }) : /* @__PURE__ */ jsx(Fragment, { children: _e && /* @__PURE__ */ jsx(Tooltip$1, { title: (be = (Me = de == null ? void 0 : de.input) == null ? void 0 : Me.values) == null ? void 0 : be.clear, trigger: ["focus"], children: /* @__PURE__ */ jsx(
          "button",
          {
            className: "go-input__clear-button",
            disabled: me && !ne.length,
            onClick: Ae,
            onPointerDown: ye,
            children: typeof Z == "object" && Z.icon ? Z.icon : /* @__PURE__ */ jsx(CloseMiniLine, {})
          }
        ) }) })
      ] })
    }
  );
}), DatePickerPopover = ({
  value: t,
  defaultValue: r,
  showTime: n,
  size: a,
  renderPopover: s,
  onCancel: o,
  onApply: l,
  onClear: x,
  isDateDisabled: j,
  isHourDisabled: Z,
  isMinuteDisabled: V
}) => {
  var G, K, J, ee;
  const { localization: $ } = useContext(ConfigContext), [X, W] = useState$1(t), Y = /* @__PURE__ */ jsx(
    Calendar$1,
    {
      value: X,
      onChange: W,
      defaultValue: r,
      showTime: n,
      isDateDisabled: j,
      isHourDisabled: Z,
      isMinuteDisabled: V
    }
  ), U = () => l(X);
  return s ? /* @__PURE__ */ jsx(Fragment, { children: s({ calendar: Y, currentDate: X, onCancel: o, onApply: U, onClear: x }) }) : /* @__PURE__ */ jsxs(Fragment, { children: [
    Y,
    /* @__PURE__ */ jsxs("div", { className: "go-date-picker__popover-footer", children: [
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "danger",
          size: a,
          className: "go-date-picker__popover-footer-button",
          icon: /* @__PURE__ */ jsx(CloseRoundLight, {}),
          onClick: x,
          children: (K = (G = $ == null ? void 0 : $.datePicker) == null ? void 0 : G.values) == null ? void 0 : K.cancel
        }
      ),
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "success",
          size: a,
          className: "go-date-picker__popover-footer-button",
          icon: /* @__PURE__ */ jsx(DoneLight, {}),
          onClick: U,
          children: (ee = (J = $ == null ? void 0 : $.datePicker) == null ? void 0 : J.values) == null ? void 0 : ee.apply
        }
      )
    ] })
  ] });
};
class DateValidator {
  constructor(r) {
    Mr(this, "value");
    this.value = r;
  }
  checkFormat(r, n) {
    if (this.value) {
      const s = parse(this.value.toString(), r, /* @__PURE__ */ new Date(), { locale: n }).getTime();
      if (!isNaN(s))
        return this.value = s, this;
    }
    return this.value = null, this;
  }
  validate() {
    return this.value && new Date(this.value).getTime() || null;
  }
}
function validate(t, r, n) {
  return t == null ? null : t instanceof Date ? t.getTime() : typeof t == "number" ? t : new DateValidator(t).checkFormat(r, n).validate();
}
function validateYear(t) {
  if (t == null || t === "")
    return null;
  if (typeof t == "number")
    return t;
  const r = Number(t);
  return Number.isNaN(r) ? null : r;
}
const DEFAULT_DATE_FORMAT$1 = "dd.MM.yyyy", DEFAULT_DATE_TIME_FORMAT$1 = "dd.MM.yyyy HH:mm", DatePicker = forwardRef(function t({
  value: r = null,
  onChange: n,
  allowClear: a,
  className: s,
  disabled: o,
  autoFocus: l,
  defaultOpen: x = !1,
  open: j,
  fieldClassName: Z,
  id: V,
  inputClassName: $,
  popoverClassName: X,
  loading: W,
  onBlur: Y,
  onFocus: U,
  placeholder: G,
  size: K,
  status: J,
  style: ee,
  tabIndex: te,
  showTime: re,
  isDateDisabled: ae,
  isHourDisabled: ie,
  isMinuteDisabled: ce,
  defaultValue: he = null,
  dateFormat: oe,
  renderPopover: le,
  tooltipProps: pe,
  onOpenChange: de
}, se) {
  var ye, Me, be, De, Fe, Le;
  const { localization: ue } = useContext(ConfigContext), fe = oe != null ? oe : re ? DEFAULT_DATE_TIME_FORMAT$1 : DEFAULT_DATE_FORMAT$1, ge = useMemo$1(() => format(/* @__PURE__ */ new Date(), fe), [fe]), ne = useRef(null), [ve, me] = useState$1((ye = x || j) != null ? ye : x), [xe, Ee] = useState$1(!1), [Se, _e] = useState$1(
    () => {
      var Ne, Ie;
      return (Ie = validate(r, fe, (Ne = ue == null ? void 0 : ue.calendar) == null ? void 0 : Ne.locale)) != null ? Ie : null;
    }
  );
  useEffect(() => {
    var Ne;
    j !== void 0 && (me(j), Ee(!0), (Ne = ne.current) == null || Ne.focus());
  }, [j]), useEffect(() => {
    var Ie, je, Ze;
    const Ne = (Ze = validate(r, fe, (Ie = ue == null ? void 0 : ue.calendar) == null ? void 0 : Ie.locale)) != null ? Ze : validate(he, fe, (je = ue == null ? void 0 : ue.calendar) == null ? void 0 : je.locale);
    _e(Ne ? format(Ne, fe) : null);
  }, [fe, he, r, (Me = ue == null ? void 0 : ue.calendar) == null ? void 0 : Me.locale]);
  const Ce = (Ne) => {
    const { value: Ie } = Ne.currentTarget;
    _e(Ie);
  }, Te = useCallback(
    (Ne) => {
      Ee(!0), U == null || U(Ne);
    },
    [U]
  ), we = useCallback(
    (Ne) => {
      var je, Ze, $e;
      const Ie = ($e = validate(r, fe, (je = ue == null ? void 0 : ue.calendar) == null ? void 0 : je.locale)) != null ? $e : validate(he, fe, (Ze = ue == null ? void 0 : ue.calendar) == null ? void 0 : Ze.locale);
      _e(Ie ? format(Ie, fe) : null), n == null || n(Ie ? new Date(Ie) : null), Ee(!1), Y == null || Y(Ne);
    },
    [fe, he, (be = ue == null ? void 0 : ue.calendar) == null ? void 0 : be.locale, Y, n, r]
  ), Re = () => {
    var Ie, je, Ze;
    const Ne = (Ze = validate(r, fe, (Ie = ue == null ? void 0 : ue.calendar) == null ? void 0 : Ie.locale)) != null ? Ze : validate(he, fe, (je = ue == null ? void 0 : ue.calendar) == null ? void 0 : je.locale);
    _e(Ne ? format(Ne, fe) : null), me(!1), de == null || de(!1);
  }, Ae = (Ne) => {
    var je, Ze, $e;
    const Ie = ($e = validate(Ne, fe, (je = ue == null ? void 0 : ue.calendar) == null ? void 0 : je.locale)) != null ? $e : validate(he, fe, (Ze = ue == null ? void 0 : ue.calendar) == null ? void 0 : Ze.locale);
    _e(Ie ? format(Ie, fe) : null), n == null || n(Ie ? new Date(Ie) : null), me(!1), de == null || de(!1);
  }, Pe = useCallback(() => {
    _e(null), n == null || n(null), me(!1), de == null || de(!1);
  }, [n, de]), ke = useCallback(() => {
    var Ne;
    me(!0), de == null || de(!0), (Ne = ne.current) == null || Ne.focus();
  }, [de]);
  return /* @__PURE__ */ jsx("div", { className: clsx("go-date-picker", s), style: ee, children: /* @__PURE__ */ jsx(
    Tooltip$1,
    {
      title: /* @__PURE__ */ jsx(
        DatePickerPopover,
        {
          value: validate(Se, fe, (De = ue == null ? void 0 : ue.calendar) == null ? void 0 : De.locale),
          defaultValue: validate(he, fe, (Fe = ue == null ? void 0 : ue.calendar) == null ? void 0 : Fe.locale),
          showTime: re,
          size: K,
          isDateDisabled: ae,
          isHourDisabled: ie,
          isMinuteDisabled: ce,
          renderPopover: le,
          onApply: Ae,
          onCancel: Re,
          onClear: Pe
        }
      ),
      placement: "bottom-start",
      open: ve,
      trigger: ["click", "focus"],
      onOpenChange: me,
      withArrow: !1,
      gap: 8,
      className: clsx("go-date-picker__popover", X),
      onPointerDown: (Ne) => Ne.preventDefault(),
      triggerRef: mergeRefs(se, ne),
      ...pe,
      children: /* @__PURE__ */ jsx(
        Input,
        {
          id: V,
          value: (Le = Se == null ? void 0 : Se.toString()) != null ? Le : null,
          onChange: Ce,
          suffix: !xe && /* @__PURE__ */ jsx(CalendarDuotoneLine, { className: "go-date-picker__suffix-icon" }),
          allowClear: a,
          loading: W,
          placeholder: G != null ? G : ge,
          size: K,
          status: J,
          tabIndex: te,
          autoFocus: l,
          disabled: o,
          inputClassName: $,
          fieldClassName: Z,
          onClear: Pe,
          onBlur: we,
          onFocus: Te,
          onClick: ke,
          onKeyUp: (Ne) => {
            Ne.code === "Enter" && ke();
          }
        }
      )
    }
  ) });
}), WeekV2 = forwardRef(function t({ weekStart: r, month: n, selectedDate: a, isDateDisabled: s, onDateChange: o, config: l, onUnmount: x }, j) {
  var $;
  const { localization: Z } = useContext(ConfigContext), V = useMemo$1(() => {
    var Y, U;
    const X = startOfWeek(toDate(r), { locale: (Y = Z == null ? void 0 : Z.calendar) == null ? void 0 : Y.locale }), W = endOfWeek(X, { locale: (U = Z == null ? void 0 : Z.calendar) == null ? void 0 : U.locale });
    return eachDayOfInterval({ start: X, end: W });
  }, [($ = Z == null ? void 0 : Z.calendar) == null ? void 0 : $.locale, r]);
  return useEffect(() => () => x(r), [x, r]), /* @__PURE__ */ jsx(
    "div",
    {
      ref: j,
      id: `${format(r, "dd.MM.yyyy")}`,
      className: "go-calendar__week-row",
      style: { height: `${l.weekRowHeight}px` },
      children: V.map((X) => {
        var W;
        return /* @__PURE__ */ jsx(
          CalendarDate,
          {
            value: X,
            onClick: () => o(X.getTime()),
            isSelected: isSelectedDate(X, a),
            isActive: isActiveMonth(n, X),
            disabled: (W = s == null ? void 0 : s(millisecondsToSeconds(X.getTime()))) != null ? W : !1
          },
          X.getTime().toString()
        );
      })
    }
  );
});
function moveWeekRows(t, r, n, a) {
  for (const [s, o] of t) {
    const l = getViewportPoint(s, r, a);
    o.style.transform = `translateY(${l - n}px)`;
  }
}
const CalendarDatesV2 = ({
  month: t,
  year: r,
  selectedDate: n,
  config: a,
  onDateChange: s,
  onMonthChange: o,
  isDateDisabled: l
}) => {
  var oe, le;
  const { localization: x } = useContext(ConfigContext), j = (oe = x == null ? void 0 : x.calendar) == null ? void 0 : oe.locale, Z = useRef(startOfWeek(startOfMonth(/* @__PURE__ */ new Date()), { locale: j })), [V, $] = useState$1(() => getStartOfMonth(t, r));
  useEffect(() => $(getStartOfMonth(t, r)), [t, r]);
  const [X, W] = useState$1(() => getWeeks(V, j));
  useEffect(() => W(getWeeks(V, j)), [j, V]);
  const Y = useRef(/* @__PURE__ */ new Map()), U = useRef(null), G = useRef(
    // eslint-disable-next-line react-hooks/refs
    getViewportByDate(V, Z.current, a.weekRowHeight, j)
  ), K = useRef(null), [J, ee] = useState$1(!1);
  useEffect(() => {
    var se;
    if (J)
      return;
    const pe = G.current, de = getViewportByDate(V, Z.current, a.weekRowHeight, j);
    (se = K.current) == null || se.call(K), K.current = animate(
      pe,
      de,
      (ue) => {
        G.current = ue, moveWeekRows(Y.current, Z.current, ue, a.weekRowHeight);
      },
      (ue) => G.current = ue
    );
  }, [a.weekRowHeight, V, J, j]);
  const te = useCallback(
    ({ y: pe }) => {
      ee(!0), G.current += pe;
      const de = Math.ceil(G.current / a.weekRowHeight), se = startOfWeek(
        // Add (NUMBER_OF_WEEKS_ON_PAGE / 2) weeks to switch months in header when month is half displayed.
        startOfMonth(add$1(Z.current, { weeks: de + NUMBER_OF_WEEKS_ON_PAGE / 2 })),
        {
          locale: j
        }
      );
      moveWeekRows(Y.current, Z.current, G.current, a.weekRowHeight);
      const ue = endOfWeek(se, { locale: j }), fe = getMonth(ue), ge = getYear(ue);
      $(getStartOfMonth(getMonth(ue), getYear(ue))), o(fe, ge);
    },
    [a.weekRowHeight, j, o]
  ), re = useCallback(() => {
    ee(!1);
  }, []), ae = useThrottledFn((pe) => {
    const de = pe > 0 ? 1 : -1, se = startOfWeek(startOfMonth(add$1(V, { months: 1 * de })), {
      locale: j
    }).getTime();
    if (Y.current.get(se)) {
      const fe = endOfWeek(se, { locale: j });
      o(getMonth(fe), getYear(fe));
    }
  }, 300);
  useScroll({
    // eslint-disable-next-line react-hooks/refs
    element: (le = U.current) != null ? le : null,
    onMove: te,
    onMoveEnd: re,
    onScroll: ae
  });
  const ie = (pe, de) => {
    if (pe !== null) {
      Y.current.set(de, pe);
      const se = G.current, ue = getViewportPoint(de, Z.current, a.weekRowHeight);
      pe.style.transform = `translateY(${ue - se}px)`;
    }
  }, ce = useCallback((pe) => {
    Y.current.delete(pe);
  }, []), he = useMemo$1(() => eachDayOfInterval({
    start: startOfWeek(V, { locale: j }),
    end: endOfWeek(V, { locale: j })
  }), [V, j]);
  return /* @__PURE__ */ jsxs("div", { className: "go-calendar__dates-container", children: [
    /* @__PURE__ */ jsx("div", { className: "go-calendar__week-days-row", children: he.map((pe) => /* @__PURE__ */ jsx(
      "div",
      {
        className: clsx("go-calendar__week-day", isWeekend(pe) && "go-calendar__date_weekend"),
        children: /* @__PURE__ */ jsx("span", { className: "go-calendar__week-day-inner", children: format(pe, "cccccc", { locale: j }) })
      },
      pe.getTime().toString()
    )) }),
    /* @__PURE__ */ jsx("div", { ref: U, className: "go-calendar__dates", children: X.map((pe) => /* @__PURE__ */ jsx(
      WeekV2,
      {
        ref: (de) => ie(de, pe),
        onUnmount: ce,
        selectedDate: n,
        month: t,
        weekStart: pe,
        config: a,
        onDateChange: s,
        isDateDisabled: l
      },
      pe.toString()
    )) })
  ] });
}, CalendarMonthPageV2 = ({
  month: t,
  year: r,
  selectedDate: n,
  config: a,
  onDateChange: s,
  onMonthChange: o,
  isDateDisabled: l
}) => /* @__PURE__ */ jsx("div", { className: "go-calendar__month-page", children: /* @__PURE__ */ jsx(
  CalendarDatesV2,
  {
    month: t,
    year: r,
    selectedDate: n,
    config: a,
    onDateChange: s,
    onMonthChange: o,
    isDateDisabled: l
  }
) });
function shouldShowTime(t) {
  return typeof t == "boolean" ? t : typeof t == "object" ? !!t.hours || !!t.minutes : !1;
}
const CalendarV2 = ({
  value: t = null,
  defaultValue: r = null,
  defaultOpenDate: n = null,
  showTime: a = !1,
  mode: s = "month",
  config: o,
  className: l,
  style: x,
  onChange: j,
  isDateDisabled: Z,
  isHourDisabled: V,
  isMinuteDisabled: $
}) => {
  var he, oe;
  const X = t ? secondsToMilliseconds(t) : null, W = r ? secondsToMilliseconds(r) : null, Y = n ? secondsToMilliseconds(n) : null, [U, G] = useReducer(
    reducer,
    initialState,
    (le) => initStore(le, X, W, Y, s)
  );
  useEffect(() => {
    X !== null && G({ type: "SET_DATE", payload: X });
  }, [X]);
  const K = useMemo$1(
    () => ({ ...DEFAULT_CALENDAR_CONFIG, ...o }),
    [o]
  ), J = useCallback(
    (le) => {
      var se, ue;
      const pe = (/* @__PURE__ */ new Date()).getTime(), de = applyTimeV2(le, (se = U.hours) != null ? se : getHours(pe), (ue = U.minutes) != null ? ue : getMinutes(pe));
      j == null || j(de ? millisecondsToSeconds(de) : null);
    },
    [j, U.hours, U.minutes]
  ), ee = useCallback(
    (le) => {
      if (G({ type: "SET_HOURS", payload: le.value }), U.mode !== "month" || U.minutes === null || X === null)
        return;
      const pe = applyTimeV2(X, le.value, U.minutes);
      j == null || j(pe ? millisecondsToSeconds(pe) : null);
    },
    [j, X, U.minutes, U.mode]
  ), te = useCallback(
    (le) => {
      if (G({ type: "SET_MINUTES", payload: le.value }), U.mode !== "month" || U.hours === null || X === null)
        return;
      const pe = applyTimeV2(X, U.hours, le.value);
      j == null || j(pe ? millisecondsToSeconds(pe) : null);
    },
    [j, U.hours, U.mode, X]
  ), re = useCallback(
    (le) => V ? U.mode === "year" ? !0 : V(
      le,
      X !== null ? millisecondsToSeconds(applyTimeV2(X, le, U.minutes)) : null
    ) : !1,
    [V, U.minutes, U.mode, X]
  ), ae = useCallback(
    (le) => $ ? U.mode === "year" ? !0 : $(
      le,
      U.hours,
      X !== null ? millisecondsToSeconds(applyTimeV2(X, U.hours, le)) : null
    ) : !1,
    [$, U.hours, U.mode, X]
  ), ie = useCallback((le, pe) => {
    G({ type: "SET_MONTH", payload: { month: le, year: pe } });
  }, []), ce = shouldShowTime(a);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: clsx("go-calendar", ce && "go-calendar_with-time", l),
      style: {
        ...x,
        "--dates-container-height": `${K.weekRowHeight * NUMBER_OF_WEEKS_ON_PAGE}px`
      },
      children: [
        /* @__PURE__ */ jsx(
          CalendarHeader,
          {
            month: (he = U.month) != null ? he : getMonth(/* @__PURE__ */ new Date()),
            year: (oe = U.year) != null ? oe : getYear(/* @__PURE__ */ new Date()),
            mode: U.mode,
            onChange: (le, pe) => {
              G({ type: "SET_MONTH", payload: { month: le, year: pe } });
            },
            onTitleClick: () => {
              G({ type: "TOGGLE_MODE" });
            }
          }
        ),
        U.mode === "month" && /* @__PURE__ */ jsx(
          CalendarMonthPageV2,
          {
            month: U.month,
            year: U.year,
            selectedDate: X,
            config: K,
            onDateChange: J,
            onMonthChange: ie,
            isDateDisabled: Z
          }
        ),
        U.mode === "year" && /* @__PURE__ */ jsx(
          CalendarYearPage,
          {
            month: U.month,
            year: U.year,
            onYearChange: (le) => {
              G({ type: "SET_YEAR", payload: le });
            },
            onMonthChange: (le) => {
              G({ type: "SET_MONTH", payload: { month: le } }), G({ type: "TOGGLE_MODE", payload: "month" });
            }
          }
        ),
        ce && /* @__PURE__ */ jsx(
          CalendarTime,
          {
            hours: U.hours,
            minutes: U.minutes,
            onHourChange: ee,
            onMinuteChange: te,
            viewSettings: typeof a == "object" ? a : void 0,
            isHourDisabled: re,
            isMinuteDisabled: ae,
            disabled: U.mode === "year"
          }
        )
      ]
    }
  );
}, DatePickerPopoverV2 = ({
  value: t,
  defaultValue: r,
  defaultOpenDate: n,
  showTime: a,
  size: s,
  renderPopover: o,
  onCancel: l,
  onApply: x,
  onClear: j,
  isDateDisabled: Z,
  isHourDisabled: V,
  isMinuteDisabled: $
}) => {
  var K, J, ee, te;
  const { localization: X } = useContext(ConfigContext), [W, Y] = useState$1(t), U = /* @__PURE__ */ jsx(
    CalendarV2,
    {
      value: W && millisecondsToSeconds(W),
      onChange: (re) => Y(re && secondsToMilliseconds(re)),
      defaultValue: r,
      defaultOpenDate: n,
      showTime: a,
      isDateDisabled: Z,
      isHourDisabled: V,
      isMinuteDisabled: $
    }
  ), G = () => x(W);
  return o ? /* @__PURE__ */ jsx(Fragment, { children: o({
    calendar: U,
    currentDate: W && millisecondsToSeconds(W),
    onCancel: l,
    onApply: G,
    onClear: j
  }) }) : /* @__PURE__ */ jsxs(Fragment, { children: [
    U,
    /* @__PURE__ */ jsxs("div", { className: "go-date-picker__popover-footer", children: [
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "danger",
          size: s,
          className: "go-date-picker__popover-footer-button",
          icon: /* @__PURE__ */ jsx(CloseRoundLight, {}),
          onClick: j,
          children: (J = (K = X == null ? void 0 : X.datePicker) == null ? void 0 : K.values) == null ? void 0 : J.cancel
        }
      ),
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "success",
          size: s,
          className: "go-date-picker__popover-footer-button",
          icon: /* @__PURE__ */ jsx(DoneLight, {}),
          onClick: G,
          children: (te = (ee = X == null ? void 0 : X.datePicker) == null ? void 0 : ee.values) == null ? void 0 : te.apply
        }
      )
    ] })
  ] });
}, DEFAULT_DATE_FORMAT = "dd.MM.yyyy", DEFAULT_DATE_TIME_FORMAT = "dd.MM.yyyy HH:mm", DatePickerV2 = forwardRef(function t({
  value: r = null,
  onChange: n,
  allowClear: a,
  className: s,
  disabled: o,
  autoFocus: l,
  defaultOpen: x = !1,
  fieldClassName: j,
  id: Z,
  inputClassName: V,
  popoverClassName: $,
  tooltipContainerClassName: X,
  loading: W,
  onBlur: Y,
  onFocus: U,
  onKeyDown: G,
  placeholder: K,
  size: J,
  status: ee,
  style: te,
  tabIndex: re,
  showTime: ae,
  isDateDisabled: ie,
  isHourDisabled: ce,
  isMinuteDisabled: he,
  defaultValue: oe = null,
  defaultOpenDate: le,
  dateFormat: pe,
  renderPopover: de,
  tooltipProps: se
}, ue) {
  var Fe, Le, Ne, Ie, je, Ze, $e, We;
  const { localization: fe } = useContext(ConfigContext), ge = r && secondsToMilliseconds(r), ne = pe != null ? pe : ae ? DEFAULT_DATE_TIME_FORMAT : DEFAULT_DATE_FORMAT, ve = useMemo$1(() => format(/* @__PURE__ */ new Date(), ne), [ne]), me = useRef(null), [xe, Ee] = useState$1(x), [Se, _e] = useState$1(!1), [Ce, Te] = useState$1(
    () => {
      var Be, Ue;
      return (Ue = validate(ge, ne, (Be = fe == null ? void 0 : fe.calendar) == null ? void 0 : Be.locale)) != null ? Ue : null;
    }
  );
  useEffect(() => {
    var Ue, Qe, et;
    const Be = (et = validate(ge, ne, (Ue = fe == null ? void 0 : fe.calendar) == null ? void 0 : Ue.locale)) != null ? et : validate(oe, ne, (Qe = fe == null ? void 0 : fe.calendar) == null ? void 0 : Qe.locale);
    Te(Be ? format(Be, ne) : null);
  }, [ne, oe, ge, (Fe = fe == null ? void 0 : fe.calendar) == null ? void 0 : Fe.locale]);
  const we = (Be) => {
    const { value: Ue } = Be.currentTarget;
    Te(Ue);
  }, Re = useCallback(
    (Be) => {
      _e(!0), U == null || U(Be);
    },
    [U]
  ), Ae = useCallback(
    (Be) => {
      var Qe, et, rt;
      const Ue = (rt = validate(ge, ne, (Qe = fe == null ? void 0 : fe.calendar) == null ? void 0 : Qe.locale)) != null ? rt : validate(oe, ne, (et = fe == null ? void 0 : fe.calendar) == null ? void 0 : et.locale);
      Te(Ue ? format(Ue, ne) : null), n == null || n(Ue ? getUnixTime(Ue) : null), _e(!1), Y == null || Y(Be);
    },
    [ne, oe, (Le = fe == null ? void 0 : fe.calendar) == null ? void 0 : Le.locale, Y, n, ge]
  ), Pe = () => {
    var Ue, Qe, et;
    const Be = (et = validate(ge, ne, (Ue = fe == null ? void 0 : fe.calendar) == null ? void 0 : Ue.locale)) != null ? et : validate(oe, ne, (Qe = fe == null ? void 0 : fe.calendar) == null ? void 0 : Qe.locale);
    Te(Be ? format(Be, ne) : null), Ee(!1);
  }, ke = useCallback(
    (Be) => {
      var Qe, et, rt;
      const Ue = (rt = validate(Be, ne, (Qe = fe == null ? void 0 : fe.calendar) == null ? void 0 : Qe.locale)) != null ? rt : validate(oe, ne, (et = fe == null ? void 0 : fe.calendar) == null ? void 0 : et.locale);
      Be !== ge && (Te(Ue ? format(Ue, ne) : null), n == null || n(Ue ? getUnixTime(Ue) : null)), Ee(!1);
    },
    [ne, oe, (Ne = fe == null ? void 0 : fe.calendar) == null ? void 0 : Ne.locale, n, ge]
  ), ye = useCallback(() => {
    Te(null), n == null || n(null), Ee(!1);
  }, [n]), Me = useCallback(() => {
    var Be;
    Ee(!0), (Be = me.current) == null || Be.focus();
  }, []), be = useCallback(
    (Be) => {
      var Ue, Qe, et, rt, ut;
      if (Be.key === "Enter") {
        if (!xe) {
          Ee(!0);
          return;
        }
        const tt = Ce === null ? null : (Qe = parse(Ce.toString(), ne, /* @__PURE__ */ new Date(), {
          locale: (Ue = fe == null ? void 0 : fe.calendar) == null ? void 0 : Ue.locale
        })) == null ? void 0 : Qe.getTime(), nt = (ut = validate(tt, ne, (et = fe == null ? void 0 : fe.calendar) == null ? void 0 : et.locale)) != null ? ut : validate(oe, ne, (rt = fe == null ? void 0 : fe.calendar) == null ? void 0 : rt.locale);
        tt !== ge && (Te(nt ? format(nt, ne) : null), n == null || n(nt ? getUnixTime(nt) : null)), Ee(!1);
      }
      G == null || G(Be);
    },
    [ne, oe, (Ie = fe == null ? void 0 : fe.calendar) == null ? void 0 : Ie.locale, n, G, xe, Ce, ge]
  ), De = useMemo$1(() => mergeRefs(ue, me), [ue]);
  return /* @__PURE__ */ jsx("div", { className: clsx("go-date-picker", s), style: te, children: /* @__PURE__ */ jsx(
    Tooltip$1,
    {
      title: /* @__PURE__ */ jsx(
        DatePickerPopoverV2,
        {
          value: validate(Ce, ne, (je = fe == null ? void 0 : fe.calendar) == null ? void 0 : je.locale),
          defaultValue: validate(oe, ne, (Ze = fe == null ? void 0 : fe.calendar) == null ? void 0 : Ze.locale),
          defaultOpenDate: validate(le, ne, ($e = fe == null ? void 0 : fe.calendar) == null ? void 0 : $e.locale),
          showTime: ae,
          size: J,
          isDateDisabled: ie,
          isHourDisabled: ce,
          isMinuteDisabled: he,
          renderPopover: de,
          onApply: ke,
          onCancel: Pe,
          onClear: ye
        }
      ),
      placement: "bottom-start",
      open: xe,
      trigger: ["click", "focus"],
      onOpenChange: Ee,
      withArrow: !1,
      gap: 8,
      containerClassName: X,
      className: clsx("go-date-picker__popover", $),
      onPointerDown: (Be) => Be.preventDefault(),
      triggerRef: De,
      focusManagerProps: { returnFocus: !1 },
      ...se,
      children: /* @__PURE__ */ jsx(
        Input,
        {
          id: Z,
          value: (We = Ce == null ? void 0 : Ce.toString()) != null ? We : null,
          onChange: we,
          suffix: !Se && /* @__PURE__ */ jsx(CalendarDuotoneLine, { className: "go-date-picker__suffix-icon" }),
          allowClear: a,
          loading: W,
          placeholder: Se ? K != null ? K : ve : K != null ? K : "",
          size: J,
          status: ee,
          tabIndex: re,
          autoFocus: l,
          disabled: o,
          inputClassName: V,
          fieldClassName: j,
          onClear: ye,
          onBlur: Ae,
          onFocus: Re,
          onClick: Me,
          onKeyDown: be
        }
      )
    }
  ) });
}), CalendarYearsRow = forwardRef(function t({ startYear: r, selectedYear: n, config: a, min: s, max: o, isYearDisabled: l, onChange: x }, j) {
  const Z = numberRange(Math.max(r, s), Math.min(r + a.numberOfYearsInRow - 1, o));
  return /* @__PURE__ */ jsx("div", { ref: j, className: "go-calendar_years__row", style: { height: `${a.rowHeight}px` }, children: Z.map((V) => /* @__PURE__ */ jsx(
    "button",
    {
      disabled: l == null ? void 0 : l(V),
      onClick: x && (() => x(V)),
      className: clsx("go-calendar_years__year", V === n && "go-calendar_years__year_selected"),
      style: { width: `calc(100% / ${a.numberOfYearsInRow})` },
      children: /* @__PURE__ */ jsx("span", { className: "go-calendar_years__year-inner", children: V })
    },
    V
  )) });
});
function getScrolledDistance(t, r, n) {
  return ((t - r) / n.numberOfYearsInRow - 1) * n.rowHeight - Math.floor(n.numberOfYearsInRow / 2) * n.rowHeight;
}
const CalendarYearsPage = ({ year: t, config: r, min: n = 1900, max: a = 2099, onChange: s, isYearDisabled: o }) => {
  const [l, x] = n <= a ? [Math.trunc(n), Math.trunc(a)] : [Math.trunc(a), Math.trunc(n)];
  useEffect(() => {
    n > a && console.warn(`Invalid minimum and maximum years: ${n} > ${a}`);
  }, [a, n]);
  const [j, Z] = useState$1(null), V = ((getStartOfYearRow(l, x, r.numberOfYearsInRow) - l) / r.numberOfYearsInRow + 1) * r.rowHeight, $ = useRef(t != null ? t : (/* @__PURE__ */ new Date()).getFullYear());
  useEffect(() => {
    if (!j)
      return;
    const W = getStartOfYearRow(l, $.current, r.numberOfYearsInRow), Y = getScrolledDistance(W, l, r);
    j.scroll({ top: Y });
  }, [r, j, l]), useEffect(() => {
    if (!j || t === null || t < l || t > x)
      return;
    const W = getStartOfYearRow(l, t, r.numberOfYearsInRow), Y = getScrolledDistance(W, l, r);
    j.scroll({ top: Y, behavior: "smooth" });
  }, [r, j, x, l, t]);
  const X = useMemo$1(
    () => getYearRowStartPoints(l, x, r.numberOfYearsInRow),
    [r.numberOfYearsInRow, x, l]
  );
  return /* @__PURE__ */ jsx(
    "div",
    {
      ref: (W) => Z(W),
      className: "go-calendar_years__inner",
      style: { height: `${r.numberOfRows * r.rowHeight}px` },
      children: /* @__PURE__ */ jsx("div", { style: { height: `${V}px` }, children: X.map((W) => /* @__PURE__ */ jsx(
        CalendarYearsRow,
        {
          startYear: W,
          selectedYear: t,
          config: r,
          min: l,
          max: x,
          isYearDisabled: o,
          onChange: s
        },
        W
      )) })
    }
  );
}, YearsCalendar = ({
  value: t,
  defaultValue: r,
  minYear: n,
  maxYear: a,
  config: s,
  style: o,
  className: l,
  onChange: x,
  isYearDisabled: j
}) => {
  var V;
  const Z = useMemo$1(
    () => ({ ...DEFAULT_YEARS_CALENDAR_CONFIG, ...s }),
    [s]
  );
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: clsx("go-calendar_years", l),
      style: {
        ...o,
        "--dates-container-height": `${Z.rowHeight * Z.numberOfRows}px`
      },
      children: /* @__PURE__ */ jsx(
        CalendarYearsPage,
        {
          year: (V = t != null ? t : r) != null ? V : null,
          config: Z,
          onChange: x,
          isYearDisabled: j,
          min: n,
          max: a
        }
      )
    }
  );
}, YearPickerPopover = ({
  value: t,
  defaultValue: r,
  minYear: n,
  maxYear: a,
  size: s,
  renderPopover: o,
  onCancel: l,
  onApply: x,
  onClear: j,
  isYearDisabled: Z,
  calendarConfig: V
}) => {
  var G, K, J, ee;
  const { localization: $ } = useContext(ConfigContext), [X, W] = useState$1(t);
  useEffect(() => {
    W(t);
  }, [t]);
  const Y = /* @__PURE__ */ jsx(
    YearsCalendar,
    {
      value: X,
      onChange: W,
      defaultValue: r,
      isYearDisabled: Z,
      minYear: n,
      maxYear: a,
      config: V
    }
  ), U = () => x(X);
  return o ? /* @__PURE__ */ jsx(Fragment, { children: o({
    calendar: Y,
    currentYear: X,
    onCancel: l,
    onApply: U,
    onClear: j
  }) }) : /* @__PURE__ */ jsxs(Fragment, { children: [
    Y,
    /* @__PURE__ */ jsxs("div", { className: "go-date-picker__popover-footer", children: [
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "danger",
          size: s,
          className: "go-date-picker__popover-footer-button",
          icon: /* @__PURE__ */ jsx(CloseRoundLight, {}),
          onClick: j,
          children: (K = (G = $ == null ? void 0 : $.datePicker) == null ? void 0 : G.values) == null ? void 0 : K.cancel
        }
      ),
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "success",
          size: s,
          className: "go-date-picker__popover-footer-button",
          icon: /* @__PURE__ */ jsx(DoneLight, {}),
          onClick: U,
          children: (ee = (J = $ == null ? void 0 : $.datePicker) == null ? void 0 : J.values) == null ? void 0 : ee.apply
        }
      )
    ] })
  ] });
}, YearPicker = forwardRef(function t({
  value: r = null,
  onChange: n,
  allowClear: a,
  className: s,
  disabled: o,
  autoFocus: l,
  defaultOpen: x = !1,
  fieldClassName: j,
  id: Z,
  inputClassName: V,
  popoverClassName: $,
  loading: X,
  onBlur: W,
  onFocus: Y,
  onKeyDown: U,
  placeholder: G,
  size: K,
  status: J,
  style: ee,
  calendarConfig: te,
  tabIndex: re,
  defaultValue: ae = null,
  renderPopover: ie,
  tooltipProps: ce,
  isYearDisabled: he,
  onApplyInPopover: oe
}, le) {
  var we;
  const pe = useRef(null), [de, se] = useState$1(x), [ue, fe] = useState$1(!1), [ge, ne] = useState$1(() => r != null ? r : null);
  useEffect(() => {
    var Ae;
    const Re = (Ae = validateYear(r)) != null ? Ae : validateYear(ae);
    ne(Re);
  }, [ae, r]);
  const ve = (Re) => {
    var ke;
    const { value: Ae } = Re.currentTarget, Pe = (ke = validateYear(Ae)) != null ? ke : validateYear(ae);
    ne(Pe);
  }, me = useCallback(
    (Re) => {
      fe(!0), Y == null || Y(Re);
    },
    [Y]
  ), xe = useCallback(
    (Re) => {
      var Pe;
      const Ae = (Pe = validateYear(r)) != null ? Pe : validateYear(ae);
      ne(Ae), n == null || n(Ae), fe(!1), W == null || W(Re);
    },
    [ae, W, n, r]
  ), Ee = () => {
    var Ae;
    const Re = (Ae = validateYear(r)) != null ? Ae : validateYear(ae);
    ne(Re), se(!1);
  }, Se = (Re) => {
    var Pe;
    const Ae = (Pe = validateYear(Re)) != null ? Pe : validateYear(ae);
    Re !== r && (ne(Ae), n == null || n(Ae)), se(!1), oe == null || oe(Ae);
  }, _e = useCallback(() => {
    ne(null), n == null || n(null);
  }, [n]), Ce = useCallback(() => {
    var Re;
    se(!0), (Re = pe.current) == null || Re.focus();
  }, []), Te = useCallback(
    (Re) => {
      var Ae;
      if (Re.key === "Enter") {
        const Pe = (Ae = validateYear(ge)) != null ? Ae : validateYear(ae);
        Pe !== r && (ne(Pe), n == null || n(Pe)), se(!de);
      }
      U == null || U(Re);
    },
    [ae, n, U, de, ge, r]
  );
  return /* @__PURE__ */ jsx("div", { className: clsx("go-date-picker", s), style: ee, children: /* @__PURE__ */ jsx(
    Tooltip$1,
    {
      title: /* @__PURE__ */ jsx(
        YearPickerPopover,
        {
          value: ge,
          defaultValue: ae,
          size: K,
          isYearDisabled: he,
          renderPopover: ie,
          onApply: Se,
          onCancel: Ee,
          onClear: _e,
          calendarConfig: te
        }
      ),
      placement: "bottom-start",
      open: de,
      trigger: ["click", "focus"],
      onOpenChange: se,
      withArrow: !1,
      gap: 8,
      className: clsx("go-date-picker__popover", $),
      onPointerDown: (Re) => Re.preventDefault(),
      triggerRef: mergeRefs(le, pe),
      focusManagerProps: { returnFocus: !1 },
      ...ce,
      children: /* @__PURE__ */ jsx(
        Input,
        {
          id: Z,
          value: (we = ge == null ? void 0 : ge.toString()) != null ? we : null,
          onChange: ve,
          suffix: !ue && /* @__PURE__ */ jsx(CalendarDuotoneLine, { className: "go-date-picker__suffix-icon" }),
          allowClear: a,
          loading: X,
          placeholder: G,
          size: K,
          status: J,
          tabIndex: re,
          autoFocus: l,
          disabled: o,
          inputClassName: V,
          fieldClassName: j,
          onClear: _e,
          onBlur: xe,
          onFocus: me,
          onClick: Ce,
          onKeyDown: Te
        }
      )
    }
  ) });
}), DeleteButton = forwardRef(
  ({ className: t, style: r, onClick: n, loading: a, onPointerUp: s, onPointerDown: o, disabled: l }, x) => /* @__PURE__ */ jsx(
    "button",
    {
      ref: x,
      className: clsx("go-delete-button", a && "go-delete-button_loading", t),
      style: r,
      disabled: l,
      onClick: n,
      onPointerDown: o,
      onPointerUp: s,
      children: a ? /* @__PURE__ */ jsx(LoaderIcon, { size: "s", className: "go-delete-button__loader" }) : /* @__PURE__ */ jsx(CloseRoundDuotone, { className: "go-delete-button__icon" })
    }
  )
);
DeleteButton.displayName = "DeleteButton";
function Item({ titleClassName: t, valueClassName: r, label: n, children: a, titleStyle: s, valueStyle: o }) {
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("div", { className: clsx("go-descriptions__item-title", t), style: s, children: n }),
    /* @__PURE__ */ jsx("div", { className: clsx("go-descriptions__item-value", r), style: o, children: a })
  ] });
}
function Descriptions({ className: t, children: r, layout: n = "horizontal" }) {
  return /* @__PURE__ */ jsx("div", { className: clsx("go-descriptions", n === "vertical" && "go-descriptions_vertical", t), children: r });
}
const descriptions = Object.assign(Descriptions, { Item });
function getOrCreatePortalElement(t) {
  const r = document.getElementById(t);
  if (r)
    return r;
  const n = document.createElement("div");
  return n.id = t, n.classList.add("go-portal"), n;
}
function useMountTransition(t, r) {
  const [n, a] = useState$1(!1);
  return useEffect(() => {
    let s;
    return t && !n ? a(!0) : !t && n && (s = window.setTimeout(() => a(!1), r)), () => {
      clearTimeout(s);
    };
  }, [r, t, n]), n;
}
const Portal = ({
  transitionDuration: t = 300,
  open: r,
  children: n,
  rootElement: a,
  className: s,
  contentClassName: o,
  contentOpenClassName: l,
  portalClassName: x,
  destroyOnClose: j = !0,
  mask: Z = !0,
  onClickOutside: V
}) => {
  var ee;
  const $ = useContext(ConfigContext), W = `go-portal-${useId$3()}`, Y = useRef(getOrCreatePortalElement(W)), U = useRef(null), G = (ee = a != null ? a : $.rootElement) != null ? ee : document.body, K = useMountTransition(r, t);
  useEffect(() => {
    const te = Y.current;
    return G.appendChild(te), () => {
      te.remove();
    };
  }, [G]), useEffect(() => {
    if (s) {
      const te = Y.current;
      return te.classList.add(s), () => te.classList.remove(s);
    }
  }, [s]), useEffect(() => {
    const te = Y.current;
    return r && window.requestAnimationFrame(() => {
      te.classList.add("go-portal_open");
    }), !r && K && window.requestAnimationFrame(() => {
      te.classList.add("go-portal_closing");
    }), () => {
      window.requestAnimationFrame(() => {
        te.classList.remove("go-portal_open"), te.classList.remove("go-portal_closing");
      });
    };
  }, [K, r]);
  const J = useCallback(
    (te) => {
      !V || !r || te.target === U.current && V(te);
    },
    [V, r]
  );
  return !K && j && !r ? null : createPortal(
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: clsx(
          "go-portal__container",
          $.theme === "dark" && "go-theme_dark",
          $.theme === "light" && "go-theme_light",
          $.style === "bordered" && "go-style_bordered",
          x
        ),
        style: { "--go-transition": `${t}ms` },
        "aria-hidden": r,
        children: [
          Z && /* @__PURE__ */ jsx("div", { ref: U, className: "go-portal__overlay", onClick: J }),
          /* @__PURE__ */ jsx("div", { className: clsx(o, "go-portal__content", r && l), children: n })
        ]
      }
    ),
    // eslint-disable-next-line react-hooks/refs
    Y.current
  );
}, Drawer = ({
  open: t,
  title: r,
  closeIcon: n = !0,
  loading: a,
  className: s,
  portalClassName: o,
  style: l,
  onClose: x,
  onClickOutside: j = x,
  children: Z,
  transitionDuration: V,
  destroyOnClose: $,
  container: X,
  mask: W
}) => {
  const Y = useCallback(() => typeof r == "string" || typeof r == "number" ? /* @__PURE__ */ jsx("h2", { className: "go-drawer__title", children: r }) : r, [r]);
  return /* @__PURE__ */ jsx(
    Portal,
    {
      open: t,
      onClickOutside: j != null ? j : null,
      className: "go-drawer__portal",
      contentClassName: "go-drawer__wrapper",
      contentOpenClassName: "go-drawer__wrapper_open",
      portalClassName: o,
      transitionDuration: V,
      destroyOnClose: $,
      rootElement: X,
      mask: W,
      children: /* @__PURE__ */ jsxs("div", { className: clsx(s, "go-drawer"), style: l, children: [
        /* @__PURE__ */ jsx("div", { className: "go-drawer__header", children: Y() }),
        n && /* @__PURE__ */ jsx("button", { className: "go-drawer__close-button", onClick: x, children: /* @__PURE__ */ jsx(CloseRoundLight, {}) }),
        Z,
        a && /* @__PURE__ */ jsx(Loader, { className: "go-drawer__loader" })
      ] })
    }
  );
}, orientationClassNames$1 = {
  horizontal: "go-field_orientation_horizontal",
  vertical: "go-field_orientation_vertical"
}, sizeClassNames$3 = {
  s: "go-field_size_s",
  m: "go-field_size_m"
}, statusClassNames$1 = {
  error: "go-field_status_error"
}, Field = ({
  children: t,
  label: r,
  id: n,
  orientation: a = "vertical",
  hint: s,
  info: o,
  size: l,
  status: x,
  className: j,
  style: Z
}) => {
  const { size: V } = useGlobalComponentConfig({ size: l }), $ = useId$3(), X = n != null ? n : `go-field-${$}`, W = () => isValidElement(t) ? cloneElement(t, {
    id: X,
    size: V,
    status: x
  }) : null;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: clsx(
        "go-field",
        orientationClassNames$1[a],
        sizeClassNames$3[V],
        !!x && statusClassNames$1[x],
        j
      ),
      style: Z,
      children: [
        (!!r || !!o) && /* @__PURE__ */ jsxs("div", { className: "go-field__label-container", children: [
          !!r && /* @__PURE__ */ jsx("label", { htmlFor: X, className: "go-field__label", title: r.toString(), children: r }),
          !!o && /* @__PURE__ */ jsx(Tooltip$1, { title: renderNode(o, "p"), placement: "top", useSafePolygon: !1, withArrow: !0, children: /* @__PURE__ */ jsx("span", { className: "go-field__info-icon", tabIndex: 0, children: /* @__PURE__ */ jsx(InfoLight, {}) }) })
        ] }),
        W(),
        !!s && renderNode(s, "p", "go-field__hint")
      ]
    }
  );
}, Upload = () => {
  const { theme: t } = useContext(ConfigContext);
  return t === "light" ? /* @__PURE__ */ jsxs("svg", { width: 328, height: 412, fill: "none", viewBox: "0 0 328 412", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#D2DFFA",
        d: "M285.972 127.126h-8.876a21.347 21.347 0 0 1-15.102-6.261 21.381 21.381 0 0 1-.285-29.93 21.35 21.35 0 0 1 14.566-6.535h6.708a22.966 22.966 0 0 0 15.777-6.982 23.002 23.002 0 0 0 6.476-16.002 23.003 23.003 0 0 0-6.476-16.002 22.966 22.966 0 0 0-15.777-6.982H47.689a22.969 22.969 0 0 0-15.778 6.982 23.005 23.005 0 0 0 0 32.004A22.969 22.969 0 0 0 47.69 84.4h2.281a21.35 21.35 0 0 1 14.566 6.536 21.382 21.382 0 0 1 5.97 14.815c0 5.669-2.25 11.106-6.255 15.114a21.347 21.347 0 0 1-15.102 6.261h-7.895a18.246 18.246 0 0 0-12.907 5.35 18.277 18.277 0 0 0 0 25.836 18.247 18.247 0 0 0 12.907 5.351h244.718a18.25 18.25 0 0 0 12.908-5.351 18.277 18.277 0 0 0 0-25.836 18.249 18.249 0 0 0-12.908-5.35Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#BECDFA",
        d: "m222.634 281.299-58.265-33.718c-5.651-3.27-12.881-1.336-16.15 4.32L94.333 345.13c-3.27 5.656-1.339 12.891 4.312 16.161l58.265 33.718c5.651 3.27 12.881 1.336 16.15-4.32l53.886-93.229c3.269-5.655 1.339-12.891-4.312-16.161Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#F1F4FA",
        stroke: "#3A36DB",
        strokeMiterlimit: "10",
        strokeWidth: "2",
        d: "M122.142 257.357h74.157l20.901 22.082v100.934a8.323 8.323 0 0 1-5.143 7.686 8.306 8.306 0 0 1-3.185.626h-86.707a8.312 8.312 0 0 1-8.306-8.312V265.67c0-2.201.872-4.312 2.425-5.87a8.303 8.303 0 0 1 5.858-2.443Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#BECDFA",
        stroke: "#3A36DB",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "M196.3 257.357v14.387c0 2.204.875 4.319 2.432 5.877a8.304 8.304 0 0 0 5.873 2.435h12.596L196.3 257.357Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#F1F4FA",
        d: "M184.982 409.671a261.313 261.313 0 0 0 3.833-36.103c0-6.668-3.217-10.505-6.046-10.505h-2.647a1.94 1.94 0 0 0-1.94 1.941v-.753a3.364 3.364 0 0 0-.949-2.433 3.36 3.36 0 0 0-2.405-1.015h-2.282a3.424 3.424 0 0 0-3.422 3.425v1.462a3.58 3.58 0 0 0-3.583-3.586h-2.281a3.769 3.769 0 0 0-3.765 3.768v.914a2.538 2.538 0 0 0-2.442-2.444h-3.149a3.354 3.354 0 0 0-3.354 3.311v3.7h-3.126a5.391 5.391 0 0 0-3.824 1.594 5.41 5.41 0 0 0-1.561 3.841v10.184a19.05 19.05 0 0 0 4.701 11.418 15.519 15.519 0 0 1 2.145 2.763 26.298 26.298 0 0 1 2.897 9.774h32.949l.251-1.256Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#3A36DB",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "M178.182 365.004a1.945 1.945 0 0 1 1.94-1.941h2.647c2.829 0 6.046 3.837 6.046 10.505a261.313 261.313 0 0 1-3.833 36.103l-.251 1.256h-32.949a26.298 26.298 0 0 0-2.897-9.774 15.519 15.519 0 0 0-2.145-2.763 19.05 19.05 0 0 1-4.701-11.418v-10.184a5.393 5.393 0 0 1 3.314-5.021 5.391 5.391 0 0 1 2.071-.414h3.126m27.632-6.349v-.753a3.364 3.364 0 0 0-.949-2.433 3.36 3.36 0 0 0-2.405-1.015h-2.282a3.424 3.424 0 0 0-3.422 3.425v1.462m9.058-.686v9.707m-9.058-9.021a3.58 3.58 0 0 0-3.583-3.586h-2.281a3.769 3.769 0 0 0-3.765 3.768v.914m9.629-1.096v8.814m-9.629-7.718a2.538 2.538 0 0 0-2.442-2.444h-3.149a3.354 3.354 0 0 0-3.354 3.311v3.7m8.945-4.567v8.86m-8.945-4.293v12.285"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#D2DFFA",
        d: "M236.481.57H75.298c-5.419 0-9.812 4.392-9.812 9.809 0 5.416 4.393 9.808 9.812 9.808H236.48c5.419 0 9.811-4.392 9.811-9.808 0-5.417-4.392-9.808-9.811-9.808Zm20.194 175.058H92.594c-8.935 0-16.178 7.244-16.178 16.179 0 8.936 7.243 16.179 16.178 16.179h164.081c8.934 0 16.177-7.243 16.177-16.179 0-8.935-7.243-16.179-16.177-16.179Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#F1F4FA",
        d: "M236.663 66.223v116.211c0 3.028-1.202 5.932-3.341 8.073a11.403 11.403 0 0 1-8.067 3.345H105.828a11.402 11.402 0 0 1-8.068-3.345 11.42 11.42 0 0 1-3.341-8.073V23.384a10.33 10.33 0 0 1 3.029-7.307 10.313 10.313 0 0 1 7.307-3.015h80.82"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#3A36DB",
        strokeDasharray: "5 5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "M236.663 66.223v116.211c0 3.028-1.202 5.932-3.341 8.073a11.403 11.403 0 0 1-8.067 3.345H105.828a11.402 11.402 0 0 1-8.068-3.345 11.42 11.42 0 0 1-3.341-8.073V23.384a10.33 10.33 0 0 1 3.029-7.307 10.313 10.313 0 0 1 7.307-3.015h80.82"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#BECDFA",
        stroke: "#3A36DB",
        strokeDasharray: "5 5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "M186.719 13.701v37.533c0 4.332-.215 7.97 2.841 11.034 3.057 3.063 7.516 3.955 11.839 3.955h35.515l-50.195-52.522Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#3A36DB",
        strokeLinecap: "round",
        strokeMiterlimit: "10",
        strokeWidth: "3",
        d: "M165.336 86.775v50.855m-25.783-25.416h51.157"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#3A36DB",
        strokeMiterlimit: "10",
        strokeWidth: "2",
        d: "M203.441 344.201h-74.225v-58.002h74.225v58.002Zm-49.788 0v-58.002m25.442 58.002v-58.002m-49.879 20.953h74.225m-74.225 18.712h74.225"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#3A36DB",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "m153.653 236.386 11.865-12.537 12.185 12.537"
      }
    )
  ] }) : /* @__PURE__ */ jsxs("svg", { width: 328, height: 412, fill: "none", viewBox: "0 0 328 412", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#28313F",
        d: "M284.487 127.126h-8.876a21.346 21.346 0 0 1-15.102-6.261 21.384 21.384 0 0 1-6.256-15.114 21.382 21.382 0 0 1 5.971-14.815 21.346 21.346 0 0 1 14.565-6.536h6.709a22.968 22.968 0 0 0 15.777-6.982 23.007 23.007 0 0 0 0-32.004 22.968 22.968 0 0 0-15.777-6.982H46.203a22.97 22.97 0 0 0-15.777 6.982 23.005 23.005 0 0 0 0 32.004A22.97 22.97 0 0 0 46.203 84.4h2.282a21.35 21.35 0 0 1 14.566 6.536 21.382 21.382 0 0 1 5.97 14.815 21.38 21.38 0 0 1-6.256 15.114 21.347 21.347 0 0 1-15.102 6.261H39.77a18.246 18.246 0 0 0-12.908 5.35 18.277 18.277 0 0 0 0 25.836 18.247 18.247 0 0 0 12.908 5.351h244.718c4.841 0 9.484-1.925 12.907-5.351a18.274 18.274 0 0 0 0-25.836 18.245 18.245 0 0 0-12.907-5.35Zm-63.338 154.173-58.266-33.718c-5.65-3.27-12.881-1.336-16.149 4.32L92.847 345.13c-3.269 5.656-1.338 12.891 4.313 16.161l58.265 33.718c5.65 3.27 12.881 1.336 16.15-4.32l53.886-93.229c3.269-5.655 1.338-12.891-4.312-16.161Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#605CFF",
        stroke: "#605CFF",
        strokeMiterlimit: "10",
        strokeWidth: "2",
        d: "M120.657 257.357h74.157l20.901 22.082v100.934a8.316 8.316 0 0 1-5.143 7.686 8.31 8.31 0 0 1-3.186.626H120.68a8.312 8.312 0 0 1-8.306-8.312V265.67c0-2.201.872-4.312 2.425-5.87a8.301 8.301 0 0 1 5.858-2.443Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#4541C9",
        stroke: "#4541C9",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "M194.814 257.357v14.387c0 2.204.876 4.319 2.433 5.877a8.302 8.302 0 0 0 5.873 2.435h12.595l-20.901-22.699Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#1A202C",
        d: "M183.496 409.671a261.315 261.315 0 0 0 3.834-36.103c0-6.668-3.217-10.505-6.047-10.505h-2.647a1.94 1.94 0 0 0-1.939 1.941v-.753a3.365 3.365 0 0 0-.95-2.433 3.345 3.345 0 0 0-2.404-1.015h-2.282a3.422 3.422 0 0 0-3.423 3.425v1.462a3.583 3.583 0 0 0-3.582-3.586h-2.282a3.773 3.773 0 0 0-2.662 1.104 3.76 3.76 0 0 0-1.103 2.664v.914a2.532 2.532 0 0 0-2.441-2.444h-3.149a3.357 3.357 0 0 0-3.354 3.311v3.7h-3.126a5.391 5.391 0 0 0-3.824 1.594 5.394 5.394 0 0 0-1.561 3.841v10.184a19.055 19.055 0 0 0 4.7 11.418 15.473 15.473 0 0 1 2.145 2.763 26.3 26.3 0 0 1 2.898 9.774h32.948l.251-1.256Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#605CFF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "M176.697 365.004a1.94 1.94 0 0 1 1.939-1.941h2.647c2.83 0 6.047 3.837 6.047 10.505a261.315 261.315 0 0 1-3.834 36.103l-.25 1.256h-32.949a26.3 26.3 0 0 0-2.898-9.774 15.473 15.473 0 0 0-2.145-2.763 19.055 19.055 0 0 1-4.7-11.418v-10.184a5.393 5.393 0 0 1 3.314-5.021 5.391 5.391 0 0 1 2.071-.414h3.126m27.632-6.349v-.753a3.365 3.365 0 0 0-.95-2.433 3.345 3.345 0 0 0-2.404-1.015h-2.282a3.422 3.422 0 0 0-3.423 3.425v1.462m9.059-.686v9.707m-9.059-9.021a3.583 3.583 0 0 0-3.582-3.586h-2.282a3.773 3.773 0 0 0-2.662 1.104 3.76 3.76 0 0 0-1.103 2.664v.914m9.629-1.096v8.814m-9.629-7.718a2.532 2.532 0 0 0-2.441-2.444h-3.149a3.357 3.357 0 0 0-3.354 3.311v3.7m8.944-4.567v8.86m-8.944-4.293v12.285"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#28313F",
        d: "M234.996.57H73.812c-5.418 0-9.811 4.392-9.811 9.809 0 5.416 4.393 9.808 9.811 9.808h161.184c5.418 0 9.811-4.392 9.811-9.808 0-5.417-4.393-9.808-9.811-9.808Zm20.193 175.058H91.109c-8.935 0-16.178 7.244-16.178 16.179 0 8.936 7.243 16.179 16.177 16.179H255.19c8.935 0 16.178-7.243 16.178-16.179 0-8.935-7.243-16.179-16.178-16.179Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#364153",
        d: "M235.178 66.223v116.211c0 3.028-1.202 5.932-3.341 8.073a11.404 11.404 0 0 1-8.068 3.345H104.342a11.403 11.403 0 0 1-8.067-3.345 11.421 11.421 0 0 1-3.341-8.073V23.384a10.33 10.33 0 0 1 3.028-7.307 10.311 10.311 0 0 1 7.308-3.015h80.82"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#605CFF",
        strokeDasharray: "5 5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "M235.178 66.223v116.211c0 3.028-1.202 5.932-3.341 8.073a11.404 11.404 0 0 1-8.068 3.345H104.342a11.403 11.403 0 0 1-8.067-3.345 11.421 11.421 0 0 1-3.341-8.073V23.384a10.33 10.33 0 0 1 3.028-7.307 10.311 10.311 0 0 1 7.308-3.015h80.82"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#1A202C",
        stroke: "#605CFF",
        strokeDasharray: "5 5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "M185.234 13.701v37.533c0 4.332-.215 7.97 2.841 11.034 3.056 3.063 7.516 3.955 11.838 3.955h35.516l-50.195-52.522Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#605CFF",
        strokeLinecap: "round",
        strokeMiterlimit: "10",
        strokeWidth: "3",
        d: "M163.851 86.775v50.855m-25.784-25.416h51.157"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#364153",
        strokeMiterlimit: "10",
        strokeWidth: "2",
        d: "M201.956 344.201H127.73v-58.002h74.226v58.002Zm-49.788 0v-58.002m25.441 58.002v-58.002m-49.879 20.953h74.226m-74.226 18.712h74.226"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#605CFF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "m152.168 236.386 11.865-12.537 12.185 12.537"
      }
    )
  ] });
}, Upload2 = () => {
  const { theme: t } = useContext(ConfigContext);
  return t === "light" ? /* @__PURE__ */ jsxs("svg", { width: 467, height: 263, fill: "none", viewBox: "0 0 384 221", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#D2DFFA",
        d: "m240.009 29.375-50.47-27.54c-4.894-2.67-11.026-.864-13.696 4.035l-44.009 80.755c-2.67 4.899-.867 11.035 4.028 13.706l50.47 27.539c4.895 2.671 11.027.864 13.696-4.034l44.01-80.755c2.669-4.9.866-11.035-4.029-13.706Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#3A36DB",
        d: "m160.411 17.293-53.94 19.905c-5.231 1.93-7.903 7.738-5.969 12.97l31.886 86.265c1.934 5.233 7.743 7.91 12.973 5.98l53.94-19.906c5.23-1.93 7.903-7.737 5.969-12.97l-31.886-86.264c-1.934-5.233-7.743-7.91-12.973-5.98Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#D2DFFA",
        d: "M74.132 43.098 33.767 55.044a7.39 7.39 0 0 0-4.985 9.188l19.143 64.557a7.398 7.398 0 0 0 9.19 4.993l40.364-11.946a7.389 7.389 0 0 0 4.986-9.188L83.322 48.091a7.398 7.398 0 0 0-9.19-4.993Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#F1F4FA",
        stroke: "#3A36DB",
        strokeMiterlimit: "10",
        strokeWidth: "2",
        d: "m5.626 73.844 41.416-19.381 17.444 6.87 26.379 56.37a5.13 5.13 0 0 1-.864 5.637 5.114 5.114 0 0 1-1.615 1.182l-48.425 22.661a5.124 5.124 0 0 1-6.811-2.472L3.172 80.651a5.128 5.128 0 0 1 2.454-6.807Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#F1F4FA",
        stroke: "#3A36DB",
        strokeMiterlimit: "10",
        strokeWidth: "2",
        d: "m73.728 101.098-41.455 19.398-15.159-32.393 11.98-5.606 29.475-13.793 15.159 32.394Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#3A36DB",
        strokeMiterlimit: "10",
        strokeWidth: "2",
        d: "m45.922 114.11-15.16-32.394m29.368 25.745L44.97 75.067M22.59 99.805l41.455-19.399M27.48 110.255l41.455-19.398"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#D2DFFA",
        stroke: "#3A36DB",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "m47.042 54.462 3.76 8.035a5.127 5.127 0 0 0 6.81 2.472l7.035-3.292-17.605-7.215Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#F1F4FA",
        d: "m382.459 79.96-22.933 56.596a5.992 5.992 0 0 1-7.809 3.309l-58.162-23.567a6.001 6.001 0 0 1-3.303-7.812l31.387-77.46a5.422 5.422 0 0 1 7.071-2.986l39.36 15.949"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#3A36DB",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "m382.459 79.96-22.933 56.596a5.992 5.992 0 0 1-7.809 3.309l-58.162-23.567a6.001 6.001 0 0 1-3.303-7.812l31.387-77.46a5.422 5.422 0 0 1 7.071-2.986l39.36 15.949"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#D2DFFA",
        stroke: "#3A36DB",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "m368.502 44.526-7.407 18.279c-.855 2.11-1.678 3.839-.794 5.934.884 2.095 2.88 3.41 4.985 4.262l17.297 7.009-14.081-35.484Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#3A36DB",
        strokeLinecap: "round",
        strokeMiterlimit: "10",
        strokeWidth: "3",
        d: "M343.666 75.894 333.63 100.66m-7.54-17.465 24.914 10.095"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#BECDFA",
        d: "M1 172.523c0 24.503 18.96 44.536 43.042 46.33v.118h263.316c30.177 0 54.642-24.445 54.642-54.597 0-28.445-21.756-51.831-49.548-54.361C310.891 60.594 270.293 21 220.45 21c-39.686 0-73.513 25.092-86.437 60.244-7.361-3.706-15.633-5.765-24.436-5.765-29.058 0-52.816 22.62-54.553 51.213a45.53 45.53 0 0 0-7.567-.618c-25.672 0-46.486 20.798-46.486 46.449H1Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#F1F4FA", d: "M227.913 165.715H136l45.956 53.919 45.957-53.919Z" }),
    /* @__PURE__ */ jsx("path", { fill: "#F1F4FA", d: "M201.913 168h-38v-57h38z" })
  ] }) : /* @__PURE__ */ jsxs("svg", { width: 467, height: 263, viewBox: "0 0 467 263", fill: "none", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M287.009 44.3749L236.539 16.8357C231.645 14.165 225.513 15.9713 222.843 20.87L178.834 101.625C176.164 106.524 177.967 112.66 182.862 115.331L233.332 142.87C238.227 145.541 244.359 143.734 247.028 138.836L291.038 58.0806C293.707 53.1819 291.904 47.0456 287.009 44.3749Z",
        fill: "#605CFF",
        fillOpacity: "0.4"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M207.411 32.293L153.471 52.1983C148.24 54.1286 145.568 59.9357 147.502 65.1686L179.388 151.433C181.322 156.666 187.131 159.343 192.361 157.413L246.301 137.507C251.531 135.577 254.204 129.77 252.27 124.537L220.384 38.2729C218.45 33.0399 212.641 30.3626 207.411 32.293Z",
        fill: "#28313F"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M121.132 58.0976L80.7674 70.0434C76.853 71.2019 74.621 75.3157 75.7823 79.2319L94.9245 143.789C96.0858 147.705 100.2 149.941 104.115 148.782L144.479 136.836C148.394 135.678 150.626 131.564 149.465 127.648L130.322 63.0909C129.161 59.1747 125.046 56.9391 121.132 58.0976Z",
        fill: "#28313F"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M52.6259 88.8436L94.042 69.4626L111.486 76.3328L137.865 132.703C138.151 133.314 138.313 133.975 138.343 134.649C138.373 135.322 138.27 135.995 138.04 136.628C137.81 137.262 137.457 137.843 137.001 138.34C136.546 138.837 135.997 139.238 135.386 139.522L86.9611 162.183C85.7309 162.759 84.3221 162.822 83.0448 162.358C81.7675 161.895 80.7263 160.943 80.1501 159.711L50.1724 95.6505C49.5973 94.4215 49.5326 93.0148 49.9925 91.7388C50.4524 90.4628 51.3994 89.4216 52.6259 88.8436Z",
        fill: "#28313F",
        stroke: "#605CFF",
        strokeWidth: "2",
        strokeMiterlimit: "10"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M120.728 116.098L79.2732 135.496L64.1143 103.103L76.0931 97.4969L105.569 83.7037L120.728 116.098Z",
        fill: "#28313F",
        stroke: "#605CFF",
        strokeWidth: "2",
        strokeMiterlimit: "10"
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M92.9216 129.11L77.7627 96.7158", stroke: "#605CFF", strokeWidth: "2", strokeMiterlimit: "10" }),
    /* @__PURE__ */ jsx("path", { d: "M107.13 122.461L91.9707 90.0667", stroke: "#605CFF", strokeWidth: "2", strokeMiterlimit: "10" }),
    /* @__PURE__ */ jsx("path", { d: "M69.5908 114.805L111.045 95.4061", stroke: "#605CFF", strokeWidth: "2", strokeMiterlimit: "10" }),
    /* @__PURE__ */ jsx("path", { d: "M74.4805 125.255L115.935 105.857", stroke: "#605CFF", strokeWidth: "2", strokeMiterlimit: "10" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M94.042 69.4624L97.8019 77.4971C98.378 78.7284 99.4193 79.6804 100.697 80.144C101.974 80.6075 103.383 80.5445 104.613 79.9688L111.647 76.677L94.042 69.4624Z",
        fill: "#605CFF",
        fillOpacity: "0.4",
        stroke: "#605CFF",
        strokeWidth: "2",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M429.459 94.9604L406.526 151.556C405.929 153.031 404.77 154.208 403.306 154.829C401.841 155.449 400.191 155.463 398.717 154.865L340.555 131.298C339.081 130.701 337.905 129.542 337.286 128.077C336.667 126.612 336.654 124.96 337.252 123.486L368.639 46.0268C368.907 45.3657 369.302 44.7639 369.803 44.2559C370.303 43.7479 370.899 43.3435 371.556 43.0661C372.213 42.7886 372.918 42.6435 373.63 42.639C374.343 42.6345 375.05 42.7707 375.71 43.0398L415.07 58.9888",
        fill: "#28313F"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M429.459 94.9604L406.526 151.556C405.929 153.031 404.77 154.208 403.306 154.829C401.841 155.449 400.191 155.463 398.717 154.865L340.555 131.298C339.081 130.701 337.905 129.542 337.286 128.077C336.667 126.612 336.654 124.96 337.252 123.486L368.639 46.0268C368.907 45.3657 369.302 44.7639 369.803 44.2559C370.303 43.7479 370.899 43.3435 371.556 43.0661C372.213 42.7886 372.918 42.6435 373.63 42.639C374.343 42.6345 375.05 42.7707 375.71 43.0398L415.07 58.9888",
        stroke: "#605CFF",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M415.502 59.5258L408.095 77.8049C407.24 79.9146 406.417 81.6441 407.301 83.7391C408.185 85.8341 410.181 87.1484 412.286 88.0014L429.583 95.0101L415.502 59.5258Z",
        fill: "#605CFF",
        fillOpacity: "0.4",
        stroke: "#605CFF",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M390.666 90.8939L380.63 115.661",
        stroke: "#605CFF",
        strokeWidth: "3",
        strokeMiterlimit: "10",
        strokeLinecap: "round"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M373.09 98.1949L398.004 108.29",
        stroke: "#605CFF",
        strokeWidth: "3",
        strokeMiterlimit: "10",
        strokeLinecap: "round"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M48.0001 189.523C48.0001 214.026 66.9599 234.059 91.0422 235.853V235.971H354.358C384.535 235.971 409 211.526 409 181.374C409 152.929 387.244 129.543 359.452 127.013C357.891 77.5941 317.293 38 267.45 38C227.764 38 193.937 63.092 181.013 98.2442C173.652 94.5378 165.38 92.4787 156.577 92.4787C127.519 92.4787 103.761 115.1 102.024 143.692C99.58 143.28 97.0481 143.074 94.4573 143.074C68.7852 143.074 47.9707 163.872 47.9707 189.523H48.0001Z",
        fill: "#4541C9"
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M274.914 182.714L183.001 182.714L228.957 236.634L274.914 182.714Z", fill: "#364153" }),
    /* @__PURE__ */ jsx("rect", { x: "248.914", y: "185", width: "38", height: "57", transform: "rotate(-180 248.914 185)", fill: "#364153" })
  ] });
}, Import = () => {
  const { theme: t } = useContext(ConfigContext);
  return t === "light" ? /* @__PURE__ */ jsxs("svg", { width: 467, height: 263, fill: "none", viewBox: "0 0 361 220", children: [
    /* @__PURE__ */ jsx("path", { fill: "#BECDFA", d: "M171.39 189.939h37.22v15.27h-37.22z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#BECDFA",
        d: "M75 58.664a8 8 0 0 1 8-8h214a8 8 0 0 1 8 8V182.41a8 8 0 0 1-8 8H83a8 8 0 0 1-8-8V58.664Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "rect",
      {
        width: "210.821",
        height: "120.157",
        x: "84.804",
        y: "60.192",
        fill: "#BECDFA",
        stroke: "#fff",
        strokeWidth: "2",
        rx: "4"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#BECDFA", d: "M138.941 205.209h102.116v14.315H138.941z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#F1F4FA",
        d: "m276.474 53.866-25.196 51.493a5.63 5.63 0 0 1-7.531 2.586l-52.918-25.893a5.636 5.636 0 0 1-2.58-7.533l34.484-70.475a5.092 5.092 0 0 1 6.818-2.332l35.811 17.522"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#3A36DB",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "m276.474 53.866-25.196 51.493a5.63 5.63 0 0 1-7.531 2.586l-52.918-25.893a5.621 5.621 0 0 1-2.849-3.23 5.636 5.636 0 0 1 .269-4.303l34.484-70.475a5.092 5.092 0 0 1 6.818-2.332l35.811 17.522"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#605CFF",
        fillOpacity: ".4",
        stroke: "#3A36DB",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "m265.732 19.766-8.138 16.63c-.939 1.92-1.823 3.486-1.133 5.506s2.473 3.382 4.388 4.319l15.737 7.7-10.854-34.155Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#D2DFFA",
        d: "m136.626 25.308-29.263 26.557a6.937 6.937 0 0 0-.47 9.803l42.507 46.787a6.946 6.946 0 0 0 9.807.476l29.263-26.558a6.937 6.937 0 0 0 .47-9.802l-42.506-46.788a6.946 6.946 0 0 0-9.808-.475Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#D2DFFA",
        stroke: "#3A36DB",
        strokeMiterlimit: "10",
        strokeWidth: "2",
        d: "m129.973 36.319 37.612-20.69 16.762 5.368 28.16 51.193a4.818 4.818 0 0 1-.464 5.333 4.801 4.801 0 0 1-1.441 1.206l-43.976 24.192a4.809 4.809 0 0 1-6.532-1.899l-32.002-58.177a4.812 4.812 0 0 1 1.881-6.526Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#D2DFFA",
        stroke: "#3A36DB",
        strokeMiterlimit: "10",
        strokeWidth: "2",
        d: "m195.436 57.682-37.647 20.71-16.183-29.42 10.879-5.983 26.768-14.725 16.183 29.418Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#3A36DB",
        strokeMiterlimit: "10",
        strokeWidth: "2",
        d: "m170.185 71.573-16.183-29.418m29.085 22.32-16.183-29.418M147.454 59.6l37.647-20.709m-32.426 30.2 37.646-20.709"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#605CFF",
        fillOpacity: ".4",
        stroke: "#3A36DB",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "m167.586 15.628 4.014 7.297a4.806 4.806 0 0 0 6.531 1.899l6.389-3.514-16.934-5.682Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M213 133h-47l23.5 27 23.5-27Z" }),
    /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M199 134h-18v-23h18zm14 34h-46v-3h46z" })
  ] }) : /* @__PURE__ */ jsxs("svg", { width: 467, height: 263, fill: "none", viewBox: "0 0 467 263", children: [
    /* @__PURE__ */ jsx("path", { fill: "#364153", d: "M183 185.92h91.913L228.957 132 183 185.92Z" }),
    /* @__PURE__ */ jsx("path", { fill: "#364153", d: "M209 183.634h38v57h-38z" }),
    /* @__PURE__ */ jsx("path", { fill: "#28313F", d: "M221.676 209.891h39.647v16.266h-39.647z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#4541C9",
        d: "M119 69.532a8 8 0 0 1 8-8h229a8 8 0 0 1 8 8v132.86a8 8 0 0 1-8 8H127a8 8 0 0 1-8-8V69.532Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "rect",
      {
        width: "224.701",
        height: "128.124",
        x: "129.378",
        y: "71.617",
        fill: "#4541C9",
        stroke: "#364153",
        strokeWidth: "2",
        rx: "4"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#4541C9", d: "M187.111 226.156h108.776v15.249H187.111z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#28313F",
        d: "m333.616 64.943-26.839 54.852a5.994 5.994 0 0 1-8.022 2.754l-56.369-27.582a5.993 5.993 0 0 1-2.748-8.023l36.732-75.072a5.434 5.434 0 0 1 3.117-2.75 5.422 5.422 0 0 1 4.146.265l38.147 18.665"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#605CFF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "m333.616 64.943-26.839 54.852a5.994 5.994 0 0 1-8.022 2.754l-56.369-27.582a5.993 5.993 0 0 1-2.748-8.023l36.732-75.072a5.434 5.434 0 0 1 3.117-2.75 5.422 5.422 0 0 1 4.146.265l38.147 18.665"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#605CFF",
        fillOpacity: ".4",
        stroke: "#605CFF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "m322.171 28.618-8.668 17.716c-1 2.045-1.942 3.712-1.207 5.864.735 2.152 2.634 3.603 4.674 4.601l16.764 8.202-11.563-36.383Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#28313F",
        d: "m184.645 34.522-31.171 28.29a7.39 7.39 0 0 0-.501 10.442l45.279 49.839a7.398 7.398 0 0 0 10.447.506l31.171-28.29a7.39 7.39 0 0 0 .501-10.441l-45.279-49.839a7.399 7.399 0 0 0-10.447-.507Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#28313F",
        stroke: "#605CFF",
        strokeMiterlimit: "10",
        strokeWidth: "2",
        d: "m177.558 46.251 40.065-22.04 17.855 5.72 29.997 54.53a5.13 5.13 0 0 1-.495 5.681 5.108 5.108 0 0 1-1.535 1.285l-46.844 25.77a5.125 5.125 0 0 1-6.958-2.023l-34.09-61.97a5.126 5.126 0 0 1 2.005-6.953Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#28313F",
        stroke: "#605CFF",
        strokeMiterlimit: "10",
        strokeWidth: "2",
        d: "m247.291 69.008-40.102 22.06-17.238-31.337 11.588-6.375 28.514-15.685 17.238 31.337Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#605CFF",
        strokeMiterlimit: "10",
        strokeWidth: "2",
        d: "m220.392 83.805-17.238-31.337m30.983 23.776-17.239-31.337m-20.719 26.144 40.101-22.06M201.739 81.16l40.102-22.059"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#605CFF",
        fillOpacity: ".4",
        stroke: "#605CFF",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "m217.623 24.212 4.276 7.772a5.126 5.126 0 0 0 6.957 2.023l6.805-3.744-18.038-6.051Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#28313F", d: "M266 149h-49l24.5 29 24.5-29Z" }),
    /* @__PURE__ */ jsx("path", { fill: "#28313F", d: "M251 150h-19v-24h19zm15 37h-48v-4h48z" })
  ] });
}, AddPhoto = () => {
  const { theme: t } = useContext(ConfigContext);
  return t === "light" ? /* @__PURE__ */ jsxs("svg", { height: 263, width: 467, fill: "none", viewBox: "0 0 467 263", children: [
    /* @__PURE__ */ jsx("rect", { width: "157.591", height: "157.591", x: "95", y: "59", fill: "#6562F5", rx: "16", transform: "rotate(-15.21 95 59)" }),
    /* @__PURE__ */ jsx(
      "rect",
      {
        width: "135.201",
        height: "135.201",
        x: "108.739",
        y: "66.866",
        fill: "#D2DFFA",
        rx: "8",
        transform: "rotate(-15.21 108.739 66.866)"
      }
    ),
    /* @__PURE__ */ jsx(
      "rect",
      {
        width: "157.591",
        height: "157.591",
        x: "226.215",
        y: "8",
        fill: "#6562F5",
        rx: "16",
        transform: "rotate(22.07 226.215 8)"
      }
    ),
    /* @__PURE__ */ jsx(
      "rect",
      {
        width: "135.201",
        height: "135.201",
        x: "232.383",
        y: "22.581",
        fill: "#D2DFFA",
        rx: "8",
        transform: "rotate(22.07 232.383 22.581)"
      }
    ),
    /* @__PURE__ */ jsx("rect", { width: "157.591", height: "157.591", x: "150.696", y: "57.871", fill: "#6562F5", rx: "16" }),
    /* @__PURE__ */ jsx("rect", { width: "135.201", height: "135.201", x: "161.892", y: "69.066", fill: "#D2DFFA", rx: "8" }),
    /* @__PURE__ */ jsx("mask", { id: "a", width: "137", height: "136", x: "161", y: "69", maskUnits: "userSpaceOnUse", children: /* @__PURE__ */ jsx("rect", { width: "135.201", height: "135.201", x: "161.892", y: "69.066", fill: "#28313F", rx: "8" }) }),
    /* @__PURE__ */ jsxs("g", { mask: "url(#a)", children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#3A36DB",
          fillOpacity: ".2",
          d: "m266.868 142.696-23.167 33.192v29.671l71.906 5.597 13.348-25.834-29.203-42.505c-7.911-11.514-24.889-11.576-32.884-.121Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#6562F5",
          d: "m206.566 124.247-47.689 67.533v15.071h137.784l-57.335-82.483c-7.921-11.394-24.755-11.457-32.76-.121Z"
        }
      ),
      /* @__PURE__ */ jsx("circle", { cx: "260.924", cy: "96.623", r: "18.084", fill: "#6562F5" })
    ] }),
    /* @__PURE__ */ jsx("circle", { cx: "229.921", cy: "201.684", r: "37.891", fill: "#BECDFA" }),
    /* @__PURE__ */ jsx("rect", { width: "6.889", height: "43.057", x: "226.476", y: "180.155", fill: "#6562F5", rx: "3.445" }),
    /* @__PURE__ */ jsx(
      "rect",
      {
        width: "6.889",
        height: "43.057",
        x: "208.392",
        y: "205.128",
        fill: "#6562F5",
        rx: "3.445",
        transform: "rotate(-90 208.392 205.128)"
      }
    )
  ] }) : /* @__PURE__ */ jsxs("svg", { height: 263, width: 467, fill: "none", viewBox: "0 0 278 232", children: [
    /* @__PURE__ */ jsx("rect", { width: "157.591", height: "157.591", y: "51", fill: "#605CFF", rx: "16", transform: "rotate(-15.21 0 51)" }),
    /* @__PURE__ */ jsx(
      "rect",
      {
        width: "135.201",
        height: "135.201",
        x: "13.739",
        y: "58.866",
        fill: "#28313F",
        rx: "8",
        transform: "rotate(-15.21 13.74 58.866)"
      }
    ),
    /* @__PURE__ */ jsx("rect", { width: "157.591", height: "157.591", x: "131.215", fill: "#605CFF", rx: "16", transform: "rotate(22.07 131.215 0)" }),
    /* @__PURE__ */ jsx(
      "rect",
      {
        width: "135.201",
        height: "135.201",
        x: "137.383",
        y: "14.581",
        fill: "#28313F",
        rx: "8",
        transform: "rotate(22.07 137.383 14.581)"
      }
    ),
    /* @__PURE__ */ jsx("rect", { width: "157.591", height: "157.591", x: "55.696", y: "49.871", fill: "#605CFF", rx: "16" }),
    /* @__PURE__ */ jsx("rect", { width: "135.201", height: "135.201", x: "66.892", y: "61.066", fill: "#28313F", rx: "8" }),
    /* @__PURE__ */ jsx("mask", { id: "a", width: "137", height: "136", x: "66", y: "61", maskUnits: "userSpaceOnUse", children: /* @__PURE__ */ jsx("rect", { width: "135.201", height: "135.201", x: "66.892", y: "61.066", fill: "#28313F", rx: "8" }) }),
    /* @__PURE__ */ jsxs("g", { fill: "#605CFF", mask: "url(#a)", children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillOpacity: ".4",
          d: "m171.868 134.696-23.167 33.192v29.671l71.906 5.597 13.348-25.834-29.203-42.505c-7.911-11.514-24.889-11.576-32.884-.121Z"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M111.566 116.247 63.877 183.78v15.071h137.784l-57.335-82.483c-7.921-11.394-24.755-11.457-32.76-.121Z" }),
      /* @__PURE__ */ jsx("circle", { cx: "165.924", cy: "88.623", r: "18.084" })
    ] }),
    /* @__PURE__ */ jsx("circle", { cx: "134.921", cy: "193.684", r: "37.891", fill: "#1A202C" }),
    /* @__PURE__ */ jsx("rect", { width: "6.889", height: "43.057", x: "131.476", y: "172.155", fill: "#605CFF", rx: "3.445" }),
    /* @__PURE__ */ jsx(
      "rect",
      {
        width: "6.889",
        height: "43.057",
        x: "113.392",
        y: "197.128",
        fill: "#605CFF",
        rx: "3.445",
        transform: "rotate(-90 113.392 197.128)"
      }
    )
  ] });
}, NoResult = () => {
  const { theme: t } = useContext(ConfigContext);
  return t === "light" ? /* @__PURE__ */ jsxs("svg", { height: 263, width: 467, fill: "none", viewBox: "0 0 262 252", children: [
    /* @__PURE__ */ jsx("circle", { cx: "126", cy: "126", r: "126", fill: "#D2DFFA" }),
    /* @__PURE__ */ jsx("path", { fill: "#3A36DB", d: "M129.5 72H227v119c0 11.046-8.954 20-20 20H80.5c-11.046 0-20-8.954-20-20V61h61l8 11Z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#7471FF",
        d: "M111 95c0 23.372-17.43 42.672-40 45.612.5 4.388 1 6.888 6 10.888-27.5 0-58-22-58-56.5 0-25.405 20.595-46 46-46s46 20.595 46 46Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#6562F5", d: "M95 93.5h167V191c0 11.046-8.954 20-20 20H78c9.389 0 17-7.611 17-17V93.5Z" }),
    /* @__PURE__ */ jsx("circle", { cx: "206", cy: "154", r: "8", fill: "#28313F" }),
    /* @__PURE__ */ jsx("circle", { cx: "151", cy: "154", r: "8", fill: "#28313F" }),
    /* @__PURE__ */ jsx("path", { fill: "#28313F", d: "M171 187a4 4 0 0 1 4-4h7a4 4 0 0 1 4 4h-15Z" })
  ] }) : /* @__PURE__ */ jsxs("svg", { height: 263, width: 467, fill: "none", viewBox: "0 0 262 252", children: [
    /* @__PURE__ */ jsx("circle", { cx: "126", cy: "126", r: "126", fill: "#28313F" }),
    /* @__PURE__ */ jsx("path", { fill: "#4541C9", d: "M129.5 72H227v119c0 11.046-8.954 20-20 20H80.5c-11.046 0-20-8.954-20-20V61h61l8 11Z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#7471FF",
        d: "M111 95c0 23.372-17.43 42.672-40 45.612.5 4.388 1 6.888 6 10.888-27.5 0-58-22-58-56.5 0-25.405 20.595-46 46-46s46 20.595 46 46Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#605CFF", d: "M95 93.5h167V191c0 11.046-8.954 20-20 20H78c9.389 0 17-7.611 17-17V93.5Z" }),
    /* @__PURE__ */ jsx("circle", { cx: "206", cy: "154", r: "8", fill: "#28313F" }),
    /* @__PURE__ */ jsx("circle", { cx: "151", cy: "154", r: "8", fill: "#28313F" }),
    /* @__PURE__ */ jsx("path", { fill: "#28313F", d: "M171 187a4 4 0 0 1 4-4h7a4 4 0 0 1 4 4h-15Z" })
  ] });
}, Delete = () => {
  const { theme: t } = useContext(ConfigContext);
  return t === "light" ? /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#D2DFFA",
        d: "M57.81 43.462h-1.95a4.71 4.71 0 0 1-3.32-1.364 4.641 4.641 0 0 1-1.376-3.295 4.64 4.64 0 0 1 1.313-3.23 4.712 4.712 0 0 1 3.202-1.425h1.474a5.069 5.069 0 0 0 3.469-1.522 4.993 4.993 0 0 0 1.423-3.488c0-1.302-.51-2.553-1.423-3.489a5.069 5.069 0 0 0-3.469-1.521H5.427a5.07 5.07 0 0 0-3.468 1.521 4.993 4.993 0 0 0-1.424 3.489c0 1.302.51 2.553 1.424 3.488a5.07 5.07 0 0 0 3.468 1.522h.502a4.712 4.712 0 0 1 3.202 1.425 4.64 4.64 0 0 1 1.313 3.23c0 1.236-.495 2.42-1.376 3.295a4.713 4.713 0 0 1-3.32 1.364H4.013a4.03 4.03 0 0 0-2.838 1.167A3.968 3.968 0 0 0 0 47.445c0 1.056.423 2.07 1.175 2.816a4.028 4.028 0 0 0 2.838 1.166H57.81c1.065 0 2.085-.42 2.838-1.166a3.967 3.967 0 0 0 1.175-2.816c0-1.056-.422-2.07-1.175-2.816a4.029 4.029 0 0 0-2.838-1.166ZM19.027 58.873a4.964 4.964 0 0 1 4.964-4.964h27.3a4.964 4.964 0 0 1 0 9.928h-27.3a4.964 4.964 0 0 1-4.964-4.964ZM5.79 15.855a4.964 4.964 0 0 1 4.965-4.964h19.027a4.964 4.964 0 1 1 0 9.927H10.755a4.964 4.964 0 0 1-4.964-4.963Zm41.364 0a4.964 4.964 0 1 1 9.928 0 4.964 4.964 0 0 1-9.928 0ZM6.62 58.873a4.964 4.964 0 1 1 9.926 0 4.964 4.964 0 0 1-9.927 0Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#6562F5",
        d: "M42.522 62.09c0 1.422-5.418 2.574-12.101 2.574-6.684 0-12.102-1.152-12.102-2.574 0-.644-2.887-22.038-3.756-30.384h31.715s-3.756 28.963-3.756 30.384Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#3A36DB",
        d: "M46.278 31.706c0 1.421-7.1 2.573-15.858 2.573-8.758 0-15.858-1.152-15.858-2.573s7.1-2.573 15.858-2.573c8.758 0 15.858 1.152 15.858 2.573Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#3A36DB",
        fillRule: "evenodd",
        d: "M22.183 40.152a.948.948 0 0 1 1.043.844l2.017 19.092a.948.948 0 0 1-1.887.199L21.34 41.195a.948.948 0 0 1 .844-1.043Zm16.892 0a.948.948 0 0 0-1.043.844l-2.017 19.092a.948.948 0 0 0 1.886.199l2.017-19.092a.948.948 0 0 0-.843-1.043Zm-8.655-.388c.523 0 .947.425.947.949v19.996a.948.948 0 0 1-1.896 0V40.713c0-.524.424-.949.948-.949Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#EB5757",
        d: "M30.464 13.702a2 2 0 0 1 2.566-1.19l10.874 3.98a2 2 0 0 1 1.19 2.566L40.038 32.87a2 2 0 0 1-2.566 1.19l-10.874-3.98a2 2 0 0 1-1.19-2.566l5.056-13.813Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#974146",
        d: "m31.993 16.205 10.385 3.802-1.052 2.873-10.385-3.801 1.052-2.874Zm-1.435 3.919 4.963 1.817-.745 2.036-4.964-1.818.745-2.035Zm-1.144 2.909 4.964 1.817-.745 2.035-4.964-1.817.745-2.035Zm6.696-.877 4.833 1.77-.745 2.035-4.833-1.77.745-2.035Zm-1.145 2.909 4.833 1.77-.745 2.035-4.833-1.77.745-2.035Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#3A36DB",
        d: "M34.06 2.504c1.171.807-1.91 7.306-6.882 14.516-4.97 7.21-9.95 12.402-11.12 11.595-1.17-.807-1.492-1.038-1.492-1.038S30.964 3.293 32.51 1.461c.487.313.78.511 1.55 1.043Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#7471FF",
        d: "M32.53 1.46c1.17.807-1.912 7.307-6.883 14.517-4.971 7.21-9.95 12.401-11.12 11.595-1.17-.807 1.912-7.306 6.883-14.516S31.36.654 32.53 1.46Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#3A36DB",
        d: "M23.676 14.328c-1.078 1.495-2.126 2.743-3.621 1.665a3.338 3.338 0 1 1 3.904-5.417c1.496 1.078.795 2.256-.283 3.752Z"
      }
    )
  ] }) : /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 63 65", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#28313F",
        d: "M57.81 43.462h-1.95a4.71 4.71 0 0 1-3.32-1.364 4.642 4.642 0 0 1-1.376-3.295 4.64 4.64 0 0 1 1.313-3.23 4.711 4.711 0 0 1 3.202-1.425h1.474a5.069 5.069 0 0 0 3.469-1.522 4.993 4.993 0 0 0 1.423-3.488c0-1.302-.51-2.553-1.423-3.488a5.069 5.069 0 0 0-3.469-1.522H5.427A5.069 5.069 0 0 0 1.96 25.65a4.993 4.993 0 0 0-1.424 3.488c0 1.302.51 2.553 1.424 3.488a5.07 5.07 0 0 0 3.468 1.523h.502a4.711 4.711 0 0 1 3.202 1.424 4.64 4.64 0 0 1 1.313 3.23c0 1.236-.495 2.42-1.376 3.295a4.713 4.713 0 0 1-3.32 1.364H4.013a4.03 4.03 0 0 0-2.838 1.167A3.967 3.967 0 0 0 0 47.445c0 1.056.423 2.07 1.175 2.816a4.029 4.029 0 0 0 2.838 1.166H57.81c1.065 0 2.085-.42 2.838-1.166a3.968 3.968 0 0 0 1.175-2.816c0-1.056-.422-2.07-1.175-2.816a4.029 4.029 0 0 0-2.838-1.166Z"
      }
    ),
    /* @__PURE__ */ jsx("rect", { width: "37.227", height: "9.927", x: "19.027", y: "53.909", fill: "#28313F", rx: "4.964" }),
    /* @__PURE__ */ jsx("rect", { width: "28.954", height: "9.927", x: "5.791", y: "10.891", fill: "#28313F", rx: "4.964" }),
    /* @__PURE__ */ jsx("rect", { width: "9.927", height: "9.927", x: "47.154", y: "10.891", fill: "#28313F", rx: "4.964" }),
    /* @__PURE__ */ jsx("rect", { width: "9.927", height: "9.927", x: "6.619", y: "53.909", fill: "#28313F", rx: "4.964" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#605CFF",
        d: "M42.522 62.09c0 1.422-5.418 2.574-12.101 2.574-6.684 0-12.102-1.152-12.102-2.574 0-.644-2.887-22.038-3.756-30.384h31.715s-3.756 28.963-3.756 30.384Z"
      }
    ),
    /* @__PURE__ */ jsx("ellipse", { cx: "30.42", cy: "31.706", fill: "#4541C9", rx: "15.858", ry: "2.573" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#4541C9",
        fillRule: "evenodd",
        d: "M22.183 40.152a.948.948 0 0 1 1.043.844l2.017 19.092a.948.948 0 1 1-1.887.199L21.34 41.195a.948.948 0 0 1 .844-1.043Zm16.892 0a.948.948 0 0 0-1.043.844l-2.017 19.092a.948.948 0 1 0 1.886.199l2.017-19.092a.948.948 0 0 0-.843-1.043Zm-8.655-.388c.523 0 .947.425.947.949v19.996a.948.948 0 1 1-1.896 0V40.713c0-.524.424-.949.948-.949Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ jsx(
      "rect",
      {
        width: "15.579",
        height: "18.709",
        x: "31.15",
        y: "11.824",
        fill: "#EB5757",
        rx: "2",
        transform: "rotate(20.107 31.15 11.824)"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#1A202C",
        d: "m31.992 16.205 10.385 3.802-1.052 2.873-10.385-3.802zm-1.435 3.919 4.964 1.817-.746 2.036-4.963-1.817zm-1.145 2.909 4.964 1.817-.746 2.036-4.963-1.817zm6.695-.877 4.833 1.77-.745 2.035-4.833-1.77zm-1.144 2.909 4.833 1.77-.745 2.035-4.833-1.77z",
        opacity: ".4"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#4541C9",
        d: "M34.06 2.504c1.17.807-1.911 7.306-6.882 14.516-4.972 7.21-9.95 12.402-11.12 11.595-1.17-.807-1.493-1.038-1.493-1.038S30.963 3.293 32.509 1.461c.487.313.78.512 1.551 1.043Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "ellipse",
      {
        cx: "23.528",
        cy: "14.516",
        fill: "#605CFF",
        rx: "15.858",
        ry: "2.573",
        transform: "rotate(-55.416 23.528 14.516)"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#4541C9",
        d: "M23.675 14.328c-1.078 1.495-2.125 2.743-3.621 1.665a3.338 3.338 0 1 1 3.904-5.417c1.496 1.078.796 2.256-.283 3.752Z"
      }
    )
  ] });
}, Archive = () => {
  const { theme: t } = useContext(ConfigContext);
  return t === "light" ? /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#D2DFFA",
        d: "M64.748 42.635h-2.186c-1.394 0-2.732-.49-3.718-1.365-.986-.874-1.54-2.059-1.54-3.295 0-1.204.527-2.362 1.47-3.23.943-.867 2.228-1.378 3.586-1.424h1.652c1.469-.041 2.862-.587 3.884-1.522 1.023-.935 1.595-2.186 1.595-3.489 0-1.302-.572-2.553-1.595-3.488-1.022-.935-2.415-1.481-3.884-1.522H6.079c-1.47.041-2.862.587-3.885 1.522C1.171 25.757.6 27.008.6 28.31c0 1.303.571 2.554 1.594 3.489 1.023.935 2.416 1.48 3.885 1.522h.562c1.358.046 2.643.557 3.586 1.425.942.867 1.47 2.025 1.47 3.23 0 1.235-.554 2.42-1.54 3.294-.987.874-2.324 1.365-3.719 1.365H4.494c-1.192 0-2.335.42-3.178 1.166C.474 44.548 0 45.561 0 46.617c0 1.057.474 2.07 1.316 2.817.843.746 1.986 1.166 3.178 1.166h60.254c1.192 0 2.335-.42 3.178-1.166.843-.747 1.316-1.76 1.316-2.816 0-1.057-.473-2.07-1.316-2.817-.843-.746-1.986-1.166-3.178-1.166Zm-45.721 15.41a4.964 4.964 0 0 1 4.964-4.963H63.7a4.964 4.964 0 0 1 0 9.927H23.99a4.964 4.964 0 0 1-4.963-4.964ZM5.79 15.027a4.964 4.964 0 0 1 4.965-4.963h39.709a4.964 4.964 0 1 1 0 9.927h-39.71a4.964 4.964 0 0 1-4.963-4.964Zm52.946 0a4.964 4.964 0 1 1 9.928 0 4.964 4.964 0 0 1-9.928 0ZM3.309 58.046a4.964 4.964 0 1 1 9.927 0 4.964 4.964 0 0 1-9.927 0Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#EB5757",
        d: "M37.498 17.605a2 2 0 0 1 2.566-1.19l15.214 5.57a2 2 0 0 1 1.191 2.565l-6.965 19.026a2 2 0 0 1-2.566 1.19l-15.215-5.57a2 2 0 0 1-1.19-2.565l6.965-19.026Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#974146",
        d: "m39.275 21.408 13.466 4.93-1.364 3.726-13.466-4.93 1.364-3.726Zm-1.861 5.082 6.436 2.356-.966 2.64-6.437-2.356.967-2.64Zm-1.483 3.772 6.437 2.356-.966 2.64-6.437-2.356.966-2.64Zm8.684-1.137 6.267 2.295-.966 2.64-6.267-2.295.966-2.64Zm-1.485 3.773 6.268 2.294-.966 2.64-6.268-2.295.967-2.64Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#6562F5", d: "M10.8 57.49V37.87H53v19.62a8 8 0 0 1-8 8H18.8a8 8 0 0 1-8-8Z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#3A36DB",
        d: "M24.61 43.24a2.302 2.302 0 0 1 2.303-2.3h10.741a2.302 2.302 0 1 1 0 4.602H26.913a2.302 2.302 0 0 1-2.302-2.301Zm-3.068 11.208a2 2 0 0 1 2-2h16.716a2 2 0 0 1 2 2v5.207a2 2 0 0 1-2 2H23.542a2 2 0 0 1-2-2v-5.207Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#6562F5",
        d: "M27.681 57.051c0-.847.687-1.534 1.535-1.534h5.37a1.535 1.535 0 0 1 0 3.069h-5.37a1.534 1.534 0 0 1-1.535-1.535ZM3.603 37.984a4 4 0 0 1 .106-5.656l29.608-28.51a4 4 0 0 1 5.656.106L43.65 8.78 8.28 42.84l-4.676-4.856Z"
      }
    )
  ] }) : /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#28313F",
        d: "M64.748 42.635h-2.186c-1.394 0-2.732-.49-3.718-1.365-.986-.874-1.54-2.059-1.54-3.295 0-1.204.527-2.361 1.47-3.23.943-.867 2.228-1.378 3.586-1.424h1.652c1.469-.041 2.862-.587 3.884-1.522 1.023-.935 1.595-2.186 1.595-3.488 0-1.303-.572-2.554-1.595-3.489-1.022-.935-2.415-1.481-3.884-1.522H6.079c-1.47.041-2.862.587-3.885 1.522C1.171 25.757.6 27.008.6 28.311c0 1.302.571 2.553 1.594 3.488 1.023.935 2.416 1.48 3.885 1.522h.562c1.358.046 2.643.557 3.586 1.425.942.867 1.47 2.025 1.47 3.23 0 1.235-.554 2.42-1.54 3.294-.987.874-2.324 1.365-3.719 1.365H4.494c-1.192 0-2.335.42-3.178 1.166C.474 44.548 0 45.561 0 46.617c0 1.057.474 2.07 1.316 2.817.843.746 1.986 1.166 3.178 1.166h60.254c1.192 0 2.335-.42 3.178-1.166.843-.747 1.316-1.76 1.316-2.816 0-1.057-.473-2.07-1.316-2.817-.843-.746-1.986-1.166-3.178-1.166Z"
      }
    ),
    /* @__PURE__ */ jsx("rect", { width: "49.636", height: "9.927", x: "19.027", y: "53.082", fill: "#28313F", rx: "4.964" }),
    /* @__PURE__ */ jsx("rect", { width: "49.636", height: "9.927", x: "5.791", y: "10.064", fill: "#28313F", rx: "4.964" }),
    /* @__PURE__ */ jsx("rect", { width: "9.927", height: "9.927", x: "58.736", y: "10.064", fill: "#28313F", rx: "4.964" }),
    /* @__PURE__ */ jsx("rect", { width: "9.927", height: "9.927", x: "3.309", y: "53.082", fill: "#28313F", rx: "4.964" }),
    /* @__PURE__ */ jsx(
      "rect",
      {
        width: "20.202",
        height: "24.261",
        x: "38.185",
        y: "15.727",
        fill: "#EB5757",
        rx: "2",
        transform: "rotate(20.107 38.185 15.727)"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#1A202C",
        d: "m39.275 21.408 13.466 4.93-1.364 3.726-13.466-4.93zm-1.861 5.082 6.436 2.356-.966 2.64-6.436-2.356zm-1.482 3.772 6.436 2.356-.966 2.64-6.436-2.356zm8.683-1.137 6.267 2.294-.966 2.64-6.267-2.294zm-1.485 3.773 6.268 2.294-.966 2.64-6.268-2.294z",
        opacity: ".4"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#605CFF", d: "M10.8 57.49V37.87H53v19.62a8 8 0 0 1-8 8H18.8a8 8 0 0 1-8-8Z" }),
    /* @__PURE__ */ jsx("rect", { width: "15.345", height: "4.603", x: "24.611", y: "40.939", fill: "#4541C9", rx: "2.302" }),
    /* @__PURE__ */ jsx("rect", { width: "20.715", height: "9.207", x: "21.543", y: "52.448", fill: "#4541C9", rx: "2" }),
    /* @__PURE__ */ jsx("rect", { width: "8.44", height: "3.069", x: "27.682", y: "55.517", fill: "#605CFF", rx: "1.534" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#4541C9",
        d: "M3.603 37.984a4 4 0 0 1 .106-5.656l29.608-28.51a4 4 0 0 1 5.656.106L43.65 8.78 8.28 42.84l-4.676-4.856Z"
      }
    )
  ] });
}, Exclude = () => {
  const { theme: t } = useContext(ConfigContext);
  return t === "light" ? /* @__PURE__ */ jsxs("svg", { width: 92, height: 66, fill: "none", viewBox: "0 0 92 66", children: [
    /* @__PURE__ */ jsxs("g", { clipPath: "url(#a)", children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#D2DFFA",
          d: "M88.913 51.968C82.954 72.292 39.88 65.925 26.07 62.318 16.759 65.612 0 59.025 0 38.325c0-8.939 13.5-7.527 22.81-19.76C32.12 6.336 42.827-2.604 55.862.69c13.034 3.293 40.5 25.875 33.051 51.28Z"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#6562F5", d: "M12.408 55.5v-8.893h5.377v-8.893h-5.377V19.927h70.318V55.5H12.408Z" }),
      /* @__PURE__ */ jsx("path", { fill: "#6562F5", d: "M12.408 56.328V46.4h.827v9.927z" }),
      /* @__PURE__ */ jsx("path", { fill: "#3A36DB", d: "M28.127 38.127v-18.2h.827v18.2zm0 18.2V46.4h.827v9.927z" }),
      /* @__PURE__ */ jsx("path", { fill: "#6562F5", d: "M17.37 47.227V37.3h.828v9.927z" }),
      /* @__PURE__ */ jsx("path", { fill: "#3A36DB", d: "M82.726 56.327v-36.4h.827v36.4zM12.408 10h71.145v9.927H12.408z" }),
      /* @__PURE__ */ jsx("path", { fill: "#F1F4FA", stroke: "#3A36DB", d: "M16.871 37.627h70.491V46.9H16.871z" }),
      /* @__PURE__ */ jsx("path", { fill: "#3A36DB", d: "M33.918 47.227V37.3h.827v9.927z" }),
      /* @__PURE__ */ jsx("path", { fill: "#3A36DB", d: "M12.408 37.3h71.145v.827H12.408zm0 9.1h71.145v.827H12.408z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          stroke: "#EB5757",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".5",
          d: "M27.05 40.905s-6.722 2.682-5.36 3.025c1.362.343 8.2-2.908 10.283-2.993 2.092-.085-7.283 4.47-6.339 4.632.935.161 12.696-4.819 15.5-4.81 2.805.01-6.205 4.333-4.416 4.313 1.799-.021 10.078-4.236 13.096-4.312 3.028-.079-7.015 4.247-4.691 4.229 2.323-.019 11.645-4.623 13.568-4.37 1.923.253-9.57 4.008-6.526 4.317 3.045.308 10.826-4.027 14.556-4.245 3.73-.22-8.627 3.948-5.012 4.058 3.606.11 9.01-4.344 11.823-3.99 2.813.355-5.164 2.828-3.989 2.989 1.176.161 4.933-2.98 8.69-2.988 3.757-.01-4.46 2.827-3.526 3.17.935.343 4.71-.838 4.71-.838"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#3A36DB", d: "M12.408 55.5h71.145v.827H12.408zm0-27.3h71.145v.827H12.408z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#EB5757",
          fillRule: "evenodd",
          d: "M14.272 42.264a1.861 1.861 0 1 1-3.723 0 1.861 1.861 0 0 1 3.723 0Zm-3.043 1.18a.5.5 0 0 1 0-.707l.474-.473-.474-.474a.5.5 0 1 1 .708-.707l.473.474.474-.474a.5.5 0 1 1 .707.707l-.474.474.474.473a.5.5 0 1 1-.707.707l-.474-.473-.473.474a.5.5 0 0 1-.708 0Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#06152B",
          d: "m4.826 42.264.354-.354.353.354-.353.353-.354-.353Zm-3.447.5a.5.5 0 1 1 0-1v1Zm1.733-2.922L5.18 41.91l-.707.707-2.069-2.068.708-.707Zm2.068 2.775-2.068 2.069-.708-.708 2.069-2.068.707.707Zm-.354.147H1.38v-1h3.447v1Z"
        }
      ),
      /* @__PURE__ */ jsx("path", { stroke: "#06152B", d: "M6.895 39.85v4.827" })
    ] }),
    /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h92v66H0z" }) }) })
  ] }) : /* @__PURE__ */ jsxs("svg", { width: 92, height: 66, fill: "none", viewBox: "0 0 92 66", children: [
    /* @__PURE__ */ jsxs("g", { clipPath: "url(#a)", children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#28313F",
          d: "M88.913 51.968C82.954 72.292 39.88 65.925 26.07 62.318 16.759 65.612 0 59.025 0 38.325c0-8.939 13.5-7.527 22.81-19.76C32.12 6.336 42.827-2.604 55.862.69c13.034 3.293 40.5 25.875 33.051 51.28Z"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#605CFF", d: "M12.408 55.5v-8.893h5.377v-8.893h-5.377V19.927h70.318V55.5H12.408Z" }),
      /* @__PURE__ */ jsx("path", { fill: "#605CFF", d: "M12.408 56.328V46.4h.827v9.927z" }),
      /* @__PURE__ */ jsx("path", { fill: "#4541C9", d: "M28.127 38.127v-18.2h.827v18.2zm0 18.2V46.4h.827v9.927z" }),
      /* @__PURE__ */ jsx("path", { fill: "#605CFF", d: "M17.37 47.227V37.3h.828v9.927z" }),
      /* @__PURE__ */ jsx("path", { fill: "#4541C9", d: "M82.726 56.327v-36.4h.827v36.4zM12.408 10h71.145v9.927H12.408z" }),
      /* @__PURE__ */ jsx("path", { fill: "#1A202C", stroke: "#4541C9", d: "M16.871 37.627h70.491V46.9H16.871z" }),
      /* @__PURE__ */ jsx("path", { fill: "#4541C9", d: "M33.918 47.227V37.3h.827v9.927z" }),
      /* @__PURE__ */ jsx("path", { fill: "#4541C9", d: "M12.408 37.3h71.145v.827H12.408zm0 9.1h71.145v.827H12.408z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          stroke: "#EB5757",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".5",
          d: "M27.05 40.905s-6.722 2.682-5.36 3.025c1.362.343 8.2-2.908 10.283-2.993 2.092-.085-7.283 4.47-6.339 4.632.935.161 12.696-4.819 15.5-4.81 2.805.01-6.205 4.333-4.416 4.313 1.799-.021 10.078-4.236 13.096-4.312 3.028-.079-7.015 4.247-4.691 4.229 2.323-.019 11.645-4.623 13.568-4.37 1.923.253-9.57 4.008-6.526 4.317 3.045.308 10.826-4.027 14.556-4.245 3.73-.22-8.627 3.948-5.012 4.058 3.606.11 9.01-4.344 11.823-3.99 2.813.355-5.164 2.828-3.989 2.989 1.176.161 4.933-2.98 8.69-2.988 3.757-.01-4.46 2.827-3.526 3.17.935.343 4.71-.838 4.71-.838"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#4541C9", d: "M12.408 55.5h71.145v.827H12.408zm0-27.3h71.145v.827H12.408z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#EB5757",
          fillRule: "evenodd",
          d: "M14.272 42.264a1.861 1.861 0 1 1-3.723 0 1.861 1.861 0 0 1 3.723 0Zm-3.043 1.18a.5.5 0 0 1 0-.707l.474-.473-.474-.474a.5.5 0 1 1 .708-.707l.473.474.474-.474a.5.5 0 0 1 .707.707l-.474.474.474.473a.5.5 0 1 1-.707.707l-.474-.473-.473.474a.5.5 0 0 1-.708 0Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#CCD2E3",
          d: "m4.826 42.264.354-.354.353.354-.353.353-.354-.353Zm-3.447.5a.5.5 0 1 1 0-1v1Zm1.733-2.922L5.18 41.91l-.707.707-2.069-2.068.708-.707Zm2.068 2.775-2.068 2.068-.708-.707 2.069-2.068.707.707Zm-.354.147H1.38v-1h3.447v1Z"
        }
      ),
      /* @__PURE__ */ jsx("path", { stroke: "#CCD2E3", d: "M6.895 39.85v4.826" })
    ] }),
    /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h92v66H0z" }) }) })
  ] });
}, Attention = () => {
  const { theme: t } = useContext(ConfigContext);
  return t === "light" ? /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsxs("g", { clipPath: "url(#a)", children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#D2DFFA",
          d: "M89.482 51.826c-5.996 20.268-49.348 13.918-63.246 10.321C16.866 65.431 0 58.863 0 38.22c0-8.914 13.586-7.507 22.956-19.705C32.326 6.317 43.101-2.597 56.22.687 69.337 3.97 96.98 26.49 89.482 51.826Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#6562F5",
          d: "M11.56 7.124a8 8 0 0 0-8 8v30.444c0 .088.002.175.005.262l-.004-.003V62.76l9.192-9.192H72a8 8 0 0 0 8-8V15.124a8 8 0 0 0-8-8H11.56Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#3A36DB",
          fillRule: "evenodd",
          d: "M72.259 23.09a2.419 2.419 0 0 1-2.42 2.418H45.65a2.419 2.419 0 0 1 0-4.838h24.19a2.419 2.419 0 0 1 2.419 2.42Zm0 7.74a2.419 2.419 0 0 1-2.42 2.419H45.65a2.419 2.419 0 0 1 0-4.838h24.19a2.419 2.419 0 0 1 2.419 2.419Zm0 7.74a2.419 2.419 0 0 1-2.42 2.42H45.65a2.419 2.419 0 0 1 0-4.838h24.19a2.419 2.419 0 0 1 2.419 2.419Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#EB5757",
          d: "M20.837 19.053 10.22 36.425c-1.221 2 .218 4.565 2.56 4.565h21.232c2.343 0 3.782-2.566 2.56-4.565L25.956 19.054c-1.17-1.915-3.95-1.915-5.12 0Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "m24.737 25.508-.236 8.028h-2.213l-.242-8.028h2.691ZM23.395 37.12c-.4 0-.742-.13-1.029-.392a1.233 1.233 0 0 1-.423-.951 1.21 1.21 0 0 1 .423-.941 1.473 1.473 0 0 1 1.029-.392c.383 0 .72.13 1.01.392.29.261.437.575.44.94a1.232 1.232 0 0 1-.21.678 1.459 1.459 0 0 1-1.24.666Z"
        }
      )
    ] }),
    /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h99v66H0z" }) }) })
  ] }) : /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsxs("g", { clipPath: "url(#a)", children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#28313F",
          d: "M89.482 51.826c-5.996 20.268-49.348 13.918-63.246 10.321C16.866 65.431 0 58.863 0 38.22c0-8.914 13.586-7.507 22.956-19.705C32.326 6.317 43.101-2.597 56.22.687 69.337 3.97 96.98 26.49 89.482 51.826Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#605CFF",
          fillRule: "evenodd",
          d: "M11.56 7.124a8 8 0 0 0-8 8v30.444c0 .088.002.175.005.262l-.004-.002V62.76l9.192-9.192H72a8 8 0 0 0 8-8V15.124a8 8 0 0 0-8-8H11.56Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#4541C9",
          fillRule: "evenodd",
          d: "M72.26 23.09a2.419 2.419 0 0 1-2.42 2.418H45.652a2.419 2.419 0 1 1 0-4.838h24.19a2.419 2.419 0 0 1 2.419 2.42Zm0 7.74a2.419 2.419 0 0 1-2.42 2.419H45.652a2.419 2.419 0 0 1 0-4.838h24.19a2.419 2.419 0 0 1 2.419 2.419Zm0 7.74a2.419 2.419 0 0 1-2.42 2.42H45.652a2.419 2.419 0 1 1 0-4.838h24.19a2.419 2.419 0 0 1 2.419 2.419Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#EB5757",
          d: "M20.837 19.054 10.221 36.425c-1.222 2 .217 4.565 2.56 4.565h21.232c2.343 0 3.781-2.566 2.56-4.565L25.957 19.054c-1.17-1.915-3.95-1.915-5.12 0Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "m24.737 25.508-.236 8.028h-2.213l-.242-8.028h2.691ZM23.395 37.12c-.4 0-.742-.13-1.028-.392a1.233 1.233 0 0 1-.424-.951 1.21 1.21 0 0 1 .424-.94 1.472 1.472 0 0 1 1.028-.393c.383 0 .72.13 1.01.392.29.261.437.575.441.94a1.232 1.232 0 0 1-.212.678 1.46 1.46 0 0 1-1.24.666Z"
        }
      )
    ] }),
    /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h99v66H0z" }) }) })
  ] });
}, Edit = () => {
  const { theme: t } = useContext(ConfigContext);
  return t === "light" ? /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsxs("g", { clipPath: "url(#a)", children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#D2DFFA",
          d: "M88.913 51.968C82.954 72.292 39.88 65.925 26.07 62.318 16.759 65.612 0 59.025 0 38.325c0-8.939 13.5-7.527 22.81-19.76C32.12 6.336 42.827-2.604 55.862.69c13.034 3.293 40.5 25.875 33.051 51.28Z"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#3A36DB", d: "M35.844 47.967h13.85v5.327h-13.85z" }),
      /* @__PURE__ */ jsx("path", { fill: "#6562F5", d: "M24.123 53.294h37.289v5.327H24.123z" }),
      /* @__PURE__ */ jsx("rect", { width: "69.63", height: "42.307", x: "7", y: "6.154", fill: "#605CFF", rx: "8" }),
      /* @__PURE__ */ jsx("rect", { width: "63.341", height: "36.018", x: "10.145", y: "9.298", fill: "#6562F5", stroke: "#F1F4FA", rx: "4.5" }),
      /* @__PURE__ */ jsx("path", { fill: "#3A36DB", d: "M45.342 20.58a1 1 0 0 0-.99 1.145 1 1 0 1 0 .99-1.146Z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#3A36DB",
          fillRule: "evenodd",
          d: "M41.44 25.707a.089.089 0 0 1-.1-.027l-.82-1.005a.09.09 0 0 1-.007-.103l.57-.919a4.717 4.717 0 0 1-.44-1.46l-.98-.454a.089.089 0 0 1-.051-.09l.13-1.29a.088.088 0 0 1 .068-.077l1.052-.247c.169-.491.415-.943.723-1.343l-.373-1.015a.09.09 0 0 1 .027-.1l1.005-.819a.089.089 0 0 1 .102-.006l.92.569a4.702 4.702 0 0 1 1.46-.44l.453-.98a.089.089 0 0 1 .09-.051l1.29.13a.089.089 0 0 1 .077.068l.248 1.052c.49.169.943.415 1.343.723l1.014-.373a.089.089 0 0 1 .1.027l.82 1.005c.023.029.026.07.006.102l-.569.92c.222.453.372.945.44 1.46l.98.454a.088.088 0 0 1 .05.09l-.13 1.289a.089.089 0 0 1-.068.077l-1.051.248a4.715 4.715 0 0 1-.723 1.343l.373 1.014a.09.09 0 0 1-.027.1l-1.005.82a.09.09 0 0 1-.103.006l-.919-.569a4.707 4.707 0 0 1-1.46.44l-.454.98a.089.089 0 0 1-.09.051l-1.289-.13a.088.088 0 0 1-.078-.069l-.247-1.051a4.711 4.711 0 0 1-1.343-.723l-1.014.373Zm3.926-.943a3.27 3.27 0 0 1-.937-.138h-.002l-.002-.001-.02-.006-.035-.011a.076.076 0 1 1 .046-.145 3.052 3.052 0 0 0 3.996-2.91c0-.7-.239-1.373-.687-1.923a3.032 3.032 0 0 0-2.058-1.107 3.055 3.055 0 0 0-3.071 4.332.076.076 0 0 1-.037.1.076.076 0 0 1-.101-.036 3.198 3.198 0 0 1-.286-1.683 3.208 3.208 0 0 1 3.51-2.865 3.182 3.182 0 0 1 2.16 1.163 3.18 3.18 0 0 1 .706 2.348 3.183 3.183 0 0 1-1.163 2.16 3.18 3.18 0 0 1-2.02.722Zm-.027-1.882a1.305 1.305 0 0 1-1.288-1.114 1.305 1.305 0 0 1 2.066-1.236 1.305 1.305 0 0 1-.778 2.35Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#3A36DB",
          d: "M28.154 29.182a1.653 1.653 0 0 0-.986 2.977c.355.263.79.372 1.227.308a1.64 1.64 0 0 0 1.085-.649c.263-.354.372-.789.308-1.226a1.654 1.654 0 0 0-1.634-1.41Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#3A36DB",
          fillRule: "evenodd",
          d: "M21.553 37.82a.15.15 0 0 1-.169-.047l-1.387-1.7a.15.15 0 0 1-.011-.174l.962-1.555a7.97 7.97 0 0 1-.743-2.472l-1.659-.767a.15.15 0 0 1-.086-.152l.221-2.183a.15.15 0 0 1 .115-.13l1.78-.42a7.96 7.96 0 0 1 1.223-2.272l-.631-1.717a.15.15 0 0 1 .046-.168l1.7-1.387a.15.15 0 0 1 .174-.012l1.555.963a7.96 7.96 0 0 1 2.472-.743l.767-1.66a.15.15 0 0 1 .152-.086l2.183.222a.15.15 0 0 1 .13.115l.42 1.779a7.956 7.956 0 0 1 2.272 1.224l1.717-.632a.15.15 0 0 1 .168.047l1.387 1.7c.04.05.045.12.012.174l-.963 1.555c.375.768.63 1.6.743 2.472l1.66.767a.15.15 0 0 1 .086.152l-.221 2.182a.15.15 0 0 1-.115.132l-1.78.418a7.956 7.956 0 0 1-1.224 2.273l.632 1.717a.15.15 0 0 1-.047.168l-1.7 1.387a.151.151 0 0 1-.174.011l-1.555-.962a7.97 7.97 0 0 1-2.472.743l-.767 1.659a.15.15 0 0 1-.151.086l-2.183-.22a.15.15 0 0 1-.131-.116l-.419-1.779a7.959 7.959 0 0 1-2.273-1.224l-1.716.632Zm6.64-1.428a5.636 5.636 0 0 1-1.684-.257l-.05-.016a.297.297 0 1 1 .183-.564 5.07 5.07 0 0 0 1.042.218l.058.005a4.949 4.949 0 0 0 3.57-1.077l.009-.007.004-.003.022-.018a4.964 4.964 0 0 0 1.838-3.882 4.96 4.96 0 0 0-1.126-3.149 4.965 4.965 0 0 0-3.368-1.812 4.97 4.97 0 0 0-3.663 1.1 4.965 4.965 0 0 0-1.838 3.875c0 .73.16 1.454.472 2.117a.299.299 0 0 1-.143.395.297.297 0 0 1-.395-.143 5.58 5.58 0 0 1-.5-2.936 5.554 5.554 0 0 1 2.029-3.768 5.548 5.548 0 0 1 4.098-1.23 5.55 5.55 0 0 1 3.768 2.027 5.55 5.55 0 0 1 1.231 4.098 5.598 5.598 0 0 1-5.558 5.027Zm-.044-3.313c-.48 0-.944-.153-1.335-.444a2.231 2.231 0 0 1-.881-1.474 2.247 2.247 0 0 1 1.893-2.548 2.248 2.248 0 0 1 2.549 1.893 2.228 2.228 0 0 1-.42 1.667 2.228 2.228 0 0 1-1.806.906Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#EB5757",
          d: "M80.768 13.075a2.663 2.663 0 0 0-3.638.974l-1.332 2.307 4.613 2.664 1.332-2.307a2.664 2.664 0 0 0-.975-3.639Zm-1.422 7.79-4.614-2.663-12.898 22.341-1.309 7.593 5.922-4.93 12.899-22.34Z"
        }
      )
    ] }),
    /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h99v66H0z" }) }) })
  ] }) : /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsxs("g", { clipPath: "url(#a)", children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#28313F",
          d: "M88.913 51.968C82.954 72.292 39.88 65.925 26.07 62.318 16.759 65.612 0 59.025 0 38.325c0-8.939 13.5-7.527 22.81-19.76C32.12 6.336 42.827-2.604 55.862.69c13.034 3.293 40.5 25.875 33.051 51.28Z"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#3A36DB", d: "M35.844 47.967h13.85v5.327h-13.85z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#605CFF",
          d: "M24.123 53.294h37.289v5.327H24.123zM7 14.154a8 8 0 0 1 8-8h53.63a8 8 0 0 1 8 8v26.307a8 8 0 0 1-8 8H15a8 8 0 0 1-8-8V14.154Z"
        }
      ),
      /* @__PURE__ */ jsx("rect", { width: "63.341", height: "36.018", x: "10.145", y: "9.298", fill: "#605CFF", stroke: "#364153", rx: "4.5" }),
      /* @__PURE__ */ jsx("path", { fill: "#4541C9", d: "M45.342 20.58a1 1 0 0 0-.99 1.145 1 1 0 1 0 .99-1.146Z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#4541C9",
          fillRule: "evenodd",
          d: "M41.44 25.707a.089.089 0 0 1-.1-.027l-.82-1.005a.09.09 0 0 1-.007-.103l.57-.919a4.717 4.717 0 0 1-.44-1.46l-.98-.454a.089.089 0 0 1-.051-.09l.13-1.29a.088.088 0 0 1 .068-.077l1.052-.247c.169-.491.415-.943.723-1.343l-.373-1.015a.09.09 0 0 1 .027-.1l1.005-.819a.089.089 0 0 1 .102-.006l.92.569a4.702 4.702 0 0 1 1.46-.44l.453-.98a.089.089 0 0 1 .09-.051l1.29.13a.089.089 0 0 1 .077.068l.248 1.052c.49.169.943.415 1.343.723l1.014-.373a.089.089 0 0 1 .1.027l.82 1.005c.023.029.026.07.006.102l-.569.92c.222.453.372.945.44 1.46l.98.454a.088.088 0 0 1 .05.09l-.13 1.289a.089.089 0 0 1-.068.077l-1.051.248a4.715 4.715 0 0 1-.723 1.343l.373 1.014a.09.09 0 0 1-.027.1l-1.005.82a.09.09 0 0 1-.103.006l-.919-.569a4.707 4.707 0 0 1-1.46.44l-.454.98a.089.089 0 0 1-.09.051l-1.289-.13a.088.088 0 0 1-.078-.069l-.247-1.051a4.711 4.711 0 0 1-1.343-.723l-1.014.373Zm3.926-.943a3.27 3.27 0 0 1-.937-.138h-.002l-.002-.001-.02-.006-.035-.011a.076.076 0 1 1 .046-.145 3.052 3.052 0 0 0 3.996-2.91c0-.7-.239-1.373-.687-1.923a3.032 3.032 0 0 0-2.058-1.107 3.055 3.055 0 0 0-3.071 4.332.076.076 0 0 1-.037.1.076.076 0 0 1-.101-.036 3.198 3.198 0 0 1-.286-1.683 3.208 3.208 0 0 1 3.51-2.865 3.182 3.182 0 0 1 2.16 1.163 3.18 3.18 0 0 1 .706 2.348 3.183 3.183 0 0 1-1.163 2.16 3.18 3.18 0 0 1-2.02.722Zm-.027-1.882a1.305 1.305 0 0 1-1.288-1.114 1.305 1.305 0 0 1 2.066-1.236 1.305 1.305 0 0 1-.778 2.35Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#4541C9",
          d: "M28.154 29.182a1.653 1.653 0 0 0-.986 2.977c.355.263.79.372 1.227.308a1.64 1.64 0 0 0 1.085-.649c.263-.354.372-.789.308-1.226a1.654 1.654 0 0 0-1.634-1.41Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#4541C9",
          fillRule: "evenodd",
          d: "M21.553 37.82a.15.15 0 0 1-.169-.046v-.001l-1.387-1.7a.15.15 0 0 1-.011-.174l.962-1.555a7.97 7.97 0 0 1-.743-2.472l-1.659-.767a.15.15 0 0 1-.086-.152l.221-2.183a.15.15 0 0 1 .115-.13l1.78-.42a7.959 7.959 0 0 1 1.223-2.272l-.631-1.717a.15.15 0 0 1 .046-.168l1.7-1.387a.15.15 0 0 1 .174-.011l1.555.962a7.96 7.96 0 0 1 2.472-.743l.767-1.66a.15.15 0 0 1 .152-.086l2.183.222a.15.15 0 0 1 .13.115l.42 1.78a7.954 7.954 0 0 1 2.272 1.223l1.717-.631a.15.15 0 0 1 .168.046l1.387 1.7c.04.05.045.12.012.174l-.963 1.555c.375.768.63 1.6.743 2.472l1.66.767a.15.15 0 0 1 .086.152l-.221 2.182a.15.15 0 0 1-.115.132l-1.78.418a7.957 7.957 0 0 1-1.224 2.273l.632 1.717a.15.15 0 0 1-.047.168l-1.7 1.387a.151.151 0 0 1-.174.011l-1.555-.962a7.97 7.97 0 0 1-2.472.743l-.767 1.659a.15.15 0 0 1-.151.087l-2.183-.222a.15.15 0 0 1-.131-.115l-.419-1.779a7.959 7.959 0 0 1-2.273-1.224l-1.716.632Zm6.64-1.428a5.636 5.636 0 0 1-1.684-.257l-.05-.016a.297.297 0 1 1 .183-.564 5.07 5.07 0 0 0 1.042.218l.058.005a4.949 4.949 0 0 0 3.57-1.077l.009-.007.004-.003.022-.018a4.965 4.965 0 0 0 1.838-3.882 4.96 4.96 0 0 0-1.126-3.149 4.965 4.965 0 0 0-3.368-1.812 4.97 4.97 0 0 0-3.663 1.1 4.964 4.964 0 0 0-1.838 3.875c0 .731.16 1.454.472 2.117a.298.298 0 0 1-.143.395.297.297 0 0 1-.395-.143 5.58 5.58 0 0 1-.5-2.936 5.554 5.554 0 0 1 2.029-3.767 5.549 5.549 0 0 1 4.098-1.231 5.55 5.55 0 0 1 3.768 2.027 5.55 5.55 0 0 1 1.231 4.098 5.598 5.598 0 0 1-5.558 5.027Zm-.044-3.313c-.48 0-.944-.153-1.335-.444a2.23 2.23 0 0 1-.881-1.474 2.247 2.247 0 0 1 1.893-2.548 2.248 2.248 0 0 1 2.549 1.893 2.229 2.229 0 0 1-.42 1.667 2.228 2.228 0 0 1-1.806.906Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#EB5757",
          fillRule: "evenodd",
          d: "M80.768 13.074a2.663 2.663 0 0 0-3.639.975l-1.332 2.307 4.614 2.664 1.332-2.307a2.663 2.663 0 0 0-.975-3.639Zm-1.423 7.791-4.613-2.663-12.9 22.341-1.307 7.593 5.921-4.93 12.9-22.34Z",
          clipRule: "evenodd"
        }
      )
    ] }),
    /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h99v66H0z" }) }) })
  ] });
}, SaveTable = () => {
  const { theme: t } = useContext(ConfigContext);
  return t === "light" ? /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#D2DFFA",
        d: "M88.097 50.956C82.194 70.884 39.513 64.641 25.83 61.105 16.605 64.334 0 57.875 0 37.579c0-8.765 13.376-7.381 22.6-19.375C31.827 6.211 42.435-2.554 55.35.675c12.914 3.23 40.127 25.371 32.747 50.281Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#6562F5", d: "M4.137 54.214V18.893h69.49v35.321H4.138Z" }),
    /* @__PURE__ */ jsx("path", { fill: "#D2DFFA", d: "M4.137 54.214V18.893h13.236v35.321H4.137Z" }),
    /* @__PURE__ */ jsx("path", { fill: "#BECDFA", d: "M18.2 54.214V18.893h13.236v35.321H18.199Zm14.064 0V18.893H45.5v35.321H32.264Z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#EB5757",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: ".5",
        d: "M11.153 18.893 6.603 21.1l4.501 2.208-6.967 2.208 7.234 2.207-6.486 2.208 6.486 2.207-6.362 2.208 6.573 2.208-6.493 2.207 6.386 2.208-6.106 2.207 6.002 2.208-4.495 2.208 4.599 2.207-4.873 2.208 1.26 2.207"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#3A36DB",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: ".5",
        d: "M42.589 18.893 32.677 21.1l9.863 2.208-9.863 2.156 10.13 2.26-10.13 2.207 8.475 2.207-8.475 2.208 7.86 2.208-7.86 2.207 6.924 2.208-6.924 2.207 4.339 2.208-2.84 2.208 1.29 2.207-2.789 2.208s1.993 1.345 2.485 2.207"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#fff",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: ".5",
        d: "m28.11 54.214-9.911-2.207 9.862-2.208-9.862-2.156 10.13-2.26-10.13-2.207 8.475-2.207-8.475-2.208 7.858-2.208-7.858-2.207 6.924-2.208-6.924-2.207 4.338-2.208-2.84-2.207 1.29-2.208-2.788-2.208s1.992-1.345 2.485-2.207"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#6562F5", d: "M3.309 55.035v-9.857h.827v9.857z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#3A36DB",
        d: "M17.373 55.036V18.893h.827v36.143zm14.063-.001V18.892h.827v36.143zm14.064.001V18.893h.827v36.143zm14.063-.001V18.892h.827v36.143zm14.064.001V18.893h.827v36.143zm-70.318-.001V18.892h.827v36.143z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#3A36DB", d: "M3.309 54.214h71.145v.821H3.309zm0-45.178h71.145v9.857H3.309z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#BECDFA",
        d: "M80.555 50.518c0 6.294-5.14 11.397-11.479 11.397-6.34 0-11.478-5.103-11.478-11.397 0-6.295 5.139-11.398 11.478-11.398 6.34 0 11.479 5.103 11.479 11.398Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#3A36DB",
        d: "M68.514 54.27v-.078c.009-.828.096-1.487.26-1.977.165-.49.4-.886.703-1.19a5.671 5.671 0 0 1 1.092-.838c.255-.156.485-.34.689-.552a2.458 2.458 0 0 0 .663-1.684c0-.425-.1-.793-.3-1.105a2.009 2.009 0 0 0-.799-.722 2.425 2.425 0 0 0-1.112-.253 2.49 2.49 0 0 0-1.027.22 1.99 1.99 0 0 0-.825.696c-.221.317-.35.73-.384 1.242h-1.638c.035-.737.225-1.367.572-1.892a3.445 3.445 0 0 1 1.385-1.203 4.365 4.365 0 0 1 1.917-.416c.763 0 1.426.152 1.99.456a3.26 3.26 0 0 1 1.313 1.248c.312.528.468 1.13.468 1.807a3.6 3.6 0 0 1-.221 1.294c-.143.385-.351.73-.624 1.033a4.282 4.282 0 0 1-.975.806c-.382.239-.687.49-.917.755-.23.26-.396.57-.5.93-.104.359-.16.807-.17 1.345v.078h-1.56Zm.833 3.848c-.321 0-.596-.114-.826-.344a1.126 1.126 0 0 1-.345-.826c0-.32.115-.596.345-.825.23-.23.505-.345.826-.345.32 0 .595.115.825.345.23.23.345.505.345.825 0 .213-.054.408-.163.585a1.224 1.224 0 0 1-.422.43 1.115 1.115 0 0 1-.585.155Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#fff",
        strokeOpacity: ".4",
        d: "M49.72 35.321c0-1.76 1.453-3.196 3.223-3.196 1.77 0 3.223 1.436 3.223 3.196 0 1.761-1.453 3.197-3.223 3.197-1.77 0-3.222-1.436-3.222-3.197Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { stroke: "#fff", strokeLinejoin: "round", d: "M52.943 33.679v3.285m1.657-1.643h-3.31" })
  ] }) : /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#28313F",
        d: "M88.097 50.956C82.194 70.884 39.513 64.641 25.83 61.105 16.605 64.334 0 57.875 0 37.579c0-8.765 13.376-7.381 22.6-19.375C31.827 6.211 42.435-2.554 55.35.675c12.914 3.23 40.127 25.371 32.747 50.281Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#605CFF", d: "M4.137 54.214V18.893h69.49v35.321H4.138Z" }),
    /* @__PURE__ */ jsx("path", { fill: "#1A202C", d: "M4.137 54.214V18.893h13.236v35.321H4.137Z" }),
    /* @__PURE__ */ jsx("path", { fill: "#7471FF", d: "M18.2 54.214V18.893h13.236v35.321H18.199Zm14.064 0V18.893H45.5v35.321H32.264Z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#EB5757",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: ".5",
        d: "M11.153 18.893 6.603 21.1l4.501 2.208-6.967 2.208 7.234 2.207-6.486 2.208 6.486 2.207-6.362 2.208 6.573 2.208-6.493 2.207 6.386 2.208-6.106 2.207 6.002 2.208-4.495 2.208 4.599 2.207-4.873 2.208 1.26 2.207"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#4541C9",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: ".5",
        d: "M42.589 18.893 32.677 21.1l9.863 2.208-9.863 2.156 10.13 2.26-10.13 2.207 8.475 2.207-8.475 2.208 7.86 2.208-7.86 2.207 6.924 2.208-6.924 2.207 4.339 2.208-2.84 2.208 1.29 2.207-2.789 2.208s1.993 1.345 2.485 2.207"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#fff",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: ".5",
        d: "m28.11 54.214-9.911-2.207 9.862-2.208-9.862-2.156 10.13-2.26-10.13-2.207 8.475-2.207-8.475-2.208 7.858-2.207-7.858-2.208 6.924-2.208-6.924-2.207 4.338-2.208-2.84-2.207 1.29-2.208-2.788-2.208s1.992-1.345 2.485-2.207"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#605CFF", d: "M3.309 55.035v-9.857h.827v9.857z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#4541C9",
        d: "M17.373 55.036V18.893h.827v36.143zm14.063-.001V18.892h.827v36.143zm14.064.001V18.893h.827v36.143zm14.063-.001V18.892h.827v36.143zm14.064.001V18.893h.827v36.143zm-70.318-.001V18.892h.827v36.143z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#4541C9", d: "M3.309 54.214h71.145v.821H3.309zm0-45.178h71.145v9.857H3.309z" }),
    /* @__PURE__ */ jsx("ellipse", { cx: "69.491", cy: "50.929", fill: "#28313F", rx: "9.1", ry: "9.036" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#BECDFA",
        fillRule: "evenodd",
        d: "M69.076 61.915c6.34 0 11.479-5.103 11.479-11.397 0-6.295-5.14-11.398-11.479-11.398-6.34 0-11.478 5.103-11.478 11.398 0 6.294 5.139 11.397 11.478 11.397Zm-.562-7.723v.078h1.56v-.078c.01-.538.066-.986.17-1.346.104-.36.27-.67.5-.93a4.04 4.04 0 0 1 .917-.754c.381-.234.706-.502.975-.806.273-.303.481-.648.624-1.033a3.6 3.6 0 0 0 .221-1.294c0-.676-.156-1.279-.468-1.807a3.259 3.259 0 0 0-1.313-1.248c-.564-.304-1.227-.455-1.99-.455-.702 0-1.34.138-1.917.416a3.446 3.446 0 0 0-1.385 1.202c-.347.525-.537 1.155-.572 1.892h1.638c.035-.511.163-.925.384-1.242.22-.316.496-.548.825-.695.33-.148.672-.221 1.027-.221.408 0 .779.084 1.112.253.334.17.6.41.8.722.2.312.299.68.299 1.105a2.458 2.458 0 0 1-.663 1.684 3.413 3.413 0 0 1-.69.552 5.67 5.67 0 0 0-1.091.839c-.304.303-.538.7-.703 1.19-.164.49-.251 1.148-.26 1.976Zm.007 3.582c.23.23.505.344.826.344.216 0 .411-.052.585-.156.177-.108.318-.25.422-.429.109-.177.163-.372.163-.585 0-.32-.115-.596-.345-.825a1.126 1.126 0 0 0-.825-.345c-.321 0-.596.115-.826.345-.23.23-.345.505-.345.825 0 .321.115.596.345.826Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#fff",
        strokeOpacity: ".4",
        d: "M49.72 35.321c0-1.76 1.453-3.196 3.223-3.196 1.77 0 3.223 1.436 3.223 3.196 0 1.761-1.453 3.197-3.223 3.197-1.77 0-3.222-1.436-3.222-3.197Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { stroke: "#fff", strokeLinejoin: "round", d: "M52.943 33.679v3.285m1.657-1.643h-3.31" })
  ] });
}, Work = () => {
  const { theme: t } = useContext(ConfigContext);
  return t === "light" ? /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#D2DFFA",
        d: "M80.245 47.483c-5.295 17.869-43.57 12.27-55.841 9.1C16.13 59.478 1.24 53.687 1.24 35.487c0-7.859 11.996-6.618 20.268-17.373C29.781 7.36 39.295-.498 50.877 2.396c11.581 2.896 35.986 22.75 29.368 45.087Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#FEBBBA",
        d: "M23.935 47.602c2.083-1.45 4.443 0 4.443 0 2.785 1.824 4.846 2.6 6.366 2.692a7.744 7.744 0 0 1-.129 4.684c-3.12-.672-5.353-2.933-6.323-4.093a1.006 1.006 0 0 0-1.395-.153c-.434.343-.855.813-.778 1.307.15.975-.98 1.285-1.064.931-.085-.353.386-2.449.386-2.449s-2.26 2.275-3.141 3.15c-.882.874-1.991 0-1.991 0s1.543-4.617 3.626-6.067v-.002Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#6562F5",
        d: "M60.812 27.522s-8.133-3.26-23.27 9.252c0 0-1.264 2.62.116 4.952.18.305.56.764 1.09 1.345.254 2.68.116 7.472-4.003 7.223a7.734 7.734 0 0 1-.13 4.683c1.442.31 3.073.283 4.858-.352 3.34-1.187 5.199-2.884 6.23-4.342 3.67 3.909 7.006 6.267 7.905 9.406 0 0 8.343.962 16.303-1.457 0 0-.148-3.632-1.1-8.83 1.56 1.194 3.272 3.164 4.472 6.396 1.161-.743 2.163-1.855 2.918-3.442 5.262-11.07-15.389-24.834-15.389-24.834Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#3A36DB",
        d: "M67.115 47.776a.226.226 0 0 0 .22-.172c.965-3.937-8.294-12.303-8.689-12.657a.226.226 0 1 0-.301.338c.094.085 9.452 8.536 8.55 12.21a.226.226 0 0 0 .22.28Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#FEBBBA",
        d: "M52.623 48.005s11.339 4.408 14.106 1.092c.188-.224.31-.48.379-.76 1.86.925 4.51 2.98 6.173 7.462-5.964 3.815-16.157-2.123-18.913-3.873a2.056 2.056 0 0 0-1.523-.28c-1.063.22-2.9.545-3.89.392-1.45-.224-3.53 4.894-5.879 3.316 0 0 2.011-8.896 9.547-7.349ZM36.02 17.474c-.04.156.94 10.78.94 10.78l3.013-.343 2.153 4.456a2.458 2.458 0 0 0 2.02 1.38c2.925.228 4.243-1.424 4.8-2.559a1.597 1.597 0 0 0-.21-1.716l-3.492-4.238c.614.02 1.449-.284 1.891-1.866.607-2.167-1.005-2.736-2.203-2.113-.964.502-.666 2.65-.512 3.47l-1.283.465.435-7.832s-6.877-2.5-7.551.116Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#6562F5",
        d: "m41.998 19.473.123 5.397a.728.728 0 0 1-.024.204c-.105.41-.57 1.796-1.957 1.232-1.258-.511-2.414-.959-3.264-.797a.754.754 0 0 0-.61.81c.09.965.33 3.137.828 4.99.1.377.475.61.858.542 1.155-.204 3.578-.701 5.434-1.559a.754.754 0 0 0 .44-.635c.09-1.348.38-5.448.638-6.577.242-1.06 1.628-1.56 2.225-1.727a.742.742 0 0 0 .455-.367c.338-.635.871-2.133-.995-2.976a.755.755 0 0 1-.368-1.023c.375-.767.629-1.973-.795-2.81-1.447-.85-2.672-.163-3.358.43a.753.753 0 0 1-.967.009c-.163-.13-.385-.192-.676-.051-.393.189-.862-.021-1.01-.432-.282-.789-.936-1.673-2.454-1.581-2.694.163-3.315 3.063-2.806 4.86.51 1.795 3.42 1.452 4.938.742 1.155-.54 2.484.305 3.054.741a.75.75 0 0 1 .293.579h-.002Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#EB5757",
        d: "m46.815 56.698-.055.001-23.79-.026a1.065 1.065 0 0 1-1.064-1.067c0-.59.48-1.076 1.067-1.065l23.79.026a1.065 1.065 0 0 1 .052 2.131Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#EB5757",
        d: "M1.584 35.07h19.813c1.461 0 2.792.844 3.415 2.168l9.159 19.447H9.35a2.295 2.295 0 0 1-2.135-1.453L.112 37.236a1.584 1.584 0 0 1 1.472-2.167Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#1A202C",
        d: "M15.542 45.041c.429 1.335.112 2.633-.708 2.897-.82.265-1.834-.603-2.264-1.94-.429-1.335-.112-2.633.708-2.897.82-.264 1.834.604 2.264 1.94Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#BECDFA",
        d: "M86.646 57.727a1.346 1.346 0 0 0-.161-.866c-.145-.242-.362-.381-.59-.381H8.602c-.3 0-.58.21-.74.556a1.603 1.603 0 0 0-.058 1.157l.837 2.487c.192.57.608.934 1.065.934h75.66c.425 0 .79-.414.87-.987l.41-2.9Z"
      }
    )
  ] }) : /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#28313F",
        d: "M80.245 47.483c-5.295 17.869-43.57 12.27-55.841 9.1C16.13 59.478 1.24 53.687 1.24 35.487c0-7.859 11.996-6.618 20.268-17.373C29.781 7.36 39.295-.498 50.877 2.396c11.581 2.896 35.986 22.75 29.368 45.087Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#FEBBBA",
        d: "M23.935 47.602c2.083-1.45 4.443 0 4.443 0 2.785 1.824 4.846 2.6 6.366 2.692a7.744 7.744 0 0 1-.129 4.684c-3.12-.672-5.353-2.933-6.323-4.093a1.006 1.006 0 0 0-1.395-.153c-.434.343-.855.813-.778 1.307.15.975-.98 1.285-1.064.932-.085-.354.386-2.45.386-2.45s-2.26 2.276-3.141 3.15c-.882.874-1.991 0-1.991 0s1.543-4.617 3.626-6.067v-.002Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#605CFF",
        d: "M60.812 27.522s-8.133-3.26-23.27 9.252c0 0-1.264 2.62.116 4.952.18.305.56.764 1.09 1.345.254 2.68.116 7.472-4.003 7.223a7.735 7.735 0 0 1-.13 4.683c1.442.31 3.073.283 4.858-.352 3.34-1.187 5.199-2.884 6.23-4.342 3.67 3.909 7.006 6.267 7.905 9.406 0 0 8.343.962 16.303-1.457 0 0-.148-3.632-1.1-8.83 1.56 1.194 3.272 3.164 4.472 6.396 1.161-.743 2.163-1.855 2.918-3.442 5.262-11.07-15.389-24.834-15.389-24.834Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#1A202C",
        d: "M67.115 47.776a.226.226 0 0 0 .22-.172c.965-3.937-8.294-12.302-8.689-12.656a.226.226 0 1 0-.301.337c.094.085 9.452 8.536 8.55 12.211a.226.226 0 0 0 .22.28Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#FEBBBA",
        d: "M52.623 48.005s11.339 4.408 14.106 1.092c.188-.224.31-.48.379-.76 1.86.925 4.51 2.98 6.173 7.462-5.964 3.815-16.157-2.123-18.913-3.873a2.056 2.056 0 0 0-1.523-.28c-1.063.22-2.9.545-3.89.392-1.45-.224-3.53 4.894-5.879 3.316 0 0 2.011-8.896 9.547-7.349ZM36.02 17.474c-.04.156.94 10.78.94 10.78l3.013-.343 2.153 4.456a2.458 2.458 0 0 0 2.02 1.38c2.925.228 4.243-1.424 4.8-2.559a1.597 1.597 0 0 0-.21-1.716l-3.492-4.238c.614.02 1.449-.284 1.891-1.866.607-2.167-1.005-2.736-2.203-2.113-.964.502-.666 2.65-.512 3.47l-1.283.465.435-7.832s-6.877-2.5-7.551.116Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#605CFF",
        d: "m41.998 19.473.123 5.397a.729.729 0 0 1-.024.204c-.105.41-.57 1.796-1.957 1.232-1.258-.511-2.414-.959-3.264-.797a.754.754 0 0 0-.61.81c.09.965.33 3.137.828 4.99.1.377.475.61.858.542 1.155-.204 3.578-.701 5.434-1.559a.754.754 0 0 0 .44-.635c.09-1.348.38-5.448.638-6.577.242-1.06 1.628-1.56 2.225-1.727a.742.742 0 0 0 .455-.367c.338-.635.871-2.133-.995-2.976a.755.755 0 0 1-.368-1.023c.375-.767.629-1.973-.795-2.81-1.447-.85-2.672-.162-3.358.43a.753.753 0 0 1-.967.009c-.163-.13-.385-.192-.676-.051-.393.189-.862-.021-1.01-.432-.282-.789-.936-1.673-2.454-1.58-2.694.162-3.315 3.062-2.806 4.858.51 1.796 3.42 1.453 4.938.743 1.155-.54 2.484.305 3.054.741a.75.75 0 0 1 .293.579h-.002Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#EB5757",
        d: "m46.815 56.698-.055.001-23.79-.026a1.065 1.065 0 0 1-1.064-1.067c0-.59.48-1.076 1.067-1.065l23.79.026a1.065 1.065 0 0 1 .052 2.131Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#EB5757",
        d: "M1.584 35.07h19.813c1.461 0 2.792.845 3.415 2.168l9.159 19.447H9.35a2.295 2.295 0 0 1-2.135-1.453L.112 37.236a1.584 1.584 0 0 1 1.472-2.167Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#1A202C",
        d: "M15.542 45.041c.429 1.336.112 2.633-.708 2.897-.82.265-1.834-.603-2.264-1.94-.429-1.335-.112-2.632.708-2.897.82-.264 1.834.604 2.264 1.94Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#28313F",
        d: "M86.646 57.727a1.346 1.346 0 0 0-.161-.866c-.145-.241-.362-.381-.59-.381H8.602c-.3 0-.58.21-.74.556a1.603 1.603 0 0 0-.058 1.157l.837 2.487c.192.57.608.934 1.065.934h75.66c.425 0 .79-.414.87-.987l.41-2.899Z"
      }
    )
  ] });
}, Support = () => {
  const { theme: t } = useContext(ConfigContext);
  return t === "light" ? /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsxs("g", { clipPath: "url(#a)", children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#D2DFFA",
          d: "M64.437 57.258c-1.334 1.415-2.598 2.328-3.596 3.05-11.73 8.476-25.61 6.006-28.56 5.402-4.356-.891-12.776-2.614-18.863-9.824-9.21-10.909-7.777-28.096-.633-39.44 1.307-2.076 8.21-13.594 22.24-15.44 8.49-1.118 18.387 1.136 25.554 7.184 15.045 12.695 13.974 38.342 3.858 49.068Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#6562F5",
          d: "m5.87 51.567 1.769 2.947a2.688 2.688 0 0 0 2.867 1.25l2.662-.57a2.246 2.246 0 0 1 2.004.567 24.039 24.039 0 0 0 4.41 3.267 2.261 2.261 0 0 1 1.13 1.757l.241 2.723a2.698 2.698 0 0 0 2.032 2.383l3.328.83a2.687 2.687 0 0 0 2.907-1.152l1.484-2.293a2.251 2.251 0 0 1 1.819-1.021 23.97 23.97 0 0 0 5.421-.815 2.245 2.245 0 0 1 2.035.44l2.087 1.753c.88.74 2.132.838 3.116.243l2.938-1.774a2.705 2.705 0 0 0 1.245-2.876l-.567-2.672a2.264 2.264 0 0 1 .564-2.01 24.112 24.112 0 0 0 3.256-4.425 2.252 2.252 0 0 1 1.751-1.135l2.715-.24a2.694 2.694 0 0 0 2.374-2.04l.827-3.339a2.705 2.705 0 0 0-1.147-2.917l-2.285-1.488a2.262 2.262 0 0 1-1.018-1.825 24.196 24.196 0 0 0-.812-5.44 2.263 2.263 0 0 1 .439-2.041l1.747-2.095a2.706 2.706 0 0 0 .242-3.126l-1.768-2.948a2.688 2.688 0 0 0-2.867-1.249l-2.662.569a2.246 2.246 0 0 1-2.003-.566 24.035 24.035 0 0 0-4.411-3.268 2.26 2.26 0 0 1-1.13-1.756l-.241-2.723a2.698 2.698 0 0 0-2.032-2.383l-3.328-.83a2.688 2.688 0 0 0-2.907 1.151l-1.484 2.293a2.25 2.25 0 0 1-1.818 1.022 23.965 23.965 0 0 0-5.422.815 2.248 2.248 0 0 1-2.035-.441l-2.087-1.753a2.685 2.685 0 0 0-3.116-.243l-2.938 1.774a2.704 2.704 0 0 0-1.245 2.876l.567 2.672a2.264 2.264 0 0 1-.564 2.01 24.108 24.108 0 0 0-3.257 4.425 2.252 2.252 0 0 1-1.75 1.135l-2.714.241a2.695 2.695 0 0 0-2.375 2.04l-.827 3.338a2.705 2.705 0 0 0 1.147 2.917l2.286 1.488a2.262 2.262 0 0 1 1.017 1.825 24.19 24.19 0 0 0 .813 5.44 2.264 2.264 0 0 1-.44 2.041L6.114 48.44a2.708 2.708 0 0 0-.242 3.127Zm7.746-5.025c-4.702-10-.435-21.93 9.531-26.648 9.966-4.718 21.857-.437 26.56 9.563 4.701 10 .434 21.93-9.532 26.649-9.966 4.718-21.857.436-26.56-9.564Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#EB5757",
          d: "M42.929 32.753c-2.128-.459-9.384-1.805-16.981-.713a8.786 8.786 0 0 0-6.171 4.03c-2.475 3.927-5.975 10.93-5.235 18.234l3.884.964s2.684-8.666 5.705-12.193c0 0 3.578 8.183 3.397 12.676a7.116 7.116 0 0 1-.024.372c-.41 4.396 17.174.82 17.174.82l-1.095-23.416a.83.83 0 0 0-.654-.775Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FEBBBA",
          d: "m36.88 24.53.51 6.083c.048.566-.242 1.095-.727 1.322-1.116.522-3.259 1.27-5.55.721-.42-.1-.693-.54-.624-.989l1.486-9.643 4.904 2.505Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FEBBBA",
          d: "M30.055 17.156s-1.154 4.495-.925 6.72c.229 2.226-.017 3.734 2.596 3.77 2.612.037 4.552-1.577 5.362-3.96 0 0 1.279-3.678.65-4.999-.629-1.321-7.683-1.531-7.683-1.531Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#3A36DB",
          d: "m35.967 22.245-.322.052s.89-2.938-.349-3.23c-1.24-.292-5.998-.496-7.254-1.978-1.21-1.428-.68-3.608.507-4.385a.173.173 0 0 1 .23.045l.139.185a.175.175 0 0 0 .313-.084c.018-.149.204-.21.302-.097.383.441 1.334 1.107 3.61 1.162 3.228.078 5.505 1.02 5.902 3.187.026.137.184.19.29.099.21-.179.57-.305 1.13.034.978.588.925 2.53-.716 4.383-.078.088-.055.229.053.276.378.169.972.62-.237 1.54-1.237.942-2.05.991-2.364.962a.175.175 0 0 1-.16-.158l-.188-1.946a.175.175 0 0 0-.201-.157l-.685.11Z"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "url(#b)", d: "M35.953 22.661s.268-2.796 1.588-2.236c1.32.56-.144 3.108-1.092 3.363l-.496-1.127Z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#EB5757",
          d: "M43.5 49.957c.379-2.687-2.395-6.636-3.542-8.135a2.495 2.495 0 0 1-.516-1.493c-.033-3.805 1.25-5.793 3.802-7.434 0 0 9.568 10.368 7.21 18.694a7.013 7.013 0 0 1-1.148 2.334c-.372-3.137-3.986-3.821-5.807-3.966Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "url(#c)",
          d: "m43.325 48.918.353-.04c-.299-2.635-2.603-5.888-3.58-7.164l-.282.217c.96 1.253 3.22 4.44 3.51 6.987Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "url(#d)",
          d: "M43.426 50.33c.033-.121.055-.246.073-.373 1.821.145 5.435.83 5.807 3.966-4.132 5.484-15.523 3.506-15.523 3.506v-2.134s8.748-1.63 9.643-4.966Z"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "url(#e)", d: "M34.88 56.84s-1.682-3.982-4.645-2.57c-2.964 1.412-2.73 2.337-2.73 2.337l7.375.232Z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#3A36DB",
          d: "M35.257 57.666a.563.563 0 0 1-.58.52l-15.356-.537a.563.563 0 0 1-.517-.396l-.446-1.431a.564.564 0 0 1 .507-.732l5.6-.299a.558.558 0 0 1 .151.013l10.202 2.267c.274.06.461.315.44.595Z"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#6562F5", d: "m24.964 57.104-.423-1.976-5.752.275.379 1.64 5.796.06Z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#3A36DB",
          d: "M27.913 35.792c.325 2.669 1.79 13.513 2.209 16.611a.71.71 0 0 1-.724.807l-24.843-.714a.71.71 0 0 1-.673-.557L.017 34.476a.712.712 0 0 1 .735-.866l26.497 1.557a.71.71 0 0 1 .664.624Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#3A36DB",
          d: "m17.926 46.79 3.672 10.457-8.538.182-.71-10.576a.82.82 0 0 1 .871-.875l3.987.266a.82.82 0 0 1 .719.547Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#3A36DB",
          d: "M25.06 57.396a.445.445 0 0 1-.422.584h-13.37a.444.444 0 0 1-.444-.445v-.576c0-.253.21-.455.463-.444l13.37.575c.184.008.345.13.402.306Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#364153",
          d: "M31.73 25.442c2.994.787 5.333-2.038 5.356-2.067l-.183-.15c-.022.028-2.267 2.736-5.113 1.988l-.06.229Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "url(#f)",
          d: "m30.973 25.037.035-.096a.33.33 0 0 1 .424-.198l.573.211c.171.063.26.253.197.425l-.035.096a.33.33 0 0 1-.424.198l-.573-.21a.332.332 0 0 1-.197-.426Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#364153",
          d: "m32.464 24.94-1.495-.427-.213 1.068 1.281.428.427-1.068Zm5.089-5.06s-.21-5.067-3.14-6.121c0 0 .917-.23 1.733.378.816.608 2.666 3.42 2.139 6.011-.645.084-.732-.268-.732-.268Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#364153",
          d: "M38.12 19.68c1.607.646 1.016 2.726 1.016 2.726-.16 1.559-.746 2.238-1.385 2.496a1.336 1.336 0 0 1-1.308-.176 1.347 1.347 0 0 1-.523-1.216c.045-.424.083-.828.077-.975-.012-.355.517-3.501 2.123-2.855Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#28313F",
          d: "M37.87 20.187a.77.77 0 0 1 .745.6c.574 2.502-.925 3.785-1.532 3.706-.64-.083-.07-3.14.208-3.899.117-.318.348-.409.578-.407Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#91B3FA",
          d: "m28.276 46.873.198-.025-1.22-9.659a1.266 1.266 0 0 0-1.178-1.106L3.178 34.695l-.012.2 22.898 1.388c.51.03.927.422.992.931l1.22 9.659Zm.547 2.727-.198.024.262 2.091.198-.025-.262-2.09Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#BECDFA",
          d: "M20.388 24.626S-1.925 13.565 5.372 5.42C12.67-2.724 26.274.531 26.962 9.103c.69 8.572-15.868 6.561-6.574 15.523Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#6562F5",
          d: "M7.035 7.524c0 .125.1.226.225.226h9.848a.225.225 0 0 0 0-.452H7.26a.225.225 0 0 0-.225.226Zm12.995.226h2.922a.225.225 0 0 0 0-.452H20.03a.225.225 0 0 0 0 .451ZM6.703 9.524c0 .125.1.226.225.226h3.698a.225.225 0 0 0 0-.452H6.928a.225.225 0 0 0-.225.226Zm9.123 0c0 .125.1.226.225.226h6.57a.225.225 0 0 0 0-.452h-6.57a.225.225 0 0 0-.225.226Zm-9.23 2.226h9.83a.225.225 0 0 0 0-.451h-9.83a.225.225 0 0 0 0 .451Zm12.291 0h3.403a.225.225 0 0 0 0-.451h-3.403a.225.225 0 0 0 0 .451Z"
        }
      )
    ] }),
    /* @__PURE__ */ jsxs("defs", { children: [
      /* @__PURE__ */ jsxs("linearGradient", { id: "b", x1: "36.412", x2: "29.89", y1: "21.947", y2: "20.245", gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#FEBBBA" }),
        /* @__PURE__ */ jsx("stop", { offset: "1", stopColor: "#FF928E" })
      ] }),
      /* @__PURE__ */ jsxs("linearGradient", { id: "c", x1: "73.798", x2: "11.65", y1: "12.078", y2: "76.265", gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#E1473D" }),
        /* @__PURE__ */ jsx("stop", { offset: "1", stopColor: "#E9605A" })
      ] }),
      /* @__PURE__ */ jsxs("linearGradient", { id: "d", x1: "44.473", x2: "37.683", y1: "46.877", y2: "64.684", gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#FEBBBA" }),
        /* @__PURE__ */ jsx("stop", { offset: "1", stopColor: "#FF928E" })
      ] }),
      /* @__PURE__ */ jsxs("linearGradient", { id: "e", x1: "36.1", x2: "29.31", y1: "43.684", y2: "61.491", gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#FEBBBA" }),
        /* @__PURE__ */ jsx("stop", { offset: "1", stopColor: "#FF928E" })
      ] }),
      /* @__PURE__ */ jsxs("linearGradient", { id: "f", x1: "30.95", x2: "32.22", y1: "25.211", y2: "25.211", gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#4F52FF" }),
        /* @__PURE__ */ jsx("stop", { offset: "1", stopColor: "#4042E2" })
      ] }),
      /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h99v66H0z" }) })
    ] })
  ] }) : /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsxs("g", { clipPath: "url(#a)", children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#28313F",
          d: "M64.437 57.258c-1.334 1.415-2.598 2.328-3.596 3.05-11.73 8.476-25.61 6.006-28.56 5.402-4.356-.891-12.776-2.614-18.863-9.824-9.21-10.909-7.777-28.096-.633-39.44 1.307-2.076 8.21-13.594 22.24-15.44 8.49-1.118 18.387 1.136 25.554 7.184 15.045 12.695 13.974 38.342 3.858 49.068Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1A202C",
          d: "m5.87 51.567 1.769 2.947a2.689 2.689 0 0 0 2.867 1.25l2.662-.57a2.246 2.246 0 0 1 2.004.567 24.039 24.039 0 0 0 4.41 3.267 2.261 2.261 0 0 1 1.13 1.757l.241 2.723a2.698 2.698 0 0 0 2.032 2.383l3.328.83a2.688 2.688 0 0 0 2.907-1.152l1.484-2.293a2.252 2.252 0 0 1 1.819-1.021 23.958 23.958 0 0 0 5.421-.815 2.245 2.245 0 0 1 2.035.44l2.087 1.753c.88.74 2.132.838 3.116.243l2.938-1.774a2.705 2.705 0 0 0 1.245-2.876l-.567-2.672a2.264 2.264 0 0 1 .564-2.01 24.112 24.112 0 0 0 3.256-4.425 2.252 2.252 0 0 1 1.751-1.135l2.715-.241a2.694 2.694 0 0 0 2.374-2.039l.827-3.339a2.705 2.705 0 0 0-1.147-2.917l-2.285-1.488a2.261 2.261 0 0 1-1.018-1.825 24.195 24.195 0 0 0-.812-5.44 2.263 2.263 0 0 1 .439-2.041l1.747-2.095a2.706 2.706 0 0 0 .242-3.126l-1.768-2.948a2.689 2.689 0 0 0-2.867-1.249l-2.662.569a2.246 2.246 0 0 1-2.003-.567 24.035 24.035 0 0 0-4.411-3.267 2.261 2.261 0 0 1-1.13-1.756l-.241-2.723a2.698 2.698 0 0 0-2.032-2.383l-3.328-.83a2.688 2.688 0 0 0-2.907 1.151l-1.484 2.293a2.25 2.25 0 0 1-1.818 1.021 23.97 23.97 0 0 0-5.422.816 2.248 2.248 0 0 1-2.035-.441l-2.087-1.753a2.685 2.685 0 0 0-3.116-.243l-2.938 1.774a2.704 2.704 0 0 0-1.245 2.876l.567 2.672a2.264 2.264 0 0 1-.564 2.01 24.108 24.108 0 0 0-3.257 4.425 2.252 2.252 0 0 1-1.75 1.135l-2.714.241a2.695 2.695 0 0 0-2.375 2.04l-.827 3.338a2.705 2.705 0 0 0 1.147 2.917l2.286 1.488a2.262 2.262 0 0 1 1.017 1.825 24.19 24.19 0 0 0 .813 5.44 2.264 2.264 0 0 1-.44 2.041L6.114 48.44a2.708 2.708 0 0 0-.242 3.127Zm7.746-5.025c-4.702-10-.435-21.93 9.531-26.648 9.966-4.718 21.857-.437 26.56 9.563 4.701 10 .434 21.93-9.532 26.649-9.966 4.718-21.857.436-26.56-9.564Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#EB5757",
          d: "M42.929 32.753c-2.128-.459-9.384-1.805-16.981-.713a8.787 8.787 0 0 0-6.171 4.03c-2.475 3.927-5.975 10.93-5.235 18.234l3.884.964s2.684-8.666 5.705-12.193c0 0 3.578 8.183 3.397 12.676a7.112 7.112 0 0 1-.024.372c-.41 4.396 17.174.82 17.174.82l-1.095-23.416a.83.83 0 0 0-.654-.775Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FEBBBA",
          d: "m36.88 24.53.51 6.083c.048.566-.242 1.095-.727 1.322-1.116.522-3.259 1.27-5.55.721-.42-.1-.693-.54-.624-.989l1.486-9.643 4.904 2.505Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FEBBBA",
          d: "M30.055 17.156s-1.154 4.495-.925 6.72c.229 2.226-.017 3.734 2.596 3.77 2.612.037 4.552-1.577 5.362-3.96 0 0 1.279-3.678.65-4.999-.629-1.321-7.683-1.531-7.683-1.531Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#605CFF",
          d: "m35.967 22.245-.322.052s.89-2.938-.349-3.23c-1.24-.292-5.998-.496-7.254-1.978-1.21-1.428-.68-3.608.507-4.385a.173.173 0 0 1 .23.045l.139.185a.175.175 0 0 0 .313-.084c.018-.149.204-.21.302-.097.383.442 1.334 1.107 3.61 1.162 3.228.078 5.505 1.02 5.902 3.187.026.137.184.19.29.099.21-.179.57-.305 1.13.034.978.588.925 2.53-.716 4.383-.078.088-.055.229.053.276.378.169.972.62-.237 1.54-1.237.942-2.05.991-2.364.962a.175.175 0 0 1-.16-.158l-.188-1.946a.175.175 0 0 0-.201-.156l-.685.11Z"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "url(#b)", d: "M35.953 22.661s.268-2.796 1.588-2.236c1.32.56-.144 3.108-1.092 3.363l-.496-1.127Z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#EB5757",
          d: "M43.5 49.957c.379-2.687-2.395-6.636-3.542-8.135a2.495 2.495 0 0 1-.516-1.493c-.033-3.805 1.25-5.793 3.802-7.434 0 0 9.568 10.368 7.21 18.694a7.012 7.012 0 0 1-1.148 2.334c-.372-3.137-3.986-3.821-5.807-3.966Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "url(#c)",
          d: "m43.325 48.918.353-.04c-.299-2.635-2.603-5.888-3.58-7.164l-.282.217c.96 1.253 3.22 4.44 3.51 6.987Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "url(#d)",
          d: "M43.426 50.33c.033-.121.055-.246.073-.373 1.821.145 5.435.83 5.807 3.966-4.132 5.484-15.523 3.506-15.523 3.506v-2.134s8.748-1.63 9.643-4.966Z"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "url(#e)", d: "M34.88 56.84s-1.682-3.982-4.645-2.57c-2.964 1.413-2.73 2.337-2.73 2.337l7.375.233Z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#605CFF",
          d: "M35.257 57.666a.563.563 0 0 1-.58.52l-15.356-.537a.563.563 0 0 1-.517-.396l-.446-1.431a.564.564 0 0 1 .507-.732l5.6-.299a.554.554 0 0 1 .151.013l10.202 2.267c.274.06.461.315.44.595Z"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "url(#f)", d: "m24.964 57.104-.423-1.976-5.752.276.379 1.639 5.796.06Z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#605CFF",
          d: "M27.913 35.792c.325 2.669 1.79 13.513 2.209 16.611a.71.71 0 0 1-.724.807l-24.843-.714a.71.71 0 0 1-.673-.557L.017 34.476a.712.712 0 0 1 .735-.866l26.497 1.557a.71.71 0 0 1 .664.624Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#605CFF",
          d: "m17.926 46.79 3.672 10.457-8.538.182-.71-10.576a.82.82 0 0 1 .871-.875l3.987.266a.82.82 0 0 1 .719.547Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#605CFF",
          d: "M25.06 57.396a.445.445 0 0 1-.422.584h-13.37a.444.444 0 0 1-.444-.445v-.576c0-.253.21-.455.463-.444l13.37.575c.184.008.345.13.402.306Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#364153",
          d: "M31.73 25.442c2.994.787 5.333-2.038 5.356-2.067l-.183-.15c-.022.028-2.267 2.736-5.113 1.988l-.06.229Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "url(#g)",
          d: "m30.973 25.037.035-.096a.33.33 0 0 1 .424-.198l.573.211c.171.063.26.253.197.425l-.035.097a.33.33 0 0 1-.424.197l-.573-.21a.332.332 0 0 1-.197-.426Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#364153",
          d: "m32.464 24.94-1.495-.426-.213 1.067 1.281.428.427-1.068Zm5.089-5.06s-.21-5.067-3.14-6.121c0 0 .917-.23 1.733.378.816.608 2.666 3.42 2.139 6.012-.645.083-.732-.27-.732-.27Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#364153",
          d: "M38.12 19.68c1.607.646 1.016 2.726 1.016 2.726-.16 1.559-.746 2.238-1.385 2.496a1.336 1.336 0 0 1-1.308-.176 1.347 1.347 0 0 1-.523-1.216c.045-.424.083-.828.077-.975-.012-.355.517-3.501 2.123-2.855Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#28313F",
          d: "M37.87 20.187a.771.771 0 0 1 .745.6c.574 2.502-.925 3.785-1.532 3.706-.64-.083-.07-3.14.208-3.899.117-.318.348-.409.578-.407Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#91B3FA",
          d: "m28.276 46.873.198-.025-1.22-9.659a1.266 1.266 0 0 0-1.178-1.106L3.178 34.695l-.012.2 22.898 1.388c.51.03.927.422.992.931l1.22 9.659Zm.547 2.727-.198.024.262 2.091.198-.025-.262-2.09Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#BECDFA",
          d: "M20.388 24.626S-1.925 13.565 5.372 5.42C12.67-2.724 26.274.531 26.962 9.103c.69 8.572-15.868 6.561-6.574 15.523Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M7.035 7.524c0 .124.1.225.225.225h9.848a.225.225 0 0 0 0-.451H7.26a.225.225 0 0 0-.225.226Zm12.995.226h2.922a.225.225 0 0 0 0-.452H20.03a.225.225 0 0 0 0 .451ZM6.703 9.524c0 .125.1.226.225.226h3.698a.225.225 0 0 0 0-.452H6.928a.225.225 0 0 0-.225.226Zm9.123 0c0 .125.1.226.225.226h6.57a.225.225 0 0 0 0-.452h-6.57a.225.225 0 0 0-.225.226Zm-9.23 2.226h9.83a.225.225 0 0 0 0-.451h-9.83a.225.225 0 0 0 0 .451Zm12.291 0h3.403a.225.225 0 0 0 0-.451h-3.403a.225.225 0 0 0 0 .451Z"
        }
      )
    ] }),
    /* @__PURE__ */ jsxs("defs", { children: [
      /* @__PURE__ */ jsxs("linearGradient", { id: "b", x1: "36.412", x2: "29.89", y1: "21.947", y2: "20.245", gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#FEBBBA" }),
        /* @__PURE__ */ jsx("stop", { offset: "1", stopColor: "#FF928E" })
      ] }),
      /* @__PURE__ */ jsxs("linearGradient", { id: "c", x1: "73.798", x2: "11.65", y1: "12.078", y2: "76.265", gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#E1473D" }),
        /* @__PURE__ */ jsx("stop", { offset: "1", stopColor: "#E9605A" })
      ] }),
      /* @__PURE__ */ jsxs("linearGradient", { id: "d", x1: "44.473", x2: "37.683", y1: "46.877", y2: "64.684", gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#FEBBBA" }),
        /* @__PURE__ */ jsx("stop", { offset: "1", stopColor: "#FF928E" })
      ] }),
      /* @__PURE__ */ jsxs("linearGradient", { id: "e", x1: "36.1", x2: "29.31", y1: "43.684", y2: "61.492", gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#FEBBBA" }),
        /* @__PURE__ */ jsx("stop", { offset: "1", stopColor: "#FF928E" })
      ] }),
      /* @__PURE__ */ jsxs("linearGradient", { id: "f", x1: "18.839", x2: "22.348", y1: "52.189", y2: "56.693", gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#4F52FF" }),
        /* @__PURE__ */ jsx("stop", { offset: "1", stopColor: "#4042E2" })
      ] }),
      /* @__PURE__ */ jsxs("linearGradient", { id: "g", x1: "30.95", x2: "32.22", y1: "25.211", y2: "25.211", gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#4F52FF" }),
        /* @__PURE__ */ jsx("stop", { offset: "1", stopColor: "#4042E2" })
      ] }),
      /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h99v66H0z" }) })
    ] })
  ] });
}, TableCross = () => {
  const { theme: t } = useContext(ConfigContext);
  return t === "light" ? /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#D2DFFA",
        d: "M86.77 51.826c-5.814 20.268-47.852 13.918-61.33 10.321C16.356 65.431 0 58.863 0 38.22c0-8.914 13.175-7.507 22.26-19.705C31.347 6.317 41.796-2.597 54.517.687 67.236 3.97 94.04 26.49 86.77 51.826Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#605CFF", d: "M9.42 52.759V19.01h66.712v33.75H9.42Z" }),
    /* @__PURE__ */ jsx("path", { fill: "#605CFF", d: "M9.42 53.544v-9.418h.785v9.418z" }),
    /* @__PURE__ */ jsx("path", { fill: "#4541C9", d: "M24.332 36.277V19.01h.785v17.267zm0 17.267v-9.418h.785v9.418z" }),
    /* @__PURE__ */ jsx("path", { fill: "#605CFF", d: "M14.129 44.91v-9.418h.785v9.418z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#4541C9",
        d: "M76.133 53.543V19.01h.785v34.533zM9.42 9.592h67.497v9.418H9.42zM24.332 44.91v-9.418h.785v9.418z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#4541C9",
        d: "M9.42 35.492h67.497v.785H9.42zm0 8.633h67.497v.785H9.42zm0 8.634h67.497v.785H9.42zm0-25.9h67.497v.785H9.42z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#06152B",
        d: "m4.578 40.201.354-.353.353.353-.353.354-.354-.354Zm-3.27.5a.5.5 0 1 1 0-1v1Zm1.662-2.816 1.962 1.963-.707.707-1.963-1.962.708-.708Zm1.962 2.67L2.97 42.517l-.708-.707 1.963-1.962.707.707Zm-.354.146h-3.27v-1h3.27v1Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { stroke: "#06152B", d: "M6.541 37.912v4.578" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#BECDFA",
        d: "M14.12 26.335v-.445h.69m4.139.445v-.445h-.575m0 0-.581-1.892m.581 1.892-1.782-1.13m1.782 1.13h-1.782m-1.783 0 .581-1.892m-.58 1.892 1.782-1.13m-1.783 1.13h1.783m-1.093-4.119h2.07m.224 2.227-1.201.762m1.2-.762h-1.2m1.2 0-.453-1.478m-1.949 1.478 1.202.762m-1.202-.762h1.202m-1.202 0 .454-1.478m.748 2.24v1.13m0-1.892.747-1.478m-.747 1.478-.748-1.478m1.495 0-.23-.749v-.668h-1.035v.668l-.23.749m1.495 0h-1.495M14.12 34.184v-.445h.69m4.139.445v-.445h-.575m0 0-.581-1.893m.581 1.893-1.782-1.13m1.782 1.13h-1.782m-1.783 0 .581-1.893m-.58 1.893 1.782-1.13m-1.783 1.13h1.783m-1.093-4.12h2.07m.224 2.227-1.201.762m1.2-.762h-1.2m1.2 0-.453-1.477m-1.949 1.477 1.202.762m-1.202-.762h1.202m-1.202 0 .454-1.477m.748 2.24v1.13m0-1.893.747-1.477m-.747 1.477-.748-1.477m1.495 0-.23-.75v-.667h-1.035v.668l-.23.748m1.495 0h-1.495M14.12 42.817v-.445h.69m4.139.445v-.445h-.575m0 0-.581-1.893m.581 1.893-1.782-1.13m1.782 1.13h-1.782m-1.783 0 .581-1.893m-.58 1.893 1.782-1.13m-1.783 1.13h1.783m-1.093-4.12h2.07m.224 2.227-1.201.762m1.2-.762h-1.2m1.2 0-.453-1.477m-1.949 1.477 1.202.762m-1.202-.762h1.202m-1.202 0 .454-1.477m.748 2.24v1.13m0-1.893.747-1.477m-.747 1.477-.748-1.477m1.495 0-.23-.75v-.667h-1.035v.668l-.23.749m1.495 0h-1.495M14.12 51.45v-.445h.69m4.139.446v-.446h-.575m0 0-.581-1.892m.581 1.892-1.782-1.13m1.782 1.13h-1.782m-1.783 0 .581-1.892m-.58 1.892 1.782-1.13m-1.783 1.13h1.783m-1.093-4.119h2.07m.224 2.227-1.201.762m1.2-.762h-1.2m1.2 0-.453-1.478m-1.949 1.478 1.202.762m-1.202-.762h1.202m-1.202 0 .454-1.478m.748 2.24v1.13m0-1.892.747-1.478m-.747 1.478-.748-1.478m1.495 0-.23-.749v-.668h-1.035v.668l-.23.75m1.495 0h-1.495"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#fff",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M27.47 22.934h18.837M30.61 31.568h18.836m-21.192 8.633H47.09m-18.836 8.633h14.912M54.94 31.568h18.836m-21.19 8.633h18.836m-24.33 8.633h14.912m-8.634-25.9h18.836"
      }
    ),
    /* @__PURE__ */ jsx("circle", { cx: "70.635", cy: "52.759", r: "8.241", fill: "#EB5757" }),
    /* @__PURE__ */ jsx("path", { stroke: "#fff", strokeLinecap: "round", d: "m66.975 56.421 7.325-7.325m0 7.325-7.325-7.325" })
  ] }) : /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#28313F",
        d: "M86.77 51.826c-5.814 20.268-47.852 13.918-61.33 10.321C16.356 65.431 0 58.863 0 38.22c0-8.914 13.175-7.507 22.26-19.705C31.347 6.317 41.796-2.597 54.517.687 67.236 3.97 94.04 26.49 86.77 51.826Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#605CFF", d: "M9.42 52.759V19.01h66.712v33.75H9.42Z" }),
    /* @__PURE__ */ jsx("path", { fill: "#605CFF", d: "M9.42 53.544v-9.418h.785v9.418z" }),
    /* @__PURE__ */ jsx("path", { fill: "#4541C9", d: "M24.332 36.277V19.01h.785v17.267zm0 17.267v-9.418h.785v9.418z" }),
    /* @__PURE__ */ jsx("path", { fill: "#605CFF", d: "M14.129 44.91v-9.418h.785v9.418z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#4541C9",
        d: "M76.133 53.543V19.01h.785v34.533zM9.42 9.592h67.497v9.418H9.42zM24.332 44.91v-9.418h.785v9.418z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#4541C9",
        d: "M9.42 35.492h67.497v.785H9.42zm0 8.633h67.497v.785H9.42zm0 8.634h67.497v.785H9.42zm0-25.9h67.497v.785H9.42z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#CCD2E3",
        d: "m4.578 40.201.354-.353.353.353-.353.354-.354-.354Zm-3.27.5a.5.5 0 0 1 0-1v1Zm1.662-2.816 1.962 1.963-.707.707-1.963-1.962.708-.708Zm1.962 2.67L2.97 42.517l-.708-.707 1.963-1.962.707.707Zm-.354.146h-3.27v-1h3.27v1Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { stroke: "#CCD2E3", d: "M6.541 37.912v4.578" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#BECDFA",
        d: "M14.12 26.335v-.445h.69m4.139.445v-.445h-.575m0 0-.581-1.892m.581 1.892-1.782-1.13m1.782 1.13h-1.782m-1.783 0 .581-1.892m-.58 1.892 1.782-1.13m-1.783 1.13h1.783m-1.093-4.119h2.07m.224 2.227-1.201.762m1.2-.762h-1.2m1.2 0-.453-1.478m-1.949 1.478 1.202.762m-1.202-.762h1.202m-1.202 0 .454-1.478m.748 2.24v1.13m0-1.892.747-1.478m-.747 1.478-.748-1.478m1.495 0-.23-.749v-.668h-1.035v.668l-.23.75m1.495 0h-1.495M14.12 34.184v-.445h.69m4.139.445v-.445h-.575m0 0-.581-1.893m.581 1.893-1.782-1.13m1.782 1.13h-1.782m-1.783 0 .581-1.893m-.58 1.893 1.782-1.13m-1.783 1.13h1.783m-1.093-4.12h2.07m.224 2.227-1.201.762m1.2-.762h-1.2m1.2 0-.453-1.477m-1.949 1.477 1.202.762m-1.202-.762h1.202m-1.202 0 .454-1.477m.748 2.24v1.13m0-1.893.747-1.477m-.747 1.477-.748-1.477m1.495 0-.23-.75v-.667h-1.035v.668l-.23.748m1.495 0h-1.495M14.12 42.817v-.445h.69m4.139.445v-.445h-.575m0 0-.581-1.892m.581 1.892-1.782-1.13m1.782 1.13h-1.782m-1.783 0 .581-1.892m-.58 1.892 1.782-1.13m-1.783 1.13h1.783m-1.093-4.12h2.07m.224 2.227-1.201.762m1.2-.761h-1.2m1.2 0-.453-1.478m-1.949 1.477 1.202.762m-1.202-.761h1.202m-1.202 0 .454-1.478m.748 2.24v1.13m0-1.892.747-1.478m-.747 1.477-.748-1.477m1.495 0-.23-.75v-.667h-1.035v.668l-.23.749m1.495 0h-1.495M14.12 51.45v-.445h.69m4.139.446v-.446h-.575m0 0-.581-1.892m.581 1.892-1.782-1.13m1.782 1.13h-1.782m-1.783 0 .581-1.892m-.58 1.892 1.782-1.13m-1.783 1.13h1.783m-1.093-4.119h2.07m.224 2.227-1.201.762m1.2-.762h-1.2m1.2 0-.453-1.478m-1.949 1.478 1.202.762m-1.202-.762h1.202m-1.202 0 .454-1.478m.748 2.24v1.13m0-1.892.747-1.478m-.747 1.478-.748-1.478m1.495 0-.23-.749v-.668h-1.035v.668l-.23.75m1.495 0h-1.495"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M27.47 22.934h18.837M30.61 31.568h18.836m-21.192 8.633H47.09m-18.836 8.633h14.912M54.94 31.568h18.836m-21.19 8.633h18.836m-24.33 8.633h14.912m-8.634-25.9h18.836"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#EB5757",
        fillRule: "evenodd",
        d: "M78.876 52.759a8.24 8.24 0 1 1-16.481 0 8.24 8.24 0 0 1 16.481 0ZM66.62 56.775a.5.5 0 0 1 0-.707l3.31-3.31-3.31-3.308a.5.5 0 1 1 .707-.707l3.31 3.309 3.309-3.31a.5.5 0 1 1 .707.708l-3.31 3.309 3.31 3.309a.5.5 0 1 1-.707.707l-3.31-3.31-3.309 3.31a.5.5 0 0 1-.707 0Z",
        clipRule: "evenodd"
      }
    )
  ] });
}, Mail = () => {
  const { theme: t } = useContext(ConfigContext);
  return t === "light" ? /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#D2DFFA",
        d: "M88.097 51.319C82.194 71.389 39.513 65.1 25.83 61.539 16.605 64.791 0 58.287 0 37.846c0-8.827 13.376-7.433 22.6-19.512C31.827 6.254 42.435-2.572 55.35.68c12.914 3.252 40.127 25.552 32.747 50.639Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#4541C9",
        d: "M5.791 30.544a8 8 0 0 1 2.918-6.178l24.328-20.01a8 8 0 0 1 10.087-.062l25.026 20.07a8 8 0 0 1 2.996 6.241v25.406a8 8 0 0 1-8 8H13.79a8 8 0 0 1-8-8V30.544Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#EB5757",
        d: "M19.855 13.72a1 1 0 0 1 1-1h35.228a1 1 0 0 1 1 1v29.717l-18.614 8.165-18.614-8.165V13.72Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#974146",
        fillRule: "evenodd",
        d: "M50.463 22.647c0 .914-.74 1.655-1.655 1.655H27.3a1.655 1.655 0 0 1 0-3.31h21.51c.913 0 1.654.741 1.654 1.655Zm0 6.618c0 .914-.74 1.655-1.655 1.655H27.3a1.655 1.655 0 0 1 0-3.31h21.51c.913 0 1.654.742 1.654 1.655Zm0 6.619c0 .913-.74 1.654-1.655 1.654H27.3a1.655 1.655 0 0 1 0-3.309h21.51c.913 0 1.654.74 1.654 1.655Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#6562F5",
        d: "m5.791 29.265 28.166 17.09a8 8 0 0 0 8.223.045l28.966-17.135v26.746a8 8 0 0 1-8 8H13.79a8 8 0 0 1-8-8V29.265Z"
      }
    )
  ] }) : /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#28313F",
        d: "M88.097 51.319C82.194 71.389 39.513 65.1 25.83 61.539 16.605 64.791 0 58.287 0 37.846c0-8.827 13.376-7.433 22.6-19.512C31.827 6.254 42.435-2.572 55.35.68c12.914 3.252 40.127 25.552 32.747 50.639Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#4541C9",
        d: "M5.791 30.544a8 8 0 0 1 2.918-6.178l24.328-20.01a8 8 0 0 1 10.087-.062l25.026 20.07a8 8 0 0 1 2.996 6.241v25.406a8 8 0 0 1-8 8H13.79a8 8 0 0 1-8-8V30.544Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#EB5757",
        d: "M19.855 13.72a1 1 0 0 1 1-1h35.228a1 1 0 0 1 1 1v29.717l-18.614 8.165-18.614-8.165V13.72Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#605CFF",
        d: "m5.791 29.265 28.166 17.09a8 8 0 0 0 8.223.045l28.966-17.135v26.746a8 8 0 0 1-8 8H13.79a8 8 0 0 1-8-8V29.265Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#1A202C",
        fillRule: "evenodd",
        d: "M50.463 22.647c0 .914-.74 1.655-1.655 1.655H27.3a1.655 1.655 0 1 1 0-3.31h21.51c.913 0 1.654.741 1.654 1.655Zm0 6.618c0 .914-.74 1.655-1.655 1.655H27.3a1.655 1.655 0 0 1 0-3.31h21.51c.913 0 1.654.742 1.654 1.655Zm0 6.619c0 .913-.74 1.654-1.655 1.654H27.3a1.655 1.655 0 0 1 0-3.309h21.51c.913 0 1.654.74 1.654 1.655Z",
        clipRule: "evenodd"
      }
    )
  ] });
}, CreateLink = () => {
  const { theme: t } = useContext(ConfigContext);
  return t === "light" ? /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsxs("g", { clipPath: "url(#a)", children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#D2DFFA",
          d: "M1.259 51.319c5.958 20.07 49.034 13.782 62.844 10.22 9.31 3.252 26.069-3.252 26.069-23.693 0-8.827-13.5-7.433-22.81-19.512C58.052 6.254 47.345-2.572 34.31.68 21.276 3.932-6.19 26.232 1.26 51.319Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#6562F5",
          fillRule: "evenodd",
          d: "M7.445 27.818v10.755H29.78V27.818H7.445Zm-.828-2.482c-.913 0-1.654.741-1.654 1.655v12.41c0 .913.74 1.654 1.654 1.654h23.991c.914 0 1.655-.741 1.655-1.655V26.991c0-.914-.74-1.655-1.655-1.655H6.618Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          stroke: "#6562F5",
          strokeLinecap: "round",
          strokeWidth: "5",
          d: "M38.88 13.755V3m0 49.148v10.754m-12.7-46.327L18.76 8.79m7.42 40.536-7.42 7.784m32.555-40.536 7.421-7.784m-7.42 40.536 7.42 7.784"
        }
      ),
      /* @__PURE__ */ jsx("path", { stroke: "#EB5757", strokeLinecap: "round", strokeWidth: "2", d: "M39.709 28.232v5.79m-2.895-2.895h5.791" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#3A36DB",
          fillRule: "evenodd",
          d: "M52.03 24.277 49.864 35.54l22.02 4.238 2.167-11.262-22.02-4.238Zm-.343-2.593a1.655 1.655 0 0 0-1.937 1.312l-2.48 12.887a1.655 1.655 0 0 0 1.312 1.937l23.644 4.55a1.655 1.655 0 0 0 1.937-1.312l2.48-12.887a1.655 1.655 0 0 0-1.312-1.937l-23.644-4.55Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("mask", { id: "b", width: "39", height: "32", x: "18", y: "18", maskUnits: "userSpaceOnUse", children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#4541C9",
          d: "M30.609 41.055c.913 0 1.654-.741 1.654-1.655v-6.204l18.2-.828 1.655-8.686 4.136 10.754-9.1 6.205-15.304 9.1-10.755-3.723-2.482-4.963 4.964-17.373 26.886-5.377-.413 4.136-1.655 7.445-19.027 2.069.414 6.618h-4.964l-.207 2.482h5.998Z"
        }
      ) }),
      /* @__PURE__ */ jsx("g", { mask: "url(#b)", children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#EB5757",
          fillRule: "evenodd",
          d: "m26.358 29.724 3.603 10.888 21.288-7.043-3.602-10.888-21.289 7.043Zm-1.564-2.096a1.655 1.655 0 0 0-1.052 2.09l4.122 12.46a1.655 1.655 0 0 0 2.09 1.05l22.86-7.562a1.655 1.655 0 0 0 1.051-2.09l-4.122-12.46a1.654 1.654 0 0 0-2.09-1.05l-22.86 7.562Z",
          clipRule: "evenodd"
        }
      ) })
    ] }),
    /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h99v66H0z" }) }) })
  ] }) : /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsxs("g", { clipPath: "url(#a)", children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#28313F",
          d: "M1.259 51.319c5.958 20.07 49.034 13.782 62.844 10.22 9.31 3.252 26.069-3.252 26.069-23.693 0-8.827-13.5-7.433-22.81-19.512C58.052 6.254 47.345-2.572 34.31.68 21.276 3.932-6.19 26.232 1.26 51.319Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#605CFF",
          fillRule: "evenodd",
          d: "M7.445 27.818v10.755H29.78V27.818H7.445Zm-.828-2.482c-.913 0-1.654.741-1.654 1.655V39.4c0 .914.74 1.654 1.654 1.654h23.991c.914 0 1.655-.74 1.655-1.654V26.99c0-.913-.74-1.654-1.655-1.654H6.618Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          stroke: "#1A202C",
          strokeLinecap: "round",
          strokeWidth: "5",
          d: "M38.88 13.755V3m0 49.148v10.754m-12.7-46.327L18.76 8.79m7.42 40.537-7.42 7.784m32.555-40.536 7.421-7.784m-7.421 40.536 7.421 7.784"
        }
      ),
      /* @__PURE__ */ jsx("path", { stroke: "#EB5757", strokeLinecap: "round", strokeWidth: "2", d: "M39.709 28.232v5.79m-2.894-2.895h5.79" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#4541C9",
          fillRule: "evenodd",
          d: "M52.03 24.277 49.864 35.54l22.02 4.238 2.167-11.262-22.02-4.238Zm-.343-2.593a1.655 1.655 0 0 0-1.937 1.312l-2.48 12.887a1.655 1.655 0 0 0 1.312 1.937l23.644 4.55a1.655 1.655 0 0 0 1.937-1.312l2.48-12.887a1.655 1.655 0 0 0-1.312-1.937l-23.644-4.55Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("mask", { id: "b", width: "39", height: "32", x: "18", y: "18", maskUnits: "userSpaceOnUse", children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#4541C9",
          d: "M30.609 41.054c.913 0 1.654-.74 1.654-1.654v-6.204l18.2-.828 1.655-8.686 4.136 10.754-9.1 6.205-15.304 9.1-10.755-3.723-2.482-4.964 4.964-17.372 26.886-5.377-.413 4.136-1.655 7.445-19.027 2.069.414 6.618h-4.964l-.207 2.481h5.998Z"
        }
      ) }),
      /* @__PURE__ */ jsx("g", { mask: "url(#b)", children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#EB5757",
          fillRule: "evenodd",
          d: "m26.358 29.724 3.603 10.888 21.288-7.043-3.602-10.888-21.289 7.043Zm-1.564-2.096a1.655 1.655 0 0 0-1.052 2.09l4.122 12.46a1.655 1.655 0 0 0 2.09 1.05l22.86-7.562a1.655 1.655 0 0 0 1.051-2.09l-4.122-12.46a1.655 1.655 0 0 0-2.09-1.05l-22.86 7.562Z",
          clipRule: "evenodd"
        }
      ) })
    ] }),
    /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h99v66H0z" }) }) })
  ] });
}, CloseNotSave = () => {
  const { theme: t } = useContext(ConfigContext);
  return t === "light" ? /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#D2DFFA",
        d: "M90.707 51.38C84.63 71.36 40.684 65.1 26.595 61.556 17.097 64.792 0 58.318 0 37.969c0-8.787 13.772-7.4 23.27-19.424C32.77 6.521 43.691-2.266 56.99.971c13.297 3.237 41.317 25.436 33.718 50.41Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#3A36DB", d: "M7.596 41.47V21.707h74.269l-.001 19.765H7.596Z" }),
    /* @__PURE__ */ jsx("ellipse", { cx: "76.801", cy: "25", fill: "#F1F4FA", rx: ".844", ry: ".824" }),
    /* @__PURE__ */ jsx("ellipse", { cx: "73.424", cy: "25", fill: "#BECDFA", rx: ".844", ry: ".824" }),
    /* @__PURE__ */ jsx("ellipse", { cx: "70.049", cy: "25", fill: "#6562F5", rx: ".844", ry: ".824" }),
    /* @__PURE__ */ jsx("path", { fill: "#EB5757", d: "M13.504 29.118h59.922v4.94H13.504v-4.94Z" }),
    /* @__PURE__ */ jsx("path", { fill: "#F1F4FA", d: "M52.084 47.484c0-.636.515-1.15 1.15-1.15h2.12c.636 0 1.15.514 1.15 1.15h-4.42Z" }),
    /* @__PURE__ */ jsx("path", { fill: "#6562F5", d: "M24.475 6.235a1 1 0 0 1 1-1h35.978a1 1 0 0 1 1 1v27.93H24.475V6.236Z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#F1F4FA",
        strokeLinecap: "round",
        strokeWidth: "2",
        d: "M37.133 26.647a8.55 8.55 0 0 1 6.752-3.294 8.55 8.55 0 0 1 6.751 3.294m-15.191-9.025L39.7 13.47m0 4.152-4.255-4.151m12.625 4.151 4.255-4.151m-.001 4.151L48.07 13.47"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#6562F5",
        d: "M24.475 41.47h1.997v23h-1.998v-23Zm3.998 0h1.998v13h-1.998v-13Zm0 15h1.998v4h-1.998v-4Zm3.997-15h1.999v20H32.47v-20Zm3.999 0h1.998v7h-1.998v-7Zm0 9h1.998v10h-1.998v-10Zm3.998-9h1.998v23h-1.998v-23Zm3.998 0h1.998v20h-1.998v-20Zm3.995 0h1.999v12H48.46v-12Zm0 14h1.999v5H48.46v-5Zm3.999-14h1.998v23h-1.998v-23Zm3.998 0h1.998v15h-1.998v-15Zm0 17h1.998v2h-1.998v-2Zm3.998-17h1.998v20h-1.998v-20Z"
      }
    )
  ] }) : /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#28313F",
        d: "M90.707 51.38C84.63 71.36 40.684 65.1 26.595 61.556 17.097 64.792 0 58.318 0 37.97c0-8.787 13.772-7.4 23.27-19.424C32.77 6.521 43.691-2.266 56.99.971c13.297 3.237 41.317 25.436 33.718 50.41Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#4541C9", d: "M7.596 41.47V21.707h74.269l-.001 19.765H7.596Z" }),
    /* @__PURE__ */ jsx("ellipse", { cx: "76.801", cy: "25", fill: "#28313F", rx: ".844", ry: ".824" }),
    /* @__PURE__ */ jsx("ellipse", { cx: "73.424", cy: "25", fill: "#1A202C", rx: ".844", ry: ".824" }),
    /* @__PURE__ */ jsx("ellipse", { cx: "70.049", cy: "25", fill: "#605CFF", rx: ".844", ry: ".824" }),
    /* @__PURE__ */ jsx("path", { fill: "#EB5757", d: "M13.504 29.118h59.922v4.94H13.504v-4.94Z" }),
    /* @__PURE__ */ jsx("path", { fill: "#28313F", d: "M52.084 47.484c0-.636.515-1.15 1.15-1.15h2.12c.636 0 1.15.514 1.15 1.15h-4.42Z" }),
    /* @__PURE__ */ jsx("path", { fill: "#7471FF", d: "M24.475 6.235a1 1 0 0 1 1-1h35.978a1 1 0 0 1 1 1v27.93H24.475V6.236Z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#28313F",
        strokeLinecap: "round",
        strokeWidth: "2",
        d: "M37.133 26.647a8.55 8.55 0 0 1 6.752-3.294 8.55 8.55 0 0 1 6.751 3.294m-15.191-9.025 4.255-4.151m0 4.151-4.255-4.151m12.625 4.151 4.255-4.151m-.001 4.151-4.254-4.151"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#7471FF",
        d: "M24.475 41.47h1.997v23h-1.998v-23Zm3.998 0h1.998v13h-1.998v-13Zm0 15h1.998v4h-1.998v-4Zm3.997-15h1.999v20H32.47v-20Zm3.999 0h1.998v7h-1.998v-7Zm0 9h1.998v10h-1.998v-10Zm3.998-9h1.998v23h-1.998v-23Zm3.998 0h1.998v20h-1.998v-20Zm3.995 0h1.999v12H48.46v-12Zm0 14h1.999v5H48.46v-5Zm3.999-14h1.998v23h-1.998v-23Zm3.998 0h1.998v15h-1.998v-15Zm0 17h1.998v2h-1.998v-2Zm3.998-17h1.998v20h-1.998v-20Z"
      }
    )
  ] });
}, NoPage = () => {
  const { theme: t } = useContext(ConfigContext);
  return t === "light" ? /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#D2DFFA",
        d: "M37 58.5a5.5 5.5 0 0 1 5.5-5.5h31a5.5 5.5 0 1 1 0 11h-31a5.5 5.5 0 0 1-5.5-5.5Zm-13 0a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0Zm0-51A5.5 5.5 0 0 1 29.5 2h21a5.5 5.5 0 1 1 0 11h-21A5.5 5.5 0 0 1 24 7.5Zm55.359 31.747H77.22a5.159 5.159 0 0 1-3.638-1.5 5.108 5.108 0 0 1-1.508-3.62c0-1.324.516-2.596 1.439-3.55a5.157 5.157 0 0 1 3.51-1.565h1.615a5.548 5.548 0 0 0 3.802-1.673A5.494 5.494 0 0 0 84 23.506c0-1.43-.56-2.806-1.56-3.833A5.548 5.548 0 0 0 78.638 18h-56.69a5.549 5.549 0 0 0-3.801 1.673 5.495 5.495 0 0 0-1.56 3.833c0 1.431.56 2.806 1.56 3.833a5.549 5.549 0 0 0 3.801 1.673h.55c1.33.05 2.587.612 3.51 1.566a5.107 5.107 0 0 1 1.438 3.549c0 1.358-.542 2.66-1.507 3.62a5.159 5.159 0 0 1-3.639 1.5h-1.902a4.409 4.409 0 0 0-3.11 1.282A4.366 4.366 0 0 0 16 43.624c0 1.16.463 2.273 1.288 3.094A4.41 4.41 0 0 0 20.398 48h58.96a4.41 4.41 0 0 0 3.11-1.282 4.365 4.365 0 0 0 0-6.189 4.409 4.409 0 0 0-3.11-1.282Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#3A36DB",
        d: "M73.705 16.796a2.89 2.89 0 0 0-2.861 3.307 2.888 2.888 0 0 0 3.276 2.434 2.89 2.89 0 0 0 2.434-3.275 2.866 2.866 0 0 0-1.134-1.896 2.864 2.864 0 0 0-1.715-.57Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#3A36DB",
        fillRule: "evenodd",
        d: "M62.434 31.605a.257.257 0 0 1-.287-.079h-.001l-2.367-2.9a.257.257 0 0 1-.02-.298l1.644-2.654a13.617 13.617 0 0 1-1.269-4.218l-2.831-1.31a.257.257 0 0 1-.147-.258l.377-3.725a.256.256 0 0 1 .196-.224l3.036-.715a13.61 13.61 0 0 1 2.09-3.879l-1.078-2.93a.257.257 0 0 1 .078-.287l2.901-2.367a.257.257 0 0 1 .297-.019l2.654 1.643a13.58 13.58 0 0 1 4.219-1.269l1.309-2.831c.045-.1.15-.158.258-.147l3.725.377c.11.01.199.09.224.196l.715 3.037a13.591 13.591 0 0 1 3.879 2.088l2.93-1.077a.257.257 0 0 1 .287.078l2.367 2.901a.258.258 0 0 1 .02.297l-1.644 2.655c.64 1.31 1.075 2.73 1.269 4.218l2.831 1.31c.1.045.159.149.148.258l-.377 3.725a.256.256 0 0 1-.197.224l-3.036.715a13.606 13.606 0 0 1-2.089 3.878l1.078 2.93a.257.257 0 0 1-.079.287l-2.9 2.367a.258.258 0 0 1-.298.02l-2.654-1.644a13.61 13.61 0 0 1-4.218 1.27l-1.31 2.83a.256.256 0 0 1-.258.148l-3.725-.377a.256.256 0 0 1-.224-.197l-.714-3.036a13.609 13.609 0 0 1-3.879-2.089l-2.93 1.078Zm11.339-2.723a9.467 9.467 0 0 1-2.705-.398l-.005-.002-.007-.002-.055-.017a6.769 6.769 0 0 1-.105-.033.219.219 0 0 1-.142-.277.22.22 0 0 1 .276-.141 8.814 8.814 0 0 0 9.65-2.934 8.762 8.762 0 0 0 1.846-4.562 8.748 8.748 0 0 0-1.94-6.461 8.757 8.757 0 0 0-5.942-3.197c-4.837-.49-9.168 3.046-9.657 7.88a8.786 8.786 0 0 0 .786 4.629.22.22 0 0 1-.105.292.22.22 0 0 1-.292-.105 9.233 9.233 0 0 1-.827-4.86c.514-5.077 5.064-8.788 10.14-8.274a9.192 9.192 0 0 1 6.236 3.356 9.184 9.184 0 0 1 2.037 6.783 9.193 9.193 0 0 1-3.356 6.237 9.185 9.185 0 0 1-5.833 2.086Zm-.076-5.436a3.769 3.769 0 0 1-3.72-3.215 3.767 3.767 0 0 1 3.174-4.272 3.737 3.737 0 0 1 2.793.702 3.74 3.74 0 0 1 1.479 2.472 3.768 3.768 0 0 1-3.727 4.313Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#6562F5",
        d: "M34.405 34.968a4.161 4.161 0 0 0-4.114 4.763 4.125 4.125 0 0 0 1.633 2.729 4.138 4.138 0 0 0 3.086.776 4.13 4.13 0 0 0 2.73-1.633 4.134 4.134 0 0 0 .777-3.086 4.165 4.165 0 0 0-4.112-3.55Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#6562F5",
        fillRule: "evenodd",
        d: "M17.787 56.71a.378.378 0 0 1-.424-.117v-.002l-3.491-4.279a.379.379 0 0 1-.029-.438l2.423-3.914a20.064 20.064 0 0 1-1.87-6.222l-4.177-1.931a.379.379 0 0 1-.217-.382l.557-5.494a.377.377 0 0 1 .29-.33l4.479-1.054a20.027 20.027 0 0 1 3.08-5.721l-1.59-4.32a.378.378 0 0 1 .117-.425l4.279-3.491a.377.377 0 0 1 .438-.029l3.915 2.423a20.064 20.064 0 0 1 6.222-1.87l1.93-4.176a.379.379 0 0 1 .383-.218l5.494.557c.16.016.294.132.33.29l1.054 4.479a20.029 20.029 0 0 1 5.721 3.08l4.321-1.59a.378.378 0 0 1 .424.117l3.491 4.279a.38.38 0 0 1 .029.438l-2.423 3.916a20.063 20.063 0 0 1 1.87 6.222l4.177 1.93a.379.379 0 0 1 .217.382l-.557 5.494a.377.377 0 0 1-.29.33L53.482 45.7a20.03 20.03 0 0 1-3.08 5.72l1.59 4.321a.378.378 0 0 1-.117.424l-4.279 3.492a.381.381 0 0 1-.438.028l-3.915-2.423a20.065 20.065 0 0 1-6.222 1.87l-1.93 4.177a.379.379 0 0 1-.382.217l-5.495-.557a.377.377 0 0 1-.33-.29l-1.054-4.477a20.029 20.029 0 0 1-5.72-3.08l-4.322 1.589Zm16.714-3.594a14.194 14.194 0 0 1-4.239-.647l-.123-.04a.747.747 0 1 1 .46-1.42 12.7 12.7 0 0 0 2.621.548l.147.014c2.11.194 4.189-.147 6.085-.964a12.62 12.62 0 0 0 2.901-1.747l.022-.017.011-.01.055-.044a12.496 12.496 0 0 0 4.561-8.478 12.486 12.486 0 0 0-2.768-9.22 12.496 12.496 0 0 0-8.478-4.561 12.51 12.51 0 0 0-9.22 2.768 12.496 12.496 0 0 0-4.562 8.478 12.528 12.528 0 0 0 1.122 6.605.75.75 0 0 1-.359.994.75.75 0 0 1-.994-.359 14.05 14.05 0 0 1-1.257-7.39 13.98 13.98 0 0 1 5.105-9.484 13.967 13.967 0 0 1 10.315-3.098 13.97 13.97 0 0 1 9.485 5.104 13.97 13.97 0 0 1 3.172 8.868c0 .48-.024.963-.073 1.446-.734 7.24-6.863 12.654-13.99 12.654Zm-.11-8.34a5.602 5.602 0 0 1-3.359-1.117 5.62 5.62 0 0 1-2.22-3.711 5.657 5.657 0 0 1 4.767-6.413 5.66 5.66 0 0 1 6.415 4.766 5.61 5.61 0 0 1-1.055 4.194 5.61 5.61 0 0 1-3.712 2.22c-.28.041-.56.06-.837.06Z",
        clipRule: "evenodd"
      }
    )
  ] }) : /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsx("rect", { width: "42", height: "11", x: "27", y: "54", fill: "#28313F", rx: "5.5" }),
    /* @__PURE__ */ jsx("rect", { width: "11", height: "11", x: "14", y: "54", fill: "#28313F", rx: "5.5" }),
    /* @__PURE__ */ jsx("rect", { width: "32", height: "11", x: "14", y: "3", fill: "#28313F", rx: "5.5" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#28313F",
        d: "M69.359 40.247H67.22a5.159 5.159 0 0 1-3.638-1.5 5.108 5.108 0 0 1-1.508-3.62c0-1.324.516-2.596 1.439-3.55a5.157 5.157 0 0 1 3.51-1.565h1.615a5.548 5.548 0 0 0 3.802-1.673A5.494 5.494 0 0 0 74 24.506c0-1.43-.56-2.806-1.56-3.833A5.548 5.548 0 0 0 68.638 19h-56.69a5.549 5.549 0 0 0-3.801 1.673 5.495 5.495 0 0 0-1.56 3.833c0 1.431.56 2.806 1.56 3.833a5.549 5.549 0 0 0 3.801 1.673h.55c1.33.05 2.587.612 3.51 1.566a5.107 5.107 0 0 1 1.438 3.549c0 1.358-.542 2.66-1.507 3.62a5.159 5.159 0 0 1-3.639 1.5h-1.902a4.409 4.409 0 0 0-3.11 1.282 4.365 4.365 0 0 0 0 6.19A4.41 4.41 0 0 0 10.398 49h58.96a4.41 4.41 0 0 0 3.11-1.282 4.365 4.365 0 0 0 0-6.189 4.409 4.409 0 0 0-3.11-1.282Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#4541C9",
        d: "M63.705 17.796a2.89 2.89 0 0 0-2.861 3.307 2.888 2.888 0 0 0 3.276 2.434 2.89 2.89 0 0 0 2.434-3.275 2.866 2.866 0 0 0-1.134-1.896 2.864 2.864 0 0 0-1.715-.57Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#4541C9",
        fillRule: "evenodd",
        d: "M52.434 32.605a.257.257 0 0 1-.287-.079h-.001l-2.367-2.9a.257.257 0 0 1-.02-.298l1.644-2.654a13.617 13.617 0 0 1-1.269-4.218l-2.831-1.31a.257.257 0 0 1-.147-.258l.377-3.725a.256.256 0 0 1 .196-.224l3.036-.715a13.61 13.61 0 0 1 2.09-3.879l-1.078-2.93a.257.257 0 0 1 .078-.287l2.901-2.367a.257.257 0 0 1 .297-.019l2.654 1.643a13.58 13.58 0 0 1 4.219-1.268l1.309-2.832c.045-.1.15-.158.258-.147l3.725.377c.11.01.199.09.224.196l.715 3.037a13.591 13.591 0 0 1 3.879 2.088l2.93-1.077a.257.257 0 0 1 .287.078l2.367 2.901a.258.258 0 0 1 .02.297l-1.644 2.655c.64 1.31 1.075 2.73 1.269 4.218l2.831 1.31c.1.045.159.149.148.258l-.377 3.725a.256.256 0 0 1-.197.224l-3.036.715a13.606 13.606 0 0 1-2.089 3.878l1.078 2.93a.257.257 0 0 1-.079.287l-2.9 2.367a.258.258 0 0 1-.298.02l-2.654-1.644a13.61 13.61 0 0 1-4.218 1.27l-1.31 2.83a.256.256 0 0 1-.258.148l-3.725-.377a.256.256 0 0 1-.224-.197l-.714-3.036a13.606 13.606 0 0 1-3.879-2.089l-2.93 1.078Zm11.339-2.723a9.437 9.437 0 0 1-2.705-.398l-.005-.002-.007-.002-.055-.017a6.769 6.769 0 0 1-.105-.033.219.219 0 0 1-.142-.277.22.22 0 0 1 .277-.141 8.813 8.813 0 0 0 9.65-2.934 8.762 8.762 0 0 0 1.845-4.562 8.748 8.748 0 0 0-1.94-6.461 8.757 8.757 0 0 0-5.942-3.197c-4.837-.49-9.168 3.046-9.658 7.88a8.786 8.786 0 0 0 .787 4.629.22.22 0 0 1-.105.292.22.22 0 0 1-.292-.105 9.233 9.233 0 0 1-.827-4.86c.514-5.077 5.064-8.788 10.14-8.274a9.192 9.192 0 0 1 6.236 3.356 9.184 9.184 0 0 1 2.037 6.783 9.193 9.193 0 0 1-3.356 6.237 9.185 9.185 0 0 1-5.833 2.086Zm-.077-5.436a3.769 3.769 0 0 1-3.72-3.215 3.767 3.767 0 0 1 3.175-4.272 3.738 3.738 0 0 1 2.793.702 3.74 3.74 0 0 1 1.479 2.472 3.768 3.768 0 0 1-3.727 4.313Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#7471FF",
        d: "M24.405 35.968a4.161 4.161 0 0 0-4.114 4.763 4.125 4.125 0 0 0 1.633 2.729 4.138 4.138 0 0 0 3.086.776 4.13 4.13 0 0 0 2.73-1.633 4.134 4.134 0 0 0 .777-3.086 4.165 4.165 0 0 0-4.112-3.55Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#7471FF",
        fillRule: "evenodd",
        d: "M7.787 57.71a.378.378 0 0 1-.424-.116v-.003l-3.491-4.278a.38.38 0 0 1-.029-.439l2.423-3.914a20.062 20.062 0 0 1-1.87-6.222L.219 40.807a.379.379 0 0 1-.217-.382l.557-5.494a.377.377 0 0 1 .29-.33l4.479-1.054a20.027 20.027 0 0 1 3.08-5.721l-1.59-4.32a.378.378 0 0 1 .117-.425l4.279-3.491a.377.377 0 0 1 .438-.029l3.915 2.423a20.064 20.064 0 0 1 6.222-1.87l1.93-4.176a.379.379 0 0 1 .383-.218l5.494.557c.16.016.294.132.33.29l1.054 4.479a20.029 20.029 0 0 1 5.721 3.08l4.321-1.59a.378.378 0 0 1 .424.117l3.491 4.279a.38.38 0 0 1 .029.438l-2.423 3.916a20.064 20.064 0 0 1 1.87 6.222l4.177 1.93a.38.38 0 0 1 .217.382l-.557 5.495a.377.377 0 0 1-.29.33l-4.479 1.054a20.032 20.032 0 0 1-3.08 5.72l1.59 4.321a.378.378 0 0 1-.117.424l-4.279 3.492a.381.381 0 0 1-.438.028l-3.915-2.423a20.065 20.065 0 0 1-6.222 1.87l-1.93 4.177a.379.379 0 0 1-.382.217l-5.495-.557a.377.377 0 0 1-.33-.289l-1.054-4.478a20.029 20.029 0 0 1-5.72-3.08L7.786 57.71Zm16.714-3.594a14.18 14.18 0 0 1-4.239-.647l-.123-.04a.747.747 0 1 1 .46-1.42 12.7 12.7 0 0 0 2.621.548l.147.014c2.11.194 4.189-.147 6.084-.964a12.617 12.617 0 0 0 2.902-1.747l.022-.017.011-.01.055-.044a12.496 12.496 0 0 0 4.561-8.478 12.486 12.486 0 0 0-2.768-9.22 12.496 12.496 0 0 0-8.478-4.561 12.51 12.51 0 0 0-9.22 2.768 12.496 12.496 0 0 0-4.562 8.478 12.528 12.528 0 0 0 1.122 6.605.75.75 0 0 1-.359.994.749.749 0 0 1-.994-.359 14.05 14.05 0 0 1-1.257-7.39 13.98 13.98 0 0 1 5.105-9.484 13.967 13.967 0 0 1 10.315-3.098 13.97 13.97 0 0 1 9.485 5.104 13.97 13.97 0 0 1 3.172 8.868c0 .48-.024.963-.073 1.446-.734 7.24-6.863 12.654-13.99 12.654Zm-.11-8.34a5.602 5.602 0 0 1-3.359-1.117 5.62 5.62 0 0 1-2.22-3.711 5.657 5.657 0 0 1 4.767-6.413 5.66 5.66 0 0 1 6.415 4.766 5.61 5.61 0 0 1-1.055 4.194 5.61 5.61 0 0 1-3.712 2.22c-.28.041-.56.06-.837.06Z",
        clipRule: "evenodd"
      }
    )
  ] });
}, Calendar = () => {
  const { theme: t } = useContext(ConfigContext);
  return t === "light" ? /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#D2DFFA",
        d: "M88.743 52.04c-5.947 19.961-48.94 13.708-62.724 10.166C16.726 65.44 0 58.97 0 38.64c0-8.78 13.474-7.393 22.767-19.407C32.059 7.221 42.745-1.558 55.755 1.676 68.765 4.911 96.177 27.09 88.743 52.04Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#3A36DB",
        d: "M14.735 10.82a8.003 8.003 0 0 0-5.217 7.503v5.566h50.61v-5.566a8.003 8.003 0 0 0-5.216-7.502v1.198a2.478 2.478 0 1 1-4.957 0v-1.696h-3.653v1.696a2.478 2.478 0 1 1-4.957 0v-1.696H37.17v1.696a2.478 2.478 0 1 1-4.957 0v-1.696h-3.651v1.696a2.478 2.478 0 1 1-4.957 0v-1.696h-3.914v1.696a2.478 2.478 0 1 1-4.956 0V10.82Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#6562F5", d: "M9.52 23.889h50.61v28a8 8 0 0 1-8 8H17.52a8 8 0 0 1-8-8v-28Z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#BECDFA",
        d: "M23.87 31.367a2 2 0 0 1 2-2h.696a2 2 0 0 1 2 2v.696a2 2 0 0 1-2 2h-.696a2 2 0 0 1-2-2v-.696Zm0 8.609a2 2 0 0 1 2-2h.696a2 2 0 0 1 2 2v.696a2 2 0 0 1-2 2h-.696a2 2 0 0 1-2-2v-.696Zm0 8.609a2 2 0 0 1 2-2h.696a2 2 0 0 1 2 2v.696a2 2 0 0 1-2 2h-.696a2 2 0 0 1-2-2v-.696Zm-8.87 0a2 2 0 0 1 2-2h.696a2 2 0 0 1 2 2v.696a2 2 0 0 1-2 2H17a2 2 0 0 1-2-2v-.696Zm17.74-17.218a2 2 0 0 1 2-2h.696a2 2 0 0 1 2 2v.696a2 2 0 0 1-2 2h-.696a2 2 0 0 1-2-2v-.696Zm0 8.609a2 2 0 0 1 2-2h.696a2 2 0 0 1 2 2v.696a2 2 0 0 1-2 2h-.696a2 2 0 0 1-2-2v-.696Zm0 8.609a2 2 0 0 1 2-2h.696a2 2 0 0 1 2 2v.696a2 2 0 0 1-2 2h-.696a2 2 0 0 1-2-2v-.696Zm8.867-17.218a2 2 0 0 1 2-2h.696a2 2 0 0 1 2 2v.696a2 2 0 0 1-2 2h-.696a2 2 0 0 1-2-2v-.696Zm0 8.609a2 2 0 0 1 2-2h.696a2 2 0 0 1 2 2v.696a2 2 0 0 1-2 2h-.696a2 2 0 0 1-2-2v-.696Zm0 8.609a2 2 0 0 1 2-2h.696a2 2 0 0 1 2 2v.696a2 2 0 0 1-2 2h-.696a2 2 0 0 1-2-2v-.696Zm8.872-17.218a2 2 0 0 1 2-2h.696a2 2 0 0 1 2 2v.696a2 2 0 0 1-2 2h-.696a2 2 0 0 1-2-2v-.696Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#3A36DB",
        d: "M16.04 7.323a1.174 1.174 0 1 1 2.348 0v4.696a1.174 1.174 0 1 1-2.348 0V7.323Zm8.87 0a1.174 1.174 0 1 1 2.349 0v4.696a1.174 1.174 0 0 1-2.348 0V7.323Zm8.609 0a1.174 1.174 0 1 1 2.347 0v4.696a1.174 1.174 0 0 1-2.347 0V7.323Zm9.131 0a1.174 1.174 0 1 1 2.349 0v4.696a1.174 1.174 0 0 1-2.348 0V7.323Zm8.61 0a1.174 1.174 0 1 1 2.349 0v4.696a1.174 1.174 0 0 1-2.348 0V7.323Zm23.742 41.871c0 8.212-6.658 14.87-14.87 14.87-8.213 0-14.87-6.658-14.87-14.87 0-8.213 6.657-14.87 14.87-14.87 8.212 0 14.87 6.657 14.87 14.87Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#6562F5",
        d: "M72.132 49.194c0 6.627-5.373 12-12 12-6.628 0-12-5.373-12-12 0-6.628 5.372-12 12-12s12 5.372 12 12Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M59.35 41.629a.783.783 0 1 1 1.565 0v8.608a.783.783 0 0 1-1.565 0V41.63Z" }),
    /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M58.306 49.977a.783.783 0 1 1 0-1.566h8.609a.783.783 0 0 1 0 1.566h-8.609Z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#EB5757",
        d: "M22.827 36.15c0 1.594-.377 3.1-1.045 4.435l.5 2.442c.304 1.487-1.093 2.757-2.544 2.314l-1.906-.582a9.867 9.867 0 0 1-4.919 1.304C7.438 46.063 3 41.625 3 36.15c0-5.475 4.438-9.913 9.913-9.913 5.475 0 9.914 4.438 9.914 9.913Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#fff",
        d: "M14.48 40.976a1.435 1.435 0 1 1-2.87 0 1.435 1.435 0 0 1 2.87 0Zm-3.229-9.659a1.8 1.8 0 1 1 3.589 0l-.523 6.272a1.276 1.276 0 0 1-2.543 0l-.523-6.272Z"
      }
    )
  ] }) : /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#28313F",
        d: "M88.743 52.04c-5.947 19.961-48.94 13.708-62.724 10.166C16.726 65.44 0 58.97 0 38.64c0-8.78 13.474-7.393 22.767-19.407C32.059 7.221 42.745-1.558 55.755 1.676 68.765 4.911 96.177 27.09 88.743 52.04Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#4541C9",
        fillRule: "evenodd",
        d: "M14.737 10.82a8.003 8.003 0 0 0-5.217 7.503v5.566h50.61v-5.566a8.003 8.003 0 0 0-5.216-7.502v1.198a2.478 2.478 0 0 1-4.957 0v-1.696h-3.653v1.696a2.478 2.478 0 0 1-4.957 0v-1.696h-4.175v1.696a2.478 2.478 0 0 1-4.957 0v-1.696h-3.651v1.696a2.478 2.478 0 0 1-4.957 0v-1.696h-3.914v1.696a2.478 2.478 0 0 1-4.956 0v-1.198Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#7471FF", d: "M9.52 23.889h50.61v28a8 8 0 0 1-8 8H17.52a8 8 0 0 1-8-8v-28Z" }),
    /* @__PURE__ */ jsx("rect", { width: "4.696", height: "4.696", x: "23.869", y: "29.367", fill: "#1A202C", rx: "2" }),
    /* @__PURE__ */ jsx("rect", { width: "4.696", height: "4.696", x: "23.869", y: "37.976", fill: "#1A202C", rx: "2" }),
    /* @__PURE__ */ jsx("rect", { width: "4.696", height: "4.696", x: "23.869", y: "46.585", fill: "#1A202C", rx: "2" }),
    /* @__PURE__ */ jsx("rect", { width: "4.696", height: "4.696", x: "14.998", y: "46.585", fill: "#1A202C", rx: "2" }),
    /* @__PURE__ */ jsx("rect", { width: "4.696", height: "4.696", x: "32.738", y: "29.367", fill: "#1A202C", rx: "2" }),
    /* @__PURE__ */ jsx("rect", { width: "4.696", height: "4.696", x: "32.738", y: "37.976", fill: "#1A202C", rx: "2" }),
    /* @__PURE__ */ jsx("rect", { width: "4.696", height: "4.696", x: "32.738", y: "46.585", fill: "#1A202C", rx: "2" }),
    /* @__PURE__ */ jsx("rect", { width: "4.696", height: "4.696", x: "41.605", y: "29.367", fill: "#1A202C", rx: "2" }),
    /* @__PURE__ */ jsx("rect", { width: "4.696", height: "4.696", x: "41.605", y: "37.976", fill: "#1A202C", rx: "2" }),
    /* @__PURE__ */ jsx("rect", { width: "4.696", height: "4.696", x: "41.605", y: "46.585", fill: "#1A202C", rx: "2" }),
    /* @__PURE__ */ jsx("rect", { width: "4.696", height: "4.696", x: "50.478", y: "29.367", fill: "#1A202C", rx: "2" }),
    /* @__PURE__ */ jsx("rect", { width: "2.348", height: "7.044", x: "16.041", y: "6.149", fill: "#605CFF", rx: "1.174" }),
    /* @__PURE__ */ jsx("rect", { width: "2.348", height: "7.044", x: "24.912", y: "6.149", fill: "#605CFF", rx: "1.174" }),
    /* @__PURE__ */ jsx("rect", { width: "2.348", height: "7.044", x: "33.52", y: "6.149", fill: "#605CFF", rx: "1.174" }),
    /* @__PURE__ */ jsx("rect", { width: "2.348", height: "7.044", x: "42.652", y: "6.149", fill: "#605CFF", rx: "1.174" }),
    /* @__PURE__ */ jsx("rect", { width: "2.348", height: "7.044", x: "51.262", y: "6.149", fill: "#605CFF", rx: "1.174" }),
    /* @__PURE__ */ jsx("circle", { cx: "60.13", cy: "49.194", r: "14.87", fill: "#4541C9" }),
    /* @__PURE__ */ jsx("circle", { cx: "60.129", cy: "49.194", r: "12", fill: "#7471FF" }),
    /* @__PURE__ */ jsx("rect", { width: "1.565", height: "10.174", x: "59.348", y: "40.846", fill: "#fff", rx: ".783" }),
    /* @__PURE__ */ jsx(
      "rect",
      {
        width: "1.565",
        height: "10.174",
        x: "57.522",
        y: "49.977",
        fill: "#fff",
        rx: ".783",
        transform: "rotate(-90 57.522 49.977)"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#EB5757",
        d: "M22.827 36.15c0 1.594-.377 3.1-1.045 4.435l.5 2.442c.304 1.487-1.093 2.757-2.544 2.314l-1.906-.582a9.867 9.867 0 0 1-4.919 1.304C7.438 46.063 3 41.625 3 36.15c0-5.475 4.438-9.913 9.913-9.913 5.475 0 9.914 4.438 9.914 9.913Z"
      }
    ),
    /* @__PURE__ */ jsx("circle", { cx: "13.044", cy: "40.976", r: "1.435", fill: "#fff" }),
    /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M11.252 31.317a1.8 1.8 0 1 1 3.588 0l-.522 6.272a1.276 1.276 0 0 1-2.543 0l-.523-6.272Z" })
  ] });
}, AllowPopup = () => {
  const { theme: t } = useContext(ConfigContext);
  return t === "light" ? /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsxs("g", { clipPath: "url(#a)", children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#D2DBEC",
          d: "M88.913 51.968C82.954 72.292 39.88 65.925 26.07 62.318 16.759 65.612 0 59.025 0 38.325c0-8.939 13.5-7.527 22.81-19.76C32.12 6.336 42.827-2.604 55.862.69c13.034 3.293 40.5 25.875 33.051 51.28Z"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#3A36DB", d: "M33.219 46.342H46.77v5.14H33.219z" }),
      /* @__PURE__ */ jsx("path", { fill: "#605CFF", d: "M21.75 51.481h36.484v5.14H21.75z" }),
      /* @__PURE__ */ jsx("path", { fill: "#698AFF", d: "M5 9a3 3 0 0 1 3-3h62.126a3 3 0 0 1 3 3v34.818a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3V9Z" }),
      /* @__PURE__ */ jsx("rect", { width: "61.952", height: "34.716", x: "8.086", y: "9.051", fill: "#698AFF", stroke: "#C5D0E5", rx: "1.5" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#3954D0",
          d: "M10 30V16h16v14zm17.152-.237V15.895h15.431v13.868zM43.494 42V15.895h24.508V42zM10 42V31h33v11z"
        }
      ),
      /* @__PURE__ */ jsx("circle", { cx: "11.815", cy: "12", r: "1", fill: "#EB5757" }),
      /* @__PURE__ */ jsx("circle", { cx: "14.539", cy: "12", r: "1", fill: "#BECDFA" }),
      /* @__PURE__ */ jsx("circle", { cx: "17.262", cy: "12", r: "1", fill: "#fff" }),
      /* @__PURE__ */ jsx("rect", { width: "46", height: "2", x: "22", y: "11", fill: "#BECDFA", rx: "1" }),
      /* @__PURE__ */ jsx("path", { fill: "#DFE6F2", d: "M35 54a1 1 0 0 1-1-1V26h56v27a1 1 0 0 1-1 1H35Z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#B7C4DE",
          d: "M35.806 39.925V26.224H51.12v13.701zm16.117 0v-13.7h13.701v13.7zm14.511 12.09V26.224h21.76v24.79a1 1 0 0 1-1 1h-20.76Zm-30.627 0V40.73h29.82v11.284h-29.82Z"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#DFE6F2", d: "M34 19a1 1 0 0 1 1-1h54a1 1 0 0 1 1 1v7H34v-7Z" }),
      /* @__PURE__ */ jsx("circle", { cx: "38.222", cy: "22.194", r: ".806", fill: "#EB5757" }),
      /* @__PURE__ */ jsx("circle", { cx: "40.642", cy: "22.194", r: ".806", fill: "#B7C4DE" }),
      /* @__PURE__ */ jsx("circle", { cx: "43.058", cy: "22.194", r: ".806", fill: "#fff" }),
      /* @__PURE__ */ jsx("rect", { width: "39.492", height: "1.612", x: "47.088", y: "21.388", fill: "#B7C4DE", rx: ".806" }),
      /* @__PURE__ */ jsx("circle", { cx: "86", cy: "50", r: "12", fill: "#EB5757" }),
      /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M78.615 48.154h14.769v3.692H78.615z" })
    ] }),
    /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h99v66H0z" }) }) })
  ] }) : /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsxs("g", { clipPath: "url(#a)", children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#28313F",
          d: "M88.913 51.968C82.954 72.292 39.88 65.925 26.07 62.318 16.759 65.612 0 59.025 0 38.325c0-8.939 13.5-7.527 22.81-19.76C32.12 6.336 42.827-2.604 55.862.69c13.034 3.293 40.5 25.875 33.051 51.28Z"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#3A36DB", d: "M33.219 46.342H46.77v5.14H33.219z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#605CFF",
          d: "M21.75 51.481h36.484v5.14H21.75zM5 9a3 3 0 0 1 3-3h62.126a3 3 0 0 1 3 3v34.818a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3V9Z"
        }
      ),
      /* @__PURE__ */ jsx("rect", { width: "61.952", height: "34.716", x: "8.086", y: "9.051", fill: "#605CFF", stroke: "#364153", rx: "1.5" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#4541C9",
          d: "M10 30V16h16v14zm17.152-.237V15.895h15.431v13.868zM43.494 42V15.895h24.508V42zM10 42V31h33v11z"
        }
      ),
      /* @__PURE__ */ jsx("circle", { cx: "11.815", cy: "12", r: "1", fill: "#EB5757" }),
      /* @__PURE__ */ jsx("circle", { cx: "14.539", cy: "12", r: "1", fill: "#BECDFA" }),
      /* @__PURE__ */ jsx("circle", { cx: "17.262", cy: "12", r: "1", fill: "#fff" }),
      /* @__PURE__ */ jsx("rect", { width: "46", height: "2", x: "22", y: "11", fill: "#BECDFA", rx: "1" }),
      /* @__PURE__ */ jsx("path", { fill: "#1A202C", d: "M35 54a1 1 0 0 1-1-1V26h56v27a1 1 0 0 1-1 1H35Z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#364153",
          d: "M35.806 39.925V26.224H51.12v13.701zm16.117 0v-13.7h13.701v13.7zm14.511 12.09V26.224h21.76v24.79a1 1 0 0 1-1 1h-20.76Zm-30.627 0V40.73h29.82v11.284h-29.82Z"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#1A202C", d: "M34 19a1 1 0 0 1 1-1h54a1 1 0 0 1 1 1v7H34v-7Z" }),
      /* @__PURE__ */ jsx("circle", { cx: "38.222", cy: "22.194", r: ".806", fill: "#EB5757" }),
      /* @__PURE__ */ jsx("circle", { cx: "40.642", cy: "22.194", r: ".806", fill: "#364153" }),
      /* @__PURE__ */ jsx("circle", { cx: "43.058", cy: "22.194", r: ".806", fill: "#fff" }),
      /* @__PURE__ */ jsx("rect", { width: "39.492", height: "1.612", x: "47.088", y: "21.388", fill: "#364153", rx: ".806" }),
      /* @__PURE__ */ jsx("circle", { cx: "86", cy: "50", r: "12", fill: "#EB5757" }),
      /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M78.615 48.154h14.769v3.692H78.615z" })
    ] }),
    /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h99v66H0z" }) }) })
  ] });
}, Tabs = () => {
  const { theme: t } = useContext(ConfigContext);
  return t === "light" ? /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, viewBox: "0 0 99 66", fill: "none", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M86.7707 51.8256C80.9557 72.0935 38.9181 65.7441 25.4406 62.1472C16.3547 65.4314 0 58.8631 0 38.2198C0 29.3057 13.1746 30.7132 22.2606 18.5149C31.3465 6.31665 41.7953 -2.59748 54.5156 0.686674C67.236 3.97082 94.0395 26.4907 86.7707 51.8256Z",
        fill: "#D2DBEC"
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M7 49C6.44771 49 6 48.5523 6 48L6 15L73 15L73 48C73 48.5523 72.5523 49 72 49L7 49Z", fill: "#3954D0" }),
    /* @__PURE__ */ jsx("rect", { x: "7", y: "33", width: "17", height: "19", transform: "rotate(-90 7 33)", fill: "#698AFF" }),
    /* @__PURE__ */ jsx("rect", { x: "27", y: "33", width: "17", height: "17", transform: "rotate(-90 27 33)", fill: "#698AFF" }),
    /* @__PURE__ */ jsx("path", { d: "M45 48L45 16L72 16L72 47C72 47.5523 71.5523 48 71 48L45 48Z", fill: "#698AFF" }),
    /* @__PURE__ */ jsx("path", { d: "M8 48C7.44771 48 7 47.5523 7 47L7 34L44 34L44 48L8 48Z", fill: "#698AFF" }),
    /* @__PURE__ */ jsx("path", { d: "M6 8C6 6.89543 6.89543 6 8 6H71C72.1046 6 73 6.89543 73 8V15H6V8Z", fill: "#3954D0" }),
    /* @__PURE__ */ jsx("circle", { cx: "10", cy: "11", r: "1", fill: "#EB5757" }),
    /* @__PURE__ */ jsx("circle", { cx: "13", cy: "11", r: "1", fill: "#C5D0E5" }),
    /* @__PURE__ */ jsx("circle", { cx: "16", cy: "11", r: "1", fill: "white" }),
    /* @__PURE__ */ jsx("rect", { x: "21", y: "10", width: "49", height: "2", rx: "1", fill: "#C5D0E5" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M24 61C23.4477 61 23 60.5523 23 60L23 27L90 27L90 60C90 60.5523 89.5523 61 89 61L24 61Z",
        fill: "#ABBAD8"
      }
    ),
    /* @__PURE__ */ jsx("rect", { x: "24", y: "45", width: "17", height: "19", transform: "rotate(-90 24 45)", fill: "#D2DBEC" }),
    /* @__PURE__ */ jsx("rect", { x: "44", y: "45", width: "17", height: "17", transform: "rotate(-90 44 45)", fill: "#D2DBEC" }),
    /* @__PURE__ */ jsx("path", { d: "M62 60L62 28L89 28L89 59C89 59.5523 88.5523 60 88 60L62 60Z", fill: "#D2DBEC" }),
    /* @__PURE__ */ jsx("path", { d: "M25 60C24.4477 60 24 59.5523 24 59L24 46L61 46L61 60L25 60Z", fill: "#D2DBEC" }),
    /* @__PURE__ */ jsx("path", { d: "M23 20C23 18.8954 23.8954 18 25 18H88C89.1046 18 90 18.8954 90 20V27H23V20Z", fill: "#D2DBEC" }),
    /* @__PURE__ */ jsx("circle", { cx: "27", cy: "23", r: "1", fill: "#EB5757" }),
    /* @__PURE__ */ jsx("circle", { cx: "30", cy: "23", r: "1", fill: "#ABBAD8" }),
    /* @__PURE__ */ jsx("circle", { cx: "33", cy: "23", r: "1", fill: "white" }),
    /* @__PURE__ */ jsx("rect", { x: "38", y: "22", width: "49", height: "2", rx: "1", fill: "#ABBAD8" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M82.4784 63.7946C88.8178 63.7946 93.9568 58.6919 93.9568 52.3973C93.9568 46.1028 88.8178 41 82.4784 41C76.1391 41 71 46.1028 71 52.3973C71 58.6919 76.1391 63.7946 82.4784 63.7946ZM81.9167 56.0713V56.1494H83.4769V56.0713C83.4856 55.5339 83.5419 55.0854 83.6459 54.7257C83.7499 54.3659 83.9168 54.0561 84.1465 53.796C84.3762 53.5316 84.6817 53.2803 85.0631 53.0419C85.4445 52.8079 85.7696 52.5392 86.0383 52.2358C86.3113 51.9324 86.5194 51.5879 86.6624 51.2021C86.8097 50.8164 86.8834 50.3852 86.8834 49.9084C86.8834 49.2323 86.7274 48.6299 86.4153 48.1012C86.1076 47.5724 85.6699 47.1564 85.1021 46.853C84.5387 46.5496 83.8756 46.3979 83.1129 46.3979C82.4107 46.3979 81.7715 46.5366 81.1951 46.814C80.623 47.0914 80.1614 47.4923 79.8104 48.0167C79.4636 48.5411 79.273 49.1717 79.2383 49.9084H80.8765C80.9112 49.397 81.039 48.9831 81.2601 48.6668C81.4811 48.3504 81.7563 48.1185 82.0857 47.9712C82.4151 47.8238 82.7575 47.7501 83.1129 47.7501C83.5202 47.7501 83.8908 47.8346 84.2245 48.0037C84.5582 48.1727 84.8248 48.4132 85.0241 48.7253C85.2235 49.0373 85.3232 49.4057 85.3232 49.8304C85.3232 50.1728 85.2625 50.4849 85.1411 50.7666C85.0241 51.0483 84.8638 51.2975 84.6601 51.5142C84.4564 51.7265 84.2267 51.9107 83.971 52.0668C83.5462 52.3225 83.1822 52.602 82.8788 52.9054C82.5754 53.2088 82.3414 53.6053 82.1767 54.0951C82.012 54.5848 81.9253 55.2436 81.9167 56.0713ZM81.9232 59.6534C82.1529 59.8831 82.4281 59.9979 82.7488 59.9979C82.9655 59.9979 83.1605 59.9459 83.3339 59.8419C83.5116 59.7336 83.6524 59.5905 83.7564 59.4128C83.8648 59.2351 83.919 59.0401 83.919 58.8278C83.919 58.507 83.8041 58.2318 83.5744 58.0021C83.3447 57.7724 83.0695 57.6576 82.7488 57.6576C82.4281 57.6576 82.1529 57.7724 81.9232 58.0021C81.6935 58.2318 81.5786 58.507 81.5786 58.8278C81.5786 59.1485 81.6935 59.4237 81.9232 59.6534Z",
        fill: "#3954D0"
      }
    )
  ] }) : /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#28313F",
        d: "M86.77 51.826c-5.814 20.268-47.852 13.918-61.33 10.321C16.356 65.431 0 58.863 0 38.22c0-8.914 13.175-7.507 22.26-19.705C31.347 6.317 41.796-2.597 54.517.687 67.236 3.97 94.04 26.49 86.77 51.826Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#605CFF", d: "M7 49a1 1 0 0 1-1-1V15h67v33a1 1 0 0 1-1 1H7Z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#7471FF",
        d: "M7 33V16h19v17zm20 0V16h17v17zm18 15V16h27v31a1 1 0 0 1-1 1H45ZM8 48a1 1 0 0 1-1-1V34h37v14H8Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#605CFF", d: "M6 8a2 2 0 0 1 2-2h63a2 2 0 0 1 2 2v7H6V8Z" }),
    /* @__PURE__ */ jsx("circle", { cx: "10", cy: "11", r: "1", fill: "#EB5757" }),
    /* @__PURE__ */ jsx("circle", { cx: "13", cy: "11", r: "1", fill: "#1A202C" }),
    /* @__PURE__ */ jsx("circle", { cx: "16", cy: "11", r: "1", fill: "#fff" }),
    /* @__PURE__ */ jsx("rect", { width: "49", height: "2", x: "21", y: "10", fill: "#1A202C", rx: "1" }),
    /* @__PURE__ */ jsx("path", { fill: "#605CFF", d: "M24 61a1 1 0 0 1-1-1V27h67v33a1 1 0 0 1-1 1H24Z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#4541C9",
        d: "M24 45V28h19v17zm20 0V28h17v17zm18 15V28h27v31a1 1 0 0 1-1 1H62Zm-37 0a1 1 0 0 1-1-1V46h37v14H25Zm-2-40a2 2 0 0 1 2-2h63a2 2 0 0 1 2 2v7H23v-7Z"
      }
    ),
    /* @__PURE__ */ jsx("circle", { cx: "27", cy: "23", r: "1", fill: "#EB5757" }),
    /* @__PURE__ */ jsx("circle", { cx: "30", cy: "23", r: "1", fill: "#1A202C" }),
    /* @__PURE__ */ jsx("circle", { cx: "33", cy: "23", r: "1", fill: "#fff" }),
    /* @__PURE__ */ jsx("rect", { width: "49", height: "2", x: "38", y: "22", fill: "#1A202C", rx: "1" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#BECDFA",
        fillRule: "evenodd",
        d: "M82.478 63.795c6.34 0 11.479-5.103 11.479-11.398 0-6.294-5.14-11.397-11.479-11.397C76.14 41 71 46.103 71 52.397c0 6.295 5.14 11.398 11.478 11.398Zm-.561-7.724v.078h1.56v-.078c.009-.537.065-.986.169-1.345.104-.36.27-.67.5-.93.23-.264.536-.516.917-.754a4.28 4.28 0 0 0 .975-.806c.273-.304.481-.648.624-1.034.148-.386.221-.817.221-1.294 0-.676-.156-1.278-.468-1.807a3.258 3.258 0 0 0-1.313-1.248c-.563-.303-1.226-.455-1.99-.455-.701 0-1.34.139-1.917.416a3.445 3.445 0 0 0-1.385 1.203c-.346.524-.537 1.155-.572 1.891h1.638c.035-.511.163-.925.384-1.241a1.98 1.98 0 0 1 .826-.696c.33-.147.671-.22 1.027-.22.407 0 .778.084 1.112.253.333.169.6.41.8.721.198.312.298.68.298 1.105a2.457 2.457 0 0 1-.663 1.684 3.42 3.42 0 0 1-.689.553 5.669 5.669 0 0 0-1.092.838c-.304.304-.538.7-.702 1.19-.165.49-.252 1.149-.26 1.976Zm.006 3.582c.23.23.505.345.826.345.217 0 .412-.052.585-.156.178-.108.318-.252.422-.43.109-.177.163-.372.163-.584 0-.321-.115-.596-.345-.826a1.126 1.126 0 0 0-.825-.344c-.32 0-.596.114-.826.344-.23.23-.344.505-.344.826 0 .32.115.596.344.825Z",
        clipRule: "evenodd"
      }
    )
  ] });
}, EmptyWidget = ({ style: t }) => {
  const { theme: r } = useContext(ConfigContext);
  return r === "light" ? /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 550, height: 550, style: t, fill: "none", viewBox: "0 0 550 550", children: /* @__PURE__ */ jsxs("g", { opacity: ".3", children: [
    /* @__PURE__ */ jsx("path", { fill: "#ABBAD8", d: "M83.5 422.5h-6v-17h6v17Z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#ABBAD8",
        d: "m80.9 410.3-3.3-5 15.4-9.7 3.2 5-15.3 9.7ZM282.1 79.7a4 4 0 0 0 4.1-4 4 4 0 0 0-4-4 4 4 0 0 0-4.1 4 4 4 0 0 0 4 4ZM375.7 247.6c0-1.7-1.4-3.2-3.2-3.2a3.2 3.2 0 0 0-3.2 3.2c0 1.8 1.4 3.2 3.2 3.2 1.8 0 3.2-1.4 3.2-3.2ZM262 110.4c3.5 0 6.4-2.8 6.4-6.3s-3-6.3-6.5-6.3a6.4 6.4 0 0 0-6.4 6.3c0 3.5 2.9 6.3 6.4 6.3ZM292.7 129.3a4 4 0 0 0-4-4 4 4 0 0 0-4 4 4 4 0 0 0 4 4 4 4 0 0 0 4-4ZM212.6 232.1ZM58.6 199.8l-.5.3.5-.2ZM364.2 139.3v-.1h-.1.1ZM362.7 138.3l-.1-.2h-.1l.2.2ZM163.3 258.9h1.6v-13.7h-1.6V259ZM214 209.3l.1-1.4-.9-.7-1 .7v1.2l.2.5 1.6-.3ZM363.5 185a3 3 0 0 0 3-3 3 3 0 0 0-3-3 3 3 0 0 0-3 3 3 3 0 0 0 3 3ZM379 204c2.7 0 4.9-2.2 4.9-4.8 0-2.7-2.2-4.9-5-4.9a4.9 4.9 0 0 0 0 9.7ZM236.8 211c2.7 0 5-2.2 5-5 0-2.6-2.3-4.7-5-4.7s-4.9 2.1-4.9 4.8c0 2.7 2.2 4.8 5 4.8ZM245.3 55.2a3 3 0 0 0 3-3 3 3 0 0 0-3-2.9 3 3 0 0 0-3 3 3 3 0 0 0 3 3ZM341.4 9.3V0S460.9 78.9 461 78.9v9.3L341.4 9.3ZM341.4 33.4V24s119.5 78.8 119.7 78.8v9.4l-119.7-79ZM537.4 209a3 3 0 0 0 3-3 3 3 0 0 0-3-2.9 3 3 0 0 0-3 3 3 3 0 0 0 3 3ZM526.2 238.3c2.8 0 5-2.1 5-4.8 0-2.7-2.2-4.8-5-4.8-2.7 0-4.9 2.1-4.9 4.8 0 2.7 2.2 4.8 5 4.8ZM509.8 121v9.4l-37.5-24.7v-9.4l37.5 24.8ZM509.8 144v9.4l-37.5-24.7v-9.4l37.5 24.8ZM509.8 167v9.4l-37.5-24.7v-9.3l37.5 24.7ZM509.8 191.8v9.3l-37.5-24.7v-9.3l37.5 24.7ZM508.7 215.4v9.3L471.2 200v-9.3l37.5 24.7ZM550 271l-106.1-70v9.4l106.1 70V271ZM550 294l-106.1-70v9.4l106.1 70V294ZM550 317l-106.1-69.9v9.3l106.1 70V317ZM463 315.7l37.5 24.7v-9.3L463 306.4v9.3ZM463 292.4l37.5 24.7v-9.3L463 283v9.4Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#ABBAD8",
        d: "m550 340.8-87-57.4v9.4l87 57.3v-9.3ZM413.3 118c3.2-3.1 6.3-6.4 8.3-8.8l1.8 1.3 19 12.6v14.2l-29.1-19.4Zm35 2.4L425.2 105l-.1.1v-.2l-123-81-.1 6.8v117.7h5.7v-30.3l66.4 44 3-4.6-24.6-16.3 11.4-2 5.4-1.2 20.1 13.4 3-4.5-15.7-10.4 1-.2 14.5-4.6 16.2 10.7 3-4.5-12.9-8.5a42.2 42.2 0 0 0 10.7-7.7l33.3 22V158l-7.5-5-3 4.5 10.5 7v19.5h5.8v-63.7ZM466.2 424.6h6v-18h-6v18Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#ABBAD8",
        d: "m468.8 411.4 3.3-5-15.4-9.7-3.2 5 15.3 9.7ZM414 478l-3.1-4.5 34.7-23.2 3.1 4.5L414 478ZM312 545.3l-3.1-4.4 50.1-33.4 3 4.5-50 33.3ZM228.5 538.3l3-4.5-50.3-33-3 4.4 50.3 33ZM245.8 550l3.1-4.5-7.1-4.7-3 4.5 7 4.7ZM155 491.4l3-4.5-44.3-29-3 4.5 44.3 29ZM80.8 442.8l3.5-4.8 13.4 9.3-3.5 4.8-13.4-9.3ZM373.5 504.4l-3-4.5 5.5-3.7 3 4.5-5.5 3.7ZM398.7 488l-3-4.4 5.5-3.7 3.1 4.4-5.6 3.7ZM459.7 447.5l-3-4.4 5.5-3.7 3 4.4-5.5 3.7ZM82 145.6l-1 .6s.2 0 .3-.2l.6-.4ZM215.4 125.5h.1-.1ZM199.7 224.1H197v-134h2.7v134ZM201 32.2v-11L142.4 60v11l58.4-38.8ZM130.9 61.6v-9.3S11.3 131.2 11 131.2v9.4l119.8-79ZM11.1 156.4v4l7.9-5.2v-4l-7.9 5.2Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#ABBAD8",
        d: "M130.9 84.5v-9.3S11.3 154 11 154v9.4l119.8-79ZM130.9 106.7v-9.3S11.3 176.3 11 176.3v9.4l119.8-79ZM.5 251v9.2L38 235.5v-9.3L.5 251ZM11.6 220.7v9.3l37.5-24.7v-9.4l-37.5 24.8ZM11.6 198.2v9.3l37.5-24.8v-9.3l-37.5 24.8ZM0 275v9.4l37.5-24.8v-9.3L0 275.1ZM200.4 157.5v-50.1l10.8-8.7v51.6l-10.8 7.2Zm-5.7 3.8L183 169v-47.5l11.7-9.4v49.2Zm-17.5 11.6-12.7 8.3V165l12.7-21.4v29.4Zm-48.8-49.7v-.3l-21 14.2-46.6 30.6v67.2l-9.3 6.4v21.8L67 252.8v-.1l20-13.2v8.1h5.7v-12l11.9-7.8V247h5.7v-21.3l12-3.1V248h5.7v-27.3l11.6-5.1V257h5.7V213L154 195l4.9-3.2v73.2h5.7v-77l12.7-8.4v37.9h5.8v-41.7l11.7-7.8v56.7h5.7v-60.5l10.8-7.1v73l-27 19.4v6.7l32.5-23.3h.3V64.8l-88.6 58.4ZM201 58V47l-58.5 38.8v11L200.8 58ZM236.7 87a3 3 0 0 0 3-3 3 3 0 0 0-3-3 3 3 0 0 0-3 3 3 3 0 0 0 3 3Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#3954D0",
        d: "m427.3 360.7-.5-.6 1.3-9 2.1-1.1 15.2-2 .5.6c-1.2 1.1-2.4 1.9-4 2.4.2.4-.2-.1 0 .2a10.5 10.5 0 0 1-6.1 2.7l.4 1c-1.5 1.5-3.6 2-5.8 2.5l.5 1-3.6 2.3Zm-4.6-10.4-.4-.8 2.8-6.9c1-2 1.8-4 2.6-6h.2v5.6l-.9 4.5-4.3 3.6Zm.6 9.4c-.2 0 0 2-.2 2l-.5 2.6-7.7 4.7c1.3 1-3.2 2.3-3.4 2.5h-.2v-.8l3.1-7.9v-.5l2.4-2.3.8-.3 2.3-1.8 3.5-3 .4.1-.5 4.7Zm-13.7-40-15.5-3.5c0-.3-3.5-10.2-3.3-10.6.2 0 3.1-2 3.3-1.7 1 1.8 3.1 4.8 5.2 6.7l3.2 1.2 8.8 1.7-.4 5.5c-.4.4-.9.2-1.3.7Zm-.3 5.2c-1.7 1.1-2.3 1.8-3.7 2.8l-24.5-3.5 10.7-4 .5-.4 17.2 4-.2 1.1Zm-2.6 47.3-.8 4a7.6 7.6 0 0 1-4.2 2.8l-.3.2-3 1.6.1.1c-.6.4-2.4 1.6-3 1.8-2.5.8-2.5 1-3 .7l.7-2.4.3-1.1 1.2-3 .7-2.2.5-.7c.3-.4 1-.6 1.6-.8 1-.3 1-.3.7-1.5 2.5-1.6 5-3.2 7.7-4.7.4-.3 1-.4 1.5-.5.4-.1-.4-.8.1-1 0-.3 1.2 0 1.2-.4v-.1l-2 7.2Zm-18.3-34.7.5.9-.3.3-3 1.9-.4-.1-5.7-11.2-.4-.7-.3-.6.6-.5 20.8 3.6c-.5.3-1.1.5-1.7.6l-1.8.4.3 1.2-4 2.6c-1.3 1-3 1-4.6 1.6Zm-7 3.8v-.1Zm5.1 44.9h-.4l-.6.4.4.8c-1.2 1.4-3 1.4-4.7 2l.1 1c-.8.7-1.8 1.3-2.9 1.5l-1 .2c-1 .3-1 .3-.8 1.5l-1.4.8-.1-6.6c.5 0 .8-.3 1-.8.2-.3.6-.1.9-.3 1-.3 1.7-1.3 2.6-1.7l9.4-5.2-2.5 6.4Zm-15-37.8.3 1.3-8.3 5.2-1.4.4-1.5.4.1 1-5 3.3-.5-1.2-.7-9 .3-1.8 2.2-.9c0-1.2 0-1.2 1.2-1.7l2-.8c.4-.1.6-.4.6-.8l19 .6-4 2.6c-1 .6-1.8 1-2.9 1.1l-1.3.3Zm-.1 47-1.4 2-7.8.8-3.2-1v-.9c.8-.3 1.7-.5 2.5-.4 1.2.1 1.8.5 2.7-.3.3-.3.6-.7.7-1.1.4-1.9.6-2.2 2.1-2.7.8-.2 0-.5.9-.7-.2-.5 2.5-.8 2.4-1.1l1.2-.8-.1 6.1Zm-13.6 8.8.4.9-.3.3c-1.5 1-2.5 2.2-4.4 2.4-.8 0-1.9 0-2.4.7l1 1.2c-1 .5-2 1.3-3 1.7-.9.4-1.5.5-2.6.8.3.7-1.5 1.7-3 2.3l-.6-.4.6-1.3 2.8-4.2.9-1.2 3.2-4.2c.6-.7 1.3-1.2 2.3-1.3.2 0 .5 0 .6-.2 1.4-1 2.8-.8 4.3-1l4 1 .2 1c-1 1.1-2.7.8-4 1.5Zm-19.8 8.6-6.4-21.4 2.9-1.7L344 400l1.5 3.3-6.3 9.1-1.3.4Zm-5.1 9c-1 .7-2.1 1.5-3.3 2-1 .6-2.3.9-3.5 1.3 0 .3 0 .6.2 1-1 .6-1.8 1.3-2.8 1.7-1 .5-2.1.7-3.3 1l.4.9c-1 .8-1.9 1.4-3 1.6l-.8.2 6.7-20.6 11.3 6.9 1.5 1.8c-1 .7-2.4.8-3.8 1.3l.4 1Zm-20.3 10-.8 2.3c-.3 1-1 1.7-2 1.8-.2 0-.4 0-.6.2v.3c-.4.5-.8 0-1.4 0l.2-2-.4-5.4v-1.3h.1v-.1l2.2-2.3 8-10.2-5.3 16.7Zm-5.1-11.8.4-6.8 1.4-10.8.2-1 6.9 5 2 1.8-10.9 13.8v-2Zm-3.3-10.2-8.7-4.5-.5-.5 2-5.1.1-.1.5-.3c.6-1 1.5-1.4 2.4-1.7h6.2l-2 12.2Zm-.6 17.6v.7c0 .5-.6.8-1 1.1l-7.6 4.9c-2 1.3-4 2.3-6.3 3-.5.2-1 .2-1.4.2h-17l-5.5-3.4-11.6-6.9.1-14.1.3-.4 11.7-7.5v16.3l1.1 1.5 1 2 1 1.1 1.6.7 1.9 1.5 2.6.7 3.7.9h3.2l2.9-.9 2-.7 3.3-4.2v-.4l.3-.7c-.4-.3.1-.5 0-.7-.3-.3 0-.3 0-.7-.2-1-.1-2.2-.1-3.3 0-.6.2-1 1-1 .6 0 1.3-.2 2-.4v-1.1l1.8-1.5c-.6-.5.4-.5 0-1-.3-.7-.3-1.2.2-1.7v-1.5l9 4.6-.2 12.9ZM290.4 531l-.2.2-.4.3-2.4.2-2.3-.3-.7-.4-1-1-1-.9v-.3l2.5-6 .3-.3.9-.8v-.1l3.1-1.6c.4.4.6.9.6 1.6l.4 5.1c.4 2 .3 2.6.2 4.3Zm-9.3-8.5-.8 1.6-.2.5-1.3 1.7c-.4.2-.9 1.3-1.6.6-.4-.3-.6-1.5-1-1.9 0 0 0-.8-.2-1v-1.6l.3-1.3.8-1.8c.3-1.1.4-1.3 1-1.9l1.2-.9 2.2 2.1.3 1.5-.7 2.4Zm-5.2-27-.9 2.1c0 .4 0 .7-.5.8-.3 0-1.5.3-1.7 0l-1.4-7.4 1.2-3.2c1 .5 3.8 1.7 4 2 .6 1.2-.3 3.8-.7 5.7Zm1.7 5.8.6-1 .2-.5c.2-1 .3-.9.4-1.3.1-1 .6-1.6.7-2.6.5.4 2 3.7 2.9 5.7l-.3.8-3 4-3.2-1.2c-.4-.3-.6-.6-.6-.7 0-.2.4-.4.7-.6l1.6-2.6Zm11.8 8.3v2.3l-.7 2.7-2.7 2.5-4.2-4.1-.4-.5V510l3-3.9 2.6-1 .9-.2 1.4.3v1.9c0 .8.5 1.6 0 2.4Zm-.3-18.2v9.4l-2.8.7h-.1l-3.5-7-1-4 .8-1 6.3-1.8c.4 1 .2 3.7.3 3.7Zm-11.6-18V472h1.8c.3 0 1.7 1 2 1 1.8.5 3 0 4.6 1 .2.1.7 1.6.9 1.8.2.2.2.7 0 1.2l-5.5-.6c-.6-.6-1.3-.8-2-1.5l-1.8-1.5Zm2.4 6.6 4.5.1c1.7.2 2.6.3 2.6 2 0 .3-.2.7-.4 1-.6.9-1.2 1.6-1.9 2.2l-2 .3-1.4-.9c-1.3-1-3.6-2.4-4-3.5-.3-1 1.5-1.3 2.6-1.2Zm-7.9 38.8c-.2 0-.5 0-.8.2l-1.2-.1-.6-8.3v-1c.2-1 .5-2 1.3-2.4.6-.3 5 2 6.4 3l.1.6-.1.2h.1l.1.8-1.3 2-4 5Zm-3.7-72-.2.7c-.2.3-1 0-1.2.2l-.7-.3-.3-.4-1.2-1.8-1-2v-.1l-1-4.8c.6-.2 1-.3 1.5-.2l1.4.8c1.1.8 2.3 2.2 2.5 3.2.5 1.8.4 2.8.2 4.7Zm-1.4 30-.7.4-.5.2-7.2 1.8-.1-.2-.5-.9c3-3.5 4.2-4.3 7.6-7.9l.9-.4.5.4v6.6Zm0 12.7-.8.4-6.2-5.2-1-.9v-1l8-1.9v8.6Zm-.3 12c-.2.6-.2.7 0 1.4l-.4.5-.4.5-.4.6-7.3-15.9.6-.3 7.4 6.3.5.8.1.3-.1 5.7Zm0 28.4-1 .6c-4-2.4-11.4-7.3-17.6-11 0 0-.2-.5-.7-.8l5.4 1.4 13.3 3.5.6.4v5.9Zm-24.1-15.4-1.6-.5c-.6-.1-1.8-.6-1.6-1.1v-.2l4.9-8.8.6-.5.7.2 14 14.3-.1.3-16.9-3.7Zm-7.5-4.8c-1.4-1.4-5.5-6.9-8.4-10.1l-.4-.7.4-.4 13.6 1.2a7 7 0 0 0 1.1.4l-.2 1.7-4.3 7.9H235Zm-9.8-5-18-11.5.5-.7 11.5 4 1 .6 5.7 6.9-.7.8Zm-27.7-19.6 14-2.1 1.7.7 1.2 6.3-.5.7-16.1-4.8-.3-.8Zm-5-3.3c-.9 0-2.7.1-4-.6l-1.5-1.3-2-4 .3-1 19 4.4.4 1c-4.4.5-4.7.9-9.2 1.3l-3 .2Zm-10-13.2-4.6-10.8 1-.6c.7.9.6.9 2.2 2l9.2 5.8.4 1-7.8 2.7-.4-.1Zm-1.8 6.5-8.3-8.5.7-.6 5 3 2.2 1.7 1 3-.6 1.4ZM170 461.6v-.5l3.4-3.5c.3.2.5 0 .8.3l1.7 5.4.5 1-.4.4-5.3-2.6-.7-.5Zm-1 7c-7.6-4.8-1.5-1.2-9.1-6l-.6-1.1 4 .5 3 1.8 2.3 3 1.2 1.2-.8.6Zm-25.2-33.1.2-.2 7.6 4.5c.6.2.6.6.6.7 0 .6.8 1.3 1.5 1.6.2 0 .3.2.5.3l7.2 12.2-.5.3-2-2.1-15-17.3Zm14.3 22.8c-2.5-.5-3-.3-5.5-.8l-2.4-1.2a8 8 0 0 1-2.4-1.7l-3.1-6.7-3.7-9.5 17 18.8.3.4c-.3.3.2.3-.2.7Zm-18.6-29.6c2 .3 4 1.3 5.5 1.5l1.9 1 2.2 3.6-1 .3-8.3-5.3-.3-1.1Zm-9.6 7.2-1.2-.7.3-1 3.7-3.1 2 1.9 1.7 3.4 3.3 9.1-9.8-9.6Zm7.6 12.4L112.3 432l-2-1-.2-.7 2.2.7 5.7 2.4.6.3.5.2h.2l2 .8c2.2.7 4.3 1.7 6.1 3.4l10.7 10.5-.6-.2Zm-30.8-21.5v-8.5l4.3 3.3-.9 3.4-3.4 1.8Zm4.1-13 1.1-.8.6.2.5.3 1.4 3v.3l.3.6.2.5-.3 1.3.2.2-5.6-4.1 1.6-1.6Zm8.2-5.2.3 1.2h-.1l.5 2.8-2.4 2-2-3.7 3.7-2.3Zm4 22.2-.4.4-8.4-3 1-.7 4.6-1.4 3.1-1.4.2 6.1Zm-.4-15.8.6 3.9-1.4 1.3-2.5 2.2-4.5 1.5.6-1.6.4-.1 3.2-3.6.9-1.3 2.7-2.3Zm.4-22.3h-.3l-2-1.4c.9-2.4 3.8-2.5 5-2.3l.4 1.7.9 5.9c-.5-.1-.8-.4-1-.9l-2.3-2-.7-1Zm-.3-11.8.1-.3.5-.7 5.3-3 1.8 1h-.3l.3.4v1.5l-3.5 2.6-1.2 1-3.3-2 .3-.5Zm0-31.6 1.2.2 9.4 4.7-3.3.7-.6.4-1.2.3-2.2.3-1.2-.1-1.4-.7c-2.6-2-2.1-5-.7-5.8Zm-2-8.8c-.2-.6.4-3.6.4-5.7s.8-3.5 1.7-7c1-3.6 1.7-2 1.7-2l.2-.2 1 .7-.3 19.7-3.7-1-.5-.6c-.2-.3-.2-3.3-.5-3.9Zm-.6-28.7c-2.3.6-3.5 1-5.6 1.4l-.7-.4 2-4.6.8-1.4 1.1-.3c.4.7.5.4.2-.2l2.3 5.3h.2l-.3.2Zm-10.7 1-1.4.6H105l-5.4-.5-.3-.4 13-5.3-3 5.6Zm-5.2 23.8v.4l-1.2.2c-.5-.5-.9-1-1.2-1.6l-.9-1-.4-.3c-.5-1.8-2.8-2.4-3.3-4.3-.1-.3-.4-.6-.7-.8-.5-.2-1-.5-1.2-.8l.5-1.3h7.7l.7.7v8.8Zm-12-40.2.6-.4 6.4 1.9-4.8 10.1-2.2-11.6Zm-.6-7 .3-2.3V286l9.3 1.9v.2l-9.1 1.7-.5-.2Zm-2.9-8.1-11.3-1.9 14.5-2.6.3.4-3.5 4Zm1.6 30.2a32.4 32.4 0 0 1-8-2.9l-.2-.7 6.1-9.2.8.3 1.9 11.9-.6.6Zm-11.7-5h-.4a32 32 0 0 1-5.4-4c-.7-.6-1-.8-1.5-1.5l.5-.8 12.3-3.7.6.4-6.1 9.6Zm2-22.8 7.6 1.5-.1 2.7-.3.5-6.8-3.9-.4-.8Zm5.5 7.9-.2.5-13.8 4.2 6-9.2 8 4.5Zm-19.4 4.2a19 19 0 0 1-1-14.3l1.8-.5 7.3 4.3h-.2L68 296l-1.3-.2Zm8.3-24c3-2.3 4-3.4 7.2-5l-2 8.6-11.3 2-.3-.4c1.6-2.2 4.2-3.6 6.4-5.2Zm11.4-6.3.1-.1 5.4 7.5-7.3 1.4 1.8-8.8Zm3.7-1.8 4.7-.7H97l3.4-.2.2.3-4.9 8.2-5.8-7.5s-.2-.2 0-.2h.1Zm14.3.8-.2 6.5-5.5 2.2h-.3l4.2-6 1.8-2.7Zm-3.7 19.6-7.8-1.5 2.5-4 .7-.6 4 5.2.6 1Zm4.5-1.1-.7.2-5.4-7 5.3-2 .2.2.6 8.6Zm-4.8 13.2-7-2.8v-.4l9-2 .3.3-2.3 4.9Zm1.8 4.2 9 3-13 5.7 4-8.7Zm6.5-7 5.5 7.5-.3.3-10.2-3.3 2-4.9 3 .4Zm-1-27.5 6.8 4.6.3.4-7-.4V266Zm9.9-2.8 3.9.8h.8c.6 0 .6.2 1 .4l-.3.6-3.5 4.3h-.5l-8.5-6h7Zm7.9 4.4h.7l.9.9c1.9 2.2 4.4 2.5 7 2.3l1.3-.2c1 0 1.2.2 1.3 1.5l.5.1c.7.6 2.2 1.6 2.3 1.9l.2.4-.2.8-17.6-3.3.2-.2 3.4-4.2Zm17.2 12.8.7.8c.3 1 .5 2.2.6 3.3.2.8 0 1.1.1 2v.2h-1l-5-.5-3-.4-.3.1-.6-.2-4-2.9 11.7-2.6.8.2Zm5.4 31.8 7.8 6-1.5.5h-.6l-1.3.5-5 .6-2 1a3 3 0 0 1-.5 0l-1-.7V313l4-1h.1Zm3.6-2 17 4 .1.4-5 3.7-9.8-6-2.3-1.8v-.2Zm2.1-3.7 23.5-6.2.2.3-5.1 10.3h-.8l-18.4-4.1.6-.3Zm19.7-16.2 2.5 5.5-.2 1-19.7 5 17.4-11.5Zm15.7-10.3-.3.8-8.3 12.9-1 .4-2.7-6 12.3-8Zm6.5-2.4 9.8 13.1-1 1.9-20.2 3.3v-.7l.4-1.4 9.7-14.7 1.3-1.5ZM206 269c.8 6.4 2.3 12.7 3 19l-.9.4-10.5-14 8.4-5.4Zm5.8 30.8 2.2.2 11.5 10.8.2 1.5-1 .6-14.9 6.8-.4.6-.1-.2 2.5-20.3Zm19.4-15.5-.3 1.4c-6.4 1.9-9.5 2.5-15.9 4.4l-2.2-1.6-3.4-19.5 21.8 15.3Zm-5.5-29.7.6.2L233 280l-.4.5-19.4-13.2-2.2-1.8 14.8-11Zm44.3 22.5v.5l-.4.1-32.1 3.9-5.1-18.8-2-8.1 39.6 22.4Zm-37.5-25.7 18.3-.7 16 9.8 5.7 12.3-.5.6-.3.1-39.3-21.8v-.3Zm16.5-13.3.2 1.5-.1 7.3-14.9 1c5.1-3.6 11.2-7.2 14.8-9.8Zm3.4 3.5 6.5 3.8.6.3h.3v.1l5 2.8.7.3 3.3 1.3.2.3c.8 1.4.6.8.6 2.5l-2.9 3.5-6.3-4-4.8-3.4c-1.5-.9-3.2-1.9-3.2-2.2v-5.3Zm.5-18.6c2.2-1.4 8.5-4.5 10.5-5.9.4 1.4.1 1.7-.7 3-.1.2 0 .7.1 1l1 3.2c1 .2 1.2.4 1.4 1.6l1.8.5c.6.1 1 .4 1 1l-.1 3.8c0 .4 0 .4-.4 1 .5.2.5.6 1 .8.7.4 1.6.7 1.9 1.8 0 .2.3.4.5.5 1.3.5 2.6 1 4 1.3 2.2.3 4.6.7 7-.1 1-.5 2.3-.6 3.6-.8.9-.1 1.7-.3 2.2-1l2.6-5 .1-13.2 12.3 7.3v12.6l-.5 1.8c-.5.4.1.2-.5.5l-2 .5-.4.2.2 1c-.5.2-1 .6-1.6.7-1.5.2-2.8.7-4 2l.2.6-2.7.8c-.2 1.3-.3 1.4-1.5 1.7-1.9.4-3.8.4-5.7.1h-1.2c-2 .3-4 .3-6.1 0h-1.3c-2.2.2-4.3.3-6.5 0l-4.5-2-.6-.5-.7-.6-6-3.4-3.8-2.6c-.3-.2-.6-.4-.7-.7l.1-13.5Zm8.5-17.5-1-3h.3l1.4-3.1.2-.1h-.2l4.3-5.4.5-.1 1.5 4.7v1l.3 2.2.2 1c0 .4.5 1 .9 1.7.2.3.7.7 1.2 1l.5.6-6.2 2.2h-.2l-3.7-2.7Zm-4.7-12.8-1-3.8 9.1 1.2-6.2 7c-.8-1-1.6-3.2-2-4.4Zm4.5-17.9.7 2.2 1.8 6.1.3 1.3h-.3l.5 1.6-9.4-1.4 6.4-9.8Zm-8.4 6 .4-.8-1.1-4.2-.2.2-1-3.6-1-3.3 8.9 2.8-6 8.8Zm2-25.6.3.8.5 1.3 2.5 8.5.7 2-9.5-2.7 5.5-9.9Zm-8.3 2.8-1.8-7.2 7.2 2-4.8 8a25 25 0 0 1-.6-2.8Zm-4.4-11.7-1.9-2.3-.2-.7-.6-2.7-.2-1 10.3.6.6 2.4 2 5.4h.1l.5 1.2-10.6-2.9Zm-4.1-13.5 7.8-4 .9.5 2.1 6.8s0-.1 0 0l-6.5-.6-3.9-.3-.4-2.4Zm-.4-7v-3c0-3.2.4-4.9 3.2-6.3 1-.4 1.7-1 2.5-1.5v4.1l.1.7-.3 3v1.8l-5.4 3.2v-2Zm34.6 72.9v-.4l.5-1.9.4-2.4v-.3l1.2-3.6 1.1-3.9 1.3-4 1-1.8 1.5-.1.8.4v.6h.1l-.1 1.1-.8 5-.2 1.9-.4 2.2-1.4 8.5v.6l-.5 2.6-.1.6-2-.4-2.5-3v-1.7Zm10.7-30.5c1.1 0 2 .6 2.3 1.5l.1.5-.1.6v.2c-.7.8-.1.5-1.1 1h-.5l-.7.2c-1 0-2-.6-2.3-1.4l-.1-.6c0-1.1 1-2 2.4-2Zm2.6 13.2v1.5l.2 2.4.3 7.7-.1 3.1V197.6l-.1 2.7-.2 2-.4.5c-.8.8-2.4 1.5-3.5 2l-.7-.6-.1-1.3 1-6.4.4-4.3.7-6.2h.2v-.8l.2-.9.1-1.7v-1l.2-.3c.1-.1.3-.4.4-.3l1 .4h.4Zm5.7 71.3.3-1 10.8-6.8 1 6.4-12.1 1.4Zm11.4 9.8-.4 1.5h-.9c-1.8-.5-1.6-.6-3.2-1.5a253 253 0 0 1-8.8-5.4l1.2-.5 12.6-1.4.6.8-1 6.5Zm4.5 17.8-.1 3.1.2.3-6-4.3h.2l-4.9-2.7-6.7-3-.8-.3 10.5-4.7c1.8.8 3.7 3.6 5.9 6.5l1.7 5Zm-.8-13.4 4.3.3 1.1 1 .2 3.3-2 .9-1.2-.9-3.2-2.3.8-2.3Zm1.6-25.6c.8-.6 1.5-.9 2.2-1.3l.2 4.5-2.8 4.2-.7-.2c0-.8-.2-1.5-.4-2.2l-.3-3.7c.3-.5.8-.7 1.8-1.3Zm3.1 9.2.6 12-5.3 1 1.2-7 .2-1.9 3.3-4Zm.8-24.6.1-5.3 1.7.6 5.6 2.6 2.2 5.3-.7 1.3-4.6-.1-4.4-3.3v-1Zm.2-9.5 5.6-2.4v.1l4-1.4.9.1 5 1.4-7.4 3.4-3 .7-1.5-.3-3.6-1.4v-.2Zm4.5-9.9 1.4-2.8 1.1-.5h.3l4.1-1 2.2-.3-4.6 5.4-.5.6-2 2-.6.3-3.8 1 2.4-4.7Zm7.9-15.4 1.8-.5 2 1v-.2l5.8 3.2-3 2.2-2.4.8-1.4.3-6.8 1 4-7.8Zm2.1-8.2v-1.5l3.5-1 .2 3 1.9 6-4.4-2.4c-.2-.1-.2-.3-.3-.4l-.9-1v-2.7Zm0-10.6v-4.4l2.2 1 .3 1.3 1.3 6.6-3.8 1.3v-5.8Zm11-13 8.4 5.2-8.2 5.7h-.4l-9.5-5.8 9.6-5.1Zm12.7 114.8 1.7-.2c2.4-2.2 3.2-3.8 4.6-3.7l-1.3 6.3-12.6 4.1-1.3.4-.9-2.8c2.3-1.4 3.8-1.8 6-3.2 1-.7 2.5-.7 3.8-1Zm11.3 8.1.3 4.3c-.2.4-.5.9-1 1.1l-1.6 1h-.2l-4.4-1.8.1-.6c1.7-1.1 2.7-1.4 4.4-2.3l2.4-1.7Zm-1.5-10.8 1-4.6.2-.2c.2-.6.4-1.2.8-1.8l2 1 2.8 1.8c.2 0 .5.5.7.6l-.2 2-.2 1-1.4 1.6-6.5 3 1-4.3h-.2Zm10.2 5.3 1.8-1 .1-.2 2.1.9 2.2 1.5-.4.3c-1.4.2-.5 1.4-1.5 1.7l-.8.9-1.5 1.3-5.8 3.8-1-.2-.3-5.8c1-.3 1.6-1 2.3-1.5l2.5-1.5.3-.2Zm-16.2 17-6.6 3.7-.7.3c-3.3-.2-4.2-3-2.3-4.8v-.3l5.2-3.9 7.6 3.2a6 6 0 0 1-.9.5l-2.3 1.4Zm-1.9 80.4c0 .2 0 .3-.2.5l-.5-.3-8.7-6 8.8-3.8c.4.2.6.5.6 1v8.6Zm-7.3 19 .6-.8 3.3-.2h1.4c1.8.9 2 1.8 2 3.8V398.2l-2.6.6-1.2-.3c-.3 0-2.4-1.5-2.4-1.5l-1-1.7v-2.2Zm4.8-11.3c.5-.6.9-1.3 1.5-1.8.2-.3.4-.6.6-.5.2 0 .4.5.4.8V388.8l-7-.3-.6-.4c1.9-2.2 3.2-4.1 5-6.3Zm-.7-4.9-7.1 8.7-1-13.7 8 5Zm-9.4-20.5 7.7 4.7.6 1.1-6 2.2-1.6.7-.3-.4-.7-8.3h.3Zm9.7-6.9 1-.4.6 1.1.8 8.6-.5.4-.8-.3-8.7-5.3h-.2l7.8-4Zm-.2-26.3-.1 1.1-.2 3.5-.4 5.6v2.8l-.2 2.7-.2 6.7h-1.7c-.2 0-1.6-.4-1.8-.6l-1.2-.6-1.5-1.3a6.7 6.7 0 0 1-1-2.2v-24.6h1.5l5.8 5 .1.3.2.2.4.6.2.7v.1Zm-8-37.8.2-.6 12.8-4.2-.2.8c-1.8 1.2-3.7 2.4-5.7 3.5l-.8 1-5.1 4-1.3-4.5Zm2.6 19.6h2.4l2.9-.4h1.2l.3-.2a834 834 0 0 1-9.5 8.2 12 12 0 0 1-1.8-1.2l-.1-.3a12 12 0 0 1 1.7-7.5l3 1.4Zm-7.2 45.2c-.7-2.5-1-4.5-1.5-7.1l-.7-5.3v-1.1l2.3-2.1v6.2l.8 2.5v.5h.2l.2.4c.3.5.7.5 1 1l.7 1.4c1.5.7 2 1.5 3.5 2.2l-4.7 2.3-.5.1c-.3-.2-1.1-.2-1.3-1Zm-5 26.5 5.2-4.2.4.2.4 9.5-6-5.5Zm-2.7 7.6c-.1-.1.3-1.1.6-1.9l.4-2 2 1.8c1.6 1.6 1.8 1.5 3.4 3l-.2 1.2-3.5-.4-2.7-1.7Zm-3.8 5.8 1.2-.3 1.4 1 7 22.8-11.2-7-11.6-8.6L325 390Zm-23.5.3.2-.3v-.2l.6-2.1H321l-9.4 5.7-1.4.6-9.8-.3 1-3.4Zm-6.1-19.6 2.6-7.8.2-.5 8.5 1.6.2.2c0 .3-.2 1.5-.7 2.5l-.7 3-2.3 4.4-1 1.4c-.4.6-1.3 1-1.6 1.7l-5.2-6.5Zm-5.6 17.4 3.9-12.4 5.2 6.1-.1 1.2-1 2.8-.2.3-1.2.4-6.6 1.6Zm-3.2 10 .4-1.4.2-.5 1.2-3.2 7-2 .1 1-3.1 8.5v.2c-.4.5-1.1 1.3-1.9 1.4-.3 0-.4.5-.6.7-.5.6-1.4.2-2-.1-.7-.3-1-.6-1.1-1.4v-.6h-.2v-2.7Zm-2.5-29.4-.8.5-.7-1.6-1.8-5.5 8.8-.2 2.4.2 1 1.1-8.9 5.5Zm-3.8 23-.9-5.9-1-9.8h-.1l-.3-2.8.3-4.4c1.1 2 2.9 6 3.5 7.4h-.1l2 4.3 1.2 2.8.6 2.1-.1.1.2.3v2l-1.9 5.9c-.7.1-1 .4-1.7.5-.4 0-.7-.1-.8-.5l-.6-.2-.3-1.7Zm-5-30h-2c-.4 0-.6-1-1-1.1l.2-1c1.5-1 2.4-1 3.8-.2l.2.7v1.2l-1.2.4Zm-4.7 19.8.6-6.5c0-1.9 1-5.2 1-6.3l1.4-.6.1 1.6h.2l.8 10h.2l1.3 14.5-.6.9a4 4 0 0 1-2.7-1.5c-.3-.4-3-.1-3.4-.5-.1 0 0-.2 0-.4h-.1l.6-4.9.4-4.7.2-1.6Zm-12.7-13.8 6.4-14.4 2-4c.3-.5.5-1.4.8-1.8l.7-.5h.7l21.4 11.6h-9.6l-.6-1.6-1.6-.8h-.1l-.6-.3h-.2l-.8-.4-1.2-.2-2 .2-1.9.6-2 1.7-.6 2.4-10.8 7.5Zm-.4 5.4.9-1.3 10-7-1.6 14.5c-.2 0-.2.5-.5.6l-8.8-6.8Zm-4.8 16.1c-1.8 1.2-3.3 2.3-5 3.3l-.2-.6 6.6-15.3.8-.7 8.4 6v.3l-1 .8-4.6 3c-1.3.9-1.2.7-3 1.7l-1.2.8c0 .4-.9.3-.8.7Zm9 74.3-13.5-2.5-.7-1.5 2.3-4.2c.2 0 .8.5 1 .8l1 1.3c1 1.9 2.7 3 5 3 1.5-.1 2.8.4 4 1.3l1.2.8-.4 1Zm-8.2 11.6-4.4-9.6.6-.7 11.6 2.2.8 1.4-7 7.2-1.6-.5Zm7 27-8-7.8-1.2-1.7-.4-1.6.2-.5 1.6-3 1.3.7 6.8 13.7-.3.3Zm-4.7 6.6 3.1 1.2 7 5 .2 2.2.3 1.6c-.4.2-.8.1-1.3.4l-.5-.5-9-9.7.2-.2Zm-8.9-10.2 1.4-2.7 1.2.4 2.8 2.6c3.3 3.7 2.4 2.4 5.7 5.8l-.5.5c-4-2-4.4-1.8-9-4.1l-1.6-2.4Zm-7.4-16.7c-.2-.1 0-.2-.2-.3l.4-.6 8.9 1.2 1.6 1.7-1.9 4.7-.7.3-.9-.5c-2.6-2.6-4.6-3.8-7.2-6.5Zm-5 10-1.3-1.2-.2-.5 11 2.8 1 1.6-.8 1.6-1.3.3-2.2-.5-6.3-4.1Zm-8-1.7h1l7.6 6.2-11.5-1-.4-1 3.2-4.2Zm-9.2-7.2 6 4.7v.6l-3 4.3-.8.1-1.3-4.2-1.3-5.2.4-.3Zm-6.5-18-.4-.4c.7-.3.4-.3 1-.4 3.6-.6 6-1.3 9.5-2 1.3-.1.5 0 1.7.3l.8 1-5.5 7-2.3-1.4-4.8-4Zm-8.2 6 .2-.9c3.8 1 9.2 3.5 12.1 4.3l.5.5-.8 3h-1c-2-1.1-5-3-8-5l-3-2Zm-6.6-1.2 8.7 5.3.1.9c-7.4-2-10.6-2.5-18-4.6l.8-.4 6.1-2 2.3.8Zm-14-15 11.6-1 1.1.6-.5 6.7-.2 1-.2.1-12-6.6.1-.7Zm.5-9.2c.6-.1 1.1-.2 1.8.2 3 1.5 4.7 1.8 7.5 3.3l.2 1.2c-4 .6-8.5.7-12.4 1.3l-.1-.3 3-5.7Zm-3.5-6.3c-3.7-2.8-7-4.7-10.8-7.5-.5-.4-.8-.9-1-1.4l10.3.2 2.1 8.7.5 1.1-1-1.1Zm-8 4.2-3-7.9 10.5 7.8c-.2.2.5.7.6.7l-3.3 6.2-1.2.4h-.2l-2-3.7a54 54 0 0 0-1.4-3.5Zm-4.4 5.8 5.3 3.9.1.3-.3.7-3 3.3-.9-.3-3.9-5.3-3.1-5.7 5.8 3.1Zm-4.2-15.9H163.3l4.2 11.5-.4.6-8.4-5-.3-.8 4-6.3Zm-5-2.8.8-.3v.2l.9 1.5-1 1.6-3.2 4-4-6.4 6.4-.6Zm-8.8-10 1.2.5c.7.2 1 .6 1.2 1.3v.2l1.1.2 1.8 1.8h1.2c.6 0 1 .2 1.2.7l.8 1.4-6 1-1.2.2-.2-.4-1.5-1.1.4-5.9Zm-.7-13.8 3.3-2.6 1-1.2 8.6 6.7.2.7c1.1 1.8 2.2 3.7 0 7l-1.5.8-1.8-1.3v-.2l-6.1-4-2.3-1.6-.2.1-3.7-2.7 2.5-1.7Zm-11.8-49.4 2.7-.8 2.5 1c.2 0 .3 0 .4.2l1.7 1.2 1.6 1.8.3.6-8.5 4-3.2-1.3-.9-.8-4-3 7.4-2.9Zm.6-12 .4.5v.2l4.7 8.2-7.5-3.9-2-1.1-.5-.7 4.9-3.3Zm-7.8-11v-.3l.1-6.2 6 13.6-.3.4c-.1 0-.3.3-.2.4v.2l-5.7 3.5.1-11.5Zm.4-7.6-.3.2v-.7l.3.5Zm-6.2-22 15.2-1.6-.6.4-4.8 3.3a4 4 0 0 1-1.3.5c-1 .3-2 .6-2.8 1.4-.8.8-1.8 1.2-2.9 1.5l-2.2-.2-2.9-4.9 2.3-.4Zm-9.8-13.1 10.3 4.2.4.1-5 4.2-.9-.2-5.8-7.6 1-.7Zm-4.6-9.5-.5-8 6.2.6-5.7 7.4Zm3.8 1.4-.2-.2 4.5-5.2.8-1.2c.2 0 .7-.5.8-.4l3.7 3.9-9.6 3.1Zm10.2-7.8 13.5 2.5-9 1-1.4.2-3.1-3.7Zm2.7 7.3 2.9 3h-10.8l-.3-.3 4.7-1.7 3.5-1Zm2 10.5-9.6-3.6-.2-.4 11.9-.2-2.1 4.2Zm9.6 5.3.4.2v.6l-12.6 1c.7-.8 2.3-2 3.5-3.4l8.7 1.6Zm6.4-2.6-2.4-.3-9.4-1.9 2-4.3 2.6-.2 7.8.7a22.3 22.3 0 0 1-.6 6Zm5.5 33.7 1.2 1.3v1.4l-13.4-8.3-.6-.6 7-.6c.1.1.3.1.3.3 2 2.2 3.6 4.3 5.5 6.5Zm26.8 6.3 2.7-4.5c.5-.6 1.7-.3 2.1 0l5.9 3.8-11.4 4.6-.9-.6 1.6-3.3Zm13.9-23.6.6.5-11 12.7h-1.3l-2.5-9.6.8-1 13.4-2.6Zm.5-5.2-.4.9-4.8 1-8.5 2 4.4-10.2.5-.2 8.8 6.5Zm5.5-1.7-1.7-.3-9.1-6 1.2-.3 18.6-3.3.3.5c-2.8 3-6.7 6.6-9.3 9.4Zm10.4 12.5-.7.4-7.7-8.7v-1.3L208 298l.2.2-2.2 20Zm13 15 3.7 2.2v.6c-3.9 2.5-11.6 6.5-14.6 7.9l-.7-.5.3-16 .4-.1 10.8 5.8Zm8.9-17.8.3-.3.2.4-.8 6-1.7 10.4-1 .7-7.3-4-7.3-4.1 2.3-1.6 13.8-7 1.5-.5Zm15-9.6.9.3.2.4-12.6 3.8a3 3 0 0 1-1.2-.6l-8-6.8-5.5-5.5 26.1 8.4Zm0-4-26-8.4 14.7-4.5 2-.6 1.7 1 2.4 3.3 5.2 9.2Zm14 24.2 11.3-13.8.1-.4.7 14.8v-.4l-12-.2Zm-1 11.4-1.4-.3-.7-6.2 1.2-1.4h2l9.2.3.2 1-10.4 6.6Zm-5.6 19.4 2-1.3c.4-.3.9-.3 1.3-.5l1.6-.4c0-.8.3-1.3 1-1.7l6-3.9-8.5 18.5-2.9-9-.5-1.7Zm-6.4 33.9-1.2.1-12.4-15 19-1 1 .2v.5l-6.4 15.2Zm.8 32-.7-.7.4-.5 4.2-3 1.2 1.6v3.8l-5-1.2Zm0 3.8 4.2 1 .9.4v3.4l-.1 1.2-.9.3-1.6-2-2.5-4.3Zm-10.4 36v-.5c2.7.3 3.6.8 6.4 1.2 1 .2 1.9.6 3 1 .7.2 1 .3 1.3 1l1.2 2.5 2.6 5.7-.4.2-14.1-11Zm2.6 14.1-1.5-1.4-3.5-9.4 1.2-.2 14.1 11.5-.4 1.1-8.5-1.1-1.4-.5Zm-3 5 1.4.3 4.8 5.7-.6.5-7.9-2-.4-1 2.7-3.5Zm-2.7-2.4v.8l-3.8 4.1-2 .6c-2-1.5-4-3.3-6.1-4.7l-1.3-1.3.8-2.4.8-.5 11.6 3.4Zm-5.3-13.5 2.4.4 3.4 9-.5.5-6.4-1.6-2.5-1-1.3-1 5-6.3Zm-14-23.1-.4-1 9.2-2.4c1.4-.3 2.3-.4 2.6 1 .3 1.6.4 4.2.7 5.8l.8 6.7.2 1.3-.4-.3-12.6-11.1Zm-8.6 6.8-.8-.4v-1.3l4.8-4c.4 0 .4.3.8.1l12.6 11-.4.4-17-5.8Zm3.8 11.7-1-.6-4-7-.5-.6 1 .1 15 4.8c1.1.4 1 .4 1 .2v1l-11 2.1h-.5Zm-6.3 5c1.4-.5 2.6-.7 4-1h.6l1.3.1 6.3 5.2-.4.5-11.3-4-.5-.5v-.3Zm-2.4-11 .7.5 3.5 5 .7 1.3-4.6 1-.8-.6.5-7.3Zm5.4-14.2.1.7c-1.4 1.2-2.1 2.2-3.8 3.6l-.9.3c-.4 0-.2-.5-.5-.8l-2.3-8 7.4 4.2Zm-9-12.5-.8-.2-1-3-2.2-8 .8.2a3 3 0 0 1 1.8.5l4 2.6c.5.3.8.8.9 1.5 0 .3 0 .7.2 1l-3.8 5.4Zm-8.4 13.8c.1-.6-.1-.4.4-.7l5.3-4.8h.6l2.3 8.6-1 .8-3.9-1.7-3.8-1.8v-.4Zm2.9-8.4-5 5-.6.3v-.3l-2.3-8.3 7.9 3.3ZM176 420a2058.9 2058.9 0 0 1 7.1-4.8l.4 1-4.3 9.9-3.5-5.3c.2-.2.3-.5.3-.8Zm-2.2-20.1-.8-1.1-.4-9.4-.2-.2h.3l.6.4h.1v.1l6.2 6.6v.2l-5.8 3.4Zm-7 25.8c.3-.3.5-.5.8-.6l3.9-2.5.7-.4 3.5 4.8H173l-6.3-.2c0-.4 0-.8.3-1.1Zm2.3-23.9c0 .8-.2 1-.4 1.7-2 1.3-2.9 2-5.2 3.2l-.3-.4-1.2-.5-.5-2.5-.6-8.4 8.2 7ZM159 385.3l.2-6 6.4 4.8.7 1-2.1 1-5 1.4-.2-2v-.1Zm-1-11.9c-.4-.1-.7-.3-.9-.6l-1.7-3-1-2.7 10.1 6-5 .3H158Zm-1.3 20.4.2.1.5 2 .7 6.5-5-3.4-.6-.8 4.2-4.4Zm-8.1-7.6 5.4 5.4-3.6 3.4-2.3-8 .5-.8Zm6.3 4.8-.1.2v-.2Zm-1.2-5-4.4-3.4.7-.9 5-3.8v.3l.3 7.8-.1.7-1.5-.7Zm-7.3-7-2.1-7.6 7.9 2 1 .4v.2l-5.1 4.8-1.2.1h-.5Zm-2.2 8.6.5.4 2 8.1-7.6-4.3 5.1-4.2ZM138 381c2 .8 2.6 1.3 4.5 2l.7 1-4.7 4.3-1-5.1-.3-1.8.8-.3Zm5.6-.5-.6.4-5-2.3-.8-1 2.5-5 .5-1 .2-.1 3.2 9Zm4.8-16.8h.9l.6 1 1.7 4.4-7.4-1.5-.8-.5c1.6-1 1.7-1.3 3.4-2.3l1.6-1.1Zm5.5-6.5v.2l-5 1.7c-.2-.1-.1-.2-.3-.4-.5-.4-.3-.6-.7-1.2l-2.6-3.8-.1-.3-2.7-4.8 11.4 8.6Zm3.5-2-14-11.2.2-.2 15 .7c.1.2.3.1.4 0l-1.6 10.6Zm4.6 9c1.7 2.2 2.3 3.3 3.4 5l-1.5-.6-11.4-6.7 1-.6 3.2-1.3h.1l2.9 1.2c.7 1 1.4 2 2.3 3Zm17 1.2-13.8-6.2-2.4-1-1.7-1.2-.1-.7 1-9 .6-.2 16.4 18.3Zm2.5-14 3.7 4.3-1 .4-15.5-9.3-3-2.8 3.8-1.3 2.2-.1 1 .6 6.6 6 2.2 2.1Zm9.1-13-4.9 8.8-6-4.6 10.6-4.5.3.3Zm19.9 13-5.8-.3-.3-.3-1.8-1.1-3.2-5.6 11 7.2ZM222 355l-.1.4-12.3-8 14.2-8 .3.2-2 15.4Zm13.7 38.6Zm7 14.3h-.7L231.4 397l.2-.5 2.5.1 5.7 1.1 2 .6c.5.8 1 1.4 1 2.2v7.3Zm2.5 26.9-11.3-7.1v-.6l4.8-1.8 1.3.6c0 .2.2.4.4.5l.2.3 4.9 7.9-.3.2Zm-11.7 10.6 1.6-.8c4.5 3 4.2 3.6 8.9 6.7l1.3 1c.7.3.9.8 1.1 1.3.2.3 0 .3 0 .6L245 457h-1.3l-10.2-11.7Zm-4.6 0c2.8 3.3 4.7 4.9 7.5 8 2 2.3 2.4 3.2 4.4 5.5l-.6.7-8.6-1.7-1.9-2-2.1-11.2 1.3.6Zm-6-27.5 2.6-.8.3-.2.5.3 3.9.3 1-.1 4.5 3.3 1 .6c.4.2-.5.2-.2.5l-3.8 1.7-6.3-1.5-1 .1-2.8-1.8-.1-.1.4-2.3Zm-6-1.2-.5-.3a18 18 0 0 1-2.2-1.6l-.3-.1-1.7-1.7-.2-.6.2-.6 2-3.7 1.6-1 2.5.5 2 1.3 1.8 1.3 2 2 .5.2.2.2-.3.3h-.3l-.3.3-7 3.5Zm-10.8 9.6c.8.4 1.4 1 1.8 1.8.6 1 1.6 1.6 2.8 1.8.7.1 1.4.3 2 .7l6.6 4.3.4.1c.6.8 0 .7 0 .8-2 .4-7 1.8-10 2.3l-1-.8-.4-1-.5-1.4-2.3-9 .6.4Zm-2.9-19-.3-.6c-.2-.2-.3-.3-.3-.5l-.2-.8.2-3.3 1 .5c1.2 0 4.5.5 4.5.5l2 1.1 1.1 1-.2 1-.1.5-2.1 4.5c-1.5-.7-1.7-.8-3.2-2l-2.4-1.8Zm-2 18.6.5.4 2.6 10.4-6.8-3.8-.6-.7.4-1 3.9-5.3ZM191 375l5.1-.8.7-.1-2.9 7.2-1.6 3.3c-.2-.6-.2.1-.3-.5l-1.2-7c-.1-1 0-1.3.2-2.1Zm6 12.2-1-1 2.6-6.5 1-1.8 2.1-4.1h.3l.1.2 4.3 16.3-9.4-3Zm1.6 4.4 9.7 3.8.5 3.2c-1.7.7-5.7-.7-9-2.4l-1.5-3.7.3-.9Zm18.7-.8-6.2 1-.8-1.5L207 377l3.4 4 7.1 10Zm.4 3.8-2.5 4.7-.8.6-1 .4h-.2c-.3-1-.4-1.8-.5-2.7l-.1-1.2v-.6c.4-.3.8-.4.7-.6l3.2-.7h1.1l.1.1Zm8 13.4-7.6-5.3V401l2.9-5 .7.3 4 11.7Zm-.6-15.6-2-1.1c-.5-.5-.5-.8-1.2-1l-3-4.2-2.9-4.4 18 11.3-9-.6Zm15.4 22.5 2 .4.2.2v2.3l-2.5 2-4.7-4 5-.9Zm-1-3.5-7.7 1-1.5-1.2-4.5-13.1 1.5.4 12.5 12.4-.2.5Zm-30-53v5l-4.9-3.3 1-4.3 4 2.6Zm5.2.6h-.2l-6-4.6h1l4.6-.7 5 3.2.4.3v.4l.2.3-5 1.1Zm8 8.6v.2l-.2 1.5-.3.6-8.7-4-.4-.2v-3.2l8.7-1.4.2.4h.8v6ZM190.1 354l4.5 3.6 13.7 9.2-1.3 1.8c-.9 0-1 0-2.8-.4-1-.2-1.4-.8-2-1l-1.4-1-8.9-8.2-3.8-4.6 2 .6Zm10.3-1.4 2.1 1.1-1 4.2-4-2.7-3-2.3 5.9-.3Zm-11.4-3-.4-.4 5.2-8.8 4.3 8.9-9 .2Zm-4.3 16.7-9-10.4 20.5 11.6.2.1c0 .3.2.7 0 1 0 .2-.5.5-1 .8L189 371l-4.4-4.6Zm6.2 63.7-.5.3-7.8-2.7 4.3-9.6 4 12ZM178.4 388l5 1 3.6 1 .6 1.4-4.3 2.7h-.3l-.3.1-6.1-6.4 1.8.2Zm-5.8-9.2 10.7 6.7h-.6l-10.6-1.6h-.2l.7-5Zm13.5-2.8h.7l1.7 8.4-10.7-7 5-.9c1.1 0 2.3-.3 3.3-.5Zm-20-12.3 7 3.3c3.2 1.7 6.2 3.6 9.5 5l.3.7-1.7.2-10.3.3c0-.2-.2-.3-.3-.4l-4.6-9.1Zm1 17.2-5-4 5.8.3 1.2 1v1.1l-.4 2.3-1.5-.7Zm1.5 7.5.3-.5.4 4.8.2 5v.4l-8.2-6.7.6-.7 6.7-2.3ZM198 404l-.1-.2v.1l-1.5-.4-1.9-1-1.5-2-.2-.4-.4-2.4.1-1.5c0-1-.2-1.8 0-3.3v-.6l1 .1c.9 1 1.6 2.4 2.3 3.8l3.1 4.3v1.5l-.6 2.4c-.5-.2-.3-.3-.3-.4Zm29.7-24.6 9.9 11.3-.1.2-15.2-10.1-11.2-7.2s-1.9-1.5-1.1-1.6l12 2.6c1.2.2 2 .8 2.8 1.6l3 3.2Zm8.7-29c-1.6 1-3.1 2.1-5.1 2.4a4.7 4.7 0 0 0-3.6 2.6c-.4.7-.8 1.2-1.6 1.7l-.7-.2 2-16.4.6-.1 8.4 10Zm11-23.2v.8l-17.4 4.1-.5-.4 2.5-15.5 1.2.3 14.3 10.7Zm.3-18 .9.7 1.3 13.6-.2.7-14-10.4-.1-1 12-3.5Zm-15.1 26.3-.7.1v-.3c6-1.8 11.3-2.5 17.6-4.3l.8.6.3 1.2.4 5.2h-.1l-18.3-2.5Zm.2 5.4c-.4-.5-.2-.7-.8-1.3l.1-.2 17.1 2v.7l-8.8 5.6c-.2.2-.6.4-1 .4l-6.6-7.2Zm1.6 26.9c1-.9 2.7-2 4.4-3.4l2.3-1.5c1.2-.7 2.3-1.5 3.8-1.7.6 0 1.2-.2 1-1 0-.3.4-.6.6-.7l.4-.3 3.3 11.3-.2.6-18.1 1.1-1.4-.2-.2-1.3 3.9-2.2.2-.1v-.6Zm31-58v.3l-11.7 14.4-1.6-13.9.3-1.3 13 .4Zm-14-4.3-3.3-2.1-7-12.6 6 3.5 10.6 7 6.9 4.6-13.3-.4ZM184.4 326l9.8-12.1 1.5-.2 7.5 8.2-.2.3-18.6 3.8Zm19.8-.3.1.2-.5 16.4-20-12.5-.6-.5 21-3.6Zm-71.5.6 23.2 14.3.4.3-17.5-1-.6-.2-.8-1-5.1-12.3.4-.1Zm-1.2-6-.8-1.2 3.4-2.2 5.8-3.7h.4v6.7h-1.2l-3.1.1c-1.4-.1-3.3.2-4.7 0l.2.4Zm135.7-17.7-5-2.7-21.7-14.4 5.7-1 26-3.3 1.7 1.5-6.7 19.9Zm16-30.6-1-.1-4-.8v.1l-2.4-.5-4.5-9.4-.5-1.4c2.7-.3 5.6-1 8.4-.8h4.2l4.4 1.6h.1l.1.1 4.5 2.2c1 .7 2.6 1.5 4 2.6l-13.2 6.4Zm27.3 28.9-13.6.4-.9-.2-10.4-14.2.8-.5 1.8.4c3.2 1 6.7 2 8.4 3.9l13.9 10.2Zm7.7-23.8 2.8 1.4-2.2 2.9-.2.2-8.7-5h-.1l2.5-1.3.2.1 5.7 1.7Zm2.2-37.5-1.7.8-2.3.9-.5.1-1.9.8-.3-1.4V237l.2-.5.5-.3 2.9-2 1.8-.3 1 1 1 1 1.3 3.4-2 .3Zm4 2.6 2.8 1.7 1 6.9-5.7-2-1.7-5.5 3.6-1.1Zm.6-18.2 2.7.6 5.7.4 3 .5.4.5v5.1c-.2-.2-.4 0-.6-.2l-2.1-.7-3.9-1.5-6.2-2.4-1.1-2.2h2Zm11.9-26.9v11.5l-.9.9-3.9 1.1v-7.8l.5-2.4.7-.7 3.6-2.6Zm-2.6-6.4ZM329.2 314l.3-.3 7.4 4-.5 3.7-.7.2-.4-.5c-2-2.5-4.1-4.6-6.1-7Zm4.2 17.5-2.6 3.5h-5.4c-.6 0 .2-.8-.2-.8l7-4.4 2.2-1.3-1 3Zm-4.5 25.3-3-3 3.3.3 4.6-.2h.8l.4.3.4.6 1 9-.4-.3-7.1-6.7Zm-6.4 9.4 9.7 2.9 1 .6-5.3 4.8-.3-.4-5.1-7.9Zm-1 12.5-4-3.1-.7-1-.1-.2-.3-.2-.9-1.4v-.2h-.1c-.9-1.7-.5-1.8-.6-3.3l.5-2.9 2.4.5 5.3 7.3 2.7 3.8.4.4v.3l-.8 2.8-2.8-1.6-1-1.2Zm-10.1-4.8c.3-.2 2.4 4.2 2.7 3.9l2.8 2.4 2.4 1.7 2 1.2.3.7c-3 0-8.6.3-13.1.3l-4.2-.1c1.5-4.6 4.2-8.2 7-10Zm-12.1-16.4.4-.7v-.3l11.4-5.6v2c.1.2-.9 4.3-.9 4.3l-.6.8-.4 1.6-1.5.6h-2L300 359c-.3-.6-.5-1-.7-1.1v-.3Zm-9.5-21.7v-.6l.6-.4 12.3-1.1.5.4-1 3.4-4.5 13.6-1.5.5-6.4-15.8Zm-13.5 4.2c1-.6 1.9-1.2 3-1.3.5 0 1-.3 1.6-.4l-.3-1c1.4-1 1.5-1.2 3-2l1.7.3 7.9 18.7-1 1.1L271 344l-.2-.4 5.5-3.5Zm-4.8-35v-.8l6.4-19.9.9.2.5.8 7.5 9.6 4.2 6.2.7.9-20.2 3Zm12.4 13.6v.9l-1.2.8-9.3 6-1-.7-.5-14.6.3-.1 11.7 7.7Zm17.6 11.3-11 1.1h-1.8l-1.7-.8v-9.1l.3-.2 13.5 8.4.7.6Zm1-5.6-1 .9-2.2-1-23.3-15.5 15.9-2.6h3.3l7.2 18.2Zm8.3-13.6-4 11.6-.4.1-.7-.3-6.4-16.2.2-.5 10.8-.5.5 5.7v.1Zm7.5-22.5-.5-.2h-.5l-4-1.3-.5-.2-.7-.3c-.6-.3-.8-.4-1.2-.8l-.5-.2.4-2c0-.6.2-1.2.4-1.7l9 5-2 1.7Zm4.2 17.4a6 6 0 0 1 1.5 1.5c.4.7.5-.3.7 2.2.3.6-.2.8-.1 1.3 0 .5-.2 1-.4 1.5-.3.3-.7.5-1.2.7h-3.1v.1h-1c-1-.4-2-.7-2.8-1.2-.6-.2-1.2-.4-1.3-1.2l-.1-.2c-.2 0-.3-.2-.4-.3l-.4-4.4 1.9-1.6c.2-.1.3-.5.8-.8.3-.1 2-.6 2.2-.4l3.7 2.8Zm3 10.4 8.1 8.6.1.2-10.3 5.7 1.6-14 .6-.5Zm-3.4 24-.1-.8.1-.4h8.5l.4.1 1 7.7-10-6.5Zm-2.4 9.7-2.4-.4c-.2-.2-.3-.6-.2-1.7v-4.2l.2-.4.5.1 3.3.8.2.2 8.8 6v.4l-10.4-.8Zm-9.6-24.7 2.5-7.7 4.6-.1.8-.3 3.7-.3v.3l-.9 5c-.2.2-.3.4-.3.2l-1.3.8-4 1-1 .2-3.1.8h-1Zm-1 8 1.2-3.8.4-.3 6.7-1.5v.4l-1.5 6.7c-.7 3-2.7 6-2.7 6l-1 .4-.9-1.7-2.3-6.2Zm1 13.2.3.9-8.8 3.8 4.5-14 3.9 9V346.2Zm8.5 15.3-1.7-1.3v-7l3 .2 7.3 7.2 4.6 4 .7.8-12.2-3.3-1.7-.6Zm6.8-72.9h.2l1.5-.7h2.4l1.3.4-.3 2.4-.2.7v3.5l-1 2-8.2-5.8 4.3-2.5Zm-9.5-19.2 1.2-.3 4.8-.6 3.5 1 1.3 2.1-.1 1.7-3.7 1.8-7.6-2.8.6-2.9Zm3-18.5-.5 2.8-1.4 3.9c-.9 1.4-.6.7-1.3 1.6l-.2-.6-.6-5.5-.4-3.1v-2.3l.9-1.7 1.6-.7.9.2.3.1.7 3.7v1.6Zm6 9-2.5 4.5-.5.7h-.3l-4.6.4 4.4-8.8h1l2.5 3.3Zm12-1.7v3.8l-1 .9-.5-.2-3.1-2.6 2.7-5.4 2-2v5.5Zm-2 25.5-3.7.5-.6-.3-8.3-.7 3.8-5 3-1.5 2.6 3.1 3 3.7.1.2Zm-4-11.8-.9-1.5-.2-.4-.2-.6.2-.4 4.5-.8h.4v.4l1.6 1.8.7.3v7.4l-.8 1.9-5.4-8.1Zm.2-26h1.1l2 1.1v.8c0 .8.2.6-.1 1.8-.3 1-1 1.7-1.4 2.6h-.5v-.2l-.4-2.2-.7-4ZM333 265l-7 1-.3-.2 1.8-2.9 2.2-.4 3.3 2.5Zm3.9-24.5v1l-1.6 2h-1.5l-1.2-1.2-.5-.2-1.2-.9-1.5-1.2 1.7-2.1 1.9-3.7v-.1h2.2c1.2.2 1.6.3 1.7.8v5.6Zm-7.9-5.5-2.4 3.1-.3-.2-.6-.6-1.4-3.8.4-2.9 4.4 2-.1 2.4Zm2 20.3-1.5 2.6-2-.6-2.8-3.2.2-1 1.3.3 4.7 1.9Zm7.4 47.3-1.9-1c-1.2-2-2.7-2.2-2.8-3.8l.4-1.6h.1l.4-4.6v-2.8h2.8l.4 4.6.8 5.3s0 .8-.2 1v2.9Zm-4.7-122.2 3.3 2v7.2l-1 .2-.4-1.3-2-6.6v-1.5Zm3.4-5.3V178.3l-3.7-2-.3-4.8 1.4 1 .1.1 2.4 1.4v1.2Zm-8.4 38.8Zm-4.6-4.4 4.3-4.8.2 6-4.5-1.2Zm5.6 8 4.1-3.4h.2v-.2l2.5-.8.5.5c.1.2 0 .5 0 .8V219.4l-.6 2-1 .4-2.1-.4-7.7-.6H323l.3-.7 5-2 1.3-.5ZM167.1 320.2l4-2.8.7.2 2 6.6-6.7-4Zm7.3 9.5-3.7 8v-.1c-2.2-4.9-2.8-7.6-5-12.4l8.7 4.5Zm-15-.1 2.6-4.4.3.2 2.7 8-5.5-3.8Zm8.3 9.8c-1.8.4-5.1 1.3-6.4 1.5l-6.5-7.7c-.1-.5-.2-1-.4-1.3.5 0 1.1 0 1.2-.3l12.1 7.8ZM150 322.6l7.9-1h1l.5.5-2.5 5.7h-3.8l-1.2-.8-4.3-3-.1-.2.5-.3 1.6-1 .4.1Zm-16 53.3-3.9-2.3a233 233 0 0 1 7-4.3l-3 6.6Zm-5 9.6 1.6-1.7 2.5-2 .7.6 1 6.6-5.8-3.5Zm.7 4.7.3.1 5.2 3.5-1.6 6c-.3.2-.5.4-.7.2-.5-.3-1.8-.9-2-1.3l-.1-.2v-.2l-1.1-8.1ZM126 415l-.6-2-.4-5v-.4c.2-.4 1.5-.4 2.5-.2l.6-1.5 3.6 2.6.3.1 3.4 2.2c.4.3.5.6.4 1-2.5.7-7.7 2.5-9.8 3.2Zm5.3 12.7v-.1l-4.4 3.5-.4-.5-.2-5.8 4.2 1.8.7.4.1.7Zm-5.2-7v-.9l.5-.3 1.3-.7 7.6-2.8-.3 2-1.5 5-.1.4h-.1l-.2-.3-1.4.2-5.8-2.6Zm14.4-15a282 282 0 0 1-4-2.7l1-3.1 1.4-4 6.2 3.8.1.2 1.7 1.7.7.3v.1l-.5 1.2-6.6 2.4Zm.6 11c.1-.4.9-.7 1-1 .8.3.4 0 1.1.3.2 0 .3.4.4.7 0 1 .6 2 1.3 2.7l-.5 6-1 .5-6.2-1.2.1-.3 1.6-6.8.2.3v-.5l2-.7Zm117.8 22.7.7 4.9-4.8-3.4c0-.5-1.7-3.4-1.7-3.8.7-.4 0-4.3.7-4.5l4 2.3c0 .4.3 2.4 1.1 4.5Zm21.2-34.3v1l-.3.1.2 2.7-1 6.3v5.7l-.6 3.7h-.2v1.3l-1.3.4-3.4-1.1v-.2l-.6-.1-2.5-2.4-.7-.9-.4-1.3-.1-3.4v-5.2l-.3-5v-2.6c.5-1.1 1.6-2 2.1-2.2l5.4.2c1.4 0 2.7.7 4 1.2l-.1 1c-.3.2.2.6-.2.8Zm73.7-89.8c0 2.2-1 3-2.2 3.3l-1-.7-3.2-2.2-.4-.5-2-1.3 7.6-6.7 1.9 5-.5 2.5-.4.4.2.2Zm24.1-22.1c.9.1 4.6 2.1 6.6 2.8l-25.8 16-1-1.9v-.3l-1-3.2.3-.2 8.8-5.8c1-.7 2.4-1.6 3.4-2l1-.8 7.3-4.7.4.1Zm8.3-6.9-1 4.7-4.4-1.3-.8-.4-.1-4.1 6.3 1.1Zm-12 42 1 .2v.7l5.8 11.3-16.6-.6 9.8-11.7Zm-1.6-16.2 5.1-3.2-3.4 12-.4.2-9-3.9 3.2-2.2c1.4-1 3-1.3 4.6-1.7l-.1-1.2ZM360 337c-.7-.2-.7-1-.7-1.7v-6.7c0-.7.3-1.3 1-1.4l.7-.3v-1c1.4-1 1.5-2.7 1.2-4.4v-.6l.1-.4 9.8 4.4-.9 1.1-11 12.5c-.3-.4 0-.3.1-.8-.2-.2 0-.6-.3-.7Zm29.5-21.2-1 1.6-10.2 3.8 3.4-13.6c.4-.4.8-.7 1.4-1 .7-.1 1.2-.5 1.6-1.2.4-.7.9-.7 1.4-.1l3.4 10.5Zm.3-26.6s-.1-.4.2-1.4l.3-3 1.7-1.6v.2l1.3 5c-.2 1.8-1 3.5-2.8 4.2l-1 .2.3-3.1v-.5Zm1.5-15V273l.3-.6 5-1-.8 3.7-.9 2.1h.2l-3.2 1.5-.6.1-.5-.3.5-4.4Zm1.5-12.3c.3 0 1.7-.7 2.7-1.1l.3.8 1.5 6.3-2 .2-3 .1h-.2l.7-6.3Zm1.8-14.4 2.9-.3-.2 7.2-.5 1.4-1.6.7-1.7.8 1.1-9.8ZM398 228l5.3 3.2 1 .6.4 1-7.9 9.3-.3-6.6 1.5-7.5Zm.8-10.5c1.7 1 9.2 6.7 10 7v3.3c-.2.1-1.6 1-2 1l-7.2-4.2-1.4-2.7.6-4.4Zm4.4-8 4.9-3.9v8.3l-.6 3.5-3.6-1.7-4.2-2.3 3.5-3.8Zm-2.7-5.8c.6-2.4 1.4-3.6 1.5-3.6l5.3-1.8-.2 3c-.7 1.4-3.2 2.6-3.4 3l-1.8 1.3-1.5 1.3.1-3.2Zm1.4-9.5.5-5c.4.2 2.5-.6 2.5-.6l2.6-.3v5.3l-4.5 2.1-1.4.3.3-1.8Zm1-10.7v-.2l.7-6v-.2l.3-.3 1.8-.8.5-.3 1.7-.8v.8l-1 8-4.1 1.6.1-1.8Zm2-17.7v-.1l.1-.7 3 2.1v3l-.7 1.3-.1.2-3.1 1.2.8-7Zm9.9-4.3c-.5 1.3-.7 2.3-1.3 3.6-.2.4-.3.6-.5.6s-.4 0-.7-.2l-4.7-3 7.2-1Zm1.4 17.3-3 1.4-1.8 1.1v-4.3l.4-6c0-.6.2-1 .6-1.3l3 .2.8 8.9Zm1 9.7c-.4.7-1 1.4-1.7 2-1 .6-1.8.6-2.8 1l-1.3.7v-6.3c.9-.3 2.7-2.7 5-2.8l.8 5.4Zm-15.7 109 2.7 1c.4-.1.6.9 1 .9.4 1 0 1.6-.5 1.9-1 .6-1.3-.4-2-.8-.7.3-1 1.5-.8 2.2.1.9 1.3 1.9 2 2 .9.2 1.8.2 2.6-.3l.3-.2.6-.7.4-.7 3.9 2 .2 4h-.3c-.1.3-7.3 1.8-10.3-1.8l-2.1-2.4c-.4-.2-.9-1.3-1-2.2l-.6-2 4-2.9Zm-5.2-5.8c.5 0 5.5-1.8 6-1.5l-.8 3.5c-1.4-.2-4.3 2.9-5.3 3l-2-.8v-1.1l2.1-3.1Zm7.3 4.7ZM402 285l1.6 1.3c-1.8 1-4.8.8-6.2 1.6l-1.2-5.1h2l3.8 2.2Zm8.8 6.4.3 3.2v3.1c-.4-.1-1.9-.4-2.7-.8l-3-1.9c-.2-.3-.4-.6-.3-.7l1-3.4 4.7.5Zm-5.9-14.3 4.6-1 1 2-.1 7-8.3-4.3-2.8-1.7 5.6-2Zm3.2-4.6-8.5 2.3.9-3.4 5.5-.2h.3l1.8 1.3Zm-4.2-7.8c1 .6 3.1 1.8 3.3 2.5l-4 .5-2.2.1-1.4-5.5 4.3 2.4Zm3-9.4 2.7-1 .5 10.5-8.8-6.2-.2-.3 5.7-3Zm-5.1-12v-.7l.6-.8 5.7-6.8.9 1.9.2 7.2-7.4-.7Zm2 3.3 5.3 1.1-.6 3-7.4 3.4.3-7.3c.3-.1 2 0 2.5-.2Zm13.6-47.7-4.4 1.4c-.7 0-1.2 0-1.5-.3v-3l.2-.6 4-2.2 1.5-.3.2 5Zm.8 4.6.8 8-1 3-.1.5-5.7-2c-.3-3.2-.2-5-.3-8.2l5.5-1.5.8.2Zm1.3 18.3.7 4.8-.2.2-2.5-1.2-1.2-.7-.5-.4-3.6-2.3-.1-4.8c0-1 3.3 1.1 5.1 1.7h.6l1.3 1 .4 1.7Zm1.7 16.7-8 3.8-.4-7.3v-6l4 .6 3.8 1.2.6 7.7Zm1.2 14.1-8.8-2a11 11 0 0 1 .2-4l7.8-3.3.8 9.3Zm.5 6c0 .6-.3 1.2-.5 1.8l-3.9 2.2h-2.7c-2.3-2.5-1.6-4.7-1.6-7.2v-.5l8.6 2.1.1 1.5Zm1.4 15.7-9.4-3.8-.2-3.4 4.9-1 4-.9c.1 2.8.6 6.4.7 9.1Zm2.1 21.3v.7l-.3 1.2-1.3 1.5-2.5 1.6 1-13.3.1-.3 2.4-1.3.6 9.9Zm1.6 14.4-6-1.5c.3-1.6.1-3.5 1.7-4l3.6-2.6.7 8Zm-13.3-30.3.3-4.9 8.7 3.6-3.4 5.8-5.6-4.5Zm3.6 39.4c-.2.3-1.7.5-2.6.7l-.1-8c2.2-5.1 5.8 2.8 2.7 7.3Zm-3.9 31c.2-.3 0-.5 0-.9v-3.3c0-.5.4-1 .5-1.6.2 0 1-2.5 1.8-4.8l1.2.1.8 10.2-.3 4.2-4 3.3c-.2-2.3-.4-6.4 0-7.2Zm4-26.9-.7 12.3-3.4-.3v-3.5c.1 2.1-.1-4.3 0-6.4 0-1.6 2.5-2.1 4.1-2Zm.7-27-.1 1.7-.8 6.4c-.2.7-.6 1.3-1 1.2l-1.8-.1-.3-7.3.6-.5 3.4-1.4Zm-2-3.7-.3.3-2 .7-.3-8 2.7 1.3c.3.4.6.9.8 1.5 0 .4.4 1 .4 1.3.3 1.7-.8 2-1.3 3Zm11.6 28.6c0 2.1-1.3 9.6-1.3 9.6l-.3.6-4.4 5.2-1.6-.4 2.1-23.3 4.1 1.1h.1c.4.2.5.5.7.7.3 1.8.6 5 .6 6.5Zm4.2 8.5.2-2.2v-1.1l1.5-.4 5.7 9.7-8.5 7.2 1-13.2Zm16.8-.4v.7l-6 3-.9.3-7.5-12.6-.5-1.2 15 9.8Zm-2.6 14.7-13 2-.5.1 8.4-7.2 5.1 5.1Zm4.6-10.3-.2 9-2-1.5-4.1-3.8-.3-1 1-.5 5.1-2.4.5.2Zm3.6 85.4c-.2-.3-.2-.7-.1-1 0-.5-.1-.8-.6-1l-.6-.1c-.7-.4-.7-.8-.1-1.2l.6-.6-1.8-.6c-.7-.3-1.6-.5-1.8-1.5 0-.2-.3-.3-.5-.4l-1.6-.6c-.6-.3-1.4-.6-1.6-1.1-.3-.7-.9-1-1.4-1-1.4-.3-2.2-1.5-3.5-2l-.2-.3c-.6-1-1.7-1.6-2.8-2-.8-.4-1.6-.9-2.5-1.2-1-.4-1.5-1.5-2.4-2.2l-.1-.3v-.3c0-.7.2-1.4.4-2.2-.9-1.1-.9-4.5.1-6-.7-.6-.7-1.4-.7-2.2 0-.8 0-1.6.8-2.1-1-1.3-1.1-4-.2-5.8-1-1.3-.8-2.7-.1-3.8l-.5-2.5v-2.2c-.1-1.3.5-2.4 1-3.5.4-.8 1-1.6 1.8-2l.4-.7.5-1.3 2.9-4.2c.4-.6.8-1.3 1.6-1.6l.4-.4c-.2-.8.3-1 .8-1.4l.2-.7.4-.8c1.1-1.7 2.2-3.5 3.5-5 .5-.6 1.1-1.1 1.5-1.8l6-6.3v-16.3l-23.3-15.9L418 160.2l-.4-2.9-15.5 2.3L398 194l-11 85.6-.4 2.8-2-.1-3.5-.6h-.1l-.3-5.5-8.5-5v-4.7l-9-5.4-.3-29.1 3.3-2.9-.2-13.8h-1l-.3-2.4-14.6-28v-21.7l-12.7-7.9-14.2 7.9-.3 23-14.2 28-.3.8v.6l.1 14 2.2 1.5v4.9l-4.2 2 .1-.5V236.2l-.1-1V222l-.4-.2-15.5-10-1.8-42.9c.4 0-.1-1.5-.2-1.8l-1.5-1.7c-.6-.5-1.1-.5-1.7-.7h-2.8l-3.5.7c-.6.3-1.4 2-1.7 2.4-.3.5-.9 3-.9 3l-.2.7-6 20.3c-4-12.3-19.3-61.3-19.6-61.9-.3-.6-2-2.7-3-4.2 0 0-.1-.2-.4-.3 0 0 .2-8.2 0-10.3-.4-2 0-2.8-.5-3.3a21 21 0 0 0-3.5-2.5c-2-1.2-1.2-.3-3.2 0-1.9.3-2.5 1.3-3.7 2-1.2.6-3.2 1.9-4.2 2.8-1 1-1.2 3.2-1.3 3.6 0 .5.5 4 .4 6.3 0 2.3.8 16.5.8 16.5l2 2.8.6 4.2 5.6 2.6 4 15.8v.1c0 .3 0 .6.3.8l.3 1.3 1.4.9 11.3 38.7 4.6 4.2.6 1-13.3 8.3-.2 12.6-26.5 18-65 41.7-6.5 4c.2-.3.2-.7 0-1.1-.2-.2-.2-.5-.2-.7V289c1.2-1 0-2.2.3-3.2l.1-.3c.6-1.7 0-3.4-.1-5-.1-.9-.4-1.7 0-2.6 0-.3 0-.5-.2-.7h.1c.3-.6-24.4-16.2-25.3-16.7-.8-.6-1.3-.7-1.9-.9H88.4l-1.4.2c-.3 0-.7.1-1 .3l-4 2.9-21.3 13.7c-.7.5-1 1-1 2v24.2c0 1.1.3 1.8 1.2 2.4l4.2 2.8c0 .6-.2 1.1 0 1.5.2.5.3.8 0 1.3-.1.5.1.8.5 1l2.3 1.6c2 1.5 3.9 3.2 5.7 4.8 1.4 1.2 3 2.2 4 3.8 0 .2.3.2.5.3l1 .6 3 3.4 2 3.2a4 4 0 0 0 4 2c.7 0 1.2.2 1.8.6 1.5 1 2.3 2.8 4 3.5l.3.4 1.3 1.2c1 .7 2 1.4 2.8 2.2.8.7 1.5 1.4 2.4 2 1.8 1.6 3.8 3 5.1 5 1.5 2.3 3.4 4.3 4.3 6.9 0 .2.3.3.4.5l1.4 1.6 3.6 5.3c.7 1 .9 2 .4 3.1a3.4 3.4 0 0 0 1 4.1c.8.6 1.6.8 2.5.7 1 0 1.8.5 2.4 1.4l1 1.7v4.3l-5.3 2.8V393h.3l-.2.7 5.9 4.6c0 1.1 0 .8-.5 1.9-.5.8-1 .8-1.1 1.6 0 .3-.4.6-.4.8l-17.8 11.2v16.8l162.1 104.5c1 .2 1.7.4 2.4.4l4.3-.2c.7 0 1.5 0 1.4-.1h6.3l8.7.2c1 0 2 .1 2.9-.4l6-4 .3-.1v-.2c.3-.5.5-1 .9-1.2 3.2-2 6-4.6 9.9-5.5-.3-.6 0-1 .5-1.3 1.3-1 2.7-1.4 4.5-1.8-.7-.9 0-1 .4-1.4 2-1.3 4-2.5 5.8-3.8 1.7-1 3.4-2.1 5.4-2.4l.6-.3-.2-1c3.7-2 6.7-5 10.8-6.3.3 0 .8-.4.8-.6 0-.7.5-.9.9-1.1l5.4-3.5c.6-.4 1.4-.7 2.1-1 .7-.3 1.6-.2 1.8-1.2l.4-.2 1.5-.6c-.1-.7.3-1 .9-1.4l2.1-1.4 5.2-3.2 1.8-.7.2-.5 8-5h.1l1-.2.1-.5 1.9-1.2.9-.3.2-.4 6.8-4.5.5-.2c.4 0 .8-.3 1.3-.5a1 1 0 0 1-.2-.4l5.7-3.7.7-.5 1.5-.4v-.5l1.3-.9h.1c.6-.3 1.6-.2 1.7-1.2l9-6c1-.4 1.8-.8 2.7-1v-.7l9.2-6.1 1-.5c.8-.2 1.6-.2 1.8-1.2v-.2l3-2a11 11 0 0 1 3.5-1.4c.2-.5.4-1 .7-1.2 1.1-.6 2.3-1 3.4-1.5.3-.5.6-1 1-1.3a671 671 0 0 1 10-6.5c.7-.4 1.5-.6 2.1-1 .4-.1 1-.3 1.2-.6l.3-.6c.4-.5 1-.7 1.4-1 2-1.4 4-2.8 6-4 2-1.3 3.7-2.7 6-3.4l.3-.2c-.2-.4-.7-.8-.7-1.2V426c0-.2.2-.6.4-.7 1.4-.3 1.6-1.3 1.4-2.5l.3-1c.3-1 .4-2-.1-3Z"
      }
    )
  ] }) }) : /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 550, height: 550, style: t, fill: "none", viewBox: "0 0 550 550", children: /* @__PURE__ */ jsxs("g", { opacity: ".2", children: [
    /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M83.5 422.5h-6v-17h6v17Z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#fff",
        d: "m80.9 410.3-3.3-5 15.4-9.7 3.2 5-15.3 9.7ZM282.1 79.7a4 4 0 0 0 4.1-4 4 4 0 0 0-4-4 4 4 0 0 0-4.1 4 4 4 0 0 0 4 4ZM375.7 247.6c0-1.7-1.4-3.2-3.2-3.2a3.2 3.2 0 0 0-3.2 3.2c0 1.8 1.4 3.2 3.2 3.2 1.8 0 3.2-1.4 3.2-3.2ZM262 110.4c3.5 0 6.4-2.8 6.4-6.3s-3-6.3-6.5-6.3a6.4 6.4 0 0 0-6.4 6.3c0 3.5 2.9 6.3 6.4 6.3ZM292.7 129.3a4 4 0 0 0-4-4 4 4 0 0 0-4 4 4 4 0 0 0 4 4 4 4 0 0 0 4-4ZM212.6 232.1ZM58.6 199.8l-.5.3.5-.2ZM364.2 139.3v-.1h-.1.1ZM362.7 138.3l-.1-.2h-.1l.2.2ZM163.3 258.9h1.6v-13.7h-1.6V259ZM214 209.3l.1-1.4-.9-.7-1 .7v1.2l.2.5 1.6-.3ZM363.5 185a3 3 0 0 0 3-3 3 3 0 0 0-3-3 3 3 0 0 0-3 3 3 3 0 0 0 3 3ZM379 204c2.7 0 4.9-2.2 4.9-4.8 0-2.7-2.2-4.9-5-4.9a4.9 4.9 0 0 0 0 9.7ZM236.8 211c2.7 0 5-2.2 5-5 0-2.6-2.3-4.7-5-4.7s-4.9 2.1-4.9 4.8c0 2.7 2.2 4.8 5 4.8ZM245.3 55.2a3 3 0 0 0 3-3 3 3 0 0 0-3-2.9 3 3 0 0 0-3 3 3 3 0 0 0 3 3ZM341.4 9.3V0S460.9 78.9 461 78.9v9.3L341.4 9.3ZM341.4 33.4V24s119.5 78.8 119.7 78.8v9.4l-119.7-79ZM537.4 209a3 3 0 0 0 3-3 3 3 0 0 0-3-2.9 3 3 0 0 0-3 3 3 3 0 0 0 3 3ZM526.2 238.3c2.8 0 5-2.1 5-4.8 0-2.7-2.2-4.8-5-4.8-2.7 0-4.9 2.1-4.9 4.8 0 2.7 2.2 4.8 5 4.8ZM509.8 121v9.4l-37.5-24.7v-9.4l37.5 24.8ZM509.8 144v9.4l-37.5-24.7v-9.4l37.5 24.8ZM509.8 167v9.4l-37.5-24.7v-9.3l37.5 24.7ZM509.8 191.8v9.3l-37.5-24.7v-9.3l37.5 24.7ZM508.7 215.4v9.3L471.2 200v-9.3l37.5 24.7ZM550 271l-106.1-70v9.4l106.1 70V271ZM550 294l-106.1-70v9.4l106.1 70V294ZM550 317l-106.1-69.9v9.3l106.1 70V317ZM463 315.7l37.5 24.7v-9.3L463 306.4v9.3ZM463 292.4l37.5 24.7v-9.3L463 283v9.4Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#fff",
        d: "m550 340.8-87-57.4v9.4l87 57.3v-9.3ZM413.3 118c3.2-3.1 6.3-6.4 8.3-8.8l1.8 1.3 19 12.6v14.2l-29.1-19.4Zm35 2.4L425.2 105l-.1.1v-.2l-123-81-.1 6.8v117.7h5.7v-30.3l66.4 44 3-4.6-24.6-16.3 11.4-2 5.4-1.2 20.1 13.4 3-4.5-15.7-10.4 1-.2 14.5-4.6 16.2 10.7 3-4.5-12.9-8.5a42.2 42.2 0 0 0 10.7-7.7l33.3 22V158l-7.5-5-3 4.5 10.5 7v19.5h5.8v-63.7ZM466.2 424.6h6v-18h-6v18Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#fff",
        d: "m468.8 411.4 3.3-5-15.4-9.7-3.2 5 15.3 9.7ZM414 478l-3.1-4.5 34.7-23.2 3.1 4.5L414 478ZM312 545.3l-3.1-4.4 50.1-33.4 3 4.5-50 33.3ZM228.5 538.3l3-4.5-50.3-33-3 4.4 50.3 33ZM245.8 550l3.1-4.5-7.1-4.7-3 4.5 7 4.7ZM155 491.4l3-4.5-44.3-29-3 4.5 44.3 29ZM80.8 442.8l3.5-4.8 13.4 9.3-3.5 4.8-13.4-9.3ZM373.5 504.4l-3-4.5 5.5-3.7 3 4.5-5.5 3.7ZM398.7 488l-3-4.4 5.5-3.7 3.1 4.4-5.6 3.7ZM459.7 447.5l-3-4.4 5.5-3.7 3 4.4-5.5 3.7ZM82 145.6l-1 .6s.2 0 .3-.2l.6-.4ZM215.4 125.5h.1-.1ZM199.7 224.1H197v-134h2.7v134ZM201 32.2v-11L142.4 60v11l58.4-38.8ZM130.9 61.6v-9.3S11.3 131.2 11 131.2v9.4l119.8-79ZM11.1 156.4v4l7.9-5.2v-4l-7.9 5.2Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#fff",
        d: "M130.9 84.5v-9.3S11.3 154 11 154v9.4l119.8-79ZM130.9 106.7v-9.3S11.3 176.3 11 176.3v9.4l119.8-79ZM.5 251v9.2L38 235.5v-9.3L.5 251ZM11.6 220.7v9.3l37.5-24.7v-9.4l-37.5 24.8ZM11.6 198.2v9.3l37.5-24.8v-9.3l-37.5 24.8ZM0 275v9.4l37.5-24.8v-9.3L0 275.1ZM200.4 157.5v-50.1l10.8-8.7v51.6l-10.8 7.2Zm-5.7 3.8L183 169v-47.5l11.7-9.4v49.2Zm-17.5 11.6-12.7 8.3V165l12.7-21.4v29.4Zm-48.8-49.7v-.3l-21 14.2-46.6 30.6v67.2l-9.3 6.4v21.8L67 252.8v-.1l20-13.2v8.1h5.7v-12l11.9-7.8V247h5.7v-21.3l12-3.1V248h5.7v-27.3l11.6-5.1V257h5.7V213L154 195l4.9-3.2v73.2h5.7v-77l12.7-8.4v37.9h5.8v-41.7l11.7-7.8v56.7h5.7v-60.5l10.8-7.1v73l-27 19.4v6.7l32.5-23.3h.3V64.8l-88.6 58.4ZM201 58V47l-58.5 38.8v11L200.8 58ZM236.7 87a3 3 0 0 0 3-3 3 3 0 0 0-3-3 3 3 0 0 0-3 3 3 3 0 0 0 3 3Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#7471FF",
        d: "m427.3 360.7-.5-.6 1.3-9 2.1-1.1 15.2-2 .5.6c-1.2 1.1-2.4 1.9-4 2.4.2.4-.2-.1 0 .2a10.5 10.5 0 0 1-6.1 2.7l.4 1c-1.5 1.5-3.6 2-5.8 2.5l.5 1-3.6 2.3Zm-4.6-10.4-.4-.8 2.8-6.9c1-2 1.8-4 2.6-6h.2v5.6l-.9 4.5-4.3 3.6Zm.6 9.4c-.2 0 0 2-.2 2l-.5 2.6-7.7 4.7c1.3 1-3.2 2.3-3.4 2.5h-.2v-.8l3.1-7.9v-.5l2.4-2.3.8-.3 2.3-1.8 3.5-3 .4.1-.5 4.7Zm-13.7-40-15.5-3.5c0-.3-3.5-10.2-3.3-10.6.2 0 3.1-2 3.3-1.7 1 1.8 3.1 4.8 5.2 6.7l3.2 1.2 8.8 1.7-.4 5.5c-.4.4-.9.2-1.3.7Zm-.3 5.2c-1.7 1.1-2.3 1.8-3.7 2.8l-24.5-3.5 10.7-4 .5-.4 17.2 4-.2 1.1Zm-2.6 47.3-.8 4a7.6 7.6 0 0 1-4.2 2.8l-.3.2-3 1.6.1.1c-.6.4-2.4 1.6-3 1.8-2.5.8-2.5 1-3 .7l.7-2.4.3-1.1 1.2-3 .7-2.2.5-.7c.3-.4 1-.6 1.6-.8 1-.3 1-.3.7-1.5 2.5-1.6 5-3.2 7.7-4.7.4-.3 1-.4 1.5-.5.4-.1-.4-.8.1-1 0-.3 1.2 0 1.2-.4v-.1l-2 7.2Zm-18.3-34.7.5.9-.3.3-3 1.9-.4-.1-5.7-11.2-.4-.7-.3-.6.6-.5 20.8 3.6c-.5.3-1.1.5-1.7.6l-1.8.4.3 1.2-4 2.6c-1.3 1-3 1-4.6 1.6Zm-7 3.8v-.1Zm5.1 44.9h-.4l-.6.4.4.8c-1.2 1.4-3 1.4-4.7 2l.1 1c-.8.7-1.8 1.3-2.9 1.5l-1 .2c-1 .3-1 .3-.8 1.5l-1.4.8-.1-6.6c.5 0 .8-.3 1-.8.2-.3.6-.1.9-.3 1-.3 1.7-1.3 2.6-1.7l9.4-5.2-2.5 6.4Zm-15-37.8.3 1.3-8.3 5.2-1.4.4-1.5.4.1 1-5 3.3-.5-1.2-.7-9 .3-1.8 2.2-.9c0-1.2 0-1.2 1.2-1.7l2-.8c.4-.1.6-.4.6-.8l19 .6-4 2.6c-1 .6-1.8 1-2.9 1.1l-1.3.3Zm-.1 47-1.4 2-7.8.8-3.2-1v-.9c.8-.3 1.7-.5 2.5-.4 1.2.1 1.8.5 2.7-.3.3-.3.6-.7.7-1.1.4-1.9.6-2.2 2.1-2.7.8-.2 0-.5.9-.7-.2-.5 2.5-.8 2.4-1.1l1.2-.8-.1 6.1Zm-13.6 8.8.4.9-.3.3c-1.5 1-2.5 2.2-4.4 2.4-.8 0-1.9 0-2.4.7l1 1.2c-1 .5-2 1.3-3 1.7-.9.4-1.5.5-2.6.8.3.7-1.5 1.7-3 2.3l-.6-.4.6-1.3 2.8-4.2.9-1.2 3.2-4.2c.6-.7 1.3-1.2 2.3-1.3.2 0 .5 0 .6-.2 1.4-1 2.8-.8 4.3-1l4 1 .2 1c-1 1.1-2.7.8-4 1.5Zm-19.8 8.6-6.4-21.4 2.9-1.7L344 400l1.5 3.3-6.3 9.1-1.3.4Zm-5.1 9c-1 .7-2.1 1.5-3.3 2-1 .6-2.3.9-3.5 1.3 0 .3 0 .6.2 1-1 .6-1.8 1.3-2.8 1.7-1 .5-2.1.7-3.3 1l.4.9c-1 .8-1.9 1.4-3 1.6l-.8.2 6.7-20.6 11.3 6.9 1.5 1.8c-1 .7-2.4.8-3.8 1.3l.4 1Zm-20.3 10-.8 2.3c-.3 1-1 1.7-2 1.8-.2 0-.4 0-.6.2v.3c-.4.5-.8 0-1.4 0l.2-2-.4-5.4v-1.3h.1v-.1l2.2-2.3 8-10.2-5.3 16.7Zm-5.1-11.8.4-6.8 1.4-10.8.2-1 6.9 5 2 1.8-10.9 13.8v-2Zm-3.3-10.2-8.7-4.5-.5-.5 2-5.1.1-.1.5-.3c.6-1 1.5-1.4 2.4-1.7h6.2l-2 12.2Zm-.6 17.6v.7c0 .5-.6.8-1 1.1l-7.6 4.9c-2 1.3-4 2.3-6.3 3-.5.2-1 .2-1.4.2h-17l-5.5-3.4-11.6-6.9.1-14.1.3-.4 11.7-7.5v16.3l1.1 1.5 1 2 1 1.1 1.6.7 1.9 1.5 2.6.7 3.7.9h3.2l2.9-.9 2-.7 3.3-4.2v-.4l.3-.7c-.4-.3.1-.5 0-.7-.3-.3 0-.3 0-.7-.2-1-.1-2.2-.1-3.3 0-.6.2-1 1-1 .6 0 1.3-.2 2-.4v-1.1l1.8-1.5c-.6-.5.4-.5 0-1-.3-.7-.3-1.2.2-1.7v-1.5l9 4.6-.2 12.9ZM290.4 531l-.2.2-.4.3-2.4.2-2.3-.3-.7-.4-1-1-1-.9v-.3l2.5-6 .3-.3.9-.8v-.1l3.1-1.6c.4.4.6.9.6 1.6l.4 5.1c.4 2 .3 2.6.2 4.3Zm-9.3-8.5-.7 1.6h-.2.1l-.2.5-1.3 1.7c-.4.2-.9 1.3-1.6.6-.4-.3-.6-1.5-1-1.9 0 0 0-.8-.2-1v-1.6l.3-1.3.8-1.8c.3-1.1.4-1.3 1-1.9l1.2-.9 2.2 2.1.3 1.5-.7 2.4Zm-5.2-27-.9 2.1c0 .4 0 .7-.5.8-.3 0-1.5.3-1.7 0l-1.4-7.4 1.2-3.2c1 .5 3.8 1.7 4 2 .6 1.2-.3 3.8-.7 5.7Zm1.7 5.8.6-1 .2-.5c.2-1 .3-.9.4-1.3.1-1 .6-1.6.7-2.6.5.4 2 3.7 2.9 5.7l-.3.8-3 4-3.2-1.2c-.4-.3-.6-.6-.6-.7 0-.2.4-.4.7-.6l1.6-2.6Zm11.8 8.3v2.3l-.7 2.7-2.7 2.5-4.2-4.1-.4-.5V510l3-3.9 2.6-1 .9-.2 1.4.3v1.9c0 .8.5 1.6 0 2.4Zm-.3-18.2v9.4l-2.8.7h-.1l-3.5-7-1-4 .8-1 6.3-1.8c.4 1 .2 3.7.3 3.7Zm-11.6-18V472h1.8c.3 0 1.7 1 2 1 1.8.5 3 0 4.6 1 .2.1.7 1.6.9 1.8.2.2.2.7 0 1.2l-5.5-.6c-.6-.6-1.3-.8-2-1.5l-1.8-1.5Zm2.4 6.6 4.5.1c1.7.2 2.6.3 2.6 2 0 .3-.2.7-.4 1-.6.9-1.2 1.6-1.9 2.2l-2 .3-1.4-.9c-1.3-1-3.6-2.4-4-3.5-.3-1 1.5-1.3 2.6-1.2Zm-7.9 38.8c-.2 0-.5 0-.8.2l-1.2-.1-.6-8.3v-1c.2-1 .5-2 1.3-2.4.6-.3 5 2 6.4 3l.1.6-.1.2h.1l.1.8-1.3 2-4 5Zm-3.7-72-.2.7c-.2.3-1 0-1.2.2l-.7-.3-.3-.4-1.2-1.8-1-2v-.1l-1-4.8c.6-.2 1-.3 1.5-.2l1.4.8c1.1.8 2.3 2.2 2.5 3.2.5 1.8.4 2.8.2 4.7Zm-1.4 30-.7.4-.5.2-7.2 1.8-.1-.2-.5-.9c3-3.5 4.2-4.3 7.6-7.9l.9-.4.5.4v6.6Zm0 12.7-.8.4-6.2-5.2-1-.9v-1l8-1.9v8.6Zm-.3 12c-.2.6-.2.7 0 1.4l-.4.5-.4.5-.4.6-7.3-15.9.6-.3 7.4 6.3.5.8.1.3-.1 5.7Zm0 28.4-1 .6c-4-2.4-11.4-7.3-17.6-11 0 0-.2-.5-.7-.8l5.4 1.4 13.3 3.5.6.4v5.9Zm-24.1-15.4-1.6-.5c-.6-.1-1.8-.6-1.6-1.1v-.2l4.9-8.8.6-.5.7.2 14 14.3-.1.3-16.9-3.7Zm-7.5-4.8c-1.4-1.4-5.5-6.9-8.4-10.1l-.4-.7.4-.4 13.6 1.2a7 7 0 0 0 1.1.4l-.2 1.7-4.3 7.9H235Zm-9.8-5-18-11.5.5-.7 11.5 4 1 .6 5.7 6.9-.7.8Zm-27.7-19.6 14-2.1 1.7.7 1.2 6.3-.5.7-16.1-4.8-.3-.8Zm-5-3.3c-.9 0-2.7.1-4-.6l-1.5-1.3-2-4 .3-1 19 4.4.4 1c-4.4.5-4.7.9-9.2 1.3l-3 .2Zm-10-13.2-4.6-10.8 1-.6c.7.9.6.9 2.2 2l9.2 5.8.4 1-7.8 2.7-.4-.1Zm-1.8 6.5-8.3-8.5.7-.6 5 3 2.2 1.7 1 3-.6 1.4ZM170 461.6v-.5l3.4-3.5c.3.2.5 0 .8.3l1.7 5.4.5 1-.4.4-5.3-2.6-.7-.5Zm-1 7c-7.6-4.8-1.5-1.2-9.1-6l-.6-1.1 4 .5 3 1.8 2.3 3 1.2 1.2-.8.6Zm-25.2-33.1.2-.2 7.6 4.5c.6.2.6.6.6.7 0 .6.8 1.3 1.5 1.6.2 0 .3.2.5.3l7.2 12.2-.5.3-2-2.1-15-17.3Zm14.3 22.8c-2.5-.5-3-.3-5.5-.8l-2.4-1.2a8 8 0 0 1-2.4-1.7l-3.1-6.7-3.7-9.5 17 18.8.3.4c-.3.3.2.3-.2.7Zm-18.6-29.6c2 .3 4 1.3 5.5 1.5l1.9 1 2.2 3.6-1 .3-8.3-5.3-.3-1.1Zm-9.6 7.2-1.2-.7.3-1 3.7-3.1 2 1.9 1.7 3.4 3.3 9.1-9.8-9.6Zm7.6 12.4L112.3 432l-2-1-.2-.7 2.2.7 5.7 2.4.6.3.5.2h.2l2 .8c2.2.7 4.3 1.7 6.1 3.4l10.7 10.5-.6-.2Zm-30.8-21.5v-8.5l4.3 3.3-.9 3.4-3.4 1.8Zm4.1-13 1.1-.8.6.2.5.3 1.4 3v.3l.3.6.2.5-.3 1.3.2.2-5.6-4.1 1.6-1.6Zm8.2-5.2.3 1.2h-.1l.5 2.8-2.4 2-2-3.7 3.7-2.3Zm4 22.2-.4.4-8.4-3 1-.7 4.6-1.4 3.1-1.4.2 6.1Zm-.4-15.8.6 3.9-1.4 1.3-2.5 2.2-4.5 1.5.6-1.6.4-.1 3.2-3.6.9-1.3 2.7-2.3Zm.4-22.3h-.3l-2-1.4c.9-2.4 3.8-2.5 5-2.3l.4 1.7.9 5.9c-.5-.1-.8-.4-1-.9l-2.3-2-.7-1Zm-.3-11.8.1-.3.5-.7 5.3-3 1.8 1h-.3l.3.4v1.5l-3.5 2.6-1.2 1-3.3-2 .3-.5Zm0-31.6 1.2.2 9.4 4.7-3.3.7-.6.4-1.2.3-2.2.3-1.2-.1-1.4-.7c-2.6-2-2.1-5-.7-5.8Zm-2-8.8c-.2-.6.4-3.6.4-5.7s.8-3.5 1.7-7c1-3.6 1.7-2 1.7-2l.2-.2 1 .7-.3 19.7-3.7-1-.5-.6c-.2-.3-.2-3.3-.5-3.9Zm-.6-28.7c-2.3.6-3.5 1-5.6 1.4l-.7-.4 2-4.6.8-1.4 1.1-.3c.4.7.5.4.2-.2l2.3 5.3h.2l-.3.2Zm-10.7 1-1.4.6H105l-5.4-.5-.3-.4 13-5.3-3 5.6Zm-5.2 23.8v.4l-1.2.2c-.5-.5-.9-1-1.2-1.6l-.9-1-.4-.3c-.5-1.8-2.8-2.4-3.3-4.3-.1-.3-.4-.6-.7-.8-.5-.2-1-.5-1.2-.8l.5-1.3h7.7l.7.7v8.8Zm-12-40.2.6-.4 6.4 1.9-4.8 10.1-2.2-11.6Zm-.6-7 .3-2.3V286l9.3 1.9v.2l-9.1 1.7-.5-.2Zm-2.9-8.1-11.3-1.9 14.5-2.6.3.4-3.5 4Zm1.6 30.2a32.4 32.4 0 0 1-8-2.9l-.2-.7 6.1-9.2.8.3 1.9 11.9-.6.6Zm-11.7-5h-.4c-2.3-1.4-3.2-2-5.4-4-.7-.6-1-.8-1.5-1.5l.5-.8 12.3-3.7.6.4-6.1 9.6Zm2-22.8 7.6 1.5-.1 2.7-.3.5-6.8-3.9-.4-.8Zm5.5 7.9-.2.5-13.8 4.2 6-9.2 8 4.5Zm-19.4 4.2a19 19 0 0 1-1-14.3l1.8-.5 7.3 4.3h-.2L68 296l-1.3-.2Zm8.3-24c3-2.3 4-3.4 7.2-5l-2 8.6-11.3 2-.3-.4c1.6-2.2 4.2-3.6 6.4-5.2Zm11.4-6.3.1-.1 5.4 7.5-7.3 1.4 1.8-8.8Zm3.7-1.8 4.7-.7H97l3.4-.2.2.3-4.9 8.2-5.8-7.5s-.2-.2 0-.2h.1Zm14.3.8-.2 6.5-5.5 2.2h-.3l4.2-6 1.8-2.7Zm-3.7 19.6-7.8-1.5 2.5-4 .7-.6 4 5.2.6 1Zm4.5-1.1-.7.2-5.4-7 5.3-2 .2.2.6 8.6Zm-4.8 13.2-7-2.8v-.4l9-2 .3.3-2.3 4.9Zm1.8 4.2 9 3-13 5.7 4-8.7Zm6.5-7 5.5 7.5-.3.3-10.2-3.3 2-4.9 3 .4Zm-1-27.5 6.8 4.6.3.4-7-.4V266Zm9.9-2.8 3.9.8h.8c.6 0 .6.2 1 .4l-.3.6-3.5 4.3h-.5l-8.5-6h7Zm7.9 4.4h.7l.9.9c1.9 2.2 4.4 2.5 7 2.3l1.3-.2c1 0 1.2.2 1.3 1.5l.5.1c.7.6 2.2 1.6 2.3 1.9l.2.4-.2.8-17.6-3.3.2-.2 3.4-4.2Zm17.2 12.8.7.8c.3 1 .5 2.2.6 3.3.2.8 0 1.1.1 2v.2h-1l-5-.5-3-.4-.3.1-.6-.2-4-2.9 11.7-2.6.8.2Zm5.4 31.8 7.8 6-1.5.5h-.6l-1.3.5-5 .6-2 1a3 3 0 0 1-.5 0l-1-.7V313l4-1h.1Zm3.6-2 17 4 .1.4-5 3.7-9.8-6-2.3-1.8v-.2Zm2.1-3.7 23.5-6.2.2.3-5.1 10.3h-.8l-18.4-4.1.6-.3Zm19.7-16.2 2.5 5.5-.2 1-19.7 5 17.4-11.5Zm15.7-10.3-.3.8-8.3 12.9-1 .4-2.7-6 12.3-8Zm6.5-2.4 9.8 13.1-1 1.9-20.2 3.3v-.7l.4-1.4 9.7-14.7 1.3-1.5ZM206 269c.8 6.4 2.3 12.7 3 19l-.9.4-10.5-14 8.4-5.4Zm5.8 30.8 2.2.2 11.5 10.8.2 1.5-1 .6-14.9 6.8-.4.6-.1-.2 2.5-20.3Zm19.4-15.5-.3 1.4c-6.4 1.9-9.5 2.5-15.9 4.4l-2.2-1.6-3.4-19.5 21.8 15.3Zm-5.5-29.7.6.2L233 280l-.4.5-19.4-13.2-2.2-1.8 14.8-11Zm44.3 22.5v.5l-.4.1-32.1 3.9-5.1-18.8-2-8.1 39.6 22.4Zm-37.5-25.7 18.3-.7 16 9.8 5.7 12.3-.5.6-.3.1-39.3-21.8v-.3Zm16.5-13.3.2 1.5-.1 7.3-14.9 1c5.1-3.6 11.2-7.2 14.8-9.8Zm3.4 3.5 6.5 3.8.6.3h.3v.1l5 2.8.7.3 3.3 1.3.2.3c.8 1.4.6.8.6 2.5l-2.9 3.5-6.3-4-4.8-3.4c-1.5-.9-3.2-1.9-3.2-2.2v-5.3Zm.5-18.6c2.2-1.4 8.5-4.5 10.5-5.9.4 1.4.1 1.7-.7 3-.1.2 0 .7.1 1l1 3.2c1 .2 1.2.4 1.4 1.6l1.8.5c.6.1 1 .4 1 1l-.1 3.8c0 .4 0 .4-.4 1 .5.2.5.6 1 .8.7.4 1.6.7 1.9 1.8 0 .2.3.4.5.5 1.3.5 2.6 1 4 1.3 2.2.3 4.6.7 7-.1 1-.5 2.3-.6 3.6-.8.9-.1 1.7-.3 2.2-1l2.6-5 .1-13.2 12.3 7.3v12.6l-.5 1.8c-.5.4.1.2-.5.5l-2 .5-.4.2.2 1c-.5.2-1 .6-1.6.7-1.5.2-2.8.7-4 2l.2.6-2.7.8c-.2 1.3-.3 1.4-1.5 1.7-1.9.4-3.8.4-5.7.1h-1.2c-2 .3-4 .3-6.1 0h-1.3c-2.2.2-4.3.3-6.5 0l-4.5-2-.6-.5-.7-.6-6-3.4-3.8-2.6c-.3-.2-.6-.4-.7-.7l.1-13.5Zm8.5-17.5-1-3h.3l1.4-3.1.2-.1h-.2l4.3-5.4.5-.1 1.5 4.7v1l.3 2.2.2 1c0 .4.5 1 .9 1.7.2.3.7.7 1.2 1l.5.6-6.2 2.2h-.2l-3.7-2.7Zm-4.7-12.8-1-3.8 9.1 1.2-6.2 7c-.8-1-1.6-3.2-2-4.4Zm4.5-17.9.7 2.2a181 181 0 0 1 1.8 6.1l.3 1.3h-.3l.5 1.6-9.4-1.4 6.4-9.8Zm-8.4 6 .4-.8-1.1-4.2-.2.2-1-3.6-1-3.3 8.9 2.8-6 8.8Zm2-25.6.3.8.5 1.3 2.5 8.5.7 2-9.5-2.7 5.5-9.9Zm-8.3 2.8-1.8-7.2 7.2 2-4.8 8-.6-2.8Zm-4.4-11.7-1.9-2.3-.2-.7-.6-2.7-.2-1 10.3.6.6 2.4 2 5.4h.1l.5 1.2-10.6-2.9Zm-4.1-13.5 7.8-4 .9.5 2.1 6.8s0-.1 0 0l-6.5-.6-3.9-.3-.4-2.4Zm-.4-7v-3c0-3.2.4-4.9 3.2-6.3 1-.4 1.7-1 2.5-1.5v4.1l.1.7-.3 3v1.8l-5.4 3.2v-2Zm34.6 72.9v-.4l.5-1.9.4-2.4v-.3l1.2-3.6 1.1-3.9 1.3-4 1-1.8 1.5-.1.8.4v.6h.1l-.1 1.1-.8 5-.2 1.9-.4 2.2-1.4 8.5v.6l-.5 2.6-.1.6-2-.4-2.5-3v-1.7Zm10.7-30.5c1.1 0 2 .6 2.3 1.5l.1.5-.1.6v.2c-.7.8-.1.5-1.1 1h-.5l-.7.2c-1 0-2-.6-2.3-1.4l-.1-.6c0-1.1 1-2 2.4-2Zm2.6 13.2v1.5l.2 2.4.3 7.7-.1 3.1V197.6l-.1 2.7-.2 2-.4.5c-.8.8-2.4 1.5-3.5 2l-.7-.6-.1-1.3 1-6.4.4-4.3.7-6.2h.2v-.8l.2-.9.1-1.7v-1l.2-.3c.1-.1.3-.4.4-.3l1 .4h.4Zm5.7 71.3.3-1 10.8-6.8 1 6.4-12.1 1.4Zm11.4 9.8-.4 1.5h-.9c-1.8-.5-1.6-.6-3.2-1.5a253 253 0 0 1-8.8-5.4l1.2-.5 12.6-1.4.6.8-1 6.5Zm4.5 17.8-.1 3.1.2.3-6-4.3h.2l-4.9-2.7-6.7-3-.8-.3 10.5-4.7c1.8.8 3.7 3.6 5.9 6.5l1.7 5Zm-.8-13.4 4.3.3 1.1 1 .2 3.3-2 .9-1.2-.9-3.2-2.3.8-2.3Zm1.6-25.6c.8-.6 1.5-.9 2.2-1.3l.2 4.5-2.8 4.2-.7-.2c0-.8-.2-1.5-.4-2.2l-.3-3.7c.3-.5.8-.7 1.8-1.3Zm3.1 9.2.6 12-5.3 1 1.2-7 .2-1.9 3.3-4Zm.8-24.6.1-5.3 1.7.6 5.6 2.6 2.2 5.3-.7 1.3-4.6-.1-4.4-3.3v-1Zm.2-9.5 5.6-2.4v.1l4-1.4.9.1 5 1.4-7.4 3.4-3 .7-1.5-.3-3.6-1.4v-.2Zm4.5-9.9 1.4-2.8 1.1-.5h.3l4.1-1 2.2-.3-4.6 5.4-.5.6-2 2-.6.3-3.8 1 2.4-4.7Zm7.9-15.4 1.8-.5 2 1v-.2l5.8 3.2-3 2.2-2.4.8-1.4.3-6.8 1 4-7.8Zm2.1-8.2v-1.5l3.5-1 .2 3 1.9 6-4.4-2.4c-.2-.1-.2-.3-.3-.4l-.9-1v-2.7Zm0-10.6v-4.4l2.2 1 .3 1.3 1.3 6.6-3.8 1.3v-5.8Zm11-13 8.4 5.2-8.2 5.7h-.4l-9.5-5.8 9.6-5.1Zm12.7 114.8 1.7-.2c2.4-2.2 3.2-3.8 4.6-3.7l-1.3 6.3-12.6 4.1-1.3.4-.9-2.8c2.3-1.4 3.8-1.8 6-3.2 1-.7 2.5-.7 3.8-1Zm11.3 8.1.3 4.3c-.2.4-.5.9-1 1.1l-1.6 1h-.2l-4.4-1.8.1-.6c1.7-1.1 2.7-1.4 4.4-2.3l2.4-1.7Zm-1.5-10.8 1-4.6.2-.2c.2-.6.4-1.2.8-1.8l2 1 2.8 1.8c.2 0 .5.5.7.6l-.2 2-.2 1-1.4 1.6-6.5 3 1-4.3h-.2Zm10.2 5.3 1.8-1 .1-.2 2.1.9 2.2 1.5-.4.3c-1.4.2-.5 1.4-1.5 1.7l-.8.9-1.5 1.3-5.8 3.8-1-.2-.3-5.8c1-.3 1.6-1 2.3-1.5l2.5-1.5.3-.2Zm-16.2 17-6.6 3.7-.7.3c-3.3-.2-4.2-3-2.3-4.8v-.3l5.2-3.9 7.6 3.2a6 6 0 0 1-.9.5l-2.3 1.4Zm-1.9 80.4c0 .2 0 .3-.2.5l-.5-.3-8.7-6 8.8-3.8c.4.2.6.5.6 1v8.6Zm-7.3 19 .6-.8 3.3-.2h1.4c1.8.9 2 1.8 2 3.8V398.2l-2.6.6-1.2-.3c-.3 0-2.4-1.5-2.4-1.5l-1-1.7v-2.2Zm4.8-11.3c.5-.6.9-1.3 1.5-1.8.2-.3.4-.6.6-.5.2 0 .4.5.4.8V388.8l-7-.3-.6-.4c1.9-2.2 3.2-4.1 5-6.3Zm-.7-4.9-7.1 8.7-1-13.7 8 5Zm-9.4-20.5 7.7 4.7.6 1.1-6 2.2-1.6.7-.3-.4-.7-8.3h.3Zm9.7-6.9 1-.4.6 1.1.8 8.6-.5.4-.8-.3-8.7-5.3h-.2l7.8-4Zm-.2-26.3-.1 1.1-.2 3.5-.4 5.6v2.8l-.2 2.7-.2 6.7h-1.7c-.2 0-1.6-.4-1.8-.6l-1.2-.6-1.5-1.3a6.7 6.7 0 0 1-1-2.2v-24.6h1.5l5.8 5 .1.3.2.2.4.6.2.7v.1Zm-8-37.8.2-.6 12.8-4.2-.2.8c-1.8 1.2-3.7 2.4-5.7 3.5l-.8 1-5.1 4-1.3-4.5Zm2.6 19.6h2.4l2.9-.4h1.2l.3-.2a834 834 0 0 1-9.5 8.2 12 12 0 0 1-1.8-1.2l-.1-.3a12 12 0 0 1 1.7-7.5l3 1.4Zm-7.2 45.2c-.7-2.5-1-4.5-1.5-7.1l-.7-5.3v-1.1l2.3-2.1v6.2l.8 2.5v.5h.2l.2.4c.3.5.7.5 1 1l.7 1.4c1.5.7 2 1.5 3.5 2.2l-4.7 2.3-.5.1c-.3-.2-1.1-.2-1.3-1Zm-5 26.5 5.2-4.2.4.2.4 9.5-6-5.5Zm-2.7 7.6c-.1-.1.3-1.1.6-1.9l.4-2 2 1.8c1.6 1.6 1.8 1.5 3.4 3l-.2 1.2-3.5-.4-2.7-1.7Zm-3.8 5.8 1.2-.3 1.4 1 7 22.8-11.2-7-11.6-8.6L325 390Zm-23.5.3.2-.3v-.2l.6-2.1H321l-9.4 5.7-1.4.6-9.8-.3 1-3.4Zm-6.1-19.6 2.6-7.8.2-.5 8.5 1.6.2.2c0 .3-.2 1.5-.7 2.5l-.7 3-2.3 4.4-1 1.4c-.4.6-1.3 1-1.6 1.7l-5.2-6.5Zm-5.6 17.4 3.9-12.4 5.2 6.1-.1 1.2-1 2.8-.2.3-1.2.4-6.6 1.6Zm-3.2 10 .4-1.4.2-.5 1.2-3.2 7-2 .1 1-3.1 8.5v.2c-.4.5-1.1 1.3-1.9 1.4-.3 0-.4.5-.6.7-.5.6-1.4.2-2-.1-.7-.3-1-.6-1.1-1.4v-.6h-.2v-2.7Zm-2.5-29.4-.8.5-.7-1.6-1.8-5.5 8.8-.2 2.4.2 1 1.1-8.9 5.5Zm-3.8 23-.9-5.9-1-9.8h-.1l-.3-2.8.3-4.4c1.1 2 2.9 6 3.5 7.4h-.1l2 4.3 1.2 2.8.6 2.1-.1.1.2.3v2l-1.9 5.9c-.7.1-1 .4-1.7.5-.4 0-.7-.1-.8-.5l-.6-.2-.3-1.7Zm-5-30h-2c-.4 0-.6-1-1-1.1l.2-1c1.5-1 2.4-1 3.8-.2l.2.7v1.2l-1.2.4Zm-4.7 19.8.6-6.5c0-1.9 1-5.2 1-6.3l1.4-.6.1 1.6h.2l.8 10h.2l1.3 14.5-.6.9a4 4 0 0 1-2.7-1.5c-.3-.4-3-.1-3.4-.5-.1 0 0-.2 0-.4h-.1l.6-4.9.4-4.7.2-1.6Zm-12.7-13.8 6.4-14.4 2-4c.3-.5.5-1.4.8-1.8l.7-.5h.7l21.4 11.6h-9.6l-.6-1.6-1.6-.8h-.1l-.6-.3h-.2l-.8-.4-1.2-.2-2 .2-1.9.6-2 1.7-.6 2.4-10.8 7.5Zm-.4 5.4.9-1.3 10-7-1.6 14.5c-.2 0-.2.5-.5.6l-8.8-6.8Zm-4.8 16.1c-1.8 1.2-3.3 2.3-5 3.3l-.2-.6 6.6-15.3.8-.7 8.4 6v.3l-1 .8-4.6 3c-1.3.9-1.2.7-3 1.7l-1.2.8c0 .4-.9.3-.8.7Zm9 74.3-13.5-2.5-.7-1.5 2.3-4.2c.2 0 .8.5 1 .8l1 1.3c1 1.9 2.7 3 5 3 1.5-.1 2.8.4 4 1.3l1.2.8-.4 1Zm-8.2 11.6-4.4-9.6.6-.7 11.6 2.2.8 1.4-7 7.2-1.6-.5Zm7 27-8-7.8-1.2-1.7-.4-1.6.2-.5 1.6-3 1.3.7 6.8 13.7-.3.3Zm-4.7 6.6 3.1 1.2 7 5 .2 2.2.3 1.6c-.4.2-.8.1-1.3.4l-.5-.5-9-9.7.2-.2Zm-8.9-10.2 1.4-2.7 1.2.4 2.8 2.6c3.3 3.7 2.4 2.4 5.7 5.8l-.5.5c-4-2-4.4-1.8-9-4.1l-1.6-2.4Zm-7.4-16.7c-.2-.1 0-.2-.2-.3l.4-.6 8.9 1.2 1.6 1.7-1.9 4.7-.7.3-.9-.5c-2.6-2.6-4.6-3.8-7.2-6.5Zm-5 10-1.3-1.2-.2-.5 11 2.8 1 1.6-.8 1.6-1.3.3-2.2-.5-6.3-4.1Zm-8-1.7h1l7.6 6.2-11.5-1-.4-1 3.2-4.2Zm-9.2-7.2 6 4.7v.6l-3 4.3-.8.1-1.3-4.2-1.3-5.2.4-.3Zm-6.5-18-.4-.4c.7-.3.4-.3 1-.4 3.6-.6 6-1.3 9.5-2 1.3-.1.5 0 1.7.3l.8 1-5.5 7-2.3-1.4-4.8-4Zm-8.2 6 .2-.9c3.8 1 9.2 3.5 12.1 4.3l.5.5-.8 3h-1c-2-1.1-5-3-8-5l-3-2Zm-6.6-1.2 8.7 5.3.1.9c-7.4-2-10.6-2.5-18-4.6l.8-.4 6.1-2 2.3.8Zm-14-15 11.6-1 1.1.6-.5 6.7-.2 1-.2.1-12-6.6.1-.7Zm.5-9.2c.6-.1 1.1-.2 1.8.2 3 1.5 4.7 1.8 7.5 3.3l.2 1.2c-4 .6-8.5.7-12.4 1.3l-.1-.3 3-5.7Zm-3.5-6.3c-3.7-2.8-7-4.7-10.8-7.5-.5-.4-.8-.9-1-1.4l10.3.2 2.1 8.7.5 1.1-1-1.1Zm-8 4.2-3-7.9 10.5 7.8c-.2.2.5.7.6.7l-3.3 6.2-1.2.4h-.2l-2-3.7-1.4-3.5Zm-4.4 5.8 5.3 3.9.1.3-.3.7-3 3.3-.9-.3-3.9-5.3-3.1-5.7 5.8 3.1Zm-4.2-15.9H163.3l4.2 11.5-.4.6-8.4-5-.3-.8 4-6.3Zm-5-2.8.8-.3v.2l.9 1.5-1 1.6-3.2 4-4-6.4 6.4-.6Zm-8.8-10 1.2.5c.7.2 1 .6 1.2 1.3v.2l1.1.2 1.8 1.8h1.2c.6 0 1 .2 1.2.7l.8 1.4-6 1-1.2.2-.2-.4a28 28 0 0 1-1.5-1.1l.4-5.9Zm-.7-13.8 3.3-2.6 1-1.2 8.6 6.7.2.7c1.1 1.8 2.2 3.7 0 7l-1.5.8-1.8-1.3v-.2l-6.1-4-2.3-1.6-.2.1-3.7-2.7 2.5-1.7Zm-11.8-49.4 2.7-.8 2.5 1c.2 0 .3 0 .4.2l1.7 1.2 1.6 1.8.3.6-8.5 4-3.2-1.3-.9-.8-4-3 7.4-2.9Zm.6-12 .4.5v.2l4.7 8.2-7.5-3.9-2-1.1-.5-.7 4.9-3.3Zm-7.8-11v-.3l.1-6.2 6 13.6-.3.4c-.1 0-.3.3-.2.4v.2l-5.7 3.5.1-11.5Zm.4-7.6-.3.2v-.7l.3.5Zm-6.2-22 15.2-1.6-.6.4-4.8 3.3a4 4 0 0 1-1.3.5c-1 .3-2 .6-2.8 1.4-.8.8-1.8 1.2-2.9 1.5l-2.2-.2-2.9-4.9 2.3-.4Zm-9.8-13.1 10.3 4.2.4.1-5 4.2-.9-.2-5.8-7.6 1-.7Zm-4.6-9.5-.5-8 6.2.6-5.7 7.4Zm3.8 1.4-.2-.2 4.5-5.2.8-1.2c.2 0 .7-.5.8-.4l3.7 3.9-9.6 3.1Zm10.2-7.8 13.5 2.5-9 1-1.4.2-3.1-3.7Zm2.7 7.3 2.9 3h-10.8l-.3-.3 4.7-1.7 3.5-1Zm2 10.5-9.6-3.6-.2-.4 11.9-.2-2.1 4.2Zm9.6 5.3.4.2v.6l-12.6 1c.7-.8 2.3-2 3.5-3.4l8.7 1.6Zm6.4-2.6-2.4-.3-9.4-1.9 2-4.3 2.6-.2 7.8.7a22.3 22.3 0 0 1-.6 6Zm5.5 33.7 1.2 1.3v1.4l-13.4-8.3-.6-.6 7-.6c.1.1.3.1.3.3 2 2.2 3.6 4.3 5.5 6.5Zm26.8 6.3 2.7-4.5c.5-.6 1.7-.3 2.1 0l5.9 3.8-11.4 4.6-.9-.6 1.6-3.3Zm13.9-23.6.6.5-11 12.7h-1.3l-2.5-9.6.8-1 13.4-2.6Zm.5-5.2-.4.9-4.8 1-8.5 2 4.4-10.2.5-.2 8.8 6.5Zm5.5-1.7-1.7-.3-9.1-6 1.2-.3 18.6-3.3.3.5c-2.8 3-6.7 6.6-9.3 9.4Zm10.4 12.5-.7.4-7.7-8.7v-1.3L208 298l.2.2-2.2 20Zm13 15 3.7 2.2v.6c-3.9 2.5-11.6 6.5-14.6 7.9l-.7-.5.3-16 .4-.1 10.8 5.8Zm8.9-17.8.3-.3.2.4-.8 6-1.7 10.4-1 .7-7.3-4-7.3-4.1 2.3-1.6 13.8-7 1.5-.5Zm15-9.6.9.3.2.4-12.6 3.8a3 3 0 0 1-1.2-.6l-8-6.8-5.5-5.5 26.1 8.4Zm0-4-26-8.4 14.7-4.5 2-.6 1.7 1 2.4 3.3 5.2 9.2Zm14 24.2 11.3-13.8.1-.4.7 14.8v-.4l-12-.2Zm-1 11.4-1.4-.3-.7-6.2 1.2-1.4h2l9.2.3.2 1-10.4 6.6Zm-5.6 19.4 2-1.3c.4-.3.9-.3 1.3-.5l1.6-.4c0-.8.3-1.3 1-1.7l6-3.9-8.5 18.5-2.9-9-.5-1.7Zm-6.4 33.9-1.2.1-12.4-15 19-1 1 .2v.5l-6.4 15.2Zm.8 32-.7-.7.4-.5 4.2-3 1.2 1.6v3.8l-5-1.2Zm0 3.8 4.2 1 .9.4v3.4l-.1 1.2-.9.3-1.6-2-2.5-4.3Zm-10.4 36v-.5c2.7.3 3.6.8 6.4 1.2 1 .2 1.9.6 3 1 .7.2 1 .3 1.3 1l1.2 2.5 2.6 5.7-.4.2-14.1-11Zm2.6 14.1-1.5-1.4-3.5-9.4 1.2-.2 14.1 11.5-.4 1.1-8.5-1.1-1.4-.5Zm-3 5 1.4.3 4.8 5.7-.6.5-7.9-2-.4-1 2.7-3.5Zm-2.7-2.4v.8l-3.8 4.1-2 .6c-2-1.5-4-3.3-6.1-4.7l-1.3-1.3.8-2.4.8-.5 11.6 3.4Zm-5.3-13.5 2.4.4 3.4 9-.5.5-6.4-1.6-2.5-1-1.3-1 5-6.3Zm-14-23.1-.4-1 9.2-2.4c1.4-.3 2.3-.4 2.6 1 .3 1.6.4 4.2.7 5.8l.8 6.7.2 1.3-.4-.3-12.6-11.1Zm-8.6 6.8-.8-.4v-1.3l4.8-4c.4 0 .4.3.8.1l12.6 11-.4.4-17-5.8Zm3.8 11.7-1-.6-4-7-.5-.6 1 .1 15 4.8c1.1.4 1 .4 1 .2v1l-11 2.1h-.5Zm-6.3 5c1.4-.5 2.6-.7 4-1h.6l1.3.1 6.3 5.2-.4.5-11.3-4-.5-.5v-.3Zm-2.4-11 .7.5 3.5 5 .7 1.3-4.6 1-.8-.6.5-7.3Zm5.4-14.2.1.7c-1.4 1.2-2.1 2.2-3.8 3.6l-.9.3c-.4 0-.2-.5-.5-.8l-2.3-8 7.4 4.2Zm-9-12.5-.8-.2-1-3-2.2-8 .8.2a3 3 0 0 1 1.8.5l4 2.6c.5.3.8.8.9 1.5 0 .3 0 .7.2 1l-3.8 5.4Zm-8.4 13.8c.1-.6-.1-.4.4-.7l5.3-4.8h.6l2.3 8.6-1 .8-3.9-1.7-3.8-1.8v-.4Zm2.9-8.4-5 5-.6.3v-.3l-2.3-8.3 7.9 3.3ZM176 420a2174.4 2174.4 0 0 1 7.1-4.8l.4 1-4.3 9.9-3.5-5.3c.2-.2.3-.5.3-.8Zm-2.2-20.1-.8-1.1-.4-9.4-.2-.2h.3l.6.4h.1v.1l6.2 6.6v.2l-5.8 3.4Zm-7 25.8c.3-.3.5-.5.8-.6l3.9-2.5.7-.4 3.5 4.8H173l-6.3-.2c0-.4 0-.8.3-1.1Zm2.3-23.9c0 .8-.2 1-.4 1.7-2 1.3-2.9 2-5.2 3.2l-.3-.4-1.2-.5-.5-2.5-.6-8.4 8.2 7ZM159 385.3l.2-6 6.4 4.8.7 1-2.1 1-5 1.4-.2-2v-.1Zm-1-11.9c-.4-.1-.7-.3-.9-.6l-1.7-3-1-2.7 10.1 6-5 .3H158Zm-1.3 20.4.2.1.5 2 .7 6.5-5-3.4-.6-.8 4.2-4.4Zm-8.1-7.6 5.4 5.4-3.6 3.4-2.3-8 .5-.8Zm6.3 4.8-.1.2v-.2Zm-1.2-5-4.4-3.4.7-.9 5-3.8v.3l.3 7.8-.1.7-1.5-.7Zm-7.3-7-2.1-7.6 7.9 2 1 .4v.2l-5.1 4.8-1.2.1h-.5Zm-2.2 8.6.5.4 2 8.1-7.6-4.3 5.1-4.2ZM138 381c2 .8 2.6 1.3 4.5 2l.7 1-4.7 4.3-1-5.1-.3-1.8.8-.3Zm5.6-.5-.6.4-5-2.3-.8-1 2.5-5 .5-1 .2-.1 3.2 9Zm4.8-16.8h.9l.6 1 1.7 4.4-7.4-1.5-.8-.5c1.6-1 1.7-1.3 3.4-2.3l1.6-1.1Zm5.5-6.5v.2l-5 1.7c-.2-.1-.1-.2-.3-.4-.5-.4-.3-.6-.7-1.2l-2.6-3.8-.1-.3-2.7-4.8 11.4 8.6Zm3.5-2-14-11.2.2-.2 15 .7c.1.2.3.1.4 0l-1.6 10.6Zm4.6 9c1.7 2.2 2.3 3.3 3.4 5l-1.5-.6-11.4-6.7 1-.6 3.2-1.3h.1l2.9 1.2c.7 1 1.4 2 2.3 3Zm17 1.2-13.8-6.2-2.4-1-1.7-1.2-.1-.7 1-9 .6-.2 16.4 18.3Zm2.5-14 3.7 4.3-1 .4-15.5-9.3-3-2.8 3.8-1.3 2.2-.1 1 .6 6.6 6 2.2 2.1Zm9.1-13-4.9 8.8-6-4.6 10.6-4.5.3.3Zm19.9 13-5.8-.3-.3-.3-1.8-1.1-3.2-5.6 11 7.2ZM222 355l-.1.4-12.3-8 14.2-8 .3.2-2 15.4Zm13.7 38.6Zm7 14.3h-.7L231.4 397l.2-.5 2.5.1 5.7 1.1 2 .6c.5.8 1 1.4 1 2.2v7.3Zm2.5 26.9-11.3-7.1v-.6l4.8-1.8 1.3.6c0 .2.2.4.4.5l.2.3 4.9 7.9-.3.2Zm-11.7 10.6 1.6-.8c4.5 3 4.2 3.6 8.9 6.7l1.3 1c.7.3.9.8 1.1 1.3.2.3 0 .3 0 .6L245 457h-1.3l-10.2-11.7Zm-4.6 0c2.8 3.3 4.7 4.9 7.5 8 2 2.3 2.4 3.2 4.4 5.5l-.6.7-8.6-1.7-1.9-2-2.1-11.2 1.3.6Zm-6-27.5 2.6-.8.3-.2.5.3 3.9.3 1-.1 4.5 3.3 1 .6c.4.2-.5.2-.2.5l-3.8 1.7-6.3-1.5-1 .1-2.8-1.8-.1-.1.4-2.3Zm-6-1.2-.5-.3a18 18 0 0 1-2.2-1.6l-.3-.1-1.7-1.7-.2-.6.2-.6 2-3.7 1.6-1 2.5.5 2 1.3 1.8 1.3 2 2 .5.2.2.2-.3.3h-.3l-.3.3-7 3.5Zm-10.8 9.6c.8.4 1.4 1 1.8 1.8.6 1 1.6 1.6 2.8 1.8.7.1 1.4.3 2 .7l6.6 4.3.4.1c.6.8 0 .7 0 .8-2 .4-7 1.8-10 2.3l-1-.8-.4-1-.5-1.4-2.3-9 .6.4Zm-2.9-19-.3-.6c-.2-.2-.3-.3-.3-.5l-.2-.8.2-3.3 1 .5c1.2 0 4.5.5 4.5.5l2 1.1 1.1 1-.2 1-.1.5-2.1 4.5c-1.5-.7-1.7-.8-3.2-2l-2.4-1.8Zm-2 18.6.5.4 2.6 10.4-6.8-3.8-.6-.7.4-1 3.9-5.3ZM191 375l5.1-.8.7-.1-2.9 7.2-1.6 3.3c-.2-.6-.2.1-.3-.5l-1.2-7c-.1-1 0-1.3.2-2.1Zm6 12.2-1-1 2.6-6.5 1-1.8 2.1-4.1h.3l.1.2 4.3 16.3-9.4-3Zm1.6 4.4 9.7 3.8.5 3.2c-1.7.7-5.7-.7-9-2.4l-1.5-3.7.3-.9Zm18.7-.8-6.2 1-.8-1.5L207 377l3.4 4 7.1 10Zm.4 3.8-2.5 4.7-.8.6-1 .4h-.2c-.3-1-.4-1.8-.5-2.7l-.1-1.2v-.6c.4-.3.8-.4.7-.6l3.2-.7h1.1l.1.1Zm8 13.4-7.6-5.3V401l2.9-5 .7.3 4 11.7Zm-.6-15.6-2-1.1c-.5-.5-.5-.8-1.2-1l-3-4.2-2.9-4.4 18 11.3-9-.6Zm15.4 22.5 2 .4.2.2v2.3l-2.5 2-4.7-4 5-.9Zm-1-3.5-7.7 1-1.5-1.2-4.5-13.1 1.5.4 12.5 12.4-.2.5Zm-30-53v5l-4.9-3.3 1-4.3 4 2.6Zm5.2.6h-.2l-6-4.6h1l4.6-.7 5 3.2.4.3v.4l.2.3-5 1.1Zm8 8.6v.2l-.2 1.5-.3.6-8.7-4-.4-.2v-3.2l8.7-1.4.2.4h.8v6ZM190.1 354l4.5 3.6 13.7 9.2-1.3 1.8c-.9 0-1 0-2.8-.4-1-.2-1.4-.8-2-1l-1.4-1-8.9-8.2-3.8-4.6 2 .6Zm10.3-1.4 2.1 1.1-1 4.2-4-2.7-3-2.3 5.9-.3Zm-11.4-3-.4-.4 5.2-8.8 4.3 8.9-9 .2Zm-4.3 16.7-9-10.4 20.5 11.6.2.1c0 .3.2.7 0 1 0 .2-.5.5-1 .8L189 371l-4.4-4.6Zm6.2 63.7-.5.3-7.8-2.7 4.3-9.6 4 12ZM178.4 388l5 1 3.6 1 .6 1.4-4.3 2.7h-.3l-.3.1-6.1-6.4 1.8.2Zm-5.8-9.2 10.7 6.7h-.6l-10.6-1.6h-.2l.7-5Zm13.5-2.8h.7l1.7 8.4-10.7-7 5-.9c1.1 0 2.3-.3 3.3-.5Zm-20-12.3 7 3.3c3.2 1.7 6.2 3.6 9.5 5l.3.7-1.7.2-10.3.3c0-.2-.2-.3-.3-.4l-4.6-9.1Zm1 17.2-5-4 5.8.3 1.2 1v1.1l-.4 2.3-1.5-.7Zm1.5 7.5.3-.5.4 4.8.2 5v.4l-8.2-6.7.6-.7 6.7-2.3ZM198 404l-.1-.2v.1l-1.5-.4-1.9-1-1.5-2-.2-.4-.4-2.4.1-1.5c0-1-.2-1.8 0-3.3v-.6l1 .1c.9 1 1.6 2.4 2.3 3.8l3.1 4.3v1.5l-.6 2.4c-.5-.2-.3-.3-.3-.4Zm29.7-24.6 9.9 11.3-.1.2-15.2-10.1-11.2-7.2s-1.9-1.5-1.1-1.6l12 2.6c1.2.2 2 .8 2.8 1.6l3 3.2Zm8.7-29c-1.6 1-3.1 2.1-5.1 2.4a4.7 4.7 0 0 0-3.6 2.6c-.4.7-.8 1.2-1.6 1.7l-.7-.2 2-16.4.6-.1 8.4 10Zm11-23.2v.8l-17.4 4.1-.5-.4 2.5-15.5 1.2.3 14.3 10.7Zm.3-18 .9.7 1.3 13.6-.2.7-14-10.4-.1-1 12-3.5Zm-15.1 26.3-.7.1v-.3c6-1.8 11.3-2.5 17.6-4.3l.8.6.3 1.2.4 5.2h-.1l-18.3-2.5Zm.2 5.4c-.4-.5-.2-.7-.8-1.3l.1-.2 17.1 2v.7l-8.8 5.6c-.2.2-.6.4-1 .4l-6.6-7.2Zm1.6 26.9c1-.9 2.7-2 4.4-3.4l2.3-1.5c1.2-.7 2.3-1.5 3.8-1.7.6 0 1.2-.2 1-1 0-.3.4-.6.6-.7l.4-.3 3.3 11.3-.2.6-18.1 1.1-1.4-.2-.2-1.3 3.9-2.2.2-.1v-.6Zm31-58v.3l-11.7 14.4-1.6-13.9.3-1.3 13 .4Zm-14-4.3-3.3-2.1-7-12.6 6 3.5 10.6 7 6.9 4.6-13.3-.4ZM184.4 326l9.8-12.1 1.5-.2 7.5 8.2-.2.3-18.6 3.8Zm19.8-.3.1.2-.5 16.4-20-12.5-.6-.5 21-3.6Zm-71.5.6 23.2 14.3.4.3-17.5-1-.5-.2-1-1-5-12.3.4-.1Zm-1.2-6-.8-1.2 3.4-2.2 5.8-3.7h.4v6.7h-1.2l-3.1.1c-1.4-.1-3.3.2-4.7 0l.2.4Zm135.7-17.7-5-2.7-21.7-14.4 5.7-1 26-3.3 1.7 1.5-6.7 19.9Zm16-30.6-1-.1-4-.8v.1l-2.4-.5-4.5-9.4-.5-1.4c2.7-.3 5.6-1 8.4-.8h4.2l4.4 1.6h.1l.1.1 4.5 2.2c1 .7 2.6 1.5 4 2.6l-13.2 6.4Zm27.3 28.9-13.6.4-.9-.2-10.4-14.2.8-.5 1.8.4c3.2 1 6.7 2 8.4 3.9l13.9 10.2Zm7.7-23.8 2.8 1.4-2.2 2.9-.2.2-8.7-5h-.1l2.5-1.3.2.1 5.7 1.7Zm2.2-37.5-1.7.8-2.3.9-.5.1-1.9.8-.3-1.4V237l.2-.5.5-.3 2.9-2 1.8-.3 1 1 1 1 1.3 3.4-2 .3Zm4 2.6 2.8 1.7 1 6.9-5.7-2-1.7-5.5 3.6-1.1Zm.6-18.2 2.7.6 5.7.4 3 .5.4.5v5.1c-.2-.2-.4 0-.6-.2l-2.1-.7-3.9-1.5-6.2-2.4-1.1-2.2h2Zm11.9-26.9v11.5l-.9.9-3.9 1.1v-7.8l.5-2.4.7-.7 3.6-2.6Zm-2.6-6.4ZM329.2 314l.3-.3 7.4 4-.5 3.7-.7.2-.4-.5c-2-2.5-4.1-4.6-6.1-7Zm4.2 17.5-2.6 3.5h-5.4c-.6 0 .2-.8-.2-.8l7-4.4 2.2-1.3-1 3Zm-4.5 25.3-3-3 3.3.3 4.6-.2h.8l.4.3.4.6 1 9-.4-.3-7.1-6.7Zm-6.4 9.4 9.7 2.9 1 .6-5.3 4.8-.3-.4-5.1-7.9Zm-1 12.5-4-3.1-.7-1-.1-.2-.3-.2-.9-1.4v-.2h-.1c-.9-1.7-.5-1.8-.6-3.3l.5-2.9 2.4.5 5.3 7.3 2.7 3.8.4.4v.3l-.8 2.8-2.8-1.6-1-1.2Zm-10.1-4.8c.3-.2 2.4 4.2 2.7 3.9l2.8 2.4 2.4 1.7 2 1.2.3.7c-3 0-8.6.3-13.1.3l-4.2-.1c1.5-4.6 4.2-8.2 7-10Zm-12.1-16.4.4-.7v-.3l11.4-5.6v2c.1.2-.9 4.3-.9 4.3l-.6.8-.4 1.6-1.5.6h-2L300 359c-.3-.6-.5-1-.7-1.1v-.3Zm-9.5-21.7v-.6l.6-.4 12.3-1.1.5.4-1 3.4-4.5 13.6-1.5.5-6.4-15.8Zm-13.5 4.2c1-.6 1.9-1.2 3-1.3.5 0 1-.3 1.6-.4l-.3-1c1.4-1 1.5-1.2 3-2l1.7.3 7.9 18.7-1 1.1L271 344l-.2-.4 5.5-3.5Zm-4.8-35v-.8l6.4-19.9.9.2.5.8 7.5 9.6 4.2 6.2.7.9-20.2 3Zm12.4 13.6v.9l-1.2.8-9.3 6-1-.7-.5-14.6.3-.1 11.7 7.7Zm17.6 11.3-11 1.1h-1.8l-1.7-.8v-9.1l.3-.2 13.5 8.4.7.6Zm1-5.6-1 .9-2.2-1-23.3-15.5 15.9-2.6h3.3l7.2 18.2Zm8.3-13.6-4 11.6-.4.1-.7-.3-6.4-16.2.2-.5 10.8-.5.5 5.7v.1Zm7.5-22.5-.5-.2h-.5l-4-1.3-.5-.2-.7-.3c-.6-.3-.8-.4-1.2-.8l-.5-.2.4-2c0-.6.2-1.2.4-1.7l9 5-2 1.7Zm4.2 17.4a6 6 0 0 1 1.5 1.5c.4.7.5-.3.7 2.2.3.6-.2.8-.1 1.3 0 .5-.2 1-.4 1.5-.3.3-.7.5-1.2.7h-3.1v.1h-1c-1-.4-2-.7-2.8-1.2-.6-.2-1.2-.4-1.3-1.2l-.1-.2c-.2 0-.3-.2-.4-.3l-.4-4.4 1.9-1.6c.2-.1.3-.5.8-.8.3-.1 2-.6 2.2-.4l3.7 2.8Zm3 10.4 8.1 8.6.1.2-10.3 5.7 1.6-14 .6-.5Zm-3.4 24-.1-.8.1-.4h8.5l.4.1 1 7.7-10-6.5Zm-2.4 9.7-2.4-.4c-.2-.2-.3-.6-.2-1.7v-4.2l.2-.4.5.1 3.3.8.2.2 8.8 6v.4l-10.4-.8Zm-9.6-24.7 2.5-7.7 4.6-.1.8-.3 3.7-.3v.3l-.9 5c-.2.2-.3.4-.3.2l-1.3.8-4 1-1 .2-3.1.8h-1Zm-1 8 1.2-3.8.4-.3 6.7-1.5v.4a140 140 0 0 1-1.5 6.7c-.7 3-2.7 6-2.7 6l-1 .4-.9-1.7-2.3-6.2Zm1 13.2.3.9-8.8 3.8 4.5-14 3.9 9V346.2Zm8.5 15.3-1.7-1.3v-7l3 .2 7.3 7.2 4.6 4 .7.8-12.2-3.3-1.7-.6Zm6.8-72.9h.2l1.5-.7h2.4l1.3.4-.3 2.4-.2.7v3.5l-1 2-8.2-5.8 4.3-2.5Zm-9.5-19.2 1.2-.3 4.8-.6 3.5 1 1.3 2.1-.1 1.7-3.7 1.8-7.6-2.8.6-2.9Zm3-18.5-.5 2.8-1.4 3.9c-.9 1.4-.6.7-1.3 1.6l-.2-.6-.6-5.5-.4-3.1v-2.3l.9-1.7 1.6-.7.9.2.3.1.7 3.7v1.6Zm6 9-2.5 4.5-.5.7h-.3l-4.6.4 4.4-8.8h1l2.5 3.3Zm12-1.7v3.8l-1 .9-.5-.2-3.1-2.6 2.7-5.4 2-2v5.5Zm-2 25.5-3.7.5-.6-.3-8.3-.7 3.8-5 3-1.5 2.6 3.1 3 3.7.1.2Zm-4-11.8-.9-1.5-.2-.4-.2-.6.2-.4 4.5-.8h.4v.4l1.6 1.8.7.3v7.4l-.8 1.9-5.4-8.1Zm.2-26h1.1l2 1.1v.8c0 .8.2.6-.1 1.8-.3 1-1 1.7-1.4 2.6h-.5v-.2l-.4-2.2-.7-4ZM333 265l-7 1-.3-.2 1.8-2.9 2.2-.4 3.3 2.5Zm3.9-24.5v1l-1.6 2h-1.5l-1.2-1.2-.5-.2-1.2-.9-1.5-1.2 1.7-2.1 1.9-3.7v-.1h2.2c1.2.2 1.6.3 1.7.8v5.6Zm-7.9-5.5-2.4 3.1-.3-.2-.6-.6-1.4-3.8.4-2.9 4.4 2-.1 2.4Zm2 20.3-1.5 2.6-2-.6-2.8-3.2.2-1 1.3.3 4.7 1.9Zm7.4 47.3-1.9-1c-1.2-2-2.7-2.2-2.8-3.8l.4-1.6h.1l.4-4.6v-2.8h2.8l.4 4.6.8 5.3s0 .8-.2 1v2.9Zm-4.7-122.2 3.3 2v7.2l-1 .2-.4-1.3-2-6.6v-1.5Zm3.4-5.3V178.3l-3.7-2-.3-4.8 1.4 1 .1.1 2.4 1.4v1.2Zm-8.4 38.8Zm-4.6-4.4 4.3-4.8.2 6-4.5-1.2Zm5.6 8 4.1-3.4h.2v-.2l2.5-.8.5.5c.1.2 0 .5 0 .8V219.4l-.6 2-1 .4-2.1-.4-7.7-.6H323l.3-.7 5-2 1.3-.5ZM167.1 320.2l4-2.8.7.2 2 6.6-6.7-4Zm7.3 9.5-3.7 8v-.1c-2.2-4.9-2.8-7.6-5-12.4l8.7 4.5Zm-15-.1 2.6-4.4.3.2 2.7 8-5.5-3.8Zm8.3 9.8c-1.8.4-5.1 1.3-6.4 1.5l-6.5-7.7c-.1-.5-.2-1-.4-1.3.5 0 1.1 0 1.2-.3l12.1 7.8ZM150 322.6l7.9-1h1l.5.5-2.5 5.7h-3.8l-1.2-.8-4.3-3-.1-.2.5-.3 1.6-1 .4.1Zm-16 53.3-3.9-2.3a233 233 0 0 1 7-4.3l-3 6.6Zm-5 9.6 1.6-1.7 2.5-2 .7.6 1 6.6-5.8-3.5Zm.7 4.7.3.1 5.2 3.5-1.6 6c-.3.2-.5.4-.7.2-.5-.3-1.8-.9-2-1.3l-.1-.2v-.2l-1.1-8.1ZM126 415l-.6-2-.4-5v-.4c.2-.4 1.5-.4 2.5-.2l.6-1.5 3.6 2.6.3.1 3.4 2.2c.4.3.5.6.4 1-2.5.7-7.7 2.5-9.8 3.2Zm5.3 12.7v-.1l-4.4 3.5-.4-.5-.2-5.8 4.2 1.8.7.4.1.7Zm-5.2-7v-.9l.5-.3 1.3-.7 7.6-2.8-.3 2-1.5 5-.1.4h-.1l-.2-.3-1.4.2-5.8-2.6Zm14.4-15c-1.3-1-2.7-1.8-4-2.7l1-3.1 1.4-4 6.2 3.8.1.2 1.7 1.7.7.3v.1l-.5 1.2-6.6 2.4Zm.6 11c.1-.4.9-.7 1-1 .8.3.4 0 1.1.3.2 0 .3.4.4.7 0 1 .6 2 1.3 2.7l-.5 6-1 .5-6.2-1.2.1-.3 1.6-6.8.2.3v-.5l2-.7Zm117.8 22.7.7 4.9-4.8-3.4c0-.5-1.7-3.4-1.7-3.8.7-.4 0-4.3.7-4.5l4 2.3c0 .4.3 2.4 1.1 4.5Zm21.2-34.3v1l-.3.1.2 2.7-1 6.3v5.7l-.6 3.7h-.2v1.3l-1.3.4-3.4-1.1v-.2l-.6-.1-2.5-2.4-.7-.9-.4-1.3-.1-3.4v-5.2l-.3-5v-2.6c.5-1.1 1.6-2 2.1-2.2l5.4.2c1.4 0 2.7.7 4 1.2l-.1 1c-.3.2.2.6-.2.8Zm73.7-89.8c0 2.2-1 3-2.2 3.3l-1-.7-3.2-2.2-.4-.5-2-1.3 7.6-6.7 1.9 5-.5 2.5-.4.4.2.2Zm24.1-22.1c.9.1 4.6 2.1 6.6 2.8l-25.8 16-1-1.9v-.3l-1-3.2.3-.2 8.8-5.8c1-.7 2.4-1.6 3.4-2l1-.8 7.3-4.7.4.1Zm8.3-6.9-1 4.7-4.4-1.3-.8-.4-.1-4.1 6.3 1.1Zm-12 42 1 .2v.7l5.8 11.3-16.6-.6 9.8-11.7Zm-1.6-16.2 5.1-3.2-3.4 12-.4.2-9-3.9 3.2-2.2c1.4-1 3-1.3 4.6-1.7l-.1-1.2ZM360 337c-.7-.2-.7-1-.7-1.7v-6.7c0-.7.3-1.3 1-1.4l.7-.3v-1c1.4-1 1.5-2.7 1.2-4.4v-.6l.1-.4 9.8 4.4-.9 1.1-11 12.5c-.3-.4 0-.3.1-.8-.2-.2 0-.6-.3-.7Zm29.5-21.2-1 1.6-10.2 3.8 3.4-13.6c.4-.4.8-.7 1.4-1 .7-.1 1.2-.5 1.6-1.2.4-.7.9-.7 1.4-.1l3.4 10.5Zm.3-26.6s-.1-.4.2-1.4l.3-3 1.7-1.6v.2l1.3 5c-.2 1.8-1 3.5-2.8 4.2l-1 .2.3-3.1v-.5Zm1.5-15V273l.3-.6 5-1-.8 3.7-.9 2.1h.2l-3.2 1.5-.6.1-.5-.3.5-4.4Zm1.5-12.3c.3 0 1.7-.7 2.7-1.1l.3.8 1.5 6.3-2 .2-3 .1h-.2l.7-6.3Zm1.8-14.4 2.9-.3-.2 7.2-.5 1.4-1.6.7-1.7.8 1.1-9.8ZM398 228l5.3 3.2 1 .6.4 1-7.9 9.3-.3-6.6 1.5-7.5Zm.8-10.5c1.7 1 9.2 6.7 10 7v3.3c-.2.1-1.6 1-2 1l-7.2-4.2-1.4-2.7.6-4.4Zm4.4-8 4.9-3.9v8.3l-.6 3.5-3.6-1.7-4.2-2.3 3.5-3.8Zm-2.7-5.8c.6-2.4 1.4-3.6 1.5-3.6l5.3-1.8-.2 3c-.7 1.4-3.2 2.6-3.4 3l-1.8 1.3-1.5 1.3.1-3.2Zm1.4-9.5.5-5c.4.2 2.5-.6 2.5-.6l2.6-.3v5.3l-4.5 2.1-1.4.3.3-1.8Zm1-10.7v-.2l.7-6v-.2l.3-.3 1.8-.8.5-.3 1.7-.8v.8l-1 8-4.1 1.6.1-1.8Zm2-17.7v-.1l.1-.7 3 2.1v3l-.7 1.3-.1.2-3.1 1.2.8-7Zm9.9-4.3c-.5 1.3-.7 2.3-1.3 3.6-.2.4-.3.6-.5.6s-.4 0-.7-.2l-4.7-3 7.2-1Zm1.4 17.3-3 1.4-1.8 1.1v-4.3l.4-6c0-.6.2-1 .6-1.3l3 .2.8 8.9Zm1 9.7c-.4.7-1 1.4-1.7 2-1 .6-1.8.6-2.8 1l-1.3.7v-6.3c.9-.3 2.7-2.7 5-2.8l.8 5.4Zm-15.7 109 2.7 1c.4-.1.6.9 1 .9.4 1 0 1.6-.5 1.9-1 .6-1.3-.4-2-.8-.7.3-1 1.5-.8 2.2.1.9 1.3 1.9 2 2 .9.2 1.8.2 2.6-.3l.3-.2.6-.7.4-.7 3.9 2 .2 4h-.3c-.1.3-7.3 1.8-10.3-1.8l-2.1-2.4c-.4-.2-.9-1.3-1-2.2l-.6-2 4-2.9Zm-5.2-5.8c.5 0 5.5-1.8 6-1.5l-.8 3.5c-1.4-.2-4.3 2.9-5.3 3l-2-.8v-1.1l2.1-3.1Zm7.3 4.7ZM402 285l1.6 1.3c-1.8 1-4.8.8-6.2 1.6l-1.2-5.1h2l3.8 2.2Zm8.8 6.4.3 3.2v3.1c-.4-.1-1.9-.4-2.7-.8l-3-1.9c-.2-.3-.4-.6-.3-.7l1-3.4 4.7.5Zm-5.9-14.3 4.6-1 1 2-.1 7-8.3-4.3-2.8-1.7 5.6-2Zm3.2-4.6-8.5 2.3.9-3.4 5.5-.2h.3l1.8 1.3Zm-4.2-7.8c1 .6 3.1 1.8 3.3 2.5l-4 .5-2.2.1-1.4-5.5 4.3 2.4Zm3-9.4 2.7-1 .5 10.5-8.8-6.2-.2-.3 5.7-3Zm-5.1-12v-.7l.6-.8 5.7-6.8.9 1.9.2 7.2-7.4-.7Zm2 3.3 5.3 1.1-.6 3-7.4 3.4.3-7.3c.3-.1 2 0 2.5-.2Zm13.6-47.7-4.4 1.4c-.7 0-1.2 0-1.5-.3v-3l.2-.6 4-2.2 1.5-.3.2 5Zm.8 4.6.8 8-1 3-.1.5-5.7-2c-.3-3.2-.2-5-.3-8.2l5.5-1.5.8.2Zm1.3 18.3.7 4.8-.2.2-2.5-1.2-1.2-.7-.5-.4-3.6-2.3-.1-4.8c0-1 3.3 1.1 5.1 1.7h.6l1.3 1 .4 1.7Zm1.7 16.7-8 3.8-.4-7.3v-6l4 .6 3.8 1.2.6 7.7Zm1.2 14.1-8.8-2a11 11 0 0 1 .2-4l7.8-3.3.8 9.3Zm.5 6c0 .6-.3 1.2-.5 1.8l-3.9 2.2h-2.7c-2.3-2.5-1.6-4.7-1.6-7.2v-.5l8.6 2.1.1 1.5Zm1.4 15.7-9.4-3.8-.2-3.4 4.9-1 4-.9c.1 2.8.6 6.4.7 9.1Zm2.1 21.3v.7l-.3 1.2-1.3 1.5-2.5 1.6 1-13.3.1-.3 2.4-1.3.6 9.9Zm1.6 14.4-6-1.5c.3-1.6.1-3.5 1.7-4l3.6-2.6.7 8Zm-13.3-30.3.3-4.9 8.7 3.6-3.4 5.8-5.6-4.5Zm3.6 39.4c-.2.3-1.7.5-2.6.7l-.1-8c2.2-5.1 5.8 2.8 2.7 7.3Zm-3.9 31c.2-.3 0-.5 0-.9v-3.3c0-.5.4-1 .5-1.6.2 0 1-2.5 1.8-4.8l1.2.1.8 10.2-.3 4.2-4 3.3c-.2-2.3-.4-6.4 0-7.2Zm4-26.9-.7 12.3-3.4-.3v-3.5c.1 2.1-.1-4.3 0-6.4 0-1.6 2.5-2.1 4.1-2Zm.7-27-.1 1.7-.8 6.4c-.2.7-.6 1.3-1 1.2l-1.8-.1-.3-7.3.6-.5 3.4-1.4Zm-2-3.7-.3.3-2 .7-.3-8 2.7 1.3c.3.4.6.9.8 1.5 0 .4.4 1 .4 1.3.3 1.7-.8 2-1.3 3Zm11.6 28.6c0 2.1-1.3 9.6-1.3 9.6l-.3.6-4.4 5.2-1.6-.4 2.1-23.3 4.1 1.1h.1c.4.2.5.5.7.7.3 1.8.6 5 .6 6.5Zm4.2 8.5.2-2.2v-1.1l1.5-.4 5.7 9.7-8.5 7.2 1-13.2Zm16.8-.4v.7l-6 3-.9.3-7.5-12.6-.5-1.2 15 9.8Zm-2.6 14.7-13 2-.5.1 8.4-7.2 5.1 5.1Zm4.6-10.3-.2 9a48 48 0 0 1-2-1.5l-4.1-3.8-.3-1 1-.5 5.1-2.4.5.2Zm3.6 85.4c-.2-.3-.2-.7-.1-1 0-.5-.1-.8-.6-1l-.6-.1c-.7-.4-.7-.8-.1-1.2l.7-.6-1.9-.6c-.7-.3-1.6-.5-1.8-1.5 0-.2-.3-.3-.5-.4l-1.6-.6c-.6-.3-1.4-.6-1.6-1.1-.3-.7-.9-1-1.4-1-1.4-.3-2.2-1.5-3.5-2l-.2-.3c-.6-1-1.7-1.6-2.8-2-.8-.4-1.6-.9-2.5-1.2-1-.4-1.5-1.5-2.4-2.2l-.1-.3v-.3c0-.7.2-1.4.4-2.2-.9-1.1-.9-4.5.1-6-.7-.6-.7-1.4-.7-2.2 0-.8 0-1.6.8-2.1-1-1.3-1.1-4-.2-5.8-1-1.3-.8-2.7-.1-3.8l-.5-2.5v-2.2c-.1-1.3.5-2.4 1-3.5.4-.8 1-1.6 1.8-2l.4-.7.5-1.3 2.9-4.2c.4-.6.8-1.3 1.6-1.6l.4-.4c-.2-.8.3-1 .8-1.4l.2-.7.4-.8c1.1-1.7 2.2-3.5 3.5-5 .5-.6 1.1-1.1 1.5-1.8l6-6.3v-16.3l-23.3-15.9L418 160.2l-.4-2.9-15.5 2.3L398 194l-11 85.6-.4 2.8-2-.1-3.5-.6h-.1l-.3-5.5-8.5-5v-4.7l-9-5.4-.3-29.1 3.3-2.9-.2-13.8h-1l-.3-2.4-14.6-28v-21.7l-12.7-7.9-14.2 7.9-.3 23-14.2 28-.3.8v.6l.1 14 2.2 1.5v4.9l-4.2 2 .1-.5V236.2l-.1-1V222l-.4-.2-15.5-10-1.8-42.9c.4 0-.1-1.5-.2-1.8l-1.5-1.7c-.6-.5-1.1-.5-1.7-.7h-2.8l-3.5.7c-.6.3-1.4 2-1.7 2.4-.3.5-.9 3-.9 3l-.2.7-6 20.3c-4-12.3-19.3-61.3-19.6-61.9-.3-.6-2-2.7-3-4.2 0 0-.1-.2-.4-.3 0 0 .2-8.2 0-10.3-.4-2 0-2.8-.5-3.3a21 21 0 0 0-3.5-2.5c-2-1.2-1.2-.3-3.2 0-1.9.3-2.5 1.3-3.7 2-1.2.6-3.2 1.9-4.2 2.8-1 1-1.2 3.2-1.3 3.6 0 .5.5 4 .4 6.3 0 2.3.8 16.5.8 16.5l2 2.8.6 4.2 5.6 2.6 4 15.8v.1c0 .3 0 .6.3.8l.3 1.3 1.4.9 11.3 38.7 4.6 4.2.6 1-13.3 8.3-.2 12.6-26.5 18-65 41.7-6.5 4c.2-.3.2-.7 0-1.1-.2-.2-.2-.5-.2-.7V289c1.2-1 0-2.2.3-3.2l.1-.3c.6-1.7 0-3.4-.1-5-.1-.9-.4-1.7 0-2.6 0-.3 0-.5-.2-.7h.1c.3-.6-24.4-16.2-25.3-16.7-.8-.6-1.3-.7-1.9-.9H88.4a15.5 15.5 0 0 0-2.4.5l-4 2.9-21.3 13.7c-.7.5-1 1-1 2v24.2c0 1.1.3 1.8 1.2 2.4l4.2 2.8c0 .6-.2 1.1 0 1.5.2.5.3.8 0 1.3-.1.5.2.8.5 1l2.3 1.6c2 1.5 3.9 3.2 5.7 4.8 1.4 1.2 3 2.2 4 3.8 0 .2.3.2.5.3l1 .6 3 3.4 2 3.2a4 4 0 0 0 4 2c.7 0 1.2.2 1.8.6 1.5 1 2.3 2.8 4 3.5l.3.4 1.3 1.2c1 .7 2 1.4 2.8 2.2.8.7 1.5 1.4 2.4 2 1.8 1.6 3.8 3 5.1 5 1.5 2.3 3.4 4.3 4.3 6.9 0 .2.3.3.4.5l1.4 1.6 3.6 5.3c.7 1 .9 2 .4 3.1a3.4 3.4 0 0 0 1 4.1c.8.6 1.6.8 2.5.7 1 0 1.8.5 2.4 1.4l1 1.7v4.3l-5.3 2.8V393h.3l-.2.7 5.9 4.6c0 1.1 0 .8-.5 1.9-.5.8-1 .8-1.1 1.6 0 .3-.4.6-.4.8l-17.8 11.2v16.8l162.1 104.5c1 .2 1.7.4 2.4.4l4.3-.2c.7 0 1.5 0 1.4-.1h6.3l8.7.2c1 0 2 .1 2.9-.4l6-4 .3-.1v-.2c.3-.5.5-1 .9-1.2 3.2-2 6-4.6 9.9-5.5-.3-.6 0-1 .5-1.3 1.3-1 2.7-1.4 4.5-1.8-.7-.9 0-1 .4-1.4 2-1.3 4-2.5 5.8-3.8 1.7-1 3.4-2.1 5.4-2.4l.6-.3-.2-1c3.7-2 6.7-5 10.8-6.3.3 0 .8-.4.8-.6 0-.7.5-.9.9-1.1l5.4-3.5c.6-.4 1.4-.7 2.1-1 .7-.3 1.6-.2 1.8-1.2l.4-.2 1.5-.6c-.1-.7.3-1 .9-1.4l2.1-1.4 5.2-3.2 1.8-.7.2-.5 8-5h.1l1-.2.1-.5 1.9-1.2.9-.3.2-.4 6.8-4.5.5-.2c.4 0 .8-.3 1.3-.5a1 1 0 0 1-.2-.4l5.7-3.7.7-.5 1.5-.4v-.5l1.3-.9h.1c.6-.3 1.6-.2 1.7-1.2l9-6c1-.4 1.8-.8 2.7-1v-.7l9.2-6.1 1-.5c.8-.2 1.6-.2 1.8-1.2v-.2l3-2a11 11 0 0 1 3.5-1.4c.2-.5.4-1 .7-1.2 1.1-.6 2.3-1 3.4-1.5.3-.5.6-1 1-1.3l10-6.5c.7-.4 1.5-.6 2.1-1 .4-.1 1-.3 1.2-.6l.3-.6c.4-.5 1-.7 1.4-1 2-1.4 4-2.8 6-4 2-1.3 3.7-2.7 6-3.4l.3-.2c-.2-.4-.7-.8-.7-1.2V426c0-.2.2-.6.4-.7 1.4-.3 1.6-1.3 1.4-2.5l.3-1c.3-1 .4-2-.1-3Z"
      }
    )
  ] }) });
}, Illustration = {
  Upload,
  Upload2,
  Import,
  AddPhoto,
  NoResult,
  Delete,
  Archive,
  Exclude,
  Attention,
  Edit,
  SaveTable,
  Work,
  Support,
  TableCross,
  Mail,
  CreateLink,
  CloseNotSave,
  NoPage,
  Calendar,
  AllowPopup,
  Tabs,
  EmptyWidget
};
var EXP_LIMIT = 9e15, MAX_DIGITS = 1e9, NUMERALS = "0123456789abcdef", LN10 = "2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058", PI = "3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789", DEFAULTS = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed at run-time using the `Decimal.config` method.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used when rounding to `precision`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The modulo mode used when calculating the modulus: a mod n.
  // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
  // The remainder (r) is calculated as: r = a - n * q.
  //
  // UP         0 The remainder is positive if the dividend is negative, else is negative.
  // DOWN       1 The remainder has the same sign as the dividend (JavaScript %).
  // FLOOR      3 The remainder has the same sign as the divisor (Python %).
  // HALF_EVEN  6 The IEEE 754 remainder function.
  // EUCLID     9 Euclidian division. q = sign(n) * floor(a / abs(n)). Always positive.
  //
  // Truncated division (1), floored division (3), the IEEE 754 remainder (6), and Euclidian
  // division (9) are commonly used for the modulus operation. The other rounding modes can also
  // be used, but they may not give useful results.
  modulo: 1,
  // 0 to 9
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -EXP_LIMIT
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to EXP_LIMIT
  // The minimum exponent value, beneath which underflow to zero occurs.
  // JavaScript numbers: -324  (5e-324)
  minE: -EXP_LIMIT,
  // -1 to -EXP_LIMIT
  // The maximum exponent value, above which overflow to Infinity occurs.
  // JavaScript numbers: 308  (1.7976931348623157e+308)
  maxE: EXP_LIMIT,
  // 1 to EXP_LIMIT
  // Whether to use cryptographically-secure random number generation, if available.
  crypto: !1
  // true/false
}, inexact, quadrant, external = !0, decimalError = "[DecimalError] ", invalidArgument = decimalError + "Invalid argument: ", precisionLimitExceeded = decimalError + "Precision limit exceeded", cryptoUnavailable = decimalError + "crypto unavailable", tag = "[object Decimal]", mathfloor = Math.floor, mathpow = Math.pow, isBinary = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i, isHex = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i, isOctal = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, LN10_PRECISION = LN10.length - 1, PI_PRECISION = PI.length - 1, P$1 = { toStringTag: tag };
P$1.absoluteValue = P$1.abs = function() {
  var t = new this.constructor(this);
  return t.s < 0 && (t.s = 1), finalise(t);
};
P$1.ceil = function() {
  return finalise(new this.constructor(this), this.e + 1, 2);
};
P$1.clampedTo = P$1.clamp = function(t, r) {
  var n, a = this, s = a.constructor;
  if (t = new s(t), r = new s(r), !t.s || !r.s) return new s(NaN);
  if (t.gt(r)) throw Error(invalidArgument + r);
  return n = a.cmp(t), n < 0 ? t : a.cmp(r) > 0 ? r : new s(a);
};
P$1.comparedTo = P$1.cmp = function(t) {
  var r, n, a, s, o = this, l = o.d, x = (t = new o.constructor(t)).d, j = o.s, Z = t.s;
  if (!l || !x)
    return !j || !Z ? NaN : j !== Z ? j : l === x ? 0 : !l ^ j < 0 ? 1 : -1;
  if (!l[0] || !x[0]) return l[0] ? j : x[0] ? -Z : 0;
  if (j !== Z) return j;
  if (o.e !== t.e) return o.e > t.e ^ j < 0 ? 1 : -1;
  for (a = l.length, s = x.length, r = 0, n = a < s ? a : s; r < n; ++r)
    if (l[r] !== x[r]) return l[r] > x[r] ^ j < 0 ? 1 : -1;
  return a === s ? 0 : a > s ^ j < 0 ? 1 : -1;
};
P$1.cosine = P$1.cos = function() {
  var t, r, n = this, a = n.constructor;
  return n.d ? n.d[0] ? (t = a.precision, r = a.rounding, a.precision = t + Math.max(n.e, n.sd()) + LOG_BASE, a.rounding = 1, n = cosine(a, toLessThanHalfPi(a, n)), a.precision = t, a.rounding = r, finalise(quadrant == 2 || quadrant == 3 ? n.neg() : n, t, r, !0)) : new a(1) : new a(NaN);
};
P$1.cubeRoot = P$1.cbrt = function() {
  var t, r, n, a, s, o, l, x, j, Z, V = this, $ = V.constructor;
  if (!V.isFinite() || V.isZero()) return new $(V);
  for (external = !1, o = V.s * mathpow(V.s * V, 1 / 3), !o || Math.abs(o) == 1 / 0 ? (n = digitsToString(V.d), t = V.e, (o = (t - n.length + 1) % 3) && (n += o == 1 || o == -2 ? "0" : "00"), o = mathpow(n, 1 / 3), t = mathfloor((t + 1) / 3) - (t % 3 == (t < 0 ? -1 : 2)), o == 1 / 0 ? n = "5e" + t : (n = o.toExponential(), n = n.slice(0, n.indexOf("e") + 1) + t), a = new $(n), a.s = V.s) : a = new $(o.toString()), l = (t = $.precision) + 3; ; )
    if (x = a, j = x.times(x).times(x), Z = j.plus(V), a = divide(Z.plus(V).times(x), Z.plus(j), l + 2, 1), digitsToString(x.d).slice(0, l) === (n = digitsToString(a.d)).slice(0, l))
      if (n = n.slice(l - 3, l + 1), n == "9999" || !s && n == "4999") {
        if (!s && (finalise(x, t + 1, 0), x.times(x).times(x).eq(V))) {
          a = x;
          break;
        }
        l += 4, s = 1;
      } else {
        (!+n || !+n.slice(1) && n.charAt(0) == "5") && (finalise(a, t + 1, 1), r = !a.times(a).times(a).eq(V));
        break;
      }
  return external = !0, finalise(a, t, $.rounding, r);
};
P$1.decimalPlaces = P$1.dp = function() {
  var t, r = this.d, n = NaN;
  if (r) {
    if (t = r.length - 1, n = (t - mathfloor(this.e / LOG_BASE)) * LOG_BASE, t = r[t], t) for (; t % 10 == 0; t /= 10) n--;
    n < 0 && (n = 0);
  }
  return n;
};
P$1.dividedBy = P$1.div = function(t) {
  return divide(this, new this.constructor(t));
};
P$1.dividedToIntegerBy = P$1.divToInt = function(t) {
  var r = this, n = r.constructor;
  return finalise(divide(r, new n(t), 0, 1, 1), n.precision, n.rounding);
};
P$1.equals = P$1.eq = function(t) {
  return this.cmp(t) === 0;
};
P$1.floor = function() {
  return finalise(new this.constructor(this), this.e + 1, 3);
};
P$1.greaterThan = P$1.gt = function(t) {
  return this.cmp(t) > 0;
};
P$1.greaterThanOrEqualTo = P$1.gte = function(t) {
  var r = this.cmp(t);
  return r == 1 || r === 0;
};
P$1.hyperbolicCosine = P$1.cosh = function() {
  var t, r, n, a, s, o = this, l = o.constructor, x = new l(1);
  if (!o.isFinite()) return new l(o.s ? 1 / 0 : NaN);
  if (o.isZero()) return x;
  n = l.precision, a = l.rounding, l.precision = n + Math.max(o.e, o.sd()) + 4, l.rounding = 1, s = o.d.length, s < 32 ? (t = Math.ceil(s / 3), r = (1 / tinyPow(4, t)).toString()) : (t = 16, r = "2.3283064365386962890625e-10"), o = taylorSeries(l, 1, o.times(r), new l(1), !0);
  for (var j, Z = t, V = new l(8); Z--; )
    j = o.times(o), o = x.minus(j.times(V.minus(j.times(V))));
  return finalise(o, l.precision = n, l.rounding = a, !0);
};
P$1.hyperbolicSine = P$1.sinh = function() {
  var t, r, n, a, s = this, o = s.constructor;
  if (!s.isFinite() || s.isZero()) return new o(s);
  if (r = o.precision, n = o.rounding, o.precision = r + Math.max(s.e, s.sd()) + 4, o.rounding = 1, a = s.d.length, a < 3)
    s = taylorSeries(o, 2, s, s, !0);
  else {
    t = 1.4 * Math.sqrt(a), t = t > 16 ? 16 : t | 0, s = s.times(1 / tinyPow(5, t)), s = taylorSeries(o, 2, s, s, !0);
    for (var l, x = new o(5), j = new o(16), Z = new o(20); t--; )
      l = s.times(s), s = s.times(x.plus(l.times(j.times(l).plus(Z))));
  }
  return o.precision = r, o.rounding = n, finalise(s, r, n, !0);
};
P$1.hyperbolicTangent = P$1.tanh = function() {
  var t, r, n = this, a = n.constructor;
  return n.isFinite() ? n.isZero() ? new a(n) : (t = a.precision, r = a.rounding, a.precision = t + 7, a.rounding = 1, divide(n.sinh(), n.cosh(), a.precision = t, a.rounding = r)) : new a(n.s);
};
P$1.inverseCosine = P$1.acos = function() {
  var t = this, r = t.constructor, n = t.abs().cmp(1), a = r.precision, s = r.rounding;
  return n !== -1 ? n === 0 ? t.isNeg() ? getPi(r, a, s) : new r(0) : new r(NaN) : t.isZero() ? getPi(r, a + 4, s).times(0.5) : (r.precision = a + 6, r.rounding = 1, t = new r(1).minus(t).div(t.plus(1)).sqrt().atan(), r.precision = a, r.rounding = s, t.times(2));
};
P$1.inverseHyperbolicCosine = P$1.acosh = function() {
  var t, r, n = this, a = n.constructor;
  return n.lte(1) ? new a(n.eq(1) ? 0 : NaN) : n.isFinite() ? (t = a.precision, r = a.rounding, a.precision = t + Math.max(Math.abs(n.e), n.sd()) + 4, a.rounding = 1, external = !1, n = n.times(n).minus(1).sqrt().plus(n), external = !0, a.precision = t, a.rounding = r, n.ln()) : new a(n);
};
P$1.inverseHyperbolicSine = P$1.asinh = function() {
  var t, r, n = this, a = n.constructor;
  return !n.isFinite() || n.isZero() ? new a(n) : (t = a.precision, r = a.rounding, a.precision = t + 2 * Math.max(Math.abs(n.e), n.sd()) + 6, a.rounding = 1, external = !1, n = n.times(n).plus(1).sqrt().plus(n), external = !0, a.precision = t, a.rounding = r, n.ln());
};
P$1.inverseHyperbolicTangent = P$1.atanh = function() {
  var t, r, n, a, s = this, o = s.constructor;
  return s.isFinite() ? s.e >= 0 ? new o(s.abs().eq(1) ? s.s / 0 : s.isZero() ? s : NaN) : (t = o.precision, r = o.rounding, a = s.sd(), Math.max(a, t) < 2 * -s.e - 1 ? finalise(new o(s), t, r, !0) : (o.precision = n = a - s.e, s = divide(s.plus(1), new o(1).minus(s), n + t, 1), o.precision = t + 4, o.rounding = 1, s = s.ln(), o.precision = t, o.rounding = r, s.times(0.5))) : new o(NaN);
};
P$1.inverseSine = P$1.asin = function() {
  var t, r, n, a, s = this, o = s.constructor;
  return s.isZero() ? new o(s) : (r = s.abs().cmp(1), n = o.precision, a = o.rounding, r !== -1 ? r === 0 ? (t = getPi(o, n + 4, a).times(0.5), t.s = s.s, t) : new o(NaN) : (o.precision = n + 6, o.rounding = 1, s = s.div(new o(1).minus(s.times(s)).sqrt().plus(1)).atan(), o.precision = n, o.rounding = a, s.times(2)));
};
P$1.inverseTangent = P$1.atan = function() {
  var t, r, n, a, s, o, l, x, j, Z = this, V = Z.constructor, $ = V.precision, X = V.rounding;
  if (Z.isFinite()) {
    if (Z.isZero())
      return new V(Z);
    if (Z.abs().eq(1) && $ + 4 <= PI_PRECISION)
      return l = getPi(V, $ + 4, X).times(0.25), l.s = Z.s, l;
  } else {
    if (!Z.s) return new V(NaN);
    if ($ + 4 <= PI_PRECISION)
      return l = getPi(V, $ + 4, X).times(0.5), l.s = Z.s, l;
  }
  for (V.precision = x = $ + 10, V.rounding = 1, n = Math.min(28, x / LOG_BASE + 2 | 0), t = n; t; --t) Z = Z.div(Z.times(Z).plus(1).sqrt().plus(1));
  for (external = !1, r = Math.ceil(x / LOG_BASE), a = 1, j = Z.times(Z), l = new V(Z), s = Z; t !== -1; )
    if (s = s.times(j), o = l.minus(s.div(a += 2)), s = s.times(j), l = o.plus(s.div(a += 2)), l.d[r] !== void 0) for (t = r; l.d[t] === o.d[t] && t--; ) ;
  return n && (l = l.times(2 << n - 1)), external = !0, finalise(l, V.precision = $, V.rounding = X, !0);
};
P$1.isFinite = function() {
  return !!this.d;
};
P$1.isInteger = P$1.isInt = function() {
  return !!this.d && mathfloor(this.e / LOG_BASE) > this.d.length - 2;
};
P$1.isNaN = function() {
  return !this.s;
};
P$1.isNegative = P$1.isNeg = function() {
  return this.s < 0;
};
P$1.isPositive = P$1.isPos = function() {
  return this.s > 0;
};
P$1.isZero = function() {
  return !!this.d && this.d[0] === 0;
};
P$1.lessThan = P$1.lt = function(t) {
  return this.cmp(t) < 0;
};
P$1.lessThanOrEqualTo = P$1.lte = function(t) {
  return this.cmp(t) < 1;
};
P$1.logarithm = P$1.log = function(t) {
  var r, n, a, s, o, l, x, j, Z = this, V = Z.constructor, $ = V.precision, X = V.rounding, W = 5;
  if (t == null)
    t = new V(10), r = !0;
  else {
    if (t = new V(t), n = t.d, t.s < 0 || !n || !n[0] || t.eq(1)) return new V(NaN);
    r = t.eq(10);
  }
  if (n = Z.d, Z.s < 0 || !n || !n[0] || Z.eq(1))
    return new V(n && !n[0] ? -1 / 0 : Z.s != 1 ? NaN : n ? 0 : 1 / 0);
  if (r)
    if (n.length > 1)
      o = !0;
    else {
      for (s = n[0]; s % 10 === 0; ) s /= 10;
      o = s !== 1;
    }
  if (external = !1, x = $ + W, l = naturalLogarithm(Z, x), a = r ? getLn10(V, x + 10) : naturalLogarithm(t, x), j = divide(l, a, x, 1), checkRoundingDigits(j.d, s = $, X))
    do
      if (x += 10, l = naturalLogarithm(Z, x), a = r ? getLn10(V, x + 10) : naturalLogarithm(t, x), j = divide(l, a, x, 1), !o) {
        +digitsToString(j.d).slice(s + 1, s + 15) + 1 == 1e14 && (j = finalise(j, $ + 1, 0));
        break;
      }
    while (checkRoundingDigits(j.d, s += 10, X));
  return external = !0, finalise(j, $, X);
};
P$1.minus = P$1.sub = function(t) {
  var r, n, a, s, o, l, x, j, Z, V, $, X, W = this, Y = W.constructor;
  if (t = new Y(t), !W.d || !t.d)
    return !W.s || !t.s ? t = new Y(NaN) : W.d ? t.s = -t.s : t = new Y(t.d || W.s !== t.s ? W : NaN), t;
  if (W.s != t.s)
    return t.s = -t.s, W.plus(t);
  if (Z = W.d, X = t.d, x = Y.precision, j = Y.rounding, !Z[0] || !X[0]) {
    if (X[0]) t.s = -t.s;
    else if (Z[0]) t = new Y(W);
    else return new Y(j === 3 ? -0 : 0);
    return external ? finalise(t, x, j) : t;
  }
  if (n = mathfloor(t.e / LOG_BASE), V = mathfloor(W.e / LOG_BASE), Z = Z.slice(), o = V - n, o) {
    for ($ = o < 0, $ ? (r = Z, o = -o, l = X.length) : (r = X, n = V, l = Z.length), a = Math.max(Math.ceil(x / LOG_BASE), l) + 2, o > a && (o = a, r.length = 1), r.reverse(), a = o; a--; ) r.push(0);
    r.reverse();
  } else {
    for (a = Z.length, l = X.length, $ = a < l, $ && (l = a), a = 0; a < l; a++)
      if (Z[a] != X[a]) {
        $ = Z[a] < X[a];
        break;
      }
    o = 0;
  }
  for ($ && (r = Z, Z = X, X = r, t.s = -t.s), l = Z.length, a = X.length - l; a > 0; --a) Z[l++] = 0;
  for (a = X.length; a > o; ) {
    if (Z[--a] < X[a]) {
      for (s = a; s && Z[--s] === 0; ) Z[s] = BASE - 1;
      --Z[s], Z[a] += BASE;
    }
    Z[a] -= X[a];
  }
  for (; Z[--l] === 0; ) Z.pop();
  for (; Z[0] === 0; Z.shift()) --n;
  return Z[0] ? (t.d = Z, t.e = getBase10Exponent(Z, n), external ? finalise(t, x, j) : t) : new Y(j === 3 ? -0 : 0);
};
P$1.modulo = P$1.mod = function(t) {
  var r, n = this, a = n.constructor;
  return t = new a(t), !n.d || !t.s || t.d && !t.d[0] ? new a(NaN) : !t.d || n.d && !n.d[0] ? finalise(new a(n), a.precision, a.rounding) : (external = !1, a.modulo == 9 ? (r = divide(n, t.abs(), 0, 3, 1), r.s *= t.s) : r = divide(n, t, 0, a.modulo, 1), r = r.times(t), external = !0, n.minus(r));
};
P$1.naturalExponential = P$1.exp = function() {
  return naturalExponential(this);
};
P$1.naturalLogarithm = P$1.ln = function() {
  return naturalLogarithm(this);
};
P$1.negated = P$1.neg = function() {
  var t = new this.constructor(this);
  return t.s = -t.s, finalise(t);
};
P$1.plus = P$1.add = function(t) {
  var r, n, a, s, o, l, x, j, Z, V, $ = this, X = $.constructor;
  if (t = new X(t), !$.d || !t.d)
    return !$.s || !t.s ? t = new X(NaN) : $.d || (t = new X(t.d || $.s === t.s ? $ : NaN)), t;
  if ($.s != t.s)
    return t.s = -t.s, $.minus(t);
  if (Z = $.d, V = t.d, x = X.precision, j = X.rounding, !Z[0] || !V[0])
    return V[0] || (t = new X($)), external ? finalise(t, x, j) : t;
  if (o = mathfloor($.e / LOG_BASE), a = mathfloor(t.e / LOG_BASE), Z = Z.slice(), s = o - a, s) {
    for (s < 0 ? (n = Z, s = -s, l = V.length) : (n = V, a = o, l = Z.length), o = Math.ceil(x / LOG_BASE), l = o > l ? o + 1 : l + 1, s > l && (s = l, n.length = 1), n.reverse(); s--; ) n.push(0);
    n.reverse();
  }
  for (l = Z.length, s = V.length, l - s < 0 && (s = l, n = V, V = Z, Z = n), r = 0; s; )
    r = (Z[--s] = Z[s] + V[s] + r) / BASE | 0, Z[s] %= BASE;
  for (r && (Z.unshift(r), ++a), l = Z.length; Z[--l] == 0; ) Z.pop();
  return t.d = Z, t.e = getBase10Exponent(Z, a), external ? finalise(t, x, j) : t;
};
P$1.precision = P$1.sd = function(t) {
  var r, n = this;
  if (t !== void 0 && t !== !!t && t !== 1 && t !== 0) throw Error(invalidArgument + t);
  return n.d ? (r = getPrecision(n.d), t && n.e + 1 > r && (r = n.e + 1)) : r = NaN, r;
};
P$1.round = function() {
  var t = this, r = t.constructor;
  return finalise(new r(t), t.e + 1, r.rounding);
};
P$1.sine = P$1.sin = function() {
  var t, r, n = this, a = n.constructor;
  return n.isFinite() ? n.isZero() ? new a(n) : (t = a.precision, r = a.rounding, a.precision = t + Math.max(n.e, n.sd()) + LOG_BASE, a.rounding = 1, n = sine(a, toLessThanHalfPi(a, n)), a.precision = t, a.rounding = r, finalise(quadrant > 2 ? n.neg() : n, t, r, !0)) : new a(NaN);
};
P$1.squareRoot = P$1.sqrt = function() {
  var t, r, n, a, s, o, l = this, x = l.d, j = l.e, Z = l.s, V = l.constructor;
  if (Z !== 1 || !x || !x[0])
    return new V(!Z || Z < 0 && (!x || x[0]) ? NaN : x ? l : 1 / 0);
  for (external = !1, Z = Math.sqrt(+l), Z == 0 || Z == 1 / 0 ? (r = digitsToString(x), (r.length + j) % 2 == 0 && (r += "0"), Z = Math.sqrt(r), j = mathfloor((j + 1) / 2) - (j < 0 || j % 2), Z == 1 / 0 ? r = "5e" + j : (r = Z.toExponential(), r = r.slice(0, r.indexOf("e") + 1) + j), a = new V(r)) : a = new V(Z.toString()), n = (j = V.precision) + 3; ; )
    if (o = a, a = o.plus(divide(l, o, n + 2, 1)).times(0.5), digitsToString(o.d).slice(0, n) === (r = digitsToString(a.d)).slice(0, n))
      if (r = r.slice(n - 3, n + 1), r == "9999" || !s && r == "4999") {
        if (!s && (finalise(o, j + 1, 0), o.times(o).eq(l))) {
          a = o;
          break;
        }
        n += 4, s = 1;
      } else {
        (!+r || !+r.slice(1) && r.charAt(0) == "5") && (finalise(a, j + 1, 1), t = !a.times(a).eq(l));
        break;
      }
  return external = !0, finalise(a, j, V.rounding, t);
};
P$1.tangent = P$1.tan = function() {
  var t, r, n = this, a = n.constructor;
  return n.isFinite() ? n.isZero() ? new a(n) : (t = a.precision, r = a.rounding, a.precision = t + 10, a.rounding = 1, n = n.sin(), n.s = 1, n = divide(n, new a(1).minus(n.times(n)).sqrt(), t + 10, 0), a.precision = t, a.rounding = r, finalise(quadrant == 2 || quadrant == 4 ? n.neg() : n, t, r, !0)) : new a(NaN);
};
P$1.times = P$1.mul = function(t) {
  var r, n, a, s, o, l, x, j, Z, V = this, $ = V.constructor, X = V.d, W = (t = new $(t)).d;
  if (t.s *= V.s, !X || !X[0] || !W || !W[0])
    return new $(!t.s || X && !X[0] && !W || W && !W[0] && !X ? NaN : !X || !W ? t.s / 0 : t.s * 0);
  for (n = mathfloor(V.e / LOG_BASE) + mathfloor(t.e / LOG_BASE), j = X.length, Z = W.length, j < Z && (o = X, X = W, W = o, l = j, j = Z, Z = l), o = [], l = j + Z, a = l; a--; ) o.push(0);
  for (a = Z; --a >= 0; ) {
    for (r = 0, s = j + a; s > a; )
      x = o[s] + W[a] * X[s - a - 1] + r, o[s--] = x % BASE | 0, r = x / BASE | 0;
    o[s] = (o[s] + r) % BASE | 0;
  }
  for (; !o[--l]; ) o.pop();
  return r ? ++n : o.shift(), t.d = o, t.e = getBase10Exponent(o, n), external ? finalise(t, $.precision, $.rounding) : t;
};
P$1.toBinary = function(t, r) {
  return toStringBinary(this, 2, t, r);
};
P$1.toDecimalPlaces = P$1.toDP = function(t, r) {
  var n = this, a = n.constructor;
  return n = new a(n), t === void 0 ? n : (checkInt32(t, 0, MAX_DIGITS), r === void 0 ? r = a.rounding : checkInt32(r, 0, 8), finalise(n, t + n.e + 1, r));
};
P$1.toExponential = function(t, r) {
  var n, a = this, s = a.constructor;
  return t === void 0 ? n = finiteToString(a, !0) : (checkInt32(t, 0, MAX_DIGITS), r === void 0 ? r = s.rounding : checkInt32(r, 0, 8), a = finalise(new s(a), t + 1, r), n = finiteToString(a, !0, t + 1)), a.isNeg() && !a.isZero() ? "-" + n : n;
};
P$1.toFixed = function(t, r) {
  var n, a, s = this, o = s.constructor;
  return t === void 0 ? n = finiteToString(s) : (checkInt32(t, 0, MAX_DIGITS), r === void 0 ? r = o.rounding : checkInt32(r, 0, 8), a = finalise(new o(s), t + s.e + 1, r), n = finiteToString(a, !1, t + a.e + 1)), s.isNeg() && !s.isZero() ? "-" + n : n;
};
P$1.toFraction = function(t) {
  var r, n, a, s, o, l, x, j, Z, V, $, X, W = this, Y = W.d, U = W.constructor;
  if (!Y) return new U(W);
  if (Z = n = new U(1), a = j = new U(0), r = new U(a), o = r.e = getPrecision(Y) - W.e - 1, l = o % LOG_BASE, r.d[0] = mathpow(10, l < 0 ? LOG_BASE + l : l), t == null)
    t = o > 0 ? r : Z;
  else {
    if (x = new U(t), !x.isInt() || x.lt(Z)) throw Error(invalidArgument + x);
    t = x.gt(r) ? o > 0 ? r : Z : x;
  }
  for (external = !1, x = new U(digitsToString(Y)), V = U.precision, U.precision = o = Y.length * LOG_BASE * 2; $ = divide(x, r, 0, 1, 1), s = n.plus($.times(a)), s.cmp(t) != 1; )
    n = a, a = s, s = Z, Z = j.plus($.times(s)), j = s, s = r, r = x.minus($.times(s)), x = s;
  return s = divide(t.minus(n), a, 0, 1, 1), j = j.plus(s.times(Z)), n = n.plus(s.times(a)), j.s = Z.s = W.s, X = divide(Z, a, o, 1).minus(W).abs().cmp(divide(j, n, o, 1).minus(W).abs()) < 1 ? [Z, a] : [j, n], U.precision = V, external = !0, X;
};
P$1.toHexadecimal = P$1.toHex = function(t, r) {
  return toStringBinary(this, 16, t, r);
};
P$1.toNearest = function(t, r) {
  var n = this, a = n.constructor;
  if (n = new a(n), t == null) {
    if (!n.d) return n;
    t = new a(1), r = a.rounding;
  } else {
    if (t = new a(t), r === void 0 ? r = a.rounding : checkInt32(r, 0, 8), !n.d) return t.s ? n : t;
    if (!t.d)
      return t.s && (t.s = n.s), t;
  }
  return t.d[0] ? (external = !1, n = divide(n, t, 0, r, 1).times(t), external = !0, finalise(n)) : (t.s = n.s, n = t), n;
};
P$1.toNumber = function() {
  return +this;
};
P$1.toOctal = function(t, r) {
  return toStringBinary(this, 8, t, r);
};
P$1.toPower = P$1.pow = function(t) {
  var r, n, a, s, o, l, x = this, j = x.constructor, Z = +(t = new j(t));
  if (!x.d || !t.d || !x.d[0] || !t.d[0]) return new j(mathpow(+x, Z));
  if (x = new j(x), x.eq(1)) return x;
  if (a = j.precision, o = j.rounding, t.eq(1)) return finalise(x, a, o);
  if (r = mathfloor(t.e / LOG_BASE), r >= t.d.length - 1 && (n = Z < 0 ? -Z : Z) <= MAX_SAFE_INTEGER)
    return s = intPow(j, x, n, a), t.s < 0 ? new j(1).div(s) : finalise(s, a, o);
  if (l = x.s, l < 0) {
    if (r < t.d.length - 1) return new j(NaN);
    if ((t.d[r] & 1) == 0 && (l = 1), x.e == 0 && x.d[0] == 1 && x.d.length == 1)
      return x.s = l, x;
  }
  return n = mathpow(+x, Z), r = n == 0 || !isFinite(n) ? mathfloor(Z * (Math.log("0." + digitsToString(x.d)) / Math.LN10 + x.e + 1)) : new j(n + "").e, r > j.maxE + 1 || r < j.minE - 1 ? new j(r > 0 ? l / 0 : 0) : (external = !1, j.rounding = x.s = 1, n = Math.min(12, (r + "").length), s = naturalExponential(t.times(naturalLogarithm(x, a + n)), a), s.d && (s = finalise(s, a + 5, 1), checkRoundingDigits(s.d, a, o) && (r = a + 10, s = finalise(naturalExponential(t.times(naturalLogarithm(x, r + n)), r), r + 5, 1), +digitsToString(s.d).slice(a + 1, a + 15) + 1 == 1e14 && (s = finalise(s, a + 1, 0)))), s.s = l, external = !0, j.rounding = o, finalise(s, a, o));
};
P$1.toPrecision = function(t, r) {
  var n, a = this, s = a.constructor;
  return t === void 0 ? n = finiteToString(a, a.e <= s.toExpNeg || a.e >= s.toExpPos) : (checkInt32(t, 1, MAX_DIGITS), r === void 0 ? r = s.rounding : checkInt32(r, 0, 8), a = finalise(new s(a), t, r), n = finiteToString(a, t <= a.e || a.e <= s.toExpNeg, t)), a.isNeg() && !a.isZero() ? "-" + n : n;
};
P$1.toSignificantDigits = P$1.toSD = function(t, r) {
  var n = this, a = n.constructor;
  return t === void 0 ? (t = a.precision, r = a.rounding) : (checkInt32(t, 1, MAX_DIGITS), r === void 0 ? r = a.rounding : checkInt32(r, 0, 8)), finalise(new a(n), t, r);
};
P$1.toString = function() {
  var t = this, r = t.constructor, n = finiteToString(t, t.e <= r.toExpNeg || t.e >= r.toExpPos);
  return t.isNeg() && !t.isZero() ? "-" + n : n;
};
P$1.truncated = P$1.trunc = function() {
  return finalise(new this.constructor(this), this.e + 1, 1);
};
P$1.valueOf = P$1.toJSON = function() {
  var t = this, r = t.constructor, n = finiteToString(t, t.e <= r.toExpNeg || t.e >= r.toExpPos);
  return t.isNeg() ? "-" + n : n;
};
function digitsToString(t) {
  var r, n, a, s = t.length - 1, o = "", l = t[0];
  if (s > 0) {
    for (o += l, r = 1; r < s; r++)
      a = t[r] + "", n = LOG_BASE - a.length, n && (o += getZeroString(n)), o += a;
    l = t[r], a = l + "", n = LOG_BASE - a.length, n && (o += getZeroString(n));
  } else if (l === 0)
    return "0";
  for (; l % 10 === 0; ) l /= 10;
  return o + l;
}
function checkInt32(t, r, n) {
  if (t !== ~~t || t < r || t > n)
    throw Error(invalidArgument + t);
}
function checkRoundingDigits(t, r, n, a) {
  var s, o, l, x;
  for (o = t[0]; o >= 10; o /= 10) --r;
  return --r < 0 ? (r += LOG_BASE, s = 0) : (s = Math.ceil((r + 1) / LOG_BASE), r %= LOG_BASE), o = mathpow(10, LOG_BASE - r), x = t[s] % o | 0, a == null ? r < 3 ? (r == 0 ? x = x / 100 | 0 : r == 1 && (x = x / 10 | 0), l = n < 4 && x == 99999 || n > 3 && x == 49999 || x == 5e4 || x == 0) : l = (n < 4 && x + 1 == o || n > 3 && x + 1 == o / 2) && (t[s + 1] / o / 100 | 0) == mathpow(10, r - 2) - 1 || (x == o / 2 || x == 0) && (t[s + 1] / o / 100 | 0) == 0 : r < 4 ? (r == 0 ? x = x / 1e3 | 0 : r == 1 ? x = x / 100 | 0 : r == 2 && (x = x / 10 | 0), l = (a || n < 4) && x == 9999 || !a && n > 3 && x == 4999) : l = ((a || n < 4) && x + 1 == o || !a && n > 3 && x + 1 == o / 2) && (t[s + 1] / o / 1e3 | 0) == mathpow(10, r - 3) - 1, l;
}
function convertBase(t, r, n) {
  for (var a, s = [0], o, l = 0, x = t.length; l < x; ) {
    for (o = s.length; o--; ) s[o] *= r;
    for (s[0] += NUMERALS.indexOf(t.charAt(l++)), a = 0; a < s.length; a++)
      s[a] > n - 1 && (s[a + 1] === void 0 && (s[a + 1] = 0), s[a + 1] += s[a] / n | 0, s[a] %= n);
  }
  return s.reverse();
}
function cosine(t, r) {
  var n, a, s;
  if (r.isZero()) return r;
  a = r.d.length, a < 32 ? (n = Math.ceil(a / 3), s = (1 / tinyPow(4, n)).toString()) : (n = 16, s = "2.3283064365386962890625e-10"), t.precision += n, r = taylorSeries(t, 1, r.times(s), new t(1));
  for (var o = n; o--; ) {
    var l = r.times(r);
    r = l.times(l).minus(l).times(8).plus(1);
  }
  return t.precision -= n, r;
}
var divide = /* @__PURE__ */ (function() {
  function t(a, s, o) {
    var l, x = 0, j = a.length;
    for (a = a.slice(); j--; )
      l = a[j] * s + x, a[j] = l % o | 0, x = l / o | 0;
    return x && a.unshift(x), a;
  }
  function r(a, s, o, l) {
    var x, j;
    if (o != l)
      j = o > l ? 1 : -1;
    else
      for (x = j = 0; x < o; x++)
        if (a[x] != s[x]) {
          j = a[x] > s[x] ? 1 : -1;
          break;
        }
    return j;
  }
  function n(a, s, o, l) {
    for (var x = 0; o--; )
      a[o] -= x, x = a[o] < s[o] ? 1 : 0, a[o] = x * l + a[o] - s[o];
    for (; !a[0] && a.length > 1; ) a.shift();
  }
  return function(a, s, o, l, x, j) {
    var Z, V, $, X, W, Y, U, G, K, J, ee, te, re, ae, ie, ce, he, oe, le, pe, de = a.constructor, se = a.s == s.s ? 1 : -1, ue = a.d, fe = s.d;
    if (!ue || !ue[0] || !fe || !fe[0])
      return new de(
        // Return NaN if either NaN, or both Infinity or 0.
        !a.s || !s.s || (ue ? fe && ue[0] == fe[0] : !fe) ? NaN : (
          // Return ±0 if x is 0 or y is ±Infinity, or return ±Infinity as y is 0.
          ue && ue[0] == 0 || !fe ? se * 0 : se / 0
        )
      );
    for (j ? (W = 1, V = a.e - s.e) : (j = BASE, W = LOG_BASE, V = mathfloor(a.e / W) - mathfloor(s.e / W)), le = fe.length, he = ue.length, K = new de(se), J = K.d = [], $ = 0; fe[$] == (ue[$] || 0); $++) ;
    if (fe[$] > (ue[$] || 0) && V--, o == null ? (ae = o = de.precision, l = de.rounding) : x ? ae = o + (a.e - s.e) + 1 : ae = o, ae < 0)
      J.push(1), Y = !0;
    else {
      if (ae = ae / W + 2 | 0, $ = 0, le == 1) {
        for (X = 0, fe = fe[0], ae++; ($ < he || X) && ae--; $++)
          ie = X * j + (ue[$] || 0), J[$] = ie / fe | 0, X = ie % fe | 0;
        Y = X || $ < he;
      } else {
        for (X = j / (fe[0] + 1) | 0, X > 1 && (fe = t(fe, X, j), ue = t(ue, X, j), le = fe.length, he = ue.length), ce = le, ee = ue.slice(0, le), te = ee.length; te < le; ) ee[te++] = 0;
        pe = fe.slice(), pe.unshift(0), oe = fe[0], fe[1] >= j / 2 && ++oe;
        do
          X = 0, Z = r(fe, ee, le, te), Z < 0 ? (re = ee[0], le != te && (re = re * j + (ee[1] || 0)), X = re / oe | 0, X > 1 ? (X >= j && (X = j - 1), U = t(fe, X, j), G = U.length, te = ee.length, Z = r(U, ee, G, te), Z == 1 && (X--, n(U, le < G ? pe : fe, G, j))) : (X == 0 && (Z = X = 1), U = fe.slice()), G = U.length, G < te && U.unshift(0), n(ee, U, te, j), Z == -1 && (te = ee.length, Z = r(fe, ee, le, te), Z < 1 && (X++, n(ee, le < te ? pe : fe, te, j))), te = ee.length) : Z === 0 && (X++, ee = [0]), J[$++] = X, Z && ee[0] ? ee[te++] = ue[ce] || 0 : (ee = [ue[ce]], te = 1);
        while ((ce++ < he || ee[0] !== void 0) && ae--);
        Y = ee[0] !== void 0;
      }
      J[0] || J.shift();
    }
    if (W == 1)
      K.e = V, inexact = Y;
    else {
      for ($ = 1, X = J[0]; X >= 10; X /= 10) $++;
      K.e = $ + V * W - 1, finalise(K, x ? o + K.e + 1 : o, l, Y);
    }
    return K;
  };
})();
function finalise(t, r, n, a) {
  var s, o, l, x, j, Z, V, $, X, W = t.constructor;
  e: if (r != null) {
    if ($ = t.d, !$) return t;
    for (s = 1, x = $[0]; x >= 10; x /= 10) s++;
    if (o = r - s, o < 0)
      o += LOG_BASE, l = r, V = $[X = 0], j = V / mathpow(10, s - l - 1) % 10 | 0;
    else if (X = Math.ceil((o + 1) / LOG_BASE), x = $.length, X >= x)
      if (a) {
        for (; x++ <= X; ) $.push(0);
        V = j = 0, s = 1, o %= LOG_BASE, l = o - LOG_BASE + 1;
      } else
        break e;
    else {
      for (V = x = $[X], s = 1; x >= 10; x /= 10) s++;
      o %= LOG_BASE, l = o - LOG_BASE + s, j = l < 0 ? 0 : V / mathpow(10, s - l - 1) % 10 | 0;
    }
    if (a = a || r < 0 || $[X + 1] !== void 0 || (l < 0 ? V : V % mathpow(10, s - l - 1)), Z = n < 4 ? (j || a) && (n == 0 || n == (t.s < 0 ? 3 : 2)) : j > 5 || j == 5 && (n == 4 || a || n == 6 && // Check whether the digit to the left of the rounding digit is odd.
    (o > 0 ? l > 0 ? V / mathpow(10, s - l) : 0 : $[X - 1]) % 10 & 1 || n == (t.s < 0 ? 8 : 7)), r < 1 || !$[0])
      return $.length = 0, Z ? (r -= t.e + 1, $[0] = mathpow(10, (LOG_BASE - r % LOG_BASE) % LOG_BASE), t.e = -r || 0) : $[0] = t.e = 0, t;
    if (o == 0 ? ($.length = X, x = 1, X--) : ($.length = X + 1, x = mathpow(10, LOG_BASE - o), $[X] = l > 0 ? (V / mathpow(10, s - l) % mathpow(10, l) | 0) * x : 0), Z)
      for (; ; )
        if (X == 0) {
          for (o = 1, l = $[0]; l >= 10; l /= 10) o++;
          for (l = $[0] += x, x = 1; l >= 10; l /= 10) x++;
          o != x && (t.e++, $[0] == BASE && ($[0] = 1));
          break;
        } else {
          if ($[X] += x, $[X] != BASE) break;
          $[X--] = 0, x = 1;
        }
    for (o = $.length; $[--o] === 0; ) $.pop();
  }
  return external && (t.e > W.maxE ? (t.d = null, t.e = NaN) : t.e < W.minE && (t.e = 0, t.d = [0])), t;
}
function finiteToString(t, r, n) {
  if (!t.isFinite()) return nonFiniteToString(t);
  var a, s = t.e, o = digitsToString(t.d), l = o.length;
  return r ? (n && (a = n - l) > 0 ? o = o.charAt(0) + "." + o.slice(1) + getZeroString(a) : l > 1 && (o = o.charAt(0) + "." + o.slice(1)), o = o + (t.e < 0 ? "e" : "e+") + t.e) : s < 0 ? (o = "0." + getZeroString(-s - 1) + o, n && (a = n - l) > 0 && (o += getZeroString(a))) : s >= l ? (o += getZeroString(s + 1 - l), n && (a = n - s - 1) > 0 && (o = o + "." + getZeroString(a))) : ((a = s + 1) < l && (o = o.slice(0, a) + "." + o.slice(a)), n && (a = n - l) > 0 && (s + 1 === l && (o += "."), o += getZeroString(a))), o;
}
function getBase10Exponent(t, r) {
  var n = t[0];
  for (r *= LOG_BASE; n >= 10; n /= 10) r++;
  return r;
}
function getLn10(t, r, n) {
  if (r > LN10_PRECISION)
    throw external = !0, n && (t.precision = n), Error(precisionLimitExceeded);
  return finalise(new t(LN10), r, 1, !0);
}
function getPi(t, r, n) {
  if (r > PI_PRECISION) throw Error(precisionLimitExceeded);
  return finalise(new t(PI), r, n, !0);
}
function getPrecision(t) {
  var r = t.length - 1, n = r * LOG_BASE + 1;
  if (r = t[r], r) {
    for (; r % 10 == 0; r /= 10) n--;
    for (r = t[0]; r >= 10; r /= 10) n++;
  }
  return n;
}
function getZeroString(t) {
  for (var r = ""; t--; ) r += "0";
  return r;
}
function intPow(t, r, n, a) {
  var s, o = new t(1), l = Math.ceil(a / LOG_BASE + 4);
  for (external = !1; ; ) {
    if (n % 2 && (o = o.times(r), truncate(o.d, l) && (s = !0)), n = mathfloor(n / 2), n === 0) {
      n = o.d.length - 1, s && o.d[n] === 0 && ++o.d[n];
      break;
    }
    r = r.times(r), truncate(r.d, l);
  }
  return external = !0, o;
}
function isOdd(t) {
  return t.d[t.d.length - 1] & 1;
}
function maxOrMin(t, r, n) {
  for (var a, s, o = new t(r[0]), l = 0; ++l < r.length; ) {
    if (s = new t(r[l]), !s.s) {
      o = s;
      break;
    }
    a = o.cmp(s), (a === n || a === 0 && o.s === n) && (o = s);
  }
  return o;
}
function naturalExponential(t, r) {
  var n, a, s, o, l, x, j, Z = 0, V = 0, $ = 0, X = t.constructor, W = X.rounding, Y = X.precision;
  if (!t.d || !t.d[0] || t.e > 17)
    return new X(t.d ? t.d[0] ? t.s < 0 ? 0 : 1 / 0 : 1 : t.s ? t.s < 0 ? 0 : t : NaN);
  for (r == null ? (external = !1, j = Y) : j = r, x = new X(0.03125); t.e > -2; )
    t = t.times(x), $ += 5;
  for (a = Math.log(mathpow(2, $)) / Math.LN10 * 2 + 5 | 0, j += a, n = o = l = new X(1), X.precision = j; ; ) {
    if (o = finalise(o.times(t), j, 1), n = n.times(++V), x = l.plus(divide(o, n, j, 1)), digitsToString(x.d).slice(0, j) === digitsToString(l.d).slice(0, j)) {
      for (s = $; s--; ) l = finalise(l.times(l), j, 1);
      if (r == null)
        if (Z < 3 && checkRoundingDigits(l.d, j - a, W, Z))
          X.precision = j += 10, n = o = x = new X(1), V = 0, Z++;
        else
          return finalise(l, X.precision = Y, W, external = !0);
      else
        return X.precision = Y, l;
    }
    l = x;
  }
}
function naturalLogarithm(t, r) {
  var n, a, s, o, l, x, j, Z, V, $, X, W = 1, Y = 10, U = t, G = U.d, K = U.constructor, J = K.rounding, ee = K.precision;
  if (U.s < 0 || !G || !G[0] || !U.e && G[0] == 1 && G.length == 1)
    return new K(G && !G[0] ? -1 / 0 : U.s != 1 ? NaN : G ? 0 : U);
  if (r == null ? (external = !1, V = ee) : V = r, K.precision = V += Y, n = digitsToString(G), a = n.charAt(0), Math.abs(o = U.e) < 15e14) {
    for (; a < 7 && a != 1 || a == 1 && n.charAt(1) > 3; )
      U = U.times(t), n = digitsToString(U.d), a = n.charAt(0), W++;
    o = U.e, a > 1 ? (U = new K("0." + n), o++) : U = new K(a + "." + n.slice(1));
  } else
    return Z = getLn10(K, V + 2, ee).times(o + ""), U = naturalLogarithm(new K(a + "." + n.slice(1)), V - Y).plus(Z), K.precision = ee, r == null ? finalise(U, ee, J, external = !0) : U;
  for ($ = U, j = l = U = divide(U.minus(1), U.plus(1), V, 1), X = finalise(U.times(U), V, 1), s = 3; ; ) {
    if (l = finalise(l.times(X), V, 1), Z = j.plus(divide(l, new K(s), V, 1)), digitsToString(Z.d).slice(0, V) === digitsToString(j.d).slice(0, V))
      if (j = j.times(2), o !== 0 && (j = j.plus(getLn10(K, V + 2, ee).times(o + ""))), j = divide(j, new K(W), V, 1), r == null)
        if (checkRoundingDigits(j.d, V - Y, J, x))
          K.precision = V += Y, Z = l = U = divide($.minus(1), $.plus(1), V, 1), X = finalise(U.times(U), V, 1), s = x = 1;
        else
          return finalise(j, K.precision = ee, J, external = !0);
      else
        return K.precision = ee, j;
    j = Z, s += 2;
  }
}
function nonFiniteToString(t) {
  return String(t.s * t.s / 0);
}
function parseDecimal(t, r) {
  var n, a, s;
  for ((n = r.indexOf(".")) > -1 && (r = r.replace(".", "")), (a = r.search(/e/i)) > 0 ? (n < 0 && (n = a), n += +r.slice(a + 1), r = r.substring(0, a)) : n < 0 && (n = r.length), a = 0; r.charCodeAt(a) === 48; a++) ;
  for (s = r.length; r.charCodeAt(s - 1) === 48; --s) ;
  if (r = r.slice(a, s), r) {
    if (s -= a, t.e = n = n - a - 1, t.d = [], a = (n + 1) % LOG_BASE, n < 0 && (a += LOG_BASE), a < s) {
      for (a && t.d.push(+r.slice(0, a)), s -= LOG_BASE; a < s; ) t.d.push(+r.slice(a, a += LOG_BASE));
      r = r.slice(a), a = LOG_BASE - r.length;
    } else
      a -= s;
    for (; a--; ) r += "0";
    t.d.push(+r), external && (t.e > t.constructor.maxE ? (t.d = null, t.e = NaN) : t.e < t.constructor.minE && (t.e = 0, t.d = [0]));
  } else
    t.e = 0, t.d = [0];
  return t;
}
function parseOther(t, r) {
  var n, a, s, o, l, x, j, Z, V;
  if (r.indexOf("_") > -1) {
    if (r = r.replace(/(\d)_(?=\d)/g, "$1"), isDecimal.test(r)) return parseDecimal(t, r);
  } else if (r === "Infinity" || r === "NaN")
    return +r || (t.s = NaN), t.e = NaN, t.d = null, t;
  if (isHex.test(r))
    n = 16, r = r.toLowerCase();
  else if (isBinary.test(r))
    n = 2;
  else if (isOctal.test(r))
    n = 8;
  else
    throw Error(invalidArgument + r);
  for (o = r.search(/p/i), o > 0 ? (j = +r.slice(o + 1), r = r.substring(2, o)) : r = r.slice(2), o = r.indexOf("."), l = o >= 0, a = t.constructor, l && (r = r.replace(".", ""), x = r.length, o = x - o, s = intPow(a, new a(n), o, o * 2)), Z = convertBase(r, n, BASE), V = Z.length - 1, o = V; Z[o] === 0; --o) Z.pop();
  return o < 0 ? new a(t.s * 0) : (t.e = getBase10Exponent(Z, V), t.d = Z, external = !1, l && (t = divide(t, s, x * 4)), j && (t = t.times(Math.abs(j) < 54 ? mathpow(2, j) : Decimal.pow(2, j))), external = !0, t);
}
function sine(t, r) {
  var n, a = r.d.length;
  if (a < 3)
    return r.isZero() ? r : taylorSeries(t, 2, r, r);
  n = 1.4 * Math.sqrt(a), n = n > 16 ? 16 : n | 0, r = r.times(1 / tinyPow(5, n)), r = taylorSeries(t, 2, r, r);
  for (var s, o = new t(5), l = new t(16), x = new t(20); n--; )
    s = r.times(r), r = r.times(o.plus(s.times(l.times(s).minus(x))));
  return r;
}
function taylorSeries(t, r, n, a, s) {
  var o, l, x, j, Z = t.precision, V = Math.ceil(Z / LOG_BASE);
  for (external = !1, j = n.times(n), x = new t(a); ; ) {
    if (l = divide(x.times(j), new t(r++ * r++), Z, 1), x = s ? a.plus(l) : a.minus(l), a = divide(l.times(j), new t(r++ * r++), Z, 1), l = x.plus(a), l.d[V] !== void 0) {
      for (o = V; l.d[o] === x.d[o] && o--; ) ;
      if (o == -1) break;
    }
    o = x, x = a, a = l, l = o;
  }
  return external = !0, l.d.length = V + 1, l;
}
function tinyPow(t, r) {
  for (var n = t; --r; ) n *= t;
  return n;
}
function toLessThanHalfPi(t, r) {
  var n, a = r.s < 0, s = getPi(t, t.precision, 1), o = s.times(0.5);
  if (r = r.abs(), r.lte(o))
    return quadrant = a ? 4 : 1, r;
  if (n = r.divToInt(s), n.isZero())
    quadrant = a ? 3 : 2;
  else {
    if (r = r.minus(n.times(s)), r.lte(o))
      return quadrant = isOdd(n) ? a ? 2 : 3 : a ? 4 : 1, r;
    quadrant = isOdd(n) ? a ? 1 : 4 : a ? 3 : 2;
  }
  return r.minus(s).abs();
}
function toStringBinary(t, r, n, a) {
  var s, o, l, x, j, Z, V, $, X, W = t.constructor, Y = n !== void 0;
  if (Y ? (checkInt32(n, 1, MAX_DIGITS), a === void 0 ? a = W.rounding : checkInt32(a, 0, 8)) : (n = W.precision, a = W.rounding), !t.isFinite())
    V = nonFiniteToString(t);
  else {
    for (V = finiteToString(t), l = V.indexOf("."), Y ? (s = 2, r == 16 ? n = n * 4 - 3 : r == 8 && (n = n * 3 - 2)) : s = r, l >= 0 && (V = V.replace(".", ""), X = new W(1), X.e = V.length - l, X.d = convertBase(finiteToString(X), 10, s), X.e = X.d.length), $ = convertBase(V, 10, s), o = j = $.length; $[--j] == 0; ) $.pop();
    if (!$[0])
      V = Y ? "0p+0" : "0";
    else {
      if (l < 0 ? o-- : (t = new W(t), t.d = $, t.e = o, t = divide(t, X, n, a, 0, s), $ = t.d, o = t.e, Z = inexact), l = $[n], x = s / 2, Z = Z || $[n + 1] !== void 0, Z = a < 4 ? (l !== void 0 || Z) && (a === 0 || a === (t.s < 0 ? 3 : 2)) : l > x || l === x && (a === 4 || Z || a === 6 && $[n - 1] & 1 || a === (t.s < 0 ? 8 : 7)), $.length = n, Z)
        for (; ++$[--n] > s - 1; )
          $[n] = 0, n || (++o, $.unshift(1));
      for (j = $.length; !$[j - 1]; --j) ;
      for (l = 0, V = ""; l < j; l++) V += NUMERALS.charAt($[l]);
      if (Y) {
        if (j > 1)
          if (r == 16 || r == 8) {
            for (l = r == 16 ? 4 : 3, --j; j % l; j++) V += "0";
            for ($ = convertBase(V, s, r), j = $.length; !$[j - 1]; --j) ;
            for (l = 1, V = "1."; l < j; l++) V += NUMERALS.charAt($[l]);
          } else
            V = V.charAt(0) + "." + V.slice(1);
        V = V + (o < 0 ? "p" : "p+") + o;
      } else if (o < 0) {
        for (; ++o; ) V = "0" + V;
        V = "0." + V;
      } else if (++o > j) for (o -= j; o--; ) V += "0";
      else o < j && (V = V.slice(0, o) + "." + V.slice(o));
    }
    V = (r == 16 ? "0x" : r == 2 ? "0b" : r == 8 ? "0o" : "") + V;
  }
  return t.s < 0 ? "-" + V : V;
}
function truncate(t, r) {
  if (t.length > r)
    return t.length = r, !0;
}
function abs(t) {
  return new this(t).abs();
}
function acos(t) {
  return new this(t).acos();
}
function acosh(t) {
  return new this(t).acosh();
}
function add(t, r) {
  return new this(t).plus(r);
}
function asin(t) {
  return new this(t).asin();
}
function asinh(t) {
  return new this(t).asinh();
}
function atan(t) {
  return new this(t).atan();
}
function atanh(t) {
  return new this(t).atanh();
}
function atan2(t, r) {
  t = new this(t), r = new this(r);
  var n, a = this.precision, s = this.rounding, o = a + 4;
  return !t.s || !r.s ? n = new this(NaN) : !t.d && !r.d ? (n = getPi(this, o, 1).times(r.s > 0 ? 0.25 : 0.75), n.s = t.s) : !r.d || t.isZero() ? (n = r.s < 0 ? getPi(this, a, s) : new this(0), n.s = t.s) : !t.d || r.isZero() ? (n = getPi(this, o, 1).times(0.5), n.s = t.s) : r.s < 0 ? (this.precision = o, this.rounding = 1, n = this.atan(divide(t, r, o, 1)), r = getPi(this, o, 1), this.precision = a, this.rounding = s, n = t.s < 0 ? n.minus(r) : n.plus(r)) : n = this.atan(divide(t, r, o, 1)), n;
}
function cbrt(t) {
  return new this(t).cbrt();
}
function ceil(t) {
  return finalise(t = new this(t), t.e + 1, 2);
}
function clamp(t, r, n) {
  return new this(t).clamp(r, n);
}
function config(t) {
  if (!t || typeof t != "object") throw Error(decimalError + "Object expected");
  var r, n, a, s = t.defaults === !0, o = [
    "precision",
    1,
    MAX_DIGITS,
    "rounding",
    0,
    8,
    "toExpNeg",
    -EXP_LIMIT,
    0,
    "toExpPos",
    0,
    EXP_LIMIT,
    "maxE",
    0,
    EXP_LIMIT,
    "minE",
    -EXP_LIMIT,
    0,
    "modulo",
    0,
    9
  ];
  for (r = 0; r < o.length; r += 3)
    if (n = o[r], s && (this[n] = DEFAULTS[n]), (a = t[n]) !== void 0)
      if (mathfloor(a) === a && a >= o[r + 1] && a <= o[r + 2]) this[n] = a;
      else throw Error(invalidArgument + n + ": " + a);
  if (n = "crypto", s && (this[n] = DEFAULTS[n]), (a = t[n]) !== void 0)
    if (a === !0 || a === !1 || a === 0 || a === 1)
      if (a)
        if (typeof crypto != "undefined" && crypto && (crypto.getRandomValues || crypto.randomBytes))
          this[n] = !0;
        else
          throw Error(cryptoUnavailable);
      else
        this[n] = !1;
    else
      throw Error(invalidArgument + n + ": " + a);
  return this;
}
function cos(t) {
  return new this(t).cos();
}
function cosh(t) {
  return new this(t).cosh();
}
function clone(t) {
  var r, n, a;
  function s(o) {
    var l, x, j, Z = this;
    if (!(Z instanceof s)) return new s(o);
    if (Z.constructor = s, isDecimalInstance(o)) {
      Z.s = o.s, external ? !o.d || o.e > s.maxE ? (Z.e = NaN, Z.d = null) : o.e < s.minE ? (Z.e = 0, Z.d = [0]) : (Z.e = o.e, Z.d = o.d.slice()) : (Z.e = o.e, Z.d = o.d ? o.d.slice() : o.d);
      return;
    }
    if (j = typeof o, j === "number") {
      if (o === 0) {
        Z.s = 1 / o < 0 ? -1 : 1, Z.e = 0, Z.d = [0];
        return;
      }
      if (o < 0 ? (o = -o, Z.s = -1) : Z.s = 1, o === ~~o && o < 1e7) {
        for (l = 0, x = o; x >= 10; x /= 10) l++;
        external ? l > s.maxE ? (Z.e = NaN, Z.d = null) : l < s.minE ? (Z.e = 0, Z.d = [0]) : (Z.e = l, Z.d = [o]) : (Z.e = l, Z.d = [o]);
        return;
      }
      if (o * 0 !== 0) {
        o || (Z.s = NaN), Z.e = NaN, Z.d = null;
        return;
      }
      return parseDecimal(Z, o.toString());
    }
    if (j === "string")
      return (x = o.charCodeAt(0)) === 45 ? (o = o.slice(1), Z.s = -1) : (x === 43 && (o = o.slice(1)), Z.s = 1), isDecimal.test(o) ? parseDecimal(Z, o) : parseOther(Z, o);
    if (j === "bigint")
      return o < 0 ? (o = -o, Z.s = -1) : Z.s = 1, parseDecimal(Z, o.toString());
    throw Error(invalidArgument + o);
  }
  if (s.prototype = P$1, s.ROUND_UP = 0, s.ROUND_DOWN = 1, s.ROUND_CEIL = 2, s.ROUND_FLOOR = 3, s.ROUND_HALF_UP = 4, s.ROUND_HALF_DOWN = 5, s.ROUND_HALF_EVEN = 6, s.ROUND_HALF_CEIL = 7, s.ROUND_HALF_FLOOR = 8, s.EUCLID = 9, s.config = s.set = config, s.clone = clone, s.isDecimal = isDecimalInstance, s.abs = abs, s.acos = acos, s.acosh = acosh, s.add = add, s.asin = asin, s.asinh = asinh, s.atan = atan, s.atanh = atanh, s.atan2 = atan2, s.cbrt = cbrt, s.ceil = ceil, s.clamp = clamp, s.cos = cos, s.cosh = cosh, s.div = div, s.exp = exp, s.floor = floor, s.hypot = hypot, s.ln = ln, s.log = log, s.log10 = log10, s.log2 = log2, s.max = max, s.min = min, s.mod = mod, s.mul = mul, s.pow = pow, s.random = random, s.round = round, s.sign = sign, s.sin = sin, s.sinh = sinh, s.sqrt = sqrt, s.sub = sub, s.sum = sum, s.tan = tan, s.tanh = tanh, s.trunc = trunc, t === void 0 && (t = {}), t && t.defaults !== !0)
    for (a = ["precision", "rounding", "toExpNeg", "toExpPos", "maxE", "minE", "modulo", "crypto"], r = 0; r < a.length; ) t.hasOwnProperty(n = a[r++]) || (t[n] = this[n]);
  return s.config(t), s;
}
function div(t, r) {
  return new this(t).div(r);
}
function exp(t) {
  return new this(t).exp();
}
function floor(t) {
  return finalise(t = new this(t), t.e + 1, 3);
}
function hypot() {
  var t, r, n = new this(0);
  for (external = !1, t = 0; t < arguments.length; )
    if (r = new this(arguments[t++]), r.d)
      n.d && (n = n.plus(r.times(r)));
    else {
      if (r.s)
        return external = !0, new this(1 / 0);
      n = r;
    }
  return external = !0, n.sqrt();
}
function isDecimalInstance(t) {
  return t instanceof Decimal || t && t.toStringTag === tag || !1;
}
function ln(t) {
  return new this(t).ln();
}
function log(t, r) {
  return new this(t).log(r);
}
function log2(t) {
  return new this(t).log(2);
}
function log10(t) {
  return new this(t).log(10);
}
function max() {
  return maxOrMin(this, arguments, -1);
}
function min() {
  return maxOrMin(this, arguments, 1);
}
function mod(t, r) {
  return new this(t).mod(r);
}
function mul(t, r) {
  return new this(t).mul(r);
}
function pow(t, r) {
  return new this(t).pow(r);
}
function random(t) {
  var r, n, a, s, o = 0, l = new this(1), x = [];
  if (t === void 0 ? t = this.precision : checkInt32(t, 1, MAX_DIGITS), a = Math.ceil(t / LOG_BASE), this.crypto)
    if (crypto.getRandomValues)
      for (r = crypto.getRandomValues(new Uint32Array(a)); o < a; )
        s = r[o], s >= 429e7 ? r[o] = crypto.getRandomValues(new Uint32Array(1))[0] : x[o++] = s % 1e7;
    else if (crypto.randomBytes) {
      for (r = crypto.randomBytes(a *= 4); o < a; )
        s = r[o] + (r[o + 1] << 8) + (r[o + 2] << 16) + ((r[o + 3] & 127) << 24), s >= 214e7 ? crypto.randomBytes(4).copy(r, o) : (x.push(s % 1e7), o += 4);
      o = a / 4;
    } else
      throw Error(cryptoUnavailable);
  else for (; o < a; ) x[o++] = Math.random() * 1e7 | 0;
  for (a = x[--o], t %= LOG_BASE, a && t && (s = mathpow(10, LOG_BASE - t), x[o] = (a / s | 0) * s); x[o] === 0; o--) x.pop();
  if (o < 0)
    n = 0, x = [0];
  else {
    for (n = -1; x[0] === 0; n -= LOG_BASE) x.shift();
    for (a = 1, s = x[0]; s >= 10; s /= 10) a++;
    a < LOG_BASE && (n -= LOG_BASE - a);
  }
  return l.e = n, l.d = x, l;
}
function round(t) {
  return finalise(t = new this(t), t.e + 1, this.rounding);
}
function sign(t) {
  return t = new this(t), t.d ? t.d[0] ? t.s : 0 * t.s : t.s || NaN;
}
function sin(t) {
  return new this(t).sin();
}
function sinh(t) {
  return new this(t).sinh();
}
function sqrt(t) {
  return new this(t).sqrt();
}
function sub(t, r) {
  return new this(t).sub(r);
}
function sum() {
  var t = 0, r = arguments, n = new this(r[t]);
  for (external = !1; n.s && ++t < r.length; ) n = n.plus(r[t]);
  return external = !0, finalise(n, this.precision, this.rounding);
}
function tan(t) {
  return new this(t).tan();
}
function tanh(t) {
  return new this(t).tanh();
}
function trunc(t) {
  return finalise(t = new this(t), t.e + 1, 1);
}
P$1[/* @__PURE__ */ Symbol.for("nodejs.util.inspect.custom")] = P$1.toString;
P$1[Symbol.toStringTag] = "Decimal";
var Decimal = P$1.constructor = clone(DEFAULTS);
LN10 = new Decimal(LN10);
PI = new Decimal(PI);
const DEFAULT_NUMBER_DELIMITER = ",", DEFAULT_NUMBER_PARSER = (t) => {
  var s, o, l, x;
  const r = t.toString().trim().match(/-?[0-9]*\.?[0-9]*(e[0-9]*)?/), n = r == null ? void 0 : r.at(0), a = Number.parseInt((o = (s = r == null ? void 0 : r.index) == null ? void 0 : s.toString()) != null ? o : "");
  return {
    number: n != null ? n : t,
    endPosition: a !== void 0 && !Number.isNaN(a) ? a + ((x = (l = r == null ? void 0 : r.at(0)) == null ? void 0 : l.length) != null ? x : 0) : null
  };
};
class NumberValidator {
  constructor(r) {
    Mr(this, "value");
    this.value = r;
  }
  checkMin(r) {
    return r !== void 0 && (this.value = Math.max(Number(this.value), r)), this;
  }
  checkMax(r) {
    return r !== void 0 && (this.value = Math.min(Number(this.value), r)), this;
  }
  applyPrecision(r) {
    const { value: n } = this;
    return r === void 0 ? this.value = n.toString() : this.value = Number(n).toFixed(r), this;
  }
  validate() {
    const r = Number.parseFloat(this.value.toString());
    return Number.isNaN(r) || !Number.isFinite(r) || this.value === "" || this.value === null ? null : r;
  }
}
function validateNumber(t, r, n, a) {
  if (t === null)
    return null;
  const s = t.toString().trim();
  if (s === "" || /^-*\.*$/.test(s))
    return null;
  if (/^-?\.[0-9]*(e[0-9]*)?$/.test(s)) {
    const o = Number.parseFloat(s);
    return new NumberValidator(o).checkMin(r).checkMax(n).applyPrecision(a).validate();
  }
  if (/^-?[0-9]+\.?(e[0-9]*)?/.test(s)) {
    const o = Number.parseFloat(s);
    return new NumberValidator(o).checkMin(r).checkMax(n).applyPrecision(a).validate();
  }
  return s !== "" && r !== void 0 ? new NumberValidator(r).applyPrecision(a).validate() : null;
}
function setCaretAtPosition(t, r) {
  if (t === null)
    return;
  const { selectionStart: n, selectionEnd: a } = r;
  n === a && (a !== null && a <= t || r.setSelectionRange(t, t));
}
const getDelimiterFormatter = (t) => (r) => r.toString().replace(".", t);
function combineFormatters(t, ...r) {
  let n = t.toString();
  for (const a of r)
    n = a(n);
  return n;
}
function replaceSpecialDelimiterWithDot(t, r) {
  return t.toString().replace(r, ".");
}
const InputNumber = forwardRef(function t({
  value: r,
  id: n,
  prefix: a,
  suffix: s,
  placeholder: o,
  size: l,
  status: x,
  min: j,
  max: Z,
  step: V = 1,
  precision: $,
  allowClear: X = !1,
  disabled: W = !1,
  tabIndex: Y = 0,
  centred: U = !1,
  formatter: G,
  parser: K = DEFAULT_NUMBER_PARSER,
  autoFocus: J,
  className: ee,
  fieldClassName: te,
  style: re,
  onChange: ae,
  onFocus: ie,
  onBlur: ce,
  onKeyDown: he,
  onKeyUp: oe,
  onClick: le,
  onMouseLeave: pe,
  onMouseEnter: de,
  loading: se,
  delimiter: ue = DEFAULT_NUMBER_DELIMITER,
  allowHandleKeys: fe = !0
}, ge) {
  const { size: ne } = useGlobalComponentConfig({ size: l }), [ve, me] = useState$1(r != null ? r : "");
  useEffect(() => {
    me(r != null ? r : "");
  }, [r]);
  const xe = useCallback(
    (_e) => {
      const Ce = _e.currentTarget.value, { number: Te } = K(replaceSpecialDelimiterWithDot(Ce, ue));
      me(Te), ae == null || ae(Te === "" ? null : Te, _e);
    },
    [ue, ae, K]
  ), Ee = useCallback(
    (_e) => {
      ce == null || ce(_e);
      const Ce = validateNumber(ve, j, Z, $);
      me(Ce != null ? Ce : ""), ae == null || ae(Ce, _e);
    },
    [Z, j, ce, ae, $, ve]
  ), Se = useCallback(
    (_e) => {
      if (fe) {
        if (_e.key === "ArrowUp") {
          _e.preventDefault();
          const Te = validateNumber(ve, j, Z, $), we = new Decimal(Te != null ? Te : 0).plus(new Decimal(V)).toNumber(), Re = validateNumber(we, j, Z, $);
          me(Re != null ? Re : ""), ae == null || ae(Re);
          return;
        }
        if (_e.key === "ArrowDown") {
          _e.preventDefault();
          const Te = validateNumber(ve, j, Z, $), we = new Decimal(Te != null ? Te : 0).minus(new Decimal(V)).toNumber(), Re = validateNumber(we, j, Z, $);
          me(Re != null ? Re : ""), ae == null || ae(Re);
          return;
        }
        const Ce = K(replaceSpecialDelimiterWithDot(ve, ue)).endPosition;
        setCaretAtPosition(Ce, _e.currentTarget);
      }
      he == null || he(_e);
    },
    [fe, ue, Z, j, ae, he, K, $, V, ve]
  );
  return /* @__PURE__ */ jsx(
    Input,
    {
      ref: ge,
      value: G ? combineFormatters(ve, G, getDelimiterFormatter(ue)).toString() : getDelimiterFormatter(ue)(ve).toString(),
      allowClear: X,
      style: re,
      disabled: W,
      placeholder: o,
      className: clsx(U && "go-input-number_centred", ee),
      tabIndex: Y,
      id: n,
      onClick: le,
      prefix: a,
      suffix: s,
      status: x,
      size: ne,
      autoFocus: J,
      fieldClassName: te,
      loading: se,
      onChange: xe,
      onBlur: Ee,
      onFocus: ie,
      onKeyDown: Se,
      onKeyUp: oe,
      onMouseLeave: pe,
      onMouseEnter: de
    }
  );
});
function Modal({
  open: t,
  title: r,
  closeIcon: n = !0,
  loading: a,
  className: s,
  headerClassName: o,
  wrapperClassName: l,
  portalClassName: x,
  style: j,
  onClose: Z,
  onClickOutside: V = Z,
  children: $,
  transitionDuration: X,
  destroyOnClose: W
}) {
  return /* @__PURE__ */ jsx(
    Portal,
    {
      open: t,
      onClickOutside: V != null ? V : null,
      className: "go-modal__portal",
      contentClassName: clsx("go-modal__wrapper", l),
      contentOpenClassName: "go-modal__wrapper_open",
      portalClassName: x,
      transitionDuration: X,
      destroyOnClose: W,
      children: /* @__PURE__ */ jsxs("div", { className: clsx(s, "go-modal"), style: j, children: [
        !!r && /* @__PURE__ */ jsx("div", { className: clsx("go-modal__header", o), children: renderNode(r, "h2", "go-modal__title") }),
        !!n && /* @__PURE__ */ jsx("button", { className: "go-modal__close-button", onClick: Z, children: /* @__PURE__ */ jsx(CloseRoundLight, {}) }),
        $,
        a && /* @__PURE__ */ jsx(Loader, { className: "go-modal__loader" })
      ] })
    }
  );
}
const u = (t) => typeof t == "number" && !isNaN(t), d = (t) => typeof t == "string", p = (t) => typeof t == "function", m = (t) => d(t) || p(t) ? t : null, f = (t) => isValidElement(t) || d(t) || p(t) || u(t);
function g(t, r, n) {
  n === void 0 && (n = 300);
  const { scrollHeight: a, style: s } = t;
  requestAnimationFrame(() => {
    s.minHeight = "initial", s.height = a + "px", s.transition = `all ${n}ms`, requestAnimationFrame(() => {
      s.height = "0", s.padding = "0", s.margin = "0", setTimeout(r, n);
    });
  });
}
function h(t) {
  let { enter: r, exit: n, appendPosition: a = !1, collapse: s = !0, collapseDuration: o = 300 } = t;
  return function(l) {
    let { children: x, position: j, preventExitTransition: Z, done: V, nodeRef: $, isIn: X } = l;
    const W = a ? `${r}--${j}` : r, Y = a ? `${n}--${j}` : n, U = useRef(0);
    return useLayoutEffect$3(() => {
      const G = $.current, K = W.split(" "), J = (ee) => {
        ee.target === $.current && (G.dispatchEvent(new Event("d")), G.removeEventListener("animationend", J), G.removeEventListener("animationcancel", J), U.current === 0 && ee.type !== "animationcancel" && G.classList.remove(...K));
      };
      G.classList.add(...K), G.addEventListener("animationend", J), G.addEventListener("animationcancel", J);
    }, []), useEffect(() => {
      const G = $.current, K = () => {
        G.removeEventListener("animationend", K), s ? g(G, V, o) : V();
      };
      X || (Z ? K() : (U.current = 1, G.className += ` ${Y}`, G.addEventListener("animationend", K)));
    }, [X]), React__default.createElement(React__default.Fragment, null, x);
  };
}
function y(t, r) {
  return t != null ? { content: t.content, containerId: t.props.containerId, id: t.props.toastId, theme: t.props.theme, type: t.props.type, data: t.props.data || {}, isLoading: t.props.isLoading, icon: t.props.icon, status: r } : {};
}
const v = { list: /* @__PURE__ */ new Map(), emitQueue: /* @__PURE__ */ new Map(), on(t, r) {
  return this.list.has(t) || this.list.set(t, []), this.list.get(t).push(r), this;
}, off(t, r) {
  if (r) {
    const n = this.list.get(t).filter((a) => a !== r);
    return this.list.set(t, n), this;
  }
  return this.list.delete(t), this;
}, cancelEmit(t) {
  const r = this.emitQueue.get(t);
  return r && (r.forEach(clearTimeout), this.emitQueue.delete(t)), this;
}, emit(t) {
  this.list.has(t) && this.list.get(t).forEach((r) => {
    const n = setTimeout(() => {
      r(...[].slice.call(arguments, 1));
    }, 0);
    this.emitQueue.has(t) || this.emitQueue.set(t, []), this.emitQueue.get(t).push(n);
  });
} }, T = (t) => {
  let { theme: r, type: n, ...a } = t;
  return React__default.createElement("svg", { viewBox: "0 0 24 24", width: "100%", height: "100%", fill: r === "colored" ? "currentColor" : `var(--toastify-icon-color-${n})`, ...a });
}, E = { info: function(t) {
  return React__default.createElement(T, { ...t }, React__default.createElement("path", { d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z" }));
}, warning: function(t) {
  return React__default.createElement(T, { ...t }, React__default.createElement("path", { d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z" }));
}, success: function(t) {
  return React__default.createElement(T, { ...t }, React__default.createElement("path", { d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z" }));
}, error: function(t) {
  return React__default.createElement(T, { ...t }, React__default.createElement("path", { d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z" }));
}, spinner: function() {
  return React__default.createElement("div", { className: "Toastify__spinner" });
} };
function C(t) {
  const [, r] = useReducer((W) => W + 1, 0), [n, a] = useState$1([]), s = useRef(null), o = useRef(/* @__PURE__ */ new Map()).current, l = (W) => n.indexOf(W) !== -1, x = useRef({ toastKey: 1, displayedToast: 0, count: 0, queue: [], props: t, containerId: null, isToastActive: l, getToast: (W) => o.get(W) }).current;
  function j(W) {
    let { containerId: Y } = W;
    const { limit: U } = x.props;
    !U || Y && x.containerId !== Y || (x.count -= x.queue.length, x.queue = []);
  }
  function Z(W) {
    a((Y) => W == null ? [] : Y.filter((U) => U !== W));
  }
  function V() {
    const { toastContent: W, toastProps: Y, staleId: U } = x.queue.shift();
    X(W, Y, U);
  }
  function $(W, Y) {
    let { delay: U, staleId: G, ...K } = Y;
    if (!f(W) || (function(pe) {
      return !s.current || x.props.enableMultiContainer && pe.containerId !== x.props.containerId || o.has(pe.toastId) && pe.updateId == null;
    })(K)) return;
    const { toastId: J, updateId: ee, data: te } = K, { props: re } = x, ae = () => Z(J), ie = ee == null;
    ie && x.count++;
    const ce = { ...re, style: re.toastStyle, key: x.toastKey++, ...Object.fromEntries(Object.entries(K).filter((pe) => {
      let [de, se] = pe;
      return se != null;
    })), toastId: J, updateId: ee, data: te, closeToast: ae, isIn: !1, className: m(K.className || re.toastClassName), bodyClassName: m(K.bodyClassName || re.bodyClassName), progressClassName: m(K.progressClassName || re.progressClassName), autoClose: !K.isLoading && (he = K.autoClose, oe = re.autoClose, he === !1 || u(he) && he > 0 ? he : oe), deleteToast() {
      const pe = y(o.get(J), "removed");
      o.delete(J), v.emit(4, pe);
      const de = x.queue.length;
      if (x.count = J == null ? x.count - x.displayedToast : x.count - 1, x.count < 0 && (x.count = 0), de > 0) {
        const se = J == null ? x.props.limit : 1;
        if (de === 1 || se === 1) x.displayedToast++, V();
        else {
          const ue = se > de ? de : se;
          x.displayedToast = ue;
          for (let fe = 0; fe < ue; fe++) V();
        }
      } else r();
    } };
    var he, oe;
    ce.iconOut = (function(pe) {
      let { theme: de, type: se, isLoading: ue, icon: fe } = pe, ge = null;
      const ne = { theme: de, type: se };
      return fe === !1 || (p(fe) ? ge = fe(ne) : isValidElement(fe) ? ge = cloneElement(fe, ne) : d(fe) || u(fe) ? ge = fe : ue ? ge = E.spinner() : ((ve) => ve in E)(se) && (ge = E[se](ne))), ge;
    })(ce), p(K.onOpen) && (ce.onOpen = K.onOpen), p(K.onClose) && (ce.onClose = K.onClose), ce.closeButton = re.closeButton, K.closeButton === !1 || f(K.closeButton) ? ce.closeButton = K.closeButton : K.closeButton === !0 && (ce.closeButton = !f(re.closeButton) || re.closeButton);
    let le = W;
    isValidElement(W) && !d(W.type) ? le = cloneElement(W, { closeToast: ae, toastProps: ce, data: te }) : p(W) && (le = W({ closeToast: ae, toastProps: ce, data: te })), re.limit && re.limit > 0 && x.count > re.limit && ie ? x.queue.push({ toastContent: le, toastProps: ce, staleId: G }) : u(U) ? setTimeout(() => {
      X(le, ce, G);
    }, U) : X(le, ce, G);
  }
  function X(W, Y, U) {
    const { toastId: G } = Y;
    U && o.delete(U);
    const K = { content: W, props: Y };
    o.set(G, K), a((J) => [...J, G].filter((ee) => ee !== U)), v.emit(4, y(K, K.props.updateId == null ? "added" : "updated"));
  }
  return useEffect(() => (x.containerId = t.containerId, v.cancelEmit(3).on(0, $).on(1, (W) => s.current && Z(W)).on(5, j).emit(2, x), () => {
    o.clear(), v.emit(3, x);
  }), []), useEffect(() => {
    x.props = t, x.isToastActive = l, x.displayedToast = n.length;
  }), { getToastToRender: function(W) {
    const Y = /* @__PURE__ */ new Map(), U = Array.from(o.values());
    return t.newestOnTop && U.reverse(), U.forEach((G) => {
      const { position: K } = G.props;
      Y.has(K) || Y.set(K, []), Y.get(K).push(G);
    }), Array.from(Y, (G) => W(G[0], G[1]));
  }, containerRef: s, isToastActive: l };
}
function b(t) {
  return t.targetTouches && t.targetTouches.length >= 1 ? t.targetTouches[0].clientX : t.clientX;
}
function I(t) {
  return t.targetTouches && t.targetTouches.length >= 1 ? t.targetTouches[0].clientY : t.clientY;
}
function _(t) {
  const [r, n] = useState$1(!1), [a, s] = useState$1(!1), o = useRef(null), l = useRef({ start: 0, x: 0, y: 0, delta: 0, removalDistance: 0, canCloseOnClick: !0, canDrag: !1, boundingRect: null, didMove: !1 }).current, x = useRef(t), { autoClose: j, pauseOnHover: Z, closeToast: V, onClick: $, closeOnClick: X } = t;
  function W(te) {
    if (t.draggable) {
      te.nativeEvent.type === "touchstart" && te.nativeEvent.preventDefault(), l.didMove = !1, document.addEventListener("mousemove", K), document.addEventListener("mouseup", J), document.addEventListener("touchmove", K), document.addEventListener("touchend", J);
      const re = o.current;
      l.canCloseOnClick = !0, l.canDrag = !0, l.boundingRect = re.getBoundingClientRect(), re.style.transition = "", l.x = b(te.nativeEvent), l.y = I(te.nativeEvent), t.draggableDirection === "x" ? (l.start = l.x, l.removalDistance = re.offsetWidth * (t.draggablePercent / 100)) : (l.start = l.y, l.removalDistance = re.offsetHeight * (t.draggablePercent === 80 ? 1.5 * t.draggablePercent : t.draggablePercent / 100));
    }
  }
  function Y(te) {
    if (l.boundingRect) {
      const { top: re, bottom: ae, left: ie, right: ce } = l.boundingRect;
      te.nativeEvent.type !== "touchend" && t.pauseOnHover && l.x >= ie && l.x <= ce && l.y >= re && l.y <= ae ? G() : U();
    }
  }
  function U() {
    n(!0);
  }
  function G() {
    n(!1);
  }
  function K(te) {
    const re = o.current;
    l.canDrag && re && (l.didMove = !0, r && G(), l.x = b(te), l.y = I(te), l.delta = t.draggableDirection === "x" ? l.x - l.start : l.y - l.start, l.start !== l.x && (l.canCloseOnClick = !1), re.style.transform = `translate${t.draggableDirection}(${l.delta}px)`, re.style.opacity = "" + (1 - Math.abs(l.delta / l.removalDistance)));
  }
  function J() {
    document.removeEventListener("mousemove", K), document.removeEventListener("mouseup", J), document.removeEventListener("touchmove", K), document.removeEventListener("touchend", J);
    const te = o.current;
    if (l.canDrag && l.didMove && te) {
      if (l.canDrag = !1, Math.abs(l.delta) > l.removalDistance) return s(!0), void t.closeToast();
      te.style.transition = "transform 0.2s, opacity 0.2s", te.style.transform = `translate${t.draggableDirection}(0)`, te.style.opacity = "1";
    }
  }
  useEffect(() => {
    x.current = t;
  }), useEffect(() => (o.current && o.current.addEventListener("d", U, { once: !0 }), p(t.onOpen) && t.onOpen(isValidElement(t.children) && t.children.props), () => {
    const te = x.current;
    p(te.onClose) && te.onClose(isValidElement(te.children) && te.children.props);
  }), []), useEffect(() => (t.pauseOnFocusLoss && (document.hasFocus() || G(), window.addEventListener("focus", U), window.addEventListener("blur", G)), () => {
    t.pauseOnFocusLoss && (window.removeEventListener("focus", U), window.removeEventListener("blur", G));
  }), [t.pauseOnFocusLoss]);
  const ee = { onMouseDown: W, onTouchStart: W, onMouseUp: Y, onTouchEnd: Y };
  return j && Z && (ee.onMouseEnter = G, ee.onMouseLeave = U), X && (ee.onClick = (te) => {
    $ && $(te), l.canCloseOnClick && V();
  }), { playToast: U, pauseToast: G, isRunning: r, preventExitTransition: a, toastRef: o, eventHandlers: ee };
}
function L(t) {
  let { closeToast: r, theme: n, ariaLabel: a = "close" } = t;
  return React__default.createElement("button", { className: `Toastify__close-button Toastify__close-button--${n}`, type: "button", onClick: (s) => {
    s.stopPropagation(), r(s);
  }, "aria-label": a }, React__default.createElement("svg", { "aria-hidden": "true", viewBox: "0 0 14 16" }, React__default.createElement("path", { fillRule: "evenodd", d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z" })));
}
function O(t) {
  let { delay: r, isRunning: n, closeToast: a, type: s = "default", hide: o, className: l, style: x, controlledProgress: j, progress: Z, rtl: V, isIn: $, theme: X } = t;
  const W = o || j && Z === 0, Y = { ...x, animationDuration: `${r}ms`, animationPlayState: n ? "running" : "paused", opacity: W ? 0 : 1 };
  j && (Y.transform = `scaleX(${Z})`);
  const U = c("Toastify__progress-bar", j ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${X}`, `Toastify__progress-bar--${s}`, { "Toastify__progress-bar--rtl": V }), G = p(l) ? l({ rtl: V, type: s, defaultClassName: U }) : c(U, l);
  return React__default.createElement("div", { role: "progressbar", "aria-hidden": W ? "true" : "false", "aria-label": "notification timer", className: G, style: Y, [j && Z >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: j && Z < 1 ? null : () => {
    $ && a();
  } });
}
const N = (t) => {
  const { isRunning: r, preventExitTransition: n, toastRef: a, eventHandlers: s } = _(t), { closeButton: o, children: l, autoClose: x, onClick: j, type: Z, hideProgressBar: V, closeToast: $, transition: X, position: W, className: Y, style: U, bodyClassName: G, bodyStyle: K, progressClassName: J, progressStyle: ee, updateId: te, role: re, progress: ae, rtl: ie, toastId: ce, deleteToast: he, isIn: oe, isLoading: le, iconOut: pe, closeOnClick: de, theme: se } = t, ue = c("Toastify__toast", `Toastify__toast-theme--${se}`, `Toastify__toast--${Z}`, { "Toastify__toast--rtl": ie }, { "Toastify__toast--close-on-click": de }), fe = p(Y) ? Y({ rtl: ie, position: W, type: Z, defaultClassName: ue }) : c(ue, Y), ge = !!ae || !x, ne = { closeToast: $, type: Z, theme: se };
  let ve = null;
  return o === !1 || (ve = p(o) ? o(ne) : isValidElement(o) ? cloneElement(o, ne) : L(ne)), React__default.createElement(X, { isIn: oe, done: he, position: W, preventExitTransition: n, nodeRef: a }, React__default.createElement("div", { id: ce, onClick: j, className: fe, ...s, style: U, ref: a }, React__default.createElement("div", { ...oe && { role: re }, className: p(G) ? G({ type: Z }) : c("Toastify__toast-body", G), style: K }, pe != null && React__default.createElement("div", { className: c("Toastify__toast-icon", { "Toastify--animate-icon Toastify__zoom-enter": !le }) }, pe), React__default.createElement("div", null, l)), ve, React__default.createElement(O, { ...te && !ge ? { key: `pb-${te}` } : {}, rtl: ie, theme: se, delay: x, isRunning: r, isIn: oe, closeToast: $, hide: V, type: Z, style: ee, className: J, controlledProgress: ge, progress: ae || 0 })));
}, M = function(t, r) {
  return r === void 0 && (r = !1), { enter: `Toastify--animate Toastify__${t}-enter`, exit: `Toastify--animate Toastify__${t}-exit`, appendPosition: r };
}, R = h(M("bounce", !0)), w = h(M("slide", !0));
h(M("zoom"));
h(M("flip"));
const k = forwardRef((t, r) => {
  const { getToastToRender: n, containerRef: a, isToastActive: s } = C(t), { className: o, style: l, rtl: x, containerId: j } = t;
  function Z(V) {
    const $ = c("Toastify__toast-container", `Toastify__toast-container--${V}`, { "Toastify__toast-container--rtl": x });
    return p(o) ? o({ position: V, rtl: x, defaultClassName: $ }) : c($, m(o));
  }
  return useEffect(() => {
    r && (r.current = a.current);
  }, []), React__default.createElement("div", { ref: a, className: "Toastify", id: j }, n((V, $) => {
    const X = $.length ? { ...l } : { ...l, pointerEvents: "none" };
    return React__default.createElement("div", { className: Z(V), style: X, key: `container-${V}` }, $.map((W, Y) => {
      let { content: U, props: G } = W;
      return React__default.createElement(N, { ...G, isIn: s(G.toastId), style: { ...G.style, "--nth": Y + 1, "--len": $.length }, key: `toast-${G.key}` }, U);
    }));
  }));
});
k.displayName = "ToastContainer", k.defaultProps = { position: "top-right", transition: R, autoClose: 5e3, closeButton: L, pauseOnHover: !0, pauseOnFocusLoss: !0, closeOnClick: !0, draggable: !0, draggablePercent: 80, draggableDirection: "x", role: "alert", theme: "light" };
let P, B = /* @__PURE__ */ new Map(), D = [], A = 1;
function z() {
  return "" + A++;
}
function F(t) {
  return t && (d(t.toastId) || u(t.toastId)) ? t.toastId : z();
}
function H(t, r) {
  return B.size > 0 ? v.emit(0, t, r) : D.push({ content: t, options: r }), r.toastId;
}
function S(t, r) {
  return { ...r, type: r && r.type || t, toastId: F(r) };
}
function q(t) {
  return (r, n) => H(r, S(t, n));
}
function Q(t, r) {
  return H(t, S("default", r));
}
Q.loading = (t, r) => H(t, S("default", { isLoading: !0, autoClose: !1, closeOnClick: !1, closeButton: !1, draggable: !1, ...r })), Q.promise = function(t, r, n) {
  let a, { pending: s, error: o, success: l } = r;
  s && (a = d(s) ? Q.loading(s, n) : Q.loading(s.render, { ...n, ...s }));
  const x = { isLoading: null, autoClose: null, closeOnClick: null, closeButton: null, draggable: null }, j = (V, $, X) => {
    if ($ == null) return void Q.dismiss(a);
    const W = { type: V, ...x, ...n, data: X }, Y = d($) ? { render: $ } : $;
    return a ? Q.update(a, { ...W, ...Y }) : Q(Y.render, { ...W, ...Y }), X;
  }, Z = p(t) ? t() : t;
  return Z.then((V) => j("success", l, V)).catch((V) => j("error", o, V)), Z;
}, Q.success = q("success"), Q.info = q("info"), Q.error = q("error"), Q.warning = q("warning"), Q.warn = Q.warning, Q.dark = (t, r) => H(t, S("default", { theme: "dark", ...r })), Q.dismiss = (t) => {
  B.size > 0 ? v.emit(1, t) : D = D.filter((r) => t != null && r.options.toastId !== t);
}, Q.clearWaitingQueue = function(t) {
  return t === void 0 && (t = {}), v.emit(5, t);
}, Q.isActive = (t) => {
  let r = !1;
  return B.forEach((n) => {
    n.isToastActive && n.isToastActive(t) && (r = !0);
  }), r;
}, Q.update = function(t, r) {
  r === void 0 && (r = {}), setTimeout(() => {
    const n = (function(a, s) {
      let { containerId: o } = s;
      const l = B.get(o || P);
      return l && l.getToast(a);
    })(t, r);
    if (n) {
      const { props: a, content: s } = n, o = { delay: 100, ...a, ...r, toastId: r.toastId || t, updateId: z() };
      o.toastId !== t && (o.staleId = t);
      const l = o.render || s;
      delete o.render, H(l, o);
    }
  }, 0);
}, Q.done = (t) => {
  Q.update(t, { progress: 1 });
}, Q.onChange = (t) => (v.on(4, t), () => {
  v.off(4, t);
}), Q.POSITION = { TOP_LEFT: "top-left", TOP_RIGHT: "top-right", TOP_CENTER: "top-center", BOTTOM_LEFT: "bottom-left", BOTTOM_RIGHT: "bottom-right", BOTTOM_CENTER: "bottom-center" }, Q.TYPE = { INFO: "info", SUCCESS: "success", WARNING: "warning", ERROR: "error", DEFAULT: "default" }, v.on(2, (t) => {
  P = t.containerId || t, B.set(P, t), D.forEach((r) => {
    v.emit(0, r.content, r.options);
  }), D = [];
}).on(3, (t) => {
  B.delete(t.containerId || t), B.size === 0 && v.off(0).off(1).off(5);
});
function CloseButton({ closeToast: t }) {
  return /* @__PURE__ */ jsx("button", { className: "go-notification-close", type: "button", onClick: (r) => t(r), children: /* @__PURE__ */ jsx(CloseMiniLine, { style: { fontSize: 24, color: "#fff" } }) });
}
function getIcon(t) {
  switch (t) {
    case "error":
      return /* @__PURE__ */ jsx(AttantionMiniCustom, { style: { color: "#fff", fontSize: 24 } });
    case "success":
      return /* @__PURE__ */ jsx(CheckRoundFill, { style: { color: "#fff", fontSize: 24 } });
    case "warning":
      return /* @__PURE__ */ jsx(QuestionFill, { style: { color: "#fff", fontSize: 24 } });
    default:
      return /* @__PURE__ */ jsx(InfoRoundFill, { style: { color: "#fff", fontSize: 24 } });
  }
}
function isSameContainer(t, r) {
  return r == null ? t.containerId == null : t.containerId === r;
}
function isViewportBoundaryReached(t, r, n) {
  const { bottom: a, top: s } = t.getBoundingClientRect();
  return isBottomPosition(r) ? s < n : a > window.innerHeight - n;
}
function getActiveToastIds(t, r) {
  return t.filter((n) => !r.has(n));
}
function applyKeepNewestVisibleOverflow({
  activeToastIds: t,
  dismissingToastIds: r,
  newestOnTop: n,
  overflowOffset: a,
  position: s,
  suppressDismissAnimation: o,
  toastContainer: l
}) {
  if (!isKeepNewestVisibleOrder(s, n)) {
    dismissFirstTrackedToast(t, r);
    return;
  }
  keepNewestVisibleToasts(
    l,
    t,
    r,
    s,
    a,
    o
  );
}
function isBottomPosition(t) {
  return t == null ? void 0 : t.startsWith("bottom");
}
function isKeepNewestVisibleOrder(t, r) {
  return isBottomPosition(t) ? r !== !0 : r === !0;
}
function getElementHeight(t) {
  const r = window.getComputedStyle(t);
  return t.offsetHeight + parseFloat(r.marginTop || "0") + parseFloat(r.marginBottom || "0");
}
function getToastElements(t) {
  return Array.from(t.querySelectorAll(".Toastify__toast"));
}
function getToastElementsById(t) {
  return new Map(t.map((r) => [r.id, r]));
}
function getAvailableStackHeight(t, r, n) {
  const { bottom: a, top: s } = t.getBoundingClientRect();
  return isBottomPosition(r) ? a - n : window.innerHeight - n - s;
}
function getNewestVisibleToastIds(t, r, n) {
  const a = /* @__PURE__ */ new Set();
  let s = 0;
  return [...t].reverse().some((o) => {
    const l = r.get(String(o)), x = l ? getElementHeight(l) : 0;
    return a.size > 0 && s + x > n ? !0 : (a.add(o), s += x, !1);
  }), a;
}
function hideToastElementsBeforeDismiss(t, r) {
  t.forEach((n) => {
    const a = r.get(String(n));
    a && a.classList.add("go-notification-toast--overflow-hidden");
  });
}
function dismissToastIds(t, r) {
  t.forEach((n) => {
    r.add(n), Q.dismiss(n);
  });
}
function dismissFirstTrackedToast(t, r) {
  const [n] = t;
  n != null && dismissToastIds([n], r);
}
function keepNewestVisibleToasts(t, r, n, a, s, o) {
  const l = getAvailableStackHeight(t, a, s), x = getToastElementsById(getToastElements(t)), j = getNewestVisibleToastIds(r, x, l), Z = r.filter((V) => !j.has(V));
  o && hideToastElementsBeforeDismiss(Z, x), dismissToastIds(Z, n);
}
function useNotificationOverflow({
  containerId: t,
  newestOnTop: r,
  overflowOffset: n,
  overflowStrategy: a,
  position: s
}) {
  const o = useRef(null), l = useRef([]), x = useRef(/* @__PURE__ */ new Set()), j = useRef(null), Z = useRef(0), V = useRef(!1), $ = a !== "none", X = useCallback(() => {
    var G, K;
    return (K = (G = o.current) == null ? void 0 : G.querySelector(".Toastify__toast-container")) != null ? K : null;
  }, []), W = useCallback(
    (G) => {
      const K = X();
      if (!K || K.querySelector(".Toastify__toast") == null || x.current.size > 0)
        return;
      const J = getActiveToastIds(l.current, x.current);
      J.length !== 0 && isViewportBoundaryReached(K, s, n) && applyKeepNewestVisibleOverflow({
        activeToastIds: J,
        dismissingToastIds: x.current,
        newestOnTop: r,
        overflowOffset: n,
        position: s,
        suppressDismissAnimation: G,
        toastContainer: K
      });
    },
    [X, r, n, s]
  ), Y = useCallback(() => {
    $ && j.current == null && (j.current = requestAnimationFrame(() => {
      const G = Z.current > 1 && V.current;
      j.current = null, W(G), Z.current = 0, V.current = !1;
    }));
  }, [W, $]), U = useCallback(() => {
    j.current != null && (cancelAnimationFrame(j.current), j.current = null), Z.current = 0, V.current = !1;
  }, []);
  return useEffect(() => {
    if (!$) {
      U(), l.current = [], x.current.clear();
      return;
    }
    const G = Q.onChange((K) => {
      isSameContainer(K, t) && (K.status === "added" && (Z.current === 0 && (V.current = getActiveToastIds(l.current, x.current).length === 0), Z.current += 1, l.current = l.current.includes(K.id) ? l.current : [...l.current, K.id]), K.status === "removed" && (l.current = l.current.filter((J) => J !== K.id), x.current.delete(K.id)), Y());
    });
    return Y(), () => {
      G();
    };
  }, [U, t, $, Y]), useEffect(() => {
    if (!$)
      return;
    const G = () => {
      Y();
    };
    return window.addEventListener("resize", G), () => {
      window.removeEventListener("resize", G);
    };
  }, [$, Y]), useEffect(() => U, [U]), { wrapperRef: o };
}
function NotificationContainer({
  style: t,
  containerId: r,
  enableMultiContainer: n = r != null,
  fitContentWidth: a = !1,
  newestOnTop: s,
  overflowOffset: o = 16,
  overflowStrategy: l = "none",
  position: x = "top-right",
  ...j
}) {
  const { wrapperRef: Z } = useNotificationOverflow({
    containerId: r,
    newestOnTop: s,
    overflowOffset: o,
    overflowStrategy: l,
    position: x
  });
  return /* @__PURE__ */ jsx("div", { ref: Z, children: /* @__PURE__ */ jsx(
    k,
    {
      ...j,
      containerId: r,
      enableMultiContainer: n,
      newestOnTop: s,
      position: x,
      style: a ? { width: "fit-content", ...t } : t
    }
  ) });
}
function NotificationContent({ title: t, text: r }) {
  return /* @__PURE__ */ jsxs("div", { className: "go-notification-content__wrapper", children: [
    t && /* @__PURE__ */ jsx("div", { className: "go-notification-content__title", children: t }),
    r && /* @__PURE__ */ jsx("div", { className: "go-notification-content__text", children: r })
  ] });
}
function mergeToastClassName(t, r) {
  return typeof r == "function" ? (n) => clsx(t, r(n)) : clsx(t, r);
}
function getToastOptions({
  isCustomContent: t,
  className: r,
  bodyClassName: n,
  style: a,
  bodyStyle: s,
  type: o,
  closeButton: l,
  icon: x,
  ...j
}) {
  const Z = o != null ? o : "info", V = {
    className: mergeToastClassName(clsx(`go-notification-${Z}`, "go-notification"), r),
    bodyClassName: mergeToastClassName("go-notification-body", n),
    closeButton: l === !0 ? (X) => /* @__PURE__ */ jsx(CloseButton, { closeToast: X.closeToast }) : l,
    icon: x === !0 ? getIcon(Z) : x,
    type: Z
  }, $ = {
    className: mergeToastClassName("go-notification-custom", r),
    bodyClassName: n,
    closeButton: !1,
    icon: !1,
    style: {
      width: "fit-content",
      minHeight: "initial",
      padding: 0,
      borderRadius: 0,
      background: "transparent",
      boxShadow: "none",
      ...a
    },
    bodyStyle: {
      width: "100%",
      margin: 0,
      padding: 0,
      display: "block",
      ...s
    },
    type: o
  };
  return {
    ...j,
    style: a,
    bodyStyle: s,
    ...t ? $ : V
  };
}
function createNotification({
  content: t,
  className: r,
  bodyClassName: n,
  title: a,
  text: s,
  progressStyle: o,
  delay: l,
  isLoading: x,
  style: j,
  bodyStyle: Z,
  type: V,
  transition: $ = w,
  position: X,
  autoClose: W = 5e3,
  closeOnClick: Y = !1,
  closeButton: U = !0,
  icon: G = !0,
  draggable: K = !1,
  progress: J = void 0,
  pauseOnHover: ee = !0,
  theme: te = "dark",
  hideProgressBar: re = !0,
  ...ae
}) {
  const ie = t != null, ce = t != null ? t : /* @__PURE__ */ jsx(NotificationContent, { text: s, title: a });
  return Q(
    ce,
    getToastOptions({
      isCustomContent: ie,
      className: r,
      bodyClassName: n,
      progressStyle: o,
      delay: l,
      isLoading: x,
      style: j,
      bodyStyle: Z,
      type: V,
      transition: $,
      position: X,
      autoClose: W,
      closeOnClick: Y,
      closeButton: U,
      icon: G,
      draggable: K,
      progress: J,
      pauseOnHover: ee,
      theme: te,
      hideProgressBar: re,
      ...ae
    })
  );
}
function dismissNotification(t) {
  Q.dismiss(t);
}
const Radio = forwardRef(
  ({
    checked: t = !1,
    value: r,
    name: n,
    id: a,
    className: s,
    style: o,
    size: l,
    disabled: x,
    children: j,
    onChange: Z
  }, V) => {
    const { size: $ } = useGlobalComponentConfig({ size: l }), X = useId$3(), W = a || `go-radio-${X}`, [Y, U] = useState$1(t);
    useEffect(() => {
      U(t);
    }, [t]);
    const G = (K) => {
      const J = K.currentTarget.checked, ee = K.currentTarget.value;
      U(J), Z == null || Z(ee, J, K);
    };
    return /* @__PURE__ */ jsxs(
      "div",
      {
        className: clsx(s, "go-radio", x && "go-radio_disabled", $ === "s" && "go-radio_size_s"),
        style: o,
        children: [
          !!j && /* @__PURE__ */ jsx("label", { htmlFor: W, className: "go-radio__label", children: j }),
          /* @__PURE__ */ jsxs("div", { className: "go-radio__button", children: [
            /* @__PURE__ */ jsx(
              "input",
              {
                ref: V,
                id: W,
                type: "radio",
                name: n,
                value: r,
                checked: Y,
                disabled: x,
                onChange: G,
                className: "go-radio__input"
              }
            ),
            /* @__PURE__ */ jsx("label", { htmlFor: W, className: "go-radio__button-inner" })
          ] })
        ]
      }
    );
  }
);
Radio.displayName = "Radio";
const RadioGroup = ({
  value: t,
  name: r,
  items: n,
  itemClassName: a,
  onChange: s,
  style: o,
  className: l
}) => {
  const [x, j] = useState$1(t);
  useEffect(() => {
    j(t);
  }, [t]);
  const Z = useCallback(
    (V) => {
      j(V), s == null || s(V);
    },
    [s]
  );
  return /* @__PURE__ */ jsx("div", { style: o, className: clsx("go-radio-group", l), children: n.map((V) => /* @__PURE__ */ jsx(
    Radio,
    {
      checked: V.value === x,
      value: V.value,
      onChange: Z,
      className: a,
      disabled: V.disabled,
      name: r,
      id: V.id,
      ref: V.ref,
      style: V.style,
      children: V.label
    },
    V.value
  )) });
};
function RadioButton({
  value: t,
  name: r,
  id: n,
  checked: a,
  disabled: s,
  style: o,
  className: l,
  children: x,
  onChange: j
}) {
  return /* @__PURE__ */ jsxs("div", { className: clsx(l, "go-radio-button-group__item"), style: o, children: [
    /* @__PURE__ */ jsx(
      "input",
      {
        type: "radio",
        name: r,
        id: n,
        value: t,
        checked: a,
        disabled: s,
        onChange: j,
        className: "go-radio-button-group__item-input"
      }
    ),
    /* @__PURE__ */ jsx("label", { htmlFor: n, className: "go-radio-button-group__item-label", children: x })
  ] });
}
const sizeClassNames$2 = {
  s: "go-radio-button-group_size_s",
  m: "go-radio-button-group_size_m",
  l: "go-radio-button-group_size_l"
}, variantClassNames = {
  default: "go-radio-button-group_variant_default",
  flat: "go-radio-button-group_variant_flat"
};
function RadioButtonGroup({
  value: t,
  name: r,
  items: n,
  className: a,
  itemClassName: s,
  size: o,
  style: l,
  variant: x = "default",
  onChange: j
}) {
  const { size: Z } = useGlobalComponentConfig({ size: o }), V = useId$3(), $ = r || `go-rbg-${V}`, [X, W] = useState$1(t);
  useEffect(() => {
    W(t);
  }, [t]);
  const Y = useCallback(
    (U) => {
      W(U), j == null || j(U);
    },
    [j]
  );
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: clsx(
        a,
        "go-radio-button-group",
        sizeClassNames$2[o || Z],
        variantClassNames[x]
      ),
      style: l,
      children: n.map((U) => {
        var G;
        return /* @__PURE__ */ jsx(
          RadioButton,
          {
            id: `${$}-${U.value}`,
            name: $,
            value: U.value,
            checked: U.value === X,
            disabled: U.disabled,
            onChange: () => Y(U.value),
            className: clsx(s, U.className),
            style: U.style,
            children: U.label
          },
          (G = U.value) == null ? void 0 : G.toString()
        );
      })
    }
  );
}
function isEqual(t, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, a = /* @__PURE__ */ new Set();
  function s(o, l) {
    var x = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, j = a.has(o);
    if (warningOnce(!j, "Warning: There may be circular references"), j)
      return !1;
    if (o === l)
      return !0;
    if (n && x > 1)
      return !1;
    a.add(o);
    var Z = x + 1;
    if (Array.isArray(o)) {
      if (!Array.isArray(l) || o.length !== l.length)
        return !1;
      for (var V = 0; V < o.length; V++)
        if (!s(o[V], l[V], Z))
          return !1;
      return !0;
    }
    if (o && l && _typeof$1(o) === "object" && _typeof$1(l) === "object") {
      var $ = Object.keys(o);
      return $.length !== Object.keys(l).length ? !1 : $.every(function(X) {
        return s(o[X], l[X], Z);
      });
    }
    return !1;
  }
  return s(t, r);
}
function getOffset(t, r, n) {
  return (t - r) / (n - r);
}
function getDirectionStyle(t, r, n, a) {
  var s = getOffset(r, n, a), o = {};
  switch (t) {
    case "rtl":
      o.right = "".concat(s * 100, "%"), o.transform = "translateX(50%)";
      break;
    case "btt":
      o.bottom = "".concat(s * 100, "%"), o.transform = "translateY(50%)";
      break;
    case "ttb":
      o.top = "".concat(s * 100, "%"), o.transform = "translateY(-50%)";
      break;
    default:
      o.left = "".concat(s * 100, "%"), o.transform = "translateX(-50%)";
      break;
  }
  return o;
}
function getIndex(t, r) {
  return Array.isArray(t) ? t[r] : t;
}
var SliderContext = /* @__PURE__ */ React.createContext({
  min: 0,
  max: 0,
  direction: "ltr",
  step: 1,
  includedStart: 0,
  includedEnd: 0,
  tabIndex: 0,
  keyboard: !0,
  styles: {},
  classNames: {}
}), _excluded$1 = ["prefixCls", "value", "valueIndex", "onStartMove", "style", "render", "dragging", "onOffsetChange", "onChangeComplete", "onFocus", "onMouseEnter"], Handle = /* @__PURE__ */ React.forwardRef(function(t, r) {
  var n = t.prefixCls, a = t.value, s = t.valueIndex, o = t.onStartMove, l = t.style, x = t.render, j = t.dragging, Z = t.onOffsetChange, V = t.onChangeComplete, $ = t.onFocus, X = t.onMouseEnter, W = _objectWithoutProperties(t, _excluded$1), Y = React.useContext(SliderContext), U = Y.min, G = Y.max, K = Y.direction, J = Y.disabled, ee = Y.keyboard, te = Y.range, re = Y.tabIndex, ae = Y.ariaLabelForHandle, ie = Y.ariaLabelledByForHandle, ce = Y.ariaValueTextFormatterForHandle, he = Y.styles, oe = Y.classNames, le = "".concat(n, "-handle"), pe = function(Ee) {
    J || o(Ee, s);
  }, de = function(Ee) {
    $ == null || $(Ee, s);
  }, se = function(Ee) {
    X(Ee, s);
  }, ue = function(Ee) {
    if (!J && ee) {
      var Se = null;
      switch (Ee.which || Ee.keyCode) {
        case KeyCode.LEFT:
          Se = K === "ltr" || K === "btt" ? -1 : 1;
          break;
        case KeyCode.RIGHT:
          Se = K === "ltr" || K === "btt" ? 1 : -1;
          break;
        // Up is plus
        case KeyCode.UP:
          Se = K !== "ttb" ? 1 : -1;
          break;
        // Down is minus
        case KeyCode.DOWN:
          Se = K !== "ttb" ? -1 : 1;
          break;
        case KeyCode.HOME:
          Se = "min";
          break;
        case KeyCode.END:
          Se = "max";
          break;
        case KeyCode.PAGE_UP:
          Se = 2;
          break;
        case KeyCode.PAGE_DOWN:
          Se = -2;
          break;
      }
      Se !== null && (Ee.preventDefault(), Z(Se, s));
    }
  }, fe = function(Ee) {
    switch (Ee.which || Ee.keyCode) {
      case KeyCode.LEFT:
      case KeyCode.RIGHT:
      case KeyCode.UP:
      case KeyCode.DOWN:
      case KeyCode.HOME:
      case KeyCode.END:
      case KeyCode.PAGE_UP:
      case KeyCode.PAGE_DOWN:
        V == null || V();
        break;
    }
  }, ge = getDirectionStyle(K, a, U, G), ne = {};
  if (s !== null) {
    var ve;
    ne = {
      tabIndex: J ? null : getIndex(re, s),
      role: "slider",
      "aria-valuemin": U,
      "aria-valuemax": G,
      "aria-valuenow": a,
      "aria-disabled": J,
      "aria-label": getIndex(ae, s),
      "aria-labelledby": getIndex(ie, s),
      "aria-valuetext": (ve = getIndex(ce, s)) === null || ve === void 0 ? void 0 : ve(a),
      "aria-orientation": K === "ltr" || K === "rtl" ? "horizontal" : "vertical",
      onMouseDown: pe,
      onTouchStart: pe,
      onFocus: de,
      onMouseEnter: se,
      onKeyDown: ue,
      onKeyUp: fe
    };
  }
  var me = /* @__PURE__ */ React.createElement("div", _extends({
    ref: r,
    className: cls(le, _defineProperty(_defineProperty({}, "".concat(le, "-").concat(s + 1), s !== null && te), "".concat(le, "-dragging"), j), oe.handle),
    style: _objectSpread2(_objectSpread2(_objectSpread2({}, ge), l), he.handle)
  }, ne, W));
  return x && (me = x(me, {
    index: s,
    prefixCls: n,
    value: a,
    dragging: j
  })), me;
});
process.env.NODE_ENV !== "production" && (Handle.displayName = "Handle");
var _excluded = ["prefixCls", "style", "onStartMove", "onOffsetChange", "values", "handleRender", "activeHandleRender", "draggingIndex", "onFocus"], Handles = /* @__PURE__ */ React.forwardRef(function(t, r) {
  var n = t.prefixCls, a = t.style, s = t.onStartMove, o = t.onOffsetChange, l = t.values, x = t.handleRender, j = t.activeHandleRender, Z = t.draggingIndex, V = t.onFocus, $ = _objectWithoutProperties(t, _excluded), X = React.useRef({});
  React.useImperativeHandle(r, function() {
    return {
      focus: function(re) {
        var ae;
        (ae = X.current[re]) === null || ae === void 0 || ae.focus();
      }
    };
  });
  var W = React.useState(-1), Y = _slicedToArray(W, 2), U = Y[0], G = Y[1], K = function(re, ae) {
    G(ae), V == null || V(re);
  }, J = function(re, ae) {
    G(ae);
  }, ee = _objectSpread2({
    prefixCls: n,
    onStartMove: s,
    onOffsetChange: o,
    render: x,
    onFocus: K,
    onMouseEnter: J
  }, $);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, l.map(function(te, re) {
    return /* @__PURE__ */ React.createElement(Handle, _extends({
      ref: function(ie) {
        ie ? X.current[re] = ie : delete X.current[re];
      },
      dragging: Z === re,
      style: getIndex(a, re),
      key: re,
      value: te,
      valueIndex: re
    }, ee));
  }), j && /* @__PURE__ */ React.createElement(Handle, _extends({
    key: "a11y"
  }, ee, {
    value: l[U],
    valueIndex: null,
    dragging: Z !== -1,
    render: j,
    style: {
      pointerEvents: "none"
    },
    tabIndex: null,
    "aria-hidden": !0
  })));
});
process.env.NODE_ENV !== "production" && (Handles.displayName = "Handles");
var Mark = function t(r) {
  var n = r.prefixCls, a = r.style, s = r.children, o = r.value, l = r.onClick, x = React.useContext(SliderContext), j = x.min, Z = x.max, V = x.direction, $ = x.includedStart, X = x.includedEnd, W = x.included, Y = "".concat(n, "-text"), U = getDirectionStyle(V, o, j, Z);
  return /* @__PURE__ */ React.createElement("span", {
    className: cls(Y, _defineProperty({}, "".concat(Y, "-active"), W && $ <= o && o <= X)),
    style: _objectSpread2(_objectSpread2({}, U), a),
    onMouseDown: function(K) {
      K.stopPropagation();
    },
    onClick: function() {
      l(o);
    }
  }, s);
}, Marks = function t(r) {
  var n = r.prefixCls, a = r.marks, s = r.onClick, o = "".concat(n, "-mark");
  return a.length ? /* @__PURE__ */ React.createElement("div", {
    className: o
  }, a.map(function(l) {
    var x = l.value, j = l.style, Z = l.label;
    return /* @__PURE__ */ React.createElement(Mark, {
      key: x,
      prefixCls: o,
      style: j,
      value: x,
      onClick: s
    }, Z);
  })) : null;
}, Dot = function t(r) {
  var n = r.prefixCls, a = r.value, s = r.style, o = r.activeStyle, l = React.useContext(SliderContext), x = l.min, j = l.max, Z = l.direction, V = l.included, $ = l.includedStart, X = l.includedEnd, W = "".concat(n, "-dot"), Y = V && $ <= a && a <= X, U = _objectSpread2(_objectSpread2({}, getDirectionStyle(Z, a, x, j)), typeof s == "function" ? s(a) : s);
  return Y && (U = _objectSpread2(_objectSpread2({}, U), typeof o == "function" ? o(a) : o)), /* @__PURE__ */ React.createElement("span", {
    className: cls(W, _defineProperty({}, "".concat(W, "-active"), Y)),
    style: U
  });
}, Steps = function t(r) {
  var n = r.prefixCls, a = r.marks, s = r.dots, o = r.style, l = r.activeStyle, x = React.useContext(SliderContext), j = x.min, Z = x.max, V = x.step, $ = React.useMemo(function() {
    var X = /* @__PURE__ */ new Set();
    if (a.forEach(function(Y) {
      X.add(Y.value);
    }), s && V !== null)
      for (var W = j; W <= Z; )
        X.add(W), W += V;
    return Array.from(X);
  }, [j, Z, V, s, a]);
  return /* @__PURE__ */ React.createElement("div", {
    className: "".concat(n, "-step")
  }, $.map(function(X) {
    return /* @__PURE__ */ React.createElement(Dot, {
      prefixCls: n,
      key: X,
      value: X,
      style: o,
      activeStyle: l
    });
  }));
}, Track = function t(r) {
  var n = r.prefixCls, a = r.style, s = r.start, o = r.end, l = r.index, x = r.onStartMove, j = r.replaceCls, Z = React.useContext(SliderContext), V = Z.direction, $ = Z.min, X = Z.max, W = Z.disabled, Y = Z.range, U = Z.classNames, G = "".concat(n, "-track"), K = getOffset(s, $, X), J = getOffset(o, $, X), ee = function(ie) {
    !W && x && x(ie, -1);
  }, te = {};
  switch (V) {
    case "rtl":
      te.right = "".concat(K * 100, "%"), te.width = "".concat(J * 100 - K * 100, "%");
      break;
    case "btt":
      te.bottom = "".concat(K * 100, "%"), te.height = "".concat(J * 100 - K * 100, "%");
      break;
    case "ttb":
      te.top = "".concat(K * 100, "%"), te.height = "".concat(J * 100 - K * 100, "%");
      break;
    default:
      te.left = "".concat(K * 100, "%"), te.width = "".concat(J * 100 - K * 100, "%");
  }
  var re = j || cls(G, _defineProperty(_defineProperty({}, "".concat(G, "-").concat(l + 1), l !== null && Y), "".concat(n, "-track-draggable"), x), U.track);
  return /* @__PURE__ */ React.createElement("div", {
    className: re,
    style: _objectSpread2(_objectSpread2({}, te), a),
    onMouseDown: ee,
    onTouchStart: ee
  });
}, Tracks = function t(r) {
  var n = r.prefixCls, a = r.style, s = r.values, o = r.startPoint, l = r.onStartMove, x = React.useContext(SliderContext), j = x.included, Z = x.range, V = x.min, $ = x.styles, X = x.classNames, W = React.useMemo(function() {
    if (!Z) {
      if (s.length === 0)
        return [];
      var U = o != null ? o : V, G = s[0];
      return [{
        start: Math.min(U, G),
        end: Math.max(U, G)
      }];
    }
    for (var K = [], J = 0; J < s.length - 1; J += 1)
      K.push({
        start: s[J],
        end: s[J + 1]
      });
    return K;
  }, [s, Z, o, V]);
  if (!j)
    return null;
  var Y = X.tracks || $.tracks ? /* @__PURE__ */ React.createElement(Track, {
    index: null,
    prefixCls: n,
    start: W[0].start,
    end: W[W.length - 1].end,
    replaceCls: cls(X.tracks, "".concat(n, "-tracks")),
    style: $.tracks
  }) : null;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, Y, W.map(function(U, G) {
    var K = U.start, J = U.end;
    return /* @__PURE__ */ React.createElement(Track, {
      index: G,
      prefixCls: n,
      style: _objectSpread2(_objectSpread2({}, getIndex(a, G)), $.track),
      start: K,
      end: J,
      key: G,
      onStartMove: l
    });
  }));
};
function getPosition(t) {
  var r = "touches" in t ? t.touches[0] : t;
  return {
    pageX: r.pageX,
    pageY: r.pageY
  };
}
function useDrag(t, r, n, a, s, o, l, x, j) {
  var Z = React.useState(null), V = _slicedToArray(Z, 2), $ = V[0], X = V[1], W = React.useState(-1), Y = _slicedToArray(W, 2), U = Y[0], G = Y[1], K = React.useState(n), J = _slicedToArray(K, 2), ee = J[0], te = J[1], re = React.useState(n), ae = _slicedToArray(re, 2), ie = ae[0], ce = ae[1], he = React.useRef(null), oe = React.useRef(null);
  React.useLayoutEffect(function() {
    U === -1 && te(n);
  }, [n, U]), React.useEffect(function() {
    return function() {
      document.removeEventListener("mousemove", he.current), document.removeEventListener("mouseup", oe.current), document.removeEventListener("touchmove", he.current), document.removeEventListener("touchend", oe.current);
    };
  }, []);
  var le = function(fe, ge) {
    ee.some(function(ne, ve) {
      return ne !== fe[ve];
    }) && (ge !== void 0 && X(ge), te(fe), l(fe));
  }, pe = useEvent$1(function(ue, fe) {
    if (ue === -1) {
      var ge = ie[0], ne = ie[ie.length - 1], ve = a - ge, me = s - ne, xe = fe * (s - a);
      xe = Math.max(xe, ve), xe = Math.min(xe, me);
      var Ee = o(ge + xe);
      xe = Ee - ge;
      var Se = ie.map(function(we) {
        return we + xe;
      });
      le(Se);
    } else {
      var _e = (s - a) * fe, Ce = _toConsumableArray(ee);
      Ce[ue] = ie[ue];
      var Te = j(Ce, _e, ue, "dist");
      le(Te.values, Te.value);
    }
  }), de = function(fe, ge, ne) {
    fe.stopPropagation();
    var ve = ne || n, me = ve[ge];
    G(ge), X(me), ce(ve);
    var xe = getPosition(fe), Ee = xe.pageX, Se = xe.pageY, _e = function(we) {
      we.preventDefault();
      var Re = getPosition(we), Ae = Re.pageX, Pe = Re.pageY, ke = Ae - Ee, ye = Pe - Se, Me = t.current.getBoundingClientRect(), be = Me.width, De = Me.height, Fe;
      switch (r) {
        case "btt":
          Fe = -ye / De;
          break;
        case "ttb":
          Fe = ye / De;
          break;
        case "rtl":
          Fe = -ke / be;
          break;
        default:
          Fe = ke / be;
      }
      pe(ge, Fe);
    }, Ce = function Te(we) {
      we.preventDefault(), document.removeEventListener("mouseup", Te), document.removeEventListener("mousemove", _e), document.removeEventListener("touchend", Te), document.removeEventListener("touchmove", _e), he.current = null, oe.current = null, G(-1), x();
    };
    document.addEventListener("mouseup", Ce), document.addEventListener("mousemove", _e), document.addEventListener("touchend", Ce), document.addEventListener("touchmove", _e), he.current = _e, oe.current = Ce;
  }, se = React.useMemo(function() {
    var ue = _toConsumableArray(n).sort(function(ge, ne) {
      return ge - ne;
    }), fe = _toConsumableArray(ee).sort(function(ge, ne) {
      return ge - ne;
    });
    return ue.every(function(ge, ne) {
      return ge === fe[ne];
    }) ? ee : n;
  }, [n, ee]);
  return [U, $, se, de];
}
function useOffset(t, r, n, a, s, o) {
  var l = React.useCallback(function(W) {
    return Math.max(t, Math.min(r, W));
  }, [t, r]), x = React.useCallback(function(W) {
    if (n !== null) {
      var Y = t + Math.round((l(W) - t) / n) * n, U = function(ee) {
        return (String(ee).split(".")[1] || "").length;
      }, G = Math.max(U(n), U(r), U(t)), K = Number(Y.toFixed(G));
      return t <= K && K <= r ? K : null;
    }
    return null;
  }, [n, t, r, l]), j = React.useCallback(function(W) {
    var Y = l(W), U = a.map(function(J) {
      return J.value;
    });
    n !== null && U.push(x(W)), U.push(t, r);
    var G = U[0], K = r - t;
    return U.forEach(function(J) {
      var ee = Math.abs(Y - J);
      ee <= K && (G = J, K = ee);
    }), G;
  }, [t, r, a, n, l, x]), Z = function W(Y, U, G) {
    var K = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "unit";
    if (typeof U == "number") {
      var J, ee = Y[G], te = ee + U, re = [];
      a.forEach(function(oe) {
        re.push(oe.value);
      }), re.push(t, r), re.push(x(ee));
      var ae = U > 0 ? 1 : -1;
      K === "unit" ? re.push(x(ee + ae * n)) : re.push(x(te)), re = re.filter(function(oe) {
        return oe !== null;
      }).filter(function(oe) {
        return U < 0 ? oe <= ee : oe >= ee;
      }), K === "unit" && (re = re.filter(function(oe) {
        return oe !== ee;
      }));
      var ie = K === "unit" ? ee : te;
      J = re[0];
      var ce = Math.abs(J - ie);
      if (re.forEach(function(oe) {
        var le = Math.abs(oe - ie);
        le < ce && (J = oe, ce = le);
      }), J === void 0)
        return U < 0 ? t : r;
      if (K === "dist")
        return J;
      if (Math.abs(U) > 1) {
        var he = _toConsumableArray(Y);
        return he[G] = J, W(he, U - ae, G, K);
      }
      return J;
    } else {
      if (U === "min")
        return t;
      if (U === "max")
        return r;
    }
  }, V = function(Y, U, G) {
    var K = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "unit", J = Y[G], ee = Z(Y, U, G, K);
    return {
      value: ee,
      changed: ee !== J
    };
  }, $ = function(Y) {
    return o === null && Y === 0 || typeof o == "number" && Y < o;
  }, X = function(Y, U, G) {
    var K = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "unit", J = Y.map(j), ee = J[G], te = Z(J, U, G, K);
    if (J[G] = te, s === !1) {
      var re = o || 0;
      G > 0 && J[G - 1] !== ee && (J[G] = Math.max(J[G], J[G - 1] + re)), G < J.length - 1 && J[G + 1] !== ee && (J[G] = Math.min(J[G], J[G + 1] - re));
    } else if (typeof o == "number" || o === null) {
      for (var ae = G + 1; ae < J.length; ae += 1)
        for (var ie = !0; $(J[ae] - J[ae - 1]) && ie; ) {
          var ce = V(J, 1, ae);
          J[ae] = ce.value, ie = ce.changed;
        }
      for (var he = G; he > 0; he -= 1)
        for (var oe = !0; $(J[he] - J[he - 1]) && oe; ) {
          var le = V(J, -1, he - 1);
          J[he - 1] = le.value, oe = le.changed;
        }
      for (var pe = J.length - 1; pe > 0; pe -= 1)
        for (var de = !0; $(J[pe] - J[pe - 1]) && de; ) {
          var se = V(J, -1, pe - 1);
          J[pe - 1] = se.value, de = se.changed;
        }
      for (var ue = 0; ue < J.length - 1; ue += 1)
        for (var fe = !0; $(J[ue + 1] - J[ue]) && fe; ) {
          var ge = V(J, 1, ue + 1);
          J[ue + 1] = ge.value, fe = ge.changed;
        }
    }
    return {
      value: J[G],
      values: J
    };
  };
  return [j, X];
}
var Slider$1 = /* @__PURE__ */ React.forwardRef(function(t, r) {
  var n = t.prefixCls, a = n === void 0 ? "rc-slider" : n, s = t.className, o = t.style, l = t.classNames, x = t.styles, j = t.disabled, Z = j === void 0 ? !1 : j, V = t.keyboard, $ = V === void 0 ? !0 : V, X = t.autoFocus, W = t.onFocus, Y = t.onBlur, U = t.min, G = U === void 0 ? 0 : U, K = t.max, J = K === void 0 ? 100 : K, ee = t.step, te = ee === void 0 ? 1 : ee, re = t.value, ae = t.defaultValue, ie = t.range, ce = t.count, he = t.onChange, oe = t.onBeforeChange, le = t.onAfterChange, pe = t.onChangeComplete, de = t.allowCross, se = de === void 0 ? !0 : de, ue = t.pushable, fe = ue === void 0 ? !1 : ue, ge = t.draggableTrack, ne = t.reverse, ve = t.vertical, me = t.included, xe = me === void 0 ? !0 : me, Ee = t.startPoint, Se = t.trackStyle, _e = t.handleStyle, Ce = t.railStyle, Te = t.dotStyle, we = t.activeDotStyle, Re = t.marks, Ae = t.dots, Pe = t.handleRender, ke = t.activeHandleRender, ye = t.tabIndex, Me = ye === void 0 ? 0 : ye, be = t.ariaLabelForHandle, De = t.ariaLabelledByForHandle, Fe = t.ariaValueTextFormatterForHandle, Le = React.useRef(null), Ne = React.useRef(null), Ie = React.useMemo(function() {
    return ve ? ne ? "ttb" : "btt" : ne ? "rtl" : "ltr";
  }, [ne, ve]), je = React.useMemo(function() {
    return isFinite(G) ? G : 0;
  }, [G]), Ze = React.useMemo(function() {
    return isFinite(J) ? J : 100;
  }, [J]), $e = React.useMemo(function() {
    return te !== null && te <= 0 ? 1 : te;
  }, [te]), We = React.useMemo(function() {
    return typeof fe == "boolean" ? fe ? $e : !1 : fe >= 0 ? fe : !1;
  }, [fe, $e]), Be = React.useMemo(function() {
    return Object.keys(Re || {}).map(function(Je) {
      var Xe = Re[Je], ct = {
        value: Number(Je)
      };
      return Xe && _typeof$1(Xe) === "object" && !/* @__PURE__ */ React.isValidElement(Xe) && ("label" in Xe || "style" in Xe) ? (ct.style = Xe.style, ct.label = Xe.label) : ct.label = Xe, ct;
    }).filter(function(Je) {
      var Xe = Je.label;
      return Xe || typeof Xe == "number";
    }).sort(function(Je, Xe) {
      return Je.value - Xe.value;
    });
  }, [Re]), Ue = useOffset(je, Ze, $e, Be, se, We), Qe = _slicedToArray(Ue, 2), et = Qe[0], rt = Qe[1], ut = useMergedState$2(ae, {
    value: re
  }), tt = _slicedToArray(ut, 2), nt = tt[0], Dt = tt[1], xt = React.useMemo(function() {
    var Je = nt == null ? [] : Array.isArray(nt) ? nt : [nt], Xe = _slicedToArray(Je, 1), ct = Xe[0], bt = ct === void 0 ? je : ct, vt = nt === null ? [] : [bt];
    if (ie) {
      if (vt = _toConsumableArray(Je), ce || nt === void 0) {
        var Rt = ce >= 0 ? ce + 1 : 2;
        for (vt = vt.slice(0, Rt); vt.length < Rt; ) {
          var Et;
          vt.push((Et = vt[vt.length - 1]) !== null && Et !== void 0 ? Et : je);
        }
      }
      vt.sort(function(gt, He) {
        return gt - He;
      });
    }
    return vt.forEach(function(gt, He) {
      vt[He] = et(gt);
    }), vt;
  }, [nt, ie, je, ce, et]), yt = React.useRef(xt);
  yt.current = xt;
  var St = function(Xe) {
    return ie ? Xe : Xe[0];
  }, dt = function(Xe) {
    var ct = _toConsumableArray(Xe).sort(function(bt, vt) {
      return bt - vt;
    });
    he && !isEqual(ct, yt.current, !0) && he(St(ct)), Dt(ct);
  }, Zt = function() {
    var Xe = St(yt.current);
    le == null || le(Xe), warningOnce(!le, "[rc-slider] `onAfterChange` is deprecated. Please use `onChangeComplete` instead."), pe == null || pe(Xe);
  }, wt = useDrag(Ne, Ie, xt, je, Ze, et, dt, Zt, rt), It = _slicedToArray(wt, 4), Tt = It[0], Gt = It[1], Vt = It[2], Lt = It[3], mt = function(Xe, ct) {
    if (!Z) {
      var bt = 0, vt = Ze - je;
      xt.forEach(function(He, Ge) {
        var it = Math.abs(Xe - He);
        it <= vt && (vt = it, bt = Ge);
      });
      var Rt = _toConsumableArray(xt);
      if (Rt[bt] = Xe, ie && !xt.length && ce === void 0 && Rt.push(Xe), oe == null || oe(St(Rt)), dt(Rt), ct) {
        var Et, gt;
        (Et = document.activeElement) === null || Et === void 0 || (gt = Et.blur) === null || gt === void 0 || gt.call(Et), Le.current.focus(bt), Lt(ct, bt, Rt);
      }
    }
  }, at = function(Xe) {
    Xe.preventDefault();
    var ct = Ne.current.getBoundingClientRect(), bt = ct.width, vt = ct.height, Rt = ct.left, Et = ct.top, gt = ct.bottom, He = ct.right, Ge = Xe.clientX, it = Xe.clientY, ht;
    switch (Ie) {
      case "btt":
        ht = (gt - it) / vt;
        break;
      case "ttb":
        ht = (it - Et) / vt;
        break;
      case "rtl":
        ht = (He - Ge) / bt;
        break;
      default:
        ht = (Ge - Rt) / bt;
    }
    var Ct = je + ht * (Ze - je);
    mt(et(Ct), Xe);
  }, Pt = React.useState(null), _t = _slicedToArray(Pt, 2), pt = _t[0], Wt = _t[1], Nt = function(Xe, ct) {
    if (!Z) {
      var bt = rt(xt, Xe, ct);
      oe == null || oe(St(xt)), dt(bt.values), Wt(bt.value);
    }
  };
  React.useEffect(function() {
    if (pt !== null) {
      var Je = xt.indexOf(pt);
      Je >= 0 && Le.current.focus(Je);
    }
    Wt(null);
  }, [pt]);
  var Ye = React.useMemo(function() {
    return ge && $e === null ? (process.env.NODE_ENV !== "production" && warningOnce(!1, "`draggableTrack` is not supported when `step` is `null`."), !1) : ge;
  }, [ge, $e]), ze = function(Xe, ct) {
    Lt(Xe, ct), oe == null || oe(St(yt.current));
  }, Oe = Tt !== -1;
  React.useEffect(function() {
    if (!Oe) {
      var Je = xt.lastIndexOf(Gt);
      Le.current.focus(Je);
    }
  }, [Oe]);
  var Ve = React.useMemo(function() {
    return _toConsumableArray(Vt).sort(function(Je, Xe) {
      return Je - Xe;
    });
  }, [Vt]), qe = React.useMemo(function() {
    return ie ? [Ve[0], Ve[Ve.length - 1]] : [je, Ve[0]];
  }, [Ve, ie, je]), st = _slicedToArray(qe, 2), Mt = st[0], kt = st[1];
  React.useImperativeHandle(r, function() {
    return {
      focus: function() {
        Le.current.focus(0);
      },
      blur: function() {
        var Xe, ct = document, bt = ct.activeElement;
        (Xe = Ne.current) !== null && Xe !== void 0 && Xe.contains(bt) && (bt == null || bt.blur());
      }
    };
  }), React.useEffect(function() {
    X && Le.current.focus(0);
  }, []);
  var Ft = React.useMemo(function() {
    return {
      min: je,
      max: Ze,
      direction: Ie,
      disabled: Z,
      keyboard: $,
      step: $e,
      included: xe,
      includedStart: Mt,
      includedEnd: kt,
      range: ie,
      tabIndex: Me,
      ariaLabelForHandle: be,
      ariaLabelledByForHandle: De,
      ariaValueTextFormatterForHandle: Fe,
      styles: x || {},
      classNames: l || {}
    };
  }, [je, Ze, Ie, Z, $, $e, xe, Mt, kt, ie, Me, be, De, Fe, x, l]);
  return /* @__PURE__ */ React.createElement(SliderContext.Provider, {
    value: Ft
  }, /* @__PURE__ */ React.createElement("div", {
    ref: Ne,
    className: cls(a, s, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(a, "-disabled"), Z), "".concat(a, "-vertical"), ve), "".concat(a, "-horizontal"), !ve), "".concat(a, "-with-marks"), Be.length)),
    style: o,
    onMouseDown: at
  }, /* @__PURE__ */ React.createElement("div", {
    className: cls("".concat(a, "-rail"), l == null ? void 0 : l.rail),
    style: _objectSpread2(_objectSpread2({}, Ce), x == null ? void 0 : x.rail)
  }), /* @__PURE__ */ React.createElement(Tracks, {
    prefixCls: a,
    style: Se,
    values: Ve,
    startPoint: Ee,
    onStartMove: Ye ? ze : void 0
  }), /* @__PURE__ */ React.createElement(Steps, {
    prefixCls: a,
    marks: Be,
    dots: Ae,
    style: Te,
    activeStyle: we
  }), /* @__PURE__ */ React.createElement(Handles, {
    ref: Le,
    prefixCls: a,
    style: _e,
    values: Vt,
    draggingIndex: Tt,
    onStartMove: ze,
    onOffsetChange: Nt,
    onFocus: W,
    onBlur: Y,
    handleRender: Pe,
    activeHandleRender: ke,
    onChangeComplete: Zt
  }), /* @__PURE__ */ React.createElement(Marks, {
    prefixCls: a,
    marks: Be,
    onClick: mt
  })));
});
process.env.NODE_ENV !== "production" && (Slider$1.displayName = "Slider");
const defaultFormatter = (t) => typeof t == "number" ? t.toString() : "";
function Slider({
  step: t,
  min: r,
  max: n,
  style: a,
  prefixCls: s,
  onChange: o,
  included: l,
  disabled: x,
  reverse: j,
  className: Z,
  vertical: V,
  marks: $,
  dots: X,
  count: W,
  range: Y,
  value: U,
  defaultValue: G,
  tooltip: K,
  tooltipProps: J
}) {
  const [ee, te] = useState$1({}), re = (ie, ce) => {
    te((he) => ({ ...he, [ie]: ce }));
  };
  return /* @__PURE__ */ jsx(
    Slider$1,
    {
      step: t,
      value: U,
      handleRender: K ? (ie, ce) => {
        const { index: he, dragging: oe, value: le } = ce, pe = {
          ...ie.props,
          onMouseEnter: () => {
            re(he, !0);
          },
          onMouseLeave: () => {
            re(he, !1);
          }
        };
        if (!J)
          return /* @__PURE__ */ jsx(Tooltip$1, { trigger: [], open: ee[he] || oe, placement: V ? "right" : "top", title: le, children: cloneElement(ie, pe) });
        const {
          placement: de,
          className: se,
          containerClassName: ue,
          gap: fe,
          style: ge,
          initialOpen: ne,
          withArrow: ve,
          arrowOptions: me,
          alwaysOpen: xe,
          formatter: Ee
        } = J;
        return /* @__PURE__ */ jsx(
          Tooltip$1,
          {
            open: xe && !V ? xe : ee[he] || oe,
            placement: de,
            className: se,
            style: ge,
            initialOpen: ne,
            containerClassName: ue,
            arrowOptions: me,
            withArrow: ve,
            gap: fe,
            trigger: [],
            title: Ee ? Ee(ce.value) : defaultFormatter(le),
            children: cloneElement(ie, pe)
          }
        );
      } : void 0,
      defaultValue: G,
      style: a,
      className: Z,
      reverse: V ? !j : j,
      included: l,
      disabled: x,
      marks: $,
      vertical: V,
      range: Y,
      onChange: o,
      prefixCls: clsx(s != null ? s : "go-slider"),
      min: r,
      max: n,
      count: W,
      dots: X
    }
  );
}
const sizeClassNames$1 = {
  s: "go-switch_size_s",
  m: "go-switch_size_m"
}, orientationClassNames = {
  horizontal: "go-switch_orientation_horizontal",
  vertical: "go-switch_orientation_vertical"
}, Switch = forwardRef(function t({
  checked: r,
  orientation: n = "horizontal",
  size: a,
  disabled: s,
  leftNode: o,
  rightNode: l,
  className: x,
  containerClassName: j,
  knobClassName: Z,
  style: V,
  name: $,
  tabIndex: X,
  autoFocus: W,
  onChange: Y,
  onKeyDown: U
}, G) {
  const { size: K } = useGlobalComponentConfig({ size: a }), [J, ee] = useState$1(!1), te = (re) => {
    const { checked: ae } = re.currentTarget;
    ee(ae), Y == null || Y(ae, re);
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: clsx(
        x,
        "go-switch",
        sizeClassNames$1[K],
        orientationClassNames[n],
        (!!o || !!l) && "go-switch_with-content"
      ),
      style: V,
      children: [
        /* @__PURE__ */ jsx(
          "input",
          {
            ref: G,
            type: "checkbox",
            name: $,
            checked: r != null ? r : J,
            className: "go-switch__checkbox",
            disabled: s,
            tabIndex: X,
            autoFocus: W,
            onChange: te,
            onKeyDown: U
          }
        ),
        /* @__PURE__ */ jsxs("div", { className: "go-switch__inner", children: [
          /* @__PURE__ */ jsx("div", { className: clsx(j, "go-switch__container") }),
          /* @__PURE__ */ jsx("div", { className: clsx(Z, "go-switch__knob") }),
          /* @__PURE__ */ jsxs("div", { className: "go-switch__icons-container", children: [
            /* @__PURE__ */ jsx("div", { className: "go-switch__left-node", children: o }),
            /* @__PURE__ */ jsx("div", { className: "go-switch__right-node", children: l })
          ] })
        ] })
      ]
    }
  );
}), sizeClassNames = {
  s: "go-textarea_size_s",
  m: "go-textarea_size_m"
}, statusClassNames = {
  error: "go-textarea_status_error"
}, Textarea = forwardRef(function t({
  value: r,
  id: n,
  placeholder: a,
  size: s,
  status: o,
  maxLength: l,
  rows: x,
  minRows: j,
  maxRows: Z,
  cols: V,
  autoHeight: $ = !0,
  allowClear: X = !1,
  disabled: W = !1,
  tabIndex: Y = 0,
  suffix: U,
  className: G,
  fieldClassName: K,
  style: J,
  onChange: ee,
  onFocus: te,
  onBlur: re,
  onKeyPress: ae,
  onResize: ie
}, ce) {
  var Se, _e, Ce;
  const { localization: he } = useContext(ConfigContext), { size: oe } = useGlobalComponentConfig({ size: s }), le = useRef(null), [pe, de] = useState$1(r), [se, ue] = useState$1(!1), fe = X && !!(pe != null && pe.length), ge = (Se = j != null ? j : x) != null ? Se : 1, ne = x != null ? x : ge;
  useEffect(() => {
    de(r);
  }, [r]), useEffect(() => {
    const Te = le.current;
    Te && $ && autoHeight(Te, { minRows: ge, maxRows: Z });
  }, [pe, $, ge, Z]);
  const ve = useCallback(
    (Te) => {
      const we = Te.currentTarget.value;
      de(we), ee == null || ee(we, Te);
    },
    [ee]
  ), me = useCallback(
    (Te) => {
      ue(!0), te == null || te(Te);
    },
    [te]
  ), xe = useCallback(
    (Te) => {
      ue(!1), re == null || re(Te);
    },
    [re]
  ), Ee = useCallback(() => {
    de(""), ee == null || ee("");
  }, [ee]);
  return /* @__PURE__ */ jsxs(
    "label",
    {
      className: clsx(
        "go-textarea",
        sizeClassNames[oe],
        o && statusClassNames[o],
        se && "go-textarea_focused",
        W && "go-textarea_disabled",
        $ && "go-textarea_not-resizable",
        fe && "go-textarea_filled",
        G
      ),
      style: J,
      children: [
        /* @__PURE__ */ jsx(
          "textarea",
          {
            ref: mergeRefs(le, ce),
            id: n,
            value: pe,
            rows: ne,
            cols: V,
            placeholder: a,
            className: clsx("go-textarea__field", K),
            disabled: W,
            maxLength: l,
            tabIndex: Y,
            onChange: ve,
            onFocus: me,
            onBlur: xe,
            onKeyPress: ae,
            onResize: ie
          }
        ),
        !!U && renderNode(U, "span", "go-textarea__suffix"),
        fe && /* @__PURE__ */ jsx(Tooltip$1, { title: (Ce = (_e = he == null ? void 0 : he.input) == null ? void 0 : _e.values) == null ? void 0 : Ce.clear, trigger: ["focus"], children: /* @__PURE__ */ jsx("button", { className: "go-textarea__clear-button", onClick: Ee, children: /* @__PURE__ */ jsx(CloseRingDuotoneLine, {}) }) })
      ]
    }
  );
}), DEFAULT_MIN_CONTENT_WIDTH = 32, DEFAULT_MAX_CONTENT_WIDTH = 300, CollapseSidebar = ({
  title: t,
  icon: r,
  children: n,
  initialOpen: a = !1,
  open: s = !1,
  onToggle: o,
  width: l = { min: DEFAULT_MIN_CONTENT_WIDTH, max: DEFAULT_MAX_CONTENT_WIDTH },
  isLoading: x,
  className: j,
  style: Z,
  side: V = "left",
  onClick: $
}) => {
  const X = useRef(a != null ? a : s), [W, Y] = useState$1(
    (a != null ? a : s) ? "opening" : "closed"
  );
  useEffect(() => {
    s === X.current && !s || (X.current = s, Y(s ? "opening" : "closing"));
  }, [s]);
  const U = ["opening", "closing"].includes(W), G = ["opening", "open"].includes(W), K = () => {
    G ? (Y("closing"), o == null || o(!1)) : (Y("opening"), o == null || o(!0));
  }, J = () => {
    W === "closing" ? Y("closed") : W === "opening" && Y("open");
  }, { min: ee, max: te } = typeof l == "object" ? l : { min: DEFAULT_MIN_CONTENT_WIDTH, max: l };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: clsx(
        "go-collapse-sidebar",
        G && "go-collapse-sidebar_open",
        U && "go-collapse-sidebar_transitioning",
        `go-collapse-sidebar_side_${V}`,
        j
      ),
      style: {
        "--go-collapse-sidebar-max-content-width": `${te}px`,
        "--go-collapse-sidebar-min-content-width": `${ee}px`,
        ...Z
      },
      onTransitionEnd: J,
      onClick: $,
      children: [
        /* @__PURE__ */ jsxs("div", { className: "go-collapse-sidebar__header", children: [
          /* @__PURE__ */ jsx(
            "button",
            {
              className: clsx(
                "go-collapse-sidebar__expand-button",
                G && "go-collapse-sidebar__expand-button_expanded"
              ),
              onClick: K,
              children: /* @__PURE__ */ jsx(ExpandRightLight, {})
            }
          ),
          /* @__PURE__ */ jsx("div", { className: "go-collapse-sidebar__title-container", children: typeof t == "string" ? /* @__PURE__ */ jsx("h3", { children: t }) : t })
        ] }),
        (G || U) && /* @__PURE__ */ jsx(Scrollbar, { noScrollX: !0, children: /* @__PURE__ */ jsx("div", { className: "go-collapse-sidebar__content", children: x ? /* @__PURE__ */ jsx(Loader, { style: { "--go-loader-overlay-bg": "transparent" } }) : n }) }),
        /* @__PURE__ */ jsx("div", { className: "go-collapse-sidebar__collapsed-icon", children: r })
      ]
    }
  );
}, HINT_DEFAULT_STYLE_OPTIONS = {
  className: "go-hint__container",
  arrowOptions: {
    className: "go-hint__arrow"
  }
}, HintContent = ({ headerIcon: t, buttonOptions: r, title: n, description: a }) => /* @__PURE__ */ jsxs("div", { className: "go-hint__wrapper", children: [
  n && /* @__PURE__ */ jsxs("div", { className: "go-hint__header", children: [
    t,
    /* @__PURE__ */ jsx("h6", { className: "go-hint__title", children: n })
  ] }),
  a && /* @__PURE__ */ jsx("p", { className: clsx("go-hint__description", n && "go-hint__description_translucent"), children: a }),
  r && /* @__PURE__ */ jsx(
    Button,
    {
      className: clsx("go-hint__button", r.className),
      icon: r.icon,
      onClick: r.onClick,
      children: r.text
    }
  )
] }), HintComponent = forwardRef(function t({
  content: r,
  open: n,
  headerIcon: a,
  buttonOptions: s,
  title: o,
  description: l,
  children: x,
  arrowOptions: j,
  className: Z,
  ...V
}, $) {
  return n ? /* @__PURE__ */ jsx(
    Tooltip$1,
    {
      ref: $,
      title: r || /* @__PURE__ */ jsx(HintContent, { title: o, description: l, headerIcon: a, buttonOptions: s }),
      open: n,
      className: clsx("go-hint__container", Z),
      arrowOptions: {
        className: "go-hint__arrow",
        ...j
      },
      ...V,
      children: x
    }
  ) : x;
}), Hint = Object.assign(HintComponent, {
  HintContent
}), STYLE_VARIANTS = {
  dark: "dark",
  light: "light",
  darkBordered: "darkBordered",
  lightBordered: "lightBordered"
};
export {
  actionsBar as ActionsBar,
  AutoComplete,
  Button,
  Calendar$1 as Calendar,
  Checkbox,
  CheckboxGroup,
  collapse as Collapse,
  CollapseSidebar,
  ColorPicker,
  ConfigContext,
  ConfigProvider,
  DatePicker,
  DatePickerV2,
  DeleteButton,
  descriptions as Descriptions,
  Drawer,
  Field,
  HINT_DEFAULT_STYLE_OPTIONS,
  Hint,
  Illustration,
  Input,
  InputNumber,
  Loader,
  LoaderIcon,
  Modal,
  NotificationContainer,
  Portal,
  Radio,
  RadioButtonGroup,
  RadioGroup,
  STYLE_VARIANTS,
  Scrollbar,
  Select,
  Slider,
  Switch,
  Textarea,
  Tooltip$1 as Tooltip,
  YearPicker,
  createNotification,
  dismissNotification,
  en,
  isValidSize,
  ru,
  useDisabledRange,
  useGlobalComponentConfig,
  validateNumber
};
//# sourceMappingURL=go-ui.es.js.map
